import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

/** Method used to assign variants in A/B tests */
export enum AbTestAssignmentMethod {
  CONVERSATION_HASH = 'CONVERSATION_HASH',
  RANDOM = 'RANDOM',
  SHIPMENT_HASH = 'SHIPMENT_HASH'
}

export type AbTestConfigType = {
  __typename?: 'ABTestConfigType';
  assignmentMethod: AbTestAssignmentMethod;
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  variants: Array<AbTestVariantType>;
};

export type AbTestVariantType = {
  __typename?: 'ABTestVariantType';
  strategyId: Scalars['ID']['output'];
  weight: Scalars['Float']['output'];
};

export type AiPhoneNumber = AbstractEntity & Node & {
  __typename?: 'AIPhoneNumber';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  team: Team;
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AiProfile = {
  __typename?: 'AIProfile';
  backStory: Scalars['String']['output'];
  /** Digits that can be typed into the numpad during a phone call to identify the user. */
  dtmfPin?: Maybe<Scalars['String']['output']>;
  humanisedDelay?: Maybe<Scalars['Float']['output']>;
  languages?: Maybe<Array<SupportedLanguage>>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumber>;
  type: UserProfileType;
  voiceId?: Maybe<Scalars['String']['output']>;
  voiceModel?: Maybe<SupportedVoiceModel>;
  voiceSpeed?: Maybe<Scalars['Float']['output']>;
};

/** An object with standard fields for created and updated data */
export type AbstractEntity = {
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AbstractEvent = {
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type AbstractSharedFile = {
  createdAt: Scalars['DateTimeISO']['output'];
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AbstractSharedFileVersion = {
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type AcceptUpToMaxConfigType = {
  __typename?: 'AcceptUpToMaxConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  fallbackStrategyId: Scalars['ID']['output'];
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type AcceptancePriorPoint = {
  __typename?: 'AcceptancePriorPoint';
  price: Scalars['Float']['output'];
  probability: Scalars['Float']['output'];
};

export type ActionBehavior = AbstractEntity & Node & {
  __typename?: 'ActionBehavior';
  actionDefinition?: Maybe<ActionDefinition>;
  actionDefinitionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  datasetName: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['Float']['output']>;
  evaluationStatus: ActionBehaviorStatus;
  id: Scalars['ID']['output'];
  lastEvaluated?: Maybe<Scalars['DateTimeISO']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  scorerSlug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum ActionBehaviorStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IDLE = 'IDLE',
  RUNNING = 'RUNNING'
}

export type ActionDefinition = AbstractEntity & Node & {
  __typename?: 'ActionDefinition';
  canonicalTools?: Maybe<Array<Scalars['JSON']['output']>>;
  childLinks: Array<ActionDefinitionChildLink>;
  classifyConversationMessages?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  defaultAutonomyState?: Maybe<AutonomyState>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deterministicToolInvocations?: Maybe<DeterministicToolInvocations>;
  documents: Array<ActionDefinitionDocumentUpload>;
  events: Array<ActionDefinitionEvent>;
  globalPrompt?: Maybe<GlobalPrompt>;
  globalPromptSkillIds: Scalars['JSON']['output'];
  globalPromptToolValues?: Maybe<Scalars['JSON']['output']>;
  globalPromptValues?: Maybe<Scalars['JSON']['output']>;
  hasMemory?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  implementsTool?: Maybe<CanonicalToolType>;
  isEmbeddedInGraph: Scalars['Boolean']['output'];
  knowledgeBases: Array<KnowledgeBase>;
  memoryEntityLinks: Array<MemoryEntityLink>;
  mode: ActionDefinitionMode;
  modelOverride?: Maybe<LlmName>;
  name: Scalars['String']['output'];
  nameEmbedding?: Maybe<Array<Scalars['Float']['output']>>;
  organization: Organization;
  postCompletionMessageBehavior?: Maybe<PostCompletionMessageBehavior>;
  procedure: Procedure;
  provisioningResourceId?: Maybe<Scalars['ID']['output']>;
  reasoningEffort?: Maybe<ReasoningEffort>;
  referringActionDefinitions: Array<ActionDefinition>;
  referringActionDefinitionsCount: Scalars['Int']['output'];
  relatedGlobalPrompts: Array<GlobalPrompt>;
  respondsToCoworkers?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if executions of this action definition run detached from parent executions. */
  runDetached?: Maybe<Scalars['Boolean']['output']>;
  /** Overrides experimental service routing. Null inherits from the global prompt or uses the normal service. */
  runsOnExperimentalService?: Maybe<Scalars['Boolean']['output']>;
  /** Extra metadata for provisioned SOPs, keyed by resource ID */
  sopMetadata?: Maybe<SopMetadata>;
  subscribers?: Maybe<Array<User>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  teamGlobalPromptValues: Array<ActionDefinitionTeamGlobalPromptValues>;
  triggers?: Maybe<Array<ActionTrigger>>;
  triggersCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  workers: Array<User>;
  workersConfig: WorkersConfig;
};

export type ActionDefinitionChildLink = {
  __typename?: 'ActionDefinitionChildLink';
  actionDefinition: ActionDefinition;
  relationshipType: ActionDefinitionRelationshipType;
};

export type ActionDefinitionConnection = {
  __typename?: 'ActionDefinitionConnection';
  count: Scalars['Int']['output'];
  edges: Array<ActionDefinitionEdge>;
  nodes?: Maybe<Array<ActionDefinition>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActionDefinitionDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'ActionDefinitionDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subject: ActionDefinition;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type ActionDefinitionEdge = {
  __typename?: 'ActionDefinitionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: ActionDefinition;
};

export type ActionDefinitionEvent = AbstractEntity & Node & {
  __typename?: 'ActionDefinitionEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<DefinitionChangedData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: ActionDefinitionEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export enum ActionDefinitionEventType {
  DEFINITION_CHANGED = 'DEFINITION_CHANGED'
}

export enum ActionDefinitionMode {
  PRODUCTION = 'PRODUCTION',
  TEST = 'TEST'
}

export enum ActionDefinitionRelationshipType {
  GRAPH_NODE = 'GRAPH_NODE',
  RUN_SOP = 'RUN_SOP',
  SKILL = 'SKILL'
}

export type ActionDefinitionTagsInput = {
  organizationId: Scalars['ID']['input'];
};

export type ActionDefinitionTagsPayload = {
  __typename?: 'ActionDefinitionTagsPayload';
  tags: Array<Scalars['String']['output']>;
};

export type ActionDefinitionTeamGlobalPromptValues = AbstractEntity & Node & {
  __typename?: 'ActionDefinitionTeamGlobalPromptValues';
  actionDefinition: ActionDefinition;
  actionDefinitionId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  team: Team;
  teamId: Scalars['String']['output'];
  toolValues?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  values?: Maybe<Scalars['JSON']['output']>;
};

export type ActionDefinitionsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActionEntityIds = {
  __typename?: 'ActionEntityIds';
  externalMessageIds?: Maybe<Array<Scalars['ID']['output']>>;
  orderIds?: Maybe<Array<Scalars['ID']['output']>>;
  quoteIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ActionExecution = AbstractEntity & Node & {
  __typename?: 'ActionExecution';
  actionDefinition: ActionDefinition;
  actionTrigger?: Maybe<ActionTrigger>;
  autonomyState: AutonomyState;
  causedByActionExecution?: Maybe<ActionExecution>;
  causedByActionExecutionId?: Maybe<Scalars['ID']['output']>;
  children: Array<ActionExecution>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  documents: Array<ActionExecutionDocumentUpload>;
  events: Array<ActionExecutionEvent>;
  executeAsUser?: Maybe<User>;
  executeAsUserId?: Maybe<Scalars['ID']['output']>;
  graphNodeId?: Maybe<Scalars['String']['output']>;
  /** Indicates if this execution retains memory of previous executions. */
  hasMemory?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  input: Scalars['JSON']['output'];
  linkedConversations: Array<Conversation>;
  mode: ExecutionMode;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  output?: Maybe<Scalars['JSON']['output']>;
  parent?: Maybe<ActionExecution>;
  parentId?: Maybe<Scalars['ID']['output']>;
  reexecutedFromActionExecution?: Maybe<ActionExecution>;
  reexecutedFromActionExecutionId?: Maybe<Scalars['ID']['output']>;
  respondsToCoworkers?: Maybe<Scalars['Boolean']['output']>;
  status: ActionExecutionStatus;
  subscribers?: Maybe<Array<User>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ActionExecutionAnalysis = AbstractEntity & Node & {
  __typename?: 'ActionExecutionAnalysis';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  results?: Maybe<Scalars['JSON']['output']>;
  status: ProcessingStatus;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Maps a label anchor id (a RAW_AGENT_MESSAGE event id for text/chat turns, or a synthetic id for voice labels) to the action execution and LangGraph checkpoint to replay from in order to re-execute that agent turn. */
export type ActionExecutionCheckpointRelation = AbstractEntity & Node & {
  __typename?: 'ActionExecutionCheckpointRelation';
  actionExecution: ActionExecution;
  checkpointNs: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  replayFromCheckpointId: Scalars['String']['output'];
  threadId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ActionExecutionConnection = {
  __typename?: 'ActionExecutionConnection';
  count: Scalars['Int']['output'];
  edges: Array<ActionExecutionEdge>;
  nodes?: Maybe<Array<ActionExecution>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActionExecutionCredits = {
  __typename?: 'ActionExecutionCredits';
  actionExecutionId: Scalars['ID']['output'];
  downstream: Array<ActionExecutionCreditsLine>;
  downstreamCredits: Scalars['Float']['output'];
  ownCredits: Scalars['Float']['output'];
  totalCredits: Scalars['Float']['output'];
};

export type ActionExecutionCreditsLine = {
  __typename?: 'ActionExecutionCreditsLine';
  actionDefinitionId: Scalars['ID']['output'];
  actionDefinitionName: Scalars['String']['output'];
  actionExecutionId: Scalars['ID']['output'];
  causedByActionExecutionId?: Maybe<Scalars['ID']['output']>;
  credits: Scalars['Float']['output'];
  depth: Scalars['Int']['output'];
};

export type ActionExecutionDateFilterInput = {
  /** List ActionExecution that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List ActionExecution that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List ActionExecution that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List ActionExecution that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ActionExecutionDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'ActionExecutionDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subject: ActionExecution;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type ActionExecutionEdge = {
  __typename?: 'ActionExecutionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: ActionExecution;
};

export type ActionExecutionEntityAssociation = AbstractEntity & Node & {
  __typename?: 'ActionExecutionEntityAssociation';
  actionExecution: ActionExecution;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entity: AbstractEntity;
  id: Scalars['ID']['output'];
  organization: Organization;
  source: ActionExecution;
  target: AbstractEntity;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ActionExecutionEvent = AbstractEntity & Node & {
  __typename?: 'ActionExecutionEvent';
  actionExecution: ActionExecution;
  agentMessageView?: Maybe<AgentMessageView>;
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<ActionExecutionEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: ActionExecutionEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type ActionExecutionEventData = AeWatcherClosedData | AgentProposedOutputData | AgentReasoningData | DecisionEdgeEvaluatedData | EscalationData | InstructionMessageData | MemoryRecalledData | RawAgentMessageData | RawSupervisorMessageData | ReminderData | SpamGuardData | StatusChangedData | SupervisorProposedOutputData | SupervisorReasoningData | SupervisorToolUsedData | ToolUsedData | UnknownData | WatcherPokedData;

export type ActionExecutionEventInput = {
  actionExecutionId?: InputMaybe<Scalars['ID']['input']>;
  createdAt: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name: ActionExecutionEventType;
};

export type ActionExecutionEventOutput = {
  __typename?: 'ActionExecutionEventOutput';
  actionExecutionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: ActionExecutionEventType;
};

export enum ActionExecutionEventType {
  AGENT_PROPOSED_OUTPUT = 'AGENT_PROPOSED_OUTPUT',
  AGENT_REASONING = 'AGENT_REASONING',
  DECISION_EDGE_EVALUATED = 'DECISION_EDGE_EVALUATED',
  ESCALATION = 'ESCALATION',
  INSTRUCTION_MESSAGE = 'INSTRUCTION_MESSAGE',
  MEMORY_RECALLED = 'MEMORY_RECALLED',
  RAW_AGENT_MESSAGE = 'RAW_AGENT_MESSAGE',
  RAW_SUPERVISOR_MESSAGE = 'RAW_SUPERVISOR_MESSAGE',
  REMINDER = 'REMINDER',
  SPAM_GUARD = 'SPAM_GUARD',
  STATUS_CHANGED = 'STATUS_CHANGED',
  SUPERVISOR_PROPOSED_OUTPUT = 'SUPERVISOR_PROPOSED_OUTPUT',
  SUPERVISOR_REASONING = 'SUPERVISOR_REASONING',
  SUPERVISOR_TOOL_USED = 'SUPERVISOR_TOOL_USED',
  TOOL_USED = 'TOOL_USED',
  UNKNOWN = 'UNKNOWN',
  WATCHER_CLOSED = 'WATCHER_CLOSED',
  WATCHER_POKED = 'WATCHER_POKED'
}

export type ActionExecutionInput = {
  actionDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  conversationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFilter?: InputMaybe<ActionExecutionDateFilterInput>;
  lineageFetchPolicy?: LineageFetchPolicy;
  modes?: InputMaybe<Array<ExecutionMode>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pollLatest?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ActionExecutionStatus {
  COMPLETED = 'COMPLETED',
  DELAYING = 'DELAYING',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW',
  PROPOSED = 'PROPOSED',
  REJECTED = 'REJECTED',
  SCHEDULED = 'SCHEDULED',
  TIMEOUT = 'TIMEOUT',
  WAITING = 'WAITING'
}

export type ActionExecutionSummariesInput = {
  actionDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  modes?: InputMaybe<Array<ExecutionMode>>;
};

export type ActionExecutionSummariesPayload = {
  __typename?: 'ActionExecutionSummariesPayload';
  all: Scalars['Float']['output'];
  failedOrPaused: Scalars['Float']['output'];
  inProgress: Scalars['Float']['output'];
};

export type ActionExecutionWithDescendantsPayload = {
  __typename?: 'ActionExecutionWithDescendantsPayload';
  actionExecutions: Array<ActionExecution>;
  conversationEvents: Array<ConversationEvent>;
  externalMessages: Array<ExternalMessage>;
};

export type ActionTrigger = AbstractEntity & Node & {
  __typename?: 'ActionTrigger';
  actionDefinition: ActionDefinition;
  config: ActionTriggerConfig;
  createdAt: Scalars['DateTimeISO']['output'];
  defaultAutonomyState?: Maybe<AutonomyState>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  triggerType: ActionTriggerConfigType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ActionTriggerConfig = ConversationEventCreatedTriggerConfig | ExceptionCreatedTriggerConfig | GoogleChatMessageTriggerConfig | InboundPhoneCallTriggerConfig | MicrosoftTeamsMessageTriggerConfig | MovementEventCreatedTriggerConfig | NewClassifiedEmailThreadTriggerConfig | OrderEventCreatedTriggerConfig | PylonWebhookTriggerConfig | QuoteEventCreatedTriggerConfig | RepeatingTriggerConfig | SlackMessageTriggerConfig;

export enum ActionTriggerConfigType {
  CONVERSATION_EVENT_CREATED = 'CONVERSATION_EVENT_CREATED',
  EXCEPTION_CREATED = 'EXCEPTION_CREATED',
  GOOGLE_CHAT_MESSAGE = 'GOOGLE_CHAT_MESSAGE',
  INBOUND_PHONE_CALL = 'INBOUND_PHONE_CALL',
  MICROSOFT_TEAMS_MESSAGE = 'MICROSOFT_TEAMS_MESSAGE',
  MOVEMENT_EVENT_CREATED = 'MOVEMENT_EVENT_CREATED',
  NEW_CLASSIFIED_EMAIL_THREAD = 'NEW_CLASSIFIED_EMAIL_THREAD',
  ORDER_EVENT_CREATED = 'ORDER_EVENT_CREATED',
  PYLON_WEBHOOK = 'PYLON_WEBHOOK',
  QUOTE_EVENT_CREATED = 'QUOTE_EVENT_CREATED',
  REPEATING = 'REPEATING',
  SLACK_MESSAGE = 'SLACK_MESSAGE'
}

export enum ActionTriggerSideEffectPolicy {
  SOP_AND_SIDE_EFFECTS = 'SOP_AND_SIDE_EFFECTS',
  SOP_ONLY = 'SOP_ONLY'
}

export type ActionTriggerValidation = {
  __typename?: 'ActionTriggerValidation';
  actionDefinitionIds?: Maybe<Array<Scalars['ID']['output']>>;
  reasons: Array<Scalars['String']['output']>;
  status: ActionTriggerValidationStatus;
  validationType: ActionTriggerValidationType;
};

export type ActionTriggerValidationInput = {
  id: Scalars['ID']['input'];
};

export type ActionTriggerValidationPayload = {
  __typename?: 'ActionTriggerValidationPayload';
  validations: Array<ActionTriggerValidation>;
};

export enum ActionTriggerValidationStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  WARN = 'WARN'
}

export enum ActionTriggerValidationType {
  ACTION_DEFINITION_MODE = 'ACTION_DEFINITION_MODE',
  PLACEHOLDER_INTERPOLATION = 'PLACEHOLDER_INTERPOLATION'
}

export type ActiveLoadsCount = {
  __typename?: 'ActiveLoadsCount';
  /** Loads Vooma is tracking. */
  active: Scalars['Int']['output'];
  /** Loads Vooma isn't tracking: no Track profile, or excluded by conditional tracking. */
  inactive: Scalars['Int']['output'];
};

export type AddCarriersToLanePreferenceInput = {
  carrierIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type AddChatMessageToConversationInput = {
  attachmentDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  context?: InputMaybe<ChatViewContextInput>;
  conversationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  mirrorToExternalChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddChatMessageToConversationPayload = {
  __typename?: 'AddChatMessageToConversationPayload';
  externalMessage?: Maybe<ExternalMessage>;
  success: Scalars['Boolean']['output'];
};

export type AddDocumentToJobInput = {
  jobId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AddDocumentToJobPayload = {
  __typename?: 'AddDocumentToJobPayload';
  success: Scalars['Boolean']['output'];
};

export type AddDocumentToOrderInput = {
  documentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};

export type AddDocumentToOrderPayload = {
  __typename?: 'AddDocumentToOrderPayload';
  success: Scalars['Boolean']['output'];
};

export type AddUserToOrganizationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddUserToOrganizationPayload = {
  __typename?: 'AddUserToOrganizationPayload';
  success: Scalars['Boolean']['output'];
};

export type AddWorkerToActionDefinitionInput = {
  actionDefinitionId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

export type AddWorkerToActionDefinitionPayload = {
  __typename?: 'AddWorkerToActionDefinitionPayload';
  actionDefinition: ActionDefinition;
};

export type AdminEmail = {
  __typename?: 'AdminEmail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AdvancedBeforeTriggerSettings = {
  __typename?: 'AdvancedBeforeTriggerSettings';
  /** Offset for appointments (pickup start equals pickup end). */
  appointment: AdvancedTriggerOffset;
  windowTiers: Array<AdvancedTriggerWindowTier>;
};

export type AdvancedBeforeTriggerSettingsInput = {
  /** Offset for appointments (pickup start equals pickup end). */
  appointment: AdvancedTriggerOffsetInput;
  windowTiers: Array<AdvancedTriggerWindowTierInput>;
};

export type AdvancedTriggerOffset = {
  __typename?: 'AdvancedTriggerOffset';
  /** For appointments START and END are the same instant, so either anchor fires at the same time. */
  anchor: WindowAnchor;
  direction: OffsetDirection;
  minutes: Scalars['Float']['output'];
};

export type AdvancedTriggerOffsetInput = {
  /** For appointments START and END are the same instant, so either anchor fires at the same time. */
  anchor: WindowAnchor;
  direction: OffsetDirection;
  minutes: Scalars['Float']['input'];
};

export type AdvancedTriggerParams = {
  __typename?: 'AdvancedTriggerParams';
  /** ADVANCED: offset for appointments (stop start equals stop end). */
  appointment?: Maybe<AdvancedTriggerOffset>;
  /** ADVANCED: offsets by stop window duration. Shared by every milestone that supports ADVANCED. */
  windowTiers?: Maybe<Array<AdvancedTriggerWindowTier>>;
};

export type AdvancedTriggerParamsInput = {
  /** ADVANCED: offset for appointments (stop start equals stop end). */
  appointment?: InputMaybe<AdvancedTriggerOffsetInput>;
  /** ADVANCED: offsets by stop window duration. Shared by every milestone that supports ADVANCED. */
  windowTiers?: InputMaybe<Array<AdvancedTriggerWindowTierInput>>;
};

export type AdvancedTriggerWindowTier = {
  __typename?: 'AdvancedTriggerWindowTier';
  /** Windows up to and including this duration use this tier. Windows longer than every tier use the largest tier. */
  maxDurationMinutes: Scalars['Float']['output'];
  offset: AdvancedTriggerOffset;
};

export type AdvancedTriggerWindowTierInput = {
  /** Windows up to and including this duration use this tier. Windows longer than every tier use the largest tier. */
  maxDurationMinutes: Scalars['Float']['input'];
  offset: AdvancedTriggerOffsetInput;
};

export type AeWatcherClosedData = {
  __typename?: 'AeWatcherClosedData';
  eventDataType: ActionExecutionEventType;
};

export type AgentAction = {
  __typename?: 'AgentAction';
  confidence: Scalars['Float']['output'];
  entityIds?: Maybe<ActionEntityIds>;
  params?: Maybe<Scalars['JSON']['output']>;
  proposedAt: Scalars['DateTimeISO']['output'];
  type: AgentActionType;
};

export enum AgentActionType {
  ASK_FOR_HELP = 'ASK_FOR_HELP',
  BUILD_ORDER = 'BUILD_ORDER',
  BUILD_QUOTE = 'BUILD_QUOTE',
  MARK_QUOTE_LOST = 'MARK_QUOTE_LOST',
  MARK_QUOTE_QUOTED = 'MARK_QUOTE_QUOTED',
  MARK_QUOTE_WON = 'MARK_QUOTE_WON',
  REPEAT_ORDER = 'REPEAT_ORDER',
  REPLICATE_ORDER = 'REPLICATE_ORDER',
  SCHEDULE_ORDER = 'SCHEDULE_ORDER'
}

export type AgentConversationPreview = {
  __typename?: 'AgentConversationPreview';
  conversation: Conversation;
  /** When the latest message was sent, else when the conversation began. */
  lastActivityAt: Scalars['DateTimeISO']['output'];
  /** Sender of the latest email. */
  latestSender?: Maybe<Scalars['String']['output']>;
  /** Text of the latest SMS. */
  latestText?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  /** An email's earliest subject, or the other party's number for SMS. */
  title?: Maybe<Scalars['String']['output']>;
};

export type AgentConversationWorker = {
  __typename?: 'AgentConversationWorker';
  addresses: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type AgentConversationsInput = {
  /** Only conversations linked to one of these SOPs; all when empty. */
  actionDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The previous page's `endCursor`. */
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  startedWithinDays: Scalars['Int']['input'];
  types: Array<ConversationType>;
  /** Only conversations this worker owns. */
  workerUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type AgentConversationsPayload = {
  __typename?: 'AgentConversationsPayload';
  conversations: Array<AgentConversationPreview>;
  /** Pass as `after` to load the next page; null on the last. */
  endCursor?: Maybe<Scalars['ID']['output']>;
};

export type AgentMailDomain = {
  __typename?: 'AgentMailDomain';
  domain: Scalars['String']['output'];
  domainId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type AgentMessageView = {
  __typename?: 'AgentMessageView';
  content: Scalars['String']['output'];
  sentMessage?: Maybe<SentMessageView>;
  toolCalls: Array<ToolCallView>;
};

export type AgentProposedOutputData = {
  __typename?: 'AgentProposedOutputData';
  eventDataType: ActionExecutionEventType;
  output: Scalars['JSON']['output'];
};

export type AgentReasoningData = {
  __typename?: 'AgentReasoningData';
  eventDataType: ActionExecutionEventType;
  reasoning: Scalars['String']['output'];
};

export type AgenticPlannerSettings = {
  __typename?: 'AgenticPlannerSettings';
  type: PlanningApproach;
};

export type AljexIngestionParamsInput = {
  endProNumber?: InputMaybe<Scalars['Int']['input']>;
  startProNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type AllAppointmentsConfirmedData = {
  __typename?: 'AllAppointmentsConfirmedData';
  appointments?: Maybe<Array<ConfirmedAppointmentSnapshot>>;
  eventType: MovementEventType;
};

export type AlwaysAcceptConfigType = {
  __typename?: 'AlwaysAcceptConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type AlwaysDeclineConfigType = {
  __typename?: 'AlwaysDeclineConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type Analysis = AbstractEntity & Node & {
  __typename?: 'Analysis';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  results?: Maybe<Scalars['JSON']['output']>;
  status: ProcessingStatus;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type AnalyticsContext = {
  apiClient: VoomaApiClient;
  clientVersion?: InputMaybe<Scalars['String']['input']>;
  navigator?: InputMaybe<NavigatorFields>;
};

export type ApiClient = AbstractEntity & Node & {
  __typename?: 'ApiClient';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type ApiClientConnection = {
  __typename?: 'ApiClientConnection';
  count: Scalars['Int']['output'];
  edges: Array<ApiClientEdge>;
  nodes?: Maybe<Array<ApiClient>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ApiClientCreationFailureReason {
  DUPLICATE = 'DUPLICATE'
}

export type ApiClientEdge = {
  __typename?: 'ApiClientEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: ApiClient;
};

export type ApiClientsInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ApiResponse = AbstractEntity & Node & {
  __typename?: 'ApiResponse';
  carrierId?: Maybe<Scalars['String']['output']>;
  commonTerms?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  method: RequestMethod;
  movementId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  originatorId?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  queryParams?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  requestBody?: Maybe<Scalars['JSON']['output']>;
  requestHash?: Maybe<Scalars['String']['output']>;
  responseBody?: Maybe<Scalars['JSON']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ApplicableGenericTransformationsInput = {
  email?: InputMaybe<Scalars['JSON']['input']>;
  externalMessageId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type ApplicableGenericTransformationsPayload = {
  __typename?: 'ApplicableGenericTransformationsPayload';
  genericTransformationIds: Array<Scalars['ID']['output']>;
  resultingClasses: Array<ExternalMessageClassificationGraphQl>;
};

export type ApplyClassificationRulesInput = {
  classifications?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
};

export type ApplyClassificationRulesPayload = {
  __typename?: 'ApplyClassificationRulesPayload';
  classifications: Scalars['JSON']['output'];
};

export type ApplyGenericTransformationTemplateInput = {
  organizationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type ApplyGenericTransformationTemplatePayload = {
  __typename?: 'ApplyGenericTransformationTemplatePayload';
  genericRuleId: Scalars['ID']['output'];
  genericTransformationId: Scalars['ID']['output'];
};

export type Appointment = AbstractEntity & Node & {
  __typename?: 'Appointment';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movementStop?: Maybe<MovementStop>;
  organization: Organization;
  place?: Maybe<Place>;
  seq: Scalars['Int']['output'];
  shipment: Shipment;
  status: AppointmentStatus;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type AppointmentEvent = AbstractEntity & Node & {
  __typename?: 'AppointmentEvent';
  appointment: Appointment;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: AppointmentEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export enum AppointmentEventType {
  APPOINTMENT_WEBHOOK_ABORTED = 'APPOINTMENT_WEBHOOK_ABORTED',
  APPOINTMENT_WEBHOOK_ESCALATED = 'APPOINTMENT_WEBHOOK_ESCALATED',
  EMAIL_APPOINTMENT_REQUESTED = 'EMAIL_APPOINTMENT_REQUESTED',
  EMAIL_APPOINTMENT_REQUEST_DEFFERED_FOR_BATCH_PROCESSING = 'EMAIL_APPOINTMENT_REQUEST_DEFFERED_FOR_BATCH_PROCESSING',
  PORTAL_APPOINTMENT_REQUEST_FAILURE = 'PORTAL_APPOINTMENT_REQUEST_FAILURE',
  PORTAL_APPOINTMENT_REQUEST_PORTAL_ERROR = 'PORTAL_APPOINTMENT_REQUEST_PORTAL_ERROR',
  PORTAL_APPOINTMENT_REQUEST_SYSTEM_ERROR = 'PORTAL_APPOINTMENT_REQUEST_SYSTEM_ERROR',
  PORTAL_APPOINTMENT_SCHEDULED = 'PORTAL_APPOINTMENT_SCHEDULED',
  PORTAL_WEB_APPOINTMENT_REQUESTED = 'PORTAL_WEB_APPOINTMENT_REQUESTED'
}

export enum AppointmentStatus {
  ABORTED = 'ABORTED',
  CONFIRMED = 'CONFIRMED',
  ESCALATED = 'ESCALATED',
  NEW = 'NEW',
  PENDING_BATCH_REQUEST = 'PENDING_BATCH_REQUEST',
  REQUESTED = 'REQUESTED'
}

export type AssociatedEntitiesInput = {
  actionDefinitions?: InputMaybe<Array<Scalars['ID']['input']>>;
  carriers?: InputMaybe<Array<Scalars['ID']['input']>>;
  movements?: InputMaybe<Array<Scalars['ID']['input']>>;
  orders?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizations?: InputMaybe<Array<Scalars['ID']['input']>>;
  originators?: InputMaybe<Array<Scalars['ID']['input']>>;
  places?: InputMaybe<Array<Scalars['ID']['input']>>;
  quotes?: InputMaybe<Array<Scalars['ID']['input']>>;
  shipments?: InputMaybe<Array<Scalars['ID']['input']>>;
  teams?: InputMaybe<Array<Scalars['ID']['input']>>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AsyncTransferData = {
  __typename?: 'AsyncTransferData';
  ccRecipients: Array<Scalars['String']['output']>;
  eventDataType: ConversationEventType;
  shipmentId?: Maybe<Scalars['String']['output']>;
};

export type AuditDatAutopostsInput = {
  organizationId: Scalars['ID']['input'];
};

export type AuditDatAutopostsPayload = {
  __typename?: 'AuditDATAutopostsPayload';
  activeMappingsChecked: Scalars['Int']['output'];
  configured: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  ingestedCount: Scalars['Int']['output'];
  mcLeodCandidatesChecked: Scalars['Int']['output'];
  postFailures: Scalars['Int']['output'];
  postedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  unpostFailures: Scalars['Int']['output'];
  unpostedCount: Scalars['Int']['output'];
};

export type AuditDatShipmentPostingsInput = {
  organizationId: Scalars['ID']['input'];
};

export type AuditDatShipmentPostingsPayload = {
  __typename?: 'AuditDATShipmentPostingsPayload';
  correctedCount: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  inconclusiveCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  stillPostedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  totalChecked: Scalars['Int']['output'];
};

export type Auth0AuthenticationStrategy = Node & {
  __typename?: 'Auth0AuthenticationStrategy';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  lastSignedIn: Scalars['DateTimeISO']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum AuthPolicyLevel {
  ALLOW_SOFT_FAILURES = 'ALLOW_SOFT_FAILURES',
  NOT_REQUIRED = 'NOT_REQUIRED',
  PASS_REQUIRED = 'PASS_REQUIRED'
}

export type AuthToken = AbstractEntity & Node & {
  __typename?: 'AuthToken';
  /** Serialized as JSON */
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  type: AuthTokenType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

/** The status of the auth token. */
export enum AuthTokenStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  NOT_FOUND = 'NOT_FOUND'
}

/** The type of service to which the auth token grants access. */
export enum AuthTokenType {
  AGENTMAIL = 'AGENTMAIL',
  ALJEX = 'ALJEX',
  ALVYS = 'ALVYS',
  AVRL = 'AVRL',
  BITFREIGHTER = 'BITFREIGHTER',
  COMPOSIO = 'COMPOSIO',
  DAT = 'DAT',
  DHL_FREIGHT = 'DHL_FREIGHT',
  ECHO = 'ECHO',
  FASTMORE = 'FASTMORE',
  FRONT_CORE_API = 'FRONT_CORE_API',
  GMAIL_API = 'GMAIL_API',
  GREENSCREENS = 'GREENSCREENS',
  LANDSTAR = 'LANDSTAR',
  MERCURYGATE = 'MERCURYGATE',
  MICROSOFT_GRAPH_API = 'MICROSOFT_GRAPH_API',
  MYCARRIERPORTAL = 'MYCARRIERPORTAL',
  NFI = 'NFI',
  NTG = 'NTG',
  OPENDOCK = 'OPENDOCK',
  PROJECT_44 = 'PROJECT_44',
  SOFTMODAL = 'SOFTMODAL',
  SONAR = 'SONAR',
  THREE_PL = 'THREE_PL',
  TRANSFIX = 'TRANSFIX',
  TRUCKSTOP = 'TRUCKSTOP',
  TURVO = 'TURVO',
  UBER_GTG = 'UBER_GTG',
  WORLDWIDE_LOGISTICS = 'WORLDWIDE_LOGISTICS',
  WWEX = 'WWEX'
}

export enum AutoSubmitScope {
  AUTO_CONFIRM = 'AUTO_CONFIRM',
  DISABLED = 'DISABLED',
  FULLY_AUTONOMOUS = 'FULLY_AUTONOMOUS',
  MULTIPLE_ORDERS = 'MULTIPLE_ORDERS',
  SINGLE_ORDER = 'SINGLE_ORDER'
}

export enum AutonomyState {
  AUTONOMOUS = 'AUTONOMOUS',
  CAUTIOUSLY_AUTONOMOUS = 'CAUTIOUSLY_AUTONOMOUS',
  NO_ACTION_WITHOUT_HUMAN = 'NO_ACTION_WITHOUT_HUMAN'
}

export type AvailabilityCheck = {
  __typename?: 'AvailabilityCheck';
  fields?: Maybe<AvailabilityCheckFields>;
  info: Scalars['String']['output'];
  times: Array<Scalars['DateTimeISO']['output']>;
};

export type AvailabilityCheckFields = OpendockAvailabilityCheckFields;

export enum AwkwardMomentType {
  AUDIO_OR_TRANSCRIPTION_ISSUE = 'AUDIO_OR_TRANSCRIPTION_ISSUE',
  INTERRUPTION = 'INTERRUPTION',
  INVALID_RESPONSE = 'INVALID_RESPONSE',
  LONG_PAUSE = 'LONG_PAUSE',
  OTHER = 'OTHER',
  SLOW_RESPONSE = 'SLOW_RESPONSE'
}

export type BackfillConversationLabelsInput = {
  actionDefinitionIds: Array<Scalars['ID']['input']>;
  createdAtEnd: Scalars['DateTimeISO']['input'];
  createdAtStart: Scalars['DateTimeISO']['input'];
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  types: Array<ConversationType>;
};

export type BackfillConversationLabelsPayload = {
  __typename?: 'BackfillConversationLabelsPayload';
  jobCount: Scalars['Int']['output'];
  matchingCount: Scalars['Int']['output'];
};

export type BaseEvent = AbstractEntity & Node & {
  __typename?: 'BaseEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type BaseEventConnection = {
  __typename?: 'BaseEventConnection';
  count: Scalars['Int']['output'];
  edges: Array<BaseEventEdge>;
  nodes?: Maybe<Array<BaseEvent>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseEventEdge = {
  __typename?: 'BaseEventEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: BaseEvent;
};

export type BaseEventsInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
};

export type BasePrompt = AbstractEntity & Node & {
  __typename?: 'BasePrompt';
  createdAt: Scalars['DateTimeISO']['output'];
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type BasePromptVersion = AbstractEntity & Node & {
  __typename?: 'BasePromptVersion';
  createdAt: Scalars['DateTimeISO']['output'];
  defaultConfig: Scalars['JSON']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  form?: Maybe<Scalars['JSON']['output']>;
  guide?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  version: Scalars['Int']['output'];
};

export type BasePromptWithVersions = {
  __typename?: 'BasePromptWithVersions';
  basePrompt: BasePrompt;
  versions: Array<BasePromptVersion>;
};

export type BaseTriggerOverride = {
  __typename?: 'BaseTriggerOverride';
  active: Scalars['Boolean']['output'];
};

export type BasicUser = {
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  endsAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<BillingLineItem>;
  startsAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: Scalars['String']['output'];
  totalCents: Scalars['Float']['output'];
};

export type BillingLineItem = {
  __typename?: 'BillingLineItem';
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  totalCents: Scalars['Float']['output'];
  unitPriceCents?: Maybe<Scalars['Float']['output']>;
};

export type BooleanFlagConfiguration = {
  __typename?: 'BooleanFlagConfiguration';
  all?: Maybe<Scalars['Boolean']['output']>;
  ids?: Maybe<Array<Scalars['String']['output']>>;
};

export type BraintrustDataset = {
  __typename?: 'BraintrustDataset';
  created: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The Braintrust project environment to use */
export enum BraintrustEnvironment {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
  RELEASE_CANDIDATE = 'RELEASE_CANDIDATE',
  STAGING = 'STAGING'
}

export type BraintrustScorer = {
  __typename?: 'BraintrustScorer';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type BuildShipmentInput = {
  data: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  integration: SidekickSupportedTms;
  organizationId: Scalars['String']['input'];
};

export type BuildShipmentPayload = {
  __typename?: 'BuildShipmentPayload';
  shipmentId: Scalars['String']['output'];
};

export type BulkCreateContactError = {
  __typename?: 'BulkCreateContactError';
  email: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  transmitId: Scalars['String']['output'];
};

export type BulkCreateContactInput = {
  csvData: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type BulkCreateContactPayload = {
  __typename?: 'BulkCreateContactPayload';
  contacts: Array<Contact>;
  errors: Array<BulkCreateContactError>;
  skipped: BulkCreateContactSkipped;
  success: Scalars['Boolean']['output'];
};

export type BulkCreateContactSkipped = {
  __typename?: 'BulkCreateContactSkipped';
  alreadyExistOnOriginator: Array<Scalars['String']['output']>;
  duplicateCount: Scalars['Float']['output'];
  multipleOriginators: Array<Scalars['String']['output']>;
  noOriginators: Array<Scalars['String']['output']>;
};

export type BulkCreateContactsInput = {
  contacts: Array<CreateContactInput>;
  organizationId: Scalars['ID']['input'];
};

export type BulkCreateOriginatorsInput = {
  originators: Array<CreateOriginatorInput>;
};

export type BulkCreateOriginatorsPayload = {
  __typename?: 'BulkCreateOriginatorsPayload';
  originators: Array<CreateOriginatorPayload>;
};

export type BulkCreatePlacesInput = {
  places: Array<CreatePlaceInput>;
};

export type BulkCreatePlacesPayload = {
  __typename?: 'BulkCreatePlacesPayload';
  places: Array<CreatePlacePayload>;
};

export type BulkDeleteJobsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteJobsPayload = {
  __typename?: 'BulkDeleteJobsPayload';
  success: Scalars['Boolean']['output'];
};

export type BulkDeleteOrdersInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteOrdersPayload = {
  __typename?: 'BulkDeleteOrdersPayload';
  success: Scalars['Boolean']['output'];
};

export type BulkDeleteOriginatorsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteOriginatorsPayload = {
  __typename?: 'BulkDeleteOriginatorsPayload';
  success: Scalars['Boolean']['output'];
};

export type BulkDeletePlacesInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeletePlacesPayload = {
  __typename?: 'BulkDeletePlacesPayload';
  success: Scalars['Boolean']['output'];
};

export type BulkDeleteQuotesInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteQuotesPayload = {
  __typename?: 'BulkDeleteQuotesPayload';
  success: Scalars['Boolean']['output'];
};

export type BulkInviteUsersToOrganizationInput = {
  emails: Array<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  role?: InputMaybe<OrganizationUserRole>;
};

export type BulkInviteUsersToOrganizationPayload = {
  __typename?: 'BulkInviteUsersToOrganizationPayload';
  organizationUserRelations: Array<OrganizationUserRelation>;
  success: Scalars['Boolean']['output'];
};

/** The type of api request being cached. */
export enum CachedRequestType {
  GREENSCREENS_INDICES = 'GREENSCREENS_INDICES',
  LOAD_TO_TRUCK_RATIOS = 'LOAD_TO_TRUCK_RATIOS',
  MARKET_CONDITIONS_FORECASTS = 'MARKET_CONDITIONS_FORECASTS',
  MARKET_CONDITIONS_INDICES = 'MARKET_CONDITIONS_INDICES',
  MARKET_CONDITIONS_SCORE = 'MARKET_CONDITIONS_SCORE',
  SONAR_COVERAGE_GUIDE = 'SONAR_COVERAGE_GUIDE',
  SONAR_TRAC_FORECAST = 'SONAR_TRAC_FORECAST'
}

export type CallEndedData = {
  __typename?: 'CallEndedData';
  eventDataType: ConversationEventType;
};

export type CallFailedData = {
  __typename?: 'CallFailedData';
  eventDataType: ConversationEventType;
};

export type CallRecordingReceivedData = {
  __typename?: 'CallRecordingReceivedData';
  eventDataType: ConversationEventType;
  recordingEndTime: Scalars['DateTimeISO']['output'];
  recordingStartTime: Scalars['DateTimeISO']['output'];
};

export type CallRecordingStartedData = {
  __typename?: 'CallRecordingStartedData';
  eventDataType: ConversationEventType;
};

export type CallTransferAcceptedData = {
  __typename?: 'CallTransferAcceptedData';
  conferenceId: Scalars['String']['output'];
  eventDataType: ConversationEventType;
  transferCallSid: Scalars['String']['output'];
};

export enum CallTransferStatus {
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
  NONE = 'NONE'
}

export type CallTransferredData = {
  __typename?: 'CallTransferredData';
  eventDataType: ConversationEventType;
  extension?: Maybe<Scalars['String']['output']>;
  overrideCallerId?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
};

/** Schedule frequency for TMS integration canary verification */
export enum CanarySchedule {
  DAILY = 'DAILY',
  SIX_TIMES_DAILY = 'SIX_TIMES_DAILY',
  WEEKLY = 'WEEKLY'
}

export enum CanonicalToolType {
  ACTIVATE_PLAYWRIGHT_SESSION = 'ACTIVATE_PLAYWRIGHT_SESSION',
  ADD_FILE_FROM_URL = 'ADD_FILE_FROM_URL',
  ADD_TOOL_TO_SKILL = 'ADD_TOOL_TO_SKILL',
  ALVYS_CREATE_CHECK_CALL = 'ALVYS_CREATE_CHECK_CALL',
  ANALYZE_STRINGS = 'ANALYZE_STRINGS',
  ANSWER_INBOUND_CALL = 'ANSWER_INBOUND_CALL',
  APPROVE_SCHEDULING_PLAN = 'APPROVE_SCHEDULING_PLAN',
  ARCHIVE_ORIGINATOR = 'ARCHIVE_ORIGINATOR',
  BATCH_EMAIL_SCHEDULE_SOP = 'BATCH_EMAIL_SCHEDULE_SOP',
  BATCH_SCHEDULE_STOP = 'BATCH_SCHEDULE_STOP',
  BATCH_TOOL_CALLS = 'BATCH_TOOL_CALLS',
  BEGIN_SCHEDULE_PLANNING_SESSION = 'BEGIN_SCHEDULE_PLANNING_SESSION',
  BE_MORE_PATIENT = 'BE_MORE_PATIENT',
  BUILD_ORDERS_FROM_CONVERSATION = 'BUILD_ORDERS_FROM_CONVERSATION',
  BUILD_QUOTES_FROM_CONVERSATION = 'BUILD_QUOTES_FROM_CONVERSATION',
  CALL_CARRIER_TO_COLLECT_LOAD_BID = 'CALL_CARRIER_TO_COLLECT_LOAD_BID',
  CANCEL_INTENT_TO_HANG_UP = 'CANCEL_INTENT_TO_HANG_UP',
  CANCEL_INTENT_TO_HOLD = 'CANCEL_INTENT_TO_HOLD',
  CANCEL_INTENT_TO_TRANSFER_CALL = 'CANCEL_INTENT_TO_TRANSFER_CALL',
  CC_REP_ON_EMAIL_CONVERSATION = 'CC_REP_ON_EMAIL_CONVERSATION',
  CHAT_WITH_USER = 'CHAT_WITH_USER',
  CHECK_CARRIER_ELIGIBILITY = 'CHECK_CARRIER_ELIGIBILITY',
  CLOSE_SELF = 'CLOSE_SELF',
  COMPOSIO_PROXY_TOOL = 'COMPOSIO_PROXY_TOOL',
  COMPOSIO_TOOL = 'COMPOSIO_TOOL',
  COMPUTE_ARITHMETIC_OPERATION = 'COMPUTE_ARITHMETIC_OPERATION',
  COMPUTE_DATE_TIME_DIFFERENCE = 'COMPUTE_DATE_TIME_DIFFERENCE',
  COMPUTE_DATE_TIME_MIDPOINT = 'COMPUTE_DATE_TIME_MIDPOINT',
  COMPUTE_DATE_TIME_OFFSET = 'COMPUTE_DATE_TIME_OFFSET',
  CONFIRM_OPTIMISTIC_ORDER = 'CONFIRM_OPTIMISTIC_ORDER',
  CONTRIBUTE_TO_EMAIL_CONVERSATION = 'CONTRIBUTE_TO_EMAIL_CONVERSATION',
  CREATE_ACTION_TRIGGER = 'CREATE_ACTION_TRIGGER',
  CREATE_AND_RATE_QUOTES = 'CREATE_AND_RATE_QUOTES',
  CREATE_APPOINTMENT_FOR_STOP = 'CREATE_APPOINTMENT_FOR_STOP',
  CREATE_BEHAVIOR_LABEL = 'CREATE_BEHAVIOR_LABEL',
  CREATE_CARRIER_COVERAGE_OUTREACHES = 'CREATE_CARRIER_COVERAGE_OUTREACHES',
  CREATE_CONTACT = 'CREATE_CONTACT',
  CREATE_CONTRACT = 'CREATE_CONTRACT',
  CREATE_GENERIC_TRANSFORMATION = 'CREATE_GENERIC_TRANSFORMATION',
  CREATE_MEMORY = 'CREATE_MEMORY',
  CREATE_MOVEMENT_EXCEPTION = 'CREATE_MOVEMENT_EXCEPTION',
  CREATE_OPENDOCK_APPOINTMENT = 'CREATE_OPENDOCK_APPOINTMENT',
  CREATE_ORDER = 'CREATE_ORDER',
  CREATE_ORIGINATOR = 'CREATE_ORIGINATOR',
  CREATE_ORIGINATOR_FLOW = 'CREATE_ORIGINATOR_FLOW',
  CREATE_PLACE = 'CREATE_PLACE',
  CREATE_PLACE_SCHEDULING_METHOD = 'CREATE_PLACE_SCHEDULING_METHOD',
  CREATE_PRICING_STRATEGY = 'CREATE_PRICING_STRATEGY',
  CREATE_SKILL = 'CREATE_SKILL',
  CREATE_TRACKING_MILESTONE = 'CREATE_TRACKING_MILESTONE',
  DAT_GET_RATE = 'DAT_GET_RATE',
  DAT_SEARCH_LOADS = 'DAT_SEARCH_LOADS',
  DELETE_ACTION_TRIGGER = 'DELETE_ACTION_TRIGGER',
  DELETE_BEHAVIOR_LABEL = 'DELETE_BEHAVIOR_LABEL',
  DELETE_CONTACT = 'DELETE_CONTACT',
  DELETE_CONTRACT = 'DELETE_CONTRACT',
  DELETE_GENERIC_TRANSFORMATION = 'DELETE_GENERIC_TRANSFORMATION',
  DELETE_MEMORY = 'DELETE_MEMORY',
  DELETE_ORIGINATOR_FLOW = 'DELETE_ORIGINATOR_FLOW',
  DELETE_PLACE = 'DELETE_PLACE',
  DELETE_PLACE_SCHEDULING_METHOD = 'DELETE_PLACE_SCHEDULING_METHOD',
  DELETE_PRICING_STRATEGY = 'DELETE_PRICING_STRATEGY',
  DELETE_SHARED_FILE = 'DELETE_SHARED_FILE',
  DELETE_SKILL = 'DELETE_SKILL',
  DELIVER_APPT_WEBHOOK = 'DELIVER_APPT_WEBHOOK',
  EDIT_BEHAVIOR_LABEL = 'EDIT_BEHAVIOR_LABEL',
  EMAIL_CARRIER_TO_COLLECT_LOAD_BID = 'EMAIL_CARRIER_TO_COLLECT_LOAD_BID',
  ESTIMATE_TRANSIT_TIME = 'ESTIMATE_TRANSIT_TIME',
  EXECUTE_BASH_COMMAND = 'EXECUTE_BASH_COMMAND',
  EXECUTE_COVERAGE_PLAN = 'EXECUTE_COVERAGE_PLAN',
  EXECUTE_PROD_REPLICA_SQL_QUERY = 'EXECUTE_PROD_REPLICA_SQL_QUERY',
  EXECUTE_PYTHON_CODE = 'EXECUTE_PYTHON_CODE',
  EXECUTE_SQL_QUERY = 'EXECUTE_SQL_QUERY',
  FETCH_INTEGRATION_ENTITY = 'FETCH_INTEGRATION_ENTITY',
  FIND_ACTION_EXECUTIONS = 'FIND_ACTION_EXECUTIONS',
  FIND_CONVERSATION = 'FIND_CONVERSATION',
  FIND_EXTERNAL_MESSAGES = 'FIND_EXTERNAL_MESSAGES',
  FIND_ORDERS_FOR_EMAIL = 'FIND_ORDERS_FOR_EMAIL',
  FIND_RECORDED_OFFERS = 'FIND_RECORDED_OFFERS',
  FMCSA_CARRIER_CONTACT_LOOKUP = 'FMCSA_CARRIER_CONTACT_LOOKUP',
  FORMAT_DATE_TIME_IN_TIMEZONE = 'FORMAT_DATE_TIME_IN_TIMEZONE',
  GENERATE_RANDOM_FUTURE_DATE = 'GENERATE_RANDOM_FUTURE_DATE',
  GENLOGS_REALTIME_CARRIER_RECOMMENDATIONS = 'GENLOGS_REALTIME_CARRIER_RECOMMENDATIONS',
  GEOCODE_ADDRESS = 'GEOCODE_ADDRESS',
  GET_ACTION_EXECUTION_SNAPSHOT = 'GET_ACTION_EXECUTION_SNAPSHOT',
  GET_CARRIER_OUTREACH_STATUS = 'GET_CARRIER_OUTREACH_STATUS',
  GET_CONTRACT = 'GET_CONTRACT',
  GET_CONVERSATION_DETAILS = 'GET_CONVERSATION_DETAILS',
  GET_COVERAGE_PLAN = 'GET_COVERAGE_PLAN',
  GET_COVERAGE_PLAN_UPDATE = 'GET_COVERAGE_PLAN_UPDATE',
  GET_COVER_SOP_IDS = 'GET_COVER_SOP_IDS',
  GET_CURRENT_TIME = 'GET_CURRENT_TIME',
  GET_DEFAULT_ORDER_BUILDING_INSTRUCTIONS = 'GET_DEFAULT_ORDER_BUILDING_INSTRUCTIONS',
  GET_GENERIC_TRANSFORMATION = 'GET_GENERIC_TRANSFORMATION',
  GET_LANE_HISTORY = 'GET_LANE_HISTORY',
  GET_LINK_FOR_EXTERNAL_ENTITY = 'GET_LINK_FOR_EXTERNAL_ENTITY',
  GET_LINK_FOR_VOOMA_ENTITY = 'GET_LINK_FOR_VOOMA_ENTITY',
  GET_LOCAL_DATE_TIME = 'GET_LOCAL_DATE_TIME',
  GET_MARKET_CONDITIONS = 'GET_MARKET_CONDITIONS',
  GET_MARKET_RATES = 'GET_MARKET_RATES',
  GET_MOVEMENT_CARRIER_ACTIVITY = 'GET_MOVEMENT_CARRIER_ACTIVITY',
  GET_MOVEMENT_CARRIER_CONVERSATION = 'GET_MOVEMENT_CARRIER_CONVERSATION',
  GET_MOVEMENT_COVERAGE_PLAN = 'GET_MOVEMENT_COVERAGE_PLAN',
  GET_MOVEMENT_DESCRIPTION = 'GET_MOVEMENT_DESCRIPTION',
  GET_MOVEMENT_TRACKING_STATUSES = 'GET_MOVEMENT_TRACKING_STATUSES',
  GET_OPENDOCK_WAREHOUSE_AVAILABILITY = 'GET_OPENDOCK_WAREHOUSE_AVAILABILITY',
  GET_OPENDOCK_WAREHOUSE_CUSTOM_FIELDS = 'GET_OPENDOCK_WAREHOUSE_CUSTOM_FIELDS',
  GET_OPENDOCK_WAREHOUSE_LOAD_TYPES = 'GET_OPENDOCK_WAREHOUSE_LOAD_TYPES',
  GET_ORDER_DETAILS = 'GET_ORDER_DETAILS',
  GET_ORIGINATOR_ORDER_BUILDING_INSTRUCTIONS = 'GET_ORIGINATOR_ORDER_BUILDING_INSTRUCTIONS',
  GET_PRICING_STRATEGY = 'GET_PRICING_STRATEGY',
  GET_SCHEDULING_CONTEXT = 'GET_SCHEDULING_CONTEXT',
  GET_SHIPMENT_DETAILS = 'GET_SHIPMENT_DETAILS',
  GET_SMART_PRICING_TARGETS = 'GET_SMART_PRICING_TARGETS',
  GET_SUBMITTED_ORDER_EXAMPLES = 'GET_SUBMITTED_ORDER_EXAMPLES',
  GET_TRACK_ADVISOR_FACTS = 'GET_TRACK_ADVISOR_FACTS',
  GET_USER_VIEW_CONTEXT = 'GET_USER_VIEW_CONTEXT',
  GET_VOOMA_HELP_DOC = 'GET_VOOMA_HELP_DOC',
  GOOGLE_CHAT_SEND_MESSAGE = 'GOOGLE_CHAT_SEND_MESSAGE',
  HANG_UP_IMMEDIATELY = 'HANG_UP_IMMEDIATELY',
  HIGHWAY_DOT_NUMBER_LOOKUP = 'HIGHWAY_DOT_NUMBER_LOOKUP',
  HIGHWAY_EMAIL_ADDRESS_LOOKUP = 'HIGHWAY_EMAIL_ADDRESS_LOOKUP',
  HIGHWAY_MC_NUMBER_LOOKUP = 'HIGHWAY_MC_NUMBER_LOOKUP',
  HIGHWAY_PHONE_NUMBER_LOOKUP = 'HIGHWAY_PHONE_NUMBER_LOOKUP',
  HOLD_IMMEDIATELY = 'HOLD_IMMEDIATELY',
  INSPECT_INTEGRATION_CONFIGS = 'INSPECT_INTEGRATION_CONFIGS',
  KNOCK_SEND_EMAIL = 'KNOCK_SEND_EMAIL',
  KNOWLEDGE_BASE_LOOKUP = 'KNOWLEDGE_BASE_LOOKUP',
  LIST_ACTION_DEFINITIONS = 'LIST_ACTION_DEFINITIONS',
  LIST_ACTION_TRIGGERS = 'LIST_ACTION_TRIGGERS',
  LIST_BEHAVIOR_LABELS = 'LIST_BEHAVIOR_LABELS',
  LIST_CONTRACTS = 'LIST_CONTRACTS',
  LIST_GENERIC_TRANSFORMATIONS = 'LIST_GENERIC_TRANSFORMATIONS',
  LIST_INTEGRATIONS = 'LIST_INTEGRATIONS',
  LIST_PRICING_STRATEGIES = 'LIST_PRICING_STRATEGIES',
  LIST_SHARED_FILES = 'LIST_SHARED_FILES',
  LIST_SOP_BEHAVIORS = 'LIST_SOP_BEHAVIORS',
  LIST_TRACK_CONFIGURATION = 'LIST_TRACK_CONFIGURATION',
  LOOKUP_ORDER_BUILDING_TEMPLATE = 'LOOKUP_ORDER_BUILDING_TEMPLATE',
  LOOKUP_TEMPLATE_FIELDS = 'LOOKUP_TEMPLATE_FIELDS',
  MAP_CSV_TO_SCHEMA = 'MAP_CSV_TO_SCHEMA',
  MARK_NEGOTIATION_COMPLETE = 'MARK_NEGOTIATION_COMPLETE',
  MARK_ORDER_AI_PROCESSING_COMPLETE = 'MARK_ORDER_AI_PROCESSING_COMPLETE',
  MATCH_CONTRACTS_FOR_SHIPMENT = 'MATCH_CONTRACTS_FOR_SHIPMENT',
  MCLEOD_CARRIER_DISPATCH = 'MCLEOD_CARRIER_DISPATCH',
  MCLEOD_CARRIER_LOOKUP = 'MCLEOD_CARRIER_LOOKUP',
  MCLEOD_CREATE_NEW_CALLIN = 'MCLEOD_CREATE_NEW_CALLIN',
  MCLEOD_RECORD_CARRIER_LOAD_OFFER = 'MCLEOD_RECORD_CARRIER_LOAD_OFFER',
  MCLEOD_UPDATE_BROKERAGE_STATUS = 'MCLEOD_UPDATE_BROKERAGE_STATUS',
  MESSAGE_VEE_AS_USER = 'MESSAGE_VEE_AS_USER',
  MOCK_TOOL = 'MOCK_TOOL',
  MONTWAY_CARRIER_LOOKUP = 'MONTWAY_CARRIER_LOOKUP',
  MONTWAY_CARRIER_LOOKUP_BY_PHONE = 'MONTWAY_CARRIER_LOOKUP_BY_PHONE',
  MOUNT_SHARED_FILES = 'MOUNT_SHARED_FILES',
  MYCARRIERPORTAL_MC_NUMBER_LOOKUP = 'MYCARRIERPORTAL_MC_NUMBER_LOOKUP',
  NAIVE_CARRIER_NEGOTIATION = 'NAIVE_CARRIER_NEGOTIATION',
  PLAN_CREATE_MEMORY = 'PLAN_CREATE_MEMORY',
  POST_TO_ZAPIER = 'POST_TO_ZAPIER',
  PREVIEW_EMAIL_CLASSIFICATION_RULES = 'PREVIEW_EMAIL_CLASSIFICATION_RULES',
  PROJECT44_API = 'PROJECT44_API',
  PROPOSE_SKILL_UPDATE = 'PROPOSE_SKILL_UPDATE',
  QUERY_PROD_LOGS = 'QUERY_PROD_LOGS',
  RAISE_EXCEPTION = 'RAISE_EXCEPTION',
  RATE_CONFIRMATION_CARRIER_TO_COLLECT_LOAD_BID = 'RATE_CONFIRMATION_CARRIER_TO_COLLECT_LOAD_BID',
  READ_ACTION_TRIGGER = 'READ_ACTION_TRIGGER',
  READ_APPT_AND_RELATED_ENTITIES = 'READ_APPT_AND_RELATED_ENTITIES',
  READ_BEHAVIOR_EVALUATION = 'READ_BEHAVIOR_EVALUATION',
  READ_BEHAVIOR_LABEL = 'READ_BEHAVIOR_LABEL',
  READ_CONTACT = 'READ_CONTACT',
  READ_CONVERSATION = 'READ_CONVERSATION',
  READ_DOCUMENT = 'READ_DOCUMENT',
  READ_EXTERNAL_ENTITY = 'READ_EXTERNAL_ENTITY',
  READ_EXTERNAL_MESSAGE = 'READ_EXTERNAL_MESSAGE',
  READ_ORIGINATOR = 'READ_ORIGINATOR',
  READ_ORIGINATOR_FLOWS = 'READ_ORIGINATOR_FLOWS',
  READ_PLACE = 'READ_PLACE',
  READ_PLACE_SCHEDULING_INFO = 'READ_PLACE_SCHEDULING_INFO',
  READ_SHARED_FILE = 'READ_SHARED_FILE',
  READ_SHIPMENT_DATA = 'READ_SHIPMENT_DATA',
  READ_SKILL = 'READ_SKILL',
  READ_SOP = 'READ_SOP',
  READ_TEAM = 'READ_TEAM',
  READ_USER = 'READ_USER',
  READ_VOOMA_ENTITY = 'READ_VOOMA_ENTITY',
  RECORD_BEST_OFFER_IN_CONVERSATION = 'RECORD_BEST_OFFER_IN_CONVERSATION',
  REGISTER_INTENT_TO_HANG_UP = 'REGISTER_INTENT_TO_HANG_UP',
  REGISTER_INTENT_TO_HOLD = 'REGISTER_INTENT_TO_HOLD',
  REGISTER_INTENT_TO_TRANSFER_CALL = 'REGISTER_INTENT_TO_TRANSFER_CALL',
  RELEASE_HOLD = 'RELEASE_HOLD',
  REMOVE_TOOL_FROM_SKILL = 'REMOVE_TOOL_FROM_SKILL',
  RENAME_CONVERSATION = 'RENAME_CONVERSATION',
  REPLY_TO_EMAIL_CONVERSATION = 'REPLY_TO_EMAIL_CONVERSATION',
  REPLY_TO_EXTERNAL_MESSAGE_BY_REFERENCE = 'REPLY_TO_EXTERNAL_MESSAGE_BY_REFERENCE',
  REPLY_TO_INTERNAL_CHAT_CONVERSATION = 'REPLY_TO_INTERNAL_CHAT_CONVERSATION',
  REPLY_TO_SMS_CONVERSATION = 'REPLY_TO_SMS_CONVERSATION',
  REPROCESS_ORDER = 'REPROCESS_ORDER',
  RESOLVE_EXCEPTION = 'RESOLVE_EXCEPTION',
  RESOLVE_NEGOTIATION_PRICE_APPROVAL = 'RESOLVE_NEGOTIATION_PRICE_APPROVAL',
  RESUME_ACTION_EXECUTION_WITH_MESSAGE = 'RESUME_ACTION_EXECUTION_WITH_MESSAGE',
  RESUME_EXCEPTION_WITH_MESSAGE = 'RESUME_EXCEPTION_WITH_MESSAGE',
  REVERSE_GEOCODE_COORDINATES = 'REVERSE_GEOCODE_COORDINATES',
  RUN_BEHAVIOR_EVALS = 'RUN_BEHAVIOR_EVALS',
  RUN_PLAYWRIGHT_CLI_COMMAND = 'RUN_PLAYWRIGHT_CLI_COMMAND',
  RUN_PLAYWRIGHT_SCRIPT = 'RUN_PLAYWRIGHT_SCRIPT',
  RUN_SOP = 'RUN_SOP',
  SAVE_AS_SHARED_FILE = 'SAVE_AS_SHARED_FILE',
  SAVE_SHARED_FILE = 'SAVE_SHARED_FILE',
  SCHEDULE_AGENT = 'SCHEDULE_AGENT',
  SCHEDULE_EMAIL_APPOINTMENT = 'SCHEDULE_EMAIL_APPOINTMENT',
  SCHEDULE_PORTAL = 'SCHEDULE_PORTAL',
  SCHEDULE_PORTAL_AVAIL_APPTS = 'SCHEDULE_PORTAL_AVAIL_APPTS',
  SCHEDULE_STOP = 'SCHEDULE_STOP',
  SCHEDULE_STOP_WITH_EXECUTE_AS_USER = 'SCHEDULE_STOP_WITH_EXECUTE_AS_USER',
  SEARCH_CONTACTS = 'SEARCH_CONTACTS',
  SEARCH_FLOW_DEFINITIONS = 'SEARCH_FLOW_DEFINITIONS',
  SEARCH_INTERNAL_DIRECTORY = 'SEARCH_INTERNAL_DIRECTORY',
  SEARCH_MOVEMENTS = 'SEARCH_MOVEMENTS',
  SEARCH_OPENDOCK_WAREHOUSE = 'SEARCH_OPENDOCK_WAREHOUSE',
  SEARCH_ORIGINATORS = 'SEARCH_ORIGINATORS',
  SEARCH_PLACES = 'SEARCH_PLACES',
  SEARCH_SHIPMENTS = 'SEARCH_SHIPMENTS',
  SEARCH_VOOMA_HELP_DOCS = 'SEARCH_VOOMA_HELP_DOCS',
  SEND_COVER_RATES_PROMPT = 'SEND_COVER_RATES_PROMPT',
  SEND_DTMF_SEQUENCE = 'SEND_DTMF_SEQUENCE',
  SEND_FEEDBACK_TO_VOOMA = 'SEND_FEEDBACK_TO_VOOMA',
  SEND_RATE_CONFIRMATION = 'SEND_RATE_CONFIRMATION',
  SEND_SMS = 'SEND_SMS',
  SET_AUTOSUBMIT_SCOPE = 'SET_AUTOSUBMIT_SCOPE',
  SET_INTEGRATION_CONFIG_OVERRIDE_FOR_ORIGINATOR = 'SET_INTEGRATION_CONFIG_OVERRIDE_FOR_ORIGINATOR',
  SET_LOADBOARD_PRICING = 'SET_LOADBOARD_PRICING',
  SET_ORDER_ATTRIBUTE = 'SET_ORDER_ATTRIBUTE',
  SET_ORDER_STOP_PLACE = 'SET_ORDER_STOP_PLACE',
  SET_ORIGINATOR_ORDER_TEMPLATE = 'SET_ORIGINATOR_ORDER_TEMPLATE',
  SET_SHIPMENT_PRICING = 'SET_SHIPMENT_PRICING',
  SET_TMS_PRICING = 'SET_TMS_PRICING',
  SIMULATE_TRACK_SETTINGS_CHANGE = 'SIMULATE_TRACK_SETTINGS_CHANGE',
  SLACK_SEND_MESSAGE = 'SLACK_SEND_MESSAGE',
  SLACK_SEND_MESSAGE_TO_ANY_CHANNEL = 'SLACK_SEND_MESSAGE_TO_ANY_CHANNEL',
  SLEEP = 'SLEEP',
  START_EMAIL_CONVERSATION = 'START_EMAIL_CONVERSATION',
  START_EMAIL_SIDE_CONVERSATION = 'START_EMAIL_SIDE_CONVERSATION',
  START_INTERNAL_CHAT_CONVERSATION = 'START_INTERNAL_CHAT_CONVERSATION',
  START_SCHEDULING_FOR_STOP = 'START_SCHEDULING_FOR_STOP',
  START_SMS_CONVERSATION = 'START_SMS_CONVERSATION',
  SUBMIT_COVERAGE_PLAN_REVISION = 'SUBMIT_COVERAGE_PLAN_REVISION',
  SUBMIT_VOOMA_ORDER = 'SUBMIT_VOOMA_ORDER',
  SUBSCRIBE_TO_EVENTS = 'SUBSCRIBE_TO_EVENTS',
  TEAMS_SEND_MESSAGE = 'TEAMS_SEND_MESSAGE',
  TEAMS_SEND_MESSAGE_TO_EXECUTE_AS_USER = 'TEAMS_SEND_MESSAGE_TO_EXECUTE_AS_USER',
  TEST_CONTRACT_ELIGIBILITY = 'TEST_CONTRACT_ELIGIBILITY',
  THREE_PL_RATE_CONFIRMATION = 'THREE_PL_RATE_CONFIRMATION',
  THREE_PL_UPDATE = 'THREE_PL_UPDATE',
  TMS_GET = 'TMS_GET',
  TMS_PUT = 'TMS_PUT',
  TRACK_COMPARE_LOCATION_TO_STOP = 'TRACK_COMPARE_LOCATION_TO_STOP',
  TRACK_EN_ROUTE_PRE_CHECK = 'TRACK_EN_ROUTE_PRE_CHECK',
  TRACK_FRONT_COMMENT = 'TRACK_FRONT_COMMENT',
  TRACK_LOAD_CONTROL = 'TRACK_LOAD_CONTROL',
  TRACK_POST_SHIPPER_UPDATE = 'TRACK_POST_SHIPPER_UPDATE',
  TRACK_PREPICKUP_UPDATE_TMS = 'TRACK_PREPICKUP_UPDATE_TMS',
  TRACK_SHIPMENT = 'TRACK_SHIPMENT',
  TRACK_TMS_COMMENT = 'TRACK_TMS_COMMENT',
  TRACK_TMS_FETCH = 'TRACK_TMS_FETCH',
  TRACK_TMS_UPDATE = 'TRACK_TMS_UPDATE',
  TRANSFER_CALL_IMMEDIATELY = 'TRANSFER_CALL_IMMEDIATELY',
  TRIGGER_TMS_LOCATION_SYNC = 'TRIGGER_TMS_LOCATION_SYNC',
  TURVO_ADD_TAG = 'TURVO_ADD_TAG',
  TURVO_CREATE_EXCEPTION = 'TURVO_CREATE_EXCEPTION',
  TURVO_CREATE_TASK = 'TURVO_CREATE_TASK',
  TURVO_LOOKUP_TAGS = 'TURVO_LOOKUP_TAGS',
  TURVO_RECORD_CARRIER_LOAD_OFFER = 'TURVO_RECORD_CARRIER_LOAD_OFFER',
  TURVO_REMOVE_TAG = 'TURVO_REMOVE_TAG',
  TURVO_RESOLVE_EXCEPTION = 'TURVO_RESOLVE_EXCEPTION',
  TURVO_UPDATE_SHIPMENT_STATUS = 'TURVO_UPDATE_SHIPMENT_STATUS',
  TWILIO_FORWARD = 'TWILIO_FORWARD',
  TWILIO_HANG_UP = 'TWILIO_HANG_UP',
  TWILIO_JOIN_CONFERENCE_CALL = 'TWILIO_JOIN_CONFERENCE_CALL',
  UNDO_LAST_ORIGINATOR_TEMPLATE_CHANGE = 'UNDO_LAST_ORIGINATOR_TEMPLATE_CHANGE',
  UNSUBSCRIBE_FROM_EVENTS = 'UNSUBSCRIBE_FROM_EVENTS',
  UPDATE_ACTION_TRIGGER = 'UPDATE_ACTION_TRIGGER',
  UPDATE_CARRIER_OUTREACH_STATUS = 'UPDATE_CARRIER_OUTREACH_STATUS',
  UPDATE_CONTACT = 'UPDATE_CONTACT',
  UPDATE_CONTRACT = 'UPDATE_CONTRACT',
  UPDATE_GENERIC_TRANSFORMATION = 'UPDATE_GENERIC_TRANSFORMATION',
  UPDATE_MEMORY = 'UPDATE_MEMORY',
  UPDATE_ORDER_DETAILS = 'UPDATE_ORDER_DETAILS',
  UPDATE_ORGANIZATION_SETTINGS = 'UPDATE_ORGANIZATION_SETTINGS',
  UPDATE_ORIGINATOR = 'UPDATE_ORIGINATOR',
  UPDATE_ORIGINATOR_FLOW = 'UPDATE_ORIGINATOR_FLOW',
  UPDATE_ORIGINATOR_ORDER_BUILDING_INSTRUCTIONS = 'UPDATE_ORIGINATOR_ORDER_BUILDING_INSTRUCTIONS',
  UPDATE_PLACE = 'UPDATE_PLACE',
  UPDATE_PLACE_SCHEDULING_INFO = 'UPDATE_PLACE_SCHEDULING_INFO',
  UPDATE_PLACE_SCHEDULING_METHOD = 'UPDATE_PLACE_SCHEDULING_METHOD',
  UPDATE_PRICING_STRATEGY = 'UPDATE_PRICING_STRATEGY',
  UPDATE_SCHEDULE_PLAN = 'UPDATE_SCHEDULE_PLAN',
  UPDATE_SKILL = 'UPDATE_SKILL',
  UPDATE_TOOL_PARAMS_FOR_SKILL = 'UPDATE_TOOL_PARAMS_FOR_SKILL',
  UPDATE_TRACK_SETTINGS = 'UPDATE_TRACK_SETTINGS',
  UPDATE_VOOMA_ORDER = 'UPDATE_VOOMA_ORDER',
  UPLOAD_POD_TO_TMS = 'UPLOAD_POD_TO_TMS',
  UPSERT_SOP_BEHAVIOR = 'UPSERT_SOP_BEHAVIOR',
  USE_GRAPHQL_API = 'USE_GRAPHQL_API',
  VALIDATE_VOOMA_ORDER = 'VALIDATE_VOOMA_ORDER',
  VERIFIED_CALL_CARRIER_TO_COLLECT_LOAD_BID = 'VERIFIED_CALL_CARRIER_TO_COLLECT_LOAD_BID',
  VERIFIED_EMAIL_CARRIER_TO_COLLECT_LOAD_BID = 'VERIFIED_EMAIL_CARRIER_TO_COLLECT_LOAD_BID',
  VIEW_FEATURE_FLAGS = 'VIEW_FEATURE_FLAGS',
  VIEW_ORG_SETTINGS = 'VIEW_ORG_SETTINGS',
  VIEW_USER_SETTINGS = 'VIEW_USER_SETTINGS',
  VOOMA_AGENTIC_SHIPMENT_SEARCH_TOOL = 'VOOMA_AGENTIC_SHIPMENT_SEARCH_TOOL',
  VOOMA_AVAILABLE_SHIPMENT_SEARCH_TOOL = 'VOOMA_AVAILABLE_SHIPMENT_SEARCH_TOOL',
  VOOMA_BATCH_RATING_TOOL = 'VOOMA_BATCH_RATING_TOOL',
  VOOMA_BUILD_AGENT = 'VOOMA_BUILD_AGENT',
  VOOMA_CARRIER_VERIFICATION = 'VOOMA_CARRIER_VERIFICATION',
  VOOMA_CONCISELY_LIST_MOVEMENTS = 'VOOMA_CONCISELY_LIST_MOVEMENTS',
  VOOMA_ESTIMATE_CARRIER_ARRIVAL_TIME = 'VOOMA_ESTIMATE_CARRIER_ARRIVAL_TIME',
  VOOMA_FIND_CONTACTS_FOR_CARRIER = 'VOOMA_FIND_CONTACTS_FOR_CARRIER',
  VOOMA_FIND_VERIFIED_CONTACTS_FOR_CARRIER = 'VOOMA_FIND_VERIFIED_CONTACTS_FOR_CARRIER',
  VOOMA_GET_ANCESTOR_SOP_DEFINITION_NAME = 'VOOMA_GET_ANCESTOR_SOP_DEFINITION_NAME',
  VOOMA_GET_EXECUTING_USER_INFORMATION = 'VOOMA_GET_EXECUTING_USER_INFORMATION',
  VOOMA_GET_SHIPMENT_REFERENCE_NUMBERS = 'VOOMA_GET_SHIPMENT_REFERENCE_NUMBERS',
  VOOMA_GET_SUGGESTED_APPOINTMENT_TIME = 'VOOMA_GET_SUGGESTED_APPOINTMENT_TIME',
  VOOMA_PLACE_HAS_COMPLETE_SCHEDULE_DATA = 'VOOMA_PLACE_HAS_COMPLETE_SCHEDULE_DATA',
  VOOMA_QUOTE_COMPOSE_DRAFT = 'VOOMA_QUOTE_COMPOSE_DRAFT',
  VOOMA_QUOTE_CREATE = 'VOOMA_QUOTE_CREATE',
  VOOMA_QUOTE_CREATE_EVENT = 'VOOMA_QUOTE_CREATE_EVENT',
  VOOMA_QUOTE_GENERATE_REQUEST = 'VOOMA_QUOTE_GENERATE_REQUEST',
  VOOMA_QUOTE_GET = 'VOOMA_QUOTE_GET',
  VOOMA_QUOTE_GET_CONTEXT = 'VOOMA_QUOTE_GET_CONTEXT',
  VOOMA_QUOTE_GET_RATE = 'VOOMA_QUOTE_GET_RATE',
  VOOMA_QUOTE_LOOKUP = 'VOOMA_QUOTE_LOOKUP',
  VOOMA_QUOTE_UPDATE = 'VOOMA_QUOTE_UPDATE',
  VOOMA_RECORD_CARRIER_LOAD_OFFER = 'VOOMA_RECORD_CARRIER_LOAD_OFFER',
  VOOMA_RECORD_CARRIER_OFFER_BY_REFERENCE_NUMBER = 'VOOMA_RECORD_CARRIER_OFFER_BY_REFERENCE_NUMBER',
  VOOMA_SCHEDULE_HANDLE_APPT_CONFIRMED = 'VOOMA_SCHEDULE_HANDLE_APPT_CONFIRMED',
  VOOMA_SHIPMENT_APPOINTMENTS_LOOKUP = 'VOOMA_SHIPMENT_APPOINTMENTS_LOOKUP',
  VOOMA_SHIPMENT_APPOINTMENT_STATUS_UPDATE = 'VOOMA_SHIPMENT_APPOINTMENT_STATUS_UPDATE',
  VOOMA_SHIPMENT_LOOKUP_BY_LANE = 'VOOMA_SHIPMENT_LOOKUP_BY_LANE',
  VOOMA_SHIPMENT_LOOKUP_BY_PICKUP = 'VOOMA_SHIPMENT_LOOKUP_BY_PICKUP',
  VOOMA_SHIPMENT_LOOKUP_BY_REFERENCE = 'VOOMA_SHIPMENT_LOOKUP_BY_REFERENCE',
  VOOMA_SHIPMENT_LOOKUP_WRAPPER_TOOL = 'VOOMA_SHIPMENT_LOOKUP_WRAPPER_TOOL',
  VOOMA_SHIPMENT_MARGIN_LOOKUP = 'VOOMA_SHIPMENT_MARGIN_LOOKUP',
  VOOMA_SIMULATE_QUOTE_JOB_REPLY = 'VOOMA_SIMULATE_QUOTE_JOB_REPLY',
  VOOMA_UPDATE_PLACE_SCHEDULE_DATA = 'VOOMA_UPDATE_PLACE_SCHEDULE_DATA',
  WAIT = 'WAIT',
  WAKE_ME_UP = 'WAKE_ME_UP',
  WAKE_ME_UP_DAYS_BEFORE = 'WAKE_ME_UP_DAYS_BEFORE',
  WARM_TRANSFER_CALL = 'WARM_TRANSFER_CALL'
}

export type Carrier = AbstractEntity & Node & {
  __typename?: 'Carrier';
  contacts: Array<Contact>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  dotNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether this carrier has recently shipped for this organization */
  isInNetwork: Scalars['Boolean']['output'];
  mcNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  tmsDeepLink?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CarrierConnection = {
  __typename?: 'CarrierConnection';
  count: Scalars['Int']['output'];
  edges: Array<CarrierEdge>;
  nodes?: Maybe<Array<Carrier>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CarrierContact = {
  carrierName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierContactEntryInput = {
  carrierName: Scalars['String']['input'];
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CarrierContactVerificationEvent = AbstractEntity & Node & {
  __typename?: 'CarrierContactVerificationEvent';
  carrier: Carrier;
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<CarrierContactVerificationEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: CarrierContactVerificationEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type CarrierContactVerificationEventData = {
  __typename?: 'CarrierContactVerificationEventData';
  contactId?: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
  method?: Maybe<CarrierContactVerificationMethod>;
};

export enum CarrierContactVerificationEventType {
  VERIFICATION_EVENT = 'VERIFICATION_EVENT'
}

export enum CarrierContactVerificationMethod {
  HIGHWAY_VERIFIED_CONTACT_FOUND = 'HIGHWAY_VERIFIED_CONTACT_FOUND',
  MANUAL_VERIFICATION_COMPLETED = 'MANUAL_VERIFICATION_COMPLETED',
  VOOMA_VERIFICATION_CALL_FAILED = 'VOOMA_VERIFICATION_CALL_FAILED',
  VOOMA_VERIFICATION_CALL_SUCCEEDED = 'VOOMA_VERIFICATION_CALL_SUCCEEDED'
}

export type CarrierEdge = {
  __typename?: 'CarrierEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Carrier;
};

export type CarrierInquiryData = {
  __typename?: 'CarrierInquiryData';
  carrierId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  eventType: MovementEventType;
};

export type CarrierInterestContextInput = {
  historicalNegotiationOffers?: InputMaybe<Array<NegotiationOfferInput>>;
  negotiationOffers?: InputMaybe<Array<NegotiationOfferInput>>;
  rateGuidance?: InputMaybe<RateGuidanceInput>;
  recentCarrierInquiries?: InputMaybe<Array<RecentCarrierInquiryInput>>;
  recentCarrierOffers?: InputMaybe<Array<RecentCarrierOfferInput>>;
  recentCarriersTransferred?: InputMaybe<Array<RecentCarrierTransferInput>>;
};

export type CarrierInterestContextType = {
  __typename?: 'CarrierInterestContextType';
  historicalNegotiationOffers?: Maybe<Array<NegotiationOfferType>>;
  negotiationOffers?: Maybe<Array<NegotiationOfferType>>;
  rateGuidance?: Maybe<RateGuidanceType>;
  recentCarrierInquiries?: Maybe<Array<RecentCarrierInquiryType>>;
  recentCarrierOffers?: Maybe<Array<RecentCarrierOfferType>>;
  recentCarriersTransferred?: Maybe<Array<RecentCarrierTransferType>>;
};

export type CarrierLaneRun = {
  __typename?: 'CarrierLaneRun';
  carrier: Carrier;
  lastRunDate: Scalars['DateTimeISO']['output'];
  lastRunRate?: Maybe<Scalars['Float']['output']>;
  runCount: Scalars['Int']['output'];
};

/** Controls how the strategy responds when the carrier stops moving on price between consecutive offers. */
export enum CarrierNoBudgeBehavior {
  DONT_BUDGE = 'DONT_BUDGE',
  NEGOTIATE = 'NEGOTIATE'
}

export type CarrierOutreach = AbstractEntity & Node & {
  __typename?: 'CarrierOutreach';
  carrier: Carrier;
  contact?: Maybe<Contact>;
  conversationIds?: Maybe<Array<Scalars['String']['output']>>;
  coveragePlan?: Maybe<CoveragePlan>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  onlyCollectOffer?: Maybe<Scalars['Boolean']['output']>;
  organization: Organization;
  seq: Scalars['Int']['output'];
  skipReason?: Maybe<CarrierOutreachSkipReason>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CarrierOutreachAttempt = AbstractEntity & Node & {
  __typename?: 'CarrierOutreachAttempt';
  actionExecutionId?: Maybe<Scalars['String']['output']>;
  carrierOutreachId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  stages?: Maybe<Array<OutreachCallStage>>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CarrierOutreachMovement = AbstractEntity & Node & {
  __typename?: 'CarrierOutreachMovement';
  carrierOutreachId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  onlyCollectOffer?: Maybe<Scalars['Boolean']['output']>;
  seq: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum CarrierOutreachSkipReason {
  ACTION_DEFINITION_UNAVAILABLE = 'ACTION_DEFINITION_UNAVAILABLE',
  CARRIER_VERIFICATION_FAILED = 'CARRIER_VERIFICATION_FAILED',
  CHILD_ACTION_SKIPPED = 'CHILD_ACTION_SKIPPED',
  CONTACT_UNREACHABLE = 'CONTACT_UNREACHABLE',
  MANUAL = 'MANUAL',
  MOVEMENT_NOT_READY = 'MOVEMENT_NOT_READY',
  MOVEMENT_READINESS_CHECK_FAILED = 'MOVEMENT_READINESS_CHECK_FAILED',
  OUTBOUND_CAPACITY_TIMEOUT = 'OUTBOUND_CAPACITY_TIMEOUT',
  QUALIFYING_OFFER_RECEIVED = 'QUALIFYING_OFFER_RECEIVED',
  UNSUPPORTED_CHANNEL = 'UNSUPPORTED_CHANNEL'
}

export type CarrierRate = AbstractEntity & Node & {
  __typename?: 'CarrierRate';
  carrier?: Maybe<Carrier>;
  /** Serialized as JSON */
  computedRate?: Maybe<Scalars['JSON']['output']>;
  contact?: Maybe<Contact>;
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** Serialized as JSON */
  loadData?: Maybe<Scalars['JSON']['output']>;
  /** Serialized as JSON */
  metadata?: Maybe<Scalars['JSON']['output']>;
  movement?: Maybe<Movement>;
  organization: Organization;
  quote?: Maybe<Quote>;
  ratingMethod: RatingMethod;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CarrierSnapshot = {
  __typename?: 'CarrierSnapshot';
  dispatch?: Maybe<MovementCarrierContact>;
  driver?: Maybe<MovementCarrierContact>;
  externalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CarrierSource {
  GENLOGS = 'GENLOGS'
}

export type CarrierSourceData = CarrierSourceDataGenlogs;

export type CarrierSourceDataGenlogs = {
  __typename?: 'CarrierSourceDataGenlogs';
  carrierScoreScaled: Scalars['Float']['output'];
  source: CarrierSource;
};

/** How to aggregate results from multiple verification sources */
export enum CarrierVerificationAggregationMode {
  ALL = 'ALL',
  ANY = 'ANY'
}

/** Type of carrier verification integration */
export enum CarrierVerificationIntegrationType {
  HIGHWAY = 'HIGHWAY',
  HIGHWAY_EMAIL = 'HIGHWAY_EMAIL',
  HIGHWAY_PHONE = 'HIGHWAY_PHONE',
  HOSTED_MCLEOD = 'HOSTED_MCLEOD',
  LANDSTAR = 'LANDSTAR',
  MONTWAY = 'MONTWAY',
  MYCARRIERPORTAL = 'MYCARRIERPORTAL',
  RMIS = 'RMIS',
  TURVO = 'TURVO'
}

/** Result of carrier verification */
export enum CarrierVerificationSimulationResult {
  FAIL = 'FAIL',
  MAYBE_PASS = 'MAYBE_PASS',
  PASS = 'PASS'
}

export type CarrierVerificationSimulationResultType = {
  __typename?: 'CarrierVerificationSimulationResultType';
  aggregatedResult: CarrierVerificationSimulationResult;
  aggregationMode: CarrierVerificationAggregationMode;
  availableIntegrations: Array<CarrierVerificationIntegrationType>;
  carrierName: Scalars['String']['output'];
  dotNumber?: Maybe<Scalars['String']['output']>;
  expectedResult?: Maybe<CarrierVerificationSimulationResult>;
  individualResults: Array<IndividualVerificationResultType>;
  matchesExpected: Scalars['Boolean']['output'];
  mcNumber?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
};

export type CarriersInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeActionExecutionAutonomyStateInput = {
  autonomyState: AutonomyState;
  id: Scalars['ID']['input'];
};

export type ChangeActionExecutionAutonomyStatePayload = {
  __typename?: 'ChangeActionExecutionAutonomyStatePayload';
  success: Scalars['Boolean']['output'];
};

export type ChangeActionExecutionStatusInput = {
  id: Scalars['ID']['input'];
  status: ActionExecutionStatus;
};

export type ChangeMonthlyCommitInput = {
  monthlyCommitCents: Scalars['Int']['input'];
};

export type ChannelOption = {
  __typename?: 'ChannelOption';
  channelGroup?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ChatConversationMetadata = {
  __typename?: 'ChatConversationMetadata';
  context?: Maybe<Scalars['JSON']['output']>;
  entityIds?: Maybe<Scalars['JSON']['output']>;
};

export type ChatSuggestion = {
  __typename?: 'ChatSuggestion';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  message: Scalars['String']['output'];
  product: Product;
};

export type ChatSuggestionsInput = {
  context: ChatViewContextInput;
  organizationId: Scalars['ID']['input'];
};

export type ChatThreadMessagePreview = {
  __typename?: 'ChatThreadMessagePreview';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
};

export type ChatViewContextInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  entityIds: Scalars['JSON']['input'];
  openEmailMessageId?: InputMaybe<Scalars['ID']['input']>;
  pageContentAccess?: InputMaybe<ChatViewPageContentAccess>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ChatViewContextUpdatedData = {
  __typename?: 'ChatViewContextUpdatedData';
  context: Scalars['JSON']['output'];
  eventDataType: ConversationEventType;
};

export enum ChatViewPageContentAccess {
  ALLOWED = 'ALLOWED',
  NOT_ALLOWED = 'NOT_ALLOWED'
}

export type CheckAgentMailAvailabilityInput = {
  email: Scalars['String']['input'];
};

export type CheckAgentMailAvailabilityPayload = {
  __typename?: 'CheckAgentMailAvailabilityPayload';
  available: Scalars['Boolean']['output'];
};

export type CheckIntegrationCredentialsInput = {
  organizationId: Scalars['ID']['input'];
  type: IntegrationCredentialsType;
  usageIndicator: UsageIndicator;
};

export type CheckIntegrationCredentialsPayload = {
  __typename?: 'CheckIntegrationCredentialsPayload';
  result: IntegrationCheckResult;
};

/** Types of checks that can be performed */
export enum CheckTypes {
  AFTER = 'AFTER',
  AT_TIME = 'AT_TIME',
  BEFORE = 'BEFORE'
}

export type ClarificationRequestType = {
  __typename?: 'ClarificationRequestType';
  acceptableValues?: Maybe<Array<Scalars['String']['output']>>;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** The status of the classification case. */
export enum ClassificationStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEW = 'NEW',
  PENDING_CLASSIFICATION = 'PENDING_CLASSIFICATION',
  SKIPPED = 'SKIPPED',
  SUCCEEDED = 'SUCCEEDED'
}

export type CloneActionDefinitionInput = {
  id: Scalars['ID']['input'];
};

export type CloneActionDefinitionPayload = {
  __typename?: 'CloneActionDefinitionPayload';
  actionDefinition: ActionDefinition;
};

export type CloseToDeliveryInterval = {
  __typename?: 'CloseToDeliveryInterval';
  /** Minutes between en-route milestones while the truck is within withinMiles of the last delivery. Applies only with a fixed intervalMinutes cadence (ignored with distanceBasedIntervals or fixedDailyTimes) and overrides it, including for hot and team loads. Unset disables the override. */
  intervalMinutes?: Maybe<Scalars['Float']['output']>;
  /** Road miles from the last delivery at which intervalMinutes takes over. Defaults to 200. */
  withinMiles?: Maybe<Scalars['Float']['output']>;
  /** When set, intervalMinutes also requires the last delivery's window start or appointment to be at most this many minutes away (or already past), in addition to withinMiles. Unset applies no time condition. */
  withinMinutesOfDeliveryStart?: Maybe<Scalars['Float']['output']>;
};

export type CloseToDeliveryIntervalInput = {
  /** Minutes between en-route milestones while the truck is within withinMiles of the last delivery. Applies only with a fixed intervalMinutes cadence (ignored with distanceBasedIntervals or fixedDailyTimes) and overrides it, including for hot and team loads. Unset disables the override. */
  intervalMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Road miles from the last delivery at which intervalMinutes takes over. Defaults to 200. */
  withinMiles?: InputMaybe<Scalars['Float']['input']>;
  /** When set, intervalMinutes also requires the last delivery's window start or appointment to be at most this many minutes away (or already past), in addition to withinMiles. Unset applies no time condition. */
  withinMinutesOfDeliveryStart?: InputMaybe<Scalars['Float']['input']>;
};

export type CommodityOption = {
  __typename?: 'CommodityOption';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum CommunicationChannel {
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  EMAIL = 'EMAIL',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS'
}

export type CompleteMicrosoftGraphConnectPayload = {
  __typename?: 'CompleteMicrosoftGraphConnectPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ComposioToolInfo = {
  __typename?: 'ComposioToolInfo';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ComposioToolKitDetails = {
  __typename?: 'ComposioToolKitDetails';
  logo: Scalars['String']['output'];
  toolKitName: Scalars['String']['output'];
};

export type ComposioToolKitDetailsPayload = {
  __typename?: 'ComposioToolKitDetailsPayload';
  success: Scalars['Boolean']['output'];
  toolKit: ComposioToolKitDetails;
};

export type ComposioToolKitInfo = {
  __typename?: 'ComposioToolKitInfo';
  description: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ComputeLaneRatesInput = {
  movementId: Scalars['ID']['input'];
};

export type ComputeLaneRatesPayload = {
  __typename?: 'ComputeLaneRatesPayload';
  rates: Array<LaneRateResult>;
  success: Scalars['Boolean']['output'];
};

export type ComputeRatesInput = {
  id: Scalars['ID']['input'];
};

export type ComputeRatesPayload = {
  __typename?: 'ComputeRatesPayload';
  carrierRates: Array<CarrierRate>;
  customerRates: Array<CustomerRate>;
  ratingErrors?: Maybe<Array<RatingError>>;
  success: Scalars['Boolean']['output'];
};

export type ComputeSmartPricingPriorsInput = {
  carrierInterestContext?: InputMaybe<CarrierInterestContextInput>;
  configOverride?: InputMaybe<Scalars['JSON']['input']>;
  organizationId: Scalars['ID']['input'];
  shipmentReference: Scalars['String']['input'];
};

export enum ComputerVisionModelName {
  AZURE = 'AZURE',
  AZURE_PLUS_LLM = 'AZURE_PLUS_LLM',
  GPT_4_VISION = 'GPT_4_VISION',
  LLAMA_PARSE = 'LLAMA_PARSE'
}

export type ConditionalConfigType = {
  __typename?: 'ConditionalConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  defaultStrategyId: Scalars['ID']['output'];
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  rules: Array<ConditionalRuleType>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ConditionalRuleType = {
  __typename?: 'ConditionalRuleType';
  conditions: NegotiationStrategyConditionsType;
  strategyId: Scalars['ID']['output'];
};

export type ConferenceJoinedData = {
  __typename?: 'ConferenceJoinedData';
  conferenceId: Scalars['String']['output'];
  eventDataType: ConversationEventType;
};

export type ConfidenceRange = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type ConfigurableOptions = {
  __typename?: 'ConfigurableOptions';
  commodities?: Maybe<Array<CommodityOption>>;
  freightOrderIntegrationType?: Maybe<Scalars['String']['output']>;
  missingLocationCodeCreatesLocation?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfigureOrderTemplateInput = {
  id: Scalars['ID']['input'];
  multiOrderPrompt?: InputMaybe<Scalars['String']['input']>;
  orderBuildPrompt?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigureOrderTemplatePayload = {
  __typename?: 'ConfigureOrderTemplatePayload';
  template: Template;
};

export type ConfiguredCarrierVerificationCredentialTypesInput = {
  organizationId: Scalars['ID']['input'];
};

export type ConfiguredCarrierVerificationCredentialTypesPayload = {
  __typename?: 'ConfiguredCarrierVerificationCredentialTypesPayload';
  credentialTypes: Array<IntegrationCredentialsType>;
};

export type ConfirmedAppointmentSnapshot = {
  __typename?: 'ConfirmedAppointmentSnapshot';
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  confirmedDt?: Maybe<Scalars['DateTimeISO']['output']>;
  movementStopId?: Maybe<Scalars['String']['output']>;
};

export type ConnectWorkerComposioAccountInput = {
  organizationId: Scalars['ID']['input'];
  toolkitSlug?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

export type Contact = AbstractEntity & Node & {
  __typename?: 'Contact';
  carrier?: Maybe<Carrier>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameEmbedding?: Maybe<Array<Scalars['Float']['output']>>;
  organization: Organization;
  originator?: Maybe<Originator>;
  phone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<ContactRole>>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ContactCarrierToCollectLoadBidInput = {
  carrierContact: CarrierContact;
  contactMethod: ContactMethod;
  orderId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCarrierToCollectLoadBidPayload = {
  __typename?: 'ContactCarrierToCollectLoadBidPayload';
  actionExecutionId: Scalars['String']['output'];
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContactEdge>;
  nodes?: Maybe<Array<Contact>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Contact;
};

export enum ContactMethod {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  RATE_CONFIRMATION = 'RATE_CONFIRMATION'
}

export type ContactMethodRecord = AbstractEntity & Node & {
  __typename?: 'ContactMethodRecord';
  contactId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: ContactMethodStatus;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum ContactMethodStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum ContactRole {
  DISPATCH = 'DISPATCH',
  DRIVER = 'DRIVER'
}

export type ContactsInput = {
  carrierId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ContinuationPriorPoint = {
  __typename?: 'ContinuationPriorPoint';
  probability: Scalars['Float']['output'];
  step: Scalars['Int']['output'];
};

export type ContinueTeamsConnectionPayload = {
  __typename?: 'ContinueTeamsConnectionPayload';
  error?: Maybe<Scalars['String']['output']>;
  nextUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Contract = AbstractEntity & Node & {
  __typename?: 'Contract';
  carrier: Carrier;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  destinationName: Scalars['String']['output'];
  destinationPoint: Scalars['JSON']['output'];
  destinationRadiusMiles: Scalars['Float']['output'];
  effectiveAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Serialized as JSON */
  eligibilityCondition?: Maybe<Scalars['JSON']['output']>;
  endDate?: Maybe<Scalars['DateTimeISO']['output']>;
  equipmentTypes: Array<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  originName: Scalars['String']['output'];
  originPoint: Scalars['JSON']['output'];
  originRadiusMiles: Scalars['Float']['output'];
  originator?: Maybe<Originator>;
  /** Serialized as JSON */
  rate?: Maybe<Scalars['JSON']['output']>;
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type Conversation = AbstractEntity & Node & {
  __typename?: 'Conversation';
  actions: Array<ActionExecution>;
  analyses: Array<ConversationAnalysis>;
  /** Action executions linked by an association rather than their conversationId, such as the Vee run that started an email thread. */
  associatedActionExecutions: Array<ActionExecution>;
  associatedCarriers: Array<Carrier>;
  associatedReferenceNumbers: Array<Scalars['String']['output']>;
  associatedShipments: Array<Shipment>;
  contactIdentifier?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  events: Array<ConversationEvent>;
  externalIdentifier: Scalars['String']['output'];
  externalMessages: Array<ExternalMessage>;
  /** Open escalations whose handler is working in this conversation. */
  handledOpenEscalations: Array<Exception>;
  hasActionExecutionInProgress: Scalars['Boolean']['output'];
  hasUnreadMessages: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  latestExternalMessage?: Maybe<ChatThreadMessagePreview>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<ConversationMetadata>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  ratings: Array<ConversationRating>;
  /** For a side conversation, the thread whose email it replies about. */
  sideConversationParent?: Maybe<Conversation>;
  status: ConversationStatus;
  subscribers: Array<User>;
  summary?: Maybe<ConversationSummary>;
  title?: Maybe<Scalars['String']['output']>;
  type: ConversationType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};


export type ConversationAssociatedActionExecutionsArgs = {
  aboutThisThread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversationActionExecutionUpdatePayload = {
  __typename?: 'ConversationActionExecutionUpdatePayload';
  actionExecutionId: Scalars['String']['output'];
  conversationIds: Array<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventType: ActionExecutionEventType;
  organizationId: Scalars['String']['output'];
};

export type ConversationAnalysis = AbstractEntity & Node & {
  __typename?: 'ConversationAnalysis';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  results?: Maybe<Scalars['JSON']['output']>;
  status: ProcessingStatus;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  count: Scalars['Int']['output'];
  edges: Array<ConversationEdge>;
  nodes?: Maybe<Array<Conversation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConversationDateFilter = {
  /** List Conversation that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List Conversation that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List Conversation that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List Conversation that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Conversation;
};

export type ConversationEvent = AbstractEntity & Node & {
  __typename?: 'ConversationEvent';
  conversation: Conversation;
  conversationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<ConversationEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: ConversationEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type ConversationEventCreatedTriggerConfig = {
  __typename?: 'ConversationEventCreatedTriggerConfig';
  conversationEventTypes: Array<ConversationEventType>;
  override?: Maybe<BaseTriggerOverride>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
};

export type ConversationEventData = AsyncTransferData | CallEndedData | CallFailedData | CallRecordingReceivedData | CallRecordingStartedData | CallTransferAcceptedData | CallTransferredData | ChatViewContextUpdatedData | ConferenceJoinedData | QuietLineIntentData | ReturnedToTransferredCallData | UnknownConversationEventData | WatcherClosedData;

export type ConversationEventLabel = {
  __typename?: 'ConversationEventLabel';
  event: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  rationale: Scalars['String']['output'];
};

export enum ConversationEventType {
  ASYNC_TRANSFER = 'ASYNC_TRANSFER',
  CALL_ENDED = 'CALL_ENDED',
  CALL_FAILED = 'CALL_FAILED',
  CALL_RECORDING_RECEIVED = 'CALL_RECORDING_RECEIVED',
  CALL_RECORDING_STARTED = 'CALL_RECORDING_STARTED',
  CALL_TRANSFERRED = 'CALL_TRANSFERRED',
  CALL_TRANSFER_ACCEPTED = 'CALL_TRANSFER_ACCEPTED',
  CHAT_VIEW_CONTEXT_UPDATED = 'CHAT_VIEW_CONTEXT_UPDATED',
  CONFERENCE_JOINED = 'CONFERENCE_JOINED',
  CONVERSATION_CLOSED_BY_WATCHER = 'CONVERSATION_CLOSED_BY_WATCHER',
  INTENT_TO_HANG_UP_CANCELLED = 'INTENT_TO_HANG_UP_CANCELLED',
  INTENT_TO_HANG_UP_REGISTERED = 'INTENT_TO_HANG_UP_REGISTERED',
  INTENT_TO_HOLD_CANCELLED = 'INTENT_TO_HOLD_CANCELLED',
  INTENT_TO_HOLD_REGISTERED = 'INTENT_TO_HOLD_REGISTERED',
  INTENT_TO_TRANSFER_CANCELLED = 'INTENT_TO_TRANSFER_CANCELLED',
  INTENT_TO_TRANSFER_REGISTERED = 'INTENT_TO_TRANSFER_REGISTERED',
  RETURNED_TO_TRANSFERRED_CALL = 'RETURNED_TO_TRANSFERRED_CALL',
  UNKNOWN = 'UNKNOWN'
}

export type ConversationExceptionsInput = {
  createdAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
  organizationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type ConversationExternalMessagesConnection = {
  __typename?: 'ConversationExternalMessagesConnection';
  count: Scalars['Int']['output'];
  edges: Array<ConversationExternalMessagesEdge>;
  nodes?: Maybe<Array<ExternalMessage>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConversationExternalMessagesEdge = {
  __typename?: 'ConversationExternalMessagesEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: ExternalMessage;
};

export type ConversationExternalMessagesInput = {
  conversationId: Scalars['ID']['input'];
  /** When true, includes mirrored copies of canonical messages (rows with a canonicalMessageId). */
  includeMirrored?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ConversationFilterOption = {
  __typename?: 'ConversationFilterOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Type of filter option to retrieve for conversations */
export enum ConversationFilterOptionType {
  FROM_PHONE = 'FROM_PHONE',
  LINKED_ACTION_DEFINITION = 'LINKED_ACTION_DEFINITION',
  PARTICIPANT = 'PARTICIPANT',
  TO_PHONE = 'TO_PHONE'
}

export type ConversationFilterOptionsInput = {
  conversationTypes?: InputMaybe<Array<ConversationType>>;
  organizationId: Scalars['ID']['input'];
  type: ConversationFilterOptionType;
};

export type ConversationFilterOptionsPayload = {
  __typename?: 'ConversationFilterOptionsPayload';
  options: Array<ConversationFilterOption>;
};

export type ConversationGraphProcedure = {
  __typename?: 'ConversationGraphProcedure';
  deterministic?: Maybe<Scalars['Boolean']['output']>;
  eventLabels?: Maybe<Array<OutcomeLabel>>;
  graph: GraphDefinition;
  includeTranscriptInOutput?: Maybe<Scalars['Boolean']['output']>;
  initialInstructions: Scalars['String']['output'];
  modality: ConversationModality;
  outcomeLabels?: Maybe<Array<OutcomeLabel>>;
  outputInstructions?: Maybe<Scalars['String']['output']>;
  procedureType: ProcedureType;
  semanticWaitPatterns?: Maybe<Scalars['JSON']['output']>;
  textModelName?: Maybe<LlmName>;
  voiceModelName?: Maybe<Scalars['String']['output']>;
  watchers?: Maybe<Array<WatcherDefinition>>;
};

export enum ConversationInitiationDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}

export type ConversationLabelBackfillActionDefinitionsInput = {
  organizationId: Scalars['ID']['input'];
};

export type ConversationLabelBackfillPreviewPayload = {
  __typename?: 'ConversationLabelBackfillPreviewPayload';
  conversationCount: Scalars['Int']['output'];
  oldestCreatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ConversationMetadata = ChatConversationMetadata | EmailConversationMetadata | MicrosoftTeamsConversationMetadata | PhoneConversationMetadata | SmsConversationMetadata;

export enum ConversationModality {
  CHAT = 'CHAT',
  EMAIL = 'EMAIL',
  MICROSOFT_TEAMS = 'MICROSOFT_TEAMS',
  SMS = 'SMS',
  VOICE = 'VOICE'
}

export type ConversationOutcomeLabel = {
  __typename?: 'ConversationOutcomeLabel';
  outcome: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
};

export type ConversationRating = AbstractEntity & Node & {
  __typename?: 'ConversationRating';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  /** Integer from 0 to 10 (inclusive) */
  starRating: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type ConversationSideConversationAssociation = AbstractEntity & Node & {
  __typename?: 'ConversationSideConversationAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  conversation: Conversation;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  sideConversation: Conversation;
  source: Conversation;
  target: Conversation;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum ConversationStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING'
}

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  eventLabels?: Maybe<Array<ConversationEventLabel>>;
  outcomeLabels?: Maybe<Array<ConversationOutcomeLabel>>;
  sentiment?: Maybe<ConversationSummarySentiment>;
  summary?: Maybe<Scalars['String']['output']>;
  transferSummary?: Maybe<Scalars['String']['output']>;
};

export enum ConversationSummarySentiment {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export enum ConversationType {
  CHAT = 'CHAT',
  EMAIL = 'EMAIL',
  MICROSOFT_TEAMS = 'MICROSOFT_TEAMS',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS'
}

export type ConversationUpdatePayload = {
  __typename?: 'ConversationUpdatePayload';
  conversationId: Scalars['String']['output'];
  conversationType: ConversationType;
  messageId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  type: ConversationUpdateType;
};

export enum ConversationUpdateType {
  CONVERSATION_CREATED = 'CONVERSATION_CREATED',
  MESSAGE_CREATED = 'MESSAGE_CREATED',
  MESSAGE_UPDATED = 'MESSAGE_UPDATED',
  TITLE_UPDATED = 'TITLE_UPDATED'
}

export type ConversationsInput = {
  createdAt?: InputMaybe<ConversationDateFilter>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fromPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by last activity: the latest message time, falling back to the conversation creation time when there are no messages. */
  lastActivityAt?: InputMaybe<ConversationDateFilter>;
  /** Only return conversations with an action execution (linked directly or via association) for one of these action definitions. Conversations with no linked action executions yet are always included. */
  linkedActionDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only return conversations about one of these movements: chats started with the movement as context, or conversations whose action executions are associated with it. */
  movementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only return conversations where one of these users is the owner or has authored a message. */
  participantUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  subscriberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  toPhoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<ConversationType>>;
};

export type CopyJobToComplementaryInput = {
  id: Scalars['ID']['input'];
};

export type CopyJobToComplementaryPayload = {
  __typename?: 'CopyJobToComplementaryPayload';
  complementaryJob: Job;
  success: Scalars['Boolean']['output'];
};

export type CoverAutomaticCoverageSettingsInput = {
  organizationId: Scalars['ID']['input'];
};

export type CoverAutomaticCoverageSettingsPayload = {
  __typename?: 'CoverAutomaticCoverageSettingsPayload';
  availableStrategies: Array<CoverAutomaticCoverageStrategy>;
  canEdit: Scalars['Boolean']['output'];
  isCurrentStrategyAvailable: Scalars['Boolean']['output'];
  settings: Scalars['JSON']['output'];
};

export enum CoverAutomaticCoverageStrategy {
  CAPACITY_DRIVEN = 'CAPACITY_DRIVEN',
  CARRIER_LIST_WAVES = 'CARRIER_LIST_WAVES',
  COVERAGE_TIERS = 'COVERAGE_TIERS',
  EMPTY = 'EMPTY'
}

export type CoverEvalDatasetResult = {
  __typename?: 'CoverEvalDatasetResult';
  datasetName: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  errorRegressions?: Maybe<Scalars['Float']['output']>;
  experimentUrl?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  scorerRegressions?: Maybe<Scalars['Float']['output']>;
};

export type CoverOfferAcceptedData = {
  __typename?: 'CoverOfferAcceptedData';
  carrierId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  eventType: MovementEventType;
  negotiationStrategyId?: Maybe<Scalars['String']['output']>;
  offerAmount: Scalars['Float']['output'];
  offeredBy: CoverOfferOfferedBy;
  variantNegotiationStrategyId?: Maybe<Scalars['String']['output']>;
};

export type CoverOfferData = {
  __typename?: 'CoverOfferData';
  carrierId?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['String']['output']>;
  eventType: MovementEventType;
  movementStrategyOverride?: Maybe<Scalars['JSON']['output']>;
  negotiationStrategyId?: Maybe<Scalars['String']['output']>;
  offerAmount: Scalars['Float']['output'];
  offeredBy: CoverOfferOfferedBy;
  variantNegotiationStrategyId?: Maybe<Scalars['String']['output']>;
};

export enum CoverOfferOfferedBy {
  CARRIER = 'CARRIER',
  VOOMA = 'VOOMA'
}

export type CoverQuotesConfig = {
  inboundPhoneNumber: Scalars['String']['input'];
};

export type CoverStats = {
  __typename?: 'CoverStats';
  bookingAssistCount: Scalars['Int']['output'];
  callsDeflectedCount: Scalars['Int']['output'];
  emailsDeflectedCount: Scalars['Int']['output'];
  offersRecordedCount: Scalars['Int']['output'];
};

export type CoverStatsRangeInput = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CoveragePlan = AbstractEntity & Node & {
  __typename?: 'CoveragePlan';
  carrierOffers?: Maybe<Array<Scalars['JSON']['output']>>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  loadboardPlans?: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  outboundPlan?: Maybe<Array<Scalars['JSON']['output']>>;
  startedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type CoveragePlanExternalChannelInput = {
  channelType: ExternalChannelType;
  externalIdentifier: Scalars['String']['input'];
};

export type CoveragePlanGeneratorInput = {
  externalChannel?: InputMaybe<CoveragePlanExternalChannelInput>;
  type: CoveragePlanGeneratorType;
};

/** Which generator produces coverage plan revisions */
export enum CoveragePlanGeneratorType {
  COVERAGE_TIERS = 'COVERAGE_TIERS',
  SHARE_COVERAGE_PLAN_SOP = 'SHARE_COVERAGE_PLAN_SOP'
}

export type CoveragePlanPayload = {
  __typename?: 'CoveragePlanPayload';
  coveragePlan: CoveragePlan;
  success: Scalars['Boolean']['output'];
};

export type CoveragePlansForShipmentPayload = {
  __typename?: 'CoveragePlansForShipmentPayload';
  coveragePlans: Array<CoveragePlan>;
};

export enum CoverageState {
  COVERED = 'COVERED',
  NOT_READY_FOR_COVERAGE = 'NOT_READY_FOR_COVERAGE',
  READY_FOR_COVERAGE = 'READY_FOR_COVERAGE'
}

export type CoverageStatePreviewInput = {
  organizationId: Scalars['ID']['input'];
};

/** Coverage state a shipment is considered to be in under the organization’s current coverage-readiness rule. */
export type CoverageStatePreviewResult = {
  __typename?: 'CoverageStatePreviewResult';
  /** State after applying the coverage-readiness rule. */
  coverageState?: Maybe<CoverageState>;
  /** State derived from the TMS before rules are applied. */
  defaultCoverageState?: Maybe<CoverageState>;
  error?: Maybe<Scalars['String']['output']>;
  movementId?: Maybe<Scalars['ID']['output']>;
  /** Most recently recorded coverage event for the movement. */
  recordedCoverageState?: Maybe<CoverageState>;
  shipmentId: Scalars['ID']['output'];
  shipmentReferenceNumber?: Maybe<Scalars['String']['output']>;
  shipmentUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum CoverageStatus {
  AVAILABLE = 'AVAILABLE',
  COVERED = 'COVERED',
  CREATED = 'CREATED',
  DELIVERED = 'DELIVERED',
  DISPATCHED = 'DISPATCHED',
  LOADED = 'LOADED',
  RELEASED_TO_BILLING = 'RELEASED_TO_BILLING',
  TENDERED = 'TENDERED',
  TENDER_ACCEPTED = 'TENDER_ACCEPTED',
  TENDER_OFFERED = 'TENDER_OFFERED',
  UNKNOWN = 'UNKNOWN',
  UNLOADED = 'UNLOADED',
  VOIDED = 'VOIDED'
}

export type CoveredData = {
  __typename?: 'CoveredData';
  carrier?: Maybe<CarrierSnapshot>;
  eventType: MovementEventType;
  facilitatedByVooma?: Maybe<Scalars['Boolean']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type CrateTeamMemberPayload = {
  __typename?: 'CrateTeamMemberPayload';
  success: Scalars['Boolean']['output'];
  teamMember?: Maybe<TeamMember>;
};

export type CreateActionBehaviorInput = {
  actionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  datasetName: Scalars['String']['input'];
  scorerSlug: Scalars['String']['input'];
};

export type CreateActionDefinitionInput = {
  canonicalTools: Array<Scalars['JSON']['input']>;
  classifyConversationMessages?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAutonomyState?: InputMaybe<AutonomyState>;
  deterministicToolInvocations: DeterministicToolInvocationsInput;
  hasMemory?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<ActionDefinitionMode>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  postCompletionMessageBehavior?: InputMaybe<PostCompletionMessageBehavior>;
  procedure: Scalars['JSON']['input'];
  respondsToCoworkers?: InputMaybe<Scalars['Boolean']['input']>;
  runDetached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Overrides experimental service routing. Null inherits from the global prompt or uses the normal service. */
  runsOnExperimentalService?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workersConfig: Scalars['JSON']['input'];
};

export type CreateActionDefinitionPayload = {
  __typename?: 'CreateActionDefinitionPayload';
  actionDefinition: ActionDefinition;
};

export type CreateActionTriggerInput = {
  actionDefinitionId: Scalars['ID']['input'];
  config: Scalars['JSON']['input'];
  organizationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateActionTriggerPayload = {
  __typename?: 'CreateActionTriggerPayload';
  actionTrigger: ActionTrigger;
};

export type CreateAgentMailInboxInput = {
  /** Domain for the inbox email address. Defaults to agentmail.to */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Username for the inbox email address. Randomly generated if not specified. */
  username?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['String']['input'];
};

export type CreateAgentMailInboxPayload = {
  __typename?: 'CreateAgentMailInboxPayload';
  email?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  inboxId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateApiClientInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};

export type CreateApiClientPayload = {
  __typename?: 'CreateApiClientPayload';
  apiClient: ApiClient;
  apiKey: Scalars['String']['output'];
  errors?: Maybe<Array<ApiClientCreationFailureReason>>;
  success: Scalars['Boolean']['output'];
};

export type CreateAuthTokenInput = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  type: AuthTokenType;
  userId: Scalars['String']['input'];
};

export type CreateAuthTokenPayload = {
  __typename?: 'CreateAuthTokenPayload';
  email?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateAwkwardMomentLabelInput = {
  awkwardMomentType: AwkwardMomentType;
  conversationId: Scalars['ID']['input'];
  endSeconds: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  sourceMessageId?: InputMaybe<Scalars['ID']['input']>;
  startSeconds: Scalars['Float']['input'];
};

export type CreateAwkwardMomentLabelResult = {
  __typename?: 'CreateAwkwardMomentLabelResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateBaseEventInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateBaseEventPayload = {
  __typename?: 'CreateBaseEventPayload';
  event: BaseEvent;
  success: Scalars['Boolean']['output'];
};

export type CreateBlankDocumentInKnowledgeBaseInput = {
  knowledgeBaseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateBlankDocumentInKnowledgeBasePayload = {
  __typename?: 'CreateBlankDocumentInKnowledgeBasePayload';
  knowledgeBaseDocumentUpload: KnowledgeBaseDocumentUpload;
};

export type CreateBlankRichTextDocumentUploadInput = {
  metadata: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
  type: EntityDocumentUploadType;
};

export type CreateBlankRichTextDocumentUploadPayload = {
  __typename?: 'CreateBlankRichTextDocumentUploadPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateBraintrustDatasetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  environment: BraintrustEnvironment;
  name: Scalars['String']['input'];
};

export type CreateBraintrustDatasetResult = {
  __typename?: 'CreateBraintrustDatasetResult';
  datasetId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCarrierByIdentifierInput = {
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCarrierByIdentifierPayload = {
  __typename?: 'CreateCarrierByIdentifierPayload';
  carrier: Carrier;
};

export type CreateCarrierRateInput = {
  computedRate?: InputMaybe<Scalars['JSON']['input']>;
  loadData?: InputMaybe<Scalars['JSON']['input']>;
  quoteId: Scalars['String']['input'];
  ratingMethod: RatingMethod;
};

export type CreateCarrierRatePayload = {
  __typename?: 'CreateCarrierRatePayload';
  carrierRate: CarrierRate;
  success: Scalars['Boolean']['output'];
};

export type CreateContactInput = {
  carrierId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactPayload = {
  __typename?: 'CreateContactPayload';
  /** The contact that was filed */
  contact: Contact;
  /** Whether or not the contact was created successfully */
  success: Scalars['Boolean']['output'];
};

export type CreateCoveragePlanCarrierInput = {
  carrierId: Scalars['ID']['input'];
  contactId?: InputMaybe<Scalars['ID']['input']>;
  onlyCollectOffer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCoveragePlanFromCarrierContactListInput = {
  carriers: Array<CarrierContactEntryInput>;
  shipmentId: Scalars['ID']['input'];
};

export type CreateCoveragePlanInput = {
  carriers: Array<CreateCoveragePlanCarrierInput>;
  shipmentId: Scalars['ID']['input'];
};

export type CreateCustomerDocumentsInKnowledgeBaseInput = {
  customers: Array<CustomerDocumentData>;
  knowledgeBaseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateCustomerDocumentsInKnowledgeBasePayload = {
  __typename?: 'CreateCustomerDocumentsInKnowledgeBasePayload';
  knowledgeBaseDocumentUploads: Array<KnowledgeBaseDocumentUpload>;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomerRateInput = {
  loadData?: InputMaybe<Scalars['JSON']['input']>;
  quoteId: Scalars['String']['input'];
  rate?: InputMaybe<Scalars['JSON']['input']>;
  type: CustomerRateType;
};

export type CreateCustomerRatePayload = {
  __typename?: 'CreateCustomerRatePayload';
  customerRate: CustomerRate;
  success: Scalars['Boolean']['output'];
};

export type CreateExceptionInput = {
  actionExecutionId?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['JSON']['input']>;
  organizationId: Scalars['String']['input'];
  status?: InputMaybe<ExceptionStatus>;
  type: ExceptionType;
};

export type CreateExternalChannelInput = {
  channelType: ExternalChannelType;
  externalIdentifier: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateExternalChannelPayload = {
  __typename?: 'CreateExternalChannelPayload';
  externalChannel: ExternalChannel;
  success: Scalars['Boolean']['output'];
};

export enum CreateExternalIdMappingFailureReason {
  EXTERNAL_ID_ALREADY_EXISTS = 'EXTERNAL_ID_ALREADY_EXISTS',
  INVALID_INTEGRATION_TYPE = 'INVALID_INTEGRATION_TYPE',
  SINGLE_ENTITY_ID_NEEDED = 'SINGLE_ENTITY_ID_NEEDED',
  UNKNOWN = 'UNKNOWN'
}

export type CreateExternalIdMappingInput = {
  externalId: Scalars['String']['input'];
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExternalIdMappingPayload = {
  __typename?: 'CreateExternalIdMappingPayload';
  errors?: Maybe<Array<CreateExternalIdMappingFailureReason>>;
  externalIdMapping?: Maybe<ExternalIdMapping>;
  success: Scalars['Boolean']['output'];
};

export type CreateExternalMessageJobInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId: Scalars['ID']['input'];
  isOptimistic?: InputMaybe<Scalars['Boolean']['input']>;
  jobSource?: InputMaybe<JobSource>;
  /** The type of job to create */
  jobType: JobType;
};

export type CreateExternalMessageJobPayload = {
  __typename?: 'CreateExternalMessageJobPayload';
  job?: Maybe<Job>;
  resultingAction: JobCreationResultingAction;
  success: Scalars['Boolean']['output'];
};

export type CreateFakeTrackMovementInput = {
  organizationId: Scalars['String']['input'];
  timing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFakeTrackMovementPayload = {
  __typename?: 'CreateFakeTrackMovementPayload';
  shipmentId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateFakeTrackingMilestonesInput = {
  movementId: Scalars['ID']['input'];
};

export type CreateFakeTrackingMilestonesPayload = {
  __typename?: 'CreateFakeTrackingMilestonesPayload';
  count: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateFeatureFlagInput = {
  name: FeatureFlagName;
};

export type CreateFeatureFlagsInput = {
  names: Array<FeatureFlagName>;
};

export type CreateFreightDataMappingInput = {
  key: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: FreightDataMappingType;
  values: Scalars['JSON']['input'];
};

export type CreateFreightDataMappingItemInput = {
  key: Scalars['String']['input'];
  values: Scalars['JSON']['input'];
};

export type CreateFreightDataMappingPayload = {
  __typename?: 'CreateFreightDataMappingPayload';
  freightDataMapping: FreightDataMapping;
  success: Scalars['Boolean']['output'];
};

export type CreateFreightDataMappingsInput = {
  items: Array<CreateFreightDataMappingItemInput>;
  organizationId: Scalars['ID']['input'];
  type: FreightDataMappingType;
};

export type CreateFreightDataMappingsPayload = {
  __typename?: 'CreateFreightDataMappingsPayload';
  freightDataMappings: Array<FreightDataMapping>;
  success: Scalars['Boolean']['output'];
};

export type CreateFrontJobInput = {
  buildHint?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  emailMetadata?: InputMaybe<Scalars['JSON']['input']>;
  frontMessageData: FrontMessageData;
  isOptimistic?: InputMaybe<Scalars['Boolean']['input']>;
  jobCreationPolicy?: InputMaybe<JobCreationPolicy>;
  jobSource?: InputMaybe<JobSource>;
  /** The type of job to create */
  jobType: JobType;
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFrontMailboxSubscriptionsInput = {
  inboxIds: Array<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateFrontMailboxSubscriptionsPayload = {
  __typename?: 'CreateFrontMailboxSubscriptionsPayload';
  error?: Maybe<Scalars['String']['output']>;
  mailboxes: Array<FrontMailboxSubscription>;
  success: Scalars['Boolean']['output'];
};

export type CreateFrontReplyAllInput = {
  bccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  ccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  channelEmail?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  frontConversationId: Scalars['String']['input'];
  frontUserEmail: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  originatorAddress?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFrontReplyAllPayload = {
  __typename?: 'CreateFrontReplyAllPayload';
  messageId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateGenericRuleInput = {
  organizationId: Scalars['ID']['input'];
  transformationConfigIds: Array<Scalars['ID']['input']>;
  type: GenericRuleType;
};

export type CreateGenericRulePayload = {
  __typename?: 'CreateGenericRulePayload';
  genericRule?: Maybe<GenericRule>;
  success: Scalars['Boolean']['output'];
};

export type CreateGenericTransformationInput = {
  genericRuleType: GenericRuleType;
  organizationId: Scalars['ID']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  seq: Scalars['Int']['input'];
  transformationDef: Scalars['JSON']['input'];
};

export type CreateGenericTransformationTemplateInput = {
  definition: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  genericRuleType: GenericRuleType;
  name: Scalars['String']['input'];
};

export type CreateGlobalPromptInput = {
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  prompt: Scalars['String']['input'];
  provisioningResourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Routes inheriting action definitions to the experimental service. Null uses the normal service. */
  runsOnExperimentalService?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateGmailJobInput = {
  buildHint?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  emailMetadata?: InputMaybe<Scalars['JSON']['input']>;
  gmailMessageData: GmailMessageData;
  isOptimistic?: InputMaybe<Scalars['Boolean']['input']>;
  jobCreationPolicy?: InputMaybe<JobCreationPolicy>;
  jobSource?: InputMaybe<JobSource>;
  /** The type of job to create */
  jobType: JobType;
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateGmailReplyAllInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  gmailThreadId: Scalars['String']['input'];
};

export type CreateGmailReplyAllPayload = {
  __typename?: 'CreateGmailReplyAllPayload';
  messageId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateInstantQuoteInput = {
  destination?: InputMaybe<InstantQuoteStopInput>;
  equipmentType?: InputMaybe<StandardFreightOrderEquipmentType>;
  /** Id of the originator (customer) this Instant Quote is for. */
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  pickup?: InputMaybe<InstantQuoteStopInput>;
  /** Optional tags applied to this Instant Quote. */
  quoteTags?: InputMaybe<Array<QuoteTag>>;
  /** Vooma user id of the person who asked for this Instant Quote, from the (voomaUserId: ...) suffix on their message. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CreateJobEventFailureReason {
  JOB_DELETED = 'JOB_DELETED'
}

export type CreateJobEventInput = {
  jobId: Scalars['String']['input'];
  type: JobEventType;
};

export type CreateJobEventPayload = {
  __typename?: 'CreateJobEventPayload';
  errors?: Maybe<Array<CreateJobEventFailureReason>>;
  jobEvent?: Maybe<JobEvent>;
  success: Scalars['Boolean']['output'];
};

export type CreateJobInput = {
  buildHint?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  emailMetadata?: InputMaybe<Scalars['JSON']['input']>;
  isOptimistic?: InputMaybe<Scalars['Boolean']['input']>;
  jobSource?: InputMaybe<JobSource>;
  jobType?: InputMaybe<JobType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  uploadIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateJobPayload = {
  __typename?: 'CreateJobPayload';
  job: Job;
  resultingAction: JobCreationResultingAction;
  success: Scalars['Boolean']['output'];
};

export type CreateKnowledgeBaseInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateKnowledgeBasePayload = {
  __typename?: 'CreateKnowledgeBasePayload';
  knowledgeBase: KnowledgeBase;
};

export type CreateLabeledComputationInput = {
  labelTags?: InputMaybe<Array<LabelTag>>;
  labeledComputationData: LabeledComputationDataInput;
  savedComputationId: Scalars['String']['input'];
  source: LabeledComputationSource;
  type: LabeledComputationType;
};

export type CreateLabeledComputationPayload = {
  __typename?: 'CreateLabeledComputationPayload';
  labeledComputation: LabeledComputation;
  success: Scalars['Boolean']['output'];
};

export type CreateLanePreferenceInput = {
  carrierIds: Array<Scalars['ID']['input']>;
  equipmentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shipmentId: Scalars['ID']['input'];
};

export type CreateManagedResourceInput = {
  fallbackResourceId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  provider?: InputMaybe<ManagedResourceProvider>;
  status: ManagedResourceStatus;
  type: ManagedResourceType;
};

export type CreateMemoryEntityLinkInput = {
  id: Scalars['ID']['input'];
};

export type CreateMemoryEntityLinkPayload = {
  __typename?: 'CreateMemoryEntityLinkPayload';
  memoryEntityLink?: Maybe<MemoryEntityLink>;
  success: Scalars['Boolean']['output'];
};

export enum CreateMemoryFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type CreateMemoryInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  labeledComputationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateMemoryPayload = {
  __typename?: 'CreateMemoryPayload';
  errors?: Maybe<Array<CreateMemoryFailureReason>>;
  memory?: Maybe<Memory>;
  success: Scalars['Boolean']['output'];
};

export type CreateMessageQuoteAssociationInput = {
  entityId: Scalars['ID']['input'];
  externalMessageId: Scalars['ID']['input'];
  scores?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateMessageQuoteAssociationPayload = {
  __typename?: 'CreateMessageQuoteAssociationPayload';
  messageQuoteAssociation: MessageQuoteAssociation;
  success: Scalars['Boolean']['output'];
};

export type CreateNegotiationStrategyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  config: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: NegotiationStrategyType;
};

export type CreateNewConversationWithConciergeInput = {
  context: ChatViewContextInput;
  organizationId: Scalars['ID']['input'];
};

export type CreateNewConversationWithConciergePayload = {
  __typename?: 'CreateNewConversationWithConciergePayload';
  conversation: Conversation;
};

export type CreateNewConversationWithLabelingConciergeInput = {
  /** The task to review. Provide this or movementId. */
  actionExecutionId?: InputMaybe<Scalars['ID']['input']>;
  context: ChatViewContextInput;
  /** The load to review. Provide this or actionExecutionId. */
  movementId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateOrUpdateComposioAuthTokenInput = {
  apiKey: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type CreateOrUpdateComposioAuthTokenPayload = {
  __typename?: 'CreateOrUpdateComposioAuthTokenPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateOrUpdateExternalIdMappingInput = {
  externalId: Scalars['String']['input'];
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrUpdateExternalIdMappingPayload = {
  __typename?: 'CreateOrUpdateExternalIdMappingPayload';
  externalIdMapping?: Maybe<ExternalIdMapping>;
  success: Scalars['Boolean']['output'];
};

export type CreateOrUpdateIntegrationCredentialsInput = {
  /** Serialized as JSON */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** DFM Account ID for external ID mapping */
  dfmAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Required for OTHER credentials; ignored for typed integrations */
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  type: IntegrationCredentialsType;
  usageIndicator: UsageIndicator;
  /** Scopes the credentials to this user; omit for org-scoped credentials. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrUpdateIntegrationCredentialsPayload = {
  __typename?: 'CreateOrUpdateIntegrationCredentialsPayload';
  success: Scalars['Boolean']['output'];
};

export enum CreateOrderEventFailureReason {
  ORDER_DELETED = 'ORDER_DELETED'
}

export type CreateOrderEventInput = {
  /** Serialized as JSON */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  orderId: Scalars['String']['input'];
  type: OrderEventType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderEventPayload = {
  __typename?: 'CreateOrderEventPayload';
  errors?: Maybe<Array<CreateOrderEventFailureReason>>;
  orderEvent?: Maybe<OrderEvent>;
  success: Scalars['Boolean']['output'];
};

export type CreateOrderInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  extractedData?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  order: Order;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationInput = {
  name: Scalars['String']['input'];
};

export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  organization: Organization;
  shadowOrganization: Organization;
  success: Scalars['Boolean']['output'];
};

export type CreateOrganizationUserRelationInput = {
  organizationId: Scalars['String']['input'];
  roles?: InputMaybe<Array<OrganizationUserRole>>;
  userId: Scalars['String']['input'];
};

export type CreateOrganizationUserRelationPayload = {
  __typename?: 'CreateOrganizationUserRelationPayload';
  organizationUserRelation: OrganizationUserRelation;
  success: Scalars['Boolean']['output'];
};

export type CreateOriginatorEventInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  name: OriginatorEventType;
  originatorId: Scalars['String']['input'];
};

export type CreateOriginatorEventPayload = {
  __typename?: 'CreateOriginatorEventPayload';
  event: OriginatorEvent;
  success: Scalars['Boolean']['output'];
};

export type CreateOriginatorInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  autoSubmitScope?: InputMaybe<AutoSubmitScope>;
  configOverrides?: InputMaybe<Scalars['JSON']['input']>;
  expectedWeeklyOrderCount?: InputMaybe<Scalars['Float']['input']>;
  externalIdMappings?: InputMaybe<Array<UpdateExternalIdMappingInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  quoteAutoReplyScope?: InputMaybe<QuoteAutoReplyScope>;
  scheduleSettingsId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<OriginatorStatus>;
  trackSettingsId?: InputMaybe<Scalars['ID']['input']>;
  transmitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  voomaSupportNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOriginatorPayload = {
  __typename?: 'CreateOriginatorPayload';
  errors?: Maybe<Array<OriginatorCreationFailureReason>>;
  originator: Originator;
  success: Scalars['Boolean']['output'];
};

export type CreateOriginatorsReportPayload = {
  __typename?: 'CreateOriginatorsReportPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateOutlookJobInput = {
  buildHint?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  emailMetadata?: InputMaybe<Scalars['JSON']['input']>;
  isOptimistic?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedInbox?: InputMaybe<Scalars['Boolean']['input']>;
  jobCreationPolicy?: InputMaybe<JobCreationPolicy>;
  jobSource?: InputMaybe<JobSource>;
  /** The type of job to create */
  jobType: JobType;
  organizationId: Scalars['ID']['input'];
  outlookMessageData: OutlookMessageData;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOutlookReplyAllInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  internetMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Address of the mailbox the add-in is viewing */
  mailboxAddress?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  sharedInbox?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOutlookReplyAllPayload = {
  __typename?: 'CreateOutlookReplyAllPayload';
  messageId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreatePlaceInput = {
  address?: InputMaybe<LocationAddressInput>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  creationProvenance?: InputMaybe<PlaceCreationProvenance>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  geoPoint?: InputMaybe<GeoPointInput>;
  locationCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<PlaceTag>>;
};

/** Return type of createPlace mutation */
export type CreatePlacePayload = {
  __typename?: 'CreatePlacePayload';
  /** The reason the place creation failed, if applicable */
  failureReason?: Maybe<PlaceCreationFailureReason>;
  place: Place;
  /** Whether or not the place was created successfully */
  success: Scalars['Boolean']['output'];
};

export type CreatePlaceSchedulingMethodInput = {
  method: Scalars['JSON']['input'];
  placeId: Scalars['ID']['input'];
};

export type CreatePricingStrategyInput = {
  config: Scalars['JSON']['input'];
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  type: PricingStrategyType;
  userId: Scalars['ID']['input'];
};

export type CreatePricingStrategyPayload = {
  __typename?: 'CreatePricingStrategyPayload';
  pricingStrategy?: Maybe<PricingStrategy>;
  success: Scalars['Boolean']['output'];
};

export type CreateQuoteEventInput = {
  /** Serialized as JSON */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  quoteId: Scalars['String']['input'];
  type: QuoteEventType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuoteEventPayload = {
  __typename?: 'CreateQuoteEventPayload';
  quoteEvent: QuoteEvent;
  success: Scalars['Boolean']['output'];
};

export type CreateQuoteInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  extractedData?: InputMaybe<Scalars['JSON']['input']>;
  jobId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateQuoteNoteInput = {
  note: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateQuoteNotePayload = {
  __typename?: 'CreateQuoteNotePayload';
  quoteNote: QuoteNote;
  success: Scalars['Boolean']['output'];
};

export type CreateQuotePayload = {
  __typename?: 'CreateQuotePayload';
  quote: Quote;
  success: Scalars['Boolean']['output'];
};

export type CreateQuotesReportPayload = {
  __typename?: 'CreateQuotesReportPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateRatingInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  ratingType: Scalars['String']['input'];
  starRating: Scalars['Float']['input'];
};

export type CreateRatingPayload = {
  __typename?: 'CreateRatingPayload';
  rating: Rating;
  success: Scalars['Boolean']['output'];
};

export type CreateSavedComputationInput = {
  dataUrl: Scalars['String']['input'];
  externalMessageId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<Scalars['JSON']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  type: SavedComputationType;
};

export type CreateSavedComputationPayload = {
  __typename?: 'CreateSavedComputationPayload';
  savedComputation: SavedComputation;
  success: Scalars['Boolean']['output'];
};

export type CreateSavedViewInput = {
  isDefault: Scalars['Boolean']['input'];
  level: Scalars['String']['input'];
  query: Scalars['String']['input'];
  viewType: Scalars['String']['input'];
};

export type CreateSavedViewPayload = {
  __typename?: 'CreateSavedViewPayload';
  savedView: SavedView;
  success: Scalars['Boolean']['output'];
};

export type CreateScheduleSettingsInput = {
  isActive?: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  plannerActionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  planningSettings: PlanningSettingsInput;
};

export type CreateSharedFileInput = {
  content: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateSharedFilePayload = {
  __typename?: 'CreateSharedFilePayload';
  message: Scalars['String']['output'];
  sharedFile: SharedFileSummary;
  success: Scalars['Boolean']['output'];
};

export type CreateTeamInput = {
  addCurrentUserAsMember: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<TeamRole>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateTeamMemberInput = {
  organizationId: Scalars['ID']['input'];
  organizationUserRelationId: Scalars['ID']['input'];
  role: TeamMemberRole;
  teamId: Scalars['ID']['input'];
};

export type CreateTeamPayload = {
  __typename?: 'CreateTeamPayload';
  success: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
};

export type CreateTemplateInput = {
  initializeFromDefaultTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  specializedTemplate?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
};

export type CreateTemplatePayload = {
  __typename?: 'CreateTemplatePayload';
  errors?: Maybe<Array<TemplateCreationFailureReason>>;
  success: Scalars['Boolean']['output'];
  template: Template;
};

export type CreateTrackSettingsInput = {
  enRouteSettings: EnRouteSettingsInput;
  isActive?: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nightHoursSettings?: InputMaybe<NightHoursSettingsInput>;
  organizationId: Scalars['ID']['input'];
  stopSettings: StopSettingsInput;
};

export type CreateTrackingExceptionEventInput = {
  exceptionType: LoadExceptionType;
  movementId: Scalars['ID']['input'];
};

export type CreateTrackingExceptionEventPayload = {
  __typename?: 'CreateTrackingExceptionEventPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateTrackingMilestoneEventInput = {
  contactMethod?: InputMaybe<TrackingOutreachChannel>;
  infoToExchange?: InputMaybe<Scalars['String']['input']>;
  milestoneType: TrackingMilestoneType;
  movementId: Scalars['ID']['input'];
};

export type CreateTrackingMilestoneEventPayload = {
  __typename?: 'CreateTrackingMilestoneEventPayload';
  event?: Maybe<MovementEvent>;
  success: Scalars['Boolean']['output'];
};

export type CreateTranscriptionLabelInput = {
  contributionCreatedAt: Scalars['DateTimeISO']['input'];
  contributionTranscript: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
  sourceMessageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTranscriptionLabelResult = {
  __typename?: 'CreateTranscriptionLabelResult';
  alreadyFlagged?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CreateTransformationConfigFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type CreateTransformationConfigInput = {
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  params: Scalars['JSON']['input'];
  transformationDefinitionId: Scalars['ID']['input'];
};

export type CreateTransformationConfigPayload = {
  __typename?: 'CreateTransformationConfigPayload';
  errors?: Maybe<Array<CreateTransformationConfigFailureReason>>;
  success: Scalars['Boolean']['output'];
  transformationConfig?: Maybe<TransformationConfig>;
};

export enum CreateTransformationDefinitionFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type CreateTransformationDefinitionInput = {
  definition: Scalars['JSON']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTransformationDefinitionPayload = {
  __typename?: 'CreateTransformationDefinitionPayload';
  errors?: Maybe<Array<CreateTransformationDefinitionFailureReason>>;
  success: Scalars['Boolean']['output'];
  transformationDefinition?: Maybe<TransformationDefinition>;
};

export type CreateTurnTakingLabelInput = {
  contributionId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
};

export type CreateTurnTakingLabelResult = {
  __typename?: 'CreateTurnTakingLabelResult';
  alreadyFlagged?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateWebhookSubscriptionInput = {
  authConfig: Scalars['JSON']['input'];
  organizationId: Scalars['ID']['input'];
  subscriptionType: WebhookSubscriptionType;
  url: Scalars['String']['input'];
};

export type CreateWebhookSubscriptionPayload = {
  __typename?: 'CreateWebhookSubscriptionPayload';
  item: WebhookSubscription;
  success: Scalars['Boolean']['output'];
};

export type CreateWorkerInput = {
  backStory: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateWorkerPayload = {
  __typename?: 'CreateWorkerPayload';
  worker: User;
};

export enum CreateWorkflowFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type CreateWorkflowInput = {
  organizationId: Scalars['String']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  transformationConfigIds: Array<Scalars['ID']['input']>;
  trigger: FlowTriggerInput;
};

export type CreateWorkflowPayload = {
  __typename?: 'CreateWorkflowPayload';
  errors?: Maybe<Array<CreateWorkflowFailureReason>>;
  success: Scalars['Boolean']['output'];
  workflow?: Maybe<Workflow>;
};

export type CustomerDocumentData = {
  customerName: Scalars['String']['input'];
  originatorId: Scalars['ID']['input'];
};

export type CustomerRate = AbstractEntity & Node & {
  __typename?: 'CustomerRate';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** Serialized as JSON */
  loadData?: Maybe<Scalars['JSON']['output']>;
  /** Serialized as JSON */
  metadata?: Maybe<Scalars['JSON']['output']>;
  quote: Quote;
  /** Serialized as JSON */
  rate?: Maybe<Scalars['JSON']['output']>;
  ratingMethod?: Maybe<RatingMethod>;
  type: CustomerRateType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** The type of customer rate */
export enum CustomerRateType {
  BOOKED = 'BOOKED',
  NEGOTIATED = 'NEGOTIATED',
  QUOTED = 'QUOTED'
}

export type DatHistoryRatesInput = {
  id: Scalars['ID']['input'];
};

export type DatHistoryRatesPayload = {
  __typename?: 'DATHistoryRatesPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type DailySpend = {
  __typename?: 'DailySpend';
  day: Scalars['DateTimeISO']['output'];
  products: Array<ProductSpend>;
  totalCents: Scalars['Float']['output'];
};

export type DatAuthorizedUserPayload = {
  __typename?: 'DatAuthorizedUserPayload';
  datUsername?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export enum DateTimeInterpretationPolicy {
  DATE = 'DATE',
  DATE_AND_TIME = 'DATE_AND_TIME'
}

export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  end?: Maybe<VDateTime>;
  start: VDateTime;
  type?: Maybe<DateTimeRangeType>;
};

export enum DateTimeRangeType {
  APPOINTMENT = 'APPOINTMENT',
  FACILITY_HOURS = 'FACILITY_HOURS'
}

export type DecisionEdgeEvaluatedData = {
  __typename?: 'DecisionEdgeEvaluatedData';
  edgeId: Scalars['ID']['output'];
  eventDataType: ActionExecutionEventType;
  rationale: Scalars['String']['output'];
  shouldFollowEdge: Scalars['Boolean']['output'];
  targetNodeActionDefinitionId?: Maybe<Scalars['String']['output']>;
};

export type DefinitionChangedData = {
  __typename?: 'DefinitionChangedData';
  changedFields: Array<Scalars['String']['output']>;
  changes?: Maybe<Scalars['String']['output']>;
  eventDataType: ActionDefinitionEventType;
};

export type DeleteAiPhoneNumberInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAiPhoneNumberPayload = {
  __typename?: 'DeleteAIPhoneNumberPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteActionDefinitionDocumentInput = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteActionDefinitionDocumentPayload = {
  __typename?: 'DeleteActionDefinitionDocumentPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteActionDefinitionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteActionDefinitionPayload = {
  __typename?: 'DeleteActionDefinitionPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteActionDefinitionTeamGlobalPromptValuesInput = {
  actionDefinitionId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type DeleteActionDefinitionTeamGlobalPromptValuesPayload = {
  __typename?: 'DeleteActionDefinitionTeamGlobalPromptValuesPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteActionTriggerInput = {
  id: Scalars['ID']['input'];
};

export type DeleteActionTriggerPayload = {
  __typename?: 'DeleteActionTriggerPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteApiClientInput = {
  id: Scalars['ID']['input'];
};

export type DeleteApiClientPayload = {
  __typename?: 'DeleteApiClientPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteAuthTokenInput = {
  type: AuthTokenType;
};

export type DeleteAuthTokenPayload = {
  __typename?: 'DeleteAuthTokenPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteCarrierRateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCarrierRatePayload = {
  __typename?: 'DeleteCarrierRatePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteContactInput = {
  id: Scalars['ID']['input'];
};

export type DeleteContactPayload = {
  __typename?: 'DeleteContactPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteCoveragePlanInput = {
  coveragePlanId: Scalars['ID']['input'];
};

export type DeleteCoveragePlanPayload = {
  __typename?: 'DeleteCoveragePlanPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteCustomerRateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCustomerRatePayload = {
  __typename?: 'DeleteCustomerRatePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteDocumentInKnowledgeBaseInput = {
  documentId: Scalars['ID']['input'];
};

export type DeleteDocumentInKnowledgeBasePayload = {
  __typename?: 'DeleteDocumentInKnowledgeBasePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteExternalChannelInput = {
  id: Scalars['ID']['input'];
};

export type DeleteExternalChannelPayload = {
  __typename?: 'DeleteExternalChannelPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteFreightDataMappingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFreightDataMappingPayload = {
  __typename?: 'DeleteFreightDataMappingPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteFrontMailboxSubscriptionsInput = {
  mailboxIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DeleteFrontMailboxSubscriptionsPayload = {
  __typename?: 'DeleteFrontMailboxSubscriptionsPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteGenericRuleInput = {
  id: Scalars['ID']['input'];
};

export type DeleteGenericRulePayload = {
  __typename?: 'DeleteGenericRulePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteGenericTransformationInput = {
  genericRuleId: Scalars['ID']['input'];
  genericTransformationId: Scalars['ID']['input'];
};

export type DeleteGenericTransformationTemplatePayload = {
  __typename?: 'DeleteGenericTransformationTemplatePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteIntegrationCredentialsInput = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteIntegrationCredentialsPayload = {
  __typename?: 'DeleteIntegrationCredentialsPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteJobDocumentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobDocumentPayload = {
  __typename?: 'DeleteJobDocumentPayload';
  /** Whether or not the document was deleted successfully */
  success: Scalars['Boolean']['output'];
};

export type DeleteJobInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobPayload = {
  __typename?: 'DeleteJobPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteKnowledgeBasePayload = {
  __typename?: 'DeleteKnowledgeBasePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteLabeledComputationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLabeledComputationPayload = {
  __typename?: 'DeleteLabeledComputationPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteLanePreferenceInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLanePreferencePayload = {
  __typename?: 'DeleteLanePreferencePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteManagedResourcePayload = {
  __typename?: 'DeleteManagedResourcePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteMemoryEntityLinkInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMemoryEntityLinkPayload = {
  __typename?: 'DeleteMemoryEntityLinkPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteMemoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMemoryPayload = {
  __typename?: 'DeleteMemoryPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteNegotiationStrategyInput = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteNegotiationStrategyPayload = {
  __typename?: 'DeleteNegotiationStrategyPayload';
  /** Number of active loads using this strategy as a per-movement override. Present when deletion is blocked for this reason. */
  referencingMovementCount?: Maybe<Scalars['Int']['output']>;
  referencingSOPs?: Maybe<Array<ReferencingEntity>>;
  referencingStrategies?: Maybe<Array<ReferencingEntity>>;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrderPayload = {
  __typename?: 'DeleteOrderPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationJobInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationJobPayload = {
  __typename?: 'DeleteOrganizationJobPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteOriginatorInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOriginatorPayload = {
  __typename?: 'DeleteOriginatorPayload';
  success: Scalars['Boolean']['output'];
};

export type DeletePlaceInput = {
  id: Scalars['ID']['input'];
};

export type DeletePlacePayload = {
  __typename?: 'DeletePlacePayload';
  success: Scalars['Boolean']['output'];
};

export type DeletePlaceSchedulingMethodInput = {
  methodId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
};

export type DeletePricingStrategyInput = {
  id: Scalars['ID']['input'];
};

export type DeletePricingStrategyPayload = {
  __typename?: 'DeletePricingStrategyPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteQuoteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteQuotePayload = {
  __typename?: 'DeleteQuotePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteSavedViewInput = {
  viewId: Scalars['String']['input'];
};

export type DeleteSharedFileInput = {
  sharedFileId: Scalars['ID']['input'];
};

export type DeleteSharedFilePayload = {
  __typename?: 'DeleteSharedFilePayload';
  message: Scalars['String']['output'];
  sharedFile: SharedFileSummary;
  success: Scalars['Boolean']['output'];
};

export type DeleteShipmentOrMovementInput = {
  movementId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteTeamInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTeamMemberInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTeamMemberPayload = {
  __typename?: 'DeleteTeamMemberPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteTeamPayload = {
  __typename?: 'DeleteTeamPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTemplatePayload = {
  __typename?: 'DeleteTemplatePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteTransformationConfigInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTransformationConfigPayload = {
  __typename?: 'DeleteTransformationConfigPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteTransformationDefinitionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTransformationDefinitionPayload = {
  __typename?: 'DeleteTransformationDefinitionPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteWebhookSubscriptionInput = {
  id: Scalars['String']['input'];
};

export type DeleteWebhookSubscriptionPayload = {
  __typename?: 'DeleteWebhookSubscriptionPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteWorkerAuthTokenInput = {
  type: AuthTokenType;
  workerId: Scalars['String']['input'];
};

export type DeleteWorkerInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkerPayload = {
  __typename?: 'DeleteWorkerPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteWorkflowInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowPayload = {
  __typename?: 'DeleteWorkflowPayload';
  success: Scalars['Boolean']['output'];
};

export type DeliveryAfterSettings = {
  __typename?: 'DeliveryAfterSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minutesAfter?: Maybe<Scalars['Float']['output']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, MINUTES_AFTER applies. The phase-level minutesAfter is legacy and moves into the MINUTES_AFTER params on save. */
  triggers?: Maybe<Array<MilestoneAfterTriggerSettings>>;
};

export type DeliveryAfterSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minutesAfter?: InputMaybe<Scalars['Float']['input']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, MINUTES_AFTER applies. The phase-level minutesAfter is legacy and moves into the MINUTES_AFTER params on save. */
  triggers?: InputMaybe<Array<MilestoneAfterTriggerSettingsInput>>;
};

export type DeliveryAtSettings = {
  __typename?: 'DeliveryAtSettings';
  delayMinutes?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, DELAY applies. The phase-level delayMinutes is legacy and moves into the DELAY params on save. */
  triggers?: Maybe<Array<MilestoneAtTriggerSettings>>;
};

export type DeliveryAtSettingsInput = {
  delayMinutes?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, DELAY applies. The phase-level delayMinutes is legacy and moves into the DELAY params on save. */
  triggers?: InputMaybe<Array<MilestoneAtTriggerSettingsInput>>;
};

export type DeliveryBeforeSettings = {
  __typename?: 'DeliveryBeforeSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minutesBefore?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use triggers instead */
  trigger?: Maybe<MilestoneBeforeTrigger>;
  /** Ways to time the pre-delivery check, one per type with its own params. At most one is enabled; disabled entries keep their params so they can be re-enabled. */
  triggers?: Maybe<Array<MilestoneBeforeTriggerSettings>>;
};

export type DeliveryBeforeSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minutesBefore?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use triggers instead */
  trigger?: InputMaybe<MilestoneBeforeTrigger>;
  /** Ways to time the pre-delivery check, one per type with its own params. At most one is enabled; disabled entries keep their params so they can be re-enabled. */
  triggers?: InputMaybe<Array<MilestoneBeforeTriggerSettingsInput>>;
};

export type DeliveryTrackEventSettings = {
  __typename?: 'DeliveryTrackEventSettings';
  after?: Maybe<DeliveryAfterSettings>;
  at?: Maybe<DeliveryAtSettings>;
  before?: Maybe<DeliveryBeforeSettings>;
  /** @deprecated Use before/after/at `enabled` flags instead */
  checkTypes?: Maybe<Array<CheckTypes>>;
  /** @deprecated Use before.minutesBefore / after.minutesAfter instead */
  timeWindowMinutes?: Maybe<Scalars['Float']['output']>;
};

export type DeliveryTrackEventSettingsInput = {
  after?: InputMaybe<DeliveryAfterSettingsInput>;
  at?: InputMaybe<DeliveryAtSettingsInput>;
  before?: InputMaybe<DeliveryBeforeSettingsInput>;
  checkTypes?: InputMaybe<Array<CheckTypes>>;
  timeWindowMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type DeterministicPlanningSettings = {
  __typename?: 'DeterministicPlanningSettings';
  sequencing: PlanningSequence;
  type: PlanningApproach;
};

export type DeterministicProcedure = {
  __typename?: 'DeterministicProcedure';
  functionName: Scalars['String']['output'];
  procedureType: ProcedureType;
};

export type DeterministicToolInvocation = {
  __typename?: 'DeterministicToolInvocation';
  input: Scalars['JSON']['output'];
  tool: Scalars['JSON']['output'];
};

export type DeterministicToolInvocationInput = {
  input: Scalars['JSON']['input'];
  tool: Scalars['JSON']['input'];
};

export type DeterministicToolInvocations = {
  __typename?: 'DeterministicToolInvocations';
  onEnter?: Maybe<Array<DeterministicToolInvocation>>;
};

export type DeterministicToolInvocationsInput = {
  onEnter?: InputMaybe<Array<DeterministicToolInvocationInput>>;
};

export type DiffActionDefinitionNaturalLanguageProcedureInput = {
  actionDefinitionIdA: Scalars['ID']['input'];
  actionDefinitionIdB: Scalars['ID']['input'];
};

export type DiffActionDefinitionNaturalLanguageProcedurePayload = {
  __typename?: 'DiffActionDefinitionNaturalLanguageProcedurePayload';
  diff?: Maybe<Scalars['JSON']['output']>;
};

export type Digest = AbstractEntity & Node & {
  __typename?: 'Digest';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  omniScheduleId?: Maybe<Scalars['String']['output']>;
  subscribers: Array<User>;
  type: DigestType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DigestSubscriptionStatus = {
  __typename?: 'DigestSubscriptionStatus';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum DigestType {
  SALES_REP = 'SALES_REP',
  SALES_REP_MANAGER = 'SALES_REP_MANAGER',
  VOOMA_ROI = 'VOOMA_ROI',
  VOOMA_USAGE = 'VOOMA_USAGE'
}

export type DisableTmsIntegrationVerificationInput = {
  organizationId: Scalars['ID']['input'];
};

export type DismissConversationExceptionsInput = {
  conversationId: Scalars['ID']['input'];
};

export type DistanceBasedIntervalThreshold = {
  __typename?: 'DistanceBasedIntervalThreshold';
  intervalMinutes: Scalars['Float']['output'];
  maxDistanceMiles: Scalars['Float']['output'];
};

export type DistanceBasedIntervalThresholdInput = {
  intervalMinutes: Scalars['Float']['input'];
  maxDistanceMiles: Scalars['Float']['input'];
};

export type DistanceBasedIntervals = {
  __typename?: 'DistanceBasedIntervals';
  defaultIntervalMinutes: Scalars['Float']['output'];
  thresholds: Array<DistanceBasedIntervalThreshold>;
};

export type DistanceBasedIntervalsInput = {
  defaultIntervalMinutes: Scalars['Float']['input'];
  thresholds: Array<DistanceBasedIntervalThresholdInput>;
};

export type Document = AbstractEntity & Node & {
  __typename?: 'Document';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  s3Url?: Maybe<Scalars['String']['output']>;
  source: DocumentSource;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type DocumentRevision = AbstractEntity & Node & {
  __typename?: 'DocumentRevision';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entity: Template;
  id: Scalars['ID']['output'];
  /** Serialized as JSON */
  jsonData?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum DocumentSource {
  EMAIL = 'EMAIL',
  SHIPMENT_INGESTION = 'SHIPMENT_INGESTION'
}

export type DownloadActionDefinitionInput = {
  id: Scalars['ID']['input'];
};

export type DownloadActionDefinitionPayload = {
  __typename?: 'DownloadActionDefinitionPayload';
  actionDefinitionIds: Array<Scalars['ID']['output']>;
  downloadUrl: Scalars['String']['output'];
};

export type DownloadArtifactsInput = {
  id: Scalars['ID']['input'];
};

export type DownloadArtifactsPayload = {
  __typename?: 'DownloadArtifactsPayload';
  downloadUrl: Scalars['String']['output'];
};

export type DownloadConversationDebugPackagePayload = {
  __typename?: 'DownloadConversationDebugPackagePayload';
  downloadUrl: Scalars['String']['output'];
};

export type DownloadOrderInput = {
  id: Scalars['ID']['input'];
};

export type DownloadOrderPayload = {
  __typename?: 'DownloadOrderPayload';
  downloadUrl: Scalars['String']['output'];
};

export enum EdgeType {
  INTELLIGENT = 'INTELLIGENT',
  SIMPLE = 'SIMPLE'
}

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  filename: Scalars['String']['output'];
};

export type EmailAuthPolicy = {
  __typename?: 'EmailAuthPolicy';
  dkimPolicy?: Maybe<AuthPolicyLevel>;
  dmarcPolicy?: Maybe<AuthPolicyLevel>;
  spamPolicy?: Maybe<AuthPolicyLevel>;
  spfPolicy?: Maybe<AuthPolicyLevel>;
};

export type EmailAuthPolicyInput = {
  dkimPolicy?: InputMaybe<AuthPolicyLevel>;
  dmarcPolicy?: InputMaybe<AuthPolicyLevel>;
  spamPolicy?: InputMaybe<AuthPolicyLevel>;
  spfPolicy?: InputMaybe<AuthPolicyLevel>;
};

export type EmailConversationMetadata = {
  __typename?: 'EmailConversationMetadata';
  agentmailThreadId?: Maybe<Scalars['String']['output']>;
  alreadyCcdRecipients?: Maybe<Array<Scalars['String']['output']>>;
  frontConversationId?: Maybe<Scalars['String']['output']>;
  gmailThreadId?: Maybe<Scalars['String']['output']>;
  outlookConversationId?: Maybe<Scalars['String']['output']>;
};

export type EmailHeaderMetadata = {
  __typename?: 'EmailHeaderMetadata';
  bcc?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type EmailIntegrationStatus = {
  __typename?: 'EmailIntegrationStatus';
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  status: AuthTokenStatus;
  type: AuthTokenType;
};

export type EmailThreadChatInput = {
  externalMessageIds: Array<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export enum EmailTriggerMailboxScope {
  ORGANIZATION = 'ORGANIZATION',
  WORKERS = 'WORKERS'
}

/** Which en-route cadences run. SINGLE runs enRoute for every load. SPLIT_BY_TRACKING runs enRouteWithTracking and enRouteWithoutTracking. The inactive cadences stay saved. */
export enum EnRouteCadenceMode {
  SINGLE = 'SINGLE',
  SPLIT_BY_TRACKING = 'SPLIT_BY_TRACKING'
}

/** Controls which en-route updates are recorded. SMART (default) skips updates when city and state have not changed; if smartFilter is configured it also skips updates where the truck has not moved far enough. ALL records every update regardless of location. */
export enum EnRouteFilter {
  ALL = 'ALL',
  SMART = 'SMART'
}

export type EnRouteSettings = {
  __typename?: 'EnRouteSettings';
  /** Defaults to SPLIT_BY_TRACKING when either tracking-specific cadence is configured, else SINGLE. */
  cadenceMode?: Maybe<EnRouteCadenceMode>;
  /** Hours a solo driver drives before each 10-hour rest in ETA calculations. Defaults to 11 (the FMCSA daily driving limit) if not configured. */
  dailyDrivingHours?: Maybe<Scalars['Float']['output']>;
  enRoute: EnRouteTrackEventSettings;
  /** En-route cadence for loads with usable tracking data. Creates INTERMEDIATE_WITH_TRACKING milestones. Runs only when cadenceMode is SPLIT_BY_TRACKING. */
  enRouteWithTracking?: Maybe<EnRouteTrackEventSettings>;
  /** En-route cadence for loads without usable tracking data. Creates INTERMEDIATE_WITHOUT_TRACKING milestones. Runs only when cadenceMode is SPLIT_BY_TRACKING. Location-based fields (filter, smartFilter, stopTrackingWithinMiles, skipTrackingWithinMilesOfPickup, closeToDeliveryInterval) do not apply. */
  enRouteWithoutTracking?: Maybe<EnRouteTrackEventSettings>;
  exceptionEventsSettings?: Maybe<ExceptionEventsSettings>;
  /** Conditions for creating TRACKING_MILESTONE events. Defaults to legacy behavior (IN_TRANSIT status OR within time window) if not set. */
  trackingTrigger?: Maybe<TrackingTrigger>;
  /** Assumed truck speed in MPH for ETA calculations. Defaults to 55 if not configured. */
  truckSpeedMph?: Maybe<Scalars['Float']['output']>;
};

export type EnRouteSettingsInput = {
  /** Defaults to SPLIT_BY_TRACKING when either tracking-specific cadence is configured, else SINGLE. */
  cadenceMode?: InputMaybe<EnRouteCadenceMode>;
  /** Hours a solo driver drives before each 10-hour rest in ETA calculations. Defaults to 11 (the FMCSA daily driving limit) if not configured. */
  dailyDrivingHours?: InputMaybe<Scalars['Float']['input']>;
  enRoute: EnRouteTrackEventSettingsInput;
  /** En-route cadence for loads with usable tracking data. Creates INTERMEDIATE_WITH_TRACKING milestones. Runs only when cadenceMode is SPLIT_BY_TRACKING. */
  enRouteWithTracking?: InputMaybe<EnRouteTrackEventSettingsInput>;
  /** En-route cadence for loads without usable tracking data. Creates INTERMEDIATE_WITHOUT_TRACKING milestones. Runs only when cadenceMode is SPLIT_BY_TRACKING. Location-based fields (filter, smartFilter, stopTrackingWithinMiles, skipTrackingWithinMilesOfPickup, closeToDeliveryInterval) do not apply. */
  enRouteWithoutTracking?: InputMaybe<EnRouteTrackEventSettingsInput>;
  exceptionEventsSettings?: InputMaybe<ExceptionEventsSettingsInput>;
  /** Conditions for creating TRACKING_MILESTONE events. Defaults to legacy behavior (IN_TRANSIT status OR within time window) if not set. */
  trackingTrigger?: InputMaybe<TrackingTrigger>;
  /** Assumed truck speed in MPH for ETA calculations. Defaults to 55 if not configured. */
  truckSpeedMph?: InputMaybe<Scalars['Float']['input']>;
};

export type EnRouteTrackEventSettings = {
  __typename?: 'EnRouteTrackEventSettings';
  closeToDeliveryInterval?: Maybe<CloseToDeliveryInterval>;
  distanceBasedIntervals?: Maybe<DistanceBasedIntervals>;
  filter?: Maybe<EnRouteFilter>;
  /** Minutes after the in-transit window starts before the first en-route check/call. Subsequent checks use intervalMinutes. Defaults to 0 (immediate). */
  firstMilestoneDelayMinutes?: Maybe<Scalars['Float']['output']>;
  /** Local times of day ("HH:mm", 24-hour) at which an en-route milestone is created once per day, resolved in fixedDailyTimesTimezone, or the pickup stop's timezone when unset. Alternative to intervalMinutes/distanceBasedIntervals; ignored when either of those is set. */
  fixedDailyTimes?: Maybe<Array<Scalars['String']['output']>>;
  /** IANA timezone (e.g. "America/Chicago") that fixedDailyTimes are resolved in, so every load checks at the same wall-clock time. Unset uses the pickup stop's timezone. */
  fixedDailyTimesTimezone?: Maybe<Scalars['String']['output']>;
  /** Include the latest TMS tracking alert status (e.g. McLeod tracking_alert_status_code) in en-route milestones. */
  includeTrackingAlertStatus?: Maybe<Scalars['Boolean']['output']>;
  intervalMinutes?: Maybe<Scalars['Float']['output']>;
  /** Skip en-route milestones while the truck is within this many miles of the first pickup. Defaults to 25; 0 never skips. Maximum is 500. */
  skipTrackingWithinMilesOfPickup?: Maybe<Scalars['Float']['output']>;
  smartFilter?: Maybe<SmartFilterSettings>;
  /** Stop en-route tracking when the truck is within this many miles of the last delivery. */
  stopTrackingWithinMiles?: Maybe<Scalars['Float']['output']>;
};

export type EnRouteTrackEventSettingsInput = {
  closeToDeliveryInterval?: InputMaybe<CloseToDeliveryIntervalInput>;
  distanceBasedIntervals?: InputMaybe<DistanceBasedIntervalsInput>;
  filter?: InputMaybe<EnRouteFilter>;
  /** Minutes after the in-transit window starts before the first en-route check/call. Subsequent checks use intervalMinutes. Defaults to 0 (immediate). */
  firstMilestoneDelayMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Local times of day ("HH:mm", 24-hour) at which an en-route milestone is created once per day, resolved in fixedDailyTimesTimezone, or the pickup stop's timezone when unset. Alternative to intervalMinutes/distanceBasedIntervals; ignored when either of those is set. */
  fixedDailyTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IANA timezone (e.g. "America/Chicago") that fixedDailyTimes are resolved in, so every load checks at the same wall-clock time. Unset uses the pickup stop's timezone. */
  fixedDailyTimesTimezone?: InputMaybe<Scalars['String']['input']>;
  /** Include the latest TMS tracking alert status (e.g. McLeod tracking_alert_status_code) in en-route milestones. */
  includeTrackingAlertStatus?: InputMaybe<Scalars['Boolean']['input']>;
  intervalMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Skip en-route milestones while the truck is within this many miles of the first pickup. Defaults to 25; 0 never skips. Maximum is 500. */
  skipTrackingWithinMilesOfPickup?: InputMaybe<Scalars['Float']['input']>;
  smartFilter?: InputMaybe<SmartFilterSettingsInput>;
  /** Stop en-route tracking when the truck is within this many miles of the last delivery. */
  stopTrackingWithinMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type EnableTmsIntegrationVerificationInput = {
  organizationId: Scalars['ID']['input'];
  schedule?: InputMaybe<CanarySchedule>;
};

export type EnableTmsIntegrationVerificationPayload = {
  __typename?: 'EnableTMSIntegrationVerificationPayload';
  schedule: CanarySchedule;
  success: Scalars['Boolean']['output'];
};

export type EnsureFrontExternalMessageInput = {
  messageId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type EnsureOutlookExternalMessageInput = {
  internetMessageId?: InputMaybe<Scalars['String']['input']>;
  /** Outlook item.itemId converted to REST format */
  itemId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  /** Address of the shared mailbox the email is open in */
  sharedInbox?: InputMaybe<Scalars['String']['input']>;
};

export type EnsureShipmentExistsForQuoteInput = {
  quoteId: Scalars['ID']['input'];
};

export type EnsureShipmentExistsForQuotePayload = {
  __typename?: 'EnsureShipmentExistsForQuotePayload';
  shipment: Shipment;
};

export type EntityAssociation = AbstractEntity & Node & {
  __typename?: 'EntityAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EntityDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'EntityDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export enum EntityDocumentUploadType {
  ACTION_DEFINITION_DOCUMENT_UPLOAD = 'ACTION_DEFINITION_DOCUMENT_UPLOAD',
  ACTION_EXECUTION_DOCUMENT_UPLOAD = 'ACTION_EXECUTION_DOCUMENT_UPLOAD',
  EXTERNAL_MESSAGE_DOCUMENT_UPLOAD = 'EXTERNAL_MESSAGE_DOCUMENT_UPLOAD',
  KNOWLEDGE_BASE_DOCUMENT_UPLOAD = 'KNOWLEDGE_BASE_DOCUMENT_UPLOAD',
  ORGANIZATION_DOCUMENT_UPLOAD = 'ORGANIZATION_DOCUMENT_UPLOAD',
  USER_DOCUMENT_UPLOAD = 'USER_DOCUMENT_UPLOAD'
}

export type ErrorGroup = AbstractEntity & Node & {
  __typename?: 'ErrorGroup';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fingerprint: Scalars['String']['output'];
  firstSeenAt: Scalars['DateTimeISO']['output'];
  githubPrUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastOccurrenceCount: Scalars['Int']['output'];
  lastSeenAt: Scalars['DateTimeISO']['output'];
  linearTicketId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  source: ErrorIncidentSource;
  status: ErrorGroupStatus;
  suppressionThreshold?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  topOrganizations: Array<ErrorGroupOrganizationCount>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ErrorGroupOrganizationCount = {
  __typename?: 'ErrorGroupOrganizationCount';
  count: Scalars['Int']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export enum ErrorGroupStatus {
  INVESTIGATING = 'INVESTIGATING',
  NEW = 'NEW',
  RESOLVED = 'RESOLVED',
  SUPPRESSED = 'SUPPRESSED'
}

export enum ErrorIncidentSource {
  INCOMING_API_REQUEST = 'INCOMING_API_REQUEST'
}

export type EscalationAction = {
  __typename?: 'EscalationAction';
  type: EscalationActionType;
};

export enum EscalationActionType {
  DELETE_TASK = 'DELETE_TASK',
  RE_RUN_STEP = 'RE_RUN_STEP',
  RE_START = 'RE_START'
}

/** Channel used for escalation notifications */
export enum EscalationChannel {
  AGENT_HANDLED = 'AGENT_HANDLED',
  SLACK = 'SLACK',
  SOP = 'SOP',
  VOICE = 'VOICE'
}

export type EscalationConfigType = {
  __typename?: 'EscalationConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Channel to use for escalation notifications */
  escalationChannel: EscalationChannel;
  /** Optional custom message to display when escalation is triggered */
  escalationMessage?: Maybe<Scalars['String']['output']>;
  escalationThreshold: Scalars['Int']['output'];
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Message spoken to carrier before being placed on hold */
  holdMessage?: Maybe<Scalars['String']['output']>;
  /** Optional list of additional fields to include in escalation message (e.g., currencyPay) */
  includeFields?: Maybe<Array<Scalars['String']['output']>>;
  initialIncrementAmount: Scalars['Float']['output'];
  maxEscalationOverage?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  timeoutSeconds: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type EscalationData = {
  __typename?: 'EscalationData';
  actions: Array<EscalationAction>;
  codeExecutionError?: Maybe<Scalars['String']['output']>;
  escalationRationale?: Maybe<Scalars['String']['output']>;
  escalationType: EscalationType;
  eventDataType: ActionExecutionEventType;
  message: Scalars['String']['output'];
  subscriberIds: Array<Scalars['String']['output']>;
};

/** Status of a negotiation escalation */
export enum EscalationStatus {
  COMPLETE = 'COMPLETE',
  NONE = 'NONE',
  PENDING = 'PENDING'
}

export enum EscalationType {
  AGENT_INITIATED = 'AGENT_INITIATED',
  EMAIL_ERROR = 'EMAIL_ERROR',
  GUARD_RAIL = 'GUARD_RAIL',
  NEGOTIATION_PRICE_APPROVAL = 'NEGOTIATION_PRICE_APPROVAL',
  POST_COMPLETION_MESSAGE = 'POST_COMPLETION_MESSAGE',
  TRACK_EMAIL_THREAD_NOT_FOUND = 'TRACK_EMAIL_THREAD_NOT_FOUND',
  TRACK_TRACKING_DATA_IS_STALE = 'TRACK_TRACKING_DATA_IS_STALE',
  TRACK_VEHICLE_IS_NOT_MOVING = 'TRACK_VEHICLE_IS_NOT_MOVING',
  TRACK_VEHICLE_RUNNING_LATE = 'TRACK_VEHICLE_RUNNING_LATE',
  TRANSFER = 'TRANSFER',
  UNKNOWN = 'UNKNOWN',
  VOOMA_BUILD = 'VOOMA_BUILD'
}

export type EvaluationTrace = {
  __typename?: 'EvaluationTrace';
  externalUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Mapping between events and action executions. */
export type EventActionsMapping = AbstractEntity & Node & {
  __typename?: 'EventActionsMapping';
  actionExecution: ActionExecution;
  actionExecutionId: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  event: AbstractEvent;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type EventLabel = {
  __typename?: 'EventLabel';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Exception = AbstractEntity & Node & {
  __typename?: 'Exception';
  actionExecution?: Maybe<ActionExecution>;
  callTransferStatus: CallTransferStatus;
  /** Serialized as JSON */
  context?: Maybe<Scalars['JSON']['output']>;
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  handler?: Maybe<ActionExecution>;
  id: Scalars['ID']['output'];
  organization: Organization;
  status: ExceptionStatus;
  type: ExceptionType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExceptionConnection = {
  __typename?: 'ExceptionConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExceptionEdge>;
  nodes?: Maybe<Array<Exception>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExceptionCreatedData = {
  __typename?: 'ExceptionCreatedData';
  eventType: MovementEventType;
  exception: LoadException;
  trackingDataAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type ExceptionCreatedTriggerConfig = {
  __typename?: 'ExceptionCreatedTriggerConfig';
  override?: Maybe<BaseTriggerOverride>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
  types: Array<ExceptionType>;
};

export type ExceptionEdge = {
  __typename?: 'ExceptionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Exception;
};

export type ExceptionEventsSettings = {
  __typename?: 'ExceptionEventsSettings';
  /** Minutes before the last delivery stop's scheduled start within which RUNNING_LATE and VEHICLE_IS_NOT_MOVING exceptions trigger downstream actions (e.g. escalations). The exception is always recorded; unset means always trigger. */
  alertWindowMinutes?: Maybe<Scalars['Float']['output']>;
  infoMissing?: Maybe<InfoMissingExceptionSettings>;
  notYetDispatched?: Maybe<NotYetDispatchedExceptionSettings>;
  /** Minutes after the movement becomes IN_TRANSIT during which post-pickup exception events (Running Late, Running Late Close To Delivery, Tracking Data Not Available, Tracking Data Stale, Stationary Vehicle) are suppressed. Unset or 0 means no quiet period. Does not apply to Info Missing, Invalid Tracking Link, or Potentially Corrupted Tracking Data. */
  quietPeriodAfterInTransitMinutes?: Maybe<Scalars['Float']['output']>;
  runningLate?: Maybe<RunningLateExceptionSettings>;
  runningLateCloseToDelivery?: Maybe<RunningLateCloseToDeliveryExceptionSettings>;
  runningLateCloseToPickup?: Maybe<RunningLateCloseToPickupExceptionSettings>;
  stationaryVehicle?: Maybe<StationaryVehicleExceptionSettings>;
  trackingDataNotAvailable?: Maybe<TrackingDataNotAvailableExceptionSettings>;
  trackingDataStale?: Maybe<TrackingDataStaleExceptionSettings>;
};

export type ExceptionEventsSettingsInput = {
  /** Minutes before the last delivery stop's scheduled start within which RUNNING_LATE and VEHICLE_IS_NOT_MOVING exceptions trigger downstream actions (e.g. escalations). The exception is always recorded; unset means always trigger. */
  alertWindowMinutes?: InputMaybe<Scalars['Float']['input']>;
  infoMissing?: InputMaybe<InfoMissingExceptionSettingsInput>;
  notYetDispatched?: InputMaybe<NotYetDispatchedExceptionSettingsInput>;
  /** Minutes after the movement becomes IN_TRANSIT during which post-pickup exception events (Running Late, Running Late Close To Delivery, Tracking Data Not Available, Tracking Data Stale, Stationary Vehicle) are suppressed. Unset or 0 means no quiet period. Does not apply to Info Missing, Invalid Tracking Link, or Potentially Corrupted Tracking Data. */
  quietPeriodAfterInTransitMinutes?: InputMaybe<Scalars['Float']['input']>;
  runningLate?: InputMaybe<RunningLateExceptionSettingsInput>;
  runningLateCloseToDelivery?: InputMaybe<RunningLateCloseToDeliveryExceptionSettingsInput>;
  runningLateCloseToPickup?: InputMaybe<RunningLateCloseToPickupExceptionSettingsInput>;
  stationaryVehicle?: InputMaybe<StationaryVehicleExceptionSettingsInput>;
  trackingDataNotAvailable?: InputMaybe<TrackingDataNotAvailableExceptionSettingsInput>;
  trackingDataStale?: InputMaybe<TrackingDataStaleExceptionSettingsInput>;
};

export type ExceptionResolvedData = {
  __typename?: 'ExceptionResolvedData';
  eventType: MovementEventType;
  exception: LoadException;
};

export enum ExceptionStatus {
  IGNORED = 'IGNORED',
  NEW = 'NEW',
  NO_LONGER_VALID = 'NO_LONGER_VALID',
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED'
}

export type ExceptionTriggerSuppressedData = {
  __typename?: 'ExceptionTriggerSuppressedData';
  alertWindowMinutes?: Maybe<Scalars['Float']['output']>;
  eventType: MovementEventType;
  loadExceptionType: LoadExceptionType;
  minutesUntilLastDeliveryStart?: Maybe<Scalars['Float']['output']>;
};

export type ExceptionTriggerType = {
  __typename?: 'ExceptionTriggerType';
  carrierBestOffer: Scalars['Float']['output'];
  includeFields?: Maybe<Array<Scalars['String']['output']>>;
  timeoutSeconds?: Maybe<Scalars['Int']['output']>;
  voomaBestOffer: Scalars['Float']['output'];
};

export enum ExceptionType {
  AGENT_INITIATED = 'AGENT_INITIATED',
  CANNOT_ESTABLISH_COMMUNICATION = 'CANNOT_ESTABLISH_COMMUNICATION',
  CODE_EXCEPTION = 'CODE_EXCEPTION',
  COVERAGE_PLAN = 'COVERAGE_PLAN',
  EMAIL_ERROR = 'EMAIL_ERROR',
  GUARD_RAIL = 'GUARD_RAIL',
  MISSING_COVER_PRICING = 'MISSING_COVER_PRICING',
  NEGOTIATION_PRICE_APPROVAL = 'NEGOTIATION_PRICE_APPROVAL',
  OPERATIONAL_ISSUE = 'OPERATIONAL_ISSUE',
  POSTED_LOAD_IS_COLD = 'POSTED_LOAD_IS_COLD',
  POSTED_LOAD_IS_MISPRICED = 'POSTED_LOAD_IS_MISPRICED',
  POST_COMPLETION_MESSAGE = 'POST_COMPLETION_MESSAGE',
  QUOTING_WORKFLOW_ERROR = 'QUOTING_WORKFLOW_ERROR',
  SKILL_CHANGE_APPROVAL = 'SKILL_CHANGE_APPROVAL',
  TRACK_EMAIL_THREAD_NOT_FOUND = 'TRACK_EMAIL_THREAD_NOT_FOUND',
  TRACK_EXCEPTION = 'TRACK_EXCEPTION',
  TRACK_SETTINGS_CHANGE_APPROVAL = 'TRACK_SETTINGS_CHANGE_APPROVAL',
  TRACK_TMS_UPDATE_FAILED = 'TRACK_TMS_UPDATE_FAILED',
  TRACK_TRACKING_DATA_IS_STALE = 'TRACK_TRACKING_DATA_IS_STALE',
  TRACK_VEHICLE_IS_NOT_MOVING = 'TRACK_VEHICLE_IS_NOT_MOVING',
  TRACK_VEHICLE_RUNNING_LATE = 'TRACK_VEHICLE_RUNNING_LATE',
  TRANSFER = 'TRANSFER',
  UNKNOWN = 'UNKNOWN',
  USAGE_CAP_REACHED = 'USAGE_CAP_REACHED',
  VOOMA_BUILD_EXCEPTION = 'VOOMA_BUILD_EXCEPTION',
  WORKER_INITIATED = 'WORKER_INITIATED'
}

export type ExecuteCheckpointInput = {
  actionExecutionEvents: Array<ActionExecutionEventInput>;
  currentEventId: Scalars['String']['input'];
  useLatestSOP?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExecuteCheckpointResult = {
  __typename?: 'ExecuteCheckpointResult';
  error?: Maybe<Scalars['String']['output']>;
  newEvents?: Maybe<Array<ActionExecutionEventOutput>>;
  success: Scalars['Boolean']['output'];
};

export type ExecuteCoveragePlanInput = {
  coveragePlanId: Scalars['ID']['input'];
};

export type ExecuteCoveragePlanPayload = {
  __typename?: 'ExecuteCoveragePlanPayload';
  actionExecutionId: Scalars['ID']['output'];
};

export type ExecuteToolInput = {
  organizationId: Scalars['ID']['input'];
  toolInput: Scalars['JSON']['input'];
  toolName?: InputMaybe<Scalars['String']['input']>;
  toolType?: InputMaybe<CanonicalToolType>;
};

export type ExecuteToolResult = {
  __typename?: 'ExecuteToolResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  toolOutput?: Maybe<Scalars['String']['output']>;
};

export enum ExecutionMode {
  PRODUCTION = 'PRODUCTION',
  TEST = 'TEST'
}

export type Experiment = AbstractEntity & Node & {
  __typename?: 'Experiment';
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paramNames: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExperimentParameterAssignment = AbstractEntity & Node & {
  __typename?: 'ExperimentParameterAssignment';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  experiment: Experiment;
  id: Scalars['ID']['output'];
  parameters: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ExternalChannel = AbstractEntity & Node & {
  __typename?: 'ExternalChannel';
  channelType: ExternalChannelType;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  externalIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExternalChannelConnection = {
  __typename?: 'ExternalChannelConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExternalChannelEdge>;
  nodes?: Maybe<Array<ExternalChannel>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalChannelEdge = {
  __typename?: 'ExternalChannelEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: ExternalChannel;
};

export enum ExternalChannelType {
  ASSISTANT_EMAIL = 'ASSISTANT_EMAIL',
  GOOGLE_CHAT_SPACE = 'GOOGLE_CHAT_SPACE',
  MICROSOFT_TEAMS_CHANNEL = 'MICROSOFT_TEAMS_CHANNEL',
  SLACK_CHANNEL = 'SLACK_CHANNEL',
  VOICE = 'VOICE'
}

export type ExternalChannelsInput = {
  channelType?: InputMaybe<ExternalChannelType>;
  organizationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ExternalIdMapping = AbstractEntity & Node & {
  __typename?: 'ExternalIdMapping';
  carrierId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integrationType: Scalars['String']['output'];
  movementId?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originatorId?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  shippingOrderId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExternalMessage = AbstractEntity & Node & {
  __typename?: 'ExternalMessage';
  canonicalMessageId?: Maybe<Scalars['String']['output']>;
  classifications?: Maybe<Scalars['JSON']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  documents: Array<ExternalMessageDocumentUpload>;
  /** Serialized as JSON */
  emailMetadata?: Maybe<Scalars['JSON']['output']>;
  entityAssociations: Array<MessageEntityAssociation>;
  externalIdentifier: Scalars['String']['output'];
  externalThreadId?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  internetMessageId?: Maybe<Scalars['String']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  maybeReferences?: Maybe<Array<Scalars['String']['output']>>;
  organization: Organization;
  s3Url?: Maybe<Scalars['String']['output']>;
  status: ClassificationStatus;
  type: ExternalMessageType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExternalMessageByInternetMessageIdInput = {
  internetMessageId: Scalars['String']['input'];
};

export type ExternalMessageClassificationGraphQl = {
  __typename?: 'ExternalMessageClassificationGraphQL';
  confidence?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ExternalMessageDaySummary = {
  __typename?: 'ExternalMessageDaySummary';
  classifiedCount: Scalars['Int']['output'];
  /** test */
  date: Scalars['DateTimeISO']['output'];
  failedCount: Scalars['Int']['output'];
};

export type ExternalMessageDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'ExternalMessageDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subject: ExternalMessage;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type ExternalMessageInput = {
  excludeContent?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type ExternalMessageMetadataPayload = {
  __typename?: 'ExternalMessageMetadataPayload';
  createdAt: Scalars['DateTimeISO']['output'];
  emailMetadata?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  internetMessageId?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
};

export type ExternalMessagePayload = {
  __typename?: 'ExternalMessagePayload';
  base64EncodedContent: Scalars['String']['output'];
  /** @deprecated Replaced by base64EncodedContent */
  content: Scalars['String']['output'];
  externalMessage: ExternalMessage;
  parsedEmail?: Maybe<ParsedEmail>;
};

/** The type of case to be classified. */
export enum ExternalMessageType {
  AGENTMAIL_MESSAGE = 'AGENTMAIL_MESSAGE',
  ASSISTANT_EMAIL = 'ASSISTANT_EMAIL',
  CHAT_MESSAGE = 'CHAT_MESSAGE',
  DFM_MCLEOD_IMPORT = 'DFM_MCLEOD_IMPORT',
  FRONT_MESSAGE = 'FRONT_MESSAGE',
  GMAIL_MESSAGE = 'GMAIL_MESSAGE',
  GOOGLE_CHAT_MESSAGE = 'GOOGLE_CHAT_MESSAGE',
  HOSTED_MCLEOD_IMPORT = 'HOSTED_MCLEOD_IMPORT',
  MICROSOFT_MESSAGE = 'MICROSOFT_MESSAGE',
  MICROSOFT_TEAMS_MESSAGE = 'MICROSOFT_TEAMS_MESSAGE',
  PYLON_MESSAGE = 'PYLON_MESSAGE',
  RAPID_ALERT_MCLEOD_IMPORT = 'RAPID_ALERT_MCLEOD_IMPORT',
  SLACK_MESSAGE = 'SLACK_MESSAGE',
  SYSTEM_MESSAGE = 'SYSTEM_MESSAGE',
  TURVO_IMPORT = 'TURVO_IMPORT',
  TWILIO_SMS = 'TWILIO_SMS',
  VMAIL_MESSAGE = 'VMAIL_MESSAGE',
  VOICE_TRANSCRIPT = 'VOICE_TRANSCRIPT'
}

export type ExternalMessageUserSummary = {
  __typename?: 'ExternalMessageUserSummary';
  externalMessageDaySummaries: Array<ExternalMessageDaySummary>;
  lastClassifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId: Scalars['ID']['output'];
};

export type ExternalMessagesByUserInput = {
  daysAgo: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type ExternalMessagesByUserPayload = {
  __typename?: 'ExternalMessagesByUserPayload';
  externalMessageUserSummary: Array<ExternalMessageUserSummary>;
};

export type ExternalMessagesInput = {
  /** @deprecated Ignored by resolver */
  lookbackMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalOrderToClone = {
  __typename?: 'ExternalOrderToClone';
  externalId: Scalars['String']['output'];
  integrationType: IntegrationType;
};

export type ExtractBuildAccuracyResultsInput = {
  jobIds: Array<Scalars['ID']['input']>;
};

export type ExtractBuildAccuracyResultsPayload = {
  __typename?: 'ExtractBuildAccuracyResultsPayload';
  results: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
};

export type FailedSample = {
  __typename?: 'FailedSample';
  description: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
};

export type FeatureFlag = AbstractEntity & Node & {
  __typename?: 'FeatureFlag';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizations: BooleanFlagConfiguration;
  originators: BooleanFlagConfiguration;
  teams: BooleanFlagConfiguration;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  users: BooleanFlagConfiguration;
};

export type FeatureFlagInput = {
  id: Scalars['ID']['input'];
};

export enum FeatureFlagName {
  AGENT_SIDE_PANEL = 'AGENT_SIDE_PANEL',
  ALLOW_CONVERSATION_WITHOUT_ACTION_EXECUTION = 'ALLOW_CONVERSATION_WITHOUT_ACTION_EXECUTION',
  ALLOW_GUARDRAIL_BYPASS = 'ALLOW_GUARDRAIL_BYPASS',
  AUTOMATICALLY_ASSOCIATE_ENTITIES_IN_AE_INPUTS = 'AUTOMATICALLY_ASSOCIATE_ENTITIES_IN_AE_INPUTS',
  BUILD_CONNECTED_SHIPMENTS_IN_INFLOW = 'BUILD_CONNECTED_SHIPMENTS_IN_INFLOW',
  BUILD_ORDER_BUTTON = 'BUILD_ORDER_BUTTON',
  BUILD_QUOTE_BUTTON = 'BUILD_QUOTE_BUTTON',
  CALL_INSIGHTS = 'CALL_INSIGHTS',
  CARRIER_OFFERS = 'CARRIER_OFFERS',
  CHAT_SUGGESTIONS = 'CHAT_SUGGESTIONS',
  CODE_DRIVEN_CARRIER_OUTREACH = 'CODE_DRIVEN_CARRIER_OUTREACH',
  CONTINUE_TRACKING_WHEN_DELIVERED = 'CONTINUE_TRACKING_WHEN_DELIVERED',
  COVER_COMMAND_CENTER = 'COVER_COMMAND_CENTER',
  COVER_STOP_OUTREACH_WHEN_COVERED = 'COVER_STOP_OUTREACH_WHEN_COVERED',
  DEPRECATE_USER_ALLOW_LISTS = 'DEPRECATE_USER_ALLOW_LISTS',
  DISABLE_AGENTIC_TRANSFERS = 'DISABLE_AGENTIC_TRANSFERS',
  DISABLE_PLACE_DATA_UPDATE_FROM_TMS_IMPORT = 'DISABLE_PLACE_DATA_UPDATE_FROM_TMS_IMPORT',
  DISABLE_ROUTE_SANITY_CHECK_IN_PUBLIC_API = 'DISABLE_ROUTE_SANITY_CHECK_IN_PUBLIC_API',
  DOCUMENT_UPLOAD = 'DOCUMENT_UPLOAD',
  ELIGIBLE_FOR_VOICE_EXPERIMENT = 'ELIGIBLE_FOR_VOICE_EXPERIMENT',
  EMAIL_TRIGGER_FAST_PATH = 'EMAIL_TRIGGER_FAST_PATH',
  ENABLE_BETA_TTS_MODELS = 'ENABLE_BETA_TTS_MODELS',
  ENABLE_GEOGRAPHIC_MATCHING = 'ENABLE_GEOGRAPHIC_MATCHING',
  ENFORCE_VOICE_GUARDRAILS = 'ENFORCE_VOICE_GUARDRAILS',
  FILTER_WHO_IS_CC_ED_GUARDRAIL = 'FILTER_WHO_IS_CC_ED_GUARDRAIL',
  FINISH_CONVERSATION_BUTTON = 'FINISH_CONVERSATION_BUTTON',
  FRONTEND_MAINTENANCE_MODE = 'FRONTEND_MAINTENANCE_MODE',
  GUMSHOE_ADMIN_UI = 'GUMSHOE_ADMIN_UI',
  INCLUDE_SHIPPER_IN_MOVEMENT_EVENT = 'INCLUDE_SHIPPER_IN_MOVEMENT_EVENT',
  INSIGHTS_V2_EMBEDS = 'INSIGHTS_V2_EMBEDS',
  JEV_NEW_ORDER_CLASSIFICATION = 'JEV_NEW_ORDER_CLASSIFICATION',
  LOAD_SHIPMENT_BY_ID = 'LOAD_SHIPMENT_BY_ID',
  MCLEOD_DOCUMENT_UPLOAD = 'MCLEOD_DOCUMENT_UPLOAD',
  ORDER_PRESUBMIT_VALIDATION = 'ORDER_PRESUBMIT_VALIDATION',
  ORDER_UPDATE_PIPELINE = 'ORDER_UPDATE_PIPELINE',
  PAUSE_MESSAGE_CLASSIFICATION = 'PAUSE_MESSAGE_CLASSIFICATION',
  PROCESS_INTEGRATIONLESS_SHIPMENTS = 'PROCESS_INTEGRATIONLESS_SHIPMENTS',
  PRODUCT_COVER_SETTINGS = 'PRODUCT_COVER_SETTINGS',
  QUOTES_CONDITIONAL_AUTO_REPLY = 'QUOTES_CONDITIONAL_AUTO_REPLY',
  QUOTE_UPDATE_FROM_TMS_IMPORT = 'QUOTE_UPDATE_FROM_TMS_IMPORT',
  RATE_SHIPMENT_ON_CREATE = 'RATE_SHIPMENT_ON_CREATE',
  SCHEDULING = 'SCHEDULING',
  SELF_SERVE_BUILD_INSTRUCTIONS = 'SELF_SERVE_BUILD_INSTRUCTIONS',
  SEND_MCLEOD_SUBJECT_ORDER = 'SEND_MCLEOD_SUBJECT_ORDER',
  SHIPMENT_LINKAGE_INSIGHTS = 'SHIPMENT_LINKAGE_INSIGHTS',
  SHOW_NEGOTIATION_STRATEGY_OVERRIDE = 'SHOW_NEGOTIATION_STRATEGY_OVERRIDE',
  SHOW_VOOMA_COVER_FOR_QUOTES = 'SHOW_VOOMA_COVER_FOR_QUOTES',
  SOP_LIST_VIEW = 'SOP_LIST_VIEW',
  SYNC_DAT_POSTING_ON_UPDATE = 'SYNC_DAT_POSTING_ON_UPDATE',
  SYNC_HOSTED_MCLEOD_LOCATIONS_IN_CLERK = 'SYNC_HOSTED_MCLEOD_LOCATIONS_IN_CLERK',
  TEAMS_CHANNEL_FILE_UPLOAD = 'TEAMS_CHANNEL_FILE_UPLOAD',
  TRACK_CUSTOMER_CHECK_CALL = 'TRACK_CUSTOMER_CHECK_CALL',
  TRACK_DASHBOARD = 'TRACK_DASHBOARD',
  TRACK_INSIGHTS = 'TRACK_INSIGHTS',
  TRACK_INTEGRATION_ENTITY_SYNC = 'TRACK_INTEGRATION_ENTITY_SYNC',
  TRACK_LOADS_IN_SIDEKICK = 'TRACK_LOADS_IN_SIDEKICK',
  TRACK_SETTINGS_PAGES = 'TRACK_SETTINGS_PAGES',
  TRACK_SOP_TEST = 'TRACK_SOP_TEST',
  TRACK_WORKSPACE_PAGE = 'TRACK_WORKSPACE_PAGE',
  TRANSFER_ON_COVERAGE_PLAN = 'TRANSFER_ON_COVERAGE_PLAN',
  UPDATE_OUTLOOK_REPLY_SUBJECT = 'UPDATE_OUTLOOK_REPLY_SUBJECT',
  USAGE_DASHBOARD = 'USAGE_DASHBOARD',
  USE_CLAUDE_FOR_CLASSIFICATION = 'USE_CLAUDE_FOR_CLASSIFICATION',
  USE_DAT_BULK_REFRESH = 'USE_DAT_BULK_REFRESH',
  USE_DFM_FULL_FLOW = 'USE_DFM_FULL_FLOW',
  USE_LLM_TO_SANITY_CHECK_VOICE_TOOL_CALLS = 'USE_LLM_TO_SANITY_CHECK_VOICE_TOOL_CALLS',
  USE_STANDALONE_VOICE_SERVICE = 'USE_STANDALONE_VOICE_SERVICE',
  USE_STATEFUL_MCLEOD_SHIPMENT_POLLING = 'USE_STATEFUL_MCLEOD_SHIPMENT_POLLING',
  USE_TRACK_MCLEOD_POST_DELIVERY_DEPARTURE_UPDATE = 'USE_TRACK_MCLEOD_POST_DELIVERY_DEPARTURE_UPDATE',
  USE_VOOMA_SPEECH_ANALYSIS = 'USE_VOOMA_SPEECH_ANALYSIS',
  VIEW_CALLS_BUTTON = 'VIEW_CALLS_BUTTON'
}

export type FeatureFlagPayload = {
  __typename?: 'FeatureFlagPayload';
  featureFlag: FeatureFlag;
};

export type FeatureFlagsPayload = {
  __typename?: 'FeatureFlagsPayload';
  featureFlags: Array<FeatureFlag>;
};

export type FetchBearerTokenInput = {
  integrationType: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type FetchBearerTokenPayload = {
  __typename?: 'FetchBearerTokenPayload';
  bearerToken: Scalars['String']['output'];
};

export type FileUpload = {
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type FindDuplicateInput = {
  id: Scalars['ID']['input'];
  shouldDeduplicate: Scalars['Boolean']['input'];
};

export type FindDuplicatePayload = {
  __typename?: 'FindDuplicatePayload';
  canonicalId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FindShipmentInput = {
  organizationId: Scalars['ID']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  tms?: InputMaybe<SidekickSupportedTms>;
};

export type FindShipmentPayload = {
  __typename?: 'FindShipmentPayload';
  shipmentId: Scalars['String']['output'];
};

export type FixedAmountConfigType = {
  __typename?: 'FixedAmountConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  incrementAmount: Scalars['Float']['output'];
  /** Optional list of increment tiers evaluated in order (first match wins). When a tier matches, its incrementAmount overrides the default. Falls back to the top-level incrementAmount if no tier matches. */
  incrementTiers?: Maybe<Array<IncrementTierType>>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type FlagOriginatorInput = {
  flag: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  numJobsToFlag?: InputMaybe<Scalars['Float']['input']>;
};

export type FlagOriginatorPayload = {
  __typename?: 'FlagOriginatorPayload';
  originator: Originator;
  success: Scalars['Boolean']['output'];
};

export type FlowTrigger = {
  __typename?: 'FlowTrigger';
  config?: Maybe<Scalars['JSON']['output']>;
  type: FlowTriggerType;
};

export type FlowTriggerInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  type: FlowTriggerType;
};

export enum FlowTriggerType {
  CONFIRMED_QUOTE_CREATED = 'CONFIRMED_QUOTE_CREATED',
  ORDER_EVENT = 'ORDER_EVENT',
  QUOTE_EVENT = 'QUOTE_EVENT'
}

export type FmcsaCarrierContactPayload = {
  __typename?: 'FmcsaCarrierContactPayload';
  dbaName?: Maybe<Scalars['String']['output']>;
  dotNumber?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  mcNumber?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  physicalAddress?: Maybe<Scalars['String']['output']>;
};

export type FreightDataMapping = AbstractEntity & Node & {
  __typename?: 'FreightDataMapping';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  type: FreightDataMappingType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  values: Scalars['JSON']['output'];
};

export enum FreightDataMappingType {
  ACCESSORIAL_CODE = 'ACCESSORIAL_CODE',
  FREIGHT_MODE = 'FREIGHT_MODE',
  REFERENCE_NUMBER_TYPE = 'REFERENCE_NUMBER_TYPE',
  SHIPPING_UNIT = 'SHIPPING_UNIT',
  STANDARD_EQUIPMENT_DETAILS = 'STANDARD_EQUIPMENT_DETAILS'
}

export type FrontFilter = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
};

export type FrontInbox = {
  __typename?: 'FrontInbox';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type FrontMailboxSubscription = {
  __typename?: 'FrontMailboxSubscription';
  createdAt: Scalars['DateTimeISO']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
};

export type FrontMessageData = {
  conversationId: Scalars['String']['input'];
};

export type FrontendMaintenanceModePayload = {
  __typename?: 'FrontendMaintenanceModePayload';
  enabled: Scalars['Boolean']['output'];
};

export type GenerateBuildAccuracyReportInput = {
  labelResults: Scalars['JSON']['input'];
  runResults: Scalars['JSON']['input'];
};

export type GenerateBuildAccuracyReportPayload = {
  __typename?: 'GenerateBuildAccuracyReportPayload';
  report: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
};

export enum GenerateQuoteResponseMessageFailureReason {
  MISSING_QUOTE_DATA = 'MISSING_QUOTE_DATA',
  MISSING_RATE = 'MISSING_RATE'
}

export type GenerateQuoteResponseMessageInput = {
  draftTemplateType?: InputMaybe<Scalars['String']['input']>;
  draftingInstructions?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  quoteIds: Array<Scalars['String']['input']>;
};

export type GenerateQuoteResponseMessagePayload = {
  __typename?: 'GenerateQuoteResponseMessagePayload';
  errors?: Maybe<Array<GenerateQuoteResponseMessageFailureReason>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateShipmentLifecycleSimShipmentInput = {
  requestQuoteActionDefinitionId: Scalars['ID']['input'];
  sendOrderActionDefinitionId: Scalars['ID']['input'];
};

export type GenerateShipmentLifecycleSimShipmentPayload = {
  __typename?: 'GenerateShipmentLifecycleSimShipmentPayload';
  requestQuoteActionExecutionId: Scalars['ID']['output'];
  shipment: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
};

export type GenericRule = AbstractEntity & Node & {
  __typename?: 'GenericRule';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  transformations: Array<GenericTransformation>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum GenericRuleType {
  AUTOMATIC_COVERAGE_SETTINGS = 'AUTOMATIC_COVERAGE_SETTINGS',
  AUTOMATIC_SCHEDULE_PLAN_APPROVAL = 'AUTOMATIC_SCHEDULE_PLAN_APPROVAL',
  AUTOMATIC_SCHEDULE_PLAN_GENERATION = 'AUTOMATIC_SCHEDULE_PLAN_GENERATION',
  COVERAGE_READINESS = 'COVERAGE_READINESS',
  EMAIL_CLASSIFICATION = 'EMAIL_CLASSIFICATION',
  SHOULD_TRACK_CONDITION = 'SHOULD_TRACK_CONDITION'
}

export type GenericRulesInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  types?: InputMaybe<Array<GenericRuleType>>;
};

export type GenericTransformation = AbstractEntity & Node & {
  __typename?: 'GenericTransformation';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  genericRule: GenericRule;
  genericRuleId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  seq: Scalars['Int']['output'];
  /** Template this transformation was copied from. */
  templateId?: Maybe<Scalars['ID']['output']>;
  /** Template version last copied or merged into this transformation. */
  templateVersion?: Maybe<Scalars['Int']['output']>;
  transformationConfig: TransformationConfig;
  transformationConfigId: Scalars['String']['output'];
  transformationDefinition: TransformationDefinition;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type GenericTransformationConnection = {
  __typename?: 'GenericTransformationConnection';
  count: Scalars['Int']['output'];
  edges: Array<GenericTransformationEdge>;
  nodes?: Maybe<Array<GenericTransformation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericTransformationEdge = {
  __typename?: 'GenericTransformationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: GenericTransformation;
};

export type GenericTransformationMutationPayload = {
  __typename?: 'GenericTransformationMutationPayload';
  success: Scalars['Boolean']['output'];
};

/** A reusable generic transformation that organizations can copy into their generic rules. Each copy records the template version it came from, so later template changes can be merged into it. */
export type GenericTransformationTemplate = AbstractEntity & Node & {
  __typename?: 'GenericTransformationTemplate';
  createdAt: Scalars['DateTimeISO']['output'];
  definition: Scalars['JSON']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genericRuleType: GenericRuleType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** Incremented whenever the template definition changes. */
  version: Scalars['Int']['output'];
};

export type GenericTransformationTemplateInheritor = {
  __typename?: 'GenericTransformationTemplateInheritor';
  genericRuleId: Scalars['ID']['output'];
  genericTransformationId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  templateVersion?: Maybe<Scalars['Int']['output']>;
};

export type GenericTransformationTemplatePayload = {
  __typename?: 'GenericTransformationTemplatePayload';
  genericTransformationTemplate: GenericTransformationTemplate;
};

export type GenericTransformationTemplatesInput = {
  genericRuleTypes?: InputMaybe<Array<GenericRuleType>>;
};

export type GenericTransformationsInput = {
  genericRuleTypes?: InputMaybe<Array<GenericRuleType>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type GeoCircle = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radiusMiles: Scalars['Float']['input'];
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoPointInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GetActionDefinitionsUsedAsParentsInput = {
  organizationId: Scalars['ID']['input'];
};

export type GetActivePostingsResponse = {
  __typename?: 'GetActivePostingsResponse';
  postings: Array<LoadBoardPosting>;
};

export type GetBraintrustDatasetsInput = {
  environment?: InputMaybe<BraintrustEnvironment>;
};

export type GetCarrierInterestContextInput = {
  organizationId: Scalars['ID']['input'];
  shipmentReference: Scalars['String']['input'];
};

export type GetChannelOptionsInput = {
  channelType: ExternalChannelType;
  organizationId: Scalars['ID']['input'];
};

export type GetChannelOptionsPayload = {
  __typename?: 'GetChannelOptionsPayload';
  options: Array<ChannelOption>;
};

export type GetComposioToolKitDetailsInput = {
  authTokenId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  toolKitSlug: Scalars['String']['input'];
};

export type GetCoveragePlanInput = {
  id: Scalars['ID']['input'];
};

export type GetCoveragePlansForShipmentInput = {
  shipmentId: Scalars['ID']['input'];
};

export type GetEvaluationTraceInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetExceptionsByActionExecutionIdInput = {
  actionExecutionId: Scalars['String']['input'];
};

export type GetExceptionsInput = {
  organizationId: Scalars['String']['input'];
};

export type GetExistingCarriersInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type GetExternalIdMappingsInput = {
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetExternalIdMappingsPayload = {
  __typename?: 'GetExternalIdMappingsPayload';
  externalIdMappings: Array<ExternalIdMapping>;
};

export type GetFeatureFlagEnabledInput = {
  name: FeatureFlagName;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetLanePreferencesForShipmentInput = {
  shipmentId: Scalars['ID']['input'];
};

export type GetLoadBoardPostingsInput = {
  integrationTypes: Array<Scalars['String']['input']>;
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type GetLoadBoardPostingsPayload = {
  __typename?: 'GetLoadBoardPostingsPayload';
  postings: Array<LoadBoardPosting>;
};

export type GetMovementCoveragePlanIdsInput = {
  movementIds: Array<Scalars['ID']['input']>;
};

export type GetOrCreateConversationWithConciergeInput = {
  organizationId: Scalars['ID']['input'];
};

export type GetOriginatorOrderTemplateInput = {
  originatorId: Scalars['ID']['input'];
};

export type GetOriginatorOrderTemplatePayload = {
  __typename?: 'GetOriginatorOrderTemplatePayload';
  originatorName: Scalars['String']['output'];
  template?: Maybe<Template>;
};

export type GetQuoteSimulationsInput = {
  organizationId: Scalars['ID']['input'];
};

export type GetQuoteSimulationsPayload = {
  __typename?: 'GetQuoteSimulationsPayload';
  quoteSimulationId?: Maybe<Scalars['String']['output']>;
};

export type GetResourceResolutionPayload = {
  __typename?: 'GetResourceResolutionPayload';
  resolutions: Array<ResourceResolution>;
};

export type GetSchedulePortalAvailabilityCheckInput = {
  fields?: InputMaybe<Scalars['JSON']['input']>;
  movementStopId: Scalars['ID']['input'];
  shipmentId: Scalars['ID']['input'];
  stopsIndex: Scalars['Float']['input'];
};

export type GetSchedulePortalAvailabilityCheckPayload = {
  __typename?: 'GetSchedulePortalAvailabilityCheckPayload';
  check: AvailabilityCheck;
};

export type GetSuggestedCarriersInput = {
  orderId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  sources: Array<CarrierSource>;
};

export type GetSuggestedCarriersPayload = {
  __typename?: 'GetSuggestedCarriersPayload';
  suggestedCarriers: Array<SuggestedCarrier>;
};

export type GlobalPrompt = AbstractEntity & Node & {
  __typename?: 'GlobalPrompt';
  basePromptId?: Maybe<Scalars['ID']['output']>;
  canRollOutFromCode: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currentVersionId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  /** Routes inheriting action definitions to the experimental service. Null uses the normal service. */
  runsOnExperimentalService?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type GlobalPromptByIdInput = {
  id: Scalars['ID']['input'];
};

export type GlobalPromptPayload = {
  __typename?: 'GlobalPromptPayload';
  globalPrompt: GlobalPrompt;
};

export type GlobalPromptSnapshotsInput = {
  /** When set, only prompts that have a version with one of these provisioning resource ids are returned. */
  provisioningResourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Mode for proposing SOP alignment edits from a global prompt. */
export enum GlobalPromptSopProposalMode {
  LATEST_DIFF = 'LATEST_DIFF',
  LATEST_VERSION = 'LATEST_VERSION',
  VERSION_DIFF = 'VERSION_DIFF'
}

export type GlobalPromptVersion = AbstractEntity & Node & {
  __typename?: 'GlobalPromptVersion';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  prompt: Scalars['String']['output'];
  provisioningResourceId?: Maybe<Scalars['ID']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  version: Scalars['Int']['output'];
};

export type GlobalPromptWithVersions = {
  __typename?: 'GlobalPromptWithVersions';
  globalPrompt: GlobalPrompt;
  versions: Array<GlobalPromptVersion>;
};

export type GlobalSharedFile = AbstractEntity & AbstractSharedFile & Node & {
  __typename?: 'GlobalSharedFile';
  createdAt: Scalars['DateTimeISO']['output'];
  currentVersion?: Maybe<GlobalSharedFileVersion>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type GlobalSharedFileVersion = AbstractEntity & AbstractSharedFileVersion & Node & {
  __typename?: 'GlobalSharedFileVersion';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type GmailFilter = {
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type GmailMessageData = {
  threadId: Scalars['String']['input'];
};

export enum GoogleChatMessageSource {
  DIRECT_MESSAGE = 'DIRECT_MESSAGE',
  SPACE = 'SPACE'
}

export type GoogleChatMessageTriggerConfig = {
  __typename?: 'GoogleChatMessageTriggerConfig';
  googleChatSources: Array<GoogleChatMessageSource>;
  googleChatSpaceIds?: Maybe<Array<Scalars['String']['output']>>;
  override?: Maybe<BaseTriggerOverride>;
  respondToAnySpaceMessage?: Maybe<Scalars['Boolean']['output']>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
};

export type GraphDefinedProcedure = {
  __typename?: 'GraphDefinedProcedure';
  graph: GraphDefinition;
  procedureType: ProcedureType;
};

export type GraphDefinition = {
  __typename?: 'GraphDefinition';
  edges: Array<GraphEdge>;
  initialNodeId?: Maybe<Scalars['ID']['output']>;
  nodes: Array<GraphNode>;
};

export type GraphEdge = {
  __typename?: 'GraphEdge';
  id: Scalars['String']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  type?: Maybe<EdgeType>;
};

export type GraphNode = {
  __typename?: 'GraphNode';
  actionDefinitionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  position: GraphNodePosition;
};

export type GraphNodePosition = {
  __typename?: 'GraphNodePosition';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type GraphqlToolCatalogEntry = {
  __typename?: 'GraphqlToolCatalogEntry';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type HandleExternalMessageClassifiedAndAssociatedInput = {
  externalMessageId?: InputMaybe<Scalars['ID']['input']>;
};

export type HandleExternalMessageClassifiedAndAssociatedPayload = {
  __typename?: 'HandleExternalMessageClassifiedAndAssociatedPayload';
  success: Scalars['Boolean']['output'];
};

export type HandleNewAssistantEmailInput = {
  emailS3Bucket: Scalars['String']['input'];
  emailS3Key: Scalars['String']['input'];
};

export type HandleNewAssistantEmailPayload = {
  __typename?: 'HandleNewAssistantEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type HandleNewTrackingEmailPayload = {
  __typename?: 'HandleNewTrackingEmailPayload';
  success: Scalars['Boolean']['output'];
};

export type HasAuthorizedServiceTypePayload = {
  __typename?: 'HasAuthorizedServiceTypePayload';
  email?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type HasConciergeActionDefinitionInput = {
  organizationId: Scalars['ID']['input'];
};

export type HasConciergeActionDefinitionPayload = {
  __typename?: 'HasConciergeActionDefinitionPayload';
  actionDefinitionId?: Maybe<Scalars['ID']['output']>;
  actionDefinitionName?: Maybe<Scalars['String']['output']>;
  escalationHandlerActionDefinitionId?: Maybe<Scalars['ID']['output']>;
  escalationHandlerActionDefinitionName?: Maybe<Scalars['String']['output']>;
  hasConcierge: Scalars['Boolean']['output'];
};

export type HasIntegrationCredentialsInput = {
  organizationId: Scalars['ID']['input'];
  type: IntegrationCredentialsType;
  usageIndicator: UsageIndicator;
};

export type HasIntegrationCredentialsPayload = {
  __typename?: 'HasIntegrationCredentialsPayload';
  hasIntegrationCredentials: Scalars['Boolean']['output'];
};

export type HasLabelingConciergeInput = {
  organizationId: Scalars['ID']['input'];
};

export type HasLabelingConciergePayload = {
  __typename?: 'HasLabelingConciergePayload';
  hasLabelingConcierge: Scalars['Boolean']['output'];
};

export type HierarchyLevelSettings = {
  __typename?: 'HierarchyLevelSettings';
  autoReply?: Maybe<Scalars['JSON']['output']>;
  entity?: Maybe<SettingsEntityInfo>;
  pricingStrategy?: Maybe<PricingStrategy>;
  pricingStrategyResolutionError?: Maybe<Scalars['String']['output']>;
  settingsCount: Scalars['Int']['output'];
};

export type HighwayCredentialTestInput = {
  organizationId: Scalars['ID']['input'];
};

export type HighwayCredentialTestPayload = {
  __typename?: 'HighwayCredentialTestPayload';
  allPassed: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  results: Array<HighwayCredentialTestResult>;
};

export type HighwayCredentialTestResult = {
  __typename?: 'HighwayCredentialTestResult';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: IntegrationCheckStatus;
};

export type HostedMcLeodCredentialTestInput = {
  organizationId: Scalars['ID']['input'];
  /** Test API Module credentials */
  testApiModule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Test Dev API Module credentials against hostedInstanceDevURL */
  testDevApiModule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Test DFM credentials */
  testDfm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HostedMcLeodCredentialTestPayload = {
  __typename?: 'HostedMcLeodCredentialTestPayload';
  allPassed: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  results: Array<IntegrationCheckDetail>;
};

export type HostedMcLeodIntegrationHealthInput = {
  /** Carrier ID to test fetching a specific carrier */
  carrierId?: InputMaybe<Scalars['String']['input']>;
  /** Movement ID to test fetching a specific movement */
  movementId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type HostedMcLeodIntegrationHealthPayload = {
  __typename?: 'HostedMcLeodIntegrationHealthPayload';
  checks: Array<IntegrationCheckDetail>;
  failCount: Scalars['Float']['output'];
  organizationId: Scalars['ID']['output'];
  passCount: Scalars['Float']['output'];
  skipCount: Scalars['Float']['output'];
  warnCount: Scalars['Float']['output'];
};

/** Configuration for hot-load detection based on recent carrier offer activity. */
export type HotLoadConditionType = {
  __typename?: 'HotLoadConditionType';
  /** Minimum number of carrier offers required within the time window for this condition to match. */
  offerCountThreshold: Scalars['Int']['output'];
  /** Time window in minutes to look back for carrier offers. Defaults to 120. */
  timeWindowMinutes?: Maybe<Scalars['Int']['output']>;
};

export type HumanProfile = {
  __typename?: 'HumanProfile';
  /** Digits that can be typed into the numpad during a phone call to identify the user. */
  dtmfPin?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumber>;
  type: UserProfileType;
};

export type ImportCarrierCsvContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ImportCarrierCsvRowInput = {
  contacts: Array<ImportCarrierCsvContactInput>;
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownedEquipmentTypes?: InputMaybe<Scalars['String']['input']>;
};

export type ImportCarrierRowError = {
  __typename?: 'ImportCarrierRowError';
  message: Scalars['String']['output'];
  row: Scalars['Float']['output'];
};

export type ImportCarriersFromCsvInput = {
  rows: Array<ImportCarrierCsvRowInput>;
};

export type ImportCarriersFromCsvPayload = {
  __typename?: 'ImportCarriersFromCsvPayload';
  carriers: Array<ImportedCarrierResult>;
  errorCount: Scalars['Float']['output'];
  errors: Array<ImportCarrierRowError>;
  successCount: Scalars['Float']['output'];
  totalRows: Scalars['Float']['output'];
};

export type ImportShipmentInput = {
  payload: Scalars['JSON']['input'];
  source: ShipmentImportSource;
  updateReceivedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ImportShipmentPayload = {
  __typename?: 'ImportShipmentPayload';
  shipmentId: Scalars['String']['output'];
};

export type ImportTmsOrderInput = {
  data: Scalars['String']['input'];
  type: ExternalMessageType;
};

export type ImportTmsOrderPayload = {
  __typename?: 'ImportTmsOrderPayload';
  externalMessage?: Maybe<ExternalMessage>;
  success: Scalars['Boolean']['output'];
};

export type ImportedCarrierResult = {
  __typename?: 'ImportedCarrierResult';
  carrierId: Scalars['String']['output'];
  carrierName: Scalars['String']['output'];
  mcNumber?: Maybe<Scalars['String']['output']>;
};

export type InboundPhoneCallOverride = {
  __typename?: 'InboundPhoneCallOverride';
  active: Scalars['Boolean']['output'];
  forwardToPhoneNumber: Scalars['String']['output'];
};

export type InboundPhoneCallTriggerConfig = {
  __typename?: 'InboundPhoneCallTriggerConfig';
  override?: Maybe<InboundPhoneCallOverride>;
  phoneNumbers: Array<Scalars['String']['output']>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  testPhoneNumber?: Maybe<Scalars['String']['output']>;
  testPhoneNumberExpiresAt?: Maybe<Scalars['DateTimeISO']['output']>;
  triggerType: ActionTriggerConfigType;
};

export type IncomingApiRequest = AbstractEntity & Node & {
  __typename?: 'IncomingApiRequest';
  commonTerms?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  durationMs?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  method: RequestMethod;
  organization: Organization;
  queryParams?: Maybe<Scalars['String']['output']>;
  requestBody?: Maybe<Scalars['JSON']['output']>;
  responseBody?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

/** A tier that conditionally overrides the default increment amount based on carrier offer position and target price. */
export type IncrementTierType = {
  __typename?: 'IncrementTierType';
  /** When true, matches if the latest carrier offer exceeds the max price. When false, matches if the latest carrier offer is at or below the max price. */
  carrierOfferOverMax?: Maybe<Scalars['Boolean']['output']>;
  incrementAmount: Scalars['Float']['output'];
  targetPriceAtLeast?: Maybe<Scalars['Float']['output']>;
  targetPriceAtMost?: Maybe<Scalars['Float']['output']>;
};

export type IndividualVerificationResultType = {
  __typename?: 'IndividualVerificationResultType';
  carrierName: Scalars['String']['output'];
  carrierNotFound?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  integrationType: CarrierVerificationIntegrationType;
  matchedFailConditions: Array<Scalars['String']['output']>;
  matchedRiskConditions: Array<Scalars['String']['output']>;
  /** Structured representation Vooma extracts from the external API. Ops can reference these fields when authoring carrier verification rules. */
  parsedData?: Maybe<Scalars['JSON']['output']>;
  /** Unmodified payload returned by the external verification API. Ops uses this to identify fields that should be surfaced in the parsed representation. */
  rawData?: Maybe<Scalars['JSON']['output']>;
  result: CarrierVerificationSimulationResult;
};

/** Types of info that can be checked for the INFO_MISSING exception */
export enum InfoMissingCheckType {
  DRIVER_PHONE_MISSING = 'DRIVER_PHONE_MISSING'
}

/** When to evaluate INFO_MISSING relative to pickup milestones. Unset defaults to PRE_PICKUP. */
export enum InfoMissingEvaluateAt {
  PRE_DISPATCH = 'PRE_DISPATCH',
  PRE_PICKUP = 'PRE_PICKUP'
}

export type InfoMissingExceptionSettings = {
  __typename?: 'InfoMissingExceptionSettings';
  /** Which info fields to check. Exception fires if any are missing. */
  checks: Array<InfoMissingCheckType>;
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Phase when INFO_MISSING is evaluated. Defaults to PRE_PICKUP (legacy timing). Use PRE_DISPATCH to evaluate during the pre-dispatch window. */
  evaluateAt?: Maybe<InfoMissingEvaluateAt>;
  /** Minutes to suppress duplicate exception events of this type. When evaluateAt is PRE_DISPATCH and unset, defaults to 60. Unset with PRE_PICKUP (legacy) means no suppression. */
  suppressionPeriodMinutes?: Maybe<Scalars['Float']['output']>;
};

export type InfoMissingExceptionSettingsInput = {
  /** Which info fields to check. Exception fires if any are missing. */
  checks: Array<InfoMissingCheckType>;
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Phase when INFO_MISSING is evaluated. Defaults to PRE_PICKUP (legacy timing). Use PRE_DISPATCH to evaluate during the pre-dispatch window. */
  evaluateAt?: InputMaybe<InfoMissingEvaluateAt>;
  /** Minutes to suppress duplicate exception events of this type. When evaluateAt is PRE_DISPATCH and unset, defaults to 60. Unset with PRE_PICKUP (legacy) means no suppression. */
  suppressionPeriodMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export enum IngestableExternalDataType {
  CUSTOMERS = 'CUSTOMERS',
  USER_MAPPINGS = 'USER_MAPPINGS'
}

export type InitializeOrderTemplateForOriginatorInput = {
  originatorId: Scalars['ID']['input'];
};

export type InitializeOrderTemplateForOriginatorPayload = {
  __typename?: 'InitializeOrderTemplateForOriginatorPayload';
  template: Template;
};

export type InstantQuoteStopInput = {
  city: Scalars['String']['input'];
  /** Country code: US, CA, or MX. Defaults to US. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Date as YYYY-MM-DD. */
  date?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type InstructionMessageData = {
  __typename?: 'InstructionMessageData';
  eventDataType: ActionExecutionEventType;
  message: Scalars['String']['output'];
  sourceActionExecutionId?: Maybe<Scalars['ID']['output']>;
  sourceEventId?: Maybe<Scalars['ID']['output']>;
  sourceEventSubscriptionId?: Maybe<Scalars['ID']['output']>;
};

export type IntegrationCheckDetail = {
  __typename?: 'IntegrationCheckDetail';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: IntegrationCheckStatus;
};

export enum IntegrationCheckResult {
  FAILURE = 'FAILURE',
  PARTIAL = 'PARTIAL',
  SUCCESS = 'SUCCESS',
  UNCERTAIN = 'UNCERTAIN'
}

export enum IntegrationCheckStatus {
  FAIL = 'FAIL',
  PASS = 'PASS',
  SKIP = 'SKIP',
  WARN = 'WARN'
}

export type IntegrationCredentialsSummary = {
  __typename?: 'IntegrationCredentialsSummary';
  configPaths: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: IntegrationCredentialsType;
  usageIndicator: UsageIndicator;
};

/** The type of integration credentials. */
export enum IntegrationCredentialsType {
  ALJEX = 'ALJEX',
  ALVYS = 'ALVYS',
  AVRL = 'AVRL',
  BITFREIGHTER_RATING = 'BITFREIGHTER_RATING',
  BLUE_YONDER = 'BLUE_YONDER',
  COMPOSIO = 'COMPOSIO',
  COSTCO = 'COSTCO',
  DAT = 'DAT',
  DHL_FREIGHT = 'DHL_FREIGHT',
  DRAYRATES_RATING = 'DRAYRATES_RATING',
  DSDLINK = 'DSDLINK',
  DTS_RATING = 'DTS_RATING',
  E2OPEN = 'E2OPEN',
  ECHO = 'ECHO',
  FASTMORE = 'FASTMORE',
  FREIGHTPLUS = 'FREIGHTPLUS',
  FRONT = 'FRONT',
  GENLOGS = 'GENLOGS',
  GREENSCREENS = 'GREENSCREENS',
  HIGHWAY = 'HIGHWAY',
  HOSTED_MCLEOD = 'HOSTED_MCLEOD',
  LANDSTAR = 'LANDSTAR',
  LMCONNECT = 'LMCONNECT',
  LOADSMART_ALICE = 'LOADSMART_ALICE',
  MANHATTAN = 'MANHATTAN',
  MCLEOD = 'MCLEOD',
  MERCURYGATE = 'MERCURYGATE',
  MICROSOFT_GRAPH_APP_ONLY_AUTH = 'MICROSOFT_GRAPH_APP_ONLY_AUTH',
  MONTWAY = 'MONTWAY',
  MYCARRIERPORTAL = 'MYCARRIERPORTAL',
  NCR = 'NCR',
  NTG = 'NTG',
  OPENDOCK = 'OPENDOCK',
  OTHER = 'OTHER',
  PROD_REPLICA_SQL = 'PROD_REPLICA_SQL',
  PROJECT_44 = 'PROJECT_44',
  PROJECT_44_EU = 'PROJECT_44_EU',
  REVENOVA = 'REVENOVA',
  RMIS = 'RMIS',
  RYDERSHARE = 'RYDERSHARE',
  SAMSARA = 'SAMSARA',
  SLACK = 'SLACK',
  SOFTMODAL = 'SOFTMODAL',
  SONAR = 'SONAR',
  STRATEGY_LIVE = 'STRATEGY_LIVE',
  TABI = 'TABI',
  TAI = 'TAI',
  THREE_PL = 'THREE_PL',
  TRANSFIX_RATING = 'TRANSFIX_RATING',
  TRUCKSTOP = 'TRUCKSTOP',
  TURVO = 'TURVO',
  TWILIO = 'TWILIO',
  UBER_GTG = 'UBER_GTG',
  VOOMA_PUBLIC_API = 'VOOMA_PUBLIC_API',
  WORLDWIDE_LOGISTICS = 'WORLDWIDE_LOGISTICS',
  WWEX = 'WWEX',
  YARDVIEW = 'YARDVIEW'
}

export type IntegrationOptions = {
  integrationType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export enum IntegrationType {
  ALJEX = 'ALJEX',
  ALVYS = 'ALVYS',
  ARCBEST_TL_QUOTING = 'ARCBEST_TL_QUOTING',
  AVRL = 'AVRL',
  BITFREIGHTER_RATING = 'BITFREIGHTER_RATING',
  DAT = 'DAT',
  DFM = 'DFM',
  DHL_FREIGHT = 'DHL_FREIGHT',
  DRAYRATES_RATING = 'DRAYRATES_RATING',
  DTS_RATING = 'DTS_RATING',
  ECHO = 'ECHO',
  EVANS = 'EVANS',
  FASTMORE = 'FASTMORE',
  FREIGHTPLUS = 'FREIGHTPLUS',
  FRONT = 'FRONT',
  GENLOGS = 'GENLOGS',
  GOOGLE_WORKSPACE = 'GOOGLE_WORKSPACE',
  GREENSCREENS = 'GREENSCREENS',
  HIGHWAY = 'HIGHWAY',
  HOSTED_MCLEOD = 'HOSTED_MCLEOD',
  INTEGRATIONLESS = 'INTEGRATIONLESS',
  LANDSTAR = 'LANDSTAR',
  LEGACY_MERCURYGATE = 'LEGACY_MERCURYGATE',
  LOADSMART = 'LOADSMART',
  LOADSMART_ALICE = 'LOADSMART_ALICE',
  LOADSTOP = 'LOADSTOP',
  MACROPOINT = 'MACROPOINT',
  MACROPOINT_LINK_SCRAPING = 'MACROPOINT_LINK_SCRAPING',
  MCLEOD = 'MCLEOD',
  MERCURYGATE = 'MERCURYGATE',
  MICROSOFT = 'MICROSOFT',
  MICROSOFT_TEAMS = 'MICROSOFT_TEAMS',
  MODE = 'MODE',
  MONTWAY = 'MONTWAY',
  MOTIVE = 'MOTIVE',
  MYCARRIERPORTAL = 'MYCARRIERPORTAL',
  NFI = 'NFI',
  NTG = 'NTG',
  ORDERFUL = 'ORDERFUL',
  PROJECT_44 = 'PROJECT_44',
  PROJECT_44_EU = 'PROJECT_44_EU',
  REVENOVA = 'REVENOVA',
  SAMSARA = 'SAMSARA',
  SAMSARA_LINK_SCRAPING = 'SAMSARA_LINK_SCRAPING',
  SLACK = 'SLACK',
  SOFTMODAL = 'SOFTMODAL',
  SONAR = 'SONAR',
  STEDI = 'STEDI',
  STRATEGY_LIVE = 'STRATEGY_LIVE',
  SUNSET = 'SUNSET',
  TABI = 'TABI',
  TAI = 'TAI',
  TEST = 'TEST',
  THREE_PL = 'THREE_PL',
  TRANSFIX = 'TRANSFIX',
  TRANSFIX_RATING = 'TRANSFIX_RATING',
  TRUCKER_TOOLS = 'TRUCKER_TOOLS',
  TRUCKSTOP = 'TRUCKSTOP',
  TURVO = 'TURVO',
  UBER_GTG = 'UBER_GTG',
  VOOMA_PUBLIC_API = 'VOOMA_PUBLIC_API',
  WERNER = 'WERNER',
  WORLDWIDE_LOGISTICS = 'WORLDWIDE_LOGISTICS',
  WWEX = 'WWEX'
}

export type IntegrationVerificationEvent = AbstractEntity & Node & {
  __typename?: 'IntegrationVerificationEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<IntegrationVerificationEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: IntegrationVerificationEventType;
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type IntegrationVerificationEventData = {
  __typename?: 'IntegrationVerificationEventData';
  credentialType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<IntegrationType>;
  success: Scalars['Boolean']['output'];
};

export enum IntegrationVerificationEventType {
  INTEGRATION_VERIFICATION = 'INTEGRATION_VERIFICATION'
}

export type IntegrationVerificationEventsInput = {
  credentialType?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type InviteUserToOrganizationInput = {
  email: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  role?: InputMaybe<OrganizationUserRole>;
  skipNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteUserToOrganizationPayload = {
  __typename?: 'InviteUserToOrganizationPayload';
  organizationUserRelation: OrganizationUserRelation;
  success: Scalars['Boolean']['output'];
};

export type Job = AbstractEntity & Node & {
  __typename?: 'Job';
  buildHint?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  documents: Array<JobDocument>;
  /** Serialized as JSON */
  emailMetadata?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  jobDocuments: Array<JobDocument>;
  jobEvents: Array<JobEvent>;
  jobType?: Maybe<JobType>;
  notes?: Maybe<Scalars['String']['output']>;
  optimismStatus: OptimismStatus;
  orders: Array<Order>;
  organization: Organization;
  originator?: Maybe<Originator>;
  quotes: Array<Quote>;
  redactedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  relatedCanonicalQuotes: Array<Quote>;
  source: JobSource;
  status: ProcessingStatus;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export type JobActionExecutionAssocation = AbstractEntity & Node & {
  __typename?: 'JobActionExecutionAssocation';
  actionExecution: ActionExecution;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  job: Job;
  organization: Organization;
  source: Job;
  target: ActionExecution;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum JobConfirmationFilterStatus {
  ALL = 'ALL',
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED'
}

export type JobConnection = {
  __typename?: 'JobConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobEdge>;
  nodes?: Maybe<Array<Job>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum JobCreationPolicy {
  ALWAYS_CREATE_NEW = 'ALWAYS_CREATE_NEW',
  DO_NOT_RECREATE = 'DO_NOT_RECREATE'
}

export enum JobCreationResultingAction {
  CREATED_NEW_JOB = 'CREATED_NEW_JOB',
  FAILED_TO_CREATE_JOB = 'FAILED_TO_CREATE_JOB',
  RETURNED_EXISTING_JOB = 'RETURNED_EXISTING_JOB',
  SKIPPED_FOR_SOP = 'SKIPPED_FOR_SOP'
}

export type JobDateFilter = {
  /** List Job that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List Job that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List Job that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List Job that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type JobDocument = AbstractEntity & Node & {
  __typename?: 'JobDocument';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<JobDocumentType>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  upload?: Maybe<JobDocumentUpload>;
};

export enum JobDocumentType {
  EMAIL = 'EMAIL',
  OTHER = 'OTHER'
}

export type JobDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'JobDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type JobEdge = {
  __typename?: 'JobEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Job;
};

/** An event related to a job. */
export type JobEvent = AbstractEntity & Node & {
  __typename?: 'JobEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  type: JobEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum JobEventType {
  AI_PROCESSING_COMPLETED = 'AI_PROCESSING_COMPLETED',
  AI_PROCESSING_FAILED = 'AI_PROCESSING_FAILED',
  AI_PROCESSING_STARTED = 'AI_PROCESSING_STARTED',
  AI_PROCESSING_TRIGGERED = 'AI_PROCESSING_TRIGGERED',
  CREATED_OPTIMISTICALLY = 'CREATED_OPTIMISTICALLY',
  ORIGINATOR_RESOLUTION_FAILED = 'ORIGINATOR_RESOLUTION_FAILED',
  ORIGINATOR_RESOLUTION_SUCCEEDED = 'ORIGINATOR_RESOLUTION_SUCCEEDED',
  PREPROCESSED_QUOTES = 'PREPROCESSED_QUOTES',
  USER_CONFIRMED = 'USER_CONFIRMED'
}

export enum JobSource {
  ACTION_EXECUTION = 'ACTION_EXECUTION',
  DEPRECATED_EMAIL_MONITORING = 'DEPRECATED_EMAIL_MONITORING',
  DEPRECATED_EMAIL_MONITORING_SHORT_CIRCUIT = 'DEPRECATED_EMAIL_MONITORING_SHORT_CIRCUIT',
  FORWARDED_EMAIL = 'FORWARDED_EMAIL',
  FRONT = 'FRONT',
  FRONT_EMAIL_MONITORING = 'FRONT_EMAIL_MONITORING',
  GMAIL = 'GMAIL',
  GMAIL_EMAIL_MONITORING = 'GMAIL_EMAIL_MONITORING',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  OUTLOOK = 'OUTLOOK',
  OUTLOOK_EMAIL_MONITORING = 'OUTLOOK_EMAIL_MONITORING',
  OUTLOOK_EMAIL_MONITORING_SHORT_CIRCUIT = 'OUTLOOK_EMAIL_MONITORING_SHORT_CIRCUIT',
  UNKNOWN = 'UNKNOWN',
  VMAIL_TEST_MESSAGE = 'VMAIL_TEST_MESSAGE',
  WEBAPP = 'WEBAPP'
}

export enum JobType {
  ORDERS = 'ORDERS',
  QUOTES = 'QUOTES'
}

export enum JobUpdateFailureReason {
  JOB_DELETED = 'JOB_DELETED'
}

export type JobsInput = {
  dateFilter?: InputMaybe<JobDateFilter>;
  excludedJobTypes?: InputMaybe<Array<JobType>>;
  filterUnconfirmedJobs?: InputMaybe<Scalars['Boolean']['input']>;
  frontFilter?: InputMaybe<FrontFilter>;
  gmailFilter?: InputMaybe<GmailFilter>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  outlookFilter?: InputMaybe<OutlookFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type KnowledgeBase = AbstractEntity & Node & {
  __typename?: 'KnowledgeBase';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  documents: Array<KnowledgeBaseDocumentUpload>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type KnowledgeBaseConnection = {
  __typename?: 'KnowledgeBaseConnection';
  count: Scalars['Int']['output'];
  edges: Array<KnowledgeBaseEdge>;
  nodes?: Maybe<Array<KnowledgeBase>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type KnowledgeBaseDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'KnowledgeBaseDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subject: KnowledgeBase;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeBaseEdge = {
  __typename?: 'KnowledgeBaseEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: KnowledgeBase;
};

export type KnowledgeBasesInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum LabelTag {
  CONTROVERSIAL = 'CONTROVERSIAL',
  ENG_REVIEWED = 'ENG_REVIEWED',
  IMPORTANT = 'IMPORTANT',
  INTERESTING = 'INTERESTING',
  RANDOM = 'RANDOM'
}

export type LabeledComputation = AbstractEntity & Node & {
  __typename?: 'LabeledComputation';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<LabeledComputationData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['JSON']['output']>;
  labelTags?: Maybe<Array<LabelTag>>;
  labeledDataUrl: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  savedComputation: SavedComputation;
  source: LabeledComputationSource;
  type?: Maybe<LabeledComputationType>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type LabeledComputationConnection = {
  __typename?: 'LabeledComputationConnection';
  count: Scalars['Int']['output'];
  edges: Array<LabeledComputationEdge>;
  nodes?: Maybe<Array<LabeledComputation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LabeledComputationData = {
  __typename?: 'LabeledComputationData';
  computationType: SavedComputationType;
  functionName: Scalars['String']['output'];
  inputs: Scalars['JSONObject']['output'];
  label?: Maybe<Scalars['JSON']['output']>;
  labelTags?: Maybe<Array<LabelTag>>;
  notes?: Maybe<Scalars['String']['output']>;
  source?: Maybe<LabeledComputationSource>;
  timestamp: Scalars['DateTimeISO']['output'];
};

export type LabeledComputationDataInput = {
  computationType: SavedComputationType;
  functionName: Scalars['String']['input'];
  inputs: Scalars['JSONObject']['input'];
  label?: InputMaybe<Scalars['JSON']['input']>;
  labelTags?: InputMaybe<Array<LabelTag>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LabeledComputationSource>;
  timestamp: Scalars['DateTimeISO']['input'];
};

export type LabeledComputationEdge = {
  __typename?: 'LabeledComputationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: LabeledComputation;
};

export enum LabeledComputationSource {
  INFERRED_FROM_USER_ACTION = 'INFERRED_FROM_USER_ACTION',
  MANUALLY_CREATED = 'MANUALLY_CREATED',
  RANDOMLY_SELECTED = 'RANDOMLY_SELECTED',
  UNKNOWN = 'UNKNOWN'
}

export enum LabeledComputationType {
  ADDRESS_PARSE = 'ADDRESS_PARSE',
  BUILD_ALL_QUOTES = 'BUILD_ALL_QUOTES',
  BUILD_ALL_QUOTES_COMPLETE = 'BUILD_ALL_QUOTES_COMPLETE',
  BUILD_ORDER = 'BUILD_ORDER',
  DECIDE_IGNORE_MESSAGE = 'DECIDE_IGNORE_MESSAGE',
  DECIDE_MESSAGE_ACTION = 'DECIDE_MESSAGE_ACTION',
  EMAIL_CLASSIFICATION = 'EMAIL_CLASSIFICATION',
  ENTITY_DISCRIMINATION = 'ENTITY_DISCRIMINATION',
  FILTER_AND_SELECT_ORIGINATOR = 'FILTER_AND_SELECT_ORIGINATOR',
  INFER_MISSING_ADDRESS_COMPONENT = 'INFER_MISSING_ADDRESS_COMPONENT',
  LOCATION_MATCH = 'LOCATION_MATCH',
  ORIGINATOR_RESOLUTION = 'ORIGINATOR_RESOLUTION',
  RESOLVE_ORIGINATOR_AND_CONTACT = 'RESOLVE_ORIGINATOR_AND_CONTACT',
  TEMPLATE_COMPLETION = 'TEMPLATE_COMPLETION'
}

export type LabeledComputationsInput = {
  computationTypes?: InputMaybe<Array<SavedComputationType>>;
  externalMessageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labelTypes?: InputMaybe<Array<LabeledComputationType>>;
  labeledComputationClasses?: InputMaybe<Array<Scalars['String']['input']>>;
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quoteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedComputationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sources?: InputMaybe<Array<LabeledComputationSource>>;
};

export type LaneCarrier = {
  __typename?: 'LaneCarrier';
  avgOfferedRate?: Maybe<Scalars['Float']['output']>;
  carrierId: Scalars['ID']['output'];
  carrierName: Scalars['String']['output'];
  runCount: Scalars['Int']['output'];
};

export type LaneCarrierCount = {
  __typename?: 'LaneCarrierCount';
  avgAcceptedRate?: Maybe<Scalars['Float']['output']>;
  carriers: Array<LaneCarrier>;
  destinationCity?: Maybe<Scalars['String']['output']>;
  destinationLat: Scalars['Float']['output'];
  destinationLon: Scalars['Float']['output'];
  movementCount: Scalars['Int']['output'];
  originCity?: Maybe<Scalars['String']['output']>;
  originLat: Scalars['Float']['output'];
  originLon: Scalars['Float']['output'];
};

export type LaneCarrierRatesInput = {
  /** Lookback period in days (default: 90) */
  lookbackDays?: InputMaybe<Scalars['Float']['input']>;
  /** The movement ID to derive the lane from */
  movementId: Scalars['ID']['input'];
  /** Search radius in miles (default: 50) */
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type LaneFilter = {
  destination?: InputMaybe<GeoCircle>;
  origin?: InputMaybe<GeoCircle>;
};

export type LaneHistoryInput = {
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type LaneHistoryPayload = {
  __typename?: 'LaneHistoryPayload';
  lanes: Array<LaneCarrierCount>;
};

export type LanePreference = AbstractEntity & Node & {
  __typename?: 'LanePreference';
  carrierIds: Array<Scalars['String']['output']>;
  carriers: Array<Carrier>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  equipmentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  preferredLane: PreferredLane;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export type LanePreferencePayload = {
  __typename?: 'LanePreferencePayload';
  lanePreference: LanePreference;
  success: Scalars['Boolean']['output'];
};

export type LanePreferencesForShipmentPayload = {
  __typename?: 'LanePreferencesForShipmentPayload';
  lanePreferences: Array<LanePreference>;
  preferredLane?: Maybe<PreferredLane>;
};

export type LaneRateResult = {
  __typename?: 'LaneRateResult';
  /** Confidence score (0-100) for Greenscreens */
  confidence?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  maxRate?: Maybe<Scalars['Float']['output']>;
  midpointRate?: Maybe<Scalars['Float']['output']>;
  minRate?: Maybe<Scalars['Float']['output']>;
  provider: LaneRatingProvider;
  /** Number of reports for DAT */
  reportCount?: Maybe<Scalars['Float']['output']>;
};

export enum LaneRatingProvider {
  DAT = 'DAT',
  GREENSCREENS = 'GREENSCREENS',
  HIGHWAY_TFX = 'HIGHWAY_TFX'
}

export type LatLng = {
  __typename?: 'LatLng';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type LeaveTeamInput = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type LeaveTeamPayload = {
  __typename?: 'LeaveTeamPayload';
  success: Scalars['Boolean']['output'];
};

export type LegacyAgentBackstoryConfig = {
  __typename?: 'LegacyAgentBackstoryConfig';
  agentBackstory: Scalars['String']['output'];
  agentVoiceId?: Maybe<Scalars['String']['output']>;
  type: WorkersConfigType;
};

export type LiftUsageBlockInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum LineageFetchPolicy {
  ALL = 'ALL',
  FIRST_OF_LINEAGE_ONLY = 'FIRST_OF_LINEAGE_ONLY'
}

export type ListAgentMailDomainsPayload = {
  __typename?: 'ListAgentMailDomainsPayload';
  domains: Array<AgentMailDomain>;
};

export type ListComposioAuthTokensInput = {
  organizationId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListComposioAuthTokensPayload = {
  __typename?: 'ListComposioAuthTokensPayload';
  authTokens: Array<AuthToken>;
  success: Scalars['Boolean']['output'];
};

export type ListComposioToolKitsInput = {
  authTokenId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ListComposioToolKitsPayload = {
  __typename?: 'ListComposioToolKitsPayload';
  success: Scalars['Boolean']['output'];
  toolKits: Array<ComposioToolKitInfo>;
};

export type ListComposioToolsInput = {
  authTokenId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  toolKitSlug: Scalars['String']['input'];
};

export type ListComposioToolsPayload = {
  __typename?: 'ListComposioToolsPayload';
  success: Scalars['Boolean']['output'];
  tools: Array<ComposioToolInfo>;
};

export type ListErrorGroupsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<ErrorIncidentSource>;
  status?: InputMaybe<ErrorGroupStatus>;
};

export type ListIntegrationCredentialsInput = {
  organizationId: Scalars['ID']['input'];
};

export enum LlmName {
  CLAUDE_2_0 = 'CLAUDE_2_0',
  CLAUDE_2_1 = 'CLAUDE_2_1',
  CLAUDE_3_5_SONNET = 'CLAUDE_3_5_SONNET',
  CLAUDE_3_7_SONNET = 'CLAUDE_3_7_SONNET',
  CLAUDE_3_OPUS = 'CLAUDE_3_OPUS',
  CLAUDE_3_SONNET = 'CLAUDE_3_SONNET',
  CLAUDE_4_5_HAIKU = 'CLAUDE_4_5_HAIKU',
  CLAUDE_4_5_SONNET = 'CLAUDE_4_5_SONNET',
  CLAUDE_4_6_OPUS = 'CLAUDE_4_6_OPUS',
  CLAUDE_4_6_SONNET = 'CLAUDE_4_6_SONNET',
  CLAUDE_4_7_OPUS = 'CLAUDE_4_7_OPUS',
  CLAUDE_4_8_OPUS = 'CLAUDE_4_8_OPUS',
  CLAUDE_4_OPUS = 'CLAUDE_4_OPUS',
  CLAUDE_4_SONNET = 'CLAUDE_4_SONNET',
  CLAUDE_5_5_OPUS = 'CLAUDE_5_5_OPUS',
  GEMINI_2_5_FLASH_LITE = 'GEMINI_2_5_FLASH_LITE',
  GEMINI_2_5_PRO = 'GEMINI_2_5_PRO',
  GEMINI_3_PRO_PREVIEW = 'GEMINI_3_PRO_PREVIEW',
  GLM_5_2 = 'GLM_5_2',
  GPT_3_5_TURBO = 'GPT_3_5_TURBO',
  GPT_3_5_TURBO_16K = 'GPT_3_5_TURBO_16K',
  GPT_3_5_TURBO_INSTRUCT = 'GPT_3_5_TURBO_INSTRUCT',
  GPT_4 = 'GPT_4',
  GPT_4O = 'GPT_4O',
  GPT_4O_MINI = 'GPT_4O_MINI',
  GPT_4_1 = 'GPT_4_1',
  GPT_4_1_MINI = 'GPT_4_1_MINI',
  GPT_5 = 'GPT_5',
  GPT_5_2 = 'GPT_5_2',
  GPT_5_4 = 'GPT_5_4',
  GPT_5_5 = 'GPT_5_5',
  GPT_5_6_LUNA = 'GPT_5_6_LUNA',
  GPT_5_6_SOL = 'GPT_5_6_SOL',
  GPT_5_6_TERRA = 'GPT_5_6_TERRA',
  GPT_5_MINI = 'GPT_5_MINI',
  GPT_5_NANO = 'GPT_5_NANO',
  GPT_6_1_SOL = 'GPT_6_1_SOL',
  GPT_6_1_TERRA = 'GPT_6_1_TERRA',
  GPT_6_ASTRA = 'GPT_6_ASTRA',
  GPT_6_LUNA = 'GPT_6_LUNA',
  GPT_6_SOL = 'GPT_6_SOL',
  O4_MINI = 'O4_MINI'
}

export enum LlmProvider {
  ANTHROPIC = 'ANTHROPIC',
  FIREWORKS = 'FIREWORKS',
  GOOGLE = 'GOOGLE',
  OPENAI = 'OPENAI'
}

export type LlmRequest = AbstractEntity & Node & {
  __typename?: 'LlmRequest';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type LlmRequestRecordInput = {
  cacheReadTokens: Scalars['Int']['input'];
  cacheWriteTokens: Scalars['Int']['input'];
  externalMessageId?: InputMaybe<Scalars['ID']['input']>;
  /** Prompt tokens not read from the cache. Providers that report a prompt total including cached tokens need the cached count subtracted. */
  freshInputTokens: Scalars['Int']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  model: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  outputTokens: Scalars['Int']['input'];
  provider: LlmProvider;
  /** Output tokens spent on reasoning, as a subset of outputTokens. */
  reasoningTokens?: InputMaybe<Scalars['Int']['input']>;
  /** When the model responded. Send it rather than relying on the row creation time, which reflects when the batch arrived. */
  respondedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** When the model call was sent. */
  startedAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  task: Scalars['String']['input'];
};

export type LoadBoardPosting = {
  __typename?: 'LoadBoardPosting';
  externalId: Scalars['String']['output'];
  integrationType: IntegrationType;
  postingUrl?: Maybe<Scalars['String']['output']>;
};

export type LoadException = {
  __typename?: 'LoadException';
  data?: Maybe<Scalars['JSON']['output']>;
  type: LoadExceptionType;
};

export enum LoadExceptionType {
  INFO_MISSING = 'INFO_MISSING',
  INVALID_STOP_TIMES = 'INVALID_STOP_TIMES',
  INVALID_TRACKING_LINK = 'INVALID_TRACKING_LINK',
  MISSING_ARRIVAL = 'MISSING_ARRIVAL',
  NEEDS_LOCATION_UPDATE = 'NEEDS_LOCATION_UPDATE',
  NOT_YET_DISPATCHED = 'NOT_YET_DISPATCHED',
  POTENTIALLY_CORRUPTED_TRACKING_DATA = 'POTENTIALLY_CORRUPTED_TRACKING_DATA',
  POTENTIAL_DETENTION = 'POTENTIAL_DETENTION',
  RUNNING_LATE = 'RUNNING_LATE',
  RUNNING_LATE_CLOSE_TO_DELIVERY = 'RUNNING_LATE_CLOSE_TO_DELIVERY',
  RUNNING_LATE_CLOSE_TO_PICKUP = 'RUNNING_LATE_CLOSE_TO_PICKUP',
  TRACKING_DATA_NOT_AVAILABLE = 'TRACKING_DATA_NOT_AVAILABLE',
  TRACKING_DATA_STALE = 'TRACKING_DATA_STALE',
  UNKNOWN = 'UNKNOWN',
  VEHICLE_IS_NOT_MOVING = 'VEHICLE_IS_NOT_MOVING'
}

export type LoadPutOnHoldData = {
  __typename?: 'LoadPutOnHoldData';
  eventType: MovementEventType;
};

export type LoadTakenOffHoldData = {
  __typename?: 'LoadTakenOffHoldData';
  eventType: MovementEventType;
};

export type Location = {
  __typename?: 'Location';
  /** Main address, typically contains street and building number. Ex: 1234 Main Street. */
  addressOne?: Maybe<Scalars['String']['output']>;
  /** Optional address line 2, typically used for apartment/suite number. */
  addressTwo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type LocationAddressFilter = {
  addressOne?: InputMaybe<Scalars['String']['input']>;
  addressTwo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LocationAddressInput = {
  addressOne: Scalars['String']['input'];
  addressTwo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type LocationImportAllOriginatorsPayload = {
  __typename?: 'LocationImportAllOriginatorsPayload';
  success: Scalars['Boolean']['output'];
};

export type LogLlmRequestsInput = {
  records: Array<LlmRequestRecordInput>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type LookupFmcsaCarrierContactInput = {
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Mailbox = AbstractEntity & Node & {
  __typename?: 'Mailbox';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
};

export type ManagedResource = AbstractEntity & Node & {
  __typename?: 'ManagedResource';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fallbackResource?: Maybe<ManagedResource>;
  fallbackResourceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  provider?: Maybe<ManagedResourceProvider>;
  status: ManagedResourceStatus;
  type: ManagedResourceType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ManagedResourceInput = {
  id: Scalars['ID']['input'];
};

export type ManagedResourcePayload = {
  __typename?: 'ManagedResourcePayload';
  managedResource: ManagedResource;
};

export enum ManagedResourceProvider {
  ANTHROPIC = 'ANTHROPIC',
  DEEPGRAM = 'DEEPGRAM',
  ELEVENLABS = 'ELEVENLABS',
  FIREWORKS = 'FIREWORKS',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  OPENAI = 'OPENAI',
  VOOMA = 'VOOMA'
}

export enum ManagedResourceStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum ManagedResourceType {
  COMPUTER_VISION = 'COMPUTER_VISION',
  LLM = 'LLM',
  STT = 'STT',
  TTS = 'TTS'
}

export type MarkConversationReadInput = {
  conversationId: Scalars['ID']['input'];
  throughMessageId: Scalars['ID']['input'];
};

export type MarkConversationReadPayload = {
  __typename?: 'MarkConversationReadPayload';
  success: Scalars['Boolean']['output'];
};

export type MarketConditionsInput = {
  id: Scalars['ID']['input'];
};

export type MarketConditionsPayload = {
  __typename?: 'MarketConditionsPayload';
  equipmentType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  integrationType: IntegrationType;
  marketConditions: Array<StopMarketConditions>;
  stop?: Maybe<Scalars['JSON']['output']>;
};

export type MassDeleteShipmentsAndMovementsInput = {
  shipmentOrMovements: Array<DeleteShipmentOrMovementInput>;
};

export type MassDeleteShipmentsAndMovementsPayload = {
  __typename?: 'MassDeleteShipmentsAndMovementsPayload';
  success: Scalars['Boolean']['output'];
};

export type MassPostToLoadBoardInput = {
  postings: Array<PostToLoadBoardInput>;
};

export type MassPostToLoadBoardPayload = {
  __typename?: 'MassPostToLoadBoardPayload';
  results: Array<PostToLoadBoardPayload>;
};

export type MassUnpostFromLoadBoardInput = {
  postings: Array<UnpostFromLoadBoardInput>;
};

export type MassUnpostFromLoadBoardPayload = {
  __typename?: 'MassUnpostFromLoadBoardPayload';
  results: Array<UnpostFromLoadBoardPayload>;
};

export type MaterializedSopBuild = AbstractEntity & Node & {
  __typename?: 'MaterializedSopBuild';
  basePromptVersionId: Scalars['ID']['output'];
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  startedFromBuildId?: Maybe<Scalars['ID']['output']>;
  status: MaterializedSopBuildStatus;
  step?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum MaterializedSopBuildStatus {
  FAILED = 'FAILED',
  PASSED = 'PASSED',
  RUNNING = 'RUNNING'
}

export type MaterializedSopState = {
  __typename?: 'MaterializedSopState';
  basePrompt?: Maybe<BasePrompt>;
  basePromptConfig?: Maybe<Scalars['JSON']['output']>;
  builds: Array<MaterializedSopBuild>;
  isBehind: Scalars['Boolean']['output'];
  labelEvaluationId?: Maybe<Scalars['ID']['output']>;
  preferMaterializedPrompt: Scalars['Boolean']['output'];
  publishedBuild?: Maybe<MaterializedSopBuild>;
};

export type MaterializedSopToolChangeInput = {
  setting?: InputMaybe<Scalars['String']['input']>;
  tool: Scalars['String']['input'];
};

export type McVerificationPairInput = {
  dotNumber?: InputMaybe<Scalars['String']['input']>;
  expectedResult?: InputMaybe<CarrierVerificationSimulationResult>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MemoriesInput = {
  actionDefinitionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  computationTypes?: InputMaybe<Array<SavedComputationType>>;
  contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contactMethodIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFilter?: InputMaybe<MemoryDateFilter>;
  organizationIds: Array<Scalars['ID']['input']>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type Memory = AbstractEntity & Node & {
  __typename?: 'Memory';
  comment?: Maybe<Scalars['String']['output']>;
  computationType?: Maybe<SavedComputationType>;
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entityLinks?: Maybe<Array<MemoryEntityLink>>;
  id: Scalars['ID']['output'];
  labeledComputation?: Maybe<LabeledComputation>;
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MemoryConnection = {
  __typename?: 'MemoryConnection';
  count: Scalars['Int']['output'];
  edges: Array<MemoryEdge>;
  nodes?: Maybe<Array<Memory>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MemoryData = {
  __typename?: 'MemoryData';
  comment: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MemoryDateFilter = {
  /** List Memory that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List Memory that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List Memory that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List Memory that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type MemoryEdge = {
  __typename?: 'MemoryEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Memory;
};

export type MemoryEntityLink = AbstractEntity & Node & {
  __typename?: 'MemoryEntityLink';
  actionDefinition?: Maybe<ActionDefinition>;
  actionDefinitionId?: Maybe<Scalars['String']['output']>;
  carrier?: Maybe<Carrier>;
  carrierId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<ContactMethodRecord>;
  contactMethodId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  memory: Memory;
  memoryId: Scalars['String']['output'];
  movement?: Maybe<Movement>;
  movementId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  originator?: Maybe<Originator>;
  originatorId?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Place>;
  placeId?: Maybe<Scalars['String']['output']>;
  quote?: Maybe<Quote>;
  quoteId?: Maybe<Scalars['String']['output']>;
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MemoryRecalledData = {
  __typename?: 'MemoryRecalledData';
  eventDataType: ActionExecutionEventType;
  memories: Array<MemoryData>;
};

export type MergeGenericTransformationTemplatePayload = {
  __typename?: 'MergeGenericTransformationTemplatePayload';
  /** Number of inheriting transformations that were updated. */
  mergedCount: Scalars['Int']['output'];
};

export type MessageEntityAssociation = AbstractEntity & Node & {
  __typename?: 'MessageEntityAssociation';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  externalMessage: ExternalMessage;
  externalMessageId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  quote?: Maybe<Quote>;
  scores?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageEntityAssociationConnection = {
  __typename?: 'MessageEntityAssociationConnection';
  count: Scalars['Int']['output'];
  edges: Array<MessageEntityAssociationEdge>;
  nodes?: Maybe<Array<MessageEntityAssociation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageEntityAssociationEdge = {
  __typename?: 'MessageEntityAssociationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: MessageEntityAssociation;
};

export type MessageEntityAssociationsInput = {
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityTypes?: InputMaybe<Array<TemplateType>>;
  messageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MessageOrderAssociation = AbstractEntity & Node & {
  __typename?: 'MessageOrderAssociation';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  externalMessage: ExternalMessage;
  externalMessageId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  quote?: Maybe<Quote>;
  scores?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageQuoteAssociation = AbstractEntity & Node & {
  __typename?: 'MessageQuoteAssociation';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  externalMessage: ExternalMessage;
  externalMessageId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  quote: Quote;
  scores?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MessageQuoteAssociationConnection = {
  __typename?: 'MessageQuoteAssociationConnection';
  count: Scalars['Int']['output'];
  edges: Array<MessageQuoteAssociationEdge>;
  nodes?: Maybe<Array<MessageQuoteAssociation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageQuoteAssociationEdge = {
  __typename?: 'MessageQuoteAssociationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: MessageQuoteAssociation;
};

export type MessageQuoteAssociationsInput = {
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MessageRating = AbstractEntity & Node & {
  __typename?: 'MessageRating';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  isPositive: Scalars['Boolean']['output'];
  messageId: Scalars['ID']['output'];
  organization: Organization;
  reason?: Maybe<MessageRatingReason>;
  /** Integer from 0 to 10 (inclusive) */
  starRating: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type MessageRatingPayload = {
  __typename?: 'MessageRatingPayload';
  rating: MessageRating;
};

/** The issue a user picked when rating a Vee reply bad */
export enum MessageRatingReason {
  DIDNT_DO_WHAT_I_ASKED = 'DIDNT_DO_WHAT_I_ASKED',
  ERROR_OR_BUG = 'ERROR_OR_BUG',
  INCOMPLETE_ANSWER = 'INCOMPLETE_ANSWER',
  OTHER = 'OTHER',
  TOOK_THE_WRONG_ACTION = 'TOOK_THE_WRONG_ACTION',
  WRONG_INFORMATION = 'WRONG_INFORMATION'
}

export type MetroLane = {
  __typename?: 'MetroLane';
  avgAcceptedRate?: Maybe<Scalars['Float']['output']>;
  carriers: Array<MetroLaneCarrier>;
  destinationIsMetro: Scalars['Boolean']['output'];
  destinationLabel: Scalars['String']['output'];
  destinationLat: Scalars['Float']['output'];
  destinationLon: Scalars['Float']['output'];
  movementCount: Scalars['Int']['output'];
  originIsMetro: Scalars['Boolean']['output'];
  originLabel: Scalars['String']['output'];
  originLat: Scalars['Float']['output'];
  originLon: Scalars['Float']['output'];
};

export type MetroLaneCarrier = {
  __typename?: 'MetroLaneCarrier';
  avgOfferedRate?: Maybe<Scalars['Float']['output']>;
  carrierId: Scalars['ID']['output'];
  carrierName: Scalars['String']['output'];
  runCount: Scalars['Int']['output'];
};

export type MetroLaneHistoryInput = {
  destinationCity?: InputMaybe<Scalars['String']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  originCity?: InputMaybe<Scalars['String']['input']>;
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type MetroLaneHistoryPayload = {
  __typename?: 'MetroLaneHistoryPayload';
  lanes: Array<MetroLane>;
};

export type MicrosoftMailboxRegistrationInput = {
  address: Scalars['String']['input'];
  ownerId: Scalars['ID']['input'];
};

export type MicrosoftMailboxRegistrationResult = {
  __typename?: 'MicrosoftMailboxRegistrationResult';
  address: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  mailboxId?: Maybe<Scalars['ID']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
};

export type MicrosoftMailboxSubscriptionInput = {
  mailboxId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MicrosoftMailboxSubscriptionPayload = {
  __typename?: 'MicrosoftMailboxSubscriptionPayload';
  address?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  mailboxId: Scalars['ID']['output'];
  /** Microsoft Graph subscription currently recorded for the mailbox */
  subscriptionId?: Maybe<Scalars['String']['output']>;
};

export type MicrosoftTeamsConversationMetadata = {
  __typename?: 'MicrosoftTeamsConversationMetadata';
  participantUserIds: Array<Scalars['String']['output']>;
  teamsConversationType: Scalars['String']['output'];
};

export enum MicrosoftTeamsMessageSource {
  CHANNEL = 'CHANNEL',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE'
}

export type MicrosoftTeamsMessageTriggerConfig = {
  __typename?: 'MicrosoftTeamsMessageTriggerConfig';
  override?: Maybe<BaseTriggerOverride>;
  respondToAnyChannelMessage?: Maybe<Scalars['Boolean']['output']>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  teamsChannelIds?: Maybe<Array<Scalars['String']['output']>>;
  teamsSources: Array<MicrosoftTeamsMessageSource>;
  triggerType: ActionTriggerConfigType;
};

export type MilestoneAfterSettings = {
  __typename?: 'MilestoneAfterSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minutesAfter?: Maybe<Scalars['Float']['output']>;
};

export type MilestoneAfterSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minutesAfter?: InputMaybe<Scalars['Float']['input']>;
};

/** Strategy for when a pickup or delivery's AFTER milestone fires. */
export enum MilestoneAfterTrigger {
  ADVANCED = 'ADVANCED',
  MINUTES_AFTER = 'MINUTES_AFTER'
}

export type MilestoneAfterTriggerParams = {
  __typename?: 'MilestoneAfterTriggerParams';
  /** ADVANCED: offset for appointments (stop start equals stop end). */
  appointment?: Maybe<AdvancedTriggerOffset>;
  /** MINUTES_AFTER: minutes past the stop window end to check. */
  minutesAfter?: Maybe<Scalars['Float']['output']>;
  /** ADVANCED: offsets by stop window duration. Shared by every milestone that supports ADVANCED. */
  windowTiers?: Maybe<Array<AdvancedTriggerWindowTier>>;
};

export type MilestoneAfterTriggerParamsInput = {
  /** ADVANCED: offset for appointments (stop start equals stop end). */
  appointment?: InputMaybe<AdvancedTriggerOffsetInput>;
  /** MINUTES_AFTER: minutes past the stop window end to check. */
  minutesAfter?: InputMaybe<Scalars['Float']['input']>;
  /** ADVANCED: offsets by stop window duration. Shared by every milestone that supports ADVANCED. */
  windowTiers?: InputMaybe<Array<AdvancedTriggerWindowTierInput>>;
};

export type MilestoneAfterTriggerSettings = {
  __typename?: 'MilestoneAfterTriggerSettings';
  enabled: Scalars['Boolean']['output'];
  /** Required for an enabled ADVANCED trigger. */
  params?: Maybe<MilestoneAfterTriggerParams>;
  triggerType: MilestoneAfterTrigger;
};

export type MilestoneAfterTriggerSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  /** Required for an enabled ADVANCED trigger. */
  params?: InputMaybe<MilestoneAfterTriggerParamsInput>;
  triggerType: MilestoneAfterTrigger;
};

export type MilestoneAtSettings = {
  __typename?: 'MilestoneAtSettings';
  delayMinutes?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type MilestoneAtSettingsInput = {
  delayMinutes?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Strategy for when a pickup or delivery's AT milestone fires. */
export enum MilestoneAtTrigger {
  ADVANCED = 'ADVANCED',
  DELAY = 'DELAY'
}

export type MilestoneAtTriggerParams = {
  __typename?: 'MilestoneAtTriggerParams';
  /** ADVANCED: offset for appointments (stop start equals stop end). */
  appointment?: Maybe<AdvancedTriggerOffset>;
  /** DELAY: minutes after the stop time to start checking. */
  delayMinutes?: Maybe<Scalars['Float']['output']>;
  /** ADVANCED: offsets by stop window duration. Shared by every milestone that supports ADVANCED. */
  windowTiers?: Maybe<Array<AdvancedTriggerWindowTier>>;
};

export type MilestoneAtTriggerParamsInput = {
  /** ADVANCED: offset for appointments (stop start equals stop end). */
  appointment?: InputMaybe<AdvancedTriggerOffsetInput>;
  /** DELAY: minutes after the stop time to start checking. */
  delayMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** ADVANCED: offsets by stop window duration. Shared by every milestone that supports ADVANCED. */
  windowTiers?: InputMaybe<Array<AdvancedTriggerWindowTierInput>>;
};

export type MilestoneAtTriggerSettings = {
  __typename?: 'MilestoneAtTriggerSettings';
  enabled: Scalars['Boolean']['output'];
  /** Required for an enabled ADVANCED trigger. */
  params?: Maybe<MilestoneAtTriggerParams>;
  triggerType: MilestoneAtTrigger;
};

export type MilestoneAtTriggerSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  /** Required for an enabled ADVANCED trigger. */
  params?: InputMaybe<MilestoneAtTriggerParamsInput>;
  triggerType: MilestoneAtTrigger;
};

export type MilestoneBeforeSettings = {
  __typename?: 'MilestoneBeforeSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minutesBefore?: Maybe<Scalars['Float']['output']>;
};

export type MilestoneBeforeSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minutesBefore?: InputMaybe<Scalars['Float']['input']>;
};

/** Strategy for when a stop's BEFORE milestone fires on stops with a time window. */
export enum MilestoneBeforeTrigger {
  ADAPTIVE = 'ADAPTIVE',
  ADVANCED = 'ADVANCED',
  DELAYED = 'DELAYED',
  NEAR_END = 'NEAR_END',
  START = 'START',
  START_NO_OFFSET = 'START_NO_OFFSET',
  TWO_HOURS_AFTER_START = 'TWO_HOURS_AFTER_START'
}

export type MilestoneBeforeTriggerSettings = {
  __typename?: 'MilestoneBeforeTriggerSettings';
  enabled: Scalars['Boolean']['output'];
  /** Required for an enabled ADVANCED trigger. When minutesBefore is unset, the appointment lead time is used for pre-dispatch and INFO_MISSING timing. */
  params?: Maybe<AdvancedTriggerParams>;
  triggerType: MilestoneBeforeTrigger;
};

export type MilestoneBeforeTriggerSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  /** Required for an enabled ADVANCED trigger. When minutesBefore is unset, the appointment lead time is used for pre-dispatch and INFO_MISSING timing. */
  params?: InputMaybe<AdvancedTriggerParamsInput>;
  triggerType: MilestoneBeforeTrigger;
};

export type ModelConfig = {
  __typename?: 'ModelConfig';
  computerVisionModel?: Maybe<ComputerVisionModelName>;
  documentInterpretationModel?: Maybe<LlmName>;
  groupByFields?: Maybe<Array<Scalars['String']['output']>>;
  multiOrderBuildStrategy?: Maybe<MultiOrderBuildStrategy>;
  replicationModel?: Maybe<LlmName>;
};

export type ModelConfigInput = {
  computerVisionModel?: InputMaybe<ComputerVisionModelName>;
  documentInterpretationModel?: InputMaybe<LlmName>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  multiOrderBuildStrategy?: InputMaybe<MultiOrderBuildStrategy>;
  replicationModel?: InputMaybe<LlmName>;
};

export type MonthlyCommitChange = {
  __typename?: 'MonthlyCommitChange';
  monthlyCommitCents: Scalars['Int']['output'];
  startsAt: Scalars['DateTimeISO']['output'];
  tierAlias: Scalars['String']['output'];
};

export type MoveUserToOrganizationsInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  userId: Scalars['String']['input'];
};

export type MoveUserToOrganizationsPayload = {
  __typename?: 'MoveUserToOrganizationsPayload';
  success: Scalars['Boolean']['output'];
};

/** A movement of a good as part of a possibly intermodal shipment. */
export type Movement = AbstractEntity & Node & {
  __typename?: 'Movement';
  attributes?: Maybe<Scalars['JSON']['output']>;
  carrierRate?: Maybe<CarrierRate>;
  carrierRates: Array<CarrierRate>;
  /** Vee chats started about this movement */
  chatConversations: Array<Conversation>;
  commodity?: Maybe<Scalars['String']['output']>;
  conversations: Array<Conversation>;
  coveragePlans: Array<MovementCoveragePlan>;
  coverageStatus?: Maybe<CoverageStatus>;
  createdAt: Scalars['DateTimeISO']['output'];
  currentCoveragePlan?: Maybe<MovementCoveragePlan>;
  customerRate?: Maybe<Scalars['Float']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  details?: Maybe<Scalars['JSON']['output']>;
  firstPickupTime?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  inquiryCount: Scalars['Int']['output'];
  isTrackingPaused: Scalars['Boolean']['output'];
  laneHistoryRadiusMiles: Scalars['Int']['output'];
  lastDeliveryTime?: Maybe<Scalars['DateTimeISO']['output']>;
  latestDynamoStatus?: Maybe<MovementDynamoStatus>;
  linkedDocuments: Array<MovementLinkedDocument>;
  linkedPartyMessages: Array<MovementLinkedMessage>;
  maskedMovementData?: Maybe<Scalars['JSON']['output']>;
  movementEvents: Array<MovementEvent>;
  negotiationStrategyConfigOverride?: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  pricing?: Maybe<MovementPricing>;
  seq: Scalars['Int']['output'];
  shipment: Shipment;
  shipperThreadId?: Maybe<Scalars['String']['output']>;
  stops?: Maybe<Array<Stop>>;
  tmsStatus?: Maybe<Scalars['String']['output']>;
  trackData?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementCarrierChangedData = {
  __typename?: 'MovementCarrierChangedData';
  eventType: MovementEventType;
  from?: Maybe<CarrierSnapshot>;
  to: CarrierSnapshot;
};

export type MovementCarrierContact = {
  __typename?: 'MovementCarrierContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MovementCarrierConversationAssociation = AbstractEntity & Node & {
  __typename?: 'MovementCarrierConversationAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  conversation: Conversation;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  source: Movement;
  target: Conversation;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementConnection = {
  __typename?: 'MovementConnection';
  count: Scalars['Int']['output'];
  edges: Array<MovementEdge>;
  nodes?: Maybe<Array<Movement>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MovementConversationParty {
  CARRIER = 'CARRIER',
  SHIPPER = 'SHIPPER'
}

export type MovementCoveragePlan = AbstractEntity & Node & {
  __typename?: 'MovementCoveragePlan';
  createdAt: Scalars['DateTimeISO']['output'];
  currentRevisionId?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  exceptionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  revisions: Array<MovementCoveragePlanRevision>;
  status: MovementCoveragePlanStatus;
  stopReason?: Maybe<Scalars['String']['output']>;
  stoppedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementCoveragePlanAction = AbstractEntity & Node & {
  __typename?: 'MovementCoveragePlanAction';
  carrierOutreach?: Maybe<CarrierOutreach>;
  carrierOutreachId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  plannedAction: Scalars['JSON']['output'];
  revision: MovementCoveragePlanRevision;
  seq: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementCoveragePlanIdsPayload = {
  __typename?: 'MovementCoveragePlanIdsPayload';
  mappings: Array<MovementCoveragePlanMapping>;
};

export type MovementCoveragePlanMapping = {
  __typename?: 'MovementCoveragePlanMapping';
  coveragePlanId: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
};

export type MovementCoveragePlanRevision = AbstractEntity & Node & {
  __typename?: 'MovementCoveragePlanRevision';
  actions: Array<MovementCoveragePlanAction>;
  autonomyStatus: AutonomyState;
  coveragePlan: MovementCoveragePlan;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  notificationStrategy?: Maybe<Scalars['JSON']['output']>;
  organization: Organization;
  revision: Scalars['Int']['output'];
  shouldVerifyCarriers: Scalars['Boolean']['output'];
  transferStrategy: Scalars['JSON']['output'];
  trigger: MovementCoveragePlanRevisionTrigger;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  verificationPolicies?: Maybe<Scalars['JSON']['output']>;
};

export enum MovementCoveragePlanRevisionTrigger {
  AGENT = 'AGENT',
  BROKER_FEEDBACK = 'BROKER_FEEDBACK',
  PUBLIC_API = 'PUBLIC_API',
  READY_EVENT = 'READY_EVENT',
  SCHEDULED_PASS = 'SCHEDULED_PASS'
}

export enum MovementCoveragePlanStatus {
  ACTIVE = 'ACTIVE',
  STOPPED = 'STOPPED'
}

export type MovementDocumentAssociation = AbstractEntity & Node & {
  __typename?: 'MovementDocumentAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  document: Document;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  source: Movement;
  target: Document;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementDynamoStatus = {
  __typename?: 'MovementDynamoStatus';
  city?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export type MovementEdge = {
  __typename?: 'MovementEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Movement;
};

export type MovementEvent = AbstractEntity & Node & {
  __typename?: 'MovementEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<MovementEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Shipment;
  name: MovementEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type MovementEventCreatedTriggerConfig = {
  __typename?: 'MovementEventCreatedTriggerConfig';
  eventTypes: Array<MovementEventType>;
  exceptionTypes?: Maybe<Array<LoadExceptionType>>;
  originatorIds?: Maybe<Array<Scalars['String']['output']>>;
  override?: Maybe<BaseTriggerOverride>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  trackingMilestoneTypes?: Maybe<Array<TrackingMilestoneType>>;
  triggerType: ActionTriggerConfigType;
};

export type MovementEventData = AllAppointmentsConfirmedData | CarrierInquiryData | CoverOfferAcceptedData | CoverOfferData | CoveredData | ExceptionCreatedData | ExceptionResolvedData | ExceptionTriggerSuppressedData | LoadPutOnHoldData | LoadTakenOffHoldData | MovementCarrierChangedData | MovementStatusChangedData | NotReadyForCoverageData | PostedToLoadBoardData | PrePickupDelayStartedData | ReadyForCoverageData | RefreshedPostingOnLoadBoardData | RequestedPostToLoadBoardData | RequestedUnpostFromLoadBoardData | StopArrivedData | StopClearedData | StopEtaUpdatedData | TrackingMilestoneData | TrackingMilestoneSkippedData | TrackingPausedData | UnpostedFromLoadBoardData | UpdatedPostingOnLoadBoardData | WebhookReceivedData;

export enum MovementEventType {
  ALL_APPOINTMENTS_CONFIRMED = 'ALL_APPOINTMENTS_CONFIRMED',
  CARRIER_CHANGED = 'CARRIER_CHANGED',
  CARRIER_INQUIRY = 'CARRIER_INQUIRY',
  COVERED = 'COVERED',
  COVER_OFFER = 'COVER_OFFER',
  COVER_OFFER_ACCEPTED = 'COVER_OFFER_ACCEPTED',
  EXCEPTION_CREATED = 'EXCEPTION_CREATED',
  EXCEPTION_RESOLVED = 'EXCEPTION_RESOLVED',
  EXCEPTION_TRIGGER_SUPPRESSED = 'EXCEPTION_TRIGGER_SUPPRESSED',
  LOAD_PUT_ON_HOLD = 'LOAD_PUT_ON_HOLD',
  LOAD_TAKEN_OFF_HOLD = 'LOAD_TAKEN_OFF_HOLD',
  NOT_READY_FOR_COVERAGE = 'NOT_READY_FOR_COVERAGE',
  POSTED_TO_LOAD_BOARD = 'POSTED_TO_LOAD_BOARD',
  PRE_PICKUP_DELAY_STARTED = 'PRE_PICKUP_DELAY_STARTED',
  READY_FOR_COVERAGE = 'READY_FOR_COVERAGE',
  REFRESHED_POSTING_ON_LOAD_BOARD = 'REFRESHED_POSTING_ON_LOAD_BOARD',
  REQUESTED_POST_TO_LOAD_BOARD = 'REQUESTED_POST_TO_LOAD_BOARD',
  REQUESTED_UNPOST_FROM_LOAD_BOARD = 'REQUESTED_UNPOST_FROM_LOAD_BOARD',
  STATUS_CHANGED = 'STATUS_CHANGED',
  STOP_ARRIVED = 'STOP_ARRIVED',
  STOP_CLEARED = 'STOP_CLEARED',
  STOP_ETA_UPDATED = 'STOP_ETA_UPDATED',
  TRACKING_MILESTONE = 'TRACKING_MILESTONE',
  TRACKING_MILESTONE_SKIPPED = 'TRACKING_MILESTONE_SKIPPED',
  TRACKING_PAUSED = 'TRACKING_PAUSED',
  UNPOSTED_FROM_LOAD_BOARD = 'UNPOSTED_FROM_LOAD_BOARD',
  UPDATED_POSTING_ON_LOAD_BOARD = 'UPDATED_POSTING_ON_LOAD_BOARD',
  WEBHOOK_RECEIVED = 'WEBHOOK_RECEIVED'
}

export type MovementExceptionAssociation = AbstractEntity & Node & {
  __typename?: 'MovementExceptionAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  exception: Exception;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  source: Movement;
  target: Exception;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementLinkedDocument = {
  __typename?: 'MovementLinkedDocument';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  uploadedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MovementLinkedMessage = {
  __typename?: 'MovementLinkedMessage';
  message: ExternalMessage;
  parties: Array<MovementConversationParty>;
};

export type MovementPricing = {
  __typename?: 'MovementPricing';
  maxPrice?: Maybe<Scalars['Float']['output']>;
  targetPrice?: Maybe<Scalars['Float']['output']>;
};

export type MovementPricingInput = {
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  targetPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type MovementQuoteAssociation = AbstractEntity & Node & {
  __typename?: 'MovementQuoteAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  quote: Quote;
  source: Movement;
  target: Quote;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementShipperConversationAssociation = AbstractEntity & Node & {
  __typename?: 'MovementShipperConversationAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  conversation: Conversation;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  source: Movement;
  target: Conversation;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum MovementStatus {
  AT_DELIVERY = 'AT_DELIVERY',
  AT_PICKUP = 'AT_PICKUP',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED',
  DISPATCH = 'DISPATCH',
  IN_TRANSIT = 'IN_TRANSIT',
  READY_FOR_DISPATCH = 'READY_FOR_DISPATCH',
  UNKNOWN = 'UNKNOWN'
}

export type MovementStatusChangedData = {
  __typename?: 'MovementStatusChangedData';
  coverageStatus?: Maybe<CoverageStatus>;
  eventType: MovementEventType;
  fromStatus?: Maybe<MovementStatus>;
  tmsStatus?: Maybe<Scalars['String']['output']>;
  toStatus: MovementStatus;
};

export type MovementStop = AbstractEntity & Node & {
  __typename?: 'MovementStop';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  lifecycle?: Maybe<Scalars['JSON']['output']>;
  movement: Movement;
  organization: Organization;
  place: Place;
  seq: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementTeamAssociation = AbstractEntity & Node & {
  __typename?: 'MovementTeamAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  source: Movement;
  target: Team;
  team: Team;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MovementWithTrackSettings = {
  __typename?: 'MovementWithTrackSettings';
  corruptedTrackingExceptionId?: Maybe<Scalars['ID']['output']>;
  customerNames: Array<Scalars['String']['output']>;
  hasTrackSettings: Scalars['Boolean']['output'];
  /** True when the movement has a Track profile but doesn't meet the organization's conditional tracking rules, so Vooma isn't tracking it. */
  isExcludedFromTracking: Scalars['Boolean']['output'];
  latestTrackStatus?: Maybe<Scalars['String']['output']>;
  movement: Movement;
  openExceptionTypes: Array<Scalars['String']['output']>;
  primaryResponsibleParty?: Maybe<ResponsibleParty>;
};

export type MovementsToCoverInput = {
  organizationId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

export type MultLevelNotificationSettings = {
  __typename?: 'MultLevelNotificationSettings';
  ORGANIZATION: Scalars['JSON']['output'];
  TEAM?: Maybe<Scalars['JSON']['output']>;
  USER?: Maybe<Scalars['JSON']['output']>;
};

export enum MultiOrderBuildStrategy {
  BUILD_ONE_AND_REPLICATE = 'BUILD_ONE_AND_REPLICATE',
  INTELLIGENT_PARTITIONING = 'INTELLIGENT_PARTITIONING',
  ONE_ORDER_PER_PAGE = 'ONE_ORDER_PER_PAGE',
  ONE_ORDER_PER_PDF = 'ONE_ORDER_PER_PDF',
  PARTITION_CSV = 'PARTITION_CSV'
}

export type MultipleWorkersConfig = {
  __typename?: 'MultipleWorkersConfig';
  type: WorkersConfigType;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCarriersToLanePreference: LanePreferencePayload;
  addChatMessageToConversation: AddChatMessageToConversationPayload;
  addDocumentToJob: AddDocumentToJobPayload;
  addDocumentToOrder: AddDocumentToOrderPayload;
  addUserToOrganization: AddUserToOrganizationPayload;
  addWorkerToActionDefinition: AddWorkerToActionDefinitionPayload;
  applyClassificationRules: ApplyClassificationRulesPayload;
  /** Replaces the organization's generic rule of the template's type with a copy of the template. */
  applyGenericTransformationTemplate: ApplyGenericTransformationTemplatePayload;
  approveSchedulePlan: SchedulePlan;
  auditDATAutoposts: AuditDatAutopostsPayload;
  auditDATShipmentPostings: AuditDatShipmentPostingsPayload;
  backfillConversationLabels: BackfillConversationLabelsPayload;
  buildShipment: BuildShipmentPayload;
  bulkCreateContacts: BulkCreateContactPayload;
  bulkCreateContactsDirect: BulkCreateContactPayload;
  bulkCreateOriginators: BulkCreateOriginatorsPayload;
  bulkCreatePlaces: BulkCreatePlacesPayload;
  bulkDeleteJobs: BulkDeleteJobsPayload;
  bulkDeleteOrders: BulkDeleteOrdersPayload;
  bulkDeleteOriginators: BulkDeleteOriginatorsPayload;
  bulkDeletePlaces: BulkDeletePlacesPayload;
  bulkDeleteQuotes: BulkDeleteQuotesPayload;
  bulkInviteUsersToOrganization: BulkInviteUsersToOrganizationPayload;
  cancelActionExecution: PokeActionExecutionPayload;
  cancelSchedulePlan: SchedulePlan;
  changeActionExecutionAutonomyState: ChangeActionExecutionAutonomyStatePayload;
  changeActionExecutionStatus: ChangeActionExecutionAutonomyStatePayload;
  changeMonthlyCommit: MonthlyCommitChange;
  cloneActionDefinition: CloneActionDefinitionPayload;
  /** Resolve or dismiss an operational issue */
  closeOperationalIssue: Scalars['Boolean']['output'];
  completeMicrosoftGraphConnect: CompleteMicrosoftGraphConnectPayload;
  computeLaneRates: ComputeLaneRatesPayload;
  computeRates: ComputeRatesPayload;
  configureOrderTemplate: ConfigureOrderTemplatePayload;
  connectWorkerComposioAccount?: Maybe<Scalars['String']['output']>;
  contactCarrierToCollectLoadBid: ContactCarrierToCollectLoadBidPayload;
  continueTeamsConnection: ContinueTeamsConnectionPayload;
  copyJobToComplementary: CopyJobToComplementaryPayload;
  createActionBehavior: ActionBehavior;
  createActionDefinition: CreateActionDefinitionPayload;
  createActionTrigger: CreateActionTriggerPayload;
  /** Create or return an AgentMail inbox for a worker. */
  createAgentMailInbox: CreateAgentMailInboxPayload;
  createApiClient: CreateApiClientPayload;
  createAuthToken: CreateAuthTokenPayload;
  createAwkwardMomentLabel: CreateAwkwardMomentLabelResult;
  createBlankDocumentInKnowledgeBase: CreateBlankDocumentInKnowledgeBasePayload;
  createBlankRichTextDocumentUpload: CreateBlankRichTextDocumentUploadPayload;
  createBraintrustDataset: CreateBraintrustDatasetResult;
  createCarrierByIdentifier: CreateCarrierByIdentifierPayload;
  createCarrierRate: CreateCarrierRatePayload;
  createContact: CreateContactPayload;
  createCoveragePlan: CoveragePlanPayload;
  createCoveragePlanFromCarrierContactList: CoveragePlanPayload;
  createCustomerDocumentsInKnowledgeBase: CreateCustomerDocumentsInKnowledgeBasePayload;
  createCustomerRate: CreateCustomerRatePayload;
  createEvent: CreateBaseEventPayload;
  createException: Exception;
  createExternalChannel: CreateExternalChannelPayload;
  createExternalIdMapping?: Maybe<CreateExternalIdMappingPayload>;
  createExternalMessageJob: CreateExternalMessageJobPayload;
  createFakeTrackingMilestones: CreateFakeTrackingMilestonesPayload;
  createFeatureFlag: FeatureFlagPayload;
  createFeatureFlags: FeatureFlagsPayload;
  createFreightDataMapping: CreateFreightDataMappingPayload;
  createFreightDataMappings: CreateFreightDataMappingsPayload;
  createFrontJob: CreateJobPayload;
  createFrontMailboxSubscriptions: CreateFrontMailboxSubscriptionsPayload;
  createFrontReplyAll: CreateFrontReplyAllPayload;
  createGenericRule: CreateGenericRulePayload;
  createGenericTransformation: GenericTransformationMutationPayload;
  createGenericTransformationTemplate: GenericTransformationTemplatePayload;
  createGlobalPrompt: GlobalPromptPayload;
  createGmailJob: CreateJobPayload;
  createGmailReplyAll: CreateGmailReplyAllPayload;
  createInstantQuote: CreateQuotePayload;
  createJob: CreateJobPayload;
  createJobEvent: CreateJobEventPayload;
  createKnowledgeBase: CreateKnowledgeBasePayload;
  createLabeledComputation: CreateLabeledComputationPayload;
  createLanePreference: LanePreferencePayload;
  createManagedResource: ManagedResourcePayload;
  createMemory: CreateMemoryPayload;
  createMemoryEntityLink: CreateMemoryEntityLinkPayload;
  createMessageQuoteAssociation: CreateMessageQuoteAssociationPayload;
  createNegotiationStrategy: NegotiationStrategyPayload;
  createNewConversationWithConcierge: CreateNewConversationWithConciergePayload;
  createNewConversationWithLabelingConcierge: CreateNewConversationWithConciergePayload;
  createOrUpdateComposioAuthToken: CreateOrUpdateComposioAuthTokenPayload;
  createOrUpdateExternalIdMapping: CreateOrUpdateExternalIdMappingPayload;
  createOrUpdateIntegrationCredentials: CreateOrUpdateIntegrationCredentialsPayload;
  createOrder: CreateOrderPayload;
  createOrderEvent: CreateOrderEventPayload;
  createOrganization: CreateOrganizationPayload;
  createOrganizationUserRelation: CreateOrganizationUserRelationPayload;
  createOriginator: CreateOriginatorPayload;
  createOriginatorEvent: CreateOriginatorEventPayload;
  createOriginatorsReport: CreateOriginatorsReportPayload;
  createOutlookJob: CreateJobPayload;
  createOutlookReplyAll: CreateOutlookReplyAllPayload;
  createPlace: CreatePlacePayload;
  createPlaceSchedulingMethod: PlaceSchedulingPayload;
  createPricingStrategy: CreatePricingStrategyPayload;
  createQuote: CreateQuotePayload;
  createQuoteEvent: CreateQuoteEventPayload;
  createQuoteNote: CreateQuoteNotePayload;
  createQuotesReport: CreateQuotesReportPayload;
  createRating: CreateRatingPayload;
  createSavedComputation: CreateSavedComputationPayload;
  createSavedView: CreateSavedViewPayload;
  createScheduleSettings: ScheduleSettings;
  createSharedFile: CreateSharedFilePayload;
  createTeam: CreateTeamPayload;
  createTeamMember: CrateTeamMemberPayload;
  createTemplate: CreateTemplatePayload;
  createTrackSettings: TrackSettings;
  createTrackingExceptionEvent: CreateTrackingExceptionEventPayload;
  createTrackingMilestoneEvent: CreateTrackingMilestoneEventPayload;
  createTranscriptionLabel: CreateTranscriptionLabelResult;
  createTransformationConfig: CreateTransformationConfigPayload;
  createTransformationDefinition: CreateTransformationDefinitionPayload;
  createTurnTakingLabel: CreateTurnTakingLabelResult;
  createWebhookSubscription: CreateWebhookSubscriptionPayload;
  createWorker: CreateWorkerPayload;
  createWorkflow: CreateWorkflowPayload;
  deleteAIPhoneNumber: DeleteAiPhoneNumberPayload;
  deleteActionBehavior: Scalars['Boolean']['output'];
  deleteActionDefinition: DeleteActionDefinitionPayload;
  deleteActionDefinitionDocument: DeleteActionDefinitionDocumentPayload;
  deleteActionDefinitionTeamGlobalPromptValues: DeleteActionDefinitionTeamGlobalPromptValuesPayload;
  deleteActionTrigger: DeleteActionTriggerPayload;
  deleteApiClient: DeleteApiClientPayload;
  deleteAuthToken: DeleteAuthTokenPayload;
  deleteCarrierRate: DeleteCarrierRatePayload;
  deleteContact: DeleteContactPayload;
  deleteCoveragePlan: DeleteCoveragePlanPayload;
  deleteCustomerRate: DeleteCustomerRatePayload;
  deleteDocumentInKnowledgeBase: DeleteDocumentInKnowledgeBasePayload;
  deleteExternalChannel: DeleteExternalChannelPayload;
  deleteFreightDataMapping: DeleteFreightDataMappingPayload;
  deleteFrontMailboxSubscriptions: DeleteFrontMailboxSubscriptionsPayload;
  deleteGenericRule: DeleteGenericRulePayload;
  deleteGenericTransformation: GenericTransformationMutationPayload;
  deleteGenericTransformationTemplate: DeleteGenericTransformationTemplatePayload;
  deleteGlobalPrompt: Scalars['Boolean']['output'];
  deleteIntegrationCredentials: DeleteIntegrationCredentialsPayload;
  deleteJob: DeleteJobPayload;
  deleteJobDocument: DeleteJobDocumentPayload;
  deleteKnowledgeBaseById: DeleteKnowledgeBasePayload;
  deleteLabeledComputation: DeleteLabeledComputationPayload;
  deleteLanePreference: DeleteLanePreferencePayload;
  deleteManagedResource: DeleteManagedResourcePayload;
  deleteMemory: DeleteMemoryPayload;
  deleteMemoryEntityLink: DeleteMemoryEntityLinkPayload;
  deleteNegotiationStrategy: DeleteNegotiationStrategyPayload;
  deleteOrder: DeleteOrderPayload;
  deleteOrganizationJob: DeleteOrganizationJobPayload;
  deleteOriginator: DeleteOriginatorPayload;
  deletePlace: DeletePlacePayload;
  deletePlaceSchedulingMethod: PlaceSchedulingPayload;
  deletePricingStrategy: DeletePricingStrategyPayload;
  deleteQuote: DeleteQuotePayload;
  deleteSavedView: Scalars['Boolean']['output'];
  deleteScheduleSettings: Scalars['Boolean']['output'];
  deleteSharedFile: DeleteSharedFilePayload;
  deleteTeam: DeleteTeamPayload;
  deleteTeamMember: DeleteTeamMemberPayload;
  deleteTemplate: DeleteTemplatePayload;
  deleteTrackSettings: Scalars['Boolean']['output'];
  deleteTransformationConfig: DeleteTransformationConfigPayload;
  deleteTransformationDefinition: DeleteTransformationDefinitionPayload;
  deleteWebhookSubscription: DeleteWebhookSubscriptionPayload;
  deleteWorker: DeleteWorkerPayload;
  deleteWorkerAuthToken: DeleteAuthTokenPayload;
  deleteWorkflow: DeleteWorkflowPayload;
  diffActionDefinitionNaturalLanguageProcedure: DiffActionDefinitionNaturalLanguageProcedurePayload;
  disableTMSIntegrationVerification: Scalars['Boolean']['output'];
  discardMaterializedSopBuild: MaterializedSopState;
  disconnectWorkerComposio: Scalars['Boolean']['output'];
  dismissConversationExceptions: Scalars['Boolean']['output'];
  enableTMSIntegrationVerification: EnableTmsIntegrationVerificationPayload;
  ensureFrontExternalMessage: Scalars['ID']['output'];
  ensureOutlookExternalMessage: Scalars['ID']['output'];
  ensureShipmentExistsForQuote: EnsureShipmentExistsForQuotePayload;
  evaluateGlobalPromptBehaviors: RunGlobalPromptEvaluationResult;
  executeCheckpoint: ExecuteCheckpointResult;
  executeCoveragePlan: ExecuteCoveragePlanPayload;
  executeTool: ExecuteToolResult;
  extractBuildAccuracyResults: ExtractBuildAccuracyResultsPayload;
  findDuplicate: FindDuplicatePayload;
  findOrCreateDATHistoryRates: DatHistoryRatesPayload;
  findOrCreateMarketConditions: Array<MarketConditionsPayload>;
  flagOriginator: FlagOriginatorPayload;
  generateBuildAccuracyReport: GenerateBuildAccuracyReportPayload;
  generateSchedulePlan: SchedulePlan;
  generateShipmentLifecycleSimShipment: GenerateShipmentLifecycleSimShipmentPayload;
  handleExternalMessageClassifiedAndAssociated: HandleExternalMessageClassifiedAndAssociatedPayload;
  handleNewAssistantEmail: HandleNewAssistantEmailPayload;
  handleNewTrackingEmail: HandleNewTrackingEmailPayload;
  importCarriersFromCsv: ImportCarriersFromCsvPayload;
  importShipment: ImportShipmentPayload;
  importTmsOrder: ImportTmsOrderPayload;
  initializeOrderTemplateForOriginator: InitializeOrderTemplateForOriginatorPayload;
  inviteUserToOrganization: InviteUserToOrganizationPayload;
  leaveTeam: LeaveTeamPayload;
  liftUsageBlock: Array<UsageBlockSummary>;
  /** Records LLM calls made outside the API, such as in the vooma lambdas. Returns the number of rows written. */
  logLlmRequests: Scalars['Int']['output'];
  logout: LogoutResponse;
  markConversationRead: MarkConversationReadPayload;
  massDeleteShipmentsAndMovements: MassDeleteShipmentsAndMovementsPayload;
  massPostToLoadBoard?: Maybe<MassPostToLoadBoardPayload>;
  massUnpostFromLoadBoard: MassUnpostFromLoadBoardPayload;
  /** Copies the current template definition into every transformation that inherits from it. */
  mergeGenericTransformationTemplate: MergeGenericTransformationTemplatePayload;
  messageActionExecution: PokeActionExecutionPayload;
  moveUserToOrganizations: MoveUserToOrganizationsPayload;
  onboardNewOriginator: OnboardNewOriginatorPayload;
  page: Scalars['Boolean']['output'];
  pokeActionExecution: PokeActionExecutionPayload;
  postToLoadBoard?: Maybe<PostToLoadBoardPayload>;
  proposeFreightDataMappingValues: ProposeFreightDataMappingValuesPayload;
  proposeGlobalPromptSopAlignment: ProposeGlobalPromptSopAlignmentPayload;
  provisionAIPhoneNumber: ProvisionAiPhoneNumberPayload;
  provisionBrowserUseDemo: ProvisionBrowserUseDemoPayload;
  provisionConciergeSOP: ProvisionConciergeSopPayload;
  provisionCoverForTeam: ProvisionCoverForTeamPayload;
  provisionCoverSimulations: ProvisionCoverSimulationsPayload;
  provisionFakeTrackMovement: CreateFakeTrackMovementPayload;
  provisionForQA: ProvisionForQaPayload;
  provisionInterview: ProvisionInterviewPayload;
  provisionLabelingConcierge: ProvisionLabelingConciergePayload;
  provisionQuoteForOrg: ProvisionQuoteForOrgPayload;
  provisionQuoteForTeam: ProvisionQuoteForTeamPayload;
  provisionQuoteOriginators: ProvisionQuoteOriginatorsPayload;
  provisionQuoteSimulations: ProvisionQuoteSimulationsPayload;
  provisionRunners: ProvisionRunnersPayload;
  provisionSchedule: ProvisionSchedulePayload;
  provisionShareCoveragePlanSop: ProvisionShareCoveragePlanSopPayload;
  provisionTrack: ProvisionTrackPayload;
  provisionVee: ProvisionVeePayload;
  provisionVoomaBuildAgent: ProvisionVoomaBuildAgentPayload;
  publishMaterializedSopBuild: MaterializedSopState;
  rateMessage: MessageRatingPayload;
  reassignQuoteOwner: ReassignQuoteOwnerPayload;
  recoverMemory: RecoverMemoryPayload;
  redactOrganizationData: RedactOrganizationDataPayload;
  refreshAuthTokenForUser: Scalars['Boolean']['output'];
  refreshFrontOrganizationId: RefreshFrontOrganizationIdPayload;
  refreshOrderEntities: RefreshOrderEntitiesPayload;
  refreshPostingOnLoadBoard: UnpostFromLoadBoardPayload;
  refreshQuoteMileage: RefreshQuoteMileagePayload;
  refreshSubscriptions: RefreshSubscriptionsPayload;
  refreshWorkerComposioAccount: Scalars['String']['output'];
  registerMicrosoftMailboxes: RegisterMicrosoftMailboxesPayload;
  removeCarriersFromLanePreference: LanePreferencePayload;
  removeMessageRating: RemoveMessageRatingPayload;
  removeOrganizationLogo: Organization;
  removeSenderFromOriginator: RemoveSenderFromOriginatorPayload;
  removeUserFromOrganization: RemoveUserFromOrganizationPayload;
  removeWorkerFromActionDefinition: RemoveWorkerFromActionDefinitionPayload;
  renameDocumentInKnowledgeBase: RenameDocumentInKnowledgeBasePayload;
  renameKnowledgeBase: RenameKnowledgeBasePayload;
  renameSharedFile: RenameSharedFilePayload;
  repeatOrder: RepeatOrderPayload;
  replicateOrder: ReplicateOrderPayload;
  reprocessJob: ReprocessJobPayload;
  reprocessOrder: ReprocessOrderPayload;
  requestConversationCc: RequestConversationCcPayload;
  reserveTestPhoneNumber: ReserveTestPhoneNumberPayload;
  resolveCorruptedTrackingException: Scalars['Boolean']['output'];
  resolveSkillChangeRequest: Scalars['Boolean']['output'];
  resolveTrackSettingsChangeRequest: Scalars['Boolean']['output'];
  rollOutGlobalPromptFromCode: RollOutFromCodePayload;
  runActionBehavior: ActionBehavior;
  runBuildAccuracySamples: RunBuildAccuracySamplesPayload;
  runCoverEvals: RunCoverEvalsResult;
  runManagedResourceCanary: RunManagedResourceCanaryPayload;
  runSkillChangeTests: Scalars['Boolean']['output'];
  saveBasePromptConfig: MaterializedSopState;
  saveConversationSnapshotToDataset: SaveConversationSnapshotToDatasetResult;
  saveMessageRatingDetails: MessageRatingPayload;
  saveRowToDataset: SaveRowToDatasetResult;
  seedCoverDemoData: SeedCoverDemoDataPayload;
  seedVeeDemoData: SeedVeeDemoDataPayload;
  selectQuickReply: Scalars['Boolean']['output'];
  sendFrontMessage: SendFrontMessagePayload;
  sendGmailMessage: SendGmailMessagePayload;
  sendOutlookMessage: SendOutlookMessagePayload;
  sendSamples: SendSamplesPayload;
  sendTestNotification: Scalars['Boolean']['output'];
  setClassificationLockDurationSeconds: Scalars['Boolean']['output'];
  setDefaultTrackSettings: TrackSettings;
  setGlobalPromptBasePrompt: GlobalPromptPayload;
  setGlobalPromptRunsOnExperimentalService: GlobalPromptPayload;
  setGlobalPromptVersion: GlobalPromptPayload;
  setHostedMcLeodInstanceUrls: SetHostedMcLeodInstanceUrlsPayload;
  setLandstarConfig: SetLandstarConfigPayload;
  setMercuryGateConfig: SetMercuryGateConfigPayload;
  setMotiveScrapingConcurrency: Scalars['Boolean']['output'];
  setMovementTrackingPaused: UpdateMovementPayload;
  setOrganizationLogo: Organization;
  setPreferMaterializedPrompt: MaterializedSopState;
  setSamsaraScrapingConcurrency: Scalars['Boolean']['output'];
  setTeamAfterHoursAlwaysOn: SetTeamAfterHoursAlwaysOnPayload;
  setTeamsTenantId: TeamsTenantResultPayload;
  setToolSearchEmbeddingsEnabled: Scalars['Boolean']['output'];
  setTrackSop: SetTrackSopPayload;
  setTruckerToolsScrapingConcurrency: Scalars['Boolean']['output'];
  setTurvoPollingConcurrency: Scalars['Boolean']['output'];
  setUsageBlock: Array<UsageBlockSummary>;
  setUsageCap: Array<UsageCapSummary>;
  setValhallaComparisonEnabled: Scalars['Boolean']['output'];
  setWorkflowSponsored: Array<SponsoredWorkflow>;
  simulateCarrierVerification: SimulateCarrierVerificationPayload;
  simulateNegotiation: SimulateNegotiationResult;
  simulateQuoteJobReply: SimulateQuoteJobReplyPayload;
  simulateSemanticWaitPatterns: SimulateSemanticWaitPatternsPayload;
  simulateShipmentLookup: SimulateShipmentLookupPayload;
  simulateTransitTime: SimulateTransitTimePayload;
  startMaterializedSopBuild: MaterializedSopBuild;
  startMaterializedSopConvert: MaterializedSopBuild;
  startMaterializedSopFix: MaterializedSopState;
  startMaterializedSopLabelRun: MaterializedSopState;
  startMicrosoftGraphConnect: StartMicrosoftGraphConnectPayload;
  startOrganizationBilling: OrganizationBillingSummary;
  startTeamsAdminConsent: StartTeamsAdminConsentPayload;
  startTrackSopTest: StartTrackSopTestPayload;
  submitOrder: SubmitOrderPayload;
  submitSubjectOrder: SubmitSubjectOrderPayload;
  /** Creates the app-only subscription for a registered mailbox, or renews it if one exists */
  subscribeMicrosoftMailbox: MicrosoftMailboxSubscriptionPayload;
  subscribeToActionDefinition: SubscribeToActionDefinitionPayload;
  syncActionDefinitionToShadowOrganization: SyncActionDefinitionToShadowOrgPayload;
  syncTemplate: SyncTemplatePayload;
  takeConversationSnapshot: TakeConversationSnapshotPayload;
  terminateConversationCall: TerminateConversationCallPayload;
  tidyMaterializedSopCustomization: Scalars['String']['output'];
  toggleDigestSubscription: Scalars['Boolean']['output'];
  track: Scalars['Boolean']['output'];
  triggerActionExecution: TriggerActionExecutionPayload;
  triggerConversationAnalysis: TriggerConversationAnalysisPayload;
  triggerExternalDataIngest: TriggerExternalDataIngestPayload;
  triggerLocationImportForOriginators: LocationImportAllOriginatorsPayload;
  triggerPlaceImport: TriggerPlaceImportPayload;
  triggerPlaceIngest: TriggerPlaceIngestPayload;
  triggerPortalAppointmentScheduling: TriggerPortalAppointmentSchedulingPayload;
  triggerQuoteAgentForJob: TriggerQuoteAgentForJobPayload;
  triggerSOPAppointmentScheduling: TriggerSopAppointmentSchedulingPayload;
  triggerShipmentCSVImport: TriggerShipmentCsvImportPayload;
  triggerShipmentIngestion: TriggerShipmentIngestionPayload;
  triggerSopsForExternalMessage: TriggerSopsForExternalMessagePayload;
  triggerTrackingProcedure: TriggerTrackingProcedurePayload;
  unpostFromLoadBoard: UnpostFromLoadBoardPayload;
  unsubscribeMicrosoftMailbox: MicrosoftMailboxSubscriptionPayload;
  unsubscribeToActionDefinition: SubscribeToActionDefinitionPayload;
  updateActionBehavior: ActionBehavior;
  updateActionDefinition: UpdateActionDefinitionPayload;
  updateActionTrigger: UpdateActionTriggerPayload;
  updateCarrierRate: UpdateCarrierRatePayload;
  updateContact: UpdateContactPayload;
  updateConversationLabels: UpdateConversationLabelsPayload;
  updateCoverAutomaticCoverageSettings: CoverAutomaticCoverageSettingsPayload;
  updateCoveragePlan: CoveragePlanPayload;
  updateCustomerRate: UpdateCustomerRatePayload;
  updateErrorGroup: ErrorGroup;
  updateExternalChannel: UpdateExternalChannelPayload;
  updateExternalMessage: UpdateExternalMessagePayload;
  updateFeatureFlag: FeatureFlagPayload;
  updateFileContent: UpdateFileContentPayload;
  updateFreightDataMapping: UpdateFreightDataMappingPayload;
  updateGenericRule: UpdateGenericRulePayload;
  updateGenericTransformation: GenericTransformationMutationPayload;
  updateGenericTransformationTemplate: GenericTransformationTemplatePayload;
  updateGlobalPrompt: GlobalPromptPayload;
  updateJob: UpdateJobPayload;
  updateLabeledComputation: CreateLabeledComputationPayload;
  updateLanePreference: LanePreferencePayload;
  updateManagedResource: ManagedResourcePayload;
  updateMember: UpdateMemberPayload;
  updateMemory: UpdateMemoryPayload;
  updateMemoryEntityLink: UpdateMemoryEntityLinkPayload;
  updateMovement: UpdateMovementPayload;
  updateNegotiationStrategy: NegotiationStrategyPayload;
  updateNotificationSettings: UpdateNotificationSettingsPayload;
  updateOrder: UpdateOrderPayload;
  updateOrganization: UpdateOrganizationPayload;
  updateOrganizationIntegrationConfigs: UpdateOrganizationIntegrationConfigsPayload;
  updateOriginator: UpdateOriginatorPayload;
  updateOtherIntegrationCredentials: UpdateOtherIntegrationCredentialsPayload;
  updatePlace: UpdatePlacePayload;
  updatePlaceScheduleMethod: UpdatePlaceScheduleMethodPayload;
  updatePlaceSchedulingMethod: PlaceSchedulingPayload;
  updatePricingStrategy: CreatePricingStrategyPayload;
  updateQuote: UpdateQuotePayload;
  updateRichTextDocumentUploadMetadata: CreateBlankRichTextDocumentUploadPayload;
  updateScheduleSettings: ScheduleSettings;
  updateSharedFile: UpdateSharedFilePayload;
  updateShipment: BuildShipmentPayload;
  updateSimulationBrokerOrganization: SimulationSettingsPayload;
  updateSimulationSettings: SimulationSettingsPayload;
  updateTeam: CreateTeamPayload;
  updateTeamMember: CrateTeamMemberPayload;
  updateTemplate: UpdateTemplatePayload;
  updateTemplateUsingOrder: UpdateTemplateUsingOrderPayload;
  updateTrackDashboardPreferences: TrackDashboardPreferences;
  updateTrackSettings: TrackSettings;
  updateTransformationConfig: UpdateTransformationConfigPayload;
  updateTransformationDefinition: UpdateTransformationDefinitionPayload;
  updateUser: UpdateUserPayload;
  updateUserFeatures: UpdateUserPayload;
  updateUserProfile: UpdateUserPayload;
  updateUserSettings: UpdateUserPayload;
  updateWebhookSubscription: UpdateWebhookSubscriptionPayload;
  updateWorkerProfile: UpdateWorkerProfilePayload;
  updateWorkflow: UpdateWorkflowPayload;
  uploadFile: UploadFilePayload;
  upsertActionDefinitionTeamGlobalPromptValues: UpsertActionDefinitionTeamGlobalPromptValuesPayload;
  upsertOrganizationJob: UpsertOrganizationJobPayload;
  validatePricingStrategyInstructions: PricingStrategyValidationPayload;
  validateTextInstructions: ValidateTextInstructionsPayload;
  verifyCarrierIntegration: VerifyCarrierIntegrationPayload;
  verifyTMSIntegration: VerifyTmsIntegrationPayload;
  wakeUpActionExecution: PokeActionExecutionPayload;
};


export type MutationAddCarriersToLanePreferenceArgs = {
  input: AddCarriersToLanePreferenceInput;
};


export type MutationAddChatMessageToConversationArgs = {
  input: AddChatMessageToConversationInput;
};


export type MutationAddDocumentToJobArgs = {
  input: AddDocumentToJobInput;
};


export type MutationAddDocumentToOrderArgs = {
  input: AddDocumentToOrderInput;
};


export type MutationAddUserToOrganizationArgs = {
  input: AddUserToOrganizationInput;
};


export type MutationAddWorkerToActionDefinitionArgs = {
  input: AddWorkerToActionDefinitionInput;
};


export type MutationApplyClassificationRulesArgs = {
  input: ApplyClassificationRulesInput;
};


export type MutationApplyGenericTransformationTemplateArgs = {
  input: ApplyGenericTransformationTemplateInput;
};


export type MutationApproveSchedulePlanArgs = {
  schedulePlanId: Scalars['ID']['input'];
};


export type MutationAuditDatAutopostsArgs = {
  input: AuditDatAutopostsInput;
};


export type MutationAuditDatShipmentPostingsArgs = {
  input: AuditDatShipmentPostingsInput;
};


export type MutationBackfillConversationLabelsArgs = {
  input: BackfillConversationLabelsInput;
};


export type MutationBuildShipmentArgs = {
  input: BuildShipmentInput;
};


export type MutationBulkCreateContactsArgs = {
  input: BulkCreateContactInput;
};


export type MutationBulkCreateContactsDirectArgs = {
  input: BulkCreateContactsInput;
};


export type MutationBulkCreateOriginatorsArgs = {
  input: BulkCreateOriginatorsInput;
};


export type MutationBulkCreatePlacesArgs = {
  input: BulkCreatePlacesInput;
};


export type MutationBulkDeleteJobsArgs = {
  input: BulkDeleteJobsInput;
};


export type MutationBulkDeleteOrdersArgs = {
  input: BulkDeleteOrdersInput;
};


export type MutationBulkDeleteOriginatorsArgs = {
  input: BulkDeleteOriginatorsInput;
};


export type MutationBulkDeletePlacesArgs = {
  input: BulkDeletePlacesInput;
};


export type MutationBulkDeleteQuotesArgs = {
  input: BulkDeleteQuotesInput;
};


export type MutationBulkInviteUsersToOrganizationArgs = {
  input: BulkInviteUsersToOrganizationInput;
};


export type MutationCancelActionExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelSchedulePlanArgs = {
  schedulePlanId: Scalars['ID']['input'];
};


export type MutationChangeActionExecutionAutonomyStateArgs = {
  input: ChangeActionExecutionAutonomyStateInput;
};


export type MutationChangeActionExecutionStatusArgs = {
  input: ChangeActionExecutionStatusInput;
};


export type MutationChangeMonthlyCommitArgs = {
  input: ChangeMonthlyCommitInput;
};


export type MutationCloneActionDefinitionArgs = {
  input: CloneActionDefinitionInput;
};


export type MutationCloseOperationalIssueArgs = {
  id: Scalars['ID']['input'];
  resolution: ExceptionStatus;
};


export type MutationCompleteMicrosoftGraphConnectArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};


export type MutationComputeLaneRatesArgs = {
  input: ComputeLaneRatesInput;
};


export type MutationComputeRatesArgs = {
  input: ComputeRatesInput;
};


export type MutationConfigureOrderTemplateArgs = {
  input: ConfigureOrderTemplateInput;
};


export type MutationConnectWorkerComposioAccountArgs = {
  input: ConnectWorkerComposioAccountInput;
};


export type MutationContactCarrierToCollectLoadBidArgs = {
  input: ContactCarrierToCollectLoadBidInput;
};


export type MutationContinueTeamsConnectionArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyJobToComplementaryArgs = {
  input: CopyJobToComplementaryInput;
};


export type MutationCreateActionBehaviorArgs = {
  input: CreateActionBehaviorInput;
};


export type MutationCreateActionDefinitionArgs = {
  input: CreateActionDefinitionInput;
};


export type MutationCreateActionTriggerArgs = {
  input: CreateActionTriggerInput;
};


export type MutationCreateAgentMailInboxArgs = {
  input: CreateAgentMailInboxInput;
};


export type MutationCreateApiClientArgs = {
  input: CreateApiClientInput;
};


export type MutationCreateAuthTokenArgs = {
  input: CreateAuthTokenInput;
};


export type MutationCreateAwkwardMomentLabelArgs = {
  input: CreateAwkwardMomentLabelInput;
};


export type MutationCreateBlankDocumentInKnowledgeBaseArgs = {
  input: CreateBlankDocumentInKnowledgeBaseInput;
};


export type MutationCreateBlankRichTextDocumentUploadArgs = {
  input: CreateBlankRichTextDocumentUploadInput;
};


export type MutationCreateBraintrustDatasetArgs = {
  input: CreateBraintrustDatasetInput;
};


export type MutationCreateCarrierByIdentifierArgs = {
  input: CreateCarrierByIdentifierInput;
};


export type MutationCreateCarrierRateArgs = {
  input: CreateCarrierRateInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateCoveragePlanArgs = {
  input: CreateCoveragePlanInput;
};


export type MutationCreateCoveragePlanFromCarrierContactListArgs = {
  input: CreateCoveragePlanFromCarrierContactListInput;
};


export type MutationCreateCustomerDocumentsInKnowledgeBaseArgs = {
  input: CreateCustomerDocumentsInKnowledgeBaseInput;
};


export type MutationCreateCustomerRateArgs = {
  input: CreateCustomerRateInput;
};


export type MutationCreateEventArgs = {
  input: CreateBaseEventInput;
};


export type MutationCreateExceptionArgs = {
  input: CreateExceptionInput;
};


export type MutationCreateExternalChannelArgs = {
  input: CreateExternalChannelInput;
};


export type MutationCreateExternalIdMappingArgs = {
  input: CreateExternalIdMappingInput;
};


export type MutationCreateExternalMessageJobArgs = {
  input: CreateExternalMessageJobInput;
};


export type MutationCreateFakeTrackingMilestonesArgs = {
  input: CreateFakeTrackingMilestonesInput;
};


export type MutationCreateFeatureFlagArgs = {
  input: CreateFeatureFlagInput;
};


export type MutationCreateFeatureFlagsArgs = {
  input: CreateFeatureFlagsInput;
};


export type MutationCreateFreightDataMappingArgs = {
  input: CreateFreightDataMappingInput;
};


export type MutationCreateFreightDataMappingsArgs = {
  input: CreateFreightDataMappingsInput;
};


export type MutationCreateFrontJobArgs = {
  input: CreateFrontJobInput;
};


export type MutationCreateFrontMailboxSubscriptionsArgs = {
  input: CreateFrontMailboxSubscriptionsInput;
};


export type MutationCreateFrontReplyAllArgs = {
  input: CreateFrontReplyAllInput;
};


export type MutationCreateGenericRuleArgs = {
  input: CreateGenericRuleInput;
};


export type MutationCreateGenericTransformationArgs = {
  input: CreateGenericTransformationInput;
};


export type MutationCreateGenericTransformationTemplateArgs = {
  input: CreateGenericTransformationTemplateInput;
};


export type MutationCreateGlobalPromptArgs = {
  input: CreateGlobalPromptInput;
};


export type MutationCreateGmailJobArgs = {
  input: CreateGmailJobInput;
};


export type MutationCreateGmailReplyAllArgs = {
  input: CreateGmailReplyAllInput;
};


export type MutationCreateInstantQuoteArgs = {
  input?: InputMaybe<CreateInstantQuoteInput>;
};


export type MutationCreateJobArgs = {
  input: CreateJobInput;
};


export type MutationCreateJobEventArgs = {
  input: CreateJobEventInput;
};


export type MutationCreateKnowledgeBaseArgs = {
  input: CreateKnowledgeBaseInput;
};


export type MutationCreateLabeledComputationArgs = {
  input: CreateLabeledComputationInput;
};


export type MutationCreateLanePreferenceArgs = {
  input: CreateLanePreferenceInput;
};


export type MutationCreateManagedResourceArgs = {
  input: CreateManagedResourceInput;
};


export type MutationCreateMemoryArgs = {
  input: CreateMemoryInput;
};


export type MutationCreateMemoryEntityLinkArgs = {
  input: CreateMemoryEntityLinkInput;
};


export type MutationCreateMessageQuoteAssociationArgs = {
  input: CreateMessageQuoteAssociationInput;
};


export type MutationCreateNegotiationStrategyArgs = {
  input: CreateNegotiationStrategyInput;
};


export type MutationCreateNewConversationWithConciergeArgs = {
  input: CreateNewConversationWithConciergeInput;
};


export type MutationCreateNewConversationWithLabelingConciergeArgs = {
  input: CreateNewConversationWithLabelingConciergeInput;
};


export type MutationCreateOrUpdateComposioAuthTokenArgs = {
  input: CreateOrUpdateComposioAuthTokenInput;
};


export type MutationCreateOrUpdateExternalIdMappingArgs = {
  input: CreateOrUpdateExternalIdMappingInput;
};


export type MutationCreateOrUpdateIntegrationCredentialsArgs = {
  input: CreateOrUpdateIntegrationCredentialsInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateOrderEventArgs = {
  input: CreateOrderEventInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationUserRelationArgs = {
  input: CreateOrganizationUserRelationInput;
};


export type MutationCreateOriginatorArgs = {
  input: CreateOriginatorInput;
};


export type MutationCreateOriginatorEventArgs = {
  input: CreateOriginatorEventInput;
};


export type MutationCreateOriginatorsReportArgs = {
  input: OriginatorsInput;
};


export type MutationCreateOutlookJobArgs = {
  input: CreateOutlookJobInput;
};


export type MutationCreateOutlookReplyAllArgs = {
  input: CreateOutlookReplyAllInput;
};


export type MutationCreatePlaceArgs = {
  input: CreatePlaceInput;
};


export type MutationCreatePlaceSchedulingMethodArgs = {
  input: CreatePlaceSchedulingMethodInput;
};


export type MutationCreatePricingStrategyArgs = {
  input: CreatePricingStrategyInput;
};


export type MutationCreateQuoteArgs = {
  input: CreateQuoteInput;
};


export type MutationCreateQuoteEventArgs = {
  input: CreateQuoteEventInput;
};


export type MutationCreateQuoteNoteArgs = {
  input: CreateQuoteNoteInput;
};


export type MutationCreateQuotesReportArgs = {
  input: QuotesInput;
};


export type MutationCreateRatingArgs = {
  input: CreateRatingInput;
};


export type MutationCreateSavedComputationArgs = {
  input: CreateSavedComputationInput;
};


export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


export type MutationCreateScheduleSettingsArgs = {
  input: CreateScheduleSettingsInput;
};


export type MutationCreateSharedFileArgs = {
  input: CreateSharedFileInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTeamMemberArgs = {
  input: CreateTeamMemberInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateTrackSettingsArgs = {
  input: CreateTrackSettingsInput;
};


export type MutationCreateTrackingExceptionEventArgs = {
  input: CreateTrackingExceptionEventInput;
};


export type MutationCreateTrackingMilestoneEventArgs = {
  input: CreateTrackingMilestoneEventInput;
};


export type MutationCreateTranscriptionLabelArgs = {
  input: CreateTranscriptionLabelInput;
};


export type MutationCreateTransformationConfigArgs = {
  input: CreateTransformationConfigInput;
};


export type MutationCreateTransformationDefinitionArgs = {
  input: CreateTransformationDefinitionInput;
};


export type MutationCreateTurnTakingLabelArgs = {
  input: CreateTurnTakingLabelInput;
};


export type MutationCreateWebhookSubscriptionArgs = {
  input: CreateWebhookSubscriptionInput;
};


export type MutationCreateWorkerArgs = {
  input: CreateWorkerInput;
};


export type MutationCreateWorkflowArgs = {
  input: CreateWorkflowInput;
};


export type MutationDeleteAiPhoneNumberArgs = {
  input: DeleteAiPhoneNumberInput;
};


export type MutationDeleteActionBehaviorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteActionDefinitionArgs = {
  input: DeleteActionDefinitionInput;
};


export type MutationDeleteActionDefinitionDocumentArgs = {
  input: DeleteActionDefinitionDocumentInput;
};


export type MutationDeleteActionDefinitionTeamGlobalPromptValuesArgs = {
  input: DeleteActionDefinitionTeamGlobalPromptValuesInput;
};


export type MutationDeleteActionTriggerArgs = {
  input: DeleteActionTriggerInput;
};


export type MutationDeleteApiClientArgs = {
  input: DeleteApiClientInput;
};


export type MutationDeleteAuthTokenArgs = {
  input: DeleteAuthTokenInput;
};


export type MutationDeleteCarrierRateArgs = {
  input: DeleteCarrierRateInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteCoveragePlanArgs = {
  input: DeleteCoveragePlanInput;
};


export type MutationDeleteCustomerRateArgs = {
  input: DeleteCustomerRateInput;
};


export type MutationDeleteDocumentInKnowledgeBaseArgs = {
  input: DeleteDocumentInKnowledgeBaseInput;
};


export type MutationDeleteExternalChannelArgs = {
  input: DeleteExternalChannelInput;
};


export type MutationDeleteFreightDataMappingArgs = {
  input: DeleteFreightDataMappingInput;
};


export type MutationDeleteFrontMailboxSubscriptionsArgs = {
  input: DeleteFrontMailboxSubscriptionsInput;
};


export type MutationDeleteGenericRuleArgs = {
  input: DeleteGenericRuleInput;
};


export type MutationDeleteGenericTransformationArgs = {
  input: DeleteGenericTransformationInput;
};


export type MutationDeleteGenericTransformationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGlobalPromptArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteIntegrationCredentialsArgs = {
  input: DeleteIntegrationCredentialsInput;
};


export type MutationDeleteJobArgs = {
  input: DeleteJobInput;
};


export type MutationDeleteJobDocumentArgs = {
  input: DeleteJobDocumentInput;
};


export type MutationDeleteKnowledgeBaseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLabeledComputationArgs = {
  input: DeleteLabeledComputationInput;
};


export type MutationDeleteLanePreferenceArgs = {
  input: DeleteLanePreferenceInput;
};


export type MutationDeleteManagedResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemoryArgs = {
  input: DeleteMemoryInput;
};


export type MutationDeleteMemoryEntityLinkArgs = {
  input: DeleteMemoryEntityLinkInput;
};


export type MutationDeleteNegotiationStrategyArgs = {
  input: DeleteNegotiationStrategyInput;
};


export type MutationDeleteOrderArgs = {
  input: DeleteOrderInput;
};


export type MutationDeleteOrganizationJobArgs = {
  input: DeleteOrganizationJobInput;
};


export type MutationDeleteOriginatorArgs = {
  input: DeleteOriginatorInput;
};


export type MutationDeletePlaceArgs = {
  input: DeletePlaceInput;
};


export type MutationDeletePlaceSchedulingMethodArgs = {
  input: DeletePlaceSchedulingMethodInput;
};


export type MutationDeletePricingStrategyArgs = {
  input: DeletePricingStrategyInput;
};


export type MutationDeleteQuoteArgs = {
  input: DeleteQuoteInput;
};


export type MutationDeleteSavedViewArgs = {
  input: DeleteSavedViewInput;
};


export type MutationDeleteScheduleSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSharedFileArgs = {
  input: DeleteSharedFileInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationDeleteTeamMemberArgs = {
  input: DeleteTeamMemberInput;
};


export type MutationDeleteTemplateArgs = {
  input: DeleteTemplateInput;
};


export type MutationDeleteTrackSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTransformationConfigArgs = {
  input: DeleteTransformationConfigInput;
};


export type MutationDeleteTransformationDefinitionArgs = {
  input: DeleteTransformationDefinitionInput;
};


export type MutationDeleteWebhookSubscriptionArgs = {
  input: DeleteWebhookSubscriptionInput;
};


export type MutationDeleteWorkerArgs = {
  input: DeleteWorkerInput;
};


export type MutationDeleteWorkerAuthTokenArgs = {
  input: DeleteWorkerAuthTokenInput;
};


export type MutationDeleteWorkflowArgs = {
  input: DeleteWorkflowInput;
};


export type MutationDiffActionDefinitionNaturalLanguageProcedureArgs = {
  input: DiffActionDefinitionNaturalLanguageProcedureInput;
};


export type MutationDisableTmsIntegrationVerificationArgs = {
  input: DisableTmsIntegrationVerificationInput;
};


export type MutationDiscardMaterializedSopBuildArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  buildId: Scalars['ID']['input'];
};


export type MutationDisconnectWorkerComposioArgs = {
  input: WorkerComposioConnectionInput;
};


export type MutationDismissConversationExceptionsArgs = {
  input: DismissConversationExceptionsInput;
};


export type MutationEnableTmsIntegrationVerificationArgs = {
  input: EnableTmsIntegrationVerificationInput;
};


export type MutationEnsureFrontExternalMessageArgs = {
  input: EnsureFrontExternalMessageInput;
};


export type MutationEnsureOutlookExternalMessageArgs = {
  input: EnsureOutlookExternalMessageInput;
};


export type MutationEnsureShipmentExistsForQuoteArgs = {
  input: EnsureShipmentExistsForQuoteInput;
};


export type MutationEvaluateGlobalPromptBehaviorsArgs = {
  input: RunGlobalPromptEvaluationInput;
};


export type MutationExecuteCheckpointArgs = {
  input: ExecuteCheckpointInput;
};


export type MutationExecuteCoveragePlanArgs = {
  input: ExecuteCoveragePlanInput;
};


export type MutationExecuteToolArgs = {
  input: ExecuteToolInput;
};


export type MutationExtractBuildAccuracyResultsArgs = {
  input: ExtractBuildAccuracyResultsInput;
};


export type MutationFindDuplicateArgs = {
  input: FindDuplicateInput;
};


export type MutationFindOrCreateDatHistoryRatesArgs = {
  input: DatHistoryRatesInput;
};


export type MutationFindOrCreateMarketConditionsArgs = {
  input: MarketConditionsInput;
};


export type MutationFlagOriginatorArgs = {
  input: FlagOriginatorInput;
};


export type MutationGenerateBuildAccuracyReportArgs = {
  input: GenerateBuildAccuracyReportInput;
};


export type MutationGenerateSchedulePlanArgs = {
  movementId: Scalars['ID']['input'];
};


export type MutationGenerateShipmentLifecycleSimShipmentArgs = {
  input: GenerateShipmentLifecycleSimShipmentInput;
};


export type MutationHandleExternalMessageClassifiedAndAssociatedArgs = {
  input: HandleExternalMessageClassifiedAndAssociatedInput;
};


export type MutationHandleNewAssistantEmailArgs = {
  input: HandleNewAssistantEmailInput;
};


export type MutationHandleNewTrackingEmailArgs = {
  input: HandleNewAssistantEmailInput;
};


export type MutationImportCarriersFromCsvArgs = {
  input: ImportCarriersFromCsvInput;
};


export type MutationImportShipmentArgs = {
  input: ImportShipmentInput;
};


export type MutationImportTmsOrderArgs = {
  input: ImportTmsOrderInput;
};


export type MutationInitializeOrderTemplateForOriginatorArgs = {
  input: InitializeOrderTemplateForOriginatorInput;
};


export type MutationInviteUserToOrganizationArgs = {
  input: InviteUserToOrganizationInput;
};


export type MutationLeaveTeamArgs = {
  input: LeaveTeamInput;
};


export type MutationLiftUsageBlockArgs = {
  input: LiftUsageBlockInput;
};


export type MutationLogLlmRequestsArgs = {
  input: LogLlmRequestsInput;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationMassDeleteShipmentsAndMovementsArgs = {
  input: MassDeleteShipmentsAndMovementsInput;
};


export type MutationMassPostToLoadBoardArgs = {
  input: MassPostToLoadBoardInput;
};


export type MutationMassUnpostFromLoadBoardArgs = {
  input: MassUnpostFromLoadBoardInput;
};


export type MutationMergeGenericTransformationTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMessageActionExecutionArgs = {
  id: Scalars['ID']['input'];
  payload: Scalars['JSONObject']['input'];
};


export type MutationMoveUserToOrganizationsArgs = {
  input: MoveUserToOrganizationsInput;
};


export type MutationOnboardNewOriginatorArgs = {
  input: OnboardNewOriginatorInput;
};


export type MutationPageArgs = {
  input: PageInput;
};


export type MutationPokeActionExecutionArgs = {
  input: PokeActionExecutionInput;
};


export type MutationPostToLoadBoardArgs = {
  input: PostToLoadBoardInput;
};


export type MutationProposeFreightDataMappingValuesArgs = {
  input: ProposeFreightDataMappingValuesInput;
};


export type MutationProposeGlobalPromptSopAlignmentArgs = {
  input: ProposeGlobalPromptSopAlignmentInput;
};


export type MutationProvisionAiPhoneNumberArgs = {
  input: ProvisionAiPhoneNumberInput;
};


export type MutationProvisionBrowserUseDemoArgs = {
  input: ProvisionBrowserUseDemoInput;
};


export type MutationProvisionConciergeSopArgs = {
  input: ProvisionConciergeSopInput;
};


export type MutationProvisionCoverForTeamArgs = {
  input: ProvisionCoverForTeamInput;
};


export type MutationProvisionCoverSimulationsArgs = {
  input: ProvisionCoverSimulationsInput;
};


export type MutationProvisionFakeTrackMovementArgs = {
  input: CreateFakeTrackMovementInput;
};


export type MutationProvisionForQaArgs = {
  input: ProvisionForQaInput;
};


export type MutationProvisionInterviewArgs = {
  input: ProvisionInterviewInput;
};


export type MutationProvisionLabelingConciergeArgs = {
  input: ProvisionLabelingConciergeInput;
};


export type MutationProvisionQuoteForOrgArgs = {
  input: ProvisionQuoteForOrgInput;
};


export type MutationProvisionQuoteForTeamArgs = {
  input: ProvisionQuoteForTeamInput;
};


export type MutationProvisionQuoteOriginatorsArgs = {
  input: ProvisionQuoteOriginatorsInput;
};


export type MutationProvisionQuoteSimulationsArgs = {
  input: ProvisionQuoteSimulationsInput;
};


export type MutationProvisionRunnersArgs = {
  input: ProvisionRunnersInput;
};


export type MutationProvisionScheduleArgs = {
  input: ProvisionScheduleInput;
};


export type MutationProvisionShareCoveragePlanSopArgs = {
  input: ProvisionShareCoveragePlanSopInput;
  teamId: Scalars['String']['input'];
};


export type MutationProvisionTrackArgs = {
  input: ProvisionTrackInput;
};


export type MutationProvisionVeeArgs = {
  input: ProvisionVeeInput;
};


export type MutationProvisionVoomaBuildAgentArgs = {
  input: ProvisionVoomaBuildAgentInput;
};


export type MutationPublishMaterializedSopBuildArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  buildId: Scalars['ID']['input'];
  skippedToolChanges?: Array<MaterializedSopToolChangeInput>;
};


export type MutationRateMessageArgs = {
  input: RateMessageInput;
};


export type MutationReassignQuoteOwnerArgs = {
  input: ReassignQuoteOwnerInput;
};


export type MutationRecoverMemoryArgs = {
  input: RecoverMemoryInput;
};


export type MutationRedactOrganizationDataArgs = {
  input: RedactOrganizationDataInput;
};


export type MutationRefreshAuthTokenForUserArgs = {
  type: AuthTokenType;
  userId: Scalars['String']['input'];
};


export type MutationRefreshFrontOrganizationIdArgs = {
  input: RefreshFrontOrganizationIdInput;
};


export type MutationRefreshOrderEntitiesArgs = {
  input: RefreshOrderEntitiesInput;
};


export type MutationRefreshPostingOnLoadBoardArgs = {
  input: RefreshPostingOnLoadBoardInput;
};


export type MutationRefreshQuoteMileageArgs = {
  input: RefreshQuoteMileageInput;
};


export type MutationRefreshSubscriptionsArgs = {
  input: RefreshSubscriptionsInput;
};


export type MutationRefreshWorkerComposioAccountArgs = {
  input: WorkerComposioConnectionInput;
};


export type MutationRegisterMicrosoftMailboxesArgs = {
  input: RegisterMicrosoftMailboxesInput;
};


export type MutationRemoveCarriersFromLanePreferenceArgs = {
  input: RemoveCarriersFromLanePreferenceInput;
};


export type MutationRemoveMessageRatingArgs = {
  input: RemoveMessageRatingInput;
};


export type MutationRemoveOrganizationLogoArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveSenderFromOriginatorArgs = {
  input: RemoveSenderFromOriginatorInput;
};


export type MutationRemoveUserFromOrganizationArgs = {
  input: RemoveUserFromOrganizationInput;
};


export type MutationRemoveWorkerFromActionDefinitionArgs = {
  input: RemoveWorkerFromActionDefinitionInput;
};


export type MutationRenameDocumentInKnowledgeBaseArgs = {
  input: RenameDocumentInKnowledgeBaseInput;
};


export type MutationRenameKnowledgeBaseArgs = {
  input: RenameKnowledgeBaseInput;
};


export type MutationRenameSharedFileArgs = {
  input: RenameSharedFileInput;
};


export type MutationRepeatOrderArgs = {
  input: RepeatOrderInput;
};


export type MutationReplicateOrderArgs = {
  input: ReplicateOrderInput;
};


export type MutationReprocessJobArgs = {
  input: ReprocessJobInput;
};


export type MutationReprocessOrderArgs = {
  input: ReprocessOrderInput;
};


export type MutationRequestConversationCcArgs = {
  input: RequestConversationCcInput;
};


export type MutationReserveTestPhoneNumberArgs = {
  input: ReserveTestPhoneNumberInput;
};


export type MutationResolveCorruptedTrackingExceptionArgs = {
  exceptionId: Scalars['ID']['input'];
};


export type MutationResolveSkillChangeRequestArgs = {
  exceptionId: Scalars['ID']['input'];
  outcome: SkillChangeApprovalOutcome;
  rationale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveTrackSettingsChangeRequestArgs = {
  exceptionId: Scalars['ID']['input'];
  outcome: SkillChangeApprovalOutcome;
};


export type MutationRollOutGlobalPromptFromCodeArgs = {
  globalPromptId: Scalars['String']['input'];
};


export type MutationRunActionBehaviorArgs = {
  input: RunActionBehaviorInput;
};


export type MutationRunBuildAccuracySamplesArgs = {
  input: RunBuildAccuracySamplesInput;
};


export type MutationRunManagedResourceCanaryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRunSkillChangeTestsArgs = {
  exceptionId: Scalars['ID']['input'];
};


export type MutationSaveBasePromptConfigArgs = {
  input: SaveBasePromptConfigInput;
};


export type MutationSaveConversationSnapshotToDatasetArgs = {
  input: SaveConversationSnapshotToDatasetInput;
};


export type MutationSaveMessageRatingDetailsArgs = {
  input: SaveMessageRatingDetailsInput;
};


export type MutationSaveRowToDatasetArgs = {
  input: SaveRowToDatasetInput;
};


export type MutationSeedCoverDemoDataArgs = {
  input: SeedCoverDemoDataInput;
};


export type MutationSeedVeeDemoDataArgs = {
  input: SeedVeeDemoDataInput;
};


export type MutationSelectQuickReplyArgs = {
  input: SelectQuickReplyInput;
};


export type MutationSendFrontMessageArgs = {
  input: SendFrontMessageInput;
};


export type MutationSendGmailMessageArgs = {
  input: SendGmailMessageInput;
};


export type MutationSendOutlookMessageArgs = {
  input: SendOutlookMessageInput;
};


export type MutationSendSamplesArgs = {
  input: SendSamplesInput;
};


export type MutationSendTestNotificationArgs = {
  input: SendTestNotificationInput;
};


export type MutationSetClassificationLockDurationSecondsArgs = {
  seconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetDefaultTrackSettingsArgs = {
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
};


export type MutationSetGlobalPromptBasePromptArgs = {
  basePromptId?: InputMaybe<Scalars['ID']['input']>;
  globalPromptId: Scalars['String']['input'];
};


export type MutationSetGlobalPromptRunsOnExperimentalServiceArgs = {
  globalPromptId: Scalars['String']['input'];
  runsOnExperimentalService: Scalars['Boolean']['input'];
};


export type MutationSetGlobalPromptVersionArgs = {
  input: SetGlobalPromptVersionInput;
};


export type MutationSetHostedMcLeodInstanceUrlsArgs = {
  input: SetHostedMcLeodInstanceUrlsInput;
};


export type MutationSetLandstarConfigArgs = {
  input: SetLandstarConfigInput;
};


export type MutationSetMercuryGateConfigArgs = {
  input: SetMercuryGateConfigInput;
};


export type MutationSetMotiveScrapingConcurrencyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetMovementTrackingPausedArgs = {
  input: SetMovementTrackingPausedInput;
};


export type MutationSetOrganizationLogoArgs = {
  file: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationSetPreferMaterializedPromptArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  isOn: Scalars['Boolean']['input'];
};


export type MutationSetSamsaraScrapingConcurrencyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetTeamAfterHoursAlwaysOnArgs = {
  input: SetTeamAfterHoursAlwaysOnInput;
};


export type MutationSetTeamsTenantIdArgs = {
  organizationId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetToolSearchEmbeddingsEnabledArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetTrackSopArgs = {
  input: SetTrackSopInput;
};


export type MutationSetTruckerToolsScrapingConcurrencyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetTurvoPollingConcurrencyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetUsageBlockArgs = {
  input: SetUsageBlockInput;
};


export type MutationSetUsageCapArgs = {
  input: SetUsageCapInput;
};


export type MutationSetValhallaComparisonEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetWorkflowSponsoredArgs = {
  input: SetWorkflowSponsoredInput;
};


export type MutationSimulateCarrierVerificationArgs = {
  input: SimulateCarrierVerificationInput;
};


export type MutationSimulateNegotiationArgs = {
  input: SimulateNegotiationInput;
};


export type MutationSimulateQuoteJobReplyArgs = {
  input: SimulateQuoteJobReplyInput;
};


export type MutationSimulateSemanticWaitPatternsArgs = {
  input: SimulateSemanticWaitPatternsInput;
};


export type MutationSimulateShipmentLookupArgs = {
  input: SimulateShipmentLookupInput;
};


export type MutationSimulateTransitTimeArgs = {
  input: SimulateTransitTimeInput;
};


export type MutationStartMaterializedSopBuildArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  fromScratch?: Scalars['Boolean']['input'];
};


export type MutationStartMaterializedSopConvertArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  basePromptKey: Scalars['String']['input'];
};


export type MutationStartMaterializedSopFixArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  buildId: Scalars['ID']['input'];
  skippedLabelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationStartMaterializedSopLabelRunArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  buildId: Scalars['ID']['input'];
  evaluationId: Scalars['ID']['input'];
};


export type MutationStartMicrosoftGraphConnectArgs = {
  userId: Scalars['String']['input'];
};


export type MutationStartOrganizationBillingArgs = {
  input: StartOrganizationBillingInput;
};


export type MutationStartTeamsAdminConsentArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationStartTrackSopTestArgs = {
  input: StartTrackSopTestInput;
};


export type MutationSubmitOrderArgs = {
  input: SubmitOrderInput;
};


export type MutationSubmitSubjectOrderArgs = {
  input: SubmitSubjectOrderInput;
};


export type MutationSubscribeMicrosoftMailboxArgs = {
  input: MicrosoftMailboxSubscriptionInput;
};


export type MutationSubscribeToActionDefinitionArgs = {
  input: SubscribeToActionDefinitionInput;
};


export type MutationSyncActionDefinitionToShadowOrganizationArgs = {
  input: SyncActionDefinitionToShadowOrgInput;
};


export type MutationSyncTemplateArgs = {
  input: SyncTemplateInput;
};


export type MutationTakeConversationSnapshotArgs = {
  input: TakeConversationSnapshotInput;
};


export type MutationTerminateConversationCallArgs = {
  input: TerminateConversationCallInput;
};


export type MutationTidyMaterializedSopCustomizationArgs = {
  actionDefinitionId: Scalars['ID']['input'];
  config: Scalars['JSON']['input'];
};


export type MutationToggleDigestSubscriptionArgs = {
  digestId: Scalars['String']['input'];
  subscribe: Scalars['Boolean']['input'];
};


export type MutationTrackArgs = {
  input: TrackInput;
};


export type MutationTriggerActionExecutionArgs = {
  input: TriggerActionExecutionInput;
};


export type MutationTriggerConversationAnalysisArgs = {
  input: TriggerConversationAnalysisInput;
};


export type MutationTriggerExternalDataIngestArgs = {
  input: TriggerExternalDataIngestInput;
};


export type MutationTriggerLocationImportForOriginatorsArgs = {
  input: TriggerLocationImportInput;
};


export type MutationTriggerPlaceImportArgs = {
  input: TriggerPlaceImportInput;
};


export type MutationTriggerPlaceIngestArgs = {
  input: TriggerPlaceIngestInput;
};


export type MutationTriggerPortalAppointmentSchedulingArgs = {
  input: TriggerPortalAppointmentSchedulingInput;
};


export type MutationTriggerQuoteAgentForJobArgs = {
  input: TriggerQuoteAgentForJobInput;
};


export type MutationTriggerSopAppointmentSchedulingArgs = {
  input: TriggerSopAppointmentSchedulingInput;
};


export type MutationTriggerShipmentCsvImportArgs = {
  input: TriggerShipmentCsvImportInput;
};


export type MutationTriggerShipmentIngestionArgs = {
  input: TriggerShipmentIngestionInput;
};


export type MutationTriggerSopsForExternalMessageArgs = {
  input: TriggerSopsForExternalMessageInput;
};


export type MutationTriggerTrackingProcedureArgs = {
  input: TriggerTrackingProcedureInput;
};


export type MutationUnpostFromLoadBoardArgs = {
  input: UnpostFromLoadBoardInput;
};


export type MutationUnsubscribeMicrosoftMailboxArgs = {
  input: MicrosoftMailboxSubscriptionInput;
};


export type MutationUnsubscribeToActionDefinitionArgs = {
  input: SubscribeToActionDefinitionInput;
};


export type MutationUpdateActionBehaviorArgs = {
  input: UpdateActionBehaviorInput;
};


export type MutationUpdateActionDefinitionArgs = {
  input: UpdateActionDefinitionInput;
};


export type MutationUpdateActionTriggerArgs = {
  input: UpdateActionTriggerInput;
};


export type MutationUpdateCarrierRateArgs = {
  input: UpdateCarrierRateInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateConversationLabelsArgs = {
  input: UpdateConversationLabelsInput;
};


export type MutationUpdateCoverAutomaticCoverageSettingsArgs = {
  input: UpdateCoverAutomaticCoverageSettingsInput;
};


export type MutationUpdateCoveragePlanArgs = {
  input: UpdateCoveragePlanInput;
};


export type MutationUpdateCustomerRateArgs = {
  input: UpdateCustomerRateInput;
};


export type MutationUpdateErrorGroupArgs = {
  input: UpdateErrorGroupInput;
};


export type MutationUpdateExternalChannelArgs = {
  input: UpdateExternalChannelInput;
};


export type MutationUpdateExternalMessageArgs = {
  input: UpdateExternalMessageInput;
};


export type MutationUpdateFeatureFlagArgs = {
  input: UpdateFeatureFlagInput;
};


export type MutationUpdateFileContentArgs = {
  file: Scalars['Upload']['input'];
  input: UpdateFileContentInput;
};


export type MutationUpdateFreightDataMappingArgs = {
  input: UpdateFreightDataMappingInput;
};


export type MutationUpdateGenericRuleArgs = {
  input: UpdateGenericRuleInput;
};


export type MutationUpdateGenericTransformationArgs = {
  input: UpdateGenericTransformationInput;
};


export type MutationUpdateGenericTransformationTemplateArgs = {
  input: UpdateGenericTransformationTemplateInput;
};


export type MutationUpdateGlobalPromptArgs = {
  input: UpdateGlobalPromptInput;
};


export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
};


export type MutationUpdateLabeledComputationArgs = {
  input: UpdateLabeledComputationInput;
};


export type MutationUpdateLanePreferenceArgs = {
  input: UpdateLanePreferenceInput;
};


export type MutationUpdateManagedResourceArgs = {
  input: UpdateManagedResourceInput;
};


export type MutationUpdateMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateMemoryArgs = {
  input: UpdateMemoryInput;
};


export type MutationUpdateMemoryEntityLinkArgs = {
  input: UpdateMemoryEntityLinkInput;
};


export type MutationUpdateMovementArgs = {
  input: UpdateMovementInput;
};


export type MutationUpdateNegotiationStrategyArgs = {
  input: UpdateNegotiationStrategyInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};


export type MutationUpdateOrderArgs = {
  input: UpdateOrderInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationIntegrationConfigsArgs = {
  input: UpdateOrganizationIntegrationConfigsInput;
};


export type MutationUpdateOriginatorArgs = {
  input: UpdateOriginatorInput;
};


export type MutationUpdateOtherIntegrationCredentialsArgs = {
  input: UpdateOtherIntegrationCredentialsInput;
};


export type MutationUpdatePlaceArgs = {
  input: UpdatePlaceInput;
};


export type MutationUpdatePlaceScheduleMethodArgs = {
  input: UpdatePlaceScheduleMethodInput;
};


export type MutationUpdatePlaceSchedulingMethodArgs = {
  input: UpdatePlaceSchedulingMethodInput;
};


export type MutationUpdatePricingStrategyArgs = {
  input: UpdatePricingStrategyInput;
};


export type MutationUpdateQuoteArgs = {
  input: UpdateQuoteInput;
};


export type MutationUpdateRichTextDocumentUploadMetadataArgs = {
  input: UpdateBlankRichTextDocumentUploadMetadataInput;
};


export type MutationUpdateScheduleSettingsArgs = {
  input: UpdateScheduleSettingsInput;
};


export type MutationUpdateSharedFileArgs = {
  input: UpdateSharedFileInput;
};


export type MutationUpdateShipmentArgs = {
  input: BuildShipmentInput;
};


export type MutationUpdateSimulationBrokerOrganizationArgs = {
  input: UpdateSimulationBrokerOrganizationInput;
};


export type MutationUpdateSimulationSettingsArgs = {
  input: UpdateSimulationSettingsInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTeamMemberArgs = {
  input: UpdateTeamMemberInput;
};


export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationUpdateTemplateUsingOrderArgs = {
  input: UpdateTemplateUsingOrderInput;
};


export type MutationUpdateTrackDashboardPreferencesArgs = {
  input: UpdateTrackDashboardPreferencesInput;
};


export type MutationUpdateTrackSettingsArgs = {
  input: UpdateTrackSettingsInput;
};


export type MutationUpdateTransformationConfigArgs = {
  input: UpdateTransformationConfigInput;
};


export type MutationUpdateTransformationDefinitionArgs = {
  input: UpdateTransformationDefinitionInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserFeaturesArgs = {
  input: UpdateUserFeaturesInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationUpdateWebhookSubscriptionArgs = {
  input: UpdateWebhookSubscriptionInput;
};


export type MutationUpdateWorkerProfileArgs = {
  input: UpdateWorkerProfileInput;
};


export type MutationUpdateWorkflowArgs = {
  input: UpdateWorkflowInput;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
  input: UploadFileInput;
};


export type MutationUpsertActionDefinitionTeamGlobalPromptValuesArgs = {
  input: UpsertActionDefinitionTeamGlobalPromptValuesInput;
};


export type MutationUpsertOrganizationJobArgs = {
  input: UpsertOrganizationJobInput;
};


export type MutationValidatePricingStrategyInstructionsArgs = {
  input: ValidatePricingStrategyInstructionsInput;
};


export type MutationValidateTextInstructionsArgs = {
  input: ValidateTextInstructionsInput;
};


export type MutationVerifyCarrierIntegrationArgs = {
  input: VerifyCarrierIntegrationInput;
};


export type MutationVerifyTmsIntegrationArgs = {
  input: VerifyTmsIntegrationInput;
};


export type MutationWakeUpActionExecutionArgs = {
  id: Scalars['ID']['input'];
};

export type MyMessageRatingsInput = {
  messageIds: Array<Scalars['ID']['input']>;
};

export type NaturalLanguageProcedure = {
  __typename?: 'NaturalLanguageProcedure';
  eventLabels?: Maybe<Array<EventLabel>>;
  instructions: Scalars['String']['output'];
  outcomeLabels?: Maybe<Array<OutcomeLabel>>;
  procedureType: ProcedureType;
  watchers?: Maybe<Array<WatcherDefinition>>;
};

export type NavigatorFields = {
  appName?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type NegotiationOfferInput = {
  accepted: Scalars['Boolean']['input'];
  createdAt: Scalars['String']['input'];
  movementId: Scalars['String']['input'];
  offerAmount: Scalars['Float']['input'];
  offeredBy?: InputMaybe<Scalars['String']['input']>;
};

export type NegotiationOfferType = {
  __typename?: 'NegotiationOfferType';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  movementId: Scalars['String']['output'];
  offerAmount: Scalars['Float']['output'];
  offeredBy?: Maybe<Scalars['String']['output']>;
};

export type NegotiationStrategiesInput = {
  organizationId: Scalars['ID']['input'];
};

export type NegotiationStrategy = AbstractEntity & Node & {
  __typename?: 'NegotiationStrategy';
  active: Scalars['Boolean']['output'];
  config: NegotiationStrategyConfig;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  type: NegotiationStrategyType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type NegotiationStrategyConditionsType = {
  __typename?: 'NegotiationStrategyConditionsType';
  /** When specified, the condition matches if the average of recent carrier offer prices is above this value. */
  averageOfferAbove?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the average of recent carrier offer prices is below this value. */
  averageOfferBelow?: Maybe<Scalars['Float']['output']>;
  /** Acceptable equipment types the carrier can have. If specified and the carrier has not provided their equipment type, triggers a clarification question. Once the carrier responds, their answer is matched against this list to determine if the rule applies. */
  carrierEquipmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** When true, matches if the latest carrier offer exceeds the max price. When false, matches if the latest carrier offer is at or below the max price. */
  carrierOfferOverMax?: Maybe<Scalars['Boolean']['output']>;
  /** When true, matches once the carrier's last two offers differ by less than $25, including a price raise. When false, matches while the carrier is still lowering its price or has made fewer than two offers. */
  carrierStoppedBudging?: Maybe<Scalars['Boolean']['output']>;
  commodityPatterns?: Maybe<Array<Scalars['String']['output']>>;
  equipmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** When specified, the condition matches if any recent carrier offer price is above this value. */
  hasAnyOfferAbove?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if any recent carrier offer price is below this value. */
  hasAnyOfferBelow?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the negotiation context has rate guidance for the specified rating method. */
  hasRateGuidanceForMethod?: Maybe<RatingMethod>;
  /** Hot-load detection settings. When specified, the condition matches if the shipment has received at least offerCountThreshold offers within the time window. */
  hotLoad?: Maybe<HotLoadConditionType>;
  /** When specified, the condition matches if the shipment has received at least this many inquiries within the inquiry time window. */
  inquiryCountAtLeast?: Maybe<Scalars['Int']['output']>;
  /** When specified, the condition matches if the shipment has received at most this many inquiries within the inquiry time window. */
  inquiryCountAtMost?: Maybe<Scalars['Int']['output']>;
  /** Time window in minutes to look back for carrier inquiries. Defaults to 120. */
  inquiryTimeWindowMinutes?: Maybe<Scalars['Int']['output']>;
  maxPriceAtLeast?: Maybe<Scalars['Float']['output']>;
  maxPriceAtMost?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the shipment has received at least this many carrier offers within the offer time window. */
  offerCountAtLeast?: Maybe<Scalars['Int']['output']>;
  /** When specified, the condition matches if the shipment has received at most this many carrier offers within the offer time window. */
  offerCountAtMost?: Maybe<Scalars['Int']['output']>;
  /** When specified, the condition matches if the latest carrier offer exceeds maxPrice + this value. E.g., 500 matches when the carrier offer is more than $500 above max. */
  offerGreaterThanMaxPlus?: Maybe<Scalars['Float']['output']>;
  /** Minimum percentage position of the latest carrier offer within the target-to-max price range. For example, 50 matches offers at or above the midpoint, including offers above max. */
  offerRangePercentAtLeast?: Maybe<Scalars['Float']['output']>;
  /** Time window in minutes to look back for carrier offers. Defaults to 120. */
  offerTimeWindowMinutes?: Maybe<Scalars['Int']['output']>;
  /** Pickup date filter. Can be a number representing days from now (e.g., 3 for "within 3 days"), or a preset string: "today" for pickups today, "this_week" for pickups within the current week (Sunday-Saturday). */
  pickupDateWithin?: Maybe<Scalars['String']['output']>;
  /** Pickup window end date filter. Can be a number representing days from now (e.g., 3 for "within 3 days"), or a preset string: "today" for pickup windows ending today, "this_week" for pickup windows ending within the current week (Sunday-Saturday). */
  pickupEndDateWithin?: Maybe<Scalars['String']['output']>;
  /** Pickup window end time filter in hours. Matches when the pickup window ends within this many hours from now (e.g., 3 for "within 3 hours"). Uses exact time comparison, not calendar-day boundaries. */
  pickupEndWithinHours?: Maybe<Scalars['Float']['output']>;
  /** Pickup time filter in hours. Matches when the pickup is within this many hours from now (e.g., 3 for "within 3 hours"). Uses exact time comparison, not calendar-day boundaries. */
  pickupWithinHours?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the best-estimate rate guidance is at least this value. */
  rateGuidanceAtLeast?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the best-estimate rate guidance is at most this value. */
  rateGuidanceAtMost?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the carrier has made at least this many offers after our first offer. Offers before our first offer do not count, and repeating the same price counts again. */
  rejectionCountAtLeast?: Maybe<Scalars['Int']['output']>;
  /** When specified, the condition matches if the carrier has made at most this many offers after our first offer. Offers before our first offer do not count, and repeating the same price counts again. */
  rejectionCountAtMost?: Maybe<Scalars['Int']['output']>;
  targetPriceAtLeast?: Maybe<Scalars['Float']['output']>;
  targetPriceAtMost?: Maybe<Scalars['Float']['output']>;
  /** When specified, the condition matches if the shipment has had at least this many carriers transferred within the transfer time window. */
  transferCountAtLeast?: Maybe<Scalars['Int']['output']>;
  /** When specified, the condition matches if the shipment has had at most this many carriers transferred within the transfer time window. */
  transferCountAtMost?: Maybe<Scalars['Int']['output']>;
  /** Time window in minutes to look back for carrier transfers. Defaults to 120. */
  transferTimeWindowMinutes?: Maybe<Scalars['Int']['output']>;
};

export type NegotiationStrategyConfig = AbTestConfigType | AcceptUpToMaxConfigType | AlwaysAcceptConfigType | AlwaysDeclineConfigType | ConditionalConfigType | EscalationConfigType | FixedAmountConfigType | NeverBudgeConfigType | PercentageBasedConfigType | SmartPricingConfigType;

export type NegotiationStrategyMarginInput = {
  negotiationStrategyId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type NegotiationStrategyMarginResult = {
  __typename?: 'NegotiationStrategyMarginResult';
  acceptedMarginPerConversation?: Maybe<Scalars['Float']['output']>;
  bookedMarginPerConversation?: Maybe<Scalars['Float']['output']>;
  conversationCount: Scalars['Int']['output'];
  totalAcceptedMargin?: Maybe<Scalars['Float']['output']>;
  totalBookedMargin?: Maybe<Scalars['Float']['output']>;
};

export type NegotiationStrategyOverrideInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
};

export type NegotiationStrategyPayload = {
  __typename?: 'NegotiationStrategyPayload';
  negotiationStrategy: NegotiationStrategy;
};

/** The type of negotiation strategy */
export enum NegotiationStrategyType {
  AB_TEST = 'AB_TEST',
  ACCEPT_UP_TO_MAX = 'ACCEPT_UP_TO_MAX',
  ALWAYS_ACCEPT = 'ALWAYS_ACCEPT',
  ALWAYS_DECLINE = 'ALWAYS_DECLINE',
  CONDITIONAL = 'CONDITIONAL',
  ESCALATION = 'ESCALATION',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  NEVER_BUDGE = 'NEVER_BUDGE',
  PERCENTAGE_BASED = 'PERCENTAGE_BASED',
  SMART_PRICING = 'SMART_PRICING'
}

export type NeverBudgeConfigType = {
  __typename?: 'NeverBudgeConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type NewClassifiedEmailThreadTriggerConfig = {
  __typename?: 'NewClassifiedEmailThreadTriggerConfig';
  classifications: Array<Scalars['String']['output']>;
  /** Which scanned mailboxes the trigger watches. WORKERS (default) only watches the skill workers’ own mailboxes; ORGANIZATION watches every scanned mailbox in the organization and runs as the skill’s single worker. */
  mailboxes?: Maybe<EmailTriggerMailboxScope>;
  override?: Maybe<BaseTriggerOverride>;
  recipientEmails?: Maybe<Array<Scalars['String']['output']>>;
  senderEmails?: Maybe<Array<Scalars['String']['output']>>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  sideEffectPolicy?: Maybe<ActionTriggerSideEffectPolicy>;
  triggerType: ActionTriggerConfigType;
};

export type NightHoursSettings = {
  __typename?: 'NightHoursSettings';
  endHour?: Maybe<Scalars['Float']['output']>;
  skipAllMilestones?: Maybe<Scalars['Boolean']['output']>;
  startHour?: Maybe<Scalars['Float']['output']>;
  /** During quiet hours, allow pre-stop checks when the stop is within this many minutes. Deferred checks catch up when quiet hours end. */
  windowMinutes?: Maybe<Scalars['Float']['output']>;
};

export type NightHoursSettingsInput = {
  endHour?: InputMaybe<Scalars['Float']['input']>;
  skipAllMilestones?: InputMaybe<Scalars['Boolean']['input']>;
  startHour?: InputMaybe<Scalars['Float']['input']>;
  /** During quiet hours, allow pre-stop checks when the stop is within this many minutes. Deferred checks catch up when quiet hours end. */
  windowMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type NoWorkersConfig = {
  __typename?: 'NoWorkersConfig';
  type: WorkersConfigType;
};

/** An object with an ID */
export type Node = {
  id: Scalars['ID']['output'];
};

export type NotReadyForCoverageData = {
  __typename?: 'NotReadyForCoverageData';
  eventType: MovementEventType;
};

export type NotYetDispatchedExceptionSettings = {
  __typename?: 'NotYetDispatchedExceptionSettings';
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Minutes before pickup to check whether the movement has ever been dispatched. Defaults to 120 (2 hours) when unset. */
  minutesBeforePickup?: Maybe<Scalars['Float']['output']>;
};

export type NotYetDispatchedExceptionSettingsInput = {
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Minutes before pickup to check whether the movement has ever been dispatched. Defaults to 120 (2 hours) when unset. */
  minutesBeforePickup?: InputMaybe<Scalars['Float']['input']>;
};

export type NotesField = {
  __typename?: 'NotesField';
  notes: Scalars['String']['output'];
  notesType: NotesType;
};

export type NotesFieldInput = {
  notes: Scalars['String']['input'];
  notesType: NotesType;
};

export type NotesFields = {
  __typename?: 'NotesFields';
  notesFields: Array<NotesField>;
};

export type NotesFieldsInput = {
  notesFields: Array<NotesFieldInput>;
};

export enum NotesType {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export type NotificationSettingsInput = {
  organizationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationSettingsPayload = {
  __typename?: 'NotificationSettingsPayload';
  /** Settings for each level, including inherited settings. */
  resolvedSettingsByLevel: MultLevelNotificationSettings;
  /** Only the settings defined for each level. */
  settingsByLevel: MultLevelNotificationSettings;
};

/** Whether an offset is applied before or after its anchor. */
export enum OffsetDirection {
  AFTER = 'AFTER',
  BEFORE = 'BEFORE'
}

export type OnboardNewOriginatorInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  autoSubmitScope?: InputMaybe<AutoSubmitScope>;
  configOverrides?: InputMaybe<Scalars['JSON']['input']>;
  expectedWeeklyOrderCount?: InputMaybe<Scalars['Float']['input']>;
  externalIdMappings?: InputMaybe<Array<UpdateExternalIdMappingInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  quoteAutoReplyScope?: InputMaybe<QuoteAutoReplyScope>;
  scheduleSettingsId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<OriginatorStatus>;
  trackSettingsId?: InputMaybe<Scalars['ID']['input']>;
  transmitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  voomaSupportNotes?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardNewOriginatorPayload = {
  __typename?: 'OnboardNewOriginatorPayload';
  customerFacingOriginator: Originator;
  shadowOriginator: Originator;
  success: Scalars['Boolean']['output'];
};

export type OpenEscalationsInput = {
  createdAfter: Scalars['DateTimeISO']['input'];
  organizationId: Scalars['ID']['input'];
};

export type OpendockAvailabilityCheckFields = {
  __typename?: 'OpendockAvailabilityCheckFields';
  day: Scalars['String']['output'];
  dock: OpendockDock;
  docks: Array<OpendockDock>;
  loadType: OpendockLoadType;
  loadTypes: Array<OpendockLoadType>;
  schedulePortalType: SchedulePortalType;
  warehouse: OpendockWarehouse;
  warehouses: Array<OpendockWarehouse>;
};

export type OpendockDock = {
  __typename?: 'OpendockDock';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OpendockLoadType = {
  __typename?: 'OpendockLoadType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OpendockWarehouse = {
  __typename?: 'OpendockWarehouse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OperationalIssue = {
  __typename?: 'OperationalIssue';
  description: Scalars['String']['output'];
  firstSeenAt: Scalars['DateTimeISO']['output'];
  /** The chat where the investigator posts findings and requests approvals */
  handlerConversationId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['DateTimeISO']['output'];
  loadReference?: Maybe<Scalars['String']['output']>;
  occurrenceCount: Scalars['Int']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  /** Open requests raised by the investigator, of any type */
  pendingApprovalCount: Scalars['Int']['output'];
  severity: OperationalIssueSeverity;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum OperationalIssueSeverity {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type OperationalIssuesInput = {
  /** Defaults to every organization */
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Only issues seen since this time */
  since?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export enum OptimismStatus {
  CONFIRMED = 'CONFIRMED',
  OPTIMISTIC = 'OPTIMISTIC',
  USER_INITIATED = 'USER_INITIATED'
}

export type Order = AbstractEntity & Node & {
  __typename?: 'Order';
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTimeISO']['output'];
  createdAtDisplay?: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  documents: Array<JobDocument>;
  externalDeepLink?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalIdMappings: Array<ExternalIdMapping>;
  externalOrderToClone?: Maybe<ExternalOrderToClone>;
  /** Serialized as JSON */
  extractedData?: Maybe<Scalars['String']['output']>;
  hasSubmittedEvent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  job: Job;
  notes?: Maybe<Scalars['String']['output']>;
  optimismStatus: OptimismStatus;
  orderEvents: Array<OrderEvent>;
  organization: Organization;
  originator?: Maybe<Originator>;
  primaryReference?: Maybe<Scalars['String']['output']>;
  processingStatus: ProcessingStatus;
  shipmentAssociations?: Maybe<Array<OrderShipmentAssociation>>;
  transmitId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export type OrderConnection = {
  __typename?: 'OrderConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrderEdge>;
  nodes?: Maybe<Array<Order>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrderDateFilter = {
  /** List Order that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List Order that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List Order that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List Order that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Order;
};

export type OrderEvent = AbstractEntity & Node & {
  __typename?: 'OrderEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** Serialized as JSON */
  metadata?: Maybe<Scalars['JSON']['output']>;
  orderId: Scalars['String']['output'];
  type: OrderEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export type OrderEventCreatedTriggerConfig = {
  __typename?: 'OrderEventCreatedTriggerConfig';
  orderEventTypes: Array<OrderEventType>;
  originatorIds?: Maybe<Array<Scalars['String']['output']>>;
  override?: Maybe<BaseTriggerOverride>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
};

export enum OrderEventType {
  AI_INFERENCE_COMPLETED = 'AI_INFERENCE_COMPLETED',
  AI_PROCESSING_COMPLETED = 'AI_PROCESSING_COMPLETED',
  AI_PROCESSING_FAILED = 'AI_PROCESSING_FAILED',
  AI_PROCESSING_STARTED = 'AI_PROCESSING_STARTED',
  AI_PROCESSING_TRIGGERED = 'AI_PROCESSING_TRIGGERED',
  AUTO_SUBMIT_CONDITIONS_CHECK_FAILED = 'AUTO_SUBMIT_CONDITIONS_CHECK_FAILED',
  CREATED_OPTIMISTICALLY = 'CREATED_OPTIMISTICALLY',
  EXTRACTED_DATA_EDITED = 'EXTRACTED_DATA_EDITED',
  ORIGINATOR_UPDATED = 'ORIGINATOR_UPDATED',
  SUBMITTED = 'SUBMITTED',
  TMS_SUBMISSION_FAILED = 'TMS_SUBMISSION_FAILED',
  USER_CONFIRMED = 'USER_CONFIRMED'
}

export type OrderQuoteAssociation = AbstractEntity & Node & {
  __typename?: 'OrderQuoteAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  source: Order;
  target: Quote;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrderShipmentAssociation = AbstractEntity & Node & {
  __typename?: 'OrderShipmentAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  order: Order;
  organization: Organization;
  shipment: Shipment;
  source: Order;
  target: Shipment;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type OrderSupportNotificationsInput = {
  id: Scalars['String']['input'];
};

export type OrderSupportNotificationsPayload = {
  __typename?: 'OrderSupportNotificationsPayload';
  notifications: Array<Scalars['String']['output']>;
};

export enum OrderUpdateFailureReason {
  DATA_CORRUPTED = 'DATA_CORRUPTED',
  ORDER_DELETED = 'ORDER_DELETED'
}

export type OrdersInput = {
  dateFilter?: InputMaybe<OrderDateFilter>;
  hasBeenSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  outlookFilter?: InputMaybe<OutlookFilter>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrgInheritingGlobalPromptPayload = {
  __typename?: 'OrgInheritingGlobalPromptPayload';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrgSummary = {
  __typename?: 'OrgSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A company that provides truck transportation services. */
export type Organization = AbstractEntity & Node & {
  __typename?: 'Organization';
  configurableOptions?: Maybe<ConfigurableOptions>;
  createdAt: Scalars['DateTimeISO']['output'];
  /** The customer organization for this shadow organization */
  customerOrganization?: Maybe<Organization>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  emailAuthPolicy?: Maybe<EmailAuthPolicy>;
  emailDomains?: Maybe<Array<Scalars['String']['output']>>;
  emailSignatures: Array<OrganizationDocumentUpload>;
  enabledFeatureFlags: Array<OrganizationFeatureFlagPayload>;
  expectedWeeklyOrderCount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  integrationConfigs?: Maybe<Scalars['JSON']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  products: Array<Product>;
  retentionPeriodHours?: Maybe<Scalars['Int']['output']>;
  settings: OrganizationSettings;
  /** The shadow organization for this customer organization */
  shadowOrganization?: Maybe<Organization>;
  ssoSettings?: Maybe<SsoSettings>;
  type?: Maybe<OrganizationType>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userEmailSignatures: Array<UserDocumentUpload>;
  users: Array<OrganizationUserRelation>;
};

export type OrganizationBillingSummary = {
  __typename?: 'OrganizationBillingSummary';
  metronomeCustomerId: Scalars['String']['output'];
  metronomeUrl: Scalars['String']['output'];
  startedAt: Scalars['DateTimeISO']['output'];
  startedByName?: Maybe<Scalars['String']['output']>;
  startsAt: Scalars['DateTimeISO']['output'];
};

export type OrganizationByIntegrationIdInput = {
  integrationType: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationEdge>;
  nodes?: Maybe<Array<Organization>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'OrganizationDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subject: Organization;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationFeatureFlagPayload = {
  __typename?: 'OrganizationFeatureFlagPayload';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationJob = AbstractEntity & Node & {
  __typename?: 'OrganizationJob';
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  schedule: OrganizationJobSchedule;
  type: OrganizationJobType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum OrganizationJobSchedule {
  DAILY = 'DAILY',
  DAILY_PRE_BUSINESS_HOURS = 'DAILY_PRE_BUSINESS_HOURS',
  WEEKLY = 'WEEKLY'
}

export enum OrganizationJobType {
  SEED_VEE_DEMO_DATA = 'SEED_VEE_DEMO_DATA',
  SEND_QUOTE_REPORT = 'SEND_QUOTE_REPORT'
}

export type OrganizationSettings = {
  __typename?: 'OrganizationSettings';
  accessPolicies?: Maybe<Scalars['JSON']['output']>;
  build?: Maybe<Scalars['JSON']['output']>;
  buildShipmentFromExternalDataInstructions?: Maybe<Scalars['String']['output']>;
  carrierInterestContext?: Maybe<Scalars['JSON']['output']>;
  cover?: Maybe<Scalars['JSON']['output']>;
  customFreightTags?: Maybe<Array<Scalars['String']['output']>>;
  defaultTimezone?: Maybe<Scalars['String']['output']>;
  emailScanning?: Maybe<Scalars['JSON']['output']>;
  emailTags?: Maybe<Scalars['JSON']['output']>;
  escalationSuppressionPeriod?: Maybe<Scalars['JSON']['output']>;
  escalations?: Maybe<Scalars['JSON']['output']>;
  front?: Maybe<Scalars['JSON']['output']>;
  glossary?: Maybe<Scalars['JSON']['output']>;
  locations?: Maybe<Scalars['JSON']['output']>;
  mcNumber?: Maybe<Scalars['String']['output']>;
  movementEvents?: Maybe<Scalars['JSON']['output']>;
  notifications?: Maybe<Scalars['JSON']['output']>;
  operatingName?: Maybe<Scalars['String']['output']>;
  otherCompanyIDs?: Maybe<Array<Scalars['String']['output']>>;
  pollStopChanges?: Maybe<Scalars['Boolean']['output']>;
  polling?: Maybe<Array<Scalars['String']['output']>>;
  pollingIntervalMinutes?: Maybe<Scalars['Int']['output']>;
  pronounceableOperatingName?: Maybe<Scalars['String']['output']>;
  pylon?: Maybe<Scalars['JSON']['output']>;
  quote?: Maybe<Scalars['JSON']['output']>;
  quoteAutoReply?: Maybe<Scalars['JSON']['output']>;
  retentionPeriodHours?: Maybe<Scalars['JSON']['output']>;
  schedule?: Maybe<Scalars['JSON']['output']>;
  simulation?: Maybe<Scalars['JSON']['output']>;
  spamGuard?: Maybe<Scalars['JSON']['output']>;
  teamsWebhookUrl?: Maybe<Scalars['String']['output']>;
  telephony?: Maybe<Scalars['JSON']['output']>;
  track?: Maybe<Scalars['JSON']['output']>;
  transfersRateLimit?: Maybe<Scalars['JSON']['output']>;
  transitModeling?: Maybe<Scalars['JSON']['output']>;
};

export type OrganizationSettingsInput = {
  accessPolicies?: InputMaybe<Scalars['JSON']['input']>;
  build?: InputMaybe<Scalars['JSON']['input']>;
  buildShipmentFromExternalDataInstructions?: InputMaybe<Scalars['String']['input']>;
  carrierInterestContext?: InputMaybe<Scalars['JSON']['input']>;
  cover?: InputMaybe<Scalars['JSON']['input']>;
  customFreightTags?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultTimezone?: InputMaybe<Scalars['String']['input']>;
  emailScanning?: InputMaybe<Scalars['JSON']['input']>;
  emailTags?: InputMaybe<Scalars['JSON']['input']>;
  escalationSuppressionPeriod?: InputMaybe<Scalars['JSON']['input']>;
  escalations?: InputMaybe<Scalars['JSON']['input']>;
  front?: InputMaybe<Scalars['JSON']['input']>;
  glossary?: InputMaybe<Scalars['JSON']['input']>;
  locations?: InputMaybe<Scalars['JSON']['input']>;
  mcNumber?: InputMaybe<Scalars['String']['input']>;
  movementEvents?: InputMaybe<Scalars['JSON']['input']>;
  notifications?: InputMaybe<Scalars['JSON']['input']>;
  operatingName?: InputMaybe<Scalars['String']['input']>;
  otherCompanyIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  pollStopChanges?: InputMaybe<Scalars['Boolean']['input']>;
  polling?: InputMaybe<Array<Scalars['String']['input']>>;
  pollingIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  pronounceableOperatingName?: InputMaybe<Scalars['String']['input']>;
  pylon?: InputMaybe<Scalars['JSON']['input']>;
  quote?: InputMaybe<Scalars['JSON']['input']>;
  quoteAutoReply?: InputMaybe<Scalars['JSON']['input']>;
  retentionPeriodHours?: InputMaybe<Scalars['JSON']['input']>;
  schedule?: InputMaybe<Scalars['JSON']['input']>;
  simulation?: InputMaybe<Scalars['JSON']['input']>;
  spamGuard?: InputMaybe<Scalars['JSON']['input']>;
  teamsWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  telephony?: InputMaybe<Scalars['JSON']['input']>;
  track?: InputMaybe<Scalars['JSON']['input']>;
  transfersRateLimit?: InputMaybe<Scalars['JSON']['input']>;
  transitModeling?: InputMaybe<Scalars['JSON']['input']>;
};

export enum OrganizationType {
  CUSTOMER = 'CUSTOMER',
  SHADOW = 'SHADOW'
}

/** A relation between an Organization and a user. */
export type OrganizationUserRelation = AbstractEntity & Node & {
  __typename?: 'OrganizationUserRelation';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  roles: Array<OrganizationUserRole>;
  teamMemberships: Array<TeamMember>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

/** Connection for organization <> user relations. */
export type OrganizationUserRelationConnection = {
  __typename?: 'OrganizationUserRelationConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationUserRelationEdge>;
  nodes?: Maybe<Array<OrganizationUserRelation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationUserRelationEdge = {
  __typename?: 'OrganizationUserRelationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: OrganizationUserRelation;
};

export type OrganizationUserRelationsInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<OrganizationUserRole>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationUserRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
  OWNER = 'OWNER',
  TEST_ONLY_READ_ONLY = 'TEST_ONLY_READ_ONLY'
}

export type OrganizationsInput = {
  integration?: InputMaybe<IntegrationOptions>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type Originator = AbstractEntity & Node & {
  __typename?: 'Originator';
  attributes?: Maybe<Scalars['JSON']['output']>;
  autoSubmitScope: AutoSubmitScope;
  /** Serialized as JSON */
  configOverrides?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enabledFeatureFlags: Array<OriginatorFeatureFlagPayload>;
  expectedWeeklyOrderCount?: Maybe<Scalars['Float']['output']>;
  externalIdMappings: Array<ExternalIdMapping>;
  flagged: Scalars['Boolean']['output'];
  hasExtractedDataConfigured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  knownSenders: Array<Contact>;
  memoryEntityLinks: Array<MemoryEntityLink>;
  name: Scalars['String']['output'];
  nameEmbedding?: Maybe<Array<Scalars['Float']['output']>>;
  orderCount?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  owner?: Maybe<User>;
  quoteAutoReplyScope: QuoteAutoReplyScope;
  quoteCount?: Maybe<Scalars['Int']['output']>;
  scheduleSettings?: Maybe<ScheduleSettings>;
  scheduleSettingsId?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  status: OriginatorStatus;
  templates: Array<Template>;
  trackSettings?: Maybe<TrackSettings>;
  trackSettingsId?: Maybe<Scalars['String']['output']>;
  transmitIds: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  voomaSupportNotes: Scalars['String']['output'];
  workflows: Array<Workflow>;
};

export type OriginatorConfiguration = {
  __typename?: 'OriginatorConfiguration';
  status: OriginatorStatus;
};

export type OriginatorConnection = {
  __typename?: 'OriginatorConnection';
  count: Scalars['Int']['output'];
  edges: Array<OriginatorEdge>;
  nodes?: Maybe<Array<Originator>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum OriginatorCreationFailureReason {
  DUPLICATE = 'DUPLICATE'
}

export type OriginatorEdge = {
  __typename?: 'OriginatorEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Originator;
};

export type OriginatorEvent = AbstractEntity & Node & {
  __typename?: 'OriginatorEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<OriginatorEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: OriginatorEventType;
  originator: Originator;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type OriginatorEventConnection = {
  __typename?: 'OriginatorEventConnection';
  count: Scalars['Int']['output'];
  edges: Array<OriginatorEventEdge>;
  nodes?: Maybe<Array<OriginatorEvent>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OriginatorEventData = {
  __typename?: 'OriginatorEventData';
  configurationState?: Maybe<OriginatorConfiguration>;
};

export type OriginatorEventEdge = {
  __typename?: 'OriginatorEventEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: OriginatorEvent;
};

export enum OriginatorEventType {
  EXTRACTED_FIELDS_CONFIGURED = 'EXTRACTED_FIELDS_CONFIGURED'
}

export type OriginatorEventsInput = {
  originatorId?: InputMaybe<Scalars['String']['input']>;
};

export type OriginatorFeatureFlagPayload = {
  __typename?: 'OriginatorFeatureFlagPayload';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum OriginatorStatus {
  PRODUCTION = 'PRODUCTION',
  TEST = 'TEST'
}

export type OriginatorsInput = {
  autoSubmitScopes?: InputMaybe<Array<AutoSubmitScope>>;
  excludeTrackSettingsId?: InputMaybe<Scalars['ID']['input']>;
  filterById?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTrackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quoteAutoReplyScopes?: InputMaybe<Array<QuoteAutoReplyScope>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<OriginatorStatus>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  trackSettingsId?: InputMaybe<Scalars['ID']['input']>;
  transmitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OtherShipmentEventData = {
  __typename?: 'OtherShipmentEventData';
  eventType: ShipmentEventType;
};

export type OutcomeLabel = {
  __typename?: 'OutcomeLabel';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OutlookFilter = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** Address of the mailbox the add-in is viewing */
  mailboxAddress?: InputMaybe<Scalars['String']['input']>;
  sharedInbox?: InputMaybe<Scalars['String']['input']>;
};

export type OutlookMessageData = {
  /** Outlook item.itemId converted to REST format */
  itemId: Scalars['String']['input'];
  /** Use itemId instead. */
  messageId: Scalars['String']['input'];
};

export enum OutreachCallStage {
  AI_REJECTION = 'AI_REJECTION',
  CONNECTED = 'CONNECTED',
  INVALID_NUMBER = 'INVALID_NUMBER',
  OFFER_RECEIVED = 'OFFER_RECEIVED',
  PARTICIPATED_IN_NEGOTIATION = 'PARTICIPATED_IN_NEGOTIATION',
  RATE_AGREED = 'RATE_AGREED',
  REACHED_DISPATCH = 'REACHED_DISPATCH',
  REACHED_HUMAN = 'REACHED_HUMAN',
  SHARED_LOAD_DETAILS = 'SHARED_LOAD_DETAILS',
  VOICEMAIL = 'VOICEMAIL'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInput = {
  context: AnalyticsContext;
  name: Scalars['String']['input'];
  properties?: InputMaybe<PageProperties>;
};

export type PageProperties = {
  actionDefinitionId?: InputMaybe<Scalars['String']['input']>;
  carrierRateId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  originatorName?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  pricingStrategyId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Product>>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ParamCellValue = {
  __typename?: 'ParamCellValue';
  inPromptSchema: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  promptId?: Maybe<Scalars['ID']['output']>;
  source: ValueSource;
  teamOverrides: Array<TeamOverrideValue>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ParsedEmail = {
  __typename?: 'ParsedEmail';
  attachments: Array<EmailAttachment>;
  html: Scalars['String']['output'];
  metadata: EmailHeaderMetadata;
};

export type PercentageBasedConfigType = {
  __typename?: 'PercentageBasedConfigType';
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  incrementPercentage: Scalars['Float']['output'];
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type PhoneConversationMetadata = {
  __typename?: 'PhoneConversationMetadata';
  conferenceId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  fromPhoneNumber: Scalars['String']['output'];
  initiationDirection: ConversationInitiationDirection;
  /** Used when this conversation is an attempt to connect a new caller into an existing conference. The ID of the conference that can be joined by the caller. */
  joinableConferenceId?: Maybe<Scalars['String']['output']>;
  telephonyDurationSeconds?: Maybe<Scalars['Int']['output']>;
  toPhoneNumber: Scalars['String']['output'];
  toPhoneNumberExtension?: Maybe<Scalars['String']['output']>;
  transferCallSid?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  extension?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type PhoneNumberConfig = {
  aiPhoneNumberId?: InputMaybe<Scalars['ID']['input']>;
  areaCode?: InputMaybe<Scalars['Int']['input']>;
};

export type PhoneNumberInput = {
  extension?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PickupActualArrivalSettings = {
  __typename?: 'PickupActualArrivalSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PickupActualArrivalSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PickupActualDepartureSettings = {
  __typename?: 'PickupActualDepartureSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type PickupActualDepartureSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PickupAfterSettings = {
  __typename?: 'PickupAfterSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minutesAfter?: Maybe<Scalars['Float']['output']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, MINUTES_AFTER applies. The phase-level minutesAfter is legacy and moves into the MINUTES_AFTER params on save. */
  triggers?: Maybe<Array<MilestoneAfterTriggerSettings>>;
};

export type PickupAfterSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minutesAfter?: InputMaybe<Scalars['Float']['input']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, MINUTES_AFTER applies. The phase-level minutesAfter is legacy and moves into the MINUTES_AFTER params on save. */
  triggers?: InputMaybe<Array<MilestoneAfterTriggerSettingsInput>>;
};

export type PickupAtSettings = {
  __typename?: 'PickupAtSettings';
  delayMinutes?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, DELAY applies. The phase-level delayMinutes is legacy and moves into the DELAY params on save. */
  triggers?: Maybe<Array<MilestoneAtTriggerSettings>>;
};

export type PickupAtSettingsInput = {
  delayMinutes?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ways to time the check, one per type. At most one is enabled; with none enabled, DELAY applies. The phase-level delayMinutes is legacy and moves into the DELAY params on save. */
  triggers?: InputMaybe<Array<MilestoneAtTriggerSettingsInput>>;
};

export type PickupBeforeSettings = {
  __typename?: 'PickupBeforeSettings';
  /** @deprecated Use the ADVANCED entry params in triggers instead */
  advanced?: Maybe<AdvancedBeforeTriggerSettings>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  minutesBefore?: Maybe<Scalars['Float']['output']>;
  suppressIfCarrierChangedWithinMinutes?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use triggers instead */
  trigger?: Maybe<MilestoneBeforeTrigger>;
  /** Ways to time the pre-pickup check, one per type with its own params. At most one is enabled; disabled entries keep their params so they can be re-enabled. */
  triggers?: Maybe<Array<MilestoneBeforeTriggerSettings>>;
};

export type PickupBeforeSettingsInput = {
  /** @deprecated Use the ADVANCED entry params in triggers instead */
  advanced?: InputMaybe<AdvancedBeforeTriggerSettingsInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  minutesBefore?: InputMaybe<Scalars['Float']['input']>;
  suppressIfCarrierChangedWithinMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use triggers instead */
  trigger?: InputMaybe<MilestoneBeforeTrigger>;
  /** Ways to time the pre-pickup check, one per type with its own params. At most one is enabled; disabled entries keep their params so they can be re-enabled. */
  triggers?: InputMaybe<Array<MilestoneBeforeTriggerSettingsInput>>;
};

export type PickupTrackEventSettings = {
  __typename?: 'PickupTrackEventSettings';
  /** Fires ARRIVED_AT_PICKUP_ACTUAL once when the first pickup records an actual arrival. */
  actualArrival?: Maybe<PickupActualArrivalSettings>;
  /** Fires DEPARTED_PICKUP_ACTUAL once when the first pickup records an actual departure. */
  actualDeparture?: Maybe<PickupActualDepartureSettings>;
  after?: Maybe<PickupAfterSettings>;
  at?: Maybe<PickupAtSettings>;
  before?: Maybe<PickupBeforeSettings>;
  /** @deprecated Use before.triggers instead */
  beforeConfigs?: Maybe<Array<PickupBeforeSettings>>;
  /** @deprecated Use before/after/at `enabled` flags instead */
  checkTypes?: Maybe<Array<CheckTypes>>;
  preDispatch?: Maybe<PreDispatchSettings>;
  /** @deprecated Use before.minutesBefore / after.minutesAfter instead */
  timeWindowMinutes?: Maybe<Scalars['Float']['output']>;
};

export type PickupTrackEventSettingsInput = {
  /** Fires ARRIVED_AT_PICKUP_ACTUAL once when the first pickup records an actual arrival. */
  actualArrival?: InputMaybe<PickupActualArrivalSettingsInput>;
  /** Fires DEPARTED_PICKUP_ACTUAL once when the first pickup records an actual departure. */
  actualDeparture?: InputMaybe<PickupActualDepartureSettingsInput>;
  after?: InputMaybe<PickupAfterSettingsInput>;
  at?: InputMaybe<PickupAtSettingsInput>;
  before?: InputMaybe<PickupBeforeSettingsInput>;
  /** @deprecated Use before.triggers instead */
  beforeConfigs?: InputMaybe<Array<PickupBeforeSettingsInput>>;
  checkTypes?: InputMaybe<Array<CheckTypes>>;
  preDispatch?: InputMaybe<PreDispatchSettingsInput>;
  timeWindowMinutes?: InputMaybe<Scalars['Float']['input']>;
};

/** A location, such as a warehouse or distribution center. */
export type Place = AbstractEntity & Node & {
  __typename?: 'Place';
  address?: Maybe<PlaceAddress>;
  addressEmbedding?: Maybe<Array<Scalars['Float']['output']>>;
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTimeISO']['output'];
  creationProvenance?: Maybe<PlaceCreationProvenance>;
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  externalIdMappings: Array<ExternalIdMapping>;
  geoPoint?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  locationCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<NotesFields>;
  organization: Organization;
  originator?: Maybe<Originator>;
  tags: Array<PlaceTag>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** The address associated with a place. */
export type PlaceAddress = {
  __typename?: 'PlaceAddress';
  /** Main address, typically contains street and building number. Ex: 1234 Main Street. */
  addressOne?: Maybe<Scalars['String']['output']>;
  /** Optional address line 2, typically used for apartment/suite number. */
  addressTwo?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PlaceAddressInput = {
  /** Main address, typically contains street and building number. Ex: 1234 Main Street. */
  addressOne?: InputMaybe<Scalars['String']['input']>;
  /** Optional address line 2, typically used for apartment/suite number. */
  addressTwo?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Connection type for a place, such as a warehouse or distribution center. */
export type PlaceConnection = {
  __typename?: 'PlaceConnection';
  count: Scalars['Int']['output'];
  edges: Array<PlaceEdge>;
  nodes?: Maybe<Array<Place>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PlaceCreationFailureReason {
  DUPLICATE = 'DUPLICATE'
}

export enum PlaceCreationProvenance {
  FROM_CUSTOMER = 'FROM_CUSTOMER',
  UNKNOWN = 'UNKNOWN',
  VOOMA_AI_GENERATED = 'VOOMA_AI_GENERATED',
  VOOMA_MANUALLY_CREATED = 'VOOMA_MANUALLY_CREATED'
}

export type PlaceEdge = {
  __typename?: 'PlaceEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Place;
};

export type PlaceScheduling = {
  __typename?: 'PlaceScheduling';
  methods: Array<PlaceSchedulingMethod>;
  placeId: Scalars['ID']['output'];
};

export type PlaceSchedulingMethod = {
  __typename?: 'PlaceSchedulingMethod';
  id: Scalars['ID']['output'];
  method: Scalars['JSON']['output'];
};

export type PlaceSchedulingPayload = {
  __typename?: 'PlaceSchedulingPayload';
  scheduling: PlaceScheduling;
};

export enum PlaceTag {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP'
}

export type PlacesInput = {
  address?: InputMaybe<LocationAddressFilter>;
  addressString?: InputMaybe<Scalars['String']['input']>;
  locationCode?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<PlaceTag>>;
};

export enum PlanningApproach {
  AGENTIC = 'AGENTIC',
  DETERMINISTIC = 'DETERMINISTIC'
}

export enum PlanningSequence {
  BACKWARD_FROM_LAST_DELIVERY = 'BACKWARD_FROM_LAST_DELIVERY',
  FORWARD_FROM_FIRST_PICKUP = 'FORWARD_FROM_FIRST_PICKUP'
}

export type PlanningSettings = AgenticPlannerSettings | DeterministicPlanningSettings;

export type PlanningSettingsInput = {
  sequencing?: InputMaybe<PlanningSequence>;
  type: PlanningApproach;
};

export enum PluginLandingPage {
  ACTIVITY = 'ACTIVITY',
  CHATS = 'CHATS'
}

export type PokeActionExecutionInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
};

export type PokeActionExecutionPayload = {
  __typename?: 'PokeActionExecutionPayload';
  success: Scalars['Boolean']['output'];
};

export enum PostCompletionMessageBehavior {
  CREATE_EXCEPTION = 'CREATE_EXCEPTION',
  DO_NOTHING = 'DO_NOTHING',
  REOPEN = 'REOPEN'
}

export type PostToLoadBoardInput = {
  expiryTimeInHours?: InputMaybe<Scalars['Float']['input']>;
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  postingUserId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type PostToLoadBoardPayload = {
  __typename?: 'PostToLoadBoardPayload';
  error?: Maybe<Scalars['String']['output']>;
  externalIdMapping?: Maybe<ExternalIdMapping>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PostedToLoadBoardData = {
  __typename?: 'PostedToLoadBoardData';
  eventType: MovementEventType;
  posting?: Maybe<LoadBoardPosting>;
  postingUserId?: Maybe<Scalars['String']['output']>;
};

export type PreDispatchSettings = {
  __typename?: 'PreDispatchSettings';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Legacy MINUTES_BEFORE lead time, used when triggers has no MINUTES_BEFORE params. Minimum is 1; maximum is 1440. */
  minutesBefore?: Maybe<Scalars['Float']['output']>;
  /** Ways to open the pre-dispatch window, one per type. At most one is enabled; with none enabled, MINUTES_BEFORE applies. */
  triggers?: Maybe<Array<PreDispatchTriggerSettings>>;
};

export type PreDispatchSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legacy MINUTES_BEFORE lead time, used when triggers has no MINUTES_BEFORE params. Minimum is 1; maximum is 1440. */
  minutesBefore?: InputMaybe<Scalars['Float']['input']>;
  /** Ways to open the pre-dispatch window, one per type. At most one is enabled; with none enabled, MINUTES_BEFORE applies. */
  triggers?: InputMaybe<Array<PreDispatchTriggerSettingsInput>>;
};

/** Strategy for when the PRE_DISPATCH milestone window opens. */
export enum PreDispatchTrigger {
  ADVANCED = 'ADVANCED',
  EVENING_BEFORE_OR_MORNING_OF = 'EVENING_BEFORE_OR_MORNING_OF',
  MINUTES_BEFORE = 'MINUTES_BEFORE'
}

export type PreDispatchTriggerParams = {
  __typename?: 'PreDispatchTriggerParams';
  /** ADVANCED: offset for pickup appointments (pickup start equals pickup end). */
  appointment?: Maybe<AdvancedTriggerOffset>;
  /** EVENING_BEFORE_OR_MORNING_OF: local hour (10-16) splitting early and late pickups. Defaults to 13. */
  cutoffHour?: Maybe<Scalars['Int']['output']>;
  /** EVENING_BEFORE_OR_MORNING_OF: hours before the cutoff to open for pickups at or before it; must open between the cutoff and 7 p.m. the day before. Defaults to 6 p.m. the day before. */
  hoursBeforeCutoffForEarlyPickups?: Maybe<Scalars['Int']['output']>;
  /** EVENING_BEFORE_OR_MORNING_OF: hours before the cutoff to open for pickups after it; must open between 5 a.m. and 4 hours before the cutoff. Defaults to 8 a.m. */
  hoursBeforeCutoffForLatePickups?: Maybe<Scalars['Int']['output']>;
  /** MINUTES_BEFORE: minutes before pickup to open the window (1-1440). Defaults to 1440. */
  minutesBefore?: Maybe<Scalars['Float']['output']>;
  /** ADVANCED: offsets by pickup window duration. */
  windowTiers?: Maybe<Array<AdvancedTriggerWindowTier>>;
};

export type PreDispatchTriggerParamsInput = {
  /** ADVANCED: offset for pickup appointments (pickup start equals pickup end). */
  appointment?: InputMaybe<AdvancedTriggerOffsetInput>;
  /** EVENING_BEFORE_OR_MORNING_OF: local hour (10-16) splitting early and late pickups. Defaults to 13. */
  cutoffHour?: InputMaybe<Scalars['Int']['input']>;
  /** EVENING_BEFORE_OR_MORNING_OF: hours before the cutoff to open for pickups at or before it; must open between the cutoff and 7 p.m. the day before. Defaults to 6 p.m. the day before. */
  hoursBeforeCutoffForEarlyPickups?: InputMaybe<Scalars['Int']['input']>;
  /** EVENING_BEFORE_OR_MORNING_OF: hours before the cutoff to open for pickups after it; must open between 5 a.m. and 4 hours before the cutoff. Defaults to 8 a.m. */
  hoursBeforeCutoffForLatePickups?: InputMaybe<Scalars['Int']['input']>;
  /** MINUTES_BEFORE: minutes before pickup to open the window (1-1440). Defaults to 1440. */
  minutesBefore?: InputMaybe<Scalars['Float']['input']>;
  /** ADVANCED: offsets by pickup window duration. */
  windowTiers?: InputMaybe<Array<AdvancedTriggerWindowTierInput>>;
};

export type PreDispatchTriggerSettings = {
  __typename?: 'PreDispatchTriggerSettings';
  enabled: Scalars['Boolean']['output'];
  params?: Maybe<PreDispatchTriggerParams>;
  triggerType: PreDispatchTrigger;
};

export type PreDispatchTriggerSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  params?: InputMaybe<PreDispatchTriggerParamsInput>;
  triggerType: PreDispatchTrigger;
};

export type PrePickupDelayStartedData = {
  __typename?: 'PrePickupDelayStartedData';
  eventType: MovementEventType;
};

export type PreferredLane = AbstractEntity & Node & {
  __typename?: 'PreferredLane';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  destinationName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  originName: Scalars['String']['output'];
  route: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type PricingStrategiesInput = {
  organizationIds: Array<Scalars['ID']['input']>;
  originatorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PricingStrategy = AbstractEntity & Node & {
  __typename?: 'PricingStrategy';
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  originator?: Maybe<Originator>;
  team?: Maybe<Team>;
  type: PricingStrategyType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
};

export type PricingStrategyInstructionIssue = {
  __typename?: 'PricingStrategyInstructionIssue';
  explanation: Scalars['String']['output'];
  rule: Scalars['String']['output'];
};

export enum PricingStrategyType {
  ACTION_DEFINITION = 'ACTION_DEFINITION',
  MILEAGE_BASED = 'MILEAGE_BASED',
  MILEAGE_RATE = 'MILEAGE_RATE',
  SIMPLE_MARGIN = 'SIMPLE_MARGIN',
  WEIGHTED_AVERAGE = 'WEIGHTED_AVERAGE'
}

export type PricingStrategyValidationPayload = {
  __typename?: 'PricingStrategyValidationPayload';
  isValid: Scalars['Boolean']['output'];
  issues: Array<PricingStrategyInstructionIssue>;
};

export type Procedure = ConversationGraphProcedure | DeterministicProcedure | GraphDefinedProcedure | NaturalLanguageProcedure;

export enum ProcedureType {
  CONVERSATION_GRAPH = 'CONVERSATION_GRAPH',
  DETERMINISTIC = 'DETERMINISTIC',
  GRAPH = 'GRAPH',
  NATURAL_LANGUAGE = 'NATURAL_LANGUAGE'
}

/** Processing status, generally used for long-running jobs */
export enum ProcessingStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  NEW = 'NEW',
  PROCESSING = 'PROCESSING'
}

export enum Product {
  CALLS = 'CALLS',
  COVER = 'COVER',
  EMAIL_SCANNING = 'EMAIL_SCANNING',
  ORDERS = 'ORDERS',
  QUOTES = 'QUOTES',
  SCHEDULE = 'SCHEDULE',
  TRACK = 'TRACK',
  VEE = 'VEE',
  WORKERS = 'WORKERS'
}

export type ProductSpend = {
  __typename?: 'ProductSpend';
  name: Scalars['String']['output'];
  totalCents: Scalars['Float']['output'];
};

export type ProductUsage = {
  __typename?: 'ProductUsage';
  credits: Scalars['Float']['output'];
  /** @deprecated Usage is shown in credits */
  inputTokens: Scalars['Float']['output'];
  /** @deprecated Usage is shown in credits */
  outputTokens: Scalars['Float']['output'];
  /** @deprecated Usage is shown in credits */
  phoneSeconds: Scalars['Float']['output'];
  product: Scalars['String']['output'];
  spendCents: Scalars['Float']['output'];
};

export type ProposeFreightDataMappingValuesInput = {
  key: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: FreightDataMappingType;
};

export type ProposeFreightDataMappingValuesPayload = {
  __typename?: 'ProposeFreightDataMappingValuesPayload';
  proposedValues: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
};

export type ProposeGlobalPromptSopAlignmentInput = {
  actionDefinitionId: Scalars['ID']['input'];
  comparisonVersion?: InputMaybe<Scalars['Int']['input']>;
  globalPromptId?: InputMaybe<Scalars['ID']['input']>;
  mode: GlobalPromptSopProposalMode;
};

export type ProposeGlobalPromptSopAlignmentPayload = {
  __typename?: 'ProposeGlobalPromptSopAlignmentPayload';
  proposals: Array<SopEditProposalItem>;
};

export type ProvisionAiPhoneNumberInput = {
  areaCode: Scalars['Int']['input'];
  teamId: Scalars['ID']['input'];
};

export type ProvisionAiPhoneNumberPayload = {
  __typename?: 'ProvisionAIPhoneNumberPayload';
  aiPhoneNumber: AiPhoneNumber;
  success: Scalars['Boolean']['output'];
};

export type ProvisionBrowserUseDemoInput = {
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionBrowserUseDemoPayload = {
  __typename?: 'ProvisionBrowserUseDemoPayload';
  actionDefinitionId: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
};

export type ProvisionConciergeSopInput = {
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionConciergeSopPayload = {
  __typename?: 'ProvisionConciergeSOPPayload';
  organizationId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ProvisionCoverForTeamInput = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  coverQuotesConfig?: InputMaybe<CoverQuotesConfig>;
  coveragePlanGenerator?: InputMaybe<CoveragePlanGeneratorInput>;
  existingInboundCallOnQuoteRootAdId?: InputMaybe<Scalars['ID']['input']>;
  existingInboundCarrierCallRootAdId?: InputMaybe<Scalars['ID']['input']>;
  existingInboundCarrierEmailRootAdId?: InputMaybe<Scalars['ID']['input']>;
  existingOutboundCarrierOutreachCallAdId?: InputMaybe<Scalars['ID']['input']>;
  existingOutboundExecuteCoveragePlanAdId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['String']['input'];
  phoneNumberConfig: PhoneNumberConfig;
  provisionCoveragePlanBatchNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  provisionFor?: ProvisionFor;
  provisionOutboundCover?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['String']['input'];
};

export type ProvisionCoverForTeamPayload = {
  __typename?: 'ProvisionCoverForTeamPayload';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type ProvisionCoverSimulationsInput = {
  organizationId: Scalars['String']['input'];
};

export type ProvisionCoverSimulationsPayload = {
  __typename?: 'ProvisionCoverSimulationsPayload';
  success: Scalars['Boolean']['output'];
};

export type ProvisionDriverStatusCheckInterviewOptions = {
  interviewerPhoneNumber: Scalars['String']['input'];
};

/** The environment to provision for */
export enum ProvisionFor {
  NEW_CUSTOMER = 'NEW_CUSTOMER',
  TESTING = 'TESTING'
}

export type ProvisionForQaInput = {
  organizationId: Scalars['ID']['input'];
  testCase: QaTestCase;
};

export type ProvisionForQaPayload = {
  __typename?: 'ProvisionForQAPayload';
  actionDefinitionId: Scalars['ID']['output'];
};

export type ProvisionInterviewInput = {
  options: ProvisionInterviewOptions;
  organizationId: Scalars['String']['input'];
};

export type ProvisionInterviewOptions = {
  driverStatusCheck?: InputMaybe<ProvisionDriverStatusCheckInterviewOptions>;
};

export type ProvisionInterviewPayload = {
  __typename?: 'ProvisionInterviewPayload';
  actionDefinitionId: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type ProvisionLabelingConciergeInput = {
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionLabelingConciergePayload = {
  __typename?: 'ProvisionLabelingConciergePayload';
  organizationId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ProvisionQuoteForOrgInput = {
  integrations: Array<IntegrationType>;
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionQuoteForOrgPayload = {
  __typename?: 'ProvisionQuoteForOrgPayload';
  organizationId: Scalars['String']['output'];
};

export type ProvisionQuoteForTeamInput = {
  integrations: Array<IntegrationType>;
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
  teamId: Scalars['String']['input'];
  workerEmail: Scalars['String']['input'];
};

export type ProvisionQuoteForTeamPayload = {
  __typename?: 'ProvisionQuoteForTeamPayload';
  actionDefinitionId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export type ProvisionQuoteOriginatorsInput = {
  organizationId: Scalars['String']['input'];
};

export type ProvisionQuoteOriginatorsPayload = {
  __typename?: 'ProvisionQuoteOriginatorsPayload';
  success: Scalars['Boolean']['output'];
};

export type ProvisionQuoteSimulationsInput = {
  organizationId: Scalars['String']['input'];
};

export type ProvisionQuoteSimulationsPayload = {
  __typename?: 'ProvisionQuoteSimulationsPayload';
  success: Scalars['Boolean']['output'];
};

export type ProvisionRunnersInput = {
  organizationId: Scalars['String']['input'];
};

export type ProvisionRunnersPayload = {
  __typename?: 'ProvisionRunnersPayload';
  created: Array<ProvisionedRunner>;
  existing: Array<ProvisionedRunner>;
};

export type ProvisionScheduleInput = {
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionSchedulePayload = {
  __typename?: 'ProvisionSchedulePayload';
  success: Scalars['Boolean']['output'];
};

export type ProvisionShareCoveragePlanSopInput = {
  externalChannel?: InputMaybe<CoveragePlanExternalChannelInput>;
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionShareCoveragePlanSopPayload = {
  __typename?: 'ProvisionShareCoveragePlanSopPayload';
  actionDefinitionId: Scalars['String']['output'];
  triggerCreated: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type ProvisionTrackInput = {
  organizationId: Scalars['String']['input'];
  phoneNumberConfig: PhoneNumberConfig;
  provisionAdHocOutreach?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtDeliveryCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtDeliveryCdrCdiStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtDeliveryCdrStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtDeliverySingleThread?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtPickupActualCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtPickupCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtPickupCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtPickupCdrCdiStediEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtPickupCdrStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionAtPickupSingleThread?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRoute?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcDrInfoMissingEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcInvalidTrackingLinkEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcInvalidTrackingLinkSmsDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcNotMovingCDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcNotMovingEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcNotMovingSmsDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcRunLateCDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcRunLateCloseToDeliveryCDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcRunLateEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcRunLateSmsDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcTrackDataNotAvailCDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcTrackDataNotAvailEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcTrackDataNotAvailSmsDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcTrackDataStaleEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteExcTrackDataStaleSmsDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteGetLocationCdrStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRoutePostShipperUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEnRouteUpdateTms?: InputMaybe<Scalars['Boolean']['input']>;
  provisionEscalate?: InputMaybe<Scalars['Boolean']['input']>;
  provisionFor?: ProvisionFor;
  provisionNotYetDispatched?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPostDeliveryCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPostDeliveryCdrCdiStediUploadPod?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPostDeliverySingleThread?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPostPickupCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPostPickupSingleThread?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPostPickupSmsSingleThread?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDeliveryCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDeliveryCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDeliveryCdrCdiStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDispatchCdiStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDispatchCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDispatchExcDrInfoMissingStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPreDispatchExcRunLateCloseToPickupCDrEsc?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPrePickupCdiCdrStedi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPrePickupCdiStediCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPrePickupCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPrePickupSingleThread?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPrePickupStediCdi?: InputMaybe<Scalars['Boolean']['input']>;
  provisionPrePickupStediCdiCdr?: InputMaybe<Scalars['Boolean']['input']>;
  provisionTmsUpdateFailed?: InputMaybe<Scalars['Boolean']['input']>;
  provisionTrackConfigurationAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisionTrackPayload = {
  __typename?: 'ProvisionTrackPayload';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProvisionVeeInput = {
  organizationId: Scalars['String']['input'];
};

export type ProvisionVeePayload = {
  __typename?: 'ProvisionVeePayload';
  actionDefinitionId: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
};

export type ProvisionVoomaBuildAgentInput = {
  organizationId: Scalars['String']['input'];
  provisionFor?: ProvisionFor;
};

export type ProvisionVoomaBuildAgentPayload = {
  __typename?: 'ProvisionVoomaBuildAgentPayload';
  success: Scalars['Boolean']['output'];
};

export type ProvisionedRunner = {
  __typename?: 'ProvisionedRunner';
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PylonWebhookTriggerConfig = {
  __typename?: 'PylonWebhookTriggerConfig';
  /** When true, this trigger will also fire for private Pylon messages. The trigger's organization must be on the private-message-eligible whitelist. */
  includePrivateMessages?: Maybe<Scalars['Boolean']['output']>;
  override?: Maybe<BaseTriggerOverride>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
};

export enum QaTestCase {
  BASIC_GRAPH_SOP = 'BASIC_GRAPH_SOP',
  CONTRACT_CRUD_SOP = 'CONTRACT_CRUD_SOP',
  TEST_QUOTING_SOP = 'TEST_QUOTING_SOP',
  VEE = 'VEE'
}

export type Query = {
  __typename?: 'Query';
  actionDefinitionById: ActionDefinition;
  actionDefinitionTags: ActionDefinitionTagsPayload;
  actionDefinitions: ActionDefinitionConnection;
  actionExecutionById: ActionExecution;
  actionExecutionCredits?: Maybe<ActionExecutionCredits>;
  actionExecutionSummaries: ActionExecutionSummariesPayload;
  actionExecutionWithDescendants: ActionExecutionWithDescendantsPayload;
  actionExecutions: ActionExecutionConnection;
  actionTriggerById: ActionTrigger;
  actionTriggerValidation: ActionTriggerValidationPayload;
  activeLoadsCount: ActiveLoadsCount;
  adminEmailsByIds: Array<AdminEmail>;
  /** The organization's AI workers and connected mailboxes. Vooma admins only. */
  agentConversationWorkers: Array<AgentConversationWorker>;
  /** An organization's email and SMS conversations, newest first. Vooma admins only. */
  agentConversations: AgentConversationsPayload;
  allDigestsStatusForUser: Array<DigestSubscriptionStatus>;
  apiClients: ApiClientConnection;
  applicableGenericTransformations: ApplicableGenericTransformationsPayload;
  basePrompt?: Maybe<BasePromptWithVersions>;
  basePrompts: Array<BasePrompt>;
  billingDailySpend?: Maybe<Array<DailySpend>>;
  billingInvoices?: Maybe<Array<BillingInvoice>>;
  billingUsageByProduct?: Maybe<Array<ProductUsage>>;
  billingUsageByUser?: Maybe<Array<UserUsage>>;
  carrierById: Carrier;
  carrierInterestContext?: Maybe<CarrierInterestContextType>;
  carrierLaneRunsForLane: Array<CarrierLaneRun>;
  carrierRatesForLane: Array<CarrierRate>;
  carriers: CarrierConnection;
  chatSuggestions: Array<ChatSuggestion>;
  checkAgentMailAvailability: CheckAgentMailAvailabilityPayload;
  checkIntegrationCredentials: CheckIntegrationCredentialsPayload;
  classificationLockDurationSeconds: Scalars['Int']['output'];
  computeSmartPricingPriors: SmartPricingPriorsResult;
  configuredCarrierVerificationCredentialTypes: ConfiguredCarrierVerificationCredentialTypesPayload;
  contacts: ContactConnection;
  conversationById: Conversation;
  conversationExceptions: ExceptionConnection;
  conversationExperimentAssignments: Array<ExperimentParameterAssignment>;
  conversationExternalMessages: ConversationExternalMessagesConnection;
  conversationFilterOptions: ConversationFilterOptionsPayload;
  conversationHistoryLog: Array<Scalars['JSON']['output']>;
  conversationLabelBackfillActionDefinitions: Array<ActionDefinition>;
  conversationLabelBackfillPreview: ConversationLabelBackfillPreviewPayload;
  conversations: ConversationConnection;
  conversationsByIds: Array<Conversation>;
  coverAutomaticCoverageSettings: CoverAutomaticCoverageSettingsPayload;
  coverStats: CoverStats;
  coveragePlan: CoveragePlanPayload;
  coveragePlansForShipment: CoveragePlansForShipmentPayload;
  /** Evaluates the most recently updated shipments against the organization’s current coverage-readiness rule. */
  coverageStatePreview: Array<CoverageStatePreviewResult>;
  datAuthorizedUsers: Array<DatAuthorizedUserPayload>;
  downloadActionDefinition: DownloadActionDefinitionPayload;
  downloadArtifacts: DownloadArtifactsPayload;
  downloadConversationDebugPackage: DownloadConversationDebugPackagePayload;
  downloadOrder: DownloadOrderPayload;
  emailThreadChat?: Maybe<Conversation>;
  errorGroups: Array<ErrorGroup>;
  events: BaseEventConnection;
  exceptionEventsByMovementId: Array<TrackingEventWithActionExecution>;
  exceptionsByActionExecutionId: Array<Exception>;
  exceptionsByOrganization: ExceptionConnection;
  externalChannels: ExternalChannelConnection;
  externalMessageById: ExternalMessagePayload;
  externalMessageByInternetMessageId: ExternalMessagePayload;
  externalMessageMetadata: ExternalMessageMetadataPayload;
  externalMessagesByUser: ExternalMessagesByUserPayload;
  featureFlagById: FeatureFlagPayload;
  featureFlags: Array<FeatureFlag>;
  fetchBearerToken: FetchBearerTokenPayload;
  findShipment: FindShipmentPayload;
  freightDataMappings: Array<FreightDataMapping>;
  frontMailboxSubscriptions: Array<FrontMailboxSubscription>;
  frontSharedInboxes: Array<FrontInbox>;
  frontendMaintenanceMode: FrontendMaintenanceModePayload;
  genericRuleById: GenericRule;
  genericRules: Array<GenericRule>;
  genericTransformationById: GenericTransformation;
  genericTransformationTemplateInheritors: Array<GenericTransformationTemplateInheritor>;
  genericTransformationTemplates: Array<GenericTransformationTemplate>;
  genericTransformations: GenericTransformationConnection;
  getActionBehaviors: Array<ActionBehavior>;
  getActionDefinitionsUsedAsParents: Array<ActionDefinition>;
  getActivePostings?: Maybe<GetActivePostingsResponse>;
  getBraintrustDatasets: Array<BraintrustDataset>;
  getBraintrustScorers: Array<BraintrustScorer>;
  getCallDashboardEmbedUrl: Scalars['String']['output'];
  getChannelOptions: GetChannelOptionsPayload;
  getComposioToolKitDetails: ComposioToolKitDetailsPayload;
  getCoverDashboardEmbedUrl: Scalars['String']['output'];
  getEvaluationTraces: Array<EvaluationTrace>;
  getExceptionById?: Maybe<Exception>;
  getExistingCarriers: CarrierConnection;
  getExternalIdMappings: GetExternalIdMappingsPayload;
  getLoadBoardPostings: GetLoadBoardPostingsPayload;
  getOrCreateConversationWithConcierge: Conversation;
  getOrderDashboardEmbedUrl: Scalars['String']['output'];
  getOrganizationProducts: Array<Product>;
  getOriginatorOrderTemplate: GetOriginatorOrderTemplatePayload;
  getQuoteDashboardEmbedUrl: Scalars['String']['output'];
  getQuoteResponseMessage: GenerateQuoteResponseMessagePayload;
  getQuoteSimulationsActionDefinition: GetQuoteSimulationsPayload;
  getResourceResolution: GetResourceResolutionPayload;
  getSchedulePortalAvailabilityCheck: GetSchedulePortalAvailabilityCheckPayload;
  getShipmentDistance?: Maybe<ShipmentDistanceResult>;
  getShipmentLinkageDashboardEmbedUrl: Scalars['String']['output'];
  getSuggestedCarriers: GetSuggestedCarriersPayload;
  getTrackDashboardEmbedUrl: Scalars['String']['output'];
  globalPromptById?: Maybe<GlobalPromptWithVersions>;
  globalPromptSnapshots: Array<GlobalPromptWithVersions>;
  globalPrompts: Array<GlobalPrompt>;
  graphqlToolCatalog: Array<GraphqlToolCatalogEntry>;
  hasAuthorizedServiceType: HasAuthorizedServiceTypePayload;
  hasConciergeActionDefinition: HasConciergeActionDefinitionPayload;
  hasIntegrationCredentials: HasIntegrationCredentialsPayload;
  hasLabelingConcierge: HasLabelingConciergePayload;
  hostedMcLeodIntegrationHealth: HostedMcLeodIntegrationHealthPayload;
  inProgressActionExecutions: ActionExecutionConnection;
  integratedCarrierVerificationIntegrations: Array<CarrierVerificationIntegrationType>;
  integrationCredentials: Array<IntegrationCredentialsSummary>;
  integrationVerificationEvents: Array<IntegrationVerificationEvent>;
  isFeatureFlagEnabled: Scalars['Boolean']['output'];
  isMovementPosted?: Maybe<Scalars['Boolean']['output']>;
  jobById: Job;
  jobs: JobConnection;
  knockToken: Scalars['String']['output'];
  knowledgeBaseById: KnowledgeBase;
  knowledgeBases: KnowledgeBaseConnection;
  labeledComputationById: LabeledComputation;
  labeledComputations: LabeledComputationConnection;
  laneHistory: LaneHistoryPayload;
  lanePreferencesForShipment: LanePreferencesForShipmentPayload;
  listAgentMailDomains: ListAgentMailDomainsPayload;
  listComposioAuthTokens: ListComposioAuthTokensPayload;
  listComposioToolKits: ListComposioToolKitsPayload;
  listComposioTools: ListComposioToolsPayload;
  lookupFmcsaCarrierContact: FmcsaCarrierContactPayload;
  managedResourceById: ManagedResourcePayload;
  managedResources: Array<ManagedResource>;
  materializedSop: MaterializedSopState;
  me?: Maybe<User>;
  memories: MemoryConnection;
  memoryById: Memory;
  messageEntityAssociations: MessageEntityAssociationConnection;
  messageQuoteAssociations: MessageQuoteAssociationConnection;
  metroLaneHistory: MetroLaneHistoryPayload;
  motiveScrapingConcurrency: Scalars['Int']['output'];
  movementById: Movement;
  movementCoveragePlanIds: MovementCoveragePlanIdsPayload;
  movementDynamoStatuses: Array<MovementDynamoStatus>;
  movementSchedulePlan?: Maybe<SchedulePlan>;
  movementsToCover: MovementConnection;
  movementsWithTrackSettings: Array<MovementWithTrackSettings>;
  myEmailSignatures: Array<UserDocumentUpload>;
  myMessageRatings: Array<MessageRating>;
  needAttentionActionExecutions: ActionExecutionConnection;
  negotiationStrategies: Array<NegotiationStrategy>;
  negotiationStrategyMargin: NegotiationStrategyMarginResult;
  newExternalMessages: Array<ExternalMessage>;
  notificationSettings: NotificationSettingsPayload;
  /** Open escalations created since a time, including ones with no conversation, newest first */
  openEscalations: ExceptionConnection;
  /** Open operational issues, most severe first */
  operationalIssues: Array<OperationalIssue>;
  orderById: Order;
  orderDocuments: Array<JobDocument>;
  orderSupportNotifications: OrderSupportNotificationsPayload;
  orders: OrderConnection;
  organizationBilling?: Maybe<OrganizationBillingSummary>;
  organizationById: Organization;
  organizationByIntegrationId: Organization;
  organizationJobs: Array<OrganizationJob>;
  organizationUserRelations: OrganizationUserRelationConnection;
  organizations: OrganizationConnection;
  organizationsInheritingGlobalPrompt: Array<OrgInheritingGlobalPromptPayload>;
  originatorById: Originator;
  originatorEvents: OriginatorEventConnection;
  originators: OriginatorConnection;
  placeById: Place;
  placeScheduling: PlaceScheduling;
  places: PlaceConnection;
  pricingStrategies: Array<PricingStrategy>;
  pricingStrategyById: PricingStrategy;
  quoteById: Quote;
  quoteJobSimulationSettings: QuoteJobSimulationSettingsPayload;
  quoteMileage?: Maybe<QuoteMileage>;
  quotes: QuoteConnection;
  quotesStats: Array<QuotesStat>;
  rejectedCarrierInquiriesForLane: Array<Conversation>;
  rejectedCarrierInquiriesForMovement: Array<Conversation>;
  relatedActions: Array<AgentAction>;
  relatedExternalMessages: Array<ExternalMessage>;
  relationById: OrganizationUserRelation;
  resolveOriginator: ResolveOriginatorPayload;
  rootSOPsForProvisioning: RootSoPsForProvisioningPayload;
  samsaraScrapingConcurrency: Scalars['Int']['output'];
  savedComputationById: SavedComputation;
  savedComputations: SavedComputationConnection;
  schedulePlans: Array<SchedulePlan>;
  scheduleSettings: Array<ScheduleSettings>;
  scheduleSettingsById?: Maybe<ScheduleSettings>;
  sharedFileById: ReadSharedFilePayload;
  sharedFiles: SharedFileConnection;
  shipmentById: Shipment;
  shipments: ShipmentConnection;
  simulateShouldTrackRule: SimulateShouldTrackRulePayload;
  simulationBrokerOrganizations: Array<SimulationOrganizationPayload>;
  simulationSettings: SimulationSettingsPayload;
  sopParamsOverview: SopParamsOverview;
  sponsoredWorkflows: Array<SponsoredWorkflow>;
  statusChangedEventsByMovementId: Array<TrackingEventWithActionExecution>;
  teamById: Team;
  teamMemberById: TeamMember;
  teams: Array<Team>;
  templateById: Template;
  templates: TemplateConnection;
  templatesByOrganization: Array<Template>;
  templatesByOriginator: Array<Template>;
  testHighwayCredentials: HighwayCredentialTestPayload;
  testHostedMcLeodCredentials: HostedMcLeodCredentialTestPayload;
  toolInputValidationSchema: ToolValidationSchemaPayload;
  toolSearchEmbeddingsEnabled: Scalars['Boolean']['output'];
  trackDashboardSummary: TrackDashboardSummary;
  trackSettings: Array<TrackSettings>;
  trackSettingsById?: Maybe<TrackSettings>;
  trackShipmentInsightCounts: TrackShipmentInsightCounts;
  trackedMovementsForExternalThread: Array<ThreadTrackedMovement>;
  trackingEventsByMovementId: Array<TrackingEventWithActionExecution>;
  transformationConfigById: TransformationConfig;
  transformationConfigs: TransformationConfigConnection;
  transformationDefinitionById: TransformationDefinition;
  transformationDefinitions: TransformationDefinitionConnection;
  truckerToolsScrapingConcurrency: Scalars['Int']['output'];
  turvoPollingConcurrency: Scalars['Int']['output'];
  usageBlocks: Array<UsageBlockSummary>;
  usageCaps: Array<UsageCapSummary>;
  userByEmail?: Maybe<User>;
  userById: User;
  users: UserConnection;
  valhallaComparisonEnabled: Scalars['Boolean']['output'];
  webhookSubscriptionById: WebhookSubscriptionPayload;
  webhookSubscriptions: WebhookSubscriptionsPayload;
  workerById?: Maybe<User>;
  workerComposioAccounts: WorkerComposioAccountsPayload;
  workerEmailSignatures: Array<UserDocumentUpload>;
  workerHasAuthorizedServiceType: HasAuthorizedServiceTypePayload;
  workers: UserConnection;
  workflows: WorkflowConnection;
  workflowsByOriginator: Array<Workflow>;
};


export type QueryActionDefinitionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionDefinitionTagsArgs = {
  input: ActionDefinitionTagsInput;
};


export type QueryActionDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ActionDefinitionsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActionExecutionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionExecutionCreditsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionExecutionSummariesArgs = {
  input: ActionExecutionSummariesInput;
};


export type QueryActionExecutionWithDescendantsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ActionExecutionInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActionTriggerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionTriggerValidationArgs = {
  input: ActionTriggerValidationInput;
};


export type QueryActiveLoadsCountArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryAdminEmailsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryAgentConversationWorkersArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryAgentConversationsArgs = {
  input: AgentConversationsInput;
};


export type QueryApiClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ApiClientsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryApplicableGenericTransformationsArgs = {
  input: ApplicableGenericTransformationsInput;
};


export type QueryBasePromptArgs = {
  key: Scalars['String']['input'];
};


export type QueryBillingDailySpendArgs = {
  endingBefore: Scalars['DateTimeISO']['input'];
  startingOn: Scalars['DateTimeISO']['input'];
};


export type QueryCarrierByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarrierInterestContextArgs = {
  input: GetCarrierInterestContextInput;
};


export type QueryCarrierLaneRunsForLaneArgs = {
  input: LaneCarrierRatesInput;
};


export type QueryCarrierRatesForLaneArgs = {
  input: LaneCarrierRatesInput;
};


export type QueryCarriersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<CarriersInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatSuggestionsArgs = {
  input: ChatSuggestionsInput;
};


export type QueryCheckAgentMailAvailabilityArgs = {
  input: CheckAgentMailAvailabilityInput;
};


export type QueryCheckIntegrationCredentialsArgs = {
  input: CheckIntegrationCredentialsInput;
};


export type QueryComputeSmartPricingPriorsArgs = {
  input: ComputeSmartPricingPriorsInput;
};


export type QueryConfiguredCarrierVerificationCredentialTypesArgs = {
  input: ConfiguredCarrierVerificationCredentialTypesInput;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ContactsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversationExceptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ConversationExceptionsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryConversationExperimentAssignmentsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversationExternalMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ConversationExternalMessagesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationFilterOptionsArgs = {
  input: ConversationFilterOptionsInput;
};


export type QueryConversationHistoryLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConversationLabelBackfillActionDefinitionsArgs = {
  input: ConversationLabelBackfillActionDefinitionsInput;
};


export type QueryConversationLabelBackfillPreviewArgs = {
  input: BackfillConversationLabelsInput;
};


export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ConversationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryConversationsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCoverAutomaticCoverageSettingsArgs = {
  input: CoverAutomaticCoverageSettingsInput;
};


export type QueryCoverStatsArgs = {
  range?: InputMaybe<CoverStatsRangeInput>;
  teamId: Scalars['ID']['input'];
};


export type QueryCoveragePlanArgs = {
  input: GetCoveragePlanInput;
};


export type QueryCoveragePlansForShipmentArgs = {
  input: GetCoveragePlansForShipmentInput;
};


export type QueryCoverageStatePreviewArgs = {
  input: CoverageStatePreviewInput;
};


export type QueryDownloadActionDefinitionArgs = {
  input: DownloadActionDefinitionInput;
};


export type QueryDownloadArtifactsArgs = {
  input: DownloadArtifactsInput;
};


export type QueryDownloadConversationDebugPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDownloadOrderArgs = {
  input: DownloadOrderInput;
};


export type QueryEmailThreadChatArgs = {
  input: EmailThreadChatInput;
};


export type QueryErrorGroupsArgs = {
  input?: InputMaybe<ListErrorGroupsInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<BaseEventsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExceptionEventsByMovementIdArgs = {
  movementId: Scalars['ID']['input'];
};


export type QueryExceptionsByActionExecutionIdArgs = {
  input: GetExceptionsByActionExecutionIdInput;
};


export type QueryExceptionsByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: GetExceptionsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ExternalChannelsInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryExternalMessageByIdArgs = {
  input: ExternalMessageInput;
};


export type QueryExternalMessageByInternetMessageIdArgs = {
  input: ExternalMessageByInternetMessageIdInput;
};


export type QueryExternalMessageMetadataArgs = {
  input: ExternalMessageInput;
};


export type QueryExternalMessagesByUserArgs = {
  input: ExternalMessagesByUserInput;
};


export type QueryFeatureFlagByIdArgs = {
  input: FeatureFlagInput;
};


export type QueryFetchBearerTokenArgs = {
  input: FetchBearerTokenInput;
};


export type QueryFindShipmentArgs = {
  input: FindShipmentInput;
};


export type QueryFreightDataMappingsArgs = {
  organizationId: Scalars['ID']['input'];
  type: FreightDataMappingType;
};


export type QueryFrontMailboxSubscriptionsArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryFrontSharedInboxesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGenericRuleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGenericRulesArgs = {
  input?: InputMaybe<GenericRulesInput>;
};


export type QueryGenericTransformationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGenericTransformationTemplateInheritorsArgs = {
  templateId: Scalars['ID']['input'];
};


export type QueryGenericTransformationTemplatesArgs = {
  input?: InputMaybe<GenericTransformationTemplatesInput>;
};


export type QueryGenericTransformationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<GenericTransformationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryGetActionBehaviorsArgs = {
  actionDefinitionId: Scalars['ID']['input'];
};


export type QueryGetActionDefinitionsUsedAsParentsArgs = {
  input: GetActionDefinitionsUsedAsParentsInput;
};


export type QueryGetActivePostingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBraintrustDatasetsArgs = {
  input?: InputMaybe<GetBraintrustDatasetsInput>;
};


export type QueryGetChannelOptionsArgs = {
  input: GetChannelOptionsInput;
};


export type QueryGetComposioToolKitDetailsArgs = {
  input: GetComposioToolKitDetailsInput;
};


export type QueryGetEvaluationTracesArgs = {
  input: GetEvaluationTraceInput;
};


export type QueryGetExceptionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetExistingCarriersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: GetExistingCarriersInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetExternalIdMappingsArgs = {
  input: GetExternalIdMappingsInput;
};


export type QueryGetLoadBoardPostingsArgs = {
  input: GetLoadBoardPostingsInput;
};


export type QueryGetOrCreateConversationWithConciergeArgs = {
  input: GetOrCreateConversationWithConciergeInput;
};


export type QueryGetOrganizationProductsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOriginatorOrderTemplateArgs = {
  input: GetOriginatorOrderTemplateInput;
};


export type QueryGetQuoteResponseMessageArgs = {
  input: GenerateQuoteResponseMessageInput;
};


export type QueryGetQuoteSimulationsActionDefinitionArgs = {
  input: GetQuoteSimulationsInput;
};


export type QueryGetSchedulePortalAvailabilityCheckArgs = {
  input: GetSchedulePortalAvailabilityCheckInput;
};


export type QueryGetShipmentDistanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSuggestedCarriersArgs = {
  input: GetSuggestedCarriersInput;
};


export type QueryGlobalPromptByIdArgs = {
  input: GlobalPromptByIdInput;
};


export type QueryGlobalPromptSnapshotsArgs = {
  input?: InputMaybe<GlobalPromptSnapshotsInput>;
};


export type QueryHasAuthorizedServiceTypeArgs = {
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  type: AuthTokenType;
};


export type QueryHasConciergeActionDefinitionArgs = {
  input: HasConciergeActionDefinitionInput;
};


export type QueryHasIntegrationCredentialsArgs = {
  input: HasIntegrationCredentialsInput;
};


export type QueryHasLabelingConciergeArgs = {
  input: HasLabelingConciergeInput;
};


export type QueryHostedMcLeodIntegrationHealthArgs = {
  input: HostedMcLeodIntegrationHealthInput;
};


export type QueryInProgressActionExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ActionExecutionInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIntegratedCarrierVerificationIntegrationsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryIntegrationCredentialsArgs = {
  input: ListIntegrationCredentialsInput;
};


export type QueryIntegrationVerificationEventsArgs = {
  input: IntegrationVerificationEventsInput;
};


export type QueryIsFeatureFlagEnabledArgs = {
  input: GetFeatureFlagEnabledInput;
};


export type QueryIsMovementPostedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<JobsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryKnockTokenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKnowledgeBaseByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKnowledgeBasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<KnowledgeBasesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLabeledComputationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLabeledComputationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<LabeledComputationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLaneHistoryArgs = {
  input: LaneHistoryInput;
};


export type QueryLanePreferencesForShipmentArgs = {
  input: GetLanePreferencesForShipmentInput;
};


export type QueryListComposioAuthTokensArgs = {
  input: ListComposioAuthTokensInput;
};


export type QueryListComposioToolKitsArgs = {
  input: ListComposioToolKitsInput;
};


export type QueryListComposioToolsArgs = {
  input: ListComposioToolsInput;
};


export type QueryLookupFmcsaCarrierContactArgs = {
  input: LookupFmcsaCarrierContactInput;
};


export type QueryManagedResourceByIdArgs = {
  input: ManagedResourceInput;
};


export type QueryMaterializedSopArgs = {
  actionDefinitionId: Scalars['ID']['input'];
};


export type QueryMemoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<MemoriesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryMemoryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageEntityAssociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<MessageEntityAssociationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessageQuoteAssociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<MessageQuoteAssociationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMetroLaneHistoryArgs = {
  input: MetroLaneHistoryInput;
};


export type QueryMovementByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMovementCoveragePlanIdsArgs = {
  input: GetMovementCoveragePlanIdsInput;
};


export type QueryMovementDynamoStatusesArgs = {
  movementId: Scalars['ID']['input'];
};


export type QueryMovementSchedulePlanArgs = {
  movementId: Scalars['ID']['input'];
};


export type QueryMovementsToCoverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: MovementsToCoverInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryMovementsWithTrackSettingsArgs = {
  organizationId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyMessageRatingsArgs = {
  input: MyMessageRatingsInput;
};


export type QueryNeedAttentionActionExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ActionExecutionInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNegotiationStrategiesArgs = {
  input?: InputMaybe<NegotiationStrategiesInput>;
};


export type QueryNegotiationStrategyMarginArgs = {
  input: NegotiationStrategyMarginInput;
};


export type QueryNewExternalMessagesArgs = {
  input: ExternalMessagesInput;
};


export type QueryNotificationSettingsArgs = {
  input: NotificationSettingsInput;
};


export type QueryOpenEscalationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: OpenEscalationsInput;
};


export type QueryOperationalIssuesArgs = {
  input: OperationalIssuesInput;
};


export type QueryOrderByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderDocumentsArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrderSupportNotificationsArgs = {
  input: OrderSupportNotificationsInput;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<OrdersInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationByIntegrationIdArgs = {
  input: OrganizationByIntegrationIdInput;
};


export type QueryOrganizationJobsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationUserRelationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<OrganizationUserRelationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<OrganizationsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationsInheritingGlobalPromptArgs = {
  globalPromptId: Scalars['String']['input'];
};


export type QueryOriginatorByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOriginatorEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<OriginatorEventsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOriginatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<OriginatorsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryPlaceByIdArgs = {
  id: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlaceSchedulingArgs = {
  placeId: Scalars['ID']['input'];
};


export type QueryPlacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<PlacesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryPricingStrategiesArgs = {
  input?: InputMaybe<PricingStrategiesInput>;
};


export type QueryPricingStrategyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuoteJobSimulationSettingsArgs = {
  input: QuoteJobSimulationSettingsInput;
};


export type QueryQuoteMileageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<QuotesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  shouldUseDefaultView?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryQuotesStatsArgs = {
  input?: InputMaybe<QuotesInput>;
};


export type QueryRejectedCarrierInquiriesForLaneArgs = {
  input: RejectedCarrierInquiriesForLaneInput;
};


export type QueryRejectedCarrierInquiriesForMovementArgs = {
  input: RejectedCarrierInquiriesForMovementInput;
};


export type QueryRelatedActionsArgs = {
  input: RelatedExternalMessagesInput;
};


export type QueryRelatedExternalMessagesArgs = {
  input: RelatedExternalMessagesInput;
};


export type QueryRelationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResolveOriginatorArgs = {
  input: ResolveOriginatorInput;
};


export type QueryRootSoPsForProvisioningArgs = {
  input: RootSoPsForProvisioningInput;
};


export type QuerySavedComputationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySavedComputationsArgs = {
  input?: InputMaybe<SavedComputationsInput>;
};


export type QuerySchedulePlansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  statuses: Array<SchedulePlanStatus>;
};


export type QueryScheduleSettingsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryScheduleSettingsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedFileByIdArgs = {
  id: Scalars['ID']['input'];
  includeContent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySharedFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<SharedFilesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShipmentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<ShipmentsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  shouldUseDefaultView?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QuerySimulateShouldTrackRuleArgs = {
  input: SimulateShouldTrackRuleInput;
};


export type QuerySimulationSettingsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryStatusChangedEventsByMovementIdArgs = {
  movementId: Scalars['ID']['input'];
};


export type QueryTeamByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamMemberByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  input?: InputMaybe<TeamsInput>;
};


export type QueryTemplateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<TemplatesInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplatesByOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryTemplatesByOriginatorArgs = {
  originatorId: Scalars['ID']['input'];
};


export type QueryTestHighwayCredentialsArgs = {
  input: HighwayCredentialTestInput;
};


export type QueryTestHostedMcLeodCredentialsArgs = {
  input: HostedMcLeodCredentialTestInput;
};


export type QueryToolInputValidationSchemaArgs = {
  input: ToolValidationSchemaInput;
};


export type QueryTrackDashboardSummaryArgs = {
  input: TrackDashboardSummaryInput;
};


export type QueryTrackSettingsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryTrackSettingsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrackShipmentInsightCountsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryTrackedMovementsForExternalThreadArgs = {
  input: RelatedExternalMessagesInput;
};


export type QueryTrackingEventsByMovementIdArgs = {
  movementId: Scalars['ID']['input'];
};


export type QueryTransformationConfigByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransformationConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<TransformationConfigsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransformationDefinitionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransformationDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<TransformationDefinitionsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UsersInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryWebhookSubscriptionByIdArgs = {
  input: WebhookSubscriptionInput;
};


export type QueryWebhookSubscriptionsArgs = {
  input?: InputMaybe<WebhookSubscriptionsInput>;
};


export type QueryWorkerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkerComposioAccountsArgs = {
  input: WorkerComposioAccountsInput;
};


export type QueryWorkerEmailSignaturesArgs = {
  workerId: Scalars['ID']['input'];
};


export type QueryWorkerHasAuthorizedServiceTypeArgs = {
  input: WorkerHasAuthorizedServiceTypeInput;
};


export type QueryWorkersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<UsersInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<WorkflowsInput>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkflowsByOriginatorArgs = {
  originatorId: Scalars['ID']['input'];
};

export type QuietLineIntentData = {
  __typename?: 'QuietLineIntentData';
  eventDataType: ConversationEventType;
};

export type Quote = AbstractEntity & Node & {
  __typename?: 'Quote';
  acknowledgementTime?: Maybe<Scalars['Float']['output']>;
  canonicalId?: Maybe<Scalars['String']['output']>;
  carrierRate?: Maybe<CarrierRate>;
  carrierRates: Array<CarrierRate>;
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  createdAtDisplay?: Maybe<Scalars['DateTimeISO']['output']>;
  customFreightTags?: Maybe<Array<Scalars['String']['output']>>;
  customerRate?: Maybe<CustomerRate>;
  customerRates: Array<CustomerRate>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeepLink?: Maybe<Scalars['String']['output']>;
  externalIdMappings?: Maybe<Array<ExternalIdMapping>>;
  externalThreads: Array<QuoteExternalThread>;
  /** Serialized as JSON */
  extractedData?: Maybe<Scalars['JSON']['output']>;
  googleMapsEmbedUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job: Job;
  linkedShipments: Array<QuoteShipmentLink>;
  mileageBetweenStops?: Maybe<Array<Scalars['Float']['output']>>;
  notesCount: Scalars['Float']['output'];
  opportunityUserIds?: Maybe<Array<Scalars['String']['output']>>;
  opportunityUsers: Array<User>;
  optimismStatus: OptimismStatus;
  organization: Organization;
  originator?: Maybe<Originator>;
  primaryReference?: Maybe<Scalars['String']['output']>;
  quoteEvents: Array<QuoteEvent>;
  quoteNotes: Array<QuoteNote>;
  quoteTags?: Maybe<Array<QuoteTag>>;
  rateForm: RateForm;
  responseTime?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['JSON']['output']>;
  routeGeoCoordinates?: Maybe<Array<LatLng>>;
  shipment?: Maybe<Shipment>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  status: QuoteBidStatus;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
  validation: QuoteValidationPayload;
};

export enum QuoteAutoReplyScope {
  AGENT = 'AGENT',
  DISABLED = 'DISABLED',
  DRAFT = 'DRAFT',
  SEND = 'SEND'
}

/** Customer facing status */
export enum QuoteBidStatus {
  LOST = 'LOST',
  NEW = 'NEW',
  QUOTED = 'QUOTED',
  WON = 'WON'
}

export type QuoteConnection = {
  __typename?: 'QuoteConnection';
  count: Scalars['Int']['output'];
  edges: Array<QuoteEdge>;
  nodes?: Maybe<Array<Quote>>;
  pageInfo: PageInfo;
  savedViewRedirect?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type QuoteDateFilter = {
  /** List Quote that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List Quote that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List Quote that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List Quote that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type QuoteEdge = {
  __typename?: 'QuoteEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Quote;
};

export type QuoteEvent = AbstractEntity & Node & {
  __typename?: 'QuoteEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** Serialized as JSON */
  metadata?: Maybe<Scalars['JSON']['output']>;
  quoteId: Scalars['String']['output'];
  type: QuoteEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export type QuoteEventCreatedTriggerConfig = {
  __typename?: 'QuoteEventCreatedTriggerConfig';
  originatorIds?: Maybe<Array<Scalars['String']['output']>>;
  override?: Maybe<BaseTriggerOverride>;
  quoteEventTypes: Array<QuoteEventType>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
};

export enum QuoteEventType {
  AI_INFERENCE_COMPLETED = 'AI_INFERENCE_COMPLETED',
  AI_PROCESSING_COMPLETED = 'AI_PROCESSING_COMPLETED',
  AI_PROCESSING_FAILED = 'AI_PROCESSING_FAILED',
  AI_PROCESSING_STARTED = 'AI_PROCESSING_STARTED',
  AI_PROCESSING_TRIGGERED = 'AI_PROCESSING_TRIGGERED',
  AUTO_REPLY_DRAFTED = 'AUTO_REPLY_DRAFTED',
  AUTO_REPLY_DRAFT_FAILURE = 'AUTO_REPLY_DRAFT_FAILURE',
  AUTO_REPLY_EVALUATOR_RESPONSE = 'AUTO_REPLY_EVALUATOR_RESPONSE',
  AUTO_REPLY_SEND_FAILURE = 'AUTO_REPLY_SEND_FAILURE',
  AUTO_REPLY_SENT = 'AUTO_REPLY_SENT',
  CREATED_MANUALLY = 'CREATED_MANUALLY',
  CREATED_OPTIMISTICALLY = 'CREATED_OPTIMISTICALLY',
  EXTRACTED_DATA_EDITED = 'EXTRACTED_DATA_EDITED',
  MARKED_AS_LOST = 'MARKED_AS_LOST',
  MARKED_AS_NEW = 'MARKED_AS_NEW',
  MARKED_AS_NOT_A_QUOTE = 'MARKED_AS_NOT_A_QUOTE',
  MARKED_AS_QUOTED = 'MARKED_AS_QUOTED',
  MARKED_AS_WON = 'MARKED_AS_WON',
  ORIGINATOR_UPDATED = 'ORIGINATOR_UPDATED',
  OWNER_UPDATED = 'OWNER_UPDATED',
  PREPROCESSED = 'PREPROCESSED',
  PRICING_CHANGED = 'PRICING_CHANGED',
  RATING_FAILED = 'RATING_FAILED',
  RECEIVED_RATE = 'RECEIVED_RATE',
  REQUESTED_RATE = 'REQUESTED_RATE',
  SIMULATION_RUN = 'SIMULATION_RUN',
  USER_CONFIRMED = 'USER_CONFIRMED'
}

export type QuoteExternalThread = {
  __typename?: 'QuoteExternalThread';
  externalThreadId: Scalars['String']['output'];
  messages: Array<QuoteExternalThreadMessage>;
  threadType: ExternalMessageType;
};

export type QuoteExternalThreadMessage = {
  __typename?: 'QuoteExternalThreadMessage';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internetMessageId?: Maybe<Scalars['String']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  receivedAt?: Maybe<Scalars['String']['output']>;
  recipientAddresses?: Maybe<Array<Scalars['String']['output']>>;
  senderAddress?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type QuoteJobSimulationResolvedSettings = {
  __typename?: 'QuoteJobSimulationResolvedSettings';
  pricingStrategy?: Maybe<PricingStrategy>;
  quoteAutoReply: Scalars['JSON']['output'];
};

export type QuoteJobSimulationSettingsInput = {
  jobId: Scalars['ID']['input'];
  resolveAs: QuoteSimulationSettingsSubject;
};

export type QuoteJobSimulationSettingsPayload = {
  __typename?: 'QuoteJobSimulationSettingsPayload';
  levels: QuoteSimulationLevels;
  resolved: QuoteJobSimulationResolvedSettings;
};

export type QuoteMileage = {
  __typename?: 'QuoteMileage';
  id: Scalars['ID']['output'];
  units: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type QuoteNote = AbstractEntity & Node & {
  __typename?: 'QuoteNote';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  quote: Quote;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
};

export type QuoteShipmentLink = {
  __typename?: 'QuoteShipmentLink';
  confidence?: Maybe<Scalars['Float']['output']>;
  shipmentExternalId?: Maybe<Scalars['String']['output']>;
  shipmentReferenceNumbers: Array<Scalars['String']['output']>;
  voomaMovementId: Scalars['ID']['output'];
  voomaShipmentId?: Maybe<Scalars['ID']['output']>;
};

export type QuoteSimulationLevels = {
  __typename?: 'QuoteSimulationLevels';
  global: HierarchyLevelSettings;
  organization: HierarchyLevelSettings;
  originator?: Maybe<HierarchyLevelSettings>;
  team?: Maybe<HierarchyLevelSettings>;
  user?: Maybe<HierarchyLevelSettings>;
};

export enum QuoteSimulationSettingsSubject {
  CURRENT_USER = 'CURRENT_USER',
  JOB_OWNER = 'JOB_OWNER'
}

export enum QuoteTag {
  AUCTION = 'AUCTION',
  CONTRACT = 'CONTRACT'
}

export type QuoteValidationPayload = {
  __typename?: 'QuoteValidationPayload';
  missingFields?: Maybe<Array<Scalars['String']['output']>>;
  valid: Scalars['Boolean']['output'];
  validationMessage?: Maybe<Scalars['String']['output']>;
};

export type QuotesInput = {
  auctionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  confidenceRange?: InputMaybe<ConfidenceRange>;
  contractTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  customFreightTags?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFilter?: InputMaybe<QuoteDateFilter>;
  deliveryDateFilter?: InputMaybe<QuoteDateFilter>;
  driverRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  equipmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  freightModes?: InputMaybe<Array<Scalars['String']['input']>>;
  frontFilter?: InputMaybe<FrontFilter>;
  jobConfirmationFilterStatus?: InputMaybe<JobConfirmationFilterStatus>;
  laneFilter?: InputMaybe<LaneFilter>;
  optimismStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  outlookFilter?: InputMaybe<OutlookFilter>;
  pickupDateFilter?: InputMaybe<QuoteDateFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  shouldUseDefaultView?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<QuoteBidStatus>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  threadLength?: InputMaybe<Scalars['Int']['input']>;
  updatedAtFilter?: InputMaybe<QuoteDateFilter>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuotesStat = {
  __typename?: 'QuotesStat';
  averageResponseTime?: Maybe<Scalars['Float']['output']>;
  averageResponseTimeCount?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  medianResponseTime?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  totalCarrierRateValue: Scalars['Float']['output'];
  totalCustomerRateValue: Scalars['Float']['output'];
};

export enum RateComponentType {
  FUEL_SURCHARGE = 'FUEL_SURCHARGE',
  LINE_HAUL = 'LINE_HAUL',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  MARGIN = 'MARGIN',
  MESSAGE_ADJUSTMENT = 'MESSAGE_ADJUSTMENT',
  OTHER = 'OTHER',
  TMS_ADJUSTMENT = 'TMS_ADJUSTMENT',
  TOTAL = 'TOTAL'
}

export type RateForm = {
  __typename?: 'RateForm';
  carrierRateId?: Maybe<Scalars['String']['output']>;
  customerRateId?: Maybe<Scalars['String']['output']>;
  lineItems: Array<RateLineItem>;
};

export type RateGuidanceByMethodInput = {
  averageRatio?: InputMaybe<Scalars['Float']['input']>;
  confidenceScore?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  dataPoints?: InputMaybe<Scalars['Float']['input']>;
  highRate?: InputMaybe<Scalars['Float']['input']>;
  loadToTruckRatio?: InputMaybe<Scalars['Float']['input']>;
  lowRate?: InputMaybe<Scalars['Float']['input']>;
  method: RatingMethod;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  rate: Scalars['Float']['input'];
  reports?: InputMaybe<Scalars['Float']['input']>;
  standardDeviation?: InputMaybe<Scalars['Float']['input']>;
  totalLoads?: InputMaybe<Scalars['Float']['input']>;
  totalTrucks?: InputMaybe<Scalars['Float']['input']>;
};

export type RateGuidanceByMethodType = {
  __typename?: 'RateGuidanceByMethodType';
  averageRatio?: Maybe<Scalars['Float']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dataPoints?: Maybe<Scalars['Float']['output']>;
  highRate?: Maybe<Scalars['Float']['output']>;
  loadToTruckRatio?: Maybe<Scalars['Float']['output']>;
  lowRate?: Maybe<Scalars['Float']['output']>;
  method: RatingMethod;
  mileage?: Maybe<Scalars['Float']['output']>;
  rate: Scalars['Float']['output'];
  reports?: Maybe<Scalars['Float']['output']>;
  standardDeviation?: Maybe<Scalars['Float']['output']>;
  totalLoads?: Maybe<Scalars['Float']['output']>;
  totalTrucks?: Maybe<Scalars['Float']['output']>;
};

export type RateGuidanceInput = {
  byMethod: Array<RateGuidanceByMethodInput>;
};

export type RateGuidanceType = {
  __typename?: 'RateGuidanceType';
  byMethod: Array<RateGuidanceByMethodType>;
};

export type RateLineItem = {
  __typename?: 'RateLineItem';
  buyRate: Scalars['Float']['output'];
  componentId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  sellRate: Scalars['Float']['output'];
  type: RateComponentType;
};

export type RateMessageInput = {
  isPositive: Scalars['Boolean']['input'];
  messageId: Scalars['ID']['input'];
};

export type Rating = AbstractEntity & Node & {
  __typename?: 'Rating';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  /** Integer from 0 to 10 (inclusive) */
  starRating: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type RatingError = {
  __typename?: 'RatingError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  ratingMethod: RatingMethod;
};

/** The method used to rate a load */
export enum RatingMethod {
  ARCBEST_TL_QUOTING = 'ARCBEST_TL_QUOTING',
  AVRL = 'AVRL',
  BITFREIGHTER = 'BITFREIGHTER',
  CUSTOM = 'CUSTOM',
  DAT = 'DAT',
  DIRECT_OFFER = 'DIRECT_OFFER',
  DRAYRATES_RATING = 'DRAYRATES_RATING',
  DTS_RATING = 'DTS_RATING',
  ECHO = 'ECHO',
  FASTMORE = 'FASTMORE',
  FREIGHTPLUS = 'FREIGHTPLUS',
  GREENSCREENS = 'GREENSCREENS',
  HUMAN_INPUT = 'HUMAN_INPUT',
  NFI = 'NFI',
  NTG = 'NTG',
  SOFTMODAL = 'SOFTMODAL',
  SONAR = 'SONAR',
  SUNSET = 'SUNSET',
  TABI = 'TABI',
  TRANSFIX = 'TRANSFIX',
  TRUCKSTOP = 'TRUCKSTOP',
  WERNER = 'WERNER',
  WORLDWIDE_LOGISTICS = 'WORLDWIDE_LOGISTICS',
  WWEX = 'WWEX'
}

export type RawAgentMessageData = {
  __typename?: 'RawAgentMessageData';
  data: Scalars['JSON']['output'];
  eventDataType: ActionExecutionEventType;
  executionStartTime?: Maybe<Scalars['String']['output']>;
};

export type RawSupervisorMessageData = {
  __typename?: 'RawSupervisorMessageData';
  data: Scalars['JSON']['output'];
  eventDataType: ActionExecutionEventType;
};

export type ReadSharedFilePayload = {
  __typename?: 'ReadSharedFilePayload';
  content?: Maybe<Scalars['String']['output']>;
  file: SharedFileSummary;
  version?: Maybe<SharedFileVersionSummary>;
};

export type ReadyForCoverageData = {
  __typename?: 'ReadyForCoverageData';
  eventType: MovementEventType;
};

export enum ReasoningEffort {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MAX = 'MAX',
  MEDIUM = 'MEDIUM',
  MINIMAL = 'MINIMAL',
  NONE = 'NONE',
  XHIGH = 'XHIGH'
}

export type ReassignQuoteOwnerInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ReassignQuoteOwnerPayload = {
  __typename?: 'ReassignQuoteOwnerPayload';
  success: Scalars['Boolean']['output'];
};

export type RecentCarrierInquiryInput = {
  actionExecutionId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['String']['input'];
};

export type RecentCarrierInquiryType = {
  __typename?: 'RecentCarrierInquiryType';
  actionExecutionId: Scalars['String']['output'];
  conversationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
};

export type RecentCarrierOfferInput = {
  createdAt: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type RecentCarrierOfferType = {
  __typename?: 'RecentCarrierOfferType';
  createdAt: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type RecentCarrierTransferInput = {
  actionExecutionId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  transferType: Scalars['String']['input'];
};

export type RecentCarrierTransferType = {
  __typename?: 'RecentCarrierTransferType';
  actionExecutionId: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  transferType: Scalars['String']['output'];
};

export type RecoverMemoryInput = {
  id: Scalars['ID']['input'];
};

export type RecoverMemoryPayload = {
  __typename?: 'RecoverMemoryPayload';
  success: Scalars['Boolean']['output'];
};

export type RedactOrganizationDataInput = {
  id: Scalars['ID']['input'];
  redactionDate: Scalars['DateTimeISO']['input'];
};

export type RedactOrganizationDataPayload = {
  __typename?: 'RedactOrganizationDataPayload';
  success: Scalars['Boolean']['output'];
};

export type ReferencingEntity = {
  __typename?: 'ReferencingEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RefreshFrontOrganizationIdInput = {
  organizationId: Scalars['ID']['input'];
};

export type RefreshFrontOrganizationIdPayload = {
  __typename?: 'RefreshFrontOrganizationIdPayload';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RefreshOrderEntitiesInput = {
  id: Scalars['String']['input'];
};

export type RefreshOrderEntitiesPayload = {
  __typename?: 'RefreshOrderEntitiesPayload';
  success: Scalars['Boolean']['output'];
};

export type RefreshPostingOnLoadBoardInput = {
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type RefreshQuoteMileageInput = {
  id: Scalars['ID']['input'];
};

export type RefreshQuoteMileagePayload = {
  __typename?: 'RefreshQuoteMileagePayload';
  success: Scalars['Boolean']['output'];
};

export type RefreshSubscriptionsInput = {
  dryRun: Scalars['Boolean']['input'];
  scope?: InputMaybe<Array<AuthTokenType>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RefreshSubscriptionsPayload = {
  __typename?: 'RefreshSubscriptionsPayload';
  count: Scalars['Float']['output'];
};

export type RefreshedPostingOnLoadBoardData = {
  __typename?: 'RefreshedPostingOnLoadBoardData';
  eventType: MovementEventType;
  posting?: Maybe<LoadBoardPosting>;
  postingUserId?: Maybe<Scalars['String']['output']>;
};

export type RegisterMicrosoftMailboxesInput = {
  mailboxes: Array<MicrosoftMailboxRegistrationInput>;
  organizationId: Scalars['ID']['input'];
};

export type RegisterMicrosoftMailboxesPayload = {
  __typename?: 'RegisterMicrosoftMailboxesPayload';
  results: Array<MicrosoftMailboxRegistrationResult>;
};

export type RejectedCarrierInquiriesForLaneInput = {
  /** Lookback period in days (default: 90) */
  lookbackDays?: InputMaybe<Scalars['Float']['input']>;
  /** The movement ID to derive the lane from */
  movementId: Scalars['ID']['input'];
  /** Search radius in miles (default: 50) */
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type RejectedCarrierInquiriesForMovementInput = {
  /** The movement ID to find rejected inquiries for */
  movementId: Scalars['ID']['input'];
};

export type RelatedExternalMessagesInput = {
  apiClient: VoomaApiClient;
  externalIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  externalMessageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReminderData = {
  __typename?: 'ReminderData';
  eventDataType: ActionExecutionEventType;
  message: Scalars['String']['output'];
};

export type RemoveCarriersFromLanePreferenceInput = {
  carrierIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type RemoveMessageRatingInput = {
  messageId: Scalars['ID']['input'];
};

export type RemoveMessageRatingPayload = {
  __typename?: 'RemoveMessageRatingPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveSenderFromOriginatorInput = {
  contactId: Scalars['String']['input'];
  originatorId: Scalars['String']['input'];
};

export type RemoveSenderFromOriginatorPayload = {
  __typename?: 'RemoveSenderFromOriginatorPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveUserFromOrganizationInput = {
  organizationId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveUserFromOrganizationPayload = {
  __typename?: 'RemoveUserFromOrganizationPayload';
  success: Scalars['Boolean']['output'];
};

export type RemoveWorkerFromActionDefinitionInput = {
  actionDefinitionId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

export type RemoveWorkerFromActionDefinitionPayload = {
  __typename?: 'RemoveWorkerFromActionDefinitionPayload';
  actionDefinition: ActionDefinition;
};

export type RenameDocumentInKnowledgeBaseInput = {
  documentId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};

export type RenameDocumentInKnowledgeBasePayload = {
  __typename?: 'RenameDocumentInKnowledgeBasePayload';
  success: Scalars['Boolean']['output'];
};

export type RenameKnowledgeBaseInput = {
  knowledgeBaseId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
};

export type RenameKnowledgeBasePayload = {
  __typename?: 'RenameKnowledgeBasePayload';
  success: Scalars['Boolean']['output'];
};

export type RenameSharedFileInput = {
  fileName: Scalars['String']['input'];
  sharedFileId: Scalars['ID']['input'];
};

export type RenameSharedFilePayload = {
  __typename?: 'RenameSharedFilePayload';
  message: Scalars['String']['output'];
  sharedFile: SharedFileSummary;
  success: Scalars['Boolean']['output'];
};

export type RepeatOrderInput = {
  id: Scalars['String']['input'];
  numRepeats: Scalars['Float']['input'];
};

export type RepeatOrderPayload = {
  __typename?: 'RepeatOrderPayload';
  orders: Array<Order>;
  success: Scalars['Boolean']['output'];
};

export type RepeatingTriggerConfig = {
  __typename?: 'RepeatingTriggerConfig';
  /** Input data passed to the action execution when the trigger fires. */
  actionExecutionInput?: Maybe<Scalars['JSON']['output']>;
  /** Parsed as in https://www.npmjs.com/package/cron-parser */
  cronPattern: Scalars['String']['output'];
  override?: Maybe<BaseTriggerOverride>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  triggerType: ActionTriggerConfigType;
};

export type ReplicateOrderInput = {
  id: Scalars['String']['input'];
};

export type ReplicateOrderPayload = {
  __typename?: 'ReplicateOrderPayload';
  success: Scalars['Boolean']['output'];
};

export type Report = AbstractEntity & Node & {
  __typename?: 'Report';
  bucket?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export type ReprocessJobInput = {
  buildHint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** The type of job to reprocess */
  jobType: JobType;
};

export type ReprocessJobPayload = {
  __typename?: 'ReprocessJobPayload';
  success: Scalars['Boolean']['output'];
};

export type ReprocessOrderInput = {
  id: Scalars['String']['input'];
};

export type ReprocessOrderPayload = {
  __typename?: 'ReprocessOrderPayload';
  success: Scalars['Boolean']['output'];
};

export type RequestConversationCcInput = {
  conversationId: Scalars['ID']['input'];
  emailsToCc: Array<Scalars['String']['input']>;
};

export type RequestConversationCcPayload = {
  __typename?: 'RequestConversationCcPayload';
  alreadyRequested: Scalars['Boolean']['output'];
  conversation: Conversation;
  success: Scalars['Boolean']['output'];
};

/** The method used to make the api request */
export enum RequestMethod {
  DELETE = 'DELETE',
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT'
}

export type RequestedPostToLoadBoardData = {
  __typename?: 'RequestedPostToLoadBoardData';
  eventType: MovementEventType;
  posting?: Maybe<LoadBoardPosting>;
};

export type RequestedUnpostFromLoadBoardData = {
  __typename?: 'RequestedUnpostFromLoadBoardData';
  eventType: MovementEventType;
  posting?: Maybe<LoadBoardPosting>;
};

export type ReserveTestPhoneNumberInput = {
  actionTriggerId?: InputMaybe<Scalars['ID']['input']>;
  forceNew?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type ReserveTestPhoneNumberPayload = {
  __typename?: 'ReserveTestPhoneNumberPayload';
  aiPhoneNumber: AiPhoneNumber;
  expiresAt: Scalars['DateTimeISO']['output'];
  phoneNumber: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  wasExistingNumberAvailable: Scalars['Boolean']['output'];
};

export type ResolveOriginatorCandidate = {
  __typename?: 'ResolveOriginatorCandidate';
  originator: Originator;
};

export type ResolveOriginatorInput = {
  candidateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  threshold?: InputMaybe<Scalars['Float']['input']>;
  topK?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResolveOriginatorPayload = {
  __typename?: 'ResolveOriginatorPayload';
  candidates: Array<ResolveOriginatorCandidate>;
  success: Scalars['Boolean']['output'];
};

export type ResourceResolution = {
  __typename?: 'ResourceResolution';
  name: Scalars['String']['output'];
  resolvesToName?: Maybe<Scalars['String']['output']>;
};

export type ResponsibleParty = {
  __typename?: 'ResponsibleParty';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ReturnedToTransferredCallData = {
  __typename?: 'ReturnedToTransferredCallData';
  conferenceId: Scalars['String']['output'];
  eventDataType: ConversationEventType;
  transferAttemptConversationId?: Maybe<Scalars['String']['output']>;
};

export type RollOutFromCodePayload = {
  __typename?: 'RollOutFromCodePayload';
  failedCount: Scalars['Int']['output'];
  organizationCount: Scalars['Int']['output'];
  succeededCount: Scalars['Int']['output'];
};

export type RootSopActionDefinition = {
  __typename?: 'RootSOPActionDefinition';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RootSoPsForProvisioningInput = {
  organizationId: Scalars['ID']['input'];
};

export type RootSoPsForProvisioningItem = {
  __typename?: 'RootSOPsForProvisioningItem';
  actionDefinitions: Array<RootSopActionDefinition>;
  provisioningResourceId: Scalars['String']['output'];
  provisioningResourceName: Scalars['String']['output'];
};

export type RootSoPsForProvisioningPayload = {
  __typename?: 'RootSOPsForProvisioningPayload';
  rootSOPsForProvisioning: Array<RootSoPsForProvisioningItem>;
};

export type RunActionBehaviorInput = {
  id: Scalars['ID']['input'];
};

export type RunBuildAccuracySamplesInput = {
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  uploadIds: Array<Scalars['String']['input']>;
};

export type RunBuildAccuracySamplesPayload = {
  __typename?: 'RunBuildAccuracySamplesPayload';
  manifest: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
};

export type RunCoverEvalsResult = {
  __typename?: 'RunCoverEvalsResult';
  datasetsRun: Scalars['Float']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<CoverEvalDatasetResult>>;
  success: Scalars['Boolean']['output'];
};

export type RunGlobalPromptEvaluationInput = {
  globalPromptId: Scalars['ID']['input'];
};

export type RunGlobalPromptEvaluationResult = {
  __typename?: 'RunGlobalPromptEvaluationResult';
  experimentUrls?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  totalEvaluationsRun: Scalars['Float']['output'];
};

export type RunManagedResourceCanaryPayload = {
  __typename?: 'RunManagedResourceCanaryPayload';
  durationMs: Scalars['Float']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  overallStatus: Scalars['String']['output'];
};

export type RunningLateCloseToDeliveryExceptionSettings = {
  __typename?: 'RunningLateCloseToDeliveryExceptionSettings';
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Minutes before the last delivery stop's scheduled start from which a running-late load triggers this exception. Defaults to 60 when unset. Fires once per movement. */
  minutesBeforeDelivery?: Maybe<Scalars['Float']['output']>;
  /** Minutes past the delivery window end the ETA must exceed before the load counts as running late. Defaults to 30 when unset. */
  toleranceMinutes?: Maybe<Scalars['Float']['output']>;
};

export type RunningLateCloseToDeliveryExceptionSettingsInput = {
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Minutes before the last delivery stop's scheduled start from which a running-late load triggers this exception. Defaults to 60 when unset. Fires once per movement. */
  minutesBeforeDelivery?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes past the delivery window end the ETA must exceed before the load counts as running late. Defaults to 30 when unset. */
  toleranceMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type RunningLateCloseToPickupExceptionSettings = {
  __typename?: 'RunningLateCloseToPickupExceptionSettings';
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Minutes before the first pickup stop's scheduled start from which a running-late truck triggers this exception, until the pickup window ends. Defaults to 60 when unset. Fires once per movement. */
  minutesBeforePickup?: Maybe<Scalars['Float']['output']>;
  /** Minutes past the pickup window end the ETA must exceed before the truck counts as running late. Defaults to 30 when unset. */
  toleranceMinutes?: Maybe<Scalars['Float']['output']>;
};

export type RunningLateCloseToPickupExceptionSettingsInput = {
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Minutes before the first pickup stop's scheduled start from which a running-late truck triggers this exception, until the pickup window ends. Defaults to 60 when unset. Fires once per movement. */
  minutesBeforePickup?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes past the pickup window end the ETA must exceed before the truck counts as running late. Defaults to 30 when unset. */
  toleranceMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type RunningLateExceptionSettings = {
  __typename?: 'RunningLateExceptionSettings';
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: Maybe<Scalars['Float']['output']>;
  /** Minutes of tolerance before triggering RUNNING_LATE exception. Defaults to 30 minutes. */
  toleranceMinutes?: Maybe<Scalars['Float']['output']>;
};

export type RunningLateExceptionSettingsInput = {
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes of tolerance before triggering RUNNING_LATE exception. Defaults to 30 minutes. */
  toleranceMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type SmsConversationMetadata = {
  __typename?: 'SMSConversationMetadata';
  ourPhoneNumber: Scalars['String']['output'];
  theirPhoneNumber: Scalars['String']['output'];
};

export type SopAppointmentSchedulingForm = {
  emailsUnparsed: Scalars['String']['input'];
  requestedDt: Scalars['DateTimeISO']['input'];
};

export type SaveBasePromptConfigInput = {
  actionDefinitionId: Scalars['ID']['input'];
  basePromptKey: Scalars['String']['input'];
  config: Scalars['JSON']['input'];
};

export type SaveConversationSnapshotToDatasetInput = {
  conversationId: Scalars['ID']['input'];
  datasetIds: Array<Scalars['String']['input']>;
  timestamp: Scalars['DateTimeISO']['input'];
};

export type SaveConversationSnapshotToDatasetResult = {
  __typename?: 'SaveConversationSnapshotToDatasetResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SaveMessageRatingDetailsInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
  reason?: InputMaybe<MessageRatingReason>;
};

export type SaveRowToDatasetInput = {
  actionExecutionEvents: Array<ActionExecutionEventInput>;
  currentEventId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
};

export type SaveRowToDatasetResult = {
  __typename?: 'SaveRowToDatasetResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SavedComputation = AbstractEntity & Node & {
  __typename?: 'SavedComputation';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<SavedComputationData>;
  dataUrl: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  externalMessageId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  jobId?: Maybe<Scalars['String']['output']>;
  labeledComputations: Array<LabeledComputation>;
  orderId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  originatorId?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['JSON']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SavedComputationType>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SavedComputationConnection = {
  __typename?: 'SavedComputationConnection';
  count: Scalars['Int']['output'];
  edges: Array<SavedComputationEdge>;
  nodes?: Maybe<Array<SavedComputation>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SavedComputationData = {
  __typename?: 'SavedComputationData';
  computationType: SavedComputationType;
  functionName: Scalars['String']['output'];
  inputs: Scalars['JSONObject']['output'];
  output?: Maybe<Scalars['JSON']['output']>;
  timestamp: Scalars['DateTimeISO']['output'];
};

export type SavedComputationEdge = {
  __typename?: 'SavedComputationEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: SavedComputation;
};

export enum SavedComputationType {
  ADDRESS_PARSE = 'ADDRESS_PARSE',
  BUILD_ALL_QUOTES = 'BUILD_ALL_QUOTES',
  BUILD_ORDER = 'BUILD_ORDER',
  DECIDE_IGNORE_MESSAGE = 'DECIDE_IGNORE_MESSAGE',
  DECIDE_MESSAGE_ACTION = 'DECIDE_MESSAGE_ACTION',
  EMAIL_CLASSIFICATION = 'EMAIL_CLASSIFICATION',
  EMAIL_CLASSIFICATION_V2 = 'EMAIL_CLASSIFICATION_V2',
  ENTITY_DISCRIMINATION = 'ENTITY_DISCRIMINATION',
  FILTER_AND_SELECT_ORIGINATOR = 'FILTER_AND_SELECT_ORIGINATOR',
  INFER_MISSING_ADDRESS_COMPONENT = 'INFER_MISSING_ADDRESS_COMPONENT',
  LOCATION_MATCH = 'LOCATION_MATCH',
  MESSAGE_ENTITY_ASSOCIATION = 'MESSAGE_ENTITY_ASSOCIATION',
  ORIGINATOR_RESOLUTION = 'ORIGINATOR_RESOLUTION',
  RESOLVE_ORIGINATOR_AND_CONTACT = 'RESOLVE_ORIGINATOR_AND_CONTACT',
  TEMPLATE_COMPLETION = 'TEMPLATE_COMPLETION'
}

export type SavedComputationsInput = {
  externalMessageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  quoteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  savedComputationClasses?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<SavedComputationType>>;
};

/** A saved view of a user's query. */
export type SavedView = AbstractEntity & Node & {
  __typename?: 'SavedView';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  /** The level of the view. */
  level: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  team: Team;
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user: User;
  /** The type of view. */
  viewType: Scalars['String']['output'];
};

export enum ScheduleMethod {
  BLUE_YONDER = 'BLUE_YONDER',
  COSTCO = 'COSTCO',
  DSDLINK = 'DSDLINK',
  E2OPEN = 'E2OPEN',
  EMAIL = 'EMAIL',
  LMCONNECT = 'LMCONNECT',
  MANHATTAN = 'MANHATTAN',
  NCR = 'NCR',
  OPENDOCK = 'OPENDOCK',
  PHONE = 'PHONE',
  PORTAL = 'PORTAL',
  RYDERSHARE = 'RYDERSHARE',
  YARDVIEW = 'YARDVIEW'
}

/** A plan for scheduling stop appointments on a movement. */
export type SchedulePlan = AbstractEntity & Node & {
  __typename?: 'SchedulePlan';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  plan: Scalars['JSON']['output'];
  planningActionExecution?: Maybe<ActionExecution>;
  status: SchedulePlanStatus;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SchedulePlanEvent = AbstractEntity & Node & {
  __typename?: 'SchedulePlanEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: SchedulePlanEventType;
  schedulePlan: SchedulePlan;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export enum SchedulePlanEventType {
  APPROVED = 'APPROVED',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED'
}

export enum SchedulePlanStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  EXECUTING = 'EXECUTING',
  PLANNING = 'PLANNING'
}

export enum SchedulePortalType {
  BLUE_YONDER = 'BLUE_YONDER',
  COSTCO = 'COSTCO',
  DSDLINK = 'DSDLINK',
  E2OPEN = 'E2OPEN',
  LMCONNECT = 'LMCONNECT',
  MANHATTAN = 'MANHATTAN',
  NCR = 'NCR',
  OPENDOCK = 'OPENDOCK',
  RYDERSHARE = 'RYDERSHARE',
  YARDVIEW = 'YARDVIEW'
}

/** Settings for scheduling functionality. */
export type ScheduleSettings = AbstractEntity & Node & {
  __typename?: 'ScheduleSettings';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  plannerActionDefinitionId?: Maybe<Scalars['String']['output']>;
  planningSettings: PlanningSettings;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** A scheduling method for a place. */
export type SchedulingMethod = AbstractEntity & Node & {
  __typename?: 'SchedulingMethod';
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  methodType: ScheduleMethod;
  organization: Organization;
  place: Place;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SeedCoverDemoDataInput = {
  organizationId: Scalars['String']['input'];
};

export type SeedCoverDemoDataPayload = {
  __typename?: 'SeedCoverDemoDataPayload';
  actionExecutionsSeeded: Scalars['Int']['output'];
  carrierOffersSeeded: Scalars['Int']['output'];
  coveragePlansSeeded: Scalars['Int']['output'];
  shipmentsCreated: Scalars['Int']['output'];
  shipmentsUpdated: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type SeedVeeDemoDataInput = {
  organizationId: Scalars['String']['input'];
};

export type SeedVeeDemoDataPayload = {
  __typename?: 'SeedVeeDemoDataPayload';
  success: Scalars['Boolean']['output'];
};

export type SelectQuickReplyInput = {
  cardId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  optionIndex: Scalars['Int']['input'];
};

export type SemanticWaitExchangeItemInput = {
  role: Scalars['String']['input'];
  transcript: Scalars['String']['input'];
};

export type SemanticWaitPatternSimulationResult = {
  __typename?: 'SemanticWaitPatternSimulationResult';
  patternName: Scalars['String']['output'];
  status: SemanticWaitStatus;
};

export enum SemanticWaitStatus {
  DORMANT = 'DORMANT',
  INACTIVE = 'INACTIVE',
  SHOULD_WAIT = 'SHOULD_WAIT',
  WAIT_COMPLETED = 'WAIT_COMPLETED'
}

export type SendFrontMessageInput = {
  bccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  ccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  channelEmail?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  frontConversationId: Scalars['String']['input'];
  frontUserEmail: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  originatorAddress?: InputMaybe<Scalars['String']['input']>;
};

export type SendFrontMessagePayload = {
  __typename?: 'SendFrontMessagePayload';
  success: Scalars['Boolean']['output'];
};

export type SendGmailMessageInput = {
  draftId: Scalars['String']['input'];
};

export type SendGmailMessagePayload = {
  __typename?: 'SendGmailMessagePayload';
  success: Scalars['Boolean']['output'];
};

export type SendOutlookMessageInput = {
  /** Address of the mailbox the add-in is viewing */
  mailboxAddress?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['String']['input'];
  sharedInbox?: InputMaybe<Scalars['String']['input']>;
};

export type SendOutlookMessagePayload = {
  __typename?: 'SendOutlookMessagePayload';
  success: Scalars['Boolean']['output'];
};

export type SendSamplesInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  generateMany?: InputMaybe<Scalars['Boolean']['input']>;
  locationCode?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  transmitId?: InputMaybe<Scalars['String']['input']>;
};

export type SendSamplesPayload = {
  __typename?: 'SendSamplesPayload';
  failedSamples?: Maybe<Array<FailedSample>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SendTestNotificationInput = {
  organizationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['String']['input'];
};

export type SentMessageView = {
  __typename?: 'SentMessageView';
  body: Scalars['String']['output'];
  ccRecipients: Array<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toRecipients: Array<Scalars['String']['output']>;
};

export type SetGlobalPromptVersionInput = {
  globalPromptId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type SetHostedMcLeodInstanceUrlsInput = {
  hostedInstanceDevURL?: InputMaybe<Scalars['String']['input']>;
  hostedInstanceURL: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type SetHostedMcLeodInstanceUrlsPayload = {
  __typename?: 'SetHostedMcLeodInstanceUrlsPayload';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type SetLandstarConfigInput = {
  agencyCode?: InputMaybe<Scalars['String']['input']>;
  isLive: Scalars['Boolean']['input'];
  nonProdEnv?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sendAsProduction: Scalars['Boolean']['input'];
};

export type SetLandstarConfigPayload = {
  __typename?: 'SetLandstarConfigPayload';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type SetMercuryGateConfigInput = {
  baseUrl: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  useRestApi: Scalars['Boolean']['input'];
};

export type SetMercuryGateConfigPayload = {
  __typename?: 'SetMercuryGateConfigPayload';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type SetMovementTrackingPausedInput = {
  movementId: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
  source?: InputMaybe<TrackingPauseSource>;
};

export type SetTeamAfterHoursAlwaysOnInput = {
  alwaysOn: Scalars['Boolean']['input'];
  teamId: Scalars['ID']['input'];
};

export type SetTeamAfterHoursAlwaysOnPayload = {
  __typename?: 'SetTeamAfterHoursAlwaysOnPayload';
  /** The saved Always on value. */
  alwaysOn?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether after hours is in effect right now, from Always on or the weekly schedule. */
  isAfterHoursActive?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetTrackSopInput = {
  organizationId: Scalars['ID']['input'];
  provisionKey: Scalars['String']['input'];
};

export type SetTrackSopPayload = {
  __typename?: 'SetTrackSopPayload';
  actionDefinition: ActionDefinition;
};

export type SetUsageBlockInput = {
  level: UsageBlockLevel;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetUsageCapInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  scope: UsageCapScope;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetWorkflowSponsoredInput = {
  actionDefinitionId: Scalars['ID']['input'];
  isVoomaSponsored: Scalars['Boolean']['input'];
};

export type SettingsEntityInfo = {
  __typename?: 'SettingsEntityInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: SettingsEntityType;
};

export enum SettingsEntityType {
  GLOBAL = 'GLOBAL',
  ORGANIZATION = 'ORGANIZATION',
  ORIGINATOR = 'ORIGINATOR',
  TEAM = 'TEAM',
  USER = 'USER'
}

export type SharedFile = AbstractEntity & AbstractSharedFile & Node & {
  __typename?: 'SharedFile';
  createdAt: Scalars['DateTimeISO']['output'];
  currentVersion?: Maybe<SharedFileVersion>;
  currentVersionId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SharedFileConnection = {
  __typename?: 'SharedFileConnection';
  count: Scalars['Int']['output'];
  edges: Array<SharedFileSummaryEdge>;
  nodes?: Maybe<Array<SharedFileSummary>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SharedFileScope {
  GLOBAL = 'GLOBAL',
  ORGANIZATION = 'ORGANIZATION'
}

export type SharedFileSummary = {
  __typename?: 'SharedFileSummary';
  canEdit: Scalars['Boolean']['output'];
  currentVersion?: Maybe<SharedFileVersionSummary>;
  id: Scalars['ID']['output'];
  scope: SharedFileScope;
};

export type SharedFileSummaryEdge = {
  __typename?: 'SharedFileSummaryEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: SharedFileSummary;
};

export type SharedFileVersion = AbstractEntity & AbstractSharedFileVersion & Node & {
  __typename?: 'SharedFileVersion';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type SharedFileVersionSummary = {
  __typename?: 'SharedFileVersionSummary';
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SharedFilesInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SharedInbox = {
  __typename?: 'SharedInbox';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SharedInboxInput = {
  authTokenType: AuthTokenType;
  query: Scalars['String']['input'];
};

export type Shipment = AbstractEntity & Node & {
  __typename?: 'Shipment';
  carrierRates?: Maybe<Array<ShipmentCarrierMetadata>>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  deliveryDatetime?: Maybe<Scalars['DateTimeISO']['output']>;
  externalDeepLink?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movements: Array<Movement>;
  organization: Organization;
  pickupDatetime?: Maybe<Scalars['DateTimeISO']['output']>;
  referenceNumbers?: Maybe<Array<Scalars['String']['output']>>;
  route?: Maybe<Scalars['JSON']['output']>;
  schedulingInfo: ShipmentSchedulingInfoPayload;
  trackingInfo: ShipmentTrackingInfoPayload;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  user?: Maybe<User>;
};

export enum ShipmentCsvImportType {
  VOOMA_SHIPMENT_SCHEMA = 'VOOMA_SHIPMENT_SCHEMA'
}

export type ShipmentCarrierMetadata = {
  __typename?: 'ShipmentCarrierMetadata';
  buyRate?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pickupAt?: Maybe<Scalars['String']['output']>;
  sellRate?: Maybe<Scalars['Float']['output']>;
};

export type ShipmentConnection = {
  __typename?: 'ShipmentConnection';
  count: Scalars['Int']['output'];
  edges: Array<ShipmentEdge>;
  nodes?: Maybe<Array<Shipment>>;
  pageInfo: PageInfo;
  savedViewRedirect?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type ShipmentDateFilter = {
  /** List Shipment that have been created at or before the given date. */
  end?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List Shipment that have been created in the last N days. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** List Shipment that have been created in the next N days. */
  next?: InputMaybe<Scalars['Int']['input']>;
  /** List Shipment that have been created at or after the given date. */
  start?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type ShipmentDistanceResult = {
  __typename?: 'ShipmentDistanceResult';
  distance: Scalars['Float']['output'];
  usdPerMile: Scalars['Float']['output'];
};

export type ShipmentEdge = {
  __typename?: 'ShipmentEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Shipment;
};

export type ShipmentEquipmentType = {
  __typename?: 'ShipmentEquipmentType';
  equipmentType?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
};

export type ShipmentEvent = AbstractEntity & Node & {
  __typename?: 'ShipmentEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<ShipmentEventData>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: ShipmentEventType;
  shipment: Shipment;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export type ShipmentEventData = OtherShipmentEventData;

export enum ShipmentEventType {
  OTHER = 'OTHER'
}

export enum ShipmentImportSource {
  ALJEX = 'ALJEX',
  ALVYS = 'ALVYS',
  CSV_UPLOAD = 'CSV_UPLOAD',
  HOSTED_MCLEOD = 'HOSTED_MCLEOD',
  INTEGRATIONLESS = 'INTEGRATIONLESS',
  MONTWAY = 'MONTWAY',
  REVENOVA = 'REVENOVA',
  TAI = 'TAI',
  THREE_PL = 'THREE_PL',
  TRANSFIX = 'TRANSFIX'
}

export type ShipmentLookupResultType = {
  __typename?: 'ShipmentLookupResultType';
  description: Scalars['String']['output'];
  equipment?: Maybe<Array<ShipmentEquipmentType>>;
  error?: Maybe<Scalars['String']['output']>;
  found: Scalars['Boolean']['output'];
  hasCarrier?: Maybe<Scalars['Boolean']['output']>;
  matchCount: Scalars['Float']['output'];
  movementId?: Maybe<Scalars['String']['output']>;
  pricingData?: Maybe<ShipmentPricingType>;
  referenceNumber: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  stops?: Maybe<Array<ShipmentStopType>>;
};

export type ShipmentPricingType = {
  __typename?: 'ShipmentPricingType';
  maxPrice?: Maybe<Scalars['Float']['output']>;
  targetPrice?: Maybe<Scalars['Float']['output']>;
};

export type ShipmentSchedulingInfoPayload = {
  __typename?: 'ShipmentSchedulingInfoPayload';
  stops: Array<Scalars['JSON']['output']>;
  tmsId?: Maybe<Scalars['String']['output']>;
};

export type ShipmentStopLocationType = {
  __typename?: 'ShipmentStopLocationType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ShipmentStopType = {
  __typename?: 'ShipmentStopType';
  endDateTime?: Maybe<Scalars['String']['output']>;
  location: ShipmentStopLocationType;
  startDateTime?: Maybe<Scalars['String']['output']>;
  stopType?: Maybe<Scalars['String']['output']>;
};

export type ShipmentTrackingInfoPayload = {
  __typename?: 'ShipmentTrackingInfoPayload';
  dispatchEmail?: Maybe<Scalars['String']['output']>;
  dispatchName?: Maybe<Scalars['String']['output']>;
  dispatchPhone?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
};

export type ShipmentsInput = {
  createdDateFilter?: InputMaybe<ShipmentDateFilter>;
  deliveryDateFilter?: InputMaybe<ShipmentDateFilter>;
  equipmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCarrier?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  laneFilter?: InputMaybe<LaneFilter>;
  loadboardFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  onHold?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pickupDateFilter?: InputMaybe<ShipmentDateFilter>;
  referenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ShippingOrder = AbstractEntity & Node & {
  __typename?: 'ShippingOrder';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  originator?: Maybe<Originator>;
  shipment: Shipment;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ShippingOrderMovementAssociation = AbstractEntity & Node & {
  __typename?: 'ShippingOrderMovementAssociation';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  movement: Movement;
  organization: Organization;
  shippingOrder: ShippingOrder;
  source: ShippingOrder;
  target: Movement;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type ShouldTrackSimulationResult = {
  __typename?: 'ShouldTrackSimulationResult';
  error?: Maybe<Scalars['String']['output']>;
  movementId: Scalars['ID']['output'];
  passed: Scalars['Boolean']['output'];
  pickupStop?: Maybe<Stop>;
  shipmentId: Scalars['ID']['output'];
  shipmentReferenceNumber?: Maybe<Scalars['String']['output']>;
};

export enum SidekickSupportedTms {
  ALJEX = 'ALJEX',
  LEGACY_MERCURYGATE = 'LEGACY_MERCURYGATE',
  LOADSMART = 'LOADSMART',
  LOADSTOP = 'LOADSTOP',
  MCLEOD_WEB = 'MCLEOD_WEB',
  MERCURYGATE = 'MERCURYGATE',
  TAI = 'TAI',
  THREE_PL = 'THREE_PL',
  TURVO = 'TURVO',
  UBER_GTG = 'UBER_GTG',
  UNKNOWN = 'UNKNOWN'
}

export type SimulateCarrierVerificationInput = {
  organizationId: Scalars['ID']['input'];
  verificationPairs: Array<McVerificationPairInput>;
};

export type SimulateCarrierVerificationPayload = {
  __typename?: 'SimulateCarrierVerificationPayload';
  error?: Maybe<Scalars['String']['output']>;
  matchCount: Scalars['Float']['output'];
  passCount: Scalars['Float']['output'];
  results: Array<CarrierVerificationSimulationResultType>;
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Float']['output'];
};

export type SimulateNegotiationInput = {
  carrierContext?: InputMaybe<SimulationCarrierContextInput>;
  carrierInterestContext?: InputMaybe<CarrierInterestContextInput>;
  configOverride?: InputMaybe<Scalars['JSON']['input']>;
  exceptionStatus?: InputMaybe<EscalationStatus>;
  maxPrice: Scalars['Float']['input'];
  offerHistory: Array<SimulationOfferInput>;
  organizationId: Scalars['ID']['input'];
  shipmentReference: Scalars['String']['input'];
  strategyId: Scalars['ID']['input'];
  targetPrice: Scalars['Float']['input'];
  triggerActualExceptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SimulateNegotiationResult = {
  __typename?: 'SimulateNegotiationResult';
  error?: Maybe<Scalars['String']['output']>;
  handlerActionExecutionId?: Maybe<Scalars['ID']['output']>;
  needsClarification?: Maybe<ClarificationRequestType>;
  recommendedAction?: Maybe<Scalars['String']['output']>;
  strategyUsed?: Maybe<StrategyUsedType>;
  success: Scalars['Boolean']['output'];
  triggerException?: Maybe<ExceptionTriggerType>;
  variantStrategyId?: Maybe<Scalars['String']['output']>;
  variantStrategyName?: Maybe<Scalars['String']['output']>;
};

export type SimulateQuoteJobReplyInput = {
  id: Scalars['ID']['input'];
  simulationInput?: InputMaybe<SimulateQuoteJobReplyOverridesInput>;
};

export type SimulateQuoteJobReplyOverridesInput = {
  settingsOverride?: InputMaybe<SimulationSettingsOverrideInput>;
  whenToRespondInstructionsOverride?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SimulateQuoteJobReplyPayload = {
  __typename?: 'SimulateQuoteJobReplyPayload';
  steps: Array<SimulationStepType>;
  success: Scalars['Boolean']['output'];
};

export type SimulateSemanticWaitPatternsInput = {
  exchange: Array<SemanticWaitExchangeItemInput>;
  id: Scalars['ID']['input'];
  lookbackTurns?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulateSemanticWaitPatternsPayload = {
  __typename?: 'SimulateSemanticWaitPatternsPayload';
  results: Array<SemanticWaitPatternSimulationResult>;
};

export type SimulateShipmentLookupInput = {
  organizationId: Scalars['ID']['input'];
  referenceNumbers: Array<Scalars['String']['input']>;
};

export type SimulateShipmentLookupPayload = {
  __typename?: 'SimulateShipmentLookupPayload';
  error?: Maybe<Scalars['String']['output']>;
  foundCount: Scalars['Float']['output'];
  results: Array<ShipmentLookupResultType>;
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Float']['output'];
};

export type SimulateShouldTrackRuleInput = {
  organizationId: Scalars['ID']['input'];
  sampleSize: Scalars['Int']['input'];
  transformationDef: Scalars['JSON']['input'];
};

export type SimulateShouldTrackRulePayload = {
  __typename?: 'SimulateShouldTrackRulePayload';
  evaluatedCount: Scalars['Int']['output'];
  passedCount: Scalars['Int']['output'];
  results: Array<ShouldTrackSimulationResult>;
};

export type SimulateTransitLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['ID']['input']>;
};

export type SimulateTransitTimeInput = {
  destination: SimulateTransitLocationInput;
  id: Scalars['ID']['input'];
  mileage?: InputMaybe<Scalars['Float']['input']>;
  origin: SimulateTransitLocationInput;
};

export type SimulateTransitTimePayload = {
  __typename?: 'SimulateTransitTimePayload';
  mileage: Scalars['Float']['output'];
  milesPerDay?: Maybe<Scalars['Float']['output']>;
  provider: Scalars['String']['output'];
  strategyType: Scalars['String']['output'];
  transitDays: Scalars['Float']['output'];
};

export type SimulationCarrierContextInput = {
  equipmentType?: InputMaybe<Scalars['String']['input']>;
};

export type SimulationOfferInput = {
  offeredBy: SimulationOfferedBy;
  price: Scalars['Float']['input'];
};

/** Who made the offer in a negotiation */
export enum SimulationOfferedBy {
  COUNTERPARTY = 'COUNTERPARTY',
  ME = 'ME'
}

export type SimulationOrganizationPayload = {
  __typename?: 'SimulationOrganizationPayload';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SimulationPricingStrategyInput = {
  config: Scalars['JSON']['input'];
  type: PricingStrategyType;
};

export type SimulationSettingsOverrideInput = {
  alwaysOnDraftingInstructions?: InputMaybe<Scalars['String']['input']>;
  autoReplyScope?: InputMaybe<QuoteAutoReplyScope>;
  bccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  ccRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  draftTemplateType?: InputMaybe<Scalars['String']['input']>;
  draftingInstructions?: InputMaybe<Scalars['String']['input']>;
  pricingStrategy?: InputMaybe<SimulationPricingStrategyInput>;
  sendDelaySeconds?: InputMaybe<Scalars['Float']['input']>;
  whenToRespondInstructions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SimulationSettingsPayload = {
  __typename?: 'SimulationSettingsPayload';
  carrierInquiryActionDefinitionId?: Maybe<Scalars['ID']['output']>;
  carrierInquiryActionDefinitionOrganizationId?: Maybe<Scalars['ID']['output']>;
  enabled: Scalars['Boolean']['output'];
  intervalMinutes: Scalars['Int']['output'];
  isSimulationBroker: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
};

export enum SimulationStepStatus {
  ERROR = 'ERROR',
  OK = 'OK',
  PENDING = 'PENDING',
  SKIPPED = 'SKIPPED'
}

export type SimulationStepType = {
  __typename?: 'SimulationStepType';
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['DateTimeISO']['output'];
  status: SimulationStepStatus;
  title: Scalars['String']['output'];
};

export type SingleWorkerConfig = {
  __typename?: 'SingleWorkerConfig';
  type: WorkersConfigType;
};

export enum SkillChangeApprovalOutcome {
  APPLIED = 'APPLIED',
  DENIED = 'DENIED'
}

export enum SlackMessageSource {
  CHANNEL = 'CHANNEL',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE'
}

export type SlackMessageTriggerConfig = {
  __typename?: 'SlackMessageTriggerConfig';
  override?: Maybe<BaseTriggerOverride>;
  respondToAnyChannelMessage?: Maybe<Scalars['Boolean']['output']>;
  showToolActivity?: Maybe<Scalars['Boolean']['output']>;
  slackChannelIds?: Maybe<Array<Scalars['String']['output']>>;
  sources: Array<SlackMessageSource>;
  triggerType: ActionTriggerConfigType;
};

export type SmartFilterSettings = {
  __typename?: 'SmartFilterSettings';
  /** When set, also skip events where the truck moved less than this many miles from the last event location, even if city or state changed. Requires coordinates on both events; ignored otherwise. */
  minDistanceMiles?: Maybe<Scalars['Float']['output']>;
};

export type SmartFilterSettingsInput = {
  /** When set, also skip events where the truck moved less than this many miles from the last event location, even if city or state changed. Requires coordinates on both events; ignored otherwise. */
  minDistanceMiles?: InputMaybe<Scalars['Float']['input']>;
};

export type SmartPricingConfigType = {
  __typename?: 'SmartPricingConfigType';
  /** Bayesian alpha prior for the acceptance model. Defaults to 1.0 (uniform prior). */
  alphaPrior?: Maybe<Scalars['Float']['output']>;
  autoRejectThreshold?: Maybe<Scalars['Float']['output']>;
  /** Percentage above max price that triggers automatic rejection. When specified, carrier offers exceeding maxPrice * (1 + autoRejectThresholdPercent/100) will be declined. A minimum floor is applied internally to handle edge cases with very low-priced loads. */
  autoRejectThresholdPercent?: Maybe<Scalars['Float']['output']>;
  /** Bayesian beta prior for the acceptance model. Defaults to 1.0 (uniform prior). */
  betaPrior?: Maybe<Scalars['Float']['output']>;
  /** Controls behavior when the carrier stops moving on price (their last two offers differ by less than the budge threshold). DONT_BUDGE (default when unset) reiterates the last outbound offer; NEGOTIATE continues incrementing instead. */
  carrierNoBudgeBehavior?: Maybe<CarrierNoBudgeBehavior>;
  /** Expected number of carrier offers per available truck. Combined with the truck-to-load ratio to estimate total expected offers — e.g., if the ratio is 3 and this value is 5, the model expects 15 offers. */
  expectedOffersPerTruckToLoad?: Maybe<Scalars['Float']['output']>;
  /** Constant added to totalCharge to calculate the cost of failing to book. Defaults to 500. */
  failCostConstant?: Maybe<Scalars['Float']['output']>;
  /** Fixed dollar amount to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. Cannot be combined with firstOfferBelowTargetCounterPercent. */
  firstOfferBelowTargetCounterDollars?: Maybe<Scalars['Float']['output']>;
  /** Percentage to counter below the carrier's first offer when it is below the target price and we have not yet made an offer. For example, 5 means counter at 95% of the carrier's offer. Cannot be combined with firstOfferBelowTargetCounterDollars. */
  firstOfferBelowTargetCounterPercent?: Maybe<Scalars['Float']['output']>;
  /** Maximum number of negotiation rounds before giving up. Defaults to 20. */
  maxSteps?: Maybe<Scalars['Int']['output']>;
  /** Scaling factor for negotiation steps. If Vooma handles 1 out of every N offers, set this to N. Defaults to 3. */
  offerSamplingRate?: Maybe<Scalars['Float']['output']>;
  /** Custom message when the recommended price exceeds the max price and requires approval. Supports ${{recommendedPrice}} and ${{maxPrice}} placeholders. Defaults to a message asking to transfer the carrier to a representative. */
  requiresApprovalMessage?: Maybe<Scalars['String']['output']>;
  /** Fixed dollar amount added to the target price for the opening offer. The negotiation starts at targetPrice + targetBuffer and follows the strategy from there. Cannot be combined with targetBufferPercent. */
  targetBuffer?: Maybe<Scalars['Float']['output']>;
  /** Percentage of the (maxPrice − targetPrice) range added to the target price for the opening offer. For example, 50 means start halfway between target and max. Cannot be combined with targetBuffer. */
  targetBufferPercent?: Maybe<Scalars['Float']['output']>;
  /** Exponential decay factor per day for historical data weighting. 1.0 means no decay, 0.95 means 5% decay per day. Defaults to 0.95. */
  timeDecay?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type SmartPricingPriorsResult = {
  __typename?: 'SmartPricingPriorsResult';
  acceptancePriors: Array<AcceptancePriorPoint>;
  continuationPriors: Array<ContinuationPriorPoint>;
};

export type SopEditProposalItem = {
  __typename?: 'SopEditProposalItem';
  anchor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lineHint?: Maybe<Scalars['Int']['output']>;
  rationale: Scalars['String']['output'];
  replacement: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SopMetadata = {
  __typename?: 'SopMetadata';
  /** The Track SOP catalog entry this SOP is provisioned from */
  catalogKey?: Maybe<Scalars['String']['output']>;
  /** What this SOP does in a Track run */
  trackStepKind?: Maybe<TrackStepKind>;
};

export type SopOrgRef = {
  __typename?: 'SopOrgRef';
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  promptId?: Maybe<Scalars['ID']['output']>;
};

export type SopOverview = {
  __typename?: 'SopOverview';
  displayName: Scalars['String']['output'];
  orgs: Array<SopOrgRef>;
  params: Array<SopParamOverview>;
  prompts: Array<SopPrompt>;
  resourceName: Scalars['String']['output'];
};

export type SopParamOverview = {
  __typename?: 'SopParamOverview';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  values: Array<ParamCellValue>;
};

export type SopParamsOverview = {
  __typename?: 'SopParamsOverview';
  organizations: Array<OrgSummary>;
  sops: Array<SopOverview>;
};

export type SopPrompt = {
  __typename?: 'SopPrompt';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SortInput = {
  field: Scalars['String']['input'];
  order: Scalars['String']['input'];
};

export type SpamGuardData = {
  __typename?: 'SpamGuardData';
  communicationChannel: CommunicationChannel;
  eventDataType: ActionExecutionEventType;
  fromIdentifier: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  toIdentifier: Scalars['String']['output'];
};

export type SponsoredWorkflow = {
  __typename?: 'SponsoredWorkflow';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SsoProviderSettings = {
  __typename?: 'SsoProviderSettings';
  autoProvisioningEnabled: Scalars['Boolean']['output'];
  connectionName: Scalars['String']['output'];
  emailDomains?: Maybe<Array<Scalars['String']['output']>>;
  groups?: Maybe<Array<Scalars['String']['output']>>;
  linkExistingUsers?: Maybe<Scalars['Boolean']['output']>;
};

export type SsoSettings = {
  __typename?: 'SsoSettings';
  auth0?: Maybe<Array<SsoProviderSettings>>;
};

export enum StandardFreightOrderEquipmentType {
  AUTO_CARRIER = 'AUTO_CARRIER',
  BOAT_HAULING_TRAILER = 'BOAT_HAULING_TRAILER',
  BOX_TRUCK = 'BOX_TRUCK',
  CARGO_VAN = 'CARGO_VAN',
  CHASSIS_ONLY = 'CHASSIS_ONLY',
  CHASSIS_ONLY_SUPER = 'CHASSIS_ONLY_SUPER',
  CHASSIS_ONLY_TRI_AXLE = 'CHASSIS_ONLY_TRI_AXLE',
  CONESTOGA = 'CONESTOGA',
  CONTAINER = 'CONTAINER',
  CONTAINER_FLAT_RACK = 'CONTAINER_FLAT_RACK',
  CONTAINER_HIGH_CUBE = 'CONTAINER_HIGH_CUBE',
  CONTAINER_INSULATED = 'CONTAINER_INSULATED',
  CONTAINER_OPEN_TOP = 'CONTAINER_OPEN_TOP',
  CONTAINER_REFRIGERATED = 'CONTAINER_REFRIGERATED',
  DOUBLE_DROP = 'DOUBLE_DROP',
  DRY_VAN = 'DRY_VAN',
  DUMP_TRUCK = 'DUMP_TRUCK',
  FLATBED = 'FLATBED',
  FLATBED_B_TRAIN = 'FLATBED_B_TRAIN',
  FLATBED_EXTENDABLE = 'FLATBED_EXTENDABLE',
  FLATBED_MAXI = 'FLATBED_MAXI',
  FLATBED_OR_STEP_DECK = 'FLATBED_OR_STEP_DECK',
  HOPPER_BOTTOM = 'HOPPER_BOTTOM',
  HOT_SHOT = 'HOT_SHOT',
  LIVESTOCK = 'LIVESTOCK',
  LOW_BOY = 'LOW_BOY',
  MULTI_AXLE_HEAVY_HAULER = 'MULTI_AXLE_HEAVY_HAULER',
  OTHER = 'OTHER',
  POWER_ONLY = 'POWER_ONLY',
  REEFER = 'REEFER',
  REMOVABLE_GOOSENECK = 'REMOVABLE_GOOSENECK',
  REMOVABLE_GOOSENECK_EXTENDABLE = 'REMOVABLE_GOOSENECK_EXTENDABLE',
  SPRINTER_VAN = 'SPRINTER_VAN',
  STEP_DECK = 'STEP_DECK',
  STEP_DECK_CONESTOGA = 'STEP_DECK_CONESTOGA',
  STRAIGHT_TRUCK = 'STRAIGHT_TRUCK',
  TANKER = 'TANKER',
  TANKER_ALUMINUM = 'TANKER_ALUMINUM',
  TANKER_CHEMICAL = 'TANKER_CHEMICAL',
  TANKER_CONTAINER = 'TANKER_CONTAINER',
  TANKER_MULTI_COMPARTMENT = 'TANKER_MULTI_COMPARTMENT',
  TANKER_PNEUMATIC = 'TANKER_PNEUMATIC',
  TANKER_STEEL = 'TANKER_STEEL',
  VAN_CURTAIN_SIDE = 'VAN_CURTAIN_SIDE',
  VAN_DOUBLE_PUP = 'VAN_DOUBLE_PUP',
  VAN_INSULATED = 'VAN_INSULATED',
  VAN_OPEN_TOP = 'VAN_OPEN_TOP',
  VAN_OR_FLATBED = 'VAN_OR_FLATBED',
  VAN_OR_REEFER = 'VAN_OR_REEFER',
  VAN_PLATED = 'VAN_PLATED',
  VAN_TRIPLE_PUP = 'VAN_TRIPLE_PUP',
  VAN_VENTED = 'VAN_VENTED'
}

export type StartMicrosoftGraphConnectPayload = {
  __typename?: 'StartMicrosoftGraphConnectPayload';
  authorizeUrl: Scalars['String']['output'];
};

export type StartOrganizationBillingInput = {
  monthlyCommitCents: Scalars['Int']['input'];
  startsAt: Scalars['DateTimeISO']['input'];
};

export type StartTeamsAdminConsentPayload = {
  __typename?: 'StartTeamsAdminConsentPayload';
  authorizeUrl: Scalars['String']['output'];
};

export type StartTrackSopTestInput = {
  actionDefinitionId: Scalars['ID']['input'];
  exceptionType?: InputMaybe<LoadExceptionType>;
  milestoneType?: InputMaybe<TrackingMilestoneType>;
  redirectEmailAddress?: InputMaybe<Scalars['String']['input']>;
  redirectPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  sourceMovementId: Scalars['ID']['input'];
};

export type StartTrackSopTestPayload = {
  __typename?: 'StartTrackSopTestPayload';
  actionExecutionId?: Maybe<Scalars['ID']['output']>;
  movementId: Scalars['ID']['output'];
  referenceNumber: Scalars['String']['output'];
  shipmentId: Scalars['ID']['output'];
};

export type StationaryVehicleExceptionSettings = {
  __typename?: 'StationaryVehicleExceptionSettings';
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: Maybe<Scalars['Float']['output']>;
  /** Minutes at same location before triggering VEHICLE_IS_NOT_MOVING exception */
  thresholdMinutes: Scalars['Float']['output'];
};

export type StationaryVehicleExceptionSettingsInput = {
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes at same location before triggering VEHICLE_IS_NOT_MOVING exception */
  thresholdMinutes: Scalars['Float']['input'];
};

export type StatusChangedData = {
  __typename?: 'StatusChangedData';
  eventDataType: ActionExecutionEventType;
  fromStatus: ActionExecutionStatus;
  toStatus: ActionExecutionStatus;
};

export type Stop = {
  __typename?: 'Stop';
  dateTimeRanges: Array<DateTimeRange>;
  externalNotes?: Maybe<Scalars['String']['output']>;
  location: Location;
  stopType?: Maybe<StopType>;
};

export type StopArrivedData = {
  __typename?: 'StopArrivedData';
  arrivedAt: Scalars['String']['output'];
  eventType: MovementEventType;
  movementStopId: Scalars['String']['output'];
};

export type StopClearedData = {
  __typename?: 'StopClearedData';
  arrivedAt?: Maybe<Scalars['String']['output']>;
  clearedAt: Scalars['String']['output'];
  eventType: MovementEventType;
  movementStopId: Scalars['String']['output'];
};

export type StopEtaUpdatedData = {
  __typename?: 'StopEtaUpdatedData';
  eta: Scalars['String']['output'];
  eventType: MovementEventType;
  movementStopId?: Maybe<Scalars['String']['output']>;
};

export type StopEvent = AbstractEntity & Node & {
  __typename?: 'StopEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  eventTimestamp?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name: StopEventType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  userId?: Maybe<User>;
};

export enum StopEventType {
  ARRIVED = 'ARRIVED',
  CLEARED = 'CLEARED'
}

export type StopMarketConditions = {
  __typename?: 'StopMarketConditions';
  apiResponse: Scalars['JSON']['output'];
  requestType: CachedRequestType;
};

export type StopSettings = {
  __typename?: 'StopSettings';
  delivery: DeliveryTrackEventSettings;
  pickup: PickupTrackEventSettings;
  stops: StopTrackEventSettings;
};

export type StopSettingsInput = {
  delivery: DeliveryTrackEventSettingsInput;
  pickup: PickupTrackEventSettingsInput;
  stops: StopTrackEventSettingsInput;
};

export type StopTrackEventSettings = {
  __typename?: 'StopTrackEventSettings';
  after?: Maybe<MilestoneAfterSettings>;
  at?: Maybe<MilestoneAtSettings>;
  before?: Maybe<MilestoneBeforeSettings>;
  /** @deprecated Use before/after/at `enabled` flags instead */
  checkTypes?: Maybe<Array<CheckTypes>>;
  /** @deprecated Use before.minutesBefore / after.minutesAfter instead */
  timeWindowMinutes?: Maybe<Scalars['Float']['output']>;
};

export type StopTrackEventSettingsInput = {
  after?: InputMaybe<MilestoneAfterSettingsInput>;
  at?: InputMaybe<MilestoneAtSettingsInput>;
  before?: InputMaybe<MilestoneBeforeSettingsInput>;
  /** @deprecated Use before/after/at `enabled` flags instead */
  checkTypes?: InputMaybe<Array<CheckTypes>>;
  /** @deprecated Use before.minutesBefore / after.minutesAfter instead */
  timeWindowMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export enum StopType {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP'
}

export type StrategyUsedType = {
  __typename?: 'StrategyUsedType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum SubmitOrderError {
  DOCUMENT_UPLOAD_FAILED = 'DOCUMENT_UPLOAD_FAILED'
}

export type SubmitOrderInput = {
  id: Scalars['String']['input'];
};

export type SubmitOrderPayload = {
  __typename?: 'SubmitOrderPayload';
  errors?: Maybe<Array<SubmitOrderError>>;
  order: Order;
  success: Scalars['Boolean']['output'];
};

export type SubmitSubjectOrderInput = {
  organizationId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};

export type SubmitSubjectOrderPayload = {
  __typename?: 'SubmitSubjectOrderPayload';
  error?: Maybe<Scalars['String']['output']>;
  externalOrderId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscribeToActionDefinitionInput = {
  actionDefinitionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SubscribeToActionDefinitionPayload = {
  __typename?: 'SubscribeToActionDefinitionPayload';
  actionDefinition: ActionDefinition;
};

export type Subscription = {
  __typename?: 'Subscription';
  conversationActionExecutionUpdated: ConversationActionExecutionUpdatePayload;
  conversationUpdated: ConversationUpdatePayload;
};


export type SubscriptionConversationActionExecutionUpdatedArgs = {
  conversationIds: Array<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type SubscriptionConversationUpdatedArgs = {
  organizationId: Scalars['String']['input'];
};

export enum SubscriptionType {
  AGENTMAIL = 'AGENTMAIL',
  FRONT = 'FRONT',
  GMAIL = 'GMAIL',
  OUTLOOK = 'OUTLOOK'
}

export type SuggestedCarrier = {
  __typename?: 'SuggestedCarrier';
  carrierName?: Maybe<Scalars['String']['output']>;
  dotNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mcNumber: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sourceData: CarrierSourceData;
};

export type SupervisorProposedOutputData = {
  __typename?: 'SupervisorProposedOutputData';
  eventDataType: ActionExecutionEventType;
  output: Scalars['JSON']['output'];
};

export type SupervisorReasoningData = {
  __typename?: 'SupervisorReasoningData';
  eventDataType: ActionExecutionEventType;
  reasoning: Scalars['String']['output'];
};

export type SupervisorToolUsedData = {
  __typename?: 'SupervisorToolUsedData';
  completedAt?: Maybe<Scalars['String']['output']>;
  eventDataType: ActionExecutionEventType;
  isBatched?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rawMessage?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<ToolCallStatus>;
  toolCallId?: Maybe<Scalars['String']['output']>;
  toolInput: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput?: Maybe<Scalars['JSON']['output']>;
};

export enum SupportedLanguage {
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH'
}

export enum SupportedVoiceModel {
  ELEVEN_FLASH_V2_5 = 'ELEVEN_FLASH_V2_5',
  ELEVEN_MULTILINGUAL_V2 = 'ELEVEN_MULTILINGUAL_V2',
  ELEVEN_TURBO_V2_5 = 'ELEVEN_TURBO_V2_5',
  VOOMA_ORPHEUS_V0_1 = 'VOOMA_ORPHEUS_V0_1'
}

export type SyncActionDefinitionToShadowOrgInput = {
  id: Scalars['ID']['input'];
};

export type SyncActionDefinitionToShadowOrgPayload = {
  __typename?: 'SyncActionDefinitionToShadowOrgPayload';
  success: Scalars['Boolean']['output'];
  syncedActionDefinitionIds: Array<Scalars['ID']['output']>;
};

export type SyncTemplateInput = {
  id: Scalars['ID']['input'];
};

export type SyncTemplatePayload = {
  __typename?: 'SyncTemplatePayload';
  destinationOrganization: Organization;
  destinationOriginator: Originator;
  destinationTemplate: Template;
  sourceOrganization: Organization;
  success: Scalars['Boolean']['output'];
};

export type TakeConversationSnapshotInput = {
  id: Scalars['ID']['input'];
  timestamp: Scalars['DateTimeISO']['input'];
};

export type TakeConversationSnapshotPayload = {
  __typename?: 'TakeConversationSnapshotPayload';
  success: Scalars['Boolean']['output'];
};

export type Team = AbstractEntity & Node & {
  __typename?: 'Team';
  actionTriggerCount: Scalars['Int']['output'];
  aiPhoneNumbers?: Maybe<Array<AiPhoneNumber>>;
  createdAt: Scalars['DateTimeISO']['output'];
  creator: User;
  creatorId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  description: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inboundPhoneCallTriggers: Array<ActionTrigger>;
  members: Array<TeamMember>;
  name: Scalars['String']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  phoneNumber?: Maybe<PhoneNumber>;
  roles: Array<TeamRole>;
  settings: Scalars['JSON']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** A relation between a Team and an organization user relation. */
export type TeamMember = AbstractEntity & Node & {
  __typename?: 'TeamMember';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organizationUserRelation: OrganizationUserRelation;
  organizationUserRelationId: Scalars['String']['output'];
  role: TeamMemberRole;
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum TeamMemberRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export type TeamOverrideValue = {
  __typename?: 'TeamOverrideValue';
  teamId: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum TeamRole {
  TRACK = 'TRACK'
}

export type TeamsInput = {
  organizationIds: Array<Scalars['ID']['input']>;
};

export type TeamsTenantResultPayload = {
  __typename?: 'TeamsTenantResultPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Template = AbstractEntity & Node & {
  __typename?: 'Template';
  createdAt: Scalars['DateTimeISO']['output'];
  currentRevision: TemplateRevision;
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  modelConfig?: Maybe<ModelConfig>;
  multiOrderPrompt?: Maybe<Scalars['String']['output']>;
  orderBuildPrompt?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  originator?: Maybe<Originator>;
  revisions: Array<TemplateRevision>;
  /**
   * Serialized as JSON
   * @deprecated This field is now stored on the current revision entity.
   */
  specializedTemplate?: Maybe<Scalars['String']['output']>;
  type: TemplateType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  count: Scalars['Int']['output'];
  edges: Array<TemplateEdge>;
  nodes?: Maybe<Array<Template>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum TemplateCreationFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Template;
};

export type TemplateRevision = AbstractEntity & Node & {
  __typename?: 'TemplateRevision';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  entity: Template;
  id: Scalars['ID']['output'];
  /** Serialized as JSON */
  jsonData?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum TemplateType {
  FREIGHT_ORDER = 'FREIGHT_ORDER',
  QUOTE = 'QUOTE'
}

export type TemplatesInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type TerminateConversationCallInput = {
  conversationId: Scalars['ID']['input'];
};

export type TerminateConversationCallPayload = {
  __typename?: 'TerminateConversationCallPayload';
  success: Scalars['Boolean']['output'];
};

export type TextValidationResult = {
  __typename?: 'TextValidationResult';
  rationale: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  textToHighlight: Scalars['String']['output'];
};

export enum ThirdPartyTmsIntegrationTypes {
  ALJEX = 'ALJEX',
  DAT = 'DAT',
  HOSTED_MCLEOD = 'HOSTED_MCLEOD',
  INTEGRATIONLESS = 'INTEGRATIONLESS',
  LEGACY_MERCURYGATE = 'LEGACY_MERCURYGATE',
  LOADSMART = 'LOADSMART',
  LOADSTOP = 'LOADSTOP',
  MCLEOD = 'MCLEOD',
  MERCURYGATE = 'MERCURYGATE',
  MYCARRIERPORTAL = 'MYCARRIERPORTAL',
  REVENOVA = 'REVENOVA',
  STRATEGY_LIVE = 'STRATEGY_LIVE',
  TAI = 'TAI',
  TEST = 'TEST',
  THREE_PL = 'THREE_PL',
  TRUCKER_TOOLS = 'TRUCKER_TOOLS',
  TURVO = 'TURVO'
}

export type ThreadTrackedMovement = {
  __typename?: 'ThreadTrackedMovement';
  isPaused: Scalars['Boolean']['output'];
  movementId: Scalars['ID']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  shipmentId: Scalars['ID']['output'];
};

export enum TimeDisplayStyle {
  TIME_12H = 'TIME_12H',
  TIME_24H = 'TIME_24H'
}

export enum ToolCallStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_RESPONSE = 'NO_RESPONSE',
  SUCCEEDED = 'SUCCEEDED'
}

export type ToolCallView = {
  __typename?: 'ToolCallView';
  args?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type ToolUsedData = {
  __typename?: 'ToolUsedData';
  completedAt?: Maybe<Scalars['String']['output']>;
  eventDataType: ActionExecutionEventType;
  isBatched?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rawMessage?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<ToolCallStatus>;
  toolCallId?: Maybe<Scalars['String']['output']>;
  toolInput: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput?: Maybe<Scalars['JSON']['output']>;
};

export type ToolValidationSchemaInput = {
  toolType: CanonicalToolType;
};

export type ToolValidationSchemaPayload = {
  __typename?: 'ToolValidationSchemaPayload';
  jsonSchema: Scalars['JSON']['output'];
};

export type TrackDashboardCategoryCount = {
  __typename?: 'TrackDashboardCategoryCount';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type TrackDashboardCheckScore = {
  __typename?: 'TrackDashboardCheckScore';
  /** Key of the SOP checklist item, e.g. etaObtained. */
  checkName: Scalars['String']['output'];
  failCount: Scalars['Int']['output'];
  passCount: Scalars['Int']['output'];
};

export type TrackDashboardDisruptions = {
  __typename?: 'TrackDashboardDisruptions';
  /** Runs where a disruption came up and the agent escalated to the party the SOP names. */
  saved: Scalars['Int']['output'];
  /** Runs where a disruption came up. */
  total: Scalars['Int']['output'];
};

/** Cards, SOP checks and totals hidden on the Track dashboard for everyone in the organization. */
export type TrackDashboardPreferences = {
  __typename?: 'TrackDashboardPreferences';
  hiddenCards?: Maybe<Array<Scalars['String']['output']>>;
  hiddenSopChecks?: Maybe<Array<Scalars['String']['output']>>;
  hiddenTotals?: Maybe<Array<Scalars['String']['output']>>;
};

export type TrackDashboardSummary = {
  __typename?: 'TrackDashboardSummary';
  automatedRuns: Scalars['Int']['output'];
  /** Automated runs in the period per tracking milestone type, most first. */
  automatedRunsByMilestone: Array<TrackDashboardCategoryCount>;
  /** Automated runs in the period per hour when it is one day, otherwise per day. */
  automatedRunsTrend: Array<TrackDashboardTrendBucket>;
  /** Trend bucket that contains now. */
  currentTrendBucket: Scalars['String']['output'];
  /** Counted over UTC days. */
  disruptions: TrackDashboardDisruptions;
  /** Disruptions saved per UTC week for the last 8 weeks, including this one. */
  disruptionsByWeek: Array<TrackDashboardWeeklyDisruptions>;
  /** Estimated hours of manual check calls the automated runs replaced. */
  estimatedHoursSaved: Scalars['Float']['output'];
  /** Track exceptions created in the period per load exception type, most first. */
  exceptionsByType: Array<TrackDashboardCategoryCount>;
  /** Automated runs in the same number of days before the period. */
  priorPeriodAutomatedRuns: Scalars['Int']['output'];
  /** Pass and fail counts per SOP checklist item over the UTC days of the period. Runs where a check was n/a are not counted. */
  sopCheckScores: Array<TrackDashboardCheckScore>;
  /** IANA timezone the period is measured in: the organization default, or America/Chicago when it has none. */
  timezone: Scalars['String']['output'];
  totals: TrackDashboardTotals;
  trendGranularity: TrackDashboardTrendGranularity;
};

export type TrackDashboardSummaryInput = {
  /** How many calendar days to summarize in the organization's timezone, ending today. 1 is today only. */
  days: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
};

export type TrackDashboardTotals = {
  __typename?: 'TrackDashboardTotals';
  calls: Scalars['Int']['output'];
  /** When the analytics pipeline last computed these counts. Counts cover loads picking up in the period. */
  computedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  emails: Scalars['Int']['output'];
  escalations: Scalars['Int']['output'];
  missingInfo: Scalars['Int']['output'];
  shipperUpdates: Scalars['Int']['output'];
  sms: Scalars['Int']['output'];
  sopRuns: Scalars['Int']['output'];
  statusChanges: Scalars['Int']['output'];
  timeUpdates: Scalars['Int']['output'];
  tmsComments: Scalars['Int']['output'];
};

export type TrackDashboardTrendBucket = {
  __typename?: 'TrackDashboardTrendBucket';
  /** Local start of the bucket in the organization's timezone: YYYY-MM-DDTHH:00 for hours, YYYY-MM-DD for days. */
  bucket: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export enum TrackDashboardTrendGranularity {
  DAY = 'DAY',
  HOUR = 'HOUR'
}

export type TrackDashboardWeeklyDisruptions = {
  __typename?: 'TrackDashboardWeeklyDisruptions';
  saved: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Monday that starts the UTC week, YYYY-MM-DD. */
  weekStart: Scalars['String']['output'];
};

export type TrackInput = {
  context: AnalyticsContext;
  event: Scalars['String']['input'];
  properties?: InputMaybe<TrackProperties>;
};

export type TrackProperties = {
  actionDefinitionId?: InputMaybe<Scalars['String']['input']>;
  autoReplySettings?: InputMaybe<Scalars['JSON']['input']>;
  carrierRateId?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Float']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  feedbackProperties?: InputMaybe<Scalars['JSON']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  originatorName?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  pricingStrategyId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Product>>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['JSON']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  targetUserId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Settings for tracking functionality. */
export type TrackSettings = AbstractEntity & Node & {
  __typename?: 'TrackSettings';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  enRouteSettings: EnRouteSettings;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nightHoursSettings?: Maybe<NightHoursSettings>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  stopSettings: StopSettings;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TrackShipmentInsightCounts = {
  __typename?: 'TrackShipmentInsightCounts';
  pastPickupLoads: Scalars['Int']['output'];
  readyForDispatch: Scalars['Int']['output'];
  withCarrierConversation: Scalars['Int']['output'];
  withDriverPhone: Scalars['Int']['output'];
};

export enum TrackStepKind {
  CALL_DISPATCHER = 'CALL_DISPATCHER',
  CALL_DRIVER = 'CALL_DRIVER',
  CHECK = 'CHECK',
  EMAIL_DISPATCH = 'EMAIL_DISPATCH',
  ESCALATION = 'ESCALATION',
  TEXT_DRIVER = 'TEXT_DRIVER',
  UPDATE_TMS = 'UPDATE_TMS'
}

/** On-time state derived from a TMS tracking alert status code */
export enum TrackingAlertState {
  DELAYED = 'DELAYED',
  ON_TIME = 'ON_TIME',
  UNKNOWN = 'UNKNOWN'
}

export type TrackingDataNotAvailableExceptionSettings = {
  __typename?: 'TrackingDataNotAvailableExceptionSettings';
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: Maybe<Scalars['Float']['output']>;
};

export type TrackingDataNotAvailableExceptionSettingsInput = {
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackingDataStaleExceptionSettings = {
  __typename?: 'TrackingDataStaleExceptionSettings';
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: Maybe<Scalars['Float']['output']>;
  /** Minutes since last tracking update before triggering TRACKING_DATA_STALE exception */
  thresholdMinutes: Scalars['Float']['output'];
};

export type TrackingDataStaleExceptionSettingsInput = {
  /** Whether this exception type is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Minutes to suppress duplicate exception events of this type */
  suppressionPeriodMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes since last tracking update before triggering TRACKING_DATA_STALE exception */
  thresholdMinutes: Scalars['Float']['input'];
};

export type TrackingEventWithActionExecution = {
  __typename?: 'TrackingEventWithActionExecution';
  actionExecutions: Array<ActionExecution>;
  event: MovementEvent;
};

export type TrackingMilestone = {
  __typename?: 'TrackingMilestone';
  stopNumber?: Maybe<Scalars['String']['output']>;
  type: TrackingMilestoneType;
};

export type TrackingMilestoneAlertStatus = {
  __typename?: 'TrackingMilestoneAlertStatus';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTimeISO']['output'];
  state: TrackingAlertState;
};

export type TrackingMilestoneData = {
  __typename?: 'TrackingMilestoneData';
  arrivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  closeToPickupMiles?: Maybe<Scalars['Float']['output']>;
  contactMethod?: Maybe<TrackingOutreachChannel>;
  currentExceptions?: Maybe<Array<LoadExceptionType>>;
  departedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  etaToLastDelivery?: Maybe<Scalars['DateTimeISO']['output']>;
  etaToNextStop?: Maybe<Scalars['DateTimeISO']['output']>;
  eventType: MovementEventType;
  infoToExchange?: Maybe<Scalars['String']['output']>;
  isLastPickupPast?: Maybe<Scalars['Boolean']['output']>;
  isRoundTrip?: Maybe<Scalars['Boolean']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  lastTrackingUpdate?: Maybe<Scalars['DateTimeISO']['output']>;
  location?: Maybe<TrackingMilestoneLocation>;
  milesFromFirstPickup?: Maybe<Scalars['Float']['output']>;
  milesToLastDelivery?: Maybe<Scalars['Float']['output']>;
  milesToNextStop?: Maybe<Scalars['Float']['output']>;
  milestone: TrackingMilestone;
  minutesAtCurrentLocation?: Maybe<Scalars['Float']['output']>;
  minutesSinceLastTrackingUpdate?: Maybe<Scalars['Float']['output']>;
  minutesUntilLastDeliveryStart?: Maybe<Scalars['Float']['output']>;
  nextCheckInMinutes?: Maybe<Scalars['Float']['output']>;
  nextStop?: Maybe<TrackingMilestoneNextStop>;
  onTime?: Maybe<Scalars['Boolean']['output']>;
  trackingAlertStatus?: Maybe<TrackingMilestoneAlertStatus>;
  trackingDataAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type TrackingMilestoneLocation = {
  __typename?: 'TrackingMilestoneLocation';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type TrackingMilestoneNextStop = {
  __typename?: 'TrackingMilestoneNextStop';
  city?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum TrackingMilestoneSkipReason {
  INVALID_STOP_TIMES = 'INVALID_STOP_TIMES'
}

export type TrackingMilestoneSkippedData = {
  __typename?: 'TrackingMilestoneSkippedData';
  eventType: MovementEventType;
  milestone: TrackingMilestone;
  reason: TrackingMilestoneSkipReason;
};

export enum TrackingMilestoneType {
  AD_HOC = 'AD_HOC',
  ARRIVED_AT_PICKUP_ACTUAL = 'ARRIVED_AT_PICKUP_ACTUAL',
  DEPARTED_PICKUP_ACTUAL = 'DEPARTED_PICKUP_ACTUAL',
  INTERMEDIATE = 'INTERMEDIATE',
  INTERMEDIATE_WITHOUT_TRACKING = 'INTERMEDIATE_WITHOUT_TRACKING',
  INTERMEDIATE_WITH_TRACKING = 'INTERMEDIATE_WITH_TRACKING',
  ON_DELIVERY = 'ON_DELIVERY',
  ON_PICKUP = 'ON_PICKUP',
  ON_STOPS = 'ON_STOPS',
  POST_DELIVERY = 'POST_DELIVERY',
  POST_PICKUP = 'POST_PICKUP',
  POST_STOPS = 'POST_STOPS',
  PRE_DELIVERY = 'PRE_DELIVERY',
  PRE_DISPATCH = 'PRE_DISPATCH',
  PRE_PICKUP = 'PRE_PICKUP',
  PRE_STOPS = 'PRE_STOPS'
}

export enum TrackingOutreachChannel {
  CALL_DISPATCHER = 'CALL_DISPATCHER',
  CALL_DRIVER = 'CALL_DRIVER',
  EMAIL_DISPATCH = 'EMAIL_DISPATCH',
  SMS_DRIVER = 'SMS_DRIVER'
}

/** Whether en-route tracking evaluation was paused or resumed */
export enum TrackingPauseChange {
  PAUSED = 'PAUSED',
  RESUMED = 'RESUMED'
}

/** What caused a TRACKING_PAUSED event */
export enum TrackingPauseSource {
  EXTENSION = 'EXTENSION',
  MACROPOINT = 'MACROPOINT',
  MANUAL = 'MANUAL'
}

export type TrackingPausedData = {
  __typename?: 'TrackingPausedData';
  change: TrackingPauseChange;
  eventType: MovementEventType;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TrackingPauseSource>;
};

/** Defines conditions for creating TRACKING_MILESTONE events during en-route tracking */
export enum TrackingTrigger {
  IN_TRANSIT_AND_WINDOW_MET = 'IN_TRANSIT_AND_WINDOW_MET',
  IN_TRANSIT_ONLY = 'IN_TRANSIT_ONLY',
  WINDOW_MET_ONLY = 'WINDOW_MET_ONLY'
}

export type TransformationConfig = AbstractEntity & Node & {
  __typename?: 'TransformationConfig';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  genericTransformations: Array<GenericTransformation>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  originator?: Maybe<Originator>;
  params: Scalars['JSON']['output'];
  transformationDefinition: TransformationDefinition;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  workflows: Array<WorkflowTransformation>;
};

export type TransformationConfigConnection = {
  __typename?: 'TransformationConfigConnection';
  count: Scalars['Int']['output'];
  edges: Array<TransformationConfigEdge>;
  nodes?: Maybe<Array<TransformationConfig>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TransformationConfigEdge = {
  __typename?: 'TransformationConfigEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: TransformationConfig;
};

export type TransformationConfigsInput = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TransformationDefinition = AbstractEntity & Node & {
  __typename?: 'TransformationDefinition';
  createdAt: Scalars['DateTimeISO']['output'];
  definition: Scalars['JSON']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  excludeFromWorkflowEditor: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  originator?: Maybe<Originator>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type TransformationDefinitionConnection = {
  __typename?: 'TransformationDefinitionConnection';
  count: Scalars['Int']['output'];
  edges: Array<TransformationDefinitionEdge>;
  nodes?: Maybe<Array<TransformationDefinition>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TransformationDefinitionEdge = {
  __typename?: 'TransformationDefinitionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: TransformationDefinition;
};

export type TransformationDefinitionsInput = {
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  originatorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TriggerActionExecutionInput = {
  actionDefinitionId: Scalars['ID']['input'];
  associatedEntities?: InputMaybe<AssociatedEntitiesInput>;
  data: Scalars['JSON']['input'];
};

export type TriggerActionExecutionPayload = {
  __typename?: 'TriggerActionExecutionPayload';
  actionExecutionId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type TriggerConversationAnalysisInput = {
  conversationIds: Array<Scalars['ID']['input']>;
};

export type TriggerConversationAnalysisPayload = {
  __typename?: 'TriggerConversationAnalysisPayload';
  failedConversationIds: Array<Scalars['ID']['output']>;
  succeededConversationIds: Array<Scalars['ID']['output']>;
};

export type TriggerExternalDataIngestInput = {
  dataType: IngestableExternalDataType;
  integrationType: IntegrationType;
  organizationId: Scalars['ID']['input'];
};

export type TriggerExternalDataIngestPayload = {
  __typename?: 'TriggerExternalDataIngestPayload';
  success: Scalars['Boolean']['output'];
};

export type TriggerLocationImportInput = {
  organizationId: Scalars['String']['input'];
};

export type TriggerPlaceImportInput = {
  format: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  s3Key: Scalars['String']['input'];
};

export type TriggerPlaceImportPayload = {
  __typename?: 'TriggerPlaceImportPayload';
  success: Scalars['Boolean']['output'];
};

export type TriggerPlaceIngestInput = {
  organizationId: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriggerPlaceIngestPayload = {
  __typename?: 'TriggerPlaceIngestPayload';
  success: Scalars['Boolean']['output'];
};

export type TriggerPortalAppointmentSchedulingInput = {
  details?: InputMaybe<Scalars['JSON']['input']>;
  dt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  movementStopId: Scalars['ID']['input'];
  shipmentId: Scalars['ID']['input'];
  stopsIndexToSchedule: Scalars['Float']['input'];
};

export type TriggerPortalAppointmentSchedulingPayload = {
  __typename?: 'TriggerPortalAppointmentSchedulingPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TriggerQuoteAgentForJobInput = {
  id: Scalars['ID']['input'];
};

export type TriggerQuoteAgentForJobPayload = {
  __typename?: 'TriggerQuoteAgentForJobPayload';
  actionExecutionId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TriggerSopAppointmentSchedulingInput = {
  form: SopAppointmentSchedulingForm;
  movementStopId: Scalars['ID']['input'];
  placesToUpdate: Array<UpdatedPlace>;
  shipmentId: Scalars['ID']['input'];
  stopsIndex: Scalars['Float']['input'];
};

export type TriggerSopAppointmentSchedulingPayload = {
  __typename?: 'TriggerSOPAppointmentSchedulingPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TriggerShipmentCsvImportInput = {
  importType: ShipmentCsvImportType;
  integrationType?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  s3Key: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type TriggerShipmentCsvImportPayload = {
  __typename?: 'TriggerShipmentCSVImportPayload';
  success: Scalars['Boolean']['output'];
};

export type TriggerShipmentIngestionInput = {
  aljexParams?: InputMaybe<AljexIngestionParamsInput>;
  integrationType?: InputMaybe<ThirdPartyTmsIntegrationTypes>;
  maxRows?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerShipmentIngestionPayload = {
  __typename?: 'TriggerShipmentIngestionPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TriggerSopsForExternalMessageInput = {
  externalMessageId: Scalars['ID']['input'];
};

export type TriggerSopsForExternalMessagePayload = {
  __typename?: 'TriggerSopsForExternalMessagePayload';
  success: Scalars['Boolean']['output'];
};

export type TriggerTrackingProcedureInput = {
  shipmentId: Scalars['String']['input'];
};

export type TriggerTrackingProcedurePayload = {
  __typename?: 'TriggerTrackingProcedurePayload';
  success: Scalars['Boolean']['output'];
};

export type UnknownConversationEventData = {
  __typename?: 'UnknownConversationEventData';
  eventDataType: ConversationEventType;
};

export type UnknownData = {
  __typename?: 'UnknownData';
  eventDataType: ActionExecutionEventType;
};

export type UnpostFromLoadBoardInput = {
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
};

export type UnpostFromLoadBoardPayload = {
  __typename?: 'UnpostFromLoadBoardPayload';
  success: Scalars['Boolean']['output'];
};

export type UnpostedFromLoadBoardData = {
  __typename?: 'UnpostedFromLoadBoardData';
  eventType: MovementEventType;
  posting?: Maybe<LoadBoardPosting>;
};

export type UpdateActionBehaviorInput = {
  id: Scalars['ID']['input'];
  lastEvaluated?: InputMaybe<Scalars['DateTimeISO']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateActionDefinitionInput = {
  canonicalTools?: InputMaybe<Array<Scalars['JSON']['input']>>;
  classifyConversationMessages?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAutonomyState?: InputMaybe<AutonomyState>;
  deterministicToolInvocations?: InputMaybe<DeterministicToolInvocationsInput>;
  globalPromptId?: InputMaybe<Scalars['ID']['input']>;
  globalPromptToolValues?: InputMaybe<Scalars['JSON']['input']>;
  globalPromptValues?: InputMaybe<Scalars['JSON']['input']>;
  hasMemory?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  knowledgeBaseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode?: InputMaybe<ActionDefinitionMode>;
  modelOverride?: InputMaybe<LlmName>;
  name?: InputMaybe<Scalars['String']['input']>;
  postCompletionMessageBehavior?: InputMaybe<PostCompletionMessageBehavior>;
  procedure?: InputMaybe<Scalars['JSON']['input']>;
  reasoningEffort?: InputMaybe<ReasoningEffort>;
  respondsToCoworkers?: InputMaybe<Scalars['Boolean']['input']>;
  runDetached?: InputMaybe<Scalars['Boolean']['input']>;
  /** Overrides experimental service routing. Null inherits from the global prompt or uses the normal service. */
  runsOnExperimentalService?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workersConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateActionDefinitionPayload = {
  __typename?: 'UpdateActionDefinitionPayload';
  actionDefinition: ActionDefinition;
};

export type UpdateActionTriggerInput = {
  config: Scalars['JSON']['input'];
  defaultAutonomyState?: InputMaybe<AutonomyState>;
  id: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateActionTriggerPayload = {
  __typename?: 'UpdateActionTriggerPayload';
  actionTrigger: ActionTrigger;
};

export type UpdateBlankRichTextDocumentUploadMetadataInput = {
  id: Scalars['ID']['input'];
  metadata: Scalars['JSON']['input'];
  organizationId: Scalars['ID']['input'];
  type: EntityDocumentUploadType;
};

export type UpdateCarrierRateInput = {
  computedRate?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  loadData?: InputMaybe<Scalars['JSON']['input']>;
  ratingMethod?: InputMaybe<RatingMethod>;
};

export type UpdateCarrierRatePayload = {
  __typename?: 'UpdateCarrierRatePayload';
  carrierRate: CarrierRate;
  success: Scalars['Boolean']['output'];
};

export type UpdateContactInput = {
  carrierId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactPayload = {
  __typename?: 'UpdateContactPayload';
  contact: Contact;
  success: Scalars['Boolean']['output'];
};

export type UpdateConversationLabelsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type UpdateConversationLabelsPayload = {
  __typename?: 'UpdateConversationLabelsPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateCoverAutomaticCoverageSettingsInput = {
  organizationId: Scalars['ID']['input'];
  settings: Scalars['JSON']['input'];
};

export type UpdateCoveragePlanInput = {
  carriers: Array<CreateCoveragePlanCarrierInput>;
  coveragePlanId: Scalars['ID']['input'];
};

export type UpdateCustomerRateInput = {
  id: Scalars['ID']['input'];
  loadData?: InputMaybe<Scalars['JSON']['input']>;
  rate?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<CustomerRateType>;
};

export type UpdateCustomerRatePayload = {
  __typename?: 'UpdateCustomerRatePayload';
  customerRate: CustomerRate;
  success: Scalars['Boolean']['output'];
};

export type UpdateErrorGroupInput = {
  githubPrUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  linearTicketId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ErrorGroupStatus>;
  suppressionThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExternalChannelInput = {
  channelType?: InputMaybe<ExternalChannelType>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateExternalChannelPayload = {
  __typename?: 'UpdateExternalChannelPayload';
  externalChannel: ExternalChannel;
  success: Scalars['Boolean']['output'];
};

export type UpdateExternalIdMappingInput = {
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  integrationType: Scalars['String']['input'];
  movementId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  shipmentId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExternalMessageInput = {
  classifications?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<ClassificationStatus>;
  threadLength?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateExternalMessagePayload = {
  __typename?: 'UpdateExternalMessagePayload';
  externalMessage: ExternalMessage;
  success: Scalars['Boolean']['output'];
};

export type UpdateFeatureFlagInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizations?: InputMaybe<Scalars['JSON']['input']>;
  originators?: InputMaybe<Scalars['JSON']['input']>;
  teams?: InputMaybe<Scalars['JSON']['input']>;
  users?: InputMaybe<Scalars['JSON']['input']>;
};

/** File upload metadata. */
export type UpdateFileContentInput = {
  id: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  subjectType: UploadableEntity;
};

/** Return type for the uploadFile mutation */
export type UpdateFileContentPayload = {
  __typename?: 'UpdateFileContentPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateFreightDataMappingInput = {
  id: Scalars['ID']['input'];
  values: Scalars['JSON']['input'];
};

export type UpdateFreightDataMappingPayload = {
  __typename?: 'UpdateFreightDataMappingPayload';
  freightDataMapping: FreightDataMapping;
  success: Scalars['Boolean']['output'];
};

export type UpdateGenericRuleInput = {
  id: Scalars['ID']['input'];
  transformationConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<GenericRuleType>;
};

export type UpdateGenericRulePayload = {
  __typename?: 'UpdateGenericRulePayload';
  genericRule?: Maybe<GenericRule>;
  success: Scalars['Boolean']['output'];
};

export type UpdateGenericTransformationInput = {
  genericRuleId: Scalars['ID']['input'];
  genericTransformationId: Scalars['ID']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  transformationDef?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateGenericTransformationTemplateInput = {
  definition?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlobalPromptInput = {
  /** When set, the update is rejected unless this is still the latest version id. */
  expectedLatestVersionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  prompt: Scalars['String']['input'];
  provisioningResourceId?: InputMaybe<Scalars['ID']['input']>;
  /** Routes inheriting action definitions to the experimental service. Null uses the normal service. */
  runsOnExperimentalService?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  emailMetadata?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateJobPayload = {
  __typename?: 'UpdateJobPayload';
  errors?: Maybe<Array<JobUpdateFailureReason>>;
  job: Job;
  success: Scalars['Boolean']['output'];
};

export type UpdateLabeledComputationInput = {
  id: Scalars['String']['input'];
  labeledComputationData: LabeledComputationDataInput;
};

export type UpdateLanePreferenceInput = {
  carrierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManagedResourceInput = {
  fallbackResourceId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<ManagedResourceProvider>;
  status?: InputMaybe<ManagedResourceStatus>;
  type?: InputMaybe<ManagedResourceType>;
};

export type UpdateMemberInput = {
  organizationUserRelationId: Scalars['ID']['input'];
  role?: InputMaybe<OrganizationUserRole>;
  user?: InputMaybe<UpdateMemberUserDetails>;
};

export type UpdateMemberPayload = {
  __typename?: 'UpdateMemberPayload';
  member: OrganizationUserRelation;
  success: Scalars['Boolean']['output'];
};

export type UpdateMemberProfileInput = {
  dtmfPin?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  type?: InputMaybe<UserProfileType>;
};

export type UpdateMemberUserDetails = {
  excludeFromReporting?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<UpdateMemberProfileInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemoryEntityLinkInput = {
  actionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  carrierId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  contactMethodId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  movementId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['ID']['input']>;
  quoteId?: InputMaybe<Scalars['ID']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMemoryEntityLinkPayload = {
  __typename?: 'UpdateMemoryEntityLinkPayload';
  success: Scalars['Boolean']['output'];
};

export enum UpdateMemoryFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type UpdateMemoryInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  labeledComputationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMemoryPayload = {
  __typename?: 'UpdateMemoryPayload';
  errors?: Maybe<Array<UpdateMemoryFailureReason>>;
  memory?: Maybe<Memory>;
  success: Scalars['Boolean']['output'];
};

export type UpdateMovementInput = {
  id: Scalars['ID']['input'];
  negotiationStrategyConfigOverride?: InputMaybe<NegotiationStrategyOverrideInput>;
  pricing?: InputMaybe<MovementPricingInput>;
  trackData?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateMovementPayload = {
  __typename?: 'UpdateMovementPayload';
  movement: Movement;
  success: Scalars['Boolean']['output'];
};

export type UpdateNegotiationStrategyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  type?: InputMaybe<NegotiationStrategyType>;
};

export type UpdateNotificationSettingsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  settings: Scalars['JSON']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNotificationSettingsPayload = {
  __typename?: 'UpdateNotificationSettingsPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateOrderInput = {
  externalOrderId?: InputMaybe<Scalars['String']['input']>;
  extractedData?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  transmitId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderPayload = {
  __typename?: 'UpdateOrderPayload';
  errors?: Maybe<Array<OrderUpdateFailureReason>>;
  order: Order;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationInput = {
  emailAuthPolicy?: InputMaybe<EmailAuthPolicyInput>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedWeeklyOrderCount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  integrationConfigs?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Product>>;
  settings?: InputMaybe<OrganizationSettingsInput>;
};

export type UpdateOrganizationIntegrationConfigsInput = {
  id: Scalars['ID']['input'];
  integrationConfigs: Scalars['JSON']['input'];
};

export type UpdateOrganizationIntegrationConfigsPayload = {
  __typename?: 'UpdateOrganizationIntegrationConfigsPayload';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  organization: Organization;
  success: Scalars['Boolean']['output'];
};

export type UpdateOriginatorInput = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  autoSubmitScope?: InputMaybe<AutoSubmitScope>;
  configOverrides?: InputMaybe<Scalars['JSON']['input']>;
  expectedWeeklyOrderCount?: InputMaybe<Scalars['Float']['input']>;
  externalIdMappings?: InputMaybe<Array<UpdateExternalIdMappingInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  quoteAutoReplyScope?: InputMaybe<QuoteAutoReplyScope>;
  scheduleSettingsId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<OriginatorStatus>;
  trackSettingsId?: InputMaybe<Scalars['ID']['input']>;
  transmitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  voomaSupportNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOriginatorPayload = {
  __typename?: 'UpdateOriginatorPayload';
  originator: Originator;
  success: Scalars['Boolean']['output'];
};

export type UpdateOtherIntegrationCredentialsInput = {
  /** Replacement values; configKeys omitted here retain their stored values */
  config: Scalars['JSON']['input'];
  /** Complete set of config keys to retain; omitted keys are removed */
  configKeys: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateOtherIntegrationCredentialsPayload = {
  __typename?: 'UpdateOtherIntegrationCredentialsPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdatePlaceInput = {
  address?: InputMaybe<PlaceAddressInput>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  locationCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<NotesFieldsInput>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<PlaceTag>>;
};

export type UpdatePlacePayload = {
  __typename?: 'UpdatePlacePayload';
  place: Place;
  success: Scalars['Boolean']['output'];
};

export type UpdatePlaceScheduleMethodInput = {
  id: Scalars['ID']['input'];
  method: ScheduleMethod;
};

export type UpdatePlaceScheduleMethodPayload = {
  __typename?: 'UpdatePlaceScheduleMethodPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdatePlaceSchedulingMethodInput = {
  method: Scalars['JSON']['input'];
  methodId: Scalars['ID']['input'];
  placeId: Scalars['ID']['input'];
};

export type UpdatePricingStrategyInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<PricingStrategyType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateQuoteInput = {
  carrierRateId?: InputMaybe<Scalars['ID']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  customFreightTags?: InputMaybe<Array<Scalars['String']['input']>>;
  customerRateId?: InputMaybe<Scalars['ID']['input']>;
  extractedData?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateQuotePayload = {
  __typename?: 'UpdateQuotePayload';
  quote: Quote;
  success: Scalars['Boolean']['output'];
};

export type UpdateScheduleSettingsInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  plannerActionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  planningSettings: PlanningSettingsInput;
};

export type UpdateSharedFileInput = {
  content: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  sharedFileId: Scalars['ID']['input'];
};

export type UpdateSharedFilePayload = {
  __typename?: 'UpdateSharedFilePayload';
  message: Scalars['String']['output'];
  sharedFile: SharedFileSummary;
  success: Scalars['Boolean']['output'];
};

export type UpdateSimulationBrokerOrganizationInput = {
  isSimulationBroker: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateSimulationSettingsInput = {
  carrierInquiryActionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  enabled: Scalars['Boolean']['input'];
  intervalMinutes: Scalars['Int']['input'];
  isSimulationBroker: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateTeamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['JSON']['input']>;
  roles?: InputMaybe<Array<TeamRole>>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateTeamMemberInput = {
  id: Scalars['ID']['input'];
  role: TeamMemberRole;
};

export type UpdateTemplateInput = {
  id: Scalars['ID']['input'];
  modelConfig?: InputMaybe<ModelConfigInput>;
  multiOrderPrompt?: InputMaybe<Scalars['String']['input']>;
  orderBuildPrompt?: InputMaybe<Scalars['String']['input']>;
  specializedTemplate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TemplateType>;
};

export type UpdateTemplatePayload = {
  __typename?: 'UpdateTemplatePayload';
  success: Scalars['Boolean']['output'];
  template: Template;
};

export type UpdateTemplateUsingOrderInput = {
  id: Scalars['String']['input'];
};

export type UpdateTemplateUsingOrderPayload = {
  __typename?: 'UpdateTemplateUsingOrderPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateTrackDashboardPreferencesInput = {
  hiddenCards: Array<Scalars['String']['input']>;
  hiddenSopChecks: Array<Scalars['String']['input']>;
  hiddenTotals: Array<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type UpdateTrackSettingsInput = {
  enRouteSettings?: InputMaybe<EnRouteSettingsInput>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nightHoursSettings?: InputMaybe<NightHoursSettingsInput>;
  stopSettings?: InputMaybe<StopSettingsInput>;
};

export enum UpdateTransformationConfigFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type UpdateTransformationConfigInput = {
  id: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  transformationDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTransformationConfigPayload = {
  __typename?: 'UpdateTransformationConfigPayload';
  errors?: Maybe<Array<UpdateTransformationConfigFailureReason>>;
  success: Scalars['Boolean']['output'];
  transformationConfig?: Maybe<TransformationConfig>;
};

export enum UpdateTransformationDefinitionFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type UpdateTransformationDefinitionInput = {
  definition?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
  transformationDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTransformationDefinitionPayload = {
  __typename?: 'UpdateTransformationDefinitionPayload';
  errors?: Maybe<Array<UpdateTransformationDefinitionFailureReason>>;
  success: Scalars['Boolean']['output'];
  transformationDefinition?: Maybe<TransformationDefinition>;
};

export type UpdateUserFeaturesInput = {
  features?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserInput = {
  excludeFromReporting?: InputMaybe<Scalars['Boolean']['input']>;
  features?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UserRole>>;
  settings?: InputMaybe<UserSettingsInput>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  success: Scalars['Boolean']['output'];
  user: User;
};

export type UpdateUserProfileInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserSettingsInput = {
  id: Scalars['ID']['input'];
  settings?: InputMaybe<UserSettingsInput>;
};

export type UpdateWebhookSubscriptionInput = {
  authConfig: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  subscriptionType: WebhookSubscriptionType;
  url: Scalars['String']['input'];
};

export type UpdateWebhookSubscriptionPayload = {
  __typename?: 'UpdateWebhookSubscriptionPayload';
  item: WebhookSubscription;
};

export type UpdateWorkerProfileInput = {
  backStory?: InputMaybe<Scalars['String']['input']>;
  humanisedDelay?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  languages?: InputMaybe<Array<SupportedLanguage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  voiceId?: InputMaybe<Scalars['String']['input']>;
  voiceModel?: InputMaybe<SupportedVoiceModel>;
  voiceSpeed?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateWorkerProfilePayload = {
  __typename?: 'UpdateWorkerProfilePayload';
  worker: User;
};

export enum UpdateWorkflowFailureReason {
  UNKNOWN = 'UNKNOWN'
}

export type UpdateWorkflowInput = {
  id: Scalars['ID']['input'];
  originatorId?: InputMaybe<Scalars['String']['input']>;
  transformationConfigIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  trigger?: InputMaybe<FlowTriggerInput>;
};

export type UpdateWorkflowPayload = {
  __typename?: 'UpdateWorkflowPayload';
  errors?: Maybe<Array<UpdateWorkflowFailureReason>>;
  success: Scalars['Boolean']['output'];
  workflow?: Maybe<Workflow>;
};

export type UpdatedPlace = {
  emailsUnparsed: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdatedPostingOnLoadBoardData = {
  __typename?: 'UpdatedPostingOnLoadBoardData';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  eventType: MovementEventType;
  posting?: Maybe<LoadBoardPosting>;
  postingUserId?: Maybe<Scalars['String']['output']>;
};

/** File upload metadata. */
export type UploadFileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType: UploadableEntity;
};

/** Return type for the uploadFile mutation */
export type UploadFilePayload = {
  __typename?: 'UploadFilePayload';
  subject?: Maybe<AbstractEntity>;
  success: Scalars['Boolean']['output'];
  upload?: Maybe<FileUpload>;
  url: Scalars['String']['output'];
};

export enum UploadableEntity {
  ACTION_DEFINITION_DOCUMENT = 'ACTION_DEFINITION_DOCUMENT',
  EXTERNAL_MESSAGE_DOCUMENT_UPLOAD = 'EXTERNAL_MESSAGE_DOCUMENT_UPLOAD',
  JOB_DOCUMENT_UPLOAD_ADD_TO_EXISTING_JOB = 'JOB_DOCUMENT_UPLOAD_ADD_TO_EXISTING_JOB',
  JOB_DOCUMENT_UPLOAD_PRIOR_TO_JOB_CREATION = 'JOB_DOCUMENT_UPLOAD_PRIOR_TO_JOB_CREATION',
  KNOWLEDGE_BASE_DOCUMENT = 'KNOWLEDGE_BASE_DOCUMENT',
  LOCATION_IMPORT = 'LOCATION_IMPORT',
  ORGANIZATION_DOCUMENT_UPLOAD = 'ORGANIZATION_DOCUMENT_UPLOAD',
  PROFILE_PHOTO_UPLOAD = 'PROFILE_PHOTO_UPLOAD',
  SHIPMENT_CSV_IMPORT = 'SHIPMENT_CSV_IMPORT',
  USER_DOCUMENT_UPLOAD = 'USER_DOCUMENT_UPLOAD'
}

export type UpsertActionDefinitionTeamGlobalPromptValuesInput = {
  actionDefinitionId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  toolValues?: InputMaybe<Scalars['JSON']['input']>;
  values?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpsertActionDefinitionTeamGlobalPromptValuesPayload = {
  __typename?: 'UpsertActionDefinitionTeamGlobalPromptValuesPayload';
  teamGlobalPromptValues: ActionDefinitionTeamGlobalPromptValues;
};

export type UpsertOrganizationJobInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  schedule: OrganizationJobSchedule;
  type: OrganizationJobType;
};

export type UpsertOrganizationJobPayload = {
  __typename?: 'UpsertOrganizationJobPayload';
  organizationJob: OrganizationJob;
};

export enum UsageBlockLevel {
  HARD = 'HARD',
  NONE = 'NONE',
  SOFT = 'SOFT'
}

export enum UsageBlockSource {
  MANUAL = 'MANUAL',
  METRONOME_ALERT = 'METRONOME_ALERT',
  SPEND_GUARD = 'SPEND_GUARD'
}

export type UsageBlockSummary = {
  __typename?: 'UsageBlockSummary';
  id: Scalars['ID']['output'];
  level: UsageBlockLevel;
  setByName?: Maybe<Scalars['String']['output']>;
  source: UsageBlockSource;
  startedAt: Scalars['DateTimeISO']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export enum UsageByUserKind {
  MEMBER = 'MEMBER',
  NO_USER = 'NO_USER',
  OTHER_ORGANIZATIONS = 'OTHER_ORGANIZATIONS'
}

export enum UsageCapScope {
  ALL_USERS = 'ALL_USERS',
  ORGANIZATION = 'ORGANIZATION',
  USER = 'USER'
}

export type UsageCapSummary = {
  __typename?: 'UsageCapSummary';
  amountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isSynced: Scalars['Boolean']['output'];
  lastSyncError?: Maybe<Scalars['String']['output']>;
  scope: UsageCapScope;
  setAt: Scalars['DateTimeISO']['output'];
  setByName?: Maybe<Scalars['String']['output']>;
  syncAttempts: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** The usage indicator for the integration. */
export enum UsageIndicator {
  PRODUCTION = 'PRODUCTION',
  TEST = 'TEST'
}

export type User = AbstractEntity & BasicUser & Node & {
  __typename?: 'User';
  actionDefinitions: Array<ActionDefinition>;
  auth0Auth?: Maybe<Auth0AuthenticationStrategy>;
  createdAt: Scalars['DateTimeISO']['output'];
  debug: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  /** This user's email if available. */
  email?: Maybe<Scalars['String']['output']>;
  emailIntegrations?: Maybe<Array<EmailIntegrationStatus>>;
  emailSubscriptions: Array<UserEmailSubscription>;
  excludeFromReporting: Scalars['Boolean']['output'];
  /** Serialized as JSON */
  features?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastSignedIn?: Maybe<Scalars['DateTimeISO']['output']>;
  organizations: Array<OrganizationUserRelation>;
  organizationsDetails: Array<Organization>;
  photo?: Maybe<UserProfilePhoto>;
  profile?: Maybe<UserProfile>;
  roles: Array<UserRole>;
  settings?: Maybe<UserSettings>;
  sharedInboxes: Array<SharedInbox>;
  subscribedActionDefinitions: Array<ActionDefinition>;
  subscribedActionExecutions: Array<ActionExecution>;
  subscribedConversations: Array<Conversation>;
  teams: Array<Team>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UserSharedInboxesArgs = {
  input: SharedInboxInput;
};

/** Connection type for users. */
export type UserConnection = {
  __typename?: 'UserConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserEdge>;
  nodes?: Maybe<Array<User>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDocumentUpload = AbstractEntity & FileUpload & Node & {
  __typename?: 'UserDocumentUpload';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  subject: User;
  subjectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserEmailSubscription = {
  __typename?: 'UserEmailSubscription';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  type: SubscriptionType;
};

export type UserProfile = AiProfile | HumanProfile;

export type UserProfilePhoto = AbstractEntity & FileUpload & Node & {
  __typename?: 'UserProfilePhoto';
  author: User;
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export enum UserProfileType {
  AI = 'AI',
  HUMAN = 'HUMAN'
}

export enum UserRole {
  ADMIN = 'ADMIN',
  AI_WORKER = 'AI_WORKER',
  CUSTOMER = 'CUSTOMER',
  OPERATIONS = 'OPERATIONS',
  SUPPORT = 'SUPPORT',
  SYSTEM = 'SYSTEM'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  autoReply?: Maybe<Scalars['JSON']['output']>;
  browserExtensionDomainAllowlist?: Maybe<Array<Scalars['String']['output']>>;
  emailTags?: Maybe<Scalars['JSON']['output']>;
  glossary?: Maybe<Scalars['JSON']['output']>;
  notifications?: Maybe<Scalars['JSON']['output']>;
  pluginLandingPage?: Maybe<PluginLandingPage>;
  quote?: Maybe<Scalars['JSON']['output']>;
  timeDisplayStyle?: Maybe<TimeDisplayStyle>;
  transfersRateLimit?: Maybe<Scalars['JSON']['output']>;
};

export type UserSettingsInput = {
  autoReply?: InputMaybe<Scalars['JSON']['input']>;
  browserExtensionDomainAllowlist?: InputMaybe<Array<Scalars['String']['input']>>;
  emailTags?: InputMaybe<Scalars['JSON']['input']>;
  glossary?: InputMaybe<Scalars['JSON']['input']>;
  notifications?: InputMaybe<Scalars['JSON']['input']>;
  pluginLandingPage?: InputMaybe<PluginLandingPage>;
  quote?: InputMaybe<Scalars['JSON']['input']>;
  timeDisplayStyle?: InputMaybe<TimeDisplayStyle>;
  transfersRateLimit?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserUsage = {
  __typename?: 'UserUsage';
  credits: Scalars['Float']['output'];
  /** @deprecated Usage is shown in credits */
  inputTokens: Scalars['Float']['output'];
  kind: UsageByUserKind;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Usage is shown in credits */
  outputTokens: Scalars['Float']['output'];
  /** @deprecated Usage is shown in credits */
  phoneSeconds: Scalars['Float']['output'];
  spendCents: Scalars['Float']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UsersInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type VDateTime = {
  __typename?: 'VDateTime';
  dateTime: Scalars['String']['output'];
  interpretationPolicy: DateTimeInterpretationPolicy;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type ValidatePricingStrategyInstructionsInput = {
  instructions: Scalars['String']['input'];
};

export type ValidateTextInstructionsInput = {
  text: Scalars['String']['input'];
  validationRules: Scalars['String']['input'];
};

export type ValidateTextInstructionsPayload = {
  __typename?: 'ValidateTextInstructionsPayload';
  individualHighlights: Array<TextValidationResult>;
  promptEvaluationOverview: Scalars['String']['output'];
};

/** Source of a parameter value */
export enum ValueSource {
  MATCHES_DEFAULT = 'MATCHES_DEFAULT',
  OVERRIDE = 'OVERRIDE',
  UNSET = 'UNSET'
}

export type VerifyCarrierIntegrationInput = {
  organizationId: Scalars['ID']['input'];
};

export type VerifyCarrierIntegrationPayload = {
  __typename?: 'VerifyCarrierIntegrationPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VerifyTmsIntegrationInput = {
  organizationId: Scalars['ID']['input'];
};

export type VerifyTmsIntegrationPayload = {
  __typename?: 'VerifyTMSIntegrationPayload';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** The API client registering tracking calls. */
export enum VoomaApiClient {
  CHROME = 'CHROME',
  FRONT = 'FRONT',
  OUTLOOK = 'OUTLOOK',
  SIDEKICK = 'SIDEKICK',
  VOOMA_AI = 'VOOMA_AI',
  WEB = 'WEB'
}

export type WatcherClosedData = {
  __typename?: 'WatcherClosedData';
  eventDataType: ConversationEventType;
};

export type WatcherDefinition = {
  __typename?: 'WatcherDefinition';
  functionName: Scalars['String']['output'];
  intervalMinutes: Scalars['Int']['output'];
  params?: Maybe<Scalars['JSON']['output']>;
};

export type WatcherPokedData = {
  __typename?: 'WatcherPokedData';
  eventDataType: ActionExecutionEventType;
};

export type WebhookReceivedData = {
  __typename?: 'WebhookReceivedData';
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  eventType: MovementEventType;
  tmsStatus?: Maybe<Scalars['String']['output']>;
};

export type WebhookSubscription = AbstractEntity & Node & {
  __typename?: 'WebhookSubscription';
  auth?: Maybe<Scalars['JSON']['output']>;
  authConfig: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
  subscriptionType: WebhookSubscriptionType;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  url: Scalars['String']['output'];
};

export type WebhookSubscriptionInput = {
  id: Scalars['ID']['input'];
};

export type WebhookSubscriptionPayload = {
  __typename?: 'WebhookSubscriptionPayload';
  item: WebhookSubscription;
};

export enum WebhookSubscriptionType {
  APPOINTMENT_STATUS = 'APPOINTMENT_STATUS',
  CARRIER_OFFER = 'CARRIER_OFFER',
  CARRIER_OUTREACH_BATCH_STATUS = 'CARRIER_OUTREACH_BATCH_STATUS',
  CARRIER_OUTREACH_STATUS = 'CARRIER_OUTREACH_STATUS',
  CUSTOMER_STATUS = 'CUSTOMER_STATUS',
  FREIGHT_ORDER_STATUS = 'FREIGHT_ORDER_STATUS',
  LOCATION_STATUS = 'LOCATION_STATUS',
  QUOTE_STATUS = 'QUOTE_STATUS',
  SHIPMENT_RELAY = 'SHIPMENT_RELAY',
  SHIPPER_UPDATED = 'SHIPPER_UPDATED',
  TRACKING_UPDATE = 'TRACKING_UPDATE'
}

export type WebhookSubscriptionsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type WebhookSubscriptionsPayload = {
  __typename?: 'WebhookSubscriptionsPayload';
  items: Array<WebhookSubscription>;
};

/** Which edge of a stop window (or appointment) an offset is measured from. */
export enum WindowAnchor {
  END = 'END',
  START = 'START'
}

export type WorkerComposioAccountsInput = {
  organizationId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

export type WorkerComposioAccountsPayload = {
  __typename?: 'WorkerComposioAccountsPayload';
  configured: Scalars['Boolean']['output'];
  connections: Array<WorkerComposioConnection>;
  toolKits: Array<ComposioToolKitInfo>;
};

export type WorkerComposioConnection = {
  __typename?: 'WorkerComposioConnection';
  accountLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  toolkitSlug: Scalars['String']['output'];
};

export type WorkerComposioConnectionInput = {
  connectionId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

export type WorkerHasAuthorizedServiceTypeInput = {
  type: AuthTokenType;
  workerId: Scalars['String']['input'];
};

export type WorkersConfig = LegacyAgentBackstoryConfig | MultipleWorkersConfig | NoWorkersConfig | SingleWorkerConfig;

export enum WorkersConfigType {
  LEGACY_AGENT_BACKSTORY = 'LEGACY_AGENT_BACKSTORY',
  MULTIPLE_WORKER_GROUP = 'MULTIPLE_WORKER_GROUP',
  NO_WORKERS = 'NO_WORKERS',
  SINGLE_WORKER_GROUP = 'SINGLE_WORKER_GROUP'
}

export type Workflow = AbstractEntity & Node & {
  __typename?: 'Workflow';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  originator?: Maybe<Originator>;
  transformations: Array<WorkflowTransformation>;
  trigger: FlowTrigger;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkflowEdge>;
  nodes?: Maybe<Array<Workflow>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkflowEdge = {
  __typename?: 'WorkflowEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String']['output'];
  node: Workflow;
};

export type WorkflowTransformation = AbstractEntity & Node & {
  __typename?: 'WorkflowTransformation';
  createdAt: Scalars['DateTimeISO']['output'];
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  seq: Scalars['Int']['output'];
  transformationConfig: TransformationConfig;
  transformationConfigId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  workflow: Workflow;
  workflowId: Scalars['String']['output'];
};

export type WorkflowsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOutlookReplyAllMutationVariables = Exact<{
  input: CreateOutlookReplyAllInput;
}>;


export type CreateOutlookReplyAllMutation = { __typename?: 'Mutation', createOutlookReplyAll: { __typename?: 'CreateOutlookReplyAllPayload', success: boolean, messageId?: string | null } };

export type GetOrdersQueryVariables = Exact<{
  input?: InputMaybe<OrdersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrdersQuery = { __typename?: 'Query', orders: { __typename?: 'OrderConnection', totalCount: number, count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'OrderEdge', node: { __typename?: 'Order', id: string, hasSubmittedEvent: boolean, primaryReference?: string | null, extractedData?: string | null, createdAt: any, createdAtDisplay?: any | null, externalDeepLink?: string | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', id: string, name: string } | null, job: { __typename?: 'Job', emailMetadata?: any | null }, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }> } }> } };

export type SendOutlookMessageMutationVariables = Exact<{
  input: SendOutlookMessageInput;
}>;


export type SendOutlookMessageMutation = { __typename?: 'Mutation', sendOutlookMessage: { __typename?: 'SendOutlookMessagePayload', success: boolean } };

export type GetQuoteResponseMessageQueryVariables = Exact<{
  input: GenerateQuoteResponseMessageInput;
}>;


export type GetQuoteResponseMessageQuery = { __typename?: 'Query', getQuoteResponseMessage: { __typename?: 'GenerateQuoteResponseMessagePayload', success: boolean, message?: string | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null };

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } };

export type GetMessageByInternetMessageIdQueryVariables = Exact<{
  input: ExternalMessageByInternetMessageIdInput;
}>;


export type GetMessageByInternetMessageIdQuery = { __typename?: 'Query', externalMessageByInternetMessageId: { __typename?: 'ExternalMessagePayload', externalMessage: { __typename?: 'ExternalMessage', classifications?: any | null } } };

export type PlaceFormDataQueryVariables = Exact<{
  placeId: Scalars['ID']['input'];
}>;


export type PlaceFormDataQuery = { __typename?: 'Query', placeById: { __typename?: 'Place', id: string, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null } };

export type PlaceFormFieldsFragment = { __typename?: 'Place', id: string, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null };

export type UpdatePlaceDetailsMutationVariables = Exact<{
  input: UpdatePlaceInput;
}>;


export type UpdatePlaceDetailsMutation = { __typename?: 'Mutation', updatePlace: { __typename?: 'UpdatePlacePayload', success: boolean, place: { __typename?: 'Place', id: string, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null } } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'UpdateUserPayload', success: boolean, user: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } } };

export type ActionDefinitionPreviewFragment = { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } };

export type ActionDefinitionHierarchyPreviewFragment = { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, childLinks: Array<{ __typename?: 'ActionDefinitionChildLink', relationshipType: ActionDefinitionRelationshipType, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, mode: ActionDefinitionMode, tags?: Array<string> | null, isEmbeddedInGraph: boolean, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } } }>, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } };

export type NaturalLanguageProcedurePreviewFragment = { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType };

export type DeterministicProcedurePreviewFragment = { __typename?: 'DeterministicProcedure', procedureType: ProcedureType };

export type GraphDefinedProcedurePreviewFragment = { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType };

export type ConversationGraphProcedurePreviewFragment = { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality };

export type ActionDefinitionFragment = { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> };

export type NaturalLanguageProcedureFragment = { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null };

export type DeterministicProcedureFragment = { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string };

export type GraphDefinedProcedureFragment = { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } };

export type ConversationGraphProcedureFragment = { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } };

export type NoWorkersConfigFragment = { __typename?: 'NoWorkersConfig', type: WorkersConfigType };

export type SubscribersFragment = { __typename?: 'User', id: string };

export type LegacyAgentBackstoryConfigFragment = { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null };

export type SingleWorkerConfigFragment = { __typename?: 'SingleWorkerConfig', type: WorkersConfigType };

export type MultipleWorkersConfigFragment = { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType };

export type ActionDefinitionDocumentUploadsFragment = { __typename?: 'ActionDefinition', documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> };

export type ActionExecutionNoChildrenFragment = { __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> };

export type ActionExecutionFragment = { __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, children: Array<{ __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> }>, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> };

export type TaskListItemFragment = { __typename?: 'ActionExecution', id: string, createdAt: any, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, tags?: Array<string> | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, deletedAt?: any | null } };

export type ActionExecutionEventFragment = { __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null };

export type EscalationDataFragment = { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null };

export type DecisionEdgeEvaluatedDataFragment = { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null };

export type ToolUsedDataFragment = { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null };

export type SupervisorToolUsedDataFragment = { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null };

export type MemoryRecalledDataFragment = { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> };

export type RawAgentMessageDataFragment = { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any };

export type RawSupervisorMessageDataFragment = { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any };

export type AgentReasoningDataFragment = { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string };

export type SupervisorReasoningDataFragment = { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string };

export type SpamGuardDataFragment = { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string };

export type ReminderDataFragment = { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string };

export type InstructionMessageDataFragment = { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null };

export type StatusChangedDataFragment = { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus };

export type AgentProposedOutputDataFragment = { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any };

export type SupervisorProposedOutputDataFragment = { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any };

export type ActionTriggerPreviewFragment = { __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null };

export type ActionTriggerFragment = { __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null };

export type NewClassifiedEmailThreadTriggerConfigFragment = { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type InboundPhoneCallTriggerConfigFragment = { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null };

export type MovementEventCreatedTriggerConfigFragment = { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type OrderEventCreatedTriggerConfigFragment = { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type QuoteEventCreatedTriggerConfigFragment = { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type ExceptionCreatedTriggerConfigFragment = { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type RepeatingTriggerConfigFragment = { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type ConversationEventCreatedTriggerConfigFragment = { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type MicrosoftTeamsMessageTriggerConfigFragment = { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type SlackMessageTriggerConfigFragment = { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type GoogleChatMessageTriggerConfigFragment = { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type PylonWebhookTriggerConfigFragment = { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null };

export type AdvancedTriggerParamsFieldsFragment = { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null };

export type CarrierFragment = { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean };

export type CarrierRateFragment = { __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null };

export type CarrierRatePreviewFragment = { __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod };

export type CarrierRateWithActionsFragment = { __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, actions: Array<{ __typename?: 'ActionExecution', output?: any | null }>, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null };

export type ContactFragment = { __typename?: 'Contact', id: string, name: string, email?: string | null, originator?: { __typename?: 'Originator', id: string, transmitIds: Array<string>, name: string, createdAt: any, status: OriginatorStatus, autoSubmitScope: AutoSubmitScope, expectedWeeklyOrderCount?: number | null, configOverrides?: any | null, flagged: boolean, hasExtractedDataConfigured: boolean, attributes?: any | null, organization: { __typename?: 'Organization', id: string, name: string, type?: OrganizationType | null }, knownSenders: Array<{ __typename?: 'Contact', id: string, email?: string | null }>, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null };

export type ConversationFragment = { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> };

export type PhoneConversationMetadataFragment = { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection };

export type EmailConversationMetadataFragment = { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null };

export type MicrosoftTeamsConversationMetadataFragment = { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> };

export type ChatConversationMetadataFragment = { __typename?: 'ChatConversationMetadata', context?: any | null };

export type SmsConversationMetadataFragment = { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string };

export type ConversationAnalysisFragment = { __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null };

export type ConversationEventFragment = { __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null };

export type CallFailedDataFragment = { __typename?: 'CallFailedData', eventDataType: ConversationEventType };

export type CallEndedDataFragment = { __typename?: 'CallEndedData', eventDataType: ConversationEventType };

export type ChatViewContextUpdatedDataFragment = { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any };

export type CallTransferredDataFragment = { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null };

export type CallTransferAcceptedDataFragment = { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string };

export type ConferenceJoinedDataFragment = { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string };

export type AsyncTransferDataFragment = { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null };

export type ReturnedToTransferredCallDataFragment = { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string };

export type CallRecordingReceivedDataFragment = { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any };

export type QuietLineIntentDataFragment = { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType };

export type CustomerRateFragment = { __typename?: 'CustomerRate', id: string, createdAt: any, loadData?: any | null, type: CustomerRateType, rate?: any | null, metadata?: any | null, quote: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } };

export type EnRouteTrackEventSettingsFieldsFragment = { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null };

export type ErrorGroupFragment = { __typename?: 'ErrorGroup', id: string, source: ErrorIncidentSource, title: string, status: ErrorGroupStatus, lastOccurrenceCount: number, firstSeenAt: any, lastSeenAt: any, suppressionThreshold?: number | null, linearTicketId?: string | null, githubPrUrl?: string | null, notes?: string | null, createdAt: any, updatedAt?: any | null, topOrganizations: Array<{ __typename?: 'ErrorGroupOrganizationCount', organizationId?: string | null, organizationName?: string | null, count: number }> };

export type ExceptionFragment = { __typename?: 'Exception', id: string, type: ExceptionType, status: ExceptionStatus, createdAt: any, updatedAt?: any | null, context?: any | null, actionExecution?: { __typename?: 'ActionExecution', id: string, conversationId?: string | null } | null, handler?: { __typename?: 'ActionExecution', id: string, conversationId?: string | null } | null };

export type ConversationExceptionFragment = { __typename?: 'Exception', id: string, createdAt: any, callTransferStatus: CallTransferStatus, conversation?: { __typename?: 'Conversation', associatedReferenceNumbers: Array<string>, id: string, type: ConversationType, contactIdentifier?: string | null, associatedCarriers: Array<{ __typename?: 'Carrier', name: string }>, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null, actionExecution?: { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null } | null, handler?: { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null } | null };

export type ExceptionConversationPreviewFragment = { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null };

export type ExceptionActionExecutionFragment = { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null };

export type HandlingActionExecutionFragment = { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null };

export type ExceptionBasicFragment = { __typename?: 'Exception', id: string, type: ExceptionType, status: ExceptionStatus, createdAt: any, updatedAt?: any | null, context?: any | null, actionExecution?: { __typename?: 'ActionExecution', id: string } | null, handler?: { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string } | null } | null };

export type ExternalChannelFragment = { __typename?: 'ExternalChannel', id: string, createdAt: any, organizationId: string, teamId?: string | null, userId?: string | null, channelType: ExternalChannelType, externalIdentifier: string };

export type ExternalMessageFragment = { __typename?: 'ExternalMessage', id: string, externalIdentifier: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, emailMetadata?: any | null, userId?: string | null, conversationId?: string | null, canonicalMessageId?: string | null, user?: { __typename?: 'User', id: string, username?: string | null, firstName?: string | null, lastName?: string | null, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile', name?: string | null } | null } | null, documents: Array<{ __typename?: 'ExternalMessageDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null }> };

export type GenericRuleFragment = { __typename?: 'GenericRule', id: string, createdAt: any, type: string, organization: { __typename?: 'Organization', id: string }, transformations: Array<{ __typename?: 'GenericTransformation', id: string, createdAt: any, seq: number, genericRuleId: string, transformationConfigId: string, genericRule: { __typename?: 'GenericRule', id: string, type: string }, transformationConfig: { __typename?: 'TransformationConfig', id: string, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } }> };

export type GenericTransformationFragment = { __typename?: 'GenericTransformation', id: string, createdAt: any, seq: number, genericRuleId: string, transformationConfigId: string, genericRule: { __typename?: 'GenericRule', id: string, type: string }, transformationConfig: { __typename?: 'TransformationConfig', id: string, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } };

export type GenericTransformationDetailsFragment = { __typename?: 'GenericTransformation', id: string, createdAt: any, seq: number, genericRuleId: string, transformationConfigId: string, templateId?: string | null, templateVersion?: number | null, genericRule: { __typename?: 'GenericRule', id: string, type: string, organization: { __typename?: 'Organization', id: string } }, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } };

export type JobFragment = { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> };

export type JobDocumentsFragment = { __typename?: 'Job', documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> };

export type JobEventFragment = { __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType };

export type JobSummaryFragment = { __typename?: 'Job', id: string, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, source: JobSource, optimismStatus: OptimismStatus, user?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, orders: Array<{ __typename?: 'Order', id: string, hasSubmittedEvent: boolean, primaryReference?: string | null, extractedData?: string | null, createdAt: any, createdAtDisplay?: any | null, externalDeepLink?: string | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', id: string, name: string } | null, job: { __typename?: 'Job', emailMetadata?: any | null }, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }> }>, quotes: Array<{ __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null }>, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }> };

export type KnowledgeBaseFragment = { __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> };

export type KnowledgeBaseDocumentFragment = { __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string };

export type ManagedResourceFragment = { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus, fallbackResource?: { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus } | null };

export type MemoryFragment = { __typename?: 'Memory', id: string, createdAt: any, computationType?: SavedComputationType | null, comment?: string | null, organization: { __typename?: 'Organization', id: string }, labeledComputation?: { __typename?: 'LabeledComputation', id: string, savedComputation: { __typename?: 'SavedComputation', id: string, originatorId?: string | null, jobId?: string | null } } | null, entityLinks?: Array<{ __typename?: 'MemoryEntityLink', id: string, actionDefinitionId?: string | null, organizationId?: string | null, teamId?: string | null, userId?: string | null, originatorId?: string | null, carrierId?: string | null, contactId?: string | null, placeId?: string | null, quoteId?: string | null, orderId?: string | null, shipmentId?: string | null, movementId?: string | null }> | null };

export type MemoryDetailsFragment = { __typename?: 'Memory', id: string, createdAt: any, computationType?: SavedComputationType | null, comment?: string | null, organization: { __typename?: 'Organization', id: string }, labeledComputation?: { __typename?: 'LabeledComputation', id: string, savedComputation: { __typename?: 'SavedComputation', id: string, originatorId?: string | null, jobId?: string | null } } | null, entityLinks?: Array<{ __typename?: 'MemoryEntityLink', id: string, actionDefinition?: { __typename?: 'ActionDefinition', id: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null, user?: { __typename?: 'User', id: string, username?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, carrier?: { __typename?: 'Carrier', id: string, name: string } | null, contact?: { __typename?: 'Contact', id: string, name: string } | null, contactMethod?: { __typename?: 'ContactMethodRecord', id: string, email?: string | null, phoneNumber?: string | null } | null, place?: { __typename?: 'Place', id: string, name?: string | null } | null, quote?: { __typename?: 'Quote', id: string } | null, order?: { __typename?: 'Order', id: string } | null, shipment?: { __typename?: 'Shipment', id: string } | null, movement?: { __typename?: 'Movement', id: string } | null }> | null };

export type MemoryEntityLinkEntitiesFragment = { __typename?: 'MemoryEntityLink', id: string, actionDefinition?: { __typename?: 'ActionDefinition', id: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null, user?: { __typename?: 'User', id: string, username?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, carrier?: { __typename?: 'Carrier', id: string, name: string } | null, contact?: { __typename?: 'Contact', id: string, name: string } | null, contactMethod?: { __typename?: 'ContactMethodRecord', id: string, email?: string | null, phoneNumber?: string | null } | null, place?: { __typename?: 'Place', id: string, name?: string | null } | null, quote?: { __typename?: 'Quote', id: string } | null, order?: { __typename?: 'Order', id: string } | null, shipment?: { __typename?: 'Shipment', id: string } | null, movement?: { __typename?: 'Movement', id: string } | null };

export type MessageRatingFragment = { __typename?: 'MessageRating', id: string, messageId: string, isPositive: boolean, reason?: MessageRatingReason | null, comments?: string | null };

export type MilestoneAfterTriggerParamsFieldsFragment = { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null };

export type MilestoneAtTriggerParamsFieldsFragment = { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null };

export type MovementDetailsFragment = { __typename?: 'Movement', details?: any | null, attributes?: any | null, coverageStatus?: CoverageStatus | null };

export type MovementPreviewFragment = { __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null };

export type MovementFragment = { __typename?: 'Movement', seq: number, customerRate?: number | null, inquiryCount: number, commodity?: string | null, negotiationStrategyConfigOverride?: any | null, id: string, isTrackingPaused: boolean, attributes?: any | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null }>, shipment: { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> }, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }> };

export type OrderFragment = { __typename?: 'Order', id: string, createdAt: any, updatedAt?: any | null, transmitId?: string | null, primaryReference?: string | null, hasSubmittedEvent: boolean, extractedData?: string | null, externalDeepLink?: string | null, externalId?: string | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> }, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }>, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }>, organization: { __typename?: 'Organization', id: string, integrationConfigs?: any | null }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, shipmentAssociations?: Array<{ __typename?: 'OrderShipmentAssociation', shipment: { __typename?: 'Shipment', id: string } }> | null };

export type OrderEventFragment = { __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string };

export type OrderPreviewFragment = { __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } };

export type OrderSummaryFragment = { __typename?: 'Order', id: string, hasSubmittedEvent: boolean, primaryReference?: string | null, extractedData?: string | null, createdAt: any, createdAtDisplay?: any | null, externalDeepLink?: string | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', id: string, name: string } | null, job: { __typename?: 'Job', emailMetadata?: any | null }, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }> };

export type OrganizationDocumentUploadPreviewFragment = { __typename?: 'OrganizationDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null };

export type OrganizationSettingsFragment = { __typename?: 'Organization', id: string, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } };

export type OriginatorFragment = { __typename?: 'Originator', id: string, transmitIds: Array<string>, name: string, createdAt: any, status: OriginatorStatus, autoSubmitScope: AutoSubmitScope, expectedWeeklyOrderCount?: number | null, configOverrides?: any | null, flagged: boolean, hasExtractedDataConfigured: boolean, attributes?: any | null, organization: { __typename?: 'Organization', id: string, name: string, type?: OrganizationType | null }, knownSenders: Array<{ __typename?: 'Contact', id: string, email?: string | null }>, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> };

export type PlaceFragment = { __typename?: 'Place', id: string, deletedAt?: any | null, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, creationProvenance?: PlaceCreationProvenance | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null };

export type PlaceSchedulingFragment = { __typename?: 'PlaceScheduling', placeId: string, methods: Array<{ __typename?: 'PlaceSchedulingMethod', id: string, method: any }> };

export type QuoteFragment = { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } };

export type QuoteEventFragment = { __typename?: 'QuoteEvent', id: string, createdAt: any, type: QuoteEventType, quoteId: string };

export type QuoteHistorySummaryFragment = { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, originator?: { __typename?: 'Originator', name: string } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null };

export type QuoteNoteFragment = { __typename?: 'QuoteNote', id: string, note?: string | null };

export type QuotePreviewFragment = { __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null };

export type QuoteSummaryFragment = { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null };

export type ConversationRatingFragment = { __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null };

export type SharedFileSummaryFragment = { __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null };

export type ShipmentPreviewFragment = { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> };

export type ShipmentFragment = { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> };

export type ShipmentHistorySummaryFragment = { __typename?: 'Shipment', id: string, externalId?: string | null, externalDeepLink?: string | null, carrierRates?: Array<{ __typename?: 'ShipmentCarrierMetadata', name: string, buyRate?: number | null, sellRate?: number | null, pickupAt?: string | null }> | null };

export type TeamFragment = { __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> };

export type TeamDetailsFragment = { __typename?: 'Team', id: string, name: string, description: string, email?: string | null, settings: any, actionTriggerCount: number, organizationId: string, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null, members: Array<{ __typename?: 'TeamMember', id: string, role: TeamMemberRole, organizationUserRelation: { __typename?: 'OrganizationUserRelation', id: string, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } } }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null };

export type TeamWithActionTriggerCountFragment = { __typename?: 'Team', actionTriggerCount: number, id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> };

export type TemplateFragment = { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null };

export type TemplatePreviewFragment = { __typename?: 'Template', id: string, type: TemplateType, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null };

export type TrackWorkspaceActionFieldsFragment = { __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> };

export type TrackWorkspaceActionFragment = { __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, children: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, children: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> };

export type TrackWorkspaceMovementEventFragment = { __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData', eventType: MovementEventType, appointments?: Array<{ __typename?: 'ConfirmedAppointmentSnapshot', confirmationNumber?: string | null }> | null } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData', eventType: MovementEventType, rate?: number | null, facilitatedByVooma?: boolean | null, carrier?: { __typename?: 'CarrierSnapshot', name?: string | null, externalId?: string | null } | null } | { __typename?: 'ExceptionCreatedData' } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData', eventType: MovementEventType } | { __typename?: 'LoadTakenOffHoldData', eventType: MovementEventType } | { __typename?: 'MovementCarrierChangedData', eventType: MovementEventType, from?: { __typename?: 'CarrierSnapshot', name?: string | null, externalId?: string | null, driver?: { __typename?: 'MovementCarrierContact', name?: string | null } | null, dispatch?: { __typename?: 'MovementCarrierContact', name?: string | null } | null } | null, to: { __typename?: 'CarrierSnapshot', name?: string | null, externalId?: string | null, driver?: { __typename?: 'MovementCarrierContact', name?: string | null } | null, dispatch?: { __typename?: 'MovementCarrierContact', name?: string | null } | null } } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData', eventType: MovementEventType } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData', eventType: MovementEventType } | { __typename?: 'ReadyForCoverageData', eventType: MovementEventType } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData', eventType: MovementEventType, eta: string } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData', eventType: MovementEventType, skipReason: TrackingMilestoneSkipReason, milestone: { __typename?: 'TrackingMilestone', type: TrackingMilestoneType } } | { __typename?: 'TrackingPausedData', eventType: MovementEventType, change: TrackingPauseChange, reason?: string | null, source?: TrackingPauseSource | null } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData', eventType: MovementEventType, tmsStatus?: string | null, changedFields?: Array<string> | null } | null };

export type TransformationConfigFragment = { __typename?: 'TransformationConfig', id: string, createdAt: any, params: any, organization?: { __typename?: 'Organization', id: string } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } };

export type TransformationDefinitionFragment = { __typename?: 'TransformationDefinition', id: string, createdAt: any, definition: any, organization?: { __typename?: 'Organization', id: string } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null };

export type UserDocumentUploadPreviewFragment = { __typename?: 'UserDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null, subjectId: string };

export type UserFormFieldsFragment = { __typename?: 'User', id: string, username?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean };

export type WebhookSubscriptionDetailFragment = { __typename?: 'WebhookSubscription', id: string, createdAt: any, organizationId: string, url: string, subscriptionType: WebhookSubscriptionType, authConfig: any };

export type WorkerPreviewFragment = { __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null };

export type WorkerProfilePreviewFragment = { __typename?: 'AIProfile', name?: string | null };

export type WorkerFragment = { __typename?: 'User', id: string, profile?: { __typename?: 'AIProfile', name?: string | null, backStory: string, humanisedDelay?: number | null, voiceId?: string | null, voiceModel?: SupportedVoiceModel | null, voiceSpeed?: number | null, languages?: Array<SupportedLanguage> | null } | { __typename?: 'HumanProfile' } | null, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string }> };

export type WorkerProfileFragment = { __typename?: 'AIProfile', name?: string | null, backStory: string, humanisedDelay?: number | null, voiceId?: string | null, voiceModel?: SupportedVoiceModel | null, voiceSpeed?: number | null, languages?: Array<SupportedLanguage> | null };

export type WorkflowFragment = { __typename?: 'Workflow', id: string, createdAt: any, organization: { __typename?: 'Organization', id: string }, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformations: Array<{ __typename?: 'WorkflowTransformation', id: string, seq: number, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } }>, trigger: { __typename?: 'FlowTrigger', type: FlowTriggerType, config?: any | null } };

export type GenericTransformationTemplateDetailsFragment = { __typename?: 'GenericTransformationTemplate', id: string, createdAt: any, updatedAt?: any | null, name: string, description?: string | null, genericRuleType: GenericRuleType, definition: any, version: number };

export type GenericTransformationTemplatesQueryVariables = Exact<{
  input?: InputMaybe<GenericTransformationTemplatesInput>;
}>;


export type GenericTransformationTemplatesQuery = { __typename?: 'Query', genericTransformationTemplates: Array<{ __typename?: 'GenericTransformationTemplate', id: string, createdAt: any, updatedAt?: any | null, name: string, description?: string | null, genericRuleType: GenericRuleType, definition: any, version: number }> };

export type GenericTransformationTemplateInheritorsQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
}>;


export type GenericTransformationTemplateInheritorsQuery = { __typename?: 'Query', genericTransformationTemplateInheritors: Array<{ __typename?: 'GenericTransformationTemplateInheritor', genericTransformationId: string, genericRuleId: string, organizationId: string, organizationName: string, templateVersion?: number | null }> };

export type CreateGenericTransformationTemplateMutationVariables = Exact<{
  input: CreateGenericTransformationTemplateInput;
}>;


export type CreateGenericTransformationTemplateMutation = { __typename?: 'Mutation', createGenericTransformationTemplate: { __typename?: 'GenericTransformationTemplatePayload', genericTransformationTemplate: { __typename?: 'GenericTransformationTemplate', id: string, createdAt: any, updatedAt?: any | null, name: string, description?: string | null, genericRuleType: GenericRuleType, definition: any, version: number } } };

export type UpdateGenericTransformationTemplateMutationVariables = Exact<{
  input: UpdateGenericTransformationTemplateInput;
}>;


export type UpdateGenericTransformationTemplateMutation = { __typename?: 'Mutation', updateGenericTransformationTemplate: { __typename?: 'GenericTransformationTemplatePayload', genericTransformationTemplate: { __typename?: 'GenericTransformationTemplate', id: string, createdAt: any, updatedAt?: any | null, name: string, description?: string | null, genericRuleType: GenericRuleType, definition: any, version: number } } };

export type DeleteGenericTransformationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGenericTransformationTemplateMutation = { __typename?: 'Mutation', deleteGenericTransformationTemplate: { __typename?: 'DeleteGenericTransformationTemplatePayload', success: boolean } };

export type MergeGenericTransformationTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MergeGenericTransformationTemplateMutation = { __typename?: 'Mutation', mergeGenericTransformationTemplate: { __typename?: 'MergeGenericTransformationTemplatePayload', mergedCount: number } };

export type ApplyGenericTransformationTemplateMutationVariables = Exact<{
  input: ApplyGenericTransformationTemplateInput;
}>;


export type ApplyGenericTransformationTemplateMutation = { __typename?: 'Mutation', applyGenericTransformationTemplate: { __typename?: 'ApplyGenericTransformationTemplatePayload', genericTransformationId: string, genericRuleId: string } };

export type GlobalPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalPromptsQuery = { __typename?: 'Query', globalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, createdAt: any, updatedAt?: any | null, currentVersionId?: string | null, name: string, prompt?: string | null, parameters?: any | null, runsOnExperimentalService?: boolean | null }> };

export type GlobalPromptByIdQueryVariables = Exact<{
  input: GlobalPromptByIdInput;
}>;


export type GlobalPromptByIdQuery = { __typename?: 'Query', globalPromptById?: { __typename?: 'GlobalPromptWithVersions', globalPrompt: { __typename?: 'GlobalPrompt', id: string, createdAt: any, updatedAt?: any | null, currentVersionId?: string | null, name: string, prompt?: string | null, parameters?: any | null, runsOnExperimentalService?: boolean | null, canRollOutFromCode: boolean, basePromptId?: string | null }, versions: Array<{ __typename?: 'GlobalPromptVersion', id: string, version: number, prompt: string, parameters?: any | null, provisioningResourceId?: string | null, createdAt: any }> } | null };

export type CreateGlobalPromptMutationVariables = Exact<{
  input: CreateGlobalPromptInput;
}>;


export type CreateGlobalPromptMutation = { __typename?: 'Mutation', createGlobalPrompt: { __typename?: 'GlobalPromptPayload', globalPrompt: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null } } };

export type UpdateGlobalPromptMutationVariables = Exact<{
  input: UpdateGlobalPromptInput;
}>;


export type UpdateGlobalPromptMutation = { __typename?: 'Mutation', updateGlobalPrompt: { __typename?: 'GlobalPromptPayload', globalPrompt: { __typename?: 'GlobalPrompt', id: string, prompt?: string | null, parameters?: any | null } } };

export type SetGlobalPromptRunsOnExperimentalServiceMutationVariables = Exact<{
  globalPromptId: Scalars['String']['input'];
  runsOnExperimentalService: Scalars['Boolean']['input'];
}>;


export type SetGlobalPromptRunsOnExperimentalServiceMutation = { __typename?: 'Mutation', setGlobalPromptRunsOnExperimentalService: { __typename?: 'GlobalPromptPayload', globalPrompt: { __typename?: 'GlobalPrompt', id: string, runsOnExperimentalService?: boolean | null } } };

export type SetGlobalPromptBasePromptMutationVariables = Exact<{
  globalPromptId: Scalars['String']['input'];
  basePromptId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetGlobalPromptBasePromptMutation = { __typename?: 'Mutation', setGlobalPromptBasePrompt: { __typename?: 'GlobalPromptPayload', globalPrompt: { __typename?: 'GlobalPrompt', id: string, basePromptId?: string | null } } };

export type BasePromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type BasePromptsQuery = { __typename?: 'Query', basePrompts: Array<{ __typename?: 'BasePrompt', id: string, key: string, name: string }> };

export type SetGlobalPromptVersionMutationVariables = Exact<{
  input: SetGlobalPromptVersionInput;
}>;


export type SetGlobalPromptVersionMutation = { __typename?: 'Mutation', setGlobalPromptVersion: { __typename?: 'GlobalPromptPayload', globalPrompt: { __typename?: 'GlobalPrompt', id: string, prompt?: string | null, parameters?: any | null } } };

export type DeleteGlobalPromptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteGlobalPromptMutation = { __typename?: 'Mutation', deleteGlobalPrompt: boolean };

export type RollOutGlobalPromptFromCodeMutationVariables = Exact<{
  globalPromptId: Scalars['String']['input'];
}>;


export type RollOutGlobalPromptFromCodeMutation = { __typename?: 'Mutation', rollOutGlobalPromptFromCode: { __typename?: 'RollOutFromCodePayload', organizationCount: number, succeededCount: number, failedCount: number } };

export type OrganizationsInheritingGlobalPromptQueryVariables = Exact<{
  globalPromptId: Scalars['String']['input'];
}>;


export type OrganizationsInheritingGlobalPromptQuery = { __typename?: 'Query', organizationsInheritingGlobalPrompt: Array<{ __typename?: 'OrgInheritingGlobalPromptPayload', id: string, name: string }> };

export type AddChatMessageToConversationMutationVariables = Exact<{
  input: AddChatMessageToConversationInput;
}>;


export type AddChatMessageToConversationMutation = { __typename?: 'Mutation', addChatMessageToConversation: { __typename?: 'AddChatMessageToConversationPayload', success: boolean, externalMessage?: { __typename?: 'ExternalMessage', id: string, externalIdentifier: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, emailMetadata?: any | null, userId?: string | null, conversationId?: string | null, canonicalMessageId?: string | null, user?: { __typename?: 'User', id: string, username?: string | null, firstName?: string | null, lastName?: string | null, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile', name?: string | null } | null } | null, documents: Array<{ __typename?: 'ExternalMessageDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null }> } | null } };

export type BulkDeleteQuotesMutationVariables = Exact<{
  input: BulkDeleteQuotesInput;
}>;


export type BulkDeleteQuotesMutation = { __typename?: 'Mutation', bulkDeleteQuotes: { __typename?: 'BulkDeleteQuotesPayload', success: boolean } };

export type ComputeRatesMutationVariables = Exact<{
  input: ComputeRatesInput;
}>;


export type ComputeRatesMutation = { __typename?: 'Mutation', computeRates: { __typename?: 'ComputeRatesPayload', success: boolean, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, loadData?: any | null, type: CustomerRateType, rate?: any | null, metadata?: any | null, quote: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null }>, ratingErrors?: Array<{ __typename?: 'RatingError', ratingMethod: RatingMethod, errorMessage?: string | null }> | null } };

export type CreateApiClientMutationVariables = Exact<{
  input: CreateApiClientInput;
}>;


export type CreateApiClientMutation = { __typename?: 'Mutation', createApiClient: { __typename?: 'CreateApiClientPayload', success: boolean, apiKey: string } };

export type CreateAuthTokenMutationVariables = Exact<{
  input: CreateAuthTokenInput;
}>;


export type CreateAuthTokenMutation = { __typename?: 'Mutation', createAuthToken: { __typename?: 'CreateAuthTokenPayload', success: boolean, email?: string | null } };

export type CreateAwkwardMomentLabelMutationVariables = Exact<{
  input: CreateAwkwardMomentLabelInput;
}>;


export type CreateAwkwardMomentLabelMutation = { __typename?: 'Mutation', createAwkwardMomentLabel: { __typename?: 'CreateAwkwardMomentLabelResult', success: boolean, error?: string | null } };

export type CreateCarrierRateMutationVariables = Exact<{
  input: CreateCarrierRateInput;
}>;


export type CreateCarrierRateMutation = { __typename?: 'Mutation', createCarrierRate: { __typename?: 'CreateCarrierRatePayload', success: boolean, carrierRate: { __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null } } };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact: { __typename?: 'CreateContactPayload', success: boolean } };

export type CreateCustomerRateMutationVariables = Exact<{
  input: CreateCustomerRateInput;
}>;


export type CreateCustomerRateMutation = { __typename?: 'Mutation', createCustomerRate: { __typename?: 'CreateCustomerRatePayload', success: boolean, customerRate: { __typename?: 'CustomerRate', id: string, createdAt: any, loadData?: any | null, type: CustomerRateType, rate?: any | null, metadata?: any | null, quote: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } } } };

export type CreateExternalChannelMutationVariables = Exact<{
  input: CreateExternalChannelInput;
}>;


export type CreateExternalChannelMutation = { __typename?: 'Mutation', createExternalChannel: { __typename?: 'CreateExternalChannelPayload', success: boolean, externalChannel: { __typename?: 'ExternalChannel', id: string, createdAt: any, organizationId: string, teamId?: string | null, userId?: string | null, channelType: ExternalChannelType, externalIdentifier: string } } };

export type CreateFreightDataMappingMutationVariables = Exact<{
  input: CreateFreightDataMappingInput;
}>;


export type CreateFreightDataMappingMutation = { __typename?: 'Mutation', createFreightDataMapping: { __typename?: 'CreateFreightDataMappingPayload', success: boolean, freightDataMapping: { __typename?: 'FreightDataMapping', id: string, key: string, type: FreightDataMappingType, values: any, organizationId: string, createdAt: any, updatedAt?: any | null } } };

export type CreateFrontMailboxSubscriptionsMutationVariables = Exact<{
  input: CreateFrontMailboxSubscriptionsInput;
}>;


export type CreateFrontMailboxSubscriptionsMutation = { __typename?: 'Mutation', createFrontMailboxSubscriptions: { __typename?: 'CreateFrontMailboxSubscriptionsPayload', success: boolean, error?: string | null, mailboxes: Array<{ __typename?: 'FrontMailboxSubscription', id: string, externalId: string, organizationId: string, ownerId: string, createdAt: any }> } };

export type CreateGenericTransformationMutationVariables = Exact<{
  input: CreateGenericTransformationInput;
}>;


export type CreateGenericTransformationMutation = { __typename?: 'Mutation', createGenericTransformation: { __typename?: 'GenericTransformationMutationPayload', success: boolean } };

export type CreateInstantQuoteMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateInstantQuoteMutation = { __typename?: 'Mutation', createInstantQuote: { __typename?: 'CreateQuotePayload', success: boolean, quote: { __typename?: 'Quote', id: string } } };

export type CreateMemoryEntityLinkMutationVariables = Exact<{
  input: CreateMemoryEntityLinkInput;
}>;


export type CreateMemoryEntityLinkMutation = { __typename?: 'Mutation', createMemoryEntityLink: { __typename?: 'CreateMemoryEntityLinkPayload', success: boolean, memoryEntityLink?: { __typename?: 'MemoryEntityLink', id: string, actionDefinition?: { __typename?: 'ActionDefinition', id: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null, user?: { __typename?: 'User', id: string, username?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, carrier?: { __typename?: 'Carrier', id: string, name: string } | null, contact?: { __typename?: 'Contact', id: string, name: string } | null, contactMethod?: { __typename?: 'ContactMethodRecord', id: string, email?: string | null, phoneNumber?: string | null } | null, place?: { __typename?: 'Place', id: string, name?: string | null } | null, quote?: { __typename?: 'Quote', id: string } | null, order?: { __typename?: 'Order', id: string } | null, shipment?: { __typename?: 'Shipment', id: string } | null, movement?: { __typename?: 'Movement', id: string } | null } | null } };

export type CreateOriginatorMutationVariables = Exact<{
  input: CreateOriginatorInput;
}>;


export type CreateOriginatorMutation = { __typename?: 'Mutation', createOriginator: { __typename?: 'CreateOriginatorPayload', success: boolean, originator: { __typename?: 'Originator', id: string, transmitIds: Array<string>, name: string, createdAt: any, status: OriginatorStatus, autoSubmitScope: AutoSubmitScope, expectedWeeklyOrderCount?: number | null, configOverrides?: any | null, flagged: boolean, hasExtractedDataConfigured: boolean, attributes?: any | null, organization: { __typename?: 'Organization', id: string, name: string, type?: OrganizationType | null }, knownSenders: Array<{ __typename?: 'Contact', id: string, email?: string | null }>, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } } };

export type CreateOriginatorEventMutationVariables = Exact<{
  input: CreateOriginatorEventInput;
}>;


export type CreateOriginatorEventMutation = { __typename?: 'Mutation', createOriginatorEvent: { __typename?: 'CreateOriginatorEventPayload', success: boolean } };

export type CreatePlaceSchedulingMethodMutationVariables = Exact<{
  input: CreatePlaceSchedulingMethodInput;
}>;


export type CreatePlaceSchedulingMethodMutation = { __typename?: 'Mutation', createPlaceSchedulingMethod: { __typename?: 'PlaceSchedulingPayload', scheduling: { __typename?: 'PlaceScheduling', placeId: string, methods: Array<{ __typename?: 'PlaceSchedulingMethod', id: string, method: any }> } } };

export type CreatePricingStrategyMutationVariables = Exact<{
  input: CreatePricingStrategyInput;
}>;


export type CreatePricingStrategyMutation = { __typename?: 'Mutation', createPricingStrategy: { __typename?: 'CreatePricingStrategyPayload', success: boolean, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null } };

export type CreateQuoteEventMutationVariables = Exact<{
  input: CreateQuoteEventInput;
}>;


export type CreateQuoteEventMutation = { __typename?: 'Mutation', createQuoteEvent: { __typename?: 'CreateQuoteEventPayload', success: boolean, quoteEvent: { __typename?: 'QuoteEvent', id: string, createdAt: any, type: QuoteEventType, quoteId: string } } };

export type CreateQuoteNoteMutationVariables = Exact<{
  input: CreateQuoteNoteInput;
}>;


export type CreateQuoteNoteMutation = { __typename?: 'Mutation', createQuoteNote: { __typename?: 'CreateQuoteNotePayload', success: boolean, quoteNote: { __typename?: 'QuoteNote', id: string, note?: string | null } } };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'CreateTeamPayload', success: boolean, team?: { __typename?: 'Team', id: string, name: string, description: string } | null } };

export type CreateTeamMemberMutationVariables = Exact<{
  input: CreateTeamMemberInput;
}>;


export type CreateTeamMemberMutation = { __typename?: 'Mutation', createTeamMember: { __typename?: 'CrateTeamMemberPayload', success: boolean } };

export type CreateTemplateMutationVariables = Exact<{
  input: CreateTemplateInput;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'CreateTemplatePayload', success: boolean, template: { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } } };

export type CreateTranscriptionLabelMutationVariables = Exact<{
  input: CreateTranscriptionLabelInput;
}>;


export type CreateTranscriptionLabelMutation = { __typename?: 'Mutation', createTranscriptionLabel: { __typename?: 'CreateTranscriptionLabelResult', success: boolean, alreadyFlagged?: boolean | null, error?: string | null } };

export type CreateTransformationConfigMutationVariables = Exact<{
  input: CreateTransformationConfigInput;
}>;


export type CreateTransformationConfigMutation = { __typename?: 'Mutation', createTransformationConfig: { __typename?: 'CreateTransformationConfigPayload', success: boolean, transformationConfig?: { __typename?: 'TransformationConfig', id: string, createdAt: any, params: any, organization?: { __typename?: 'Organization', id: string } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } | null } };

export type CreateTransformationDefinitionMutationVariables = Exact<{
  input: CreateTransformationDefinitionInput;
}>;


export type CreateTransformationDefinitionMutation = { __typename?: 'Mutation', createTransformationDefinition: { __typename?: 'CreateTransformationDefinitionPayload', success: boolean, transformationDefinition?: { __typename?: 'TransformationDefinition', id: string, createdAt: any, definition: any, organization?: { __typename?: 'Organization', id: string } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null } | null } };

export type CreateTurnTakingLabelMutationVariables = Exact<{
  input: CreateTurnTakingLabelInput;
}>;


export type CreateTurnTakingLabelMutation = { __typename?: 'Mutation', createTurnTakingLabel: { __typename?: 'CreateTurnTakingLabelResult', success: boolean, alreadyFlagged?: boolean | null, error?: string | null } };

export type CreateWebhookSubscriptionMutationVariables = Exact<{
  input: CreateWebhookSubscriptionInput;
}>;


export type CreateWebhookSubscriptionMutation = { __typename?: 'Mutation', createWebhookSubscription: { __typename?: 'CreateWebhookSubscriptionPayload', success: boolean, item: { __typename?: 'WebhookSubscription', id: string } } };

export type CreateWorkflowMutationVariables = Exact<{
  input: CreateWorkflowInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename?: 'CreateWorkflowPayload', success: boolean, workflow?: { __typename?: 'Workflow', id: string, createdAt: any, organization: { __typename?: 'Organization', id: string }, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformations: Array<{ __typename?: 'WorkflowTransformation', id: string, seq: number, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } }>, trigger: { __typename?: 'FlowTrigger', type: FlowTriggerType, config?: any | null } } | null } };

export type DeleteApiClientMutationVariables = Exact<{
  input: DeleteApiClientInput;
}>;


export type DeleteApiClientMutation = { __typename?: 'Mutation', deleteApiClient: { __typename?: 'DeleteApiClientPayload', success: boolean } };

export type DeleteAuthTokenMutationVariables = Exact<{
  input: DeleteAuthTokenInput;
}>;


export type DeleteAuthTokenMutation = { __typename?: 'Mutation', deleteAuthToken: { __typename?: 'DeleteAuthTokenPayload', success: boolean } };

export type DeleteContactMutationVariables = Exact<{
  input: DeleteContactInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact: { __typename?: 'DeleteContactPayload', success: boolean } };

export type DeleteFreightDataMappingMutationVariables = Exact<{
  input: DeleteFreightDataMappingInput;
}>;


export type DeleteFreightDataMappingMutation = { __typename?: 'Mutation', deleteFreightDataMapping: { __typename?: 'DeleteFreightDataMappingPayload', success: boolean } };

export type DeleteFrontMailboxSubscriptionsMutationVariables = Exact<{
  input: DeleteFrontMailboxSubscriptionsInput;
}>;


export type DeleteFrontMailboxSubscriptionsMutation = { __typename?: 'Mutation', deleteFrontMailboxSubscriptions: { __typename?: 'DeleteFrontMailboxSubscriptionsPayload', success: boolean, error?: string | null } };

export type DeleteGenericTransformationMutationVariables = Exact<{
  input: DeleteGenericTransformationInput;
}>;


export type DeleteGenericTransformationMutation = { __typename?: 'Mutation', deleteGenericTransformation: { __typename?: 'GenericTransformationMutationPayload', success: boolean } };

export type DeleteMemoryMutationVariables = Exact<{
  input: DeleteMemoryInput;
}>;


export type DeleteMemoryMutation = { __typename?: 'Mutation', deleteMemory: { __typename?: 'DeleteMemoryPayload', success: boolean } };

export type DeleteMemoryEntityLinkMutationVariables = Exact<{
  input: DeleteMemoryEntityLinkInput;
}>;


export type DeleteMemoryEntityLinkMutation = { __typename?: 'Mutation', deleteMemoryEntityLink: { __typename?: 'DeleteMemoryEntityLinkPayload', success: boolean } };

export type DeletePlaceSchedulingMethodMutationVariables = Exact<{
  input: DeletePlaceSchedulingMethodInput;
}>;


export type DeletePlaceSchedulingMethodMutation = { __typename?: 'Mutation', deletePlaceSchedulingMethod: { __typename?: 'PlaceSchedulingPayload', scheduling: { __typename?: 'PlaceScheduling', placeId: string, methods: Array<{ __typename?: 'PlaceSchedulingMethod', id: string, method: any }> } } };

export type DeletePricingStrategyMutationVariables = Exact<{
  input: DeletePricingStrategyInput;
}>;


export type DeletePricingStrategyMutation = { __typename?: 'Mutation', deletePricingStrategy: { __typename?: 'DeletePricingStrategyPayload', success: boolean } };

export type DeleteQuoteMutationVariables = Exact<{
  input: DeleteQuoteInput;
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote: { __typename?: 'DeleteQuotePayload', success: boolean } };

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'DeleteTeamPayload', success: boolean } };

export type DeleteTeamMemberMutationVariables = Exact<{
  input: DeleteTeamMemberInput;
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', deleteTeamMember: { __typename?: 'DeleteTeamMemberPayload', success: boolean } };

export type DeleteWebhookSubscriptionMutationVariables = Exact<{
  input: DeleteWebhookSubscriptionInput;
}>;


export type DeleteWebhookSubscriptionMutation = { __typename?: 'Mutation', deleteWebhookSubscription: { __typename?: 'DeleteWebhookSubscriptionPayload', success: boolean } };

export type DeleteWorkflowMutationVariables = Exact<{
  input: DeleteWorkflowInput;
}>;


export type DeleteWorkflowMutation = { __typename?: 'Mutation', deleteWorkflow: { __typename?: 'DeleteWorkflowPayload', success: boolean } };

export type FindOrCreateDatHistoryRatesMutationVariables = Exact<{
  input: DatHistoryRatesInput;
}>;


export type FindOrCreateDatHistoryRatesMutation = { __typename?: 'Mutation', findOrCreateDATHistoryRates: { __typename?: 'DATHistoryRatesPayload', metadata?: any | null, rate?: number | null, label?: string | null, key?: string | null, errorMessage?: string | null } };

export type FindOrCreateMarketConditionsMutationVariables = Exact<{
  input: MarketConditionsInput;
}>;


export type FindOrCreateMarketConditionsMutation = { __typename?: 'Mutation', findOrCreateMarketConditions: Array<{ __typename?: 'MarketConditionsPayload', stop?: any | null, equipmentType?: string | null, integrationType: IntegrationType, errorMessage?: string | null, marketConditions: Array<{ __typename?: 'StopMarketConditions', apiResponse: any, requestType: CachedRequestType }> }> };

export type LeaveTeamMutationVariables = Exact<{
  input: LeaveTeamInput;
}>;


export type LeaveTeamMutation = { __typename?: 'Mutation', leaveTeam: { __typename?: 'LeaveTeamPayload', success: boolean } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', success: boolean } };

export type OnboardNewOriginatorMutationVariables = Exact<{
  input: OnboardNewOriginatorInput;
}>;


export type OnboardNewOriginatorMutation = { __typename?: 'Mutation', onboardNewOriginator: { __typename?: 'OnboardNewOriginatorPayload', success: boolean, customerFacingOriginator: { __typename?: 'Originator', id: string, transmitIds: Array<string>, name: string, createdAt: any, status: OriginatorStatus, autoSubmitScope: AutoSubmitScope, expectedWeeklyOrderCount?: number | null, configOverrides?: any | null, flagged: boolean, hasExtractedDataConfigured: boolean, attributes?: any | null, organization: { __typename?: 'Organization', id: string, name: string, type?: OrganizationType | null }, knownSenders: Array<{ __typename?: 'Contact', id: string, email?: string | null }>, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } } };

export type PageMutationVariables = Exact<{
  input: PageInput;
}>;


export type PageMutation = { __typename?: 'Mutation', page: boolean };

export type ProposeFreightDataMappingValuesMutationVariables = Exact<{
  input: ProposeFreightDataMappingValuesInput;
}>;


export type ProposeFreightDataMappingValuesMutation = { __typename?: 'Mutation', proposeFreightDataMappingValues: { __typename?: 'ProposeFreightDataMappingValuesPayload', proposedValues: any, success: boolean } };

export type RecoverMemoryMutationVariables = Exact<{
  input: RecoverMemoryInput;
}>;


export type RecoverMemoryMutation = { __typename?: 'Mutation', recoverMemory: { __typename?: 'RecoverMemoryPayload', success: boolean } };

export type RefreshQuoteMileageMutationVariables = Exact<{
  input: RefreshQuoteMileageInput;
}>;


export type RefreshQuoteMileageMutation = { __typename?: 'Mutation', refreshQuoteMileage: { __typename?: 'RefreshQuoteMileagePayload', success: boolean } };

export type ReprocessOrderMutationVariables = Exact<{
  input: ReprocessOrderInput;
}>;


export type ReprocessOrderMutation = { __typename?: 'Mutation', reprocessOrder: { __typename?: 'ReprocessOrderPayload', success: boolean } };

export type ResolveCorruptedTrackingExceptionMutationVariables = Exact<{
  exceptionId: Scalars['ID']['input'];
}>;


export type ResolveCorruptedTrackingExceptionMutation = { __typename?: 'Mutation', resolveCorruptedTrackingException: boolean };

export type SelectQuickReplyMutationVariables = Exact<{
  input: SelectQuickReplyInput;
}>;


export type SelectQuickReplyMutation = { __typename?: 'Mutation', selectQuickReply: boolean };

export type TakeConversationSnapshotMutationVariables = Exact<{
  input: TakeConversationSnapshotInput;
}>;


export type TakeConversationSnapshotMutation = { __typename?: 'Mutation', takeConversationSnapshot: { __typename?: 'TakeConversationSnapshotPayload', success: boolean } };

export type TrackMutationVariables = Exact<{
  input: TrackInput;
}>;


export type TrackMutation = { __typename?: 'Mutation', track: boolean };

export type UpdateCarrierRateMutationVariables = Exact<{
  input: UpdateCarrierRateInput;
}>;


export type UpdateCarrierRateMutation = { __typename?: 'Mutation', updateCarrierRate: { __typename?: 'UpdateCarrierRatePayload', success: boolean, carrierRate: { __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null } } };

export type UpdateConversationLabelsMutationVariables = Exact<{
  input: UpdateConversationLabelsInput;
}>;


export type UpdateConversationLabelsMutation = { __typename?: 'Mutation', updateConversationLabels: { __typename?: 'UpdateConversationLabelsPayload', success: boolean } };

export type UpdateCustomerRateMutationVariables = Exact<{
  input: UpdateCustomerRateInput;
}>;


export type UpdateCustomerRateMutation = { __typename?: 'Mutation', updateCustomerRate: { __typename?: 'UpdateCustomerRatePayload', success: boolean, customerRate: { __typename?: 'CustomerRate', id: string, createdAt: any, loadData?: any | null, type: CustomerRateType, rate?: any | null, metadata?: any | null, quote: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } } } };

export type UpdateFreightDataMappingMutationVariables = Exact<{
  input: UpdateFreightDataMappingInput;
}>;


export type UpdateFreightDataMappingMutation = { __typename?: 'Mutation', updateFreightDataMapping: { __typename?: 'UpdateFreightDataMappingPayload', success: boolean, freightDataMapping: { __typename?: 'FreightDataMapping', id: string, key: string, type: FreightDataMappingType, values: any, organizationId: string, createdAt: any, updatedAt?: any | null } } };

export type UpdateGenericTransformationMutationVariables = Exact<{
  input: UpdateGenericTransformationInput;
}>;


export type UpdateGenericTransformationMutation = { __typename?: 'Mutation', updateGenericTransformation: { __typename?: 'GenericTransformationMutationPayload', success: boolean } };

export type UpdateMemoryMutationVariables = Exact<{
  input: UpdateMemoryInput;
}>;


export type UpdateMemoryMutation = { __typename?: 'Mutation', updateMemory: { __typename?: 'UpdateMemoryPayload', success: boolean, memory?: { __typename?: 'Memory', id: string, comment?: string | null } | null } };

export type UpdateMemoryEntityLinkMutationVariables = Exact<{
  input: UpdateMemoryEntityLinkInput;
}>;


export type UpdateMemoryEntityLinkMutation = { __typename?: 'Mutation', updateMemoryEntityLink: { __typename?: 'UpdateMemoryEntityLinkPayload', success: boolean } };

export type UpdateOriginatorMutationVariables = Exact<{
  input: UpdateOriginatorInput;
}>;


export type UpdateOriginatorMutation = { __typename?: 'Mutation', updateOriginator: { __typename?: 'UpdateOriginatorPayload', success: boolean } };

export type UpdatePlaceSchedulingMethodMutationVariables = Exact<{
  input: UpdatePlaceSchedulingMethodInput;
}>;


export type UpdatePlaceSchedulingMethodMutation = { __typename?: 'Mutation', updatePlaceSchedulingMethod: { __typename?: 'PlaceSchedulingPayload', scheduling: { __typename?: 'PlaceScheduling', placeId: string, methods: Array<{ __typename?: 'PlaceSchedulingMethod', id: string, method: any }> } } };

export type UpdatePricingStrategyMutationVariables = Exact<{
  input: UpdatePricingStrategyInput;
}>;


export type UpdatePricingStrategyMutation = { __typename?: 'Mutation', updatePricingStrategy: { __typename?: 'CreatePricingStrategyPayload', success: boolean, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null } };

export type UpdateQuoteMutationVariables = Exact<{
  input: UpdateQuoteInput;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote: { __typename?: 'UpdateQuotePayload', success: boolean, quote: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } } };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'CreateTeamPayload', success: boolean, team?: { __typename?: 'Team', id: string, name: string, description: string, settings: any, email?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } };

export type UpdateTeamMemberMutationVariables = Exact<{
  input: UpdateTeamMemberInput;
}>;


export type UpdateTeamMemberMutation = { __typename?: 'Mutation', updateTeamMember: { __typename?: 'CrateTeamMemberPayload', success: boolean } };

export type UpdateTemplateMutationVariables = Exact<{
  input: UpdateTemplateInput;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate: { __typename?: 'UpdateTemplatePayload', success: boolean, template: { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } } };

export type UpdateTransformationConfigMutationVariables = Exact<{
  input: UpdateTransformationConfigInput;
}>;


export type UpdateTransformationConfigMutation = { __typename?: 'Mutation', updateTransformationConfig: { __typename?: 'UpdateTransformationConfigPayload', transformationConfig?: { __typename?: 'TransformationConfig', id: string, createdAt: any, params: any, organization?: { __typename?: 'Organization', id: string } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } | null } };

export type UpdateUserDetailsMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserDetailsMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', success: boolean, user: { __typename?: 'User', features?: any | null, id: string, username?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean } } };

export type UpdateUserFeaturesMutationVariables = Exact<{
  input: UpdateUserFeaturesInput;
}>;


export type UpdateUserFeaturesMutation = { __typename?: 'Mutation', updateUserFeatures: { __typename?: 'UpdateUserPayload', success: boolean, user: { __typename?: 'User', features?: any | null, id: string, username?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean } } };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UpdateUserPayload', success: boolean, user: { __typename?: 'User', settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null } } };

export type UpdateWebhookSubscriptionMutationVariables = Exact<{
  input: UpdateWebhookSubscriptionInput;
}>;


export type UpdateWebhookSubscriptionMutation = { __typename?: 'Mutation', updateWebhookSubscription: { __typename?: 'UpdateWebhookSubscriptionPayload', item: { __typename?: 'WebhookSubscription', id: string, createdAt: any, organizationId: string, url: string, subscriptionType: WebhookSubscriptionType, authConfig: any } } };

export type UpdateWorkflowMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', updateWorkflow: { __typename?: 'UpdateWorkflowPayload', success: boolean, workflow?: { __typename?: 'Workflow', id: string, createdAt: any, organization: { __typename?: 'Organization', id: string }, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformations: Array<{ __typename?: 'WorkflowTransformation', id: string, seq: number, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } }>, trigger: { __typename?: 'FlowTrigger', type: FlowTriggerType, config?: any | null } } | null } };

export type UploadFileMutationVariables = Exact<{
  input: UploadFileInput;
  file: Scalars['Upload']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: { __typename?: 'UploadFilePayload', success: boolean, url: string, upload?: { __typename?: 'ActionDefinitionDocumentUpload', id: string, url: string } | { __typename?: 'ActionExecutionDocumentUpload', id: string, url: string } | { __typename?: 'EntityDocumentUpload', id: string, url: string } | { __typename?: 'ExternalMessageDocumentUpload', id: string, url: string } | { __typename?: 'JobDocumentUpload', id: string, url: string } | { __typename?: 'KnowledgeBaseDocumentUpload', id: string, url: string } | { __typename?: 'OrganizationDocumentUpload', id: string, url: string } | { __typename?: 'UserDocumentUpload', id: string, url: string } | { __typename?: 'UserProfilePhoto', id: string, url: string } | null } };

export type ValidatePricingStrategyInstructionsMutationVariables = Exact<{
  input: ValidatePricingStrategyInstructionsInput;
}>;


export type ValidatePricingStrategyInstructionsMutation = { __typename?: 'Mutation', validatePricingStrategyInstructions: { __typename?: 'PricingStrategyValidationPayload', isValid: boolean, issues: Array<{ __typename?: 'PricingStrategyInstructionIssue', rule: string, explanation: string }> } };

export type AddWorkerToActionDefinitionMutationVariables = Exact<{
  input: AddWorkerToActionDefinitionInput;
}>;


export type AddWorkerToActionDefinitionMutation = { __typename?: 'Mutation', addWorkerToActionDefinition: { __typename?: 'AddWorkerToActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type CloneActionDefinitionMutationVariables = Exact<{
  input: CloneActionDefinitionInput;
}>;


export type CloneActionDefinitionMutation = { __typename?: 'Mutation', cloneActionDefinition: { __typename?: 'CloneActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', id: string } } };

export type CreateActionDefinitionMutationVariables = Exact<{
  input: CreateActionDefinitionInput;
}>;


export type CreateActionDefinitionMutation = { __typename?: 'Mutation', createActionDefinition: { __typename?: 'CreateActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type DeleteActionDefinitionMutationVariables = Exact<{
  input: DeleteActionDefinitionInput;
}>;


export type DeleteActionDefinitionMutation = { __typename?: 'Mutation', deleteActionDefinition: { __typename?: 'DeleteActionDefinitionPayload', success: boolean } };

export type DeleteActionDefinitionDocumentMutationVariables = Exact<{
  input: DeleteActionDefinitionDocumentInput;
}>;


export type DeleteActionDefinitionDocumentMutation = { __typename?: 'Mutation', deleteActionDefinitionDocument: { __typename?: 'DeleteActionDefinitionDocumentPayload', success: boolean } };

export type DeleteActionDefinitionTeamGlobalPromptValuesMutationVariables = Exact<{
  input: DeleteActionDefinitionTeamGlobalPromptValuesInput;
}>;


export type DeleteActionDefinitionTeamGlobalPromptValuesMutation = { __typename?: 'Mutation', deleteActionDefinitionTeamGlobalPromptValues: { __typename?: 'DeleteActionDefinitionTeamGlobalPromptValuesPayload', success: boolean } };

export type DiffActionDefinitionNaturalLanguageProcedureMutationVariables = Exact<{
  input: DiffActionDefinitionNaturalLanguageProcedureInput;
}>;


export type DiffActionDefinitionNaturalLanguageProcedureMutation = { __typename?: 'Mutation', diffActionDefinitionNaturalLanguageProcedure: { __typename?: 'DiffActionDefinitionNaturalLanguageProcedurePayload', diff?: any | null } };

export type ProposeGlobalPromptSopAlignmentMutationVariables = Exact<{
  input: ProposeGlobalPromptSopAlignmentInput;
}>;


export type ProposeGlobalPromptSopAlignmentMutation = { __typename?: 'Mutation', proposeGlobalPromptSopAlignment: { __typename?: 'ProposeGlobalPromptSopAlignmentPayload', proposals: Array<{ __typename?: 'SopEditProposalItem', id: string, title: string, rationale: string, anchor: string, replacement: string, lineHint?: number | null }> } };

export type RemoveWorkerFromActionDefinitionMutationVariables = Exact<{
  input: RemoveWorkerFromActionDefinitionInput;
}>;


export type RemoveWorkerFromActionDefinitionMutation = { __typename?: 'Mutation', removeWorkerFromActionDefinition: { __typename?: 'RemoveWorkerFromActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type SetTrackSopMutationVariables = Exact<{
  input: SetTrackSopInput;
}>;


export type SetTrackSopMutation = { __typename?: 'Mutation', setTrackSop: { __typename?: 'SetTrackSopPayload', actionDefinition: { __typename?: 'ActionDefinition', id: string } } };

export type SimulateSemanticWaitPatternsMutationVariables = Exact<{
  input: SimulateSemanticWaitPatternsInput;
}>;


export type SimulateSemanticWaitPatternsMutation = { __typename?: 'Mutation', simulateSemanticWaitPatterns: { __typename?: 'SimulateSemanticWaitPatternsPayload', results: Array<{ __typename?: 'SemanticWaitPatternSimulationResult', patternName: string, status: SemanticWaitStatus }> } };

export type SubscribeToActionDefinitionMutationVariables = Exact<{
  input: SubscribeToActionDefinitionInput;
}>;


export type SubscribeToActionDefinitionMutation = { __typename?: 'Mutation', subscribeToActionDefinition: { __typename?: 'SubscribeToActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type SyncActionDefinitionToShadowOrgMutationVariables = Exact<{
  input: SyncActionDefinitionToShadowOrgInput;
}>;


export type SyncActionDefinitionToShadowOrgMutation = { __typename?: 'Mutation', syncActionDefinitionToShadowOrganization: { __typename?: 'SyncActionDefinitionToShadowOrgPayload', success: boolean, syncedActionDefinitionIds: Array<string> } };

export type UnsubscribeToActionDefinitionMutationVariables = Exact<{
  input: SubscribeToActionDefinitionInput;
}>;


export type UnsubscribeToActionDefinitionMutation = { __typename?: 'Mutation', unsubscribeToActionDefinition: { __typename?: 'SubscribeToActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type UpdateActionDefinitionMutationVariables = Exact<{
  input: UpdateActionDefinitionInput;
}>;


export type UpdateActionDefinitionMutation = { __typename?: 'Mutation', updateActionDefinition: { __typename?: 'UpdateActionDefinitionPayload', actionDefinition: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type UpsertActionDefinitionTeamGlobalPromptValuesMutationVariables = Exact<{
  input: UpsertActionDefinitionTeamGlobalPromptValuesInput;
}>;


export type UpsertActionDefinitionTeamGlobalPromptValuesMutation = { __typename?: 'Mutation', upsertActionDefinitionTeamGlobalPromptValues: { __typename?: 'UpsertActionDefinitionTeamGlobalPromptValuesPayload', teamGlobalPromptValues: { __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null } } };

export type ValidateTextInstructionsMutationVariables = Exact<{
  input: ValidateTextInstructionsInput;
}>;


export type ValidateTextInstructionsMutation = { __typename?: 'Mutation', validateTextInstructions: { __typename?: 'ValidateTextInstructionsPayload', promptEvaluationOverview: string, individualHighlights: Array<{ __typename?: 'TextValidationResult', textToHighlight: string, severity: string, rationale: string }> } };

export type ChangeActionExecutionAutonomyStateMutationVariables = Exact<{
  input: ChangeActionExecutionAutonomyStateInput;
}>;


export type ChangeActionExecutionAutonomyStateMutation = { __typename?: 'Mutation', changeActionExecutionAutonomyState: { __typename?: 'ChangeActionExecutionAutonomyStatePayload', success: boolean } };

export type TriggerActionExecutionMutationVariables = Exact<{
  input: TriggerActionExecutionInput;
}>;


export type TriggerActionExecutionMutation = { __typename?: 'Mutation', triggerActionExecution: { __typename?: 'TriggerActionExecutionPayload', actionExecutionId: string, success: boolean } };

export type CreateActionTriggerMutationVariables = Exact<{
  input: CreateActionTriggerInput;
}>;


export type CreateActionTriggerMutation = { __typename?: 'Mutation', createActionTrigger: { __typename?: 'CreateActionTriggerPayload', actionTrigger: { __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null } } };

export type DeleteActionTriggerMutationVariables = Exact<{
  input: DeleteActionTriggerInput;
}>;


export type DeleteActionTriggerMutation = { __typename?: 'Mutation', deleteActionTrigger: { __typename?: 'DeleteActionTriggerPayload', success: boolean } };

export type UpdateActionTriggerMutationVariables = Exact<{
  input: UpdateActionTriggerInput;
}>;


export type UpdateActionTriggerMutation = { __typename?: 'Mutation', updateActionTrigger: { __typename?: 'UpdateActionTriggerPayload', actionTrigger: { __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null } } };

export type DeleteAiPhoneNumberMutationVariables = Exact<{
  input: DeleteAiPhoneNumberInput;
}>;


export type DeleteAiPhoneNumberMutation = { __typename?: 'Mutation', deleteAIPhoneNumber: { __typename?: 'DeleteAIPhoneNumberPayload', success: boolean } };

export type ProvisionAiPhoneNumberMutationVariables = Exact<{
  input: ProvisionAiPhoneNumberInput;
}>;


export type ProvisionAiPhoneNumberMutation = { __typename?: 'Mutation', provisionAIPhoneNumber: { __typename?: 'ProvisionAIPhoneNumberPayload', success: boolean, aiPhoneNumber: { __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null } } };

export type ReserveTestPhoneNumberMutationVariables = Exact<{
  input: ReserveTestPhoneNumberInput;
}>;


export type ReserveTestPhoneNumberMutation = { __typename?: 'Mutation', reserveTestPhoneNumber: { __typename?: 'ReserveTestPhoneNumberPayload', phoneNumber: string, expiresAt: any, success: boolean, wasExistingNumberAvailable: boolean, aiPhoneNumber: { __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, teamId: string, organizationId: string } } };

export type CreateBraintrustDatasetMutationVariables = Exact<{
  input: CreateBraintrustDatasetInput;
}>;


export type CreateBraintrustDatasetMutation = { __typename?: 'Mutation', createBraintrustDataset: { __typename?: 'CreateBraintrustDatasetResult', success: boolean, datasetId?: string | null, error?: string | null } };

export type SaveConversationSnapshotToDatasetMutationVariables = Exact<{
  input: SaveConversationSnapshotToDatasetInput;
}>;


export type SaveConversationSnapshotToDatasetMutation = { __typename?: 'Mutation', saveConversationSnapshotToDataset: { __typename?: 'SaveConversationSnapshotToDatasetResult', success: boolean, error?: string | null } };

export type ContactCarrierToCollectLoadBidMutationVariables = Exact<{
  input: ContactCarrierToCollectLoadBidInput;
}>;


export type ContactCarrierToCollectLoadBidMutation = { __typename?: 'Mutation', contactCarrierToCollectLoadBid: { __typename?: 'ContactCarrierToCollectLoadBidPayload', actionExecutionId: string } };

export type CreateCarrierByIdentifierMutationVariables = Exact<{
  input: CreateCarrierByIdentifierInput;
}>;


export type CreateCarrierByIdentifierMutation = { __typename?: 'Mutation', createCarrierByIdentifier: { __typename?: 'CreateCarrierByIdentifierPayload', carrier: { __typename?: 'Carrier', id: string, name: string, mcNumber?: string | null, dotNumber: string } } };

export type SimulateCarrierVerificationMutationVariables = Exact<{
  input: SimulateCarrierVerificationInput;
}>;


export type SimulateCarrierVerificationMutation = { __typename?: 'Mutation', simulateCarrierVerification: { __typename?: 'SimulateCarrierVerificationPayload', success: boolean, error?: string | null, totalCount: number, passCount: number, matchCount: number, results: Array<{ __typename?: 'CarrierVerificationSimulationResultType', mcNumber?: string | null, dotNumber?: string | null, aggregatedResult: CarrierVerificationSimulationResult, carrierName: string, aggregationMode: CarrierVerificationAggregationMode, availableIntegrations: Array<CarrierVerificationIntegrationType>, summary: string, matchesExpected: boolean, expectedResult?: CarrierVerificationSimulationResult | null, individualResults: Array<{ __typename?: 'IndividualVerificationResultType', integrationType: CarrierVerificationIntegrationType, result: CarrierVerificationSimulationResult, carrierName: string, matchedFailConditions: Array<string>, matchedRiskConditions: Array<string>, error?: string | null, parsedData?: any | null, rawData?: any | null }> }> } };

export type SetClassificationLockDurationSecondsMutationVariables = Exact<{
  seconds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetClassificationLockDurationSecondsMutation = { __typename?: 'Mutation', setClassificationLockDurationSeconds: boolean };

export type ConnectWorkerComposioAccountMutationVariables = Exact<{
  input: ConnectWorkerComposioAccountInput;
}>;


export type ConnectWorkerComposioAccountMutation = { __typename?: 'Mutation', connectWorkerComposioAccount?: string | null };

export type DisconnectWorkerComposioMutationVariables = Exact<{
  input: WorkerComposioConnectionInput;
}>;


export type DisconnectWorkerComposioMutation = { __typename?: 'Mutation', disconnectWorkerComposio: boolean };

export type RefreshWorkerComposioAccountMutationVariables = Exact<{
  input: WorkerComposioConnectionInput;
}>;


export type RefreshWorkerComposioAccountMutation = { __typename?: 'Mutation', refreshWorkerComposioAccount: string };

export type CreateRatingMutationVariables = Exact<{
  input: CreateRatingInput;
}>;


export type CreateRatingMutation = { __typename?: 'Mutation', createRating: { __typename?: 'CreateRatingPayload', success: boolean } };

export type MarkConversationReadMutationVariables = Exact<{
  input: MarkConversationReadInput;
}>;


export type MarkConversationReadMutation = { __typename?: 'Mutation', markConversationRead: { __typename?: 'MarkConversationReadPayload', success: boolean } };

export type RequestConversationCcMutationVariables = Exact<{
  input: RequestConversationCcInput;
}>;


export type RequestConversationCcMutation = { __typename?: 'Mutation', requestConversationCc: { __typename?: 'RequestConversationCcPayload', success: boolean, alreadyRequested: boolean, conversation: { __typename?: 'Conversation', id: string, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata' } | { __typename?: 'SMSConversationMetadata' } | null } } };

export type TerminateConversationCallMutationVariables = Exact<{
  input: TerminateConversationCallInput;
}>;


export type TerminateConversationCallMutation = { __typename?: 'Mutation', terminateConversationCall: { __typename?: 'TerminateConversationCallPayload', success: boolean } };

export type CreateCoveragePlanFromCarrierContactListMutationVariables = Exact<{
  input: CreateCoveragePlanFromCarrierContactListInput;
}>;


export type CreateCoveragePlanFromCarrierContactListMutation = { __typename?: 'Mutation', createCoveragePlanFromCarrierContactList: { __typename?: 'CoveragePlanPayload', success: boolean, coveragePlan: { __typename?: 'CoveragePlan', id: string } } };

export type AuditDatAutopostsMutationVariables = Exact<{
  input: AuditDatAutopostsInput;
}>;


export type AuditDatAutopostsMutation = { __typename?: 'Mutation', auditDATAutoposts: { __typename?: 'AuditDATAutopostsPayload', success: boolean, configured: boolean, mcLeodCandidatesChecked: number, ingestedCount: number, postedCount: number, unpostedCount: number, postFailures: number, unpostFailures: number, activeMappingsChecked: number, skippedCount: number, error?: string | null } };

export type AuditDatShipmentPostingsMutationVariables = Exact<{
  input: AuditDatShipmentPostingsInput;
}>;


export type AuditDatShipmentPostingsMutation = { __typename?: 'Mutation', auditDATShipmentPostings: { __typename?: 'AuditDATShipmentPostingsPayload', success: boolean, totalChecked: number, correctedCount: number, stillPostedCount: number, inconclusiveCount: number, skippedCount: number, error?: string | null } };

export type CreateBlankRichTextDocumentUploadMutationVariables = Exact<{
  input: CreateBlankRichTextDocumentUploadInput;
}>;


export type CreateBlankRichTextDocumentUploadMutation = { __typename?: 'Mutation', createBlankRichTextDocumentUpload: { __typename?: 'CreateBlankRichTextDocumentUploadPayload', success: boolean } };

export type UpdateBlankRichTextDocumentUploadMetadataMutationVariables = Exact<{
  input: UpdateBlankRichTextDocumentUploadMetadataInput;
}>;


export type UpdateBlankRichTextDocumentUploadMetadataMutation = { __typename?: 'Mutation', updateRichTextDocumentUploadMetadata: { __typename?: 'CreateBlankRichTextDocumentUploadPayload', success: boolean } };

export type UpdateErrorGroupMutationVariables = Exact<{
  input: UpdateErrorGroupInput;
}>;


export type UpdateErrorGroupMutation = { __typename?: 'Mutation', updateErrorGroup: { __typename?: 'ErrorGroup', id: string, source: ErrorIncidentSource, title: string, status: ErrorGroupStatus, lastOccurrenceCount: number, firstSeenAt: any, lastSeenAt: any, suppressionThreshold?: number | null, linearTicketId?: string | null, githubPrUrl?: string | null, notes?: string | null, createdAt: any, updatedAt?: any | null, topOrganizations: Array<{ __typename?: 'ErrorGroupOrganizationCount', organizationId?: string | null, organizationName?: string | null, count: number }> } };

export type DismissConversationExceptionsMutationVariables = Exact<{
  input: DismissConversationExceptionsInput;
}>;


export type DismissConversationExceptionsMutation = { __typename?: 'Mutation', dismissConversationExceptions: boolean };

export type ResolveSkillChangeRequestMutationVariables = Exact<{
  exceptionId: Scalars['ID']['input'];
  outcome: SkillChangeApprovalOutcome;
  rationale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveSkillChangeRequestMutation = { __typename?: 'Mutation', resolveSkillChangeRequest: boolean };

export type ResolveTrackSettingsChangeRequestMutationVariables = Exact<{
  exceptionId: Scalars['ID']['input'];
  outcome: SkillChangeApprovalOutcome;
}>;


export type ResolveTrackSettingsChangeRequestMutation = { __typename?: 'Mutation', resolveTrackSettingsChangeRequest: boolean };

export type RunSkillChangeTestsMutationVariables = Exact<{
  exceptionId: Scalars['ID']['input'];
}>;


export type RunSkillChangeTestsMutation = { __typename?: 'Mutation', runSkillChangeTests: boolean };

export type CreateExceptionMutationVariables = Exact<{
  input: CreateExceptionInput;
}>;


export type CreateExceptionMutation = { __typename?: 'Mutation', createException: { __typename?: 'Exception', type: ExceptionType, status: ExceptionStatus } };

export type RunCoverEvalsMutationVariables = Exact<{ [key: string]: never; }>;


export type RunCoverEvalsMutation = { __typename?: 'Mutation', runCoverEvals: { __typename?: 'RunCoverEvalsResult', success: boolean, datasetsRun: number, message?: string | null, error?: string | null, results?: Array<{ __typename?: 'CoverEvalDatasetResult', datasetName: string, score?: number | null, experimentUrl?: string | null, scorerRegressions?: number | null, errorRegressions?: number | null, error?: string | null }> | null } };

export type CreateMemoryMutationVariables = Exact<{
  input: CreateMemoryInput;
}>;


export type CreateMemoryMutation = { __typename?: 'Mutation', createMemory: { __typename?: 'CreateMemoryPayload', success: boolean, errors?: Array<CreateMemoryFailureReason> | null, memory?: { __typename?: 'Memory', id: string, createdAt: any, computationType?: SavedComputationType | null, comment?: string | null, organization: { __typename?: 'Organization', id: string }, labeledComputation?: { __typename?: 'LabeledComputation', id: string, savedComputation: { __typename?: 'SavedComputation', id: string, originatorId?: string | null, jobId?: string | null } } | null, entityLinks?: Array<{ __typename?: 'MemoryEntityLink', id: string, actionDefinitionId?: string | null, organizationId?: string | null, teamId?: string | null, userId?: string | null, originatorId?: string | null, carrierId?: string | null, contactId?: string | null, placeId?: string | null, quoteId?: string | null, orderId?: string | null, shipmentId?: string | null, movementId?: string | null }> | null } | null } };

export type DeleteExternalChannelMutationVariables = Exact<{
  input: DeleteExternalChannelInput;
}>;


export type DeleteExternalChannelMutation = { __typename?: 'Mutation', deleteExternalChannel: { __typename?: 'DeleteExternalChannelPayload', success: boolean } };

export type UpdateExternalChannelMutationVariables = Exact<{
  input: UpdateExternalChannelInput;
}>;


export type UpdateExternalChannelMutation = { __typename?: 'Mutation', updateExternalChannel: { __typename?: 'UpdateExternalChannelPayload', success: boolean, externalChannel: { __typename?: 'ExternalChannel', id: string, createdAt: any, organizationId: string, teamId?: string | null, userId?: string | null, channelType: ExternalChannelType, externalIdentifier: string } } };

export type CreateOrUpdateExternalIdMappingMutationVariables = Exact<{
  input: CreateOrUpdateExternalIdMappingInput;
}>;


export type CreateOrUpdateExternalIdMappingMutation = { __typename?: 'Mutation', createOrUpdateExternalIdMapping: { __typename?: 'CreateOrUpdateExternalIdMappingPayload', success: boolean } };

export type EnsureOutlookExternalMessageMutationVariables = Exact<{
  input: EnsureOutlookExternalMessageInput;
}>;


export type EnsureOutlookExternalMessageMutation = { __typename?: 'Mutation', ensureOutlookExternalMessage: string };

export type DisableTmsIntegrationVerificationMutationVariables = Exact<{
  input: DisableTmsIntegrationVerificationInput;
}>;


export type DisableTmsIntegrationVerificationMutation = { __typename?: 'Mutation', disableTMSIntegrationVerification: boolean };

export type EnableTmsIntegrationVerificationMutationVariables = Exact<{
  input: EnableTmsIntegrationVerificationInput;
}>;


export type EnableTmsIntegrationVerificationMutation = { __typename?: 'Mutation', enableTMSIntegrationVerification: { __typename?: 'EnableTMSIntegrationVerificationPayload', success: boolean, schedule: CanarySchedule } };

export type VerifyCarrierIntegrationMutationVariables = Exact<{
  input: VerifyCarrierIntegrationInput;
}>;


export type VerifyCarrierIntegrationMutation = { __typename?: 'Mutation', verifyCarrierIntegration: { __typename?: 'VerifyCarrierIntegrationPayload', success: boolean, error?: string | null } };

export type VerifyTmsIntegrationMutationVariables = Exact<{
  input: VerifyTmsIntegrationInput;
}>;


export type VerifyTmsIntegrationMutation = { __typename?: 'Mutation', verifyTMSIntegration: { __typename?: 'VerifyTMSIntegrationPayload', success: boolean, error?: string | null } };

export type CreateJobFromOutlookMutationVariables = Exact<{
  input: CreateOutlookJobInput;
}>;


export type CreateJobFromOutlookMutation = { __typename?: 'Mutation', createOutlookJob: { __typename?: 'CreateJobPayload', success: boolean, job: { __typename?: 'Job', id: string, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, source: JobSource, optimismStatus: OptimismStatus, user?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, orders: Array<{ __typename?: 'Order', id: string, hasSubmittedEvent: boolean, primaryReference?: string | null, extractedData?: string | null, createdAt: any, createdAtDisplay?: any | null, externalDeepLink?: string | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', id: string, name: string } | null, job: { __typename?: 'Job', emailMetadata?: any | null }, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }> }>, quotes: Array<{ __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null }>, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }> } } };

export type DeleteJobMutationVariables = Exact<{
  input: DeleteJobInput;
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'DeleteJobPayload', success: boolean } };

export type ReprocessJobMutationVariables = Exact<{
  input: ReprocessJobInput;
}>;


export type ReprocessJobMutation = { __typename?: 'Mutation', reprocessJob: { __typename?: 'ReprocessJobPayload', success: boolean } };

export type SimulateQuoteJobReplyMutationVariables = Exact<{
  input: SimulateQuoteJobReplyInput;
}>;


export type SimulateQuoteJobReplyMutation = { __typename?: 'Mutation', simulateQuoteJobReply: { __typename?: 'SimulateQuoteJobReplyPayload', success: boolean, steps: Array<{ __typename?: 'SimulationStepType', id: string, kind: string, title: string, detail?: string | null, status: SimulationStepStatus, occurredAt: any, metadata?: any | null }> } };

export type TriggerQuoteAgentForJobMutationVariables = Exact<{
  input: TriggerQuoteAgentForJobInput;
}>;


export type TriggerQuoteAgentForJobMutation = { __typename?: 'Mutation', triggerQuoteAgentForJob: { __typename?: 'TriggerQuoteAgentForJobPayload', success: boolean, actionExecutionId?: string | null } };

export type CreateBlankDocumentInKnowledgeBaseMutationVariables = Exact<{
  input: CreateBlankDocumentInKnowledgeBaseInput;
}>;


export type CreateBlankDocumentInKnowledgeBaseMutation = { __typename?: 'Mutation', createBlankDocumentInKnowledgeBase: { __typename?: 'CreateBlankDocumentInKnowledgeBasePayload', knowledgeBaseDocumentUpload: { __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string } } };

export type CreateCustomerDocumentsInKnowledgeBaseMutationVariables = Exact<{
  input: CreateCustomerDocumentsInKnowledgeBaseInput;
}>;


export type CreateCustomerDocumentsInKnowledgeBaseMutation = { __typename?: 'Mutation', createCustomerDocumentsInKnowledgeBase: { __typename?: 'CreateCustomerDocumentsInKnowledgeBasePayload', success: boolean, knowledgeBaseDocumentUploads: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> } };

export type CreateKnowledgeBaseMutationVariables = Exact<{
  input: CreateKnowledgeBaseInput;
}>;


export type CreateKnowledgeBaseMutation = { __typename?: 'Mutation', createKnowledgeBase: { __typename?: 'CreateKnowledgeBasePayload', knowledgeBase: { __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> } } };

export type DeleteKnowledgeBaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKnowledgeBaseMutation = { __typename?: 'Mutation', deleteKnowledgeBaseById: { __typename?: 'DeleteKnowledgeBasePayload', success: boolean } };

export type DeleteKnowledgeBaseDocumentMutationVariables = Exact<{
  input: DeleteDocumentInKnowledgeBaseInput;
}>;


export type DeleteKnowledgeBaseDocumentMutation = { __typename?: 'Mutation', deleteDocumentInKnowledgeBase: { __typename?: 'DeleteDocumentInKnowledgeBasePayload', success: boolean } };

export type RenameKnowledgeBaseMutationVariables = Exact<{
  input: RenameKnowledgeBaseInput;
}>;


export type RenameKnowledgeBaseMutation = { __typename?: 'Mutation', renameKnowledgeBase: { __typename?: 'RenameKnowledgeBasePayload', success: boolean } };

export type RenameKnowledgeBaseDocumentMutationVariables = Exact<{
  input: RenameDocumentInKnowledgeBaseInput;
}>;


export type RenameKnowledgeBaseDocumentMutation = { __typename?: 'Mutation', renameDocumentInKnowledgeBase: { __typename?: 'RenameDocumentInKnowledgeBasePayload', success: boolean } };

export type UpdateFileContentMutationVariables = Exact<{
  input: UpdateFileContentInput;
  file: Scalars['Upload']['input'];
}>;


export type UpdateFileContentMutation = { __typename?: 'Mutation', updateFileContent: { __typename?: 'UpdateFileContentPayload', success: boolean } };

export type CreateManagedResourceMutationVariables = Exact<{
  input: CreateManagedResourceInput;
}>;


export type CreateManagedResourceMutation = { __typename?: 'Mutation', createManagedResource: { __typename?: 'ManagedResourcePayload', managedResource: { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus, fallbackResource?: { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus } | null } } };

export type DeleteManagedResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteManagedResourceMutation = { __typename?: 'Mutation', deleteManagedResource: { __typename?: 'DeleteManagedResourcePayload', success: boolean } };

export type RunManagedResourceCanaryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RunManagedResourceCanaryMutation = { __typename?: 'Mutation', runManagedResourceCanary: { __typename?: 'RunManagedResourceCanaryPayload', overallStatus: string, durationMs: number, failureReason?: string | null } };

export type UpdateManagedResourceMutationVariables = Exact<{
  input: UpdateManagedResourceInput;
}>;


export type UpdateManagedResourceMutation = { __typename?: 'Mutation', updateManagedResource: { __typename?: 'ManagedResourcePayload', managedResource: { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus, fallbackResource?: { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus } | null } } };

export type RateMessageMutationVariables = Exact<{
  input: RateMessageInput;
}>;


export type RateMessageMutation = { __typename?: 'Mutation', rateMessage: { __typename?: 'MessageRatingPayload', rating: { __typename?: 'MessageRating', id: string, messageId: string, isPositive: boolean, reason?: MessageRatingReason | null, comments?: string | null } } };

export type RemoveMessageRatingMutationVariables = Exact<{
  input: RemoveMessageRatingInput;
}>;


export type RemoveMessageRatingMutation = { __typename?: 'Mutation', removeMessageRating: { __typename?: 'RemoveMessageRatingPayload', success: boolean } };

export type SaveMessageRatingDetailsMutationVariables = Exact<{
  input: SaveMessageRatingDetailsInput;
}>;


export type SaveMessageRatingDetailsMutation = { __typename?: 'Mutation', saveMessageRatingDetails: { __typename?: 'MessageRatingPayload', rating: { __typename?: 'MessageRating', id: string, messageId: string, isPositive: boolean, reason?: MessageRatingReason | null, comments?: string | null } } };

export type CompleteMicrosoftGraphConnectMutationVariables = Exact<{
  state: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompleteMicrosoftGraphConnectMutation = { __typename?: 'Mutation', completeMicrosoftGraphConnect: { __typename?: 'CompleteMicrosoftGraphConnectPayload', success: boolean, error?: string | null } };

export type StartMicrosoftGraphConnectMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type StartMicrosoftGraphConnectMutation = { __typename?: 'Mutation', startMicrosoftGraphConnect: { __typename?: 'StartMicrosoftGraphConnectPayload', authorizeUrl: string } };

export type ComputeLaneRatesMutationVariables = Exact<{
  input: ComputeLaneRatesInput;
}>;


export type ComputeLaneRatesMutation = { __typename?: 'Mutation', computeLaneRates: { __typename?: 'ComputeLaneRatesPayload', success: boolean, rates: Array<{ __typename?: 'LaneRateResult', provider: LaneRatingProvider, minRate?: number | null, maxRate?: number | null, midpointRate?: number | null, confidence?: number | null, reportCount?: number | null, error?: string | null }> } };

export type CreateFakeTrackingMilestonesMutationVariables = Exact<{
  input: CreateFakeTrackingMilestonesInput;
}>;


export type CreateFakeTrackingMilestonesMutation = { __typename?: 'Mutation', createFakeTrackingMilestones: { __typename?: 'CreateFakeTrackingMilestonesPayload', success: boolean, count: number } };

export type CreateTrackingExceptionEventMutationVariables = Exact<{
  input: CreateTrackingExceptionEventInput;
}>;


export type CreateTrackingExceptionEventMutation = { __typename?: 'Mutation', createTrackingExceptionEvent: { __typename?: 'CreateTrackingExceptionEventPayload', success: boolean } };

export type CreateTrackingMilestoneEventMutationVariables = Exact<{
  input: CreateTrackingMilestoneEventInput;
}>;


export type CreateTrackingMilestoneEventMutation = { __typename?: 'Mutation', createTrackingMilestoneEvent: { __typename?: 'CreateTrackingMilestoneEventPayload', success: boolean, event?: { __typename?: 'MovementEvent', id: string, createdAt: any } | null } };

export type SetMovementTrackingPausedMutationVariables = Exact<{
  input: SetMovementTrackingPausedInput;
}>;


export type SetMovementTrackingPausedMutation = { __typename?: 'Mutation', setMovementTrackingPaused: { __typename?: 'UpdateMovementPayload', success: boolean, movement: { __typename?: 'Movement', id: string, trackData?: any | null } } };

export type StartTrackSopTestMutationVariables = Exact<{
  input: StartTrackSopTestInput;
}>;


export type StartTrackSopTestMutation = { __typename?: 'Mutation', startTrackSopTest: { __typename?: 'StartTrackSopTestPayload', movementId: string, shipmentId: string, referenceNumber: string, actionExecutionId?: string | null } };

export type UpdateMovementMutationVariables = Exact<{
  input: UpdateMovementInput;
}>;


export type UpdateMovementMutation = { __typename?: 'Mutation', updateMovement: { __typename?: 'UpdateMovementPayload', success: boolean, movement: { __typename?: 'Movement', id: string, negotiationStrategyConfigOverride?: any | null } } };

export type SimulateNegotiationMutationVariables = Exact<{
  input: SimulateNegotiationInput;
}>;


export type SimulateNegotiationMutation = { __typename?: 'Mutation', simulateNegotiation: { __typename?: 'SimulateNegotiationResult', success: boolean, error?: string | null, recommendedAction?: string | null, variantStrategyId?: string | null, variantStrategyName?: string | null, handlerActionExecutionId?: string | null, strategyUsed?: { __typename?: 'StrategyUsedType', id: string, name: string, type: string } | null, needsClarification?: { __typename?: 'ClarificationRequestType', field: string, message: string, acceptableValues?: Array<string> | null } | null, triggerException?: { __typename?: 'ExceptionTriggerType', voomaBestOffer: number, carrierBestOffer: number, timeoutSeconds?: number | null } | null } };

export type DeleteOrderMutationVariables = Exact<{
  input: DeleteOrderInput;
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: { __typename?: 'DeleteOrderPayload', success: boolean } };

export type RepeatOrderMutationVariables = Exact<{
  input: RepeatOrderInput;
}>;


export type RepeatOrderMutation = { __typename?: 'Mutation', repeatOrder: { __typename?: 'RepeatOrderPayload', success: boolean } };

export type ReplicateOrderMutationVariables = Exact<{
  input: ReplicateOrderInput;
}>;


export type ReplicateOrderMutation = { __typename?: 'Mutation', replicateOrder: { __typename?: 'ReplicateOrderPayload', success: boolean } };

export type SubmitOrderMutationVariables = Exact<{
  input: SubmitOrderInput;
}>;


export type SubmitOrderMutation = { __typename?: 'Mutation', submitOrder: { __typename?: 'SubmitOrderPayload', success: boolean, errors?: Array<SubmitOrderError> | null, order: { __typename?: 'Order', externalDeepLink?: string | null } } };

export type SubmitSubjectOrderMutationVariables = Exact<{
  input: SubmitSubjectOrderInput;
}>;


export type SubmitSubjectOrderMutation = { __typename?: 'Mutation', submitSubjectOrder: { __typename?: 'SubmitSubjectOrderPayload', success: boolean, externalOrderId?: string | null, error?: string | null } };

export type UpdateOrderMutationVariables = Exact<{
  input: UpdateOrderInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'UpdateOrderPayload', success: boolean, errors?: Array<OrderUpdateFailureReason> | null, order: { __typename?: 'Order', id: string, createdAt: any, updatedAt?: any | null, transmitId?: string | null, primaryReference?: string | null, hasSubmittedEvent: boolean, extractedData?: string | null, externalDeepLink?: string | null, externalId?: string | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> }, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }>, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }>, organization: { __typename?: 'Organization', id: string, integrationConfigs?: any | null }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, shipmentAssociations?: Array<{ __typename?: 'OrderShipmentAssociation', shipment: { __typename?: 'Shipment', id: string } }> | null } } };

export type ConfigureOrderTemplateMutationVariables = Exact<{
  input: ConfigureOrderTemplateInput;
}>;


export type ConfigureOrderTemplateMutation = { __typename?: 'Mutation', configureOrderTemplate: { __typename?: 'ConfigureOrderTemplatePayload', template: { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } } };

export type InitializeOrderTemplateMutationVariables = Exact<{
  input: InitializeOrderTemplateForOriginatorInput;
}>;


export type InitializeOrderTemplateMutation = { __typename?: 'Mutation', initializeOrderTemplateForOriginator: { __typename?: 'InitializeOrderTemplateForOriginatorPayload', template: { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } } };

export type PokeActionExecutionMutationVariables = Exact<{
  input: PokeActionExecutionInput;
}>;


export type PokeActionExecutionMutation = { __typename?: 'Mutation', pokeActionExecution: { __typename?: 'PokeActionExecutionPayload', success: boolean } };

export type ProvisionFakeTrackMovementMutationVariables = Exact<{
  input: CreateFakeTrackMovementInput;
}>;


export type ProvisionFakeTrackMovementMutation = { __typename?: 'Mutation', provisionFakeTrackMovement: { __typename?: 'CreateFakeTrackMovementPayload', success: boolean, shipmentId?: string | null } };

export type ProvisionBrowserUseDemoMutationVariables = Exact<{
  input: ProvisionBrowserUseDemoInput;
}>;


export type ProvisionBrowserUseDemoMutation = { __typename?: 'Mutation', provisionBrowserUseDemo: { __typename?: 'ProvisionBrowserUseDemoPayload', organizationId: string, actionDefinitionId: string } };

export type ProvisionConciergeSopMutationVariables = Exact<{
  input: ProvisionConciergeSopInput;
}>;


export type ProvisionConciergeSopMutation = { __typename?: 'Mutation', provisionConciergeSOP: { __typename?: 'ProvisionConciergeSOPPayload', organizationId: string, success: boolean } };

export type ProvisionCoverForTeamMutationVariables = Exact<{
  input: ProvisionCoverForTeamInput;
}>;


export type ProvisionCoverForTeamMutation = { __typename?: 'Mutation', provisionCoverForTeam: { __typename?: 'ProvisionCoverForTeamPayload', teamId: string, phoneNumber?: string | null } };

export type ProvisionCoverSimulationsMutationVariables = Exact<{
  input: ProvisionCoverSimulationsInput;
}>;


export type ProvisionCoverSimulationsMutation = { __typename?: 'Mutation', provisionCoverSimulations: { __typename?: 'ProvisionCoverSimulationsPayload', success: boolean } };

export type ProvisionInterviewMutationVariables = Exact<{
  input: ProvisionInterviewInput;
}>;


export type ProvisionInterviewMutation = { __typename?: 'Mutation', provisionInterview: { __typename?: 'ProvisionInterviewPayload', organizationId: string, actionDefinitionId: string } };

export type ProvisionLabelingConciergeMutationVariables = Exact<{
  input: ProvisionLabelingConciergeInput;
}>;


export type ProvisionLabelingConciergeMutation = { __typename?: 'Mutation', provisionLabelingConcierge: { __typename?: 'ProvisionLabelingConciergePayload', organizationId: string, success: boolean } };

export type ProvisionQuoteForOrgMutationVariables = Exact<{
  input: ProvisionQuoteForOrgInput;
}>;


export type ProvisionQuoteForOrgMutation = { __typename?: 'Mutation', provisionQuoteForOrg: { __typename?: 'ProvisionQuoteForOrgPayload', organizationId: string } };

export type ProvisionQuoteForTeamMutationVariables = Exact<{
  input: ProvisionQuoteForTeamInput;
}>;


export type ProvisionQuoteForTeamMutation = { __typename?: 'Mutation', provisionQuoteForTeam: { __typename?: 'ProvisionQuoteForTeamPayload', teamId: string, actionDefinitionId: string } };

export type ProvisionQuoteOriginatorsMutationVariables = Exact<{
  input: ProvisionQuoteOriginatorsInput;
}>;


export type ProvisionQuoteOriginatorsMutation = { __typename?: 'Mutation', provisionQuoteOriginators: { __typename?: 'ProvisionQuoteOriginatorsPayload', success: boolean } };

export type ProvisionQuoteSimulationsMutationVariables = Exact<{
  input: ProvisionQuoteSimulationsInput;
}>;


export type ProvisionQuoteSimulationsMutation = { __typename?: 'Mutation', provisionQuoteSimulations: { __typename?: 'ProvisionQuoteSimulationsPayload', success: boolean } };

export type ProvisionRunnersMutationVariables = Exact<{
  input: ProvisionRunnersInput;
}>;


export type ProvisionRunnersMutation = { __typename?: 'Mutation', provisionRunners: { __typename?: 'ProvisionRunnersPayload', created: Array<{ __typename?: 'ProvisionedRunner', id: string, name: string, isDeleted: boolean }>, existing: Array<{ __typename?: 'ProvisionedRunner', id: string, name: string, isDeleted: boolean }> } };

export type ProvisionScheduleMutationVariables = Exact<{
  input: ProvisionScheduleInput;
}>;


export type ProvisionScheduleMutation = { __typename?: 'Mutation', provisionSchedule: { __typename?: 'ProvisionSchedulePayload', success: boolean } };

export type ProvisionTrackMutationVariables = Exact<{
  input: ProvisionTrackInput;
}>;


export type ProvisionTrackMutation = { __typename?: 'Mutation', provisionTrack: { __typename?: 'ProvisionTrackPayload', success: boolean, phoneNumber?: string | null } };

export type ProvisionVeeMutationVariables = Exact<{
  input: ProvisionVeeInput;
}>;


export type ProvisionVeeMutation = { __typename?: 'Mutation', provisionVee: { __typename?: 'ProvisionVeePayload', organizationId: string, actionDefinitionId: string } };

export type ProvisionVoomaBuildAgentMutationVariables = Exact<{
  input: ProvisionVoomaBuildAgentInput;
}>;


export type ProvisionVoomaBuildAgentMutation = { __typename?: 'Mutation', provisionVoomaBuildAgent: { __typename?: 'ProvisionVoomaBuildAgentPayload', success: boolean } };

export type SeedCoverDemoDataMutationVariables = Exact<{
  input: SeedCoverDemoDataInput;
}>;


export type SeedCoverDemoDataMutation = { __typename?: 'Mutation', seedCoverDemoData: { __typename?: 'SeedCoverDemoDataPayload', success: boolean, shipmentsCreated: number, shipmentsUpdated: number, carrierOffersSeeded: number, coveragePlansSeeded: number, actionExecutionsSeeded: number } };

export type SeedVeeDemoDataMutationVariables = Exact<{
  input: SeedVeeDemoDataInput;
}>;


export type SeedVeeDemoDataMutation = { __typename?: 'Mutation', seedVeeDemoData: { __typename?: 'SeedVeeDemoDataPayload', success: boolean } };

export type FindDuplicateMutationVariables = Exact<{
  input: FindDuplicateInput;
}>;


export type FindDuplicateMutation = { __typename?: 'Mutation', findDuplicate: { __typename?: 'FindDuplicatePayload', success: boolean, canonicalId?: string | null } };

export type CreateScheduleSettingsMutationVariables = Exact<{
  input: CreateScheduleSettingsInput;
}>;


export type CreateScheduleSettingsMutation = { __typename?: 'Mutation', createScheduleSettings: { __typename?: 'ScheduleSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, plannerActionDefinitionId?: string | null, createdAt: any, updatedAt?: any | null, planningSettings: { __typename: 'AgenticPlannerSettings', type: PlanningApproach } | { __typename: 'DeterministicPlanningSettings', type: PlanningApproach, sequencing: PlanningSequence } } };

export type DeleteScheduleSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScheduleSettingsMutation = { __typename?: 'Mutation', deleteScheduleSettings: boolean };

export type UpdateScheduleSettingsMutationVariables = Exact<{
  input: UpdateScheduleSettingsInput;
}>;


export type UpdateScheduleSettingsMutation = { __typename?: 'Mutation', updateScheduleSettings: { __typename?: 'ScheduleSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, plannerActionDefinitionId?: string | null, createdAt: any, updatedAt?: any | null, planningSettings: { __typename: 'AgenticPlannerSettings', type: PlanningApproach } | { __typename: 'DeterministicPlanningSettings', type: PlanningApproach, sequencing: PlanningSequence } } };

export type ApproveSchedulePlanMutationVariables = Exact<{
  schedulePlanId: Scalars['ID']['input'];
}>;


export type ApproveSchedulePlanMutation = { __typename?: 'Mutation', approveSchedulePlan: { __typename?: 'SchedulePlan', id: string, status: SchedulePlanStatus } };

export type CancelSchedulePlanMutationVariables = Exact<{
  schedulePlanId: Scalars['ID']['input'];
}>;


export type CancelSchedulePlanMutation = { __typename?: 'Mutation', cancelSchedulePlan: { __typename?: 'SchedulePlan', id: string, status: SchedulePlanStatus } };

export type GenerateSchedulePlanMutationVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GenerateSchedulePlanMutation = { __typename?: 'Mutation', generateSchedulePlan: { __typename?: 'SchedulePlan', id: string, status: SchedulePlanStatus, plan: any, planningActionExecution?: { __typename?: 'ActionExecution', id: string, status: ActionExecutionStatus } | null } };

export type SendTestNotificationMutationVariables = Exact<{
  input: SendTestNotificationInput;
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification: boolean };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  input: UpdateNotificationSettingsInput;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateNotificationSettings: { __typename?: 'UpdateNotificationSettingsPayload', success: boolean } };

export type CreateSharedFileMutationVariables = Exact<{
  input: CreateSharedFileInput;
}>;


export type CreateSharedFileMutation = { __typename?: 'Mutation', createSharedFile: { __typename?: 'CreateSharedFilePayload', success: boolean, message: string, sharedFile: { __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null } } };

export type DeleteSharedFileMutationVariables = Exact<{
  input: DeleteSharedFileInput;
}>;


export type DeleteSharedFileMutation = { __typename?: 'Mutation', deleteSharedFile: { __typename?: 'DeleteSharedFilePayload', success: boolean, message: string, sharedFile: { __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null } } };

export type RenameSharedFileMutationVariables = Exact<{
  input: RenameSharedFileInput;
}>;


export type RenameSharedFileMutation = { __typename?: 'Mutation', renameSharedFile: { __typename?: 'RenameSharedFilePayload', success: boolean, message: string, sharedFile: { __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null } } };

export type UpdateSharedFileMutationVariables = Exact<{
  input: UpdateSharedFileInput;
}>;


export type UpdateSharedFileMutation = { __typename?: 'Mutation', updateSharedFile: { __typename?: 'UpdateSharedFilePayload', success: boolean, message: string, sharedFile: { __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null } } };

export type GenerateShipmentLifecycleSimShipmentMutationVariables = Exact<{
  input: GenerateShipmentLifecycleSimShipmentInput;
}>;


export type GenerateShipmentLifecycleSimShipmentMutation = { __typename?: 'Mutation', generateShipmentLifecycleSimShipment: { __typename?: 'GenerateShipmentLifecycleSimShipmentPayload', requestQuoteActionExecutionId: string, shipment: any, success: boolean } };

export type BuildShipmentMutationVariables = Exact<{
  input: BuildShipmentInput;
}>;


export type BuildShipmentMutation = { __typename?: 'Mutation', buildShipment: { __typename?: 'BuildShipmentPayload', shipmentId: string } };

export type EnsureShipmentExistsForQuoteMutationVariables = Exact<{
  input: EnsureShipmentExistsForQuoteInput;
}>;


export type EnsureShipmentExistsForQuoteMutation = { __typename?: 'Mutation', ensureShipmentExistsForQuote: { __typename?: 'EnsureShipmentExistsForQuotePayload', shipment: { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> } } };

export type MassDeleteShipmentsAndMovementsMutationVariables = Exact<{
  input: MassDeleteShipmentsAndMovementsInput;
}>;


export type MassDeleteShipmentsAndMovementsMutation = { __typename?: 'Mutation', massDeleteShipmentsAndMovements: { __typename?: 'MassDeleteShipmentsAndMovementsPayload', success: boolean } };

export type MassPostToLoadBoardMutationVariables = Exact<{
  input: MassPostToLoadBoardInput;
}>;


export type MassPostToLoadBoardMutation = { __typename?: 'Mutation', massPostToLoadBoard?: { __typename?: 'MassPostToLoadBoardPayload', results: Array<{ __typename?: 'PostToLoadBoardPayload', success?: boolean | null, error?: string | null, externalIdMapping?: { __typename?: 'ExternalIdMapping', id: string, integrationType: string, externalId: string } | null }> } | null };

export type MassUnpostFromLoadBoardMutationVariables = Exact<{
  input: MassUnpostFromLoadBoardInput;
}>;


export type MassUnpostFromLoadBoardMutation = { __typename?: 'Mutation', massUnpostFromLoadBoard: { __typename?: 'MassUnpostFromLoadBoardPayload', results: Array<{ __typename?: 'UnpostFromLoadBoardPayload', success: boolean }> } };

export type PostToLoadBoardMutationVariables = Exact<{
  input: PostToLoadBoardInput;
}>;


export type PostToLoadBoardMutation = { __typename?: 'Mutation', postToLoadBoard?: { __typename?: 'PostToLoadBoardPayload', externalIdMapping?: { __typename?: 'ExternalIdMapping', id: string, integrationType: string, externalId: string } | null } | null };

export type RefreshPostingOnLoadBoardMutationVariables = Exact<{
  input: RefreshPostingOnLoadBoardInput;
}>;


export type RefreshPostingOnLoadBoardMutation = { __typename?: 'Mutation', refreshPostingOnLoadBoard: { __typename?: 'UnpostFromLoadBoardPayload', success: boolean } };

export type SimulateShipmentLookupMutationVariables = Exact<{
  input: SimulateShipmentLookupInput;
}>;


export type SimulateShipmentLookupMutation = { __typename?: 'Mutation', simulateShipmentLookup: { __typename?: 'SimulateShipmentLookupPayload', success: boolean, error?: string | null, totalCount: number, foundCount: number, results: Array<{ __typename?: 'ShipmentLookupResultType', referenceNumber: string, found: boolean, shipmentId?: string | null, movementId?: string | null, description: string, hasCarrier?: boolean | null, error?: string | null, matchCount: number, stops?: Array<{ __typename?: 'ShipmentStopType', stopType?: string | null, startDateTime?: string | null, endDateTime?: string | null, location: { __typename?: 'ShipmentStopLocationType', city?: string | null, state?: string | null, zip?: string | null, country?: string | null } }> | null, pricingData?: { __typename?: 'ShipmentPricingType', targetPrice?: number | null, maxPrice?: number | null } | null, equipment?: Array<{ __typename?: 'ShipmentEquipmentType', equipmentType?: string | null, length?: number | null }> | null }> } };

export type TriggerShipmentIngestionMutationVariables = Exact<{
  input: TriggerShipmentIngestionInput;
}>;


export type TriggerShipmentIngestionMutation = { __typename?: 'Mutation', triggerShipmentIngestion: { __typename?: 'TriggerShipmentIngestionPayload', success: boolean, error?: string | null } };

export type TriggerTrackingProcedureMutationVariables = Exact<{
  input: TriggerTrackingProcedureInput;
}>;


export type TriggerTrackingProcedureMutation = { __typename?: 'Mutation', triggerTrackingProcedure: { __typename?: 'TriggerTrackingProcedurePayload', success: boolean } };

export type UnpostFromLoadBoardMutationVariables = Exact<{
  input: UnpostFromLoadBoardInput;
}>;


export type UnpostFromLoadBoardMutation = { __typename?: 'Mutation', unpostFromLoadBoard: { __typename?: 'UnpostFromLoadBoardPayload', success: boolean } };

export type UpdateShipmentMutationVariables = Exact<{
  input: BuildShipmentInput;
}>;


export type UpdateShipmentMutation = { __typename?: 'Mutation', updateShipment: { __typename?: 'BuildShipmentPayload', shipmentId: string } };

export type UpdateSimulationBrokerOrganizationMutationVariables = Exact<{
  input: UpdateSimulationBrokerOrganizationInput;
}>;


export type UpdateSimulationBrokerOrganizationMutation = { __typename?: 'Mutation', updateSimulationBrokerOrganization: { __typename?: 'SimulationSettingsPayload', organizationId: string, isSimulationBroker: boolean, enabled: boolean, intervalMinutes: number, carrierInquiryActionDefinitionId?: string | null, carrierInquiryActionDefinitionOrganizationId?: string | null } };

export type UpdateSimulationSettingsMutationVariables = Exact<{
  input: UpdateSimulationSettingsInput;
}>;


export type UpdateSimulationSettingsMutation = { __typename?: 'Mutation', updateSimulationSettings: { __typename?: 'SimulationSettingsPayload', organizationId: string, isSimulationBroker: boolean, enabled: boolean, intervalMinutes: number, carrierInquiryActionDefinitionId?: string | null, carrierInquiryActionDefinitionOrganizationId?: string | null } };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', success: boolean, organization: { __typename?: 'Organization', id: string, settings: { __typename?: 'OrganizationSettings', quoteAutoReply?: any | null } } } };

export type UpdateOriginatorSettingsMutationVariables = Exact<{
  input: UpdateOriginatorInput;
}>;


export type UpdateOriginatorSettingsMutation = { __typename?: 'Mutation', updateOriginator: { __typename?: 'UpdateOriginatorPayload', success: boolean, originator: { __typename?: 'Originator', id: string } } };

export type ContinueTeamsConnectionMutationVariables = Exact<{
  state: Scalars['String']['input'];
  tenant?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContinueTeamsConnectionMutation = { __typename?: 'Mutation', continueTeamsConnection: { __typename?: 'ContinueTeamsConnectionPayload', success: boolean, nextUrl?: string | null, error?: string | null } };

export type SetTeamsTenantIdMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetTeamsTenantIdMutation = { __typename?: 'Mutation', setTeamsTenantId: { __typename?: 'TeamsTenantResultPayload', success: boolean, error?: string | null } };

export type StartTeamsAdminConsentMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type StartTeamsAdminConsentMutation = { __typename?: 'Mutation', startTeamsAdminConsent: { __typename?: 'StartTeamsAdminConsentPayload', authorizeUrl: string } };

export type ExecuteToolMutationVariables = Exact<{
  input: ExecuteToolInput;
}>;


export type ExecuteToolMutation = { __typename?: 'Mutation', executeTool: { __typename?: 'ExecuteToolResult', success: boolean, error?: string | null, toolOutput?: string | null } };

export type CreateTrackSettingsMutationVariables = Exact<{
  input: CreateTrackSettingsInput;
}>;


export type CreateTrackSettingsMutation = { __typename?: 'Mutation', createTrackSettings: { __typename?: 'TrackSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, createdAt: any, updatedAt?: any | null, stopSettings: { __typename?: 'StopSettings', pickup: { __typename?: 'PickupTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'PickupBeforeSettings', trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, suppressIfCarrierChangedWithinMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneBeforeTriggerSettings', triggerType: MilestoneBeforeTrigger, enabled: boolean, params?: { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, beforeConfigs?: Array<{ __typename?: 'PickupBeforeSettings', enabled?: boolean | null, trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, suppressIfCarrierChangedWithinMinutes?: number | null, advanced?: { __typename?: 'AdvancedBeforeTriggerSettings', appointment: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor }, windowTiers: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> } | null }> | null, after?: { __typename?: 'PickupAfterSettings', minutesAfter?: number | null, triggers?: Array<{ __typename?: 'MilestoneAfterTriggerSettings', triggerType: MilestoneAfterTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, at?: { __typename?: 'PickupAtSettings', delayMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneAtTriggerSettings', triggerType: MilestoneAtTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, actualArrival?: { __typename?: 'PickupActualArrivalSettings', enabled?: boolean | null } | null, actualDeparture?: { __typename?: 'PickupActualDepartureSettings', enabled?: boolean | null } | null, preDispatch?: { __typename?: 'PreDispatchSettings', enabled?: boolean | null, minutesBefore?: number | null, triggers?: Array<{ __typename?: 'PreDispatchTriggerSettings', triggerType: PreDispatchTrigger, enabled: boolean, params?: { __typename?: 'PreDispatchTriggerParams', minutesBefore?: number | null, cutoffHour?: number | null, hoursBeforeCutoffForEarlyPickups?: number | null, hoursBeforeCutoffForLatePickups?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null }, stops: { __typename?: 'StopTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null }, delivery: { __typename?: 'DeliveryTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'DeliveryBeforeSettings', trigger?: MilestoneBeforeTrigger | null, triggers?: Array<{ __typename?: 'MilestoneBeforeTriggerSettings', triggerType: MilestoneBeforeTrigger, enabled: boolean, params?: { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, after?: { __typename?: 'DeliveryAfterSettings', minutesAfter?: number | null, triggers?: Array<{ __typename?: 'MilestoneAfterTriggerSettings', triggerType: MilestoneAfterTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, at?: { __typename?: 'DeliveryAtSettings', delayMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneAtTriggerSettings', triggerType: MilestoneAtTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null } }, enRouteSettings: { __typename?: 'EnRouteSettings', cadenceMode?: EnRouteCadenceMode | null, truckSpeedMph?: number | null, dailyDrivingHours?: number | null, trackingTrigger?: TrackingTrigger | null, enRoute: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null }, enRouteWithTracking?: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null } | null, enRouteWithoutTracking?: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null } | null, exceptionEventsSettings?: { __typename?: 'ExceptionEventsSettings', alertWindowMinutes?: number | null, quietPeriodAfterInTransitMinutes?: number | null, stationaryVehicle?: { __typename?: 'StationaryVehicleExceptionSettings', thresholdMinutes: number, suppressionPeriodMinutes?: number | null } | null, runningLate?: { __typename?: 'RunningLateExceptionSettings', enabled: boolean, suppressionPeriodMinutes?: number | null, toleranceMinutes?: number | null } | null, trackingDataNotAvailable?: { __typename?: 'TrackingDataNotAvailableExceptionSettings', enabled: boolean, suppressionPeriodMinutes?: number | null } | null, trackingDataStale?: { __typename?: 'TrackingDataStaleExceptionSettings', enabled: boolean, thresholdMinutes: number, suppressionPeriodMinutes?: number | null } | null, infoMissing?: { __typename?: 'InfoMissingExceptionSettings', enabled: boolean, checks: Array<InfoMissingCheckType>, suppressionPeriodMinutes?: number | null, evaluateAt?: InfoMissingEvaluateAt | null } | null, notYetDispatched?: { __typename?: 'NotYetDispatchedExceptionSettings', enabled: boolean, minutesBeforePickup?: number | null } | null, runningLateCloseToDelivery?: { __typename?: 'RunningLateCloseToDeliveryExceptionSettings', enabled: boolean, minutesBeforeDelivery?: number | null, toleranceMinutes?: number | null } | null, runningLateCloseToPickup?: { __typename?: 'RunningLateCloseToPickupExceptionSettings', enabled: boolean, minutesBeforePickup?: number | null, toleranceMinutes?: number | null } | null } | null }, nightHoursSettings?: { __typename?: 'NightHoursSettings', startHour?: number | null, endHour?: number | null, windowMinutes?: number | null, skipAllMilestones?: boolean | null } | null } };

export type DeleteTrackSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTrackSettingsMutation = { __typename?: 'Mutation', deleteTrackSettings: boolean };

export type SetDefaultTrackSettingsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isDefault: Scalars['Boolean']['input'];
}>;


export type SetDefaultTrackSettingsMutation = { __typename?: 'Mutation', setDefaultTrackSettings: { __typename?: 'TrackSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, isDefault: boolean } };

export type SetValhallaComparisonEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type SetValhallaComparisonEnabledMutation = { __typename?: 'Mutation', setValhallaComparisonEnabled: boolean };

export type UpdateTrackDashboardPreferencesMutationVariables = Exact<{
  input: UpdateTrackDashboardPreferencesInput;
}>;


export type UpdateTrackDashboardPreferencesMutation = { __typename?: 'Mutation', updateTrackDashboardPreferences: { __typename?: 'TrackDashboardPreferences', hiddenCards?: Array<string> | null, hiddenSopChecks?: Array<string> | null, hiddenTotals?: Array<string> | null } };

export type UpdateTrackSettingsMutationVariables = Exact<{
  input: UpdateTrackSettingsInput;
}>;


export type UpdateTrackSettingsMutation = { __typename?: 'Mutation', updateTrackSettings: { __typename?: 'TrackSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, createdAt: any, updatedAt?: any | null, stopSettings: { __typename?: 'StopSettings', pickup: { __typename?: 'PickupTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'PickupBeforeSettings', trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, suppressIfCarrierChangedWithinMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneBeforeTriggerSettings', triggerType: MilestoneBeforeTrigger, enabled: boolean, params?: { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, beforeConfigs?: Array<{ __typename?: 'PickupBeforeSettings', enabled?: boolean | null, trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, suppressIfCarrierChangedWithinMinutes?: number | null, advanced?: { __typename?: 'AdvancedBeforeTriggerSettings', appointment: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor }, windowTiers: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> } | null }> | null, after?: { __typename?: 'PickupAfterSettings', minutesAfter?: number | null, triggers?: Array<{ __typename?: 'MilestoneAfterTriggerSettings', triggerType: MilestoneAfterTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, at?: { __typename?: 'PickupAtSettings', delayMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneAtTriggerSettings', triggerType: MilestoneAtTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, actualArrival?: { __typename?: 'PickupActualArrivalSettings', enabled?: boolean | null } | null, actualDeparture?: { __typename?: 'PickupActualDepartureSettings', enabled?: boolean | null } | null, preDispatch?: { __typename?: 'PreDispatchSettings', enabled?: boolean | null, minutesBefore?: number | null, triggers?: Array<{ __typename?: 'PreDispatchTriggerSettings', triggerType: PreDispatchTrigger, enabled: boolean, params?: { __typename?: 'PreDispatchTriggerParams', minutesBefore?: number | null, cutoffHour?: number | null, hoursBeforeCutoffForEarlyPickups?: number | null, hoursBeforeCutoffForLatePickups?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null }, stops: { __typename?: 'StopTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null }, delivery: { __typename?: 'DeliveryTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'DeliveryBeforeSettings', trigger?: MilestoneBeforeTrigger | null, triggers?: Array<{ __typename?: 'MilestoneBeforeTriggerSettings', triggerType: MilestoneBeforeTrigger, enabled: boolean, params?: { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, after?: { __typename?: 'DeliveryAfterSettings', minutesAfter?: number | null, triggers?: Array<{ __typename?: 'MilestoneAfterTriggerSettings', triggerType: MilestoneAfterTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, at?: { __typename?: 'DeliveryAtSettings', delayMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneAtTriggerSettings', triggerType: MilestoneAtTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null } }, enRouteSettings: { __typename?: 'EnRouteSettings', cadenceMode?: EnRouteCadenceMode | null, truckSpeedMph?: number | null, dailyDrivingHours?: number | null, trackingTrigger?: TrackingTrigger | null, enRoute: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null }, enRouteWithTracking?: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null } | null, enRouteWithoutTracking?: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null } | null, exceptionEventsSettings?: { __typename?: 'ExceptionEventsSettings', alertWindowMinutes?: number | null, quietPeriodAfterInTransitMinutes?: number | null, stationaryVehicle?: { __typename?: 'StationaryVehicleExceptionSettings', thresholdMinutes: number, suppressionPeriodMinutes?: number | null } | null, runningLate?: { __typename?: 'RunningLateExceptionSettings', enabled: boolean, suppressionPeriodMinutes?: number | null, toleranceMinutes?: number | null } | null, trackingDataNotAvailable?: { __typename?: 'TrackingDataNotAvailableExceptionSettings', enabled: boolean, suppressionPeriodMinutes?: number | null } | null, trackingDataStale?: { __typename?: 'TrackingDataStaleExceptionSettings', enabled: boolean, thresholdMinutes: number, suppressionPeriodMinutes?: number | null } | null, infoMissing?: { __typename?: 'InfoMissingExceptionSettings', enabled: boolean, checks: Array<InfoMissingCheckType>, suppressionPeriodMinutes?: number | null, evaluateAt?: InfoMissingEvaluateAt | null } | null, notYetDispatched?: { __typename?: 'NotYetDispatchedExceptionSettings', enabled: boolean, minutesBeforePickup?: number | null } | null, runningLateCloseToDelivery?: { __typename?: 'RunningLateCloseToDeliveryExceptionSettings', enabled: boolean, minutesBeforeDelivery?: number | null, toleranceMinutes?: number | null } | null, runningLateCloseToPickup?: { __typename?: 'RunningLateCloseToPickupExceptionSettings', enabled: boolean, minutesBeforePickup?: number | null, toleranceMinutes?: number | null } | null } | null }, nightHoursSettings?: { __typename?: 'NightHoursSettings', startHour?: number | null, endHour?: number | null, windowMinutes?: number | null, skipAllMilestones?: boolean | null } | null } };

export type SetTruckerToolsScrapingConcurrencyMutationVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SetTruckerToolsScrapingConcurrencyMutation = { __typename?: 'Mutation', setTruckerToolsScrapingConcurrency: boolean };

export type SetToolSearchEmbeddingsEnabledMutationVariables = Exact<{
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetToolSearchEmbeddingsEnabledMutation = { __typename?: 'Mutation', setToolSearchEmbeddingsEnabled: boolean };

export type CreateAgentMailInboxMutationVariables = Exact<{
  input: CreateAgentMailInboxInput;
}>;


export type CreateAgentMailInboxMutation = { __typename?: 'Mutation', createAgentMailInbox: { __typename?: 'CreateAgentMailInboxPayload', success: boolean, email?: string | null, inboxId?: string | null, errorMessage?: string | null } };

export type CreateWorkerMutationVariables = Exact<{
  input: CreateWorkerInput;
}>;


export type CreateWorkerMutation = { __typename?: 'Mutation', createWorker: { __typename?: 'CreateWorkerPayload', worker: { __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null } } };

export type DeleteWorkerMutationVariables = Exact<{
  input: DeleteWorkerInput;
}>;


export type DeleteWorkerMutation = { __typename?: 'Mutation', deleteWorker: { __typename?: 'DeleteWorkerPayload', success: boolean } };

export type UpdateWorkerProfileMutationVariables = Exact<{
  input: UpdateWorkerProfileInput;
}>;


export type UpdateWorkerProfileMutation = { __typename?: 'Mutation', updateWorkerProfile: { __typename?: 'UpdateWorkerProfilePayload', worker: { __typename?: 'User', id: string, profile?: { __typename?: 'AIProfile', name?: string | null, backStory: string, humanisedDelay?: number | null, voiceId?: string | null, voiceModel?: SupportedVoiceModel | null, voiceSpeed?: number | null, languages?: Array<SupportedLanguage> | null } | { __typename?: 'HumanProfile' } | null, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string }> } } };

export type FrontendMaintenanceModeQueryVariables = Exact<{ [key: string]: never; }>;


export type FrontendMaintenanceModeQuery = { __typename?: 'Query', frontendMaintenanceMode: { __typename?: 'FrontendMaintenanceModePayload', enabled: boolean } };

export type GetApiKeysQueryVariables = Exact<{
  input: ApiClientsInput;
}>;


export type GetApiKeysQuery = { __typename?: 'Query', apiClients: { __typename?: 'ApiClientConnection', edges: Array<{ __typename?: 'ApiClientEdge', node: { __typename?: 'ApiClient', id: string, userEmail?: string | null, createdAt: any } }> } };

export type GetEvaluationTracesQueryVariables = Exact<{
  input: GetEvaluationTraceInput;
}>;


export type GetEvaluationTracesQuery = { __typename?: 'Query', getEvaluationTraces: Array<{ __typename?: 'EvaluationTrace', externalUrl?: string | null, name?: string | null }> };

export type GetFeatureFlagEnabledQueryVariables = Exact<{
  input: GetFeatureFlagEnabledInput;
}>;


export type GetFeatureFlagEnabledQuery = { __typename?: 'Query', isFeatureFlagEnabled: boolean };

export type GetFeedQuoteEventsQueryVariables = Exact<{
  input?: InputMaybe<JobsInput>;
}>;


export type GetFeedQuoteEventsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobConnection', edges: Array<{ __typename?: 'JobEdge', node: { __typename?: 'Job', id: string, quotes: Array<{ __typename?: 'Quote', id: string, quoteEvents: Array<{ __typename?: 'QuoteEvent', id: string, quoteId: string, createdAt: any, type: QuoteEventType, metadata?: any | null, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email?: string | null, id: string } | null }> }> } }> } };

export type GetFreightDataMappingsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  type: FreightDataMappingType;
}>;


export type GetFreightDataMappingsQuery = { __typename?: 'Query', freightDataMappings: Array<{ __typename?: 'FreightDataMapping', id: string, key: string, type: FreightDataMappingType, values: any, organizationId: string, createdAt: any, updatedAt?: any | null }> };

export type GetAuthorizedServiceQueryVariables = Exact<{
  type: AuthTokenType;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuthorizedServiceQuery = { __typename?: 'Query', hasAuthorizedServiceType: { __typename?: 'HasAuthorizedServiceTypePayload', success: boolean, email?: string | null, scopes?: Array<string> | null } };

export type GetJobsQueryVariables = Exact<{
  input?: InputMaybe<JobsInput>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'JobConnection', edges: Array<{ __typename?: 'JobEdge', node: { __typename?: 'Job', id: string, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, source: JobSource, optimismStatus: OptimismStatus, relatedCanonicalQuotes: Array<{ __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null }>, user?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, orders: Array<{ __typename?: 'Order', id: string, hasSubmittedEvent: boolean, primaryReference?: string | null, extractedData?: string | null, createdAt: any, createdAtDisplay?: any | null, externalDeepLink?: string | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', id: string, name: string } | null, job: { __typename?: 'Job', emailMetadata?: any | null }, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }> }>, quotes: Array<{ __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null }>, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }> } }> } };

export type GetKnockTokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKnockTokenQuery = { __typename?: 'Query', knockToken: string };

export type GetManagedResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagedResourcesQuery = { __typename?: 'Query', managedResources: Array<{ __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus, fallbackResource?: { __typename?: 'ManagedResource', id: string, name: string, type: ManagedResourceType, provider?: ManagedResourceProvider | null, status: ManagedResourceStatus } | null }> };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', orderById: { __typename?: 'Order', id: string, createdAt: any, updatedAt?: any | null, transmitId?: string | null, primaryReference?: string | null, hasSubmittedEvent: boolean, extractedData?: string | null, externalDeepLink?: string | null, externalId?: string | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> }, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }>, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }>, organization: { __typename?: 'Organization', id: string, integrationConfigs?: any | null }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, shipmentAssociations?: Array<{ __typename?: 'OrderShipmentAssociation', shipment: { __typename?: 'Shipment', id: string } }> | null } };

export type PricingStrategiesQueryVariables = Exact<{
  input: PricingStrategiesInput;
}>;


export type PricingStrategiesQuery = { __typename?: 'Query', pricingStrategies: Array<{ __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any }> };

export type GetResourceResolutionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResourceResolutionQuery = { __typename?: 'Query', getResourceResolution: { __typename?: 'GetResourceResolutionPayload', resolutions: Array<{ __typename?: 'ResourceResolution', name: string, resolvesToName?: string | null }> } };

export type GetTeamQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTeamQuery = { __typename?: 'Query', teamById: { __typename?: 'Team', id: string, name: string, description: string, email?: string | null, settings: any, actionTriggerCount: number, organizationId: string, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null, members: Array<{ __typename?: 'TeamMember', id: string, role: TeamMemberRole, organizationUserRelation: { __typename?: 'OrganizationUserRelation', id: string, user: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } } }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null } };

export type GetTeamsQueryVariables = Exact<{
  input: TeamsInput;
}>;


export type GetTeamsQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }> };

export type GetTeamsWithActionTriggerCountQueryVariables = Exact<{
  input: TeamsInput;
}>;


export type GetTeamsWithActionTriggerCountQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', actionTriggerCount: number, id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }> };

export type GetTransformationDefinitionsQueryVariables = Exact<{
  input?: InputMaybe<TransformationDefinitionsInput>;
}>;


export type GetTransformationDefinitionsQuery = { __typename?: 'Query', transformationDefinitions: { __typename?: 'TransformationDefinitionConnection', edges: Array<{ __typename?: 'TransformationDefinitionEdge', node: { __typename?: 'TransformationDefinition', id: string, createdAt: any, definition: any, organization?: { __typename?: 'Organization', id: string } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null } }> } };

export type GetWebhookSubscriptionsQueryVariables = Exact<{
  input: WebhookSubscriptionsInput;
}>;


export type GetWebhookSubscriptionsQuery = { __typename?: 'Query', webhookSubscriptions: { __typename?: 'WebhookSubscriptionsPayload', items: Array<{ __typename?: 'WebhookSubscription', id: string, createdAt: any, organizationId: string, url: string, subscriptionType: WebhookSubscriptionType, authConfig: any }> } };

export type GetWorkflowsQueryVariables = Exact<{
  input?: InputMaybe<WorkflowsInput>;
}>;


export type GetWorkflowsQuery = { __typename?: 'Query', workflows: { __typename?: 'WorkflowConnection', edges: Array<{ __typename?: 'WorkflowEdge', node: { __typename?: 'Workflow', id: string, createdAt: any, organization: { __typename?: 'Organization', id: string }, originator?: { __typename?: 'Originator', id: string, name: string } | null, transformations: Array<{ __typename?: 'WorkflowTransformation', id: string, seq: number, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } }>, trigger: { __typename?: 'FlowTrigger', type: FlowTriggerType, config?: any | null } } }> } };

export type HasIntegrationCredentialsQueryVariables = Exact<{
  input: HasIntegrationCredentialsInput;
}>;


export type HasIntegrationCredentialsQuery = { __typename?: 'Query', hasIntegrationCredentials: { __typename?: 'HasIntegrationCredentialsPayload', hasIntegrationCredentials: boolean } };

export type GetLaneHistoryQueryVariables = Exact<{
  input?: InputMaybe<QuotesInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLaneHistoryQuery = { __typename?: 'Query', quotes: { __typename?: 'QuoteConnection', totalCount: number, count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, originator?: { __typename?: 'Originator', name: string } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null } }> } };

export type DownloadActionDefinitionQueryVariables = Exact<{
  input: DownloadActionDefinitionInput;
}>;


export type DownloadActionDefinitionQuery = { __typename?: 'Query', downloadActionDefinition: { __typename?: 'DownloadActionDefinitionPayload', downloadUrl: string, actionDefinitionIds: Array<string> } };

export type ActionDefinitionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionDefinitionQuery = { __typename?: 'Query', actionDefinitionById: { __typename?: 'ActionDefinition', canonicalTools?: Array<any> | null, globalPromptSkillIds: any, globalPromptValues?: any | null, globalPromptToolValues?: any | null, provisioningResourceId?: string | null, id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, organization: { __typename?: 'Organization', id: string }, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality, voiceModelName?: string | null, textModelName?: LlmName | null, initialInstructions: string, outputInstructions?: string | null, includeTranscriptInOutput?: boolean | null, semanticWaitPatterns?: any | null, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType, functionName: string } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType, graph: { __typename?: 'GraphDefinition', initialNodeId?: string | null, nodes: Array<{ __typename?: 'GraphNode', id: string, actionDefinitionId: string, position: { __typename?: 'GraphNodePosition', x: number, y: number } }>, edges: Array<{ __typename?: 'GraphEdge', id: string, sourceId: string, targetId: string, type?: EdgeType | null, prompt?: string | null }> } } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType, instructions: string, outcomeLabels?: Array<{ __typename?: 'OutcomeLabel', name: string, description: string }> | null, eventLabels?: Array<{ __typename?: 'EventLabel', name: string, description: string }> | null, watchers?: Array<{ __typename?: 'WatcherDefinition', functionName: string, intervalMinutes: number, params?: any | null }> | null }, deterministicToolInvocations?: { __typename?: 'DeterministicToolInvocations', onEnter?: Array<{ __typename?: 'DeterministicToolInvocation', tool: any, input: any }> | null } | null, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> }>, workersConfig: { __typename?: 'LegacyAgentBackstoryConfig', type: WorkersConfigType, agentBackstory: string, agentVoiceId?: string | null } | { __typename?: 'MultipleWorkersConfig', type: WorkersConfigType } | { __typename?: 'NoWorkersConfig', type: WorkersConfigType } | { __typename?: 'SingleWorkerConfig', type: WorkersConfigType }, workers: Array<{ __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null }>, subscribers?: Array<{ __typename?: 'User', id: string }> | null, memoryEntityLinks: Array<{ __typename?: 'MemoryEntityLink', id: string }>, globalPrompt?: { __typename?: 'GlobalPrompt', id: string, name: string, prompt?: string | null, parameters?: any | null, basePromptId?: string | null } | null, teamGlobalPromptValues: Array<{ __typename?: 'ActionDefinitionTeamGlobalPromptValues', id: string, teamId: string, values?: any | null, toolValues?: any | null, team: { __typename?: 'Team', id: string, name: string } }>, relatedGlobalPrompts: Array<{ __typename?: 'GlobalPrompt', id: string, name: string }>, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, documents: Array<{ __typename?: 'ActionDefinitionDocumentUpload', id: string, name?: string | null, url: string }> } };

export type ActionDefinitionHierarchyPreviewsQueryVariables = Exact<{
  input: ActionDefinitionsInput;
}>;


export type ActionDefinitionHierarchyPreviewsQuery = { __typename?: 'Query', actionDefinitions: { __typename?: 'ActionDefinitionConnection', edges: Array<{ __typename?: 'ActionDefinitionEdge', node: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, childLinks: Array<{ __typename?: 'ActionDefinitionChildLink', relationshipType: ActionDefinitionRelationshipType, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, mode: ActionDefinitionMode, tags?: Array<string> | null, isEmbeddedInGraph: boolean, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } } }>, triggers?: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } } }> } };

export type ActionDefinitionPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionDefinitionPreviewQuery = { __typename?: 'Query', actionDefinitionById: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } } };

export type ActionDefinitionPreviewsQueryVariables = Exact<{
  input: ActionDefinitionsInput;
}>;


export type ActionDefinitionPreviewsQuery = { __typename?: 'Query', actionDefinitions: { __typename?: 'ActionDefinitionConnection', edges: Array<{ __typename?: 'ActionDefinitionEdge', node: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } } }> } };

export type ActionDefinitionTagsQueryVariables = Exact<{
  input: ActionDefinitionTagsInput;
}>;


export type ActionDefinitionTagsQuery = { __typename?: 'Query', actionDefinitionTags: { __typename?: 'ActionDefinitionTagsPayload', tags: Array<string> } };

export type GetActionDefinitionsUsedAsParentsQueryVariables = Exact<{
  input: GetActionDefinitionsUsedAsParentsInput;
}>;


export type GetActionDefinitionsUsedAsParentsQuery = { __typename?: 'Query', getActionDefinitionsUsedAsParents: Array<{ __typename?: 'ActionDefinition', id: string, name: string }> };

export type GetGraphqlToolCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGraphqlToolCatalogQuery = { __typename?: 'Query', graphqlToolCatalog: Array<{ __typename?: 'GraphqlToolCatalogEntry', name: string, description: string }> };

export type QuoteSimulationActionDefinitionQueryVariables = Exact<{
  input: GetQuoteSimulationsInput;
}>;


export type QuoteSimulationActionDefinitionQuery = { __typename?: 'Query', getQuoteSimulationsActionDefinition: { __typename?: 'GetQuoteSimulationsPayload', quoteSimulationId?: string | null } };

export type RootSopsForProvisioningQueryVariables = Exact<{
  input: RootSoPsForProvisioningInput;
}>;


export type RootSopsForProvisioningQuery = { __typename?: 'Query', rootSOPsForProvisioning: { __typename?: 'RootSOPsForProvisioningPayload', rootSOPsForProvisioning: Array<{ __typename?: 'RootSOPsForProvisioningItem', provisioningResourceId: string, provisioningResourceName: string, actionDefinitions: Array<{ __typename?: 'RootSOPActionDefinition', name: string, id: string }> }> } };

export type ToolValidationSchemaInputQueryVariables = Exact<{
  input: ToolValidationSchemaInput;
}>;


export type ToolValidationSchemaInputQuery = { __typename?: 'Query', toolInputValidationSchema: { __typename?: 'ToolValidationSchemaPayload', jsonSchema: any } };

export type ActionExecutionBreadcrumbQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionExecutionBreadcrumbQuery = { __typename?: 'Query', actionExecutionById: { __typename?: 'ActionExecution', id: string, parentId?: string | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, linkedConversations: Array<{ __typename?: 'Conversation', id: string, externalIdentifier: string, type: ConversationType, createdAt: any, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null }> } };

export type ActionExecutionSummariesQueryVariables = Exact<{
  input: ActionExecutionSummariesInput;
}>;


export type ActionExecutionSummariesQuery = { __typename?: 'Query', actionExecutionSummaries: { __typename?: 'ActionExecutionSummariesPayload', all: number, inProgress: number, failedOrPaused: number } };

export type ActionExecutionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionExecutionQuery = { __typename?: 'Query', actionExecutionById: { __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, children: Array<{ __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> }>, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> } };

export type ActionExecutionCreditsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionExecutionCreditsQuery = { __typename?: 'Query', actionExecutionCredits?: { __typename?: 'ActionExecutionCredits', actionExecutionId: string, ownCredits: number, downstreamCredits: number, totalCredits: number, downstream: Array<{ __typename?: 'ActionExecutionCreditsLine', actionExecutionId: string, causedByActionExecutionId?: string | null, actionDefinitionId: string, actionDefinitionName: string, depth: number, credits: number }> } | null };

export type ActionExecutionWithDescendantsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionExecutionWithDescendantsQuery = { __typename?: 'Query', actionExecutionWithDescendants: { __typename?: 'ActionExecutionWithDescendantsPayload', actionExecutions: Array<{ __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, children: Array<{ __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> }>, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> }>, conversationEvents: Array<{ __typename?: 'ConversationEvent', conversationId?: string | null, id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }>, externalMessages: Array<{ __typename?: 'ExternalMessage', id: string, externalIdentifier: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, emailMetadata?: any | null, userId?: string | null, conversationId?: string | null, canonicalMessageId?: string | null, user?: { __typename?: 'User', id: string, username?: string | null, firstName?: string | null, lastName?: string | null, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile', name?: string | null } | null } | null, documents: Array<{ __typename?: 'ExternalMessageDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null }> }> } };

export type ActionExecutionsQueryVariables = Exact<{
  input: ActionExecutionInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActionExecutionsQuery = { __typename?: 'Query', actionExecutions: { __typename?: 'ActionExecutionConnection', edges: Array<{ __typename?: 'ActionExecutionEdge', node: { __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, children: Array<{ __typename?: 'ActionExecution', id: string, organizationId: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, executeAsUserId?: string | null, tags?: Array<string> | null, hasMemory?: boolean | null, respondsToCoworkers?: boolean | null, mode: ExecutionMode, input: any, output?: any | null, reexecutedFromActionExecutionId?: string | null, parentId?: string | null, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> }>, executeAsUser?: { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, createdAt: any, updatedAt?: any | null, deletedAt?: any | null, name: string, mode: ActionDefinitionMode, modelOverride?: LlmName | null, reasoningEffort?: ReasoningEffort | null, hasMemory?: boolean | null, classifyConversationMessages?: boolean | null, respondsToCoworkers?: boolean | null, runDetached?: boolean | null, runsOnExperimentalService?: boolean | null, defaultAutonomyState?: AutonomyState | null, postCompletionMessageBehavior?: PostCompletionMessageBehavior | null, referringActionDefinitionsCount: number, isEmbeddedInGraph: boolean, triggersCount: number, implementsTool?: CanonicalToolType | null, tags?: Array<string> | null, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null, catalogKey?: string | null } | null, procedure: { __typename?: 'ConversationGraphProcedure', procedureType: ProcedureType, modality: ConversationModality } | { __typename?: 'DeterministicProcedure', procedureType: ProcedureType } | { __typename?: 'GraphDefinedProcedure', procedureType: ProcedureType } | { __typename?: 'NaturalLanguageProcedure', procedureType: ProcedureType } }, conversation?: { __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus }>, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, documents: Array<{ __typename?: 'ActionExecutionDocumentUpload', id: string, createdAt: any, name?: string | null, url: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type InProgressActionExecutionsQueryVariables = Exact<{
  input: ActionExecutionInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InProgressActionExecutionsQuery = { __typename?: 'Query', inProgressActionExecutions: { __typename?: 'ActionExecutionConnection', edges: Array<{ __typename?: 'ActionExecutionEdge', node: { __typename?: 'ActionExecution', id: string, createdAt: any, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, tags?: Array<string> | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, deletedAt?: any | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type NeedAttentionActionExecutionsQueryVariables = Exact<{
  input: ActionExecutionInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type NeedAttentionActionExecutionsQuery = { __typename?: 'Query', needAttentionActionExecutions: { __typename?: 'ActionExecutionConnection', edges: Array<{ __typename?: 'ActionExecutionEdge', node: { __typename?: 'ActionExecution', id: string, createdAt: any, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, tags?: Array<string> | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, deletedAt?: any | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type TaskListActionExecutionsQueryVariables = Exact<{
  input: ActionExecutionInput;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaskListActionExecutionsQuery = { __typename?: 'Query', actionExecutions: { __typename?: 'ActionExecutionConnection', edges: Array<{ __typename?: 'ActionExecutionEdge', node: { __typename?: 'ActionExecution', id: string, createdAt: any, deletedAt?: any | null, status: ActionExecutionStatus, autonomyState: AutonomyState, tags?: Array<string> | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, deletedAt?: any | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } };

export type ActionTriggerValidationQueryVariables = Exact<{
  input: ActionTriggerValidationInput;
}>;


export type ActionTriggerValidationQuery = { __typename?: 'Query', actionTriggerValidation: { __typename?: 'ActionTriggerValidationPayload', validations: Array<{ __typename?: 'ActionTriggerValidation', validationType: ActionTriggerValidationType, status: ActionTriggerValidationStatus, reasons: Array<string>, actionDefinitionIds?: Array<string> | null }> } };

export type ActionTriggerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActionTriggerQuery = { __typename?: 'Query', actionTriggerById: { __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null } };

export type CheckAgentMailAvailabilityQueryVariables = Exact<{
  input: CheckAgentMailAvailabilityInput;
}>;


export type CheckAgentMailAvailabilityQuery = { __typename?: 'Query', checkAgentMailAvailability: { __typename?: 'CheckAgentMailAvailabilityPayload', available: boolean } };

export type ListAgentMailDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAgentMailDomainsQuery = { __typename?: 'Query', listAgentMailDomains: { __typename?: 'ListAgentMailDomainsPayload', domains: Array<{ __typename?: 'AgentMailDomain', domainId: string, domain: string, verified: boolean }> } };

export type GetBraintrustDatasetsQueryVariables = Exact<{
  input?: InputMaybe<GetBraintrustDatasetsInput>;
}>;


export type GetBraintrustDatasetsQuery = { __typename?: 'Query', getBraintrustDatasets: Array<{ __typename?: 'BraintrustDataset', id: string, name: string, description?: string | null, created: string }> };

export type GetCarrierLaneRunsForLaneQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  lookbackDays?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCarrierLaneRunsForLaneQuery = { __typename?: 'Query', carrierLaneRunsForLane: Array<{ __typename?: 'CarrierLaneRun', runCount: number, lastRunDate: any, lastRunRate?: number | null, carrier: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } }> };

export type GetCarrierRatesForLaneQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  lookbackDays?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetCarrierRatesForLaneQuery = { __typename?: 'Query', carrierRatesForLane: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null }> };

export type GetExistingCarriersQueryVariables = Exact<{
  input: GetExistingCarriersInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetExistingCarriersQuery = { __typename?: 'Query', getExistingCarriers: { __typename?: 'CarrierConnection', count: number, totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CarrierEdge', node: { __typename?: 'Carrier', id: string, name: string, dotNumber: string, mcNumber?: string | null, organization: { __typename?: 'Organization', id: string }, contacts: Array<{ __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null, isVerified: boolean }> } }>, nodes?: Array<{ __typename?: 'Carrier', id: string, name: string, dotNumber: string, mcNumber?: string | null, contacts: Array<{ __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null, isVerified: boolean }> }> | null } };

export type GetIntegratedCarrierVerificationIntegrationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetIntegratedCarrierVerificationIntegrationsQuery = { __typename?: 'Query', integratedCarrierVerificationIntegrations: Array<CarrierVerificationIntegrationType> };

export type GetSuggestedCarriersQueryVariables = Exact<{
  input: GetSuggestedCarriersInput;
}>;


export type GetSuggestedCarriersQuery = { __typename?: 'Query', getSuggestedCarriers: { __typename?: 'GetSuggestedCarriersPayload', suggestedCarriers: Array<{ __typename?: 'SuggestedCarrier', mcNumber: string, carrierName?: string | null, phoneNumber?: string | null, email?: string | null }> } };

export type LookupFmcsaCarrierContactQueryVariables = Exact<{
  input: LookupFmcsaCarrierContactInput;
}>;


export type LookupFmcsaCarrierContactQuery = { __typename?: 'Query', lookupFmcsaCarrierContact: { __typename?: 'FmcsaCarrierContactPayload', legalName?: string | null, dbaName?: string | null, phone?: string | null, dotNumber?: string | null, mcNumber?: string | null, message: string } };

export type GetClassificationLockDurationSecondsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClassificationLockDurationSecondsQuery = { __typename?: 'Query', classificationLockDurationSeconds: number };

export type GetComposioToolKitDetailsQueryVariables = Exact<{
  input: GetComposioToolKitDetailsInput;
}>;


export type GetComposioToolKitDetailsQuery = { __typename?: 'Query', getComposioToolKitDetails: { __typename?: 'ComposioToolKitDetailsPayload', success: boolean, toolKit: { __typename?: 'ComposioToolKitDetails', toolKitName: string, logo: string } } };

export type ListComposioAuthTokensQueryVariables = Exact<{
  input: ListComposioAuthTokensInput;
}>;


export type ListComposioAuthTokensQuery = { __typename?: 'Query', listComposioAuthTokens: { __typename?: 'ListComposioAuthTokensPayload', success: boolean, authTokens: Array<{ __typename?: 'AuthToken', id: string, config?: any | null }> } };

export type ListComposioToolKitsQueryVariables = Exact<{
  input: ListComposioToolKitsInput;
}>;


export type ListComposioToolKitsQuery = { __typename?: 'Query', listComposioToolKits: { __typename?: 'ListComposioToolKitsPayload', success: boolean, toolKits: Array<{ __typename?: 'ComposioToolKitInfo', name: string, slug: string, description: string }> } };

export type ListComposioToolsQueryVariables = Exact<{
  input: ListComposioToolsInput;
}>;


export type ListComposioToolsQuery = { __typename?: 'Query', listComposioTools: { __typename?: 'ListComposioToolsPayload', success: boolean, tools: Array<{ __typename?: 'ComposioToolInfo', name: string, slug: string, description: string }> } };

export type WorkerComposioAccountsQueryVariables = Exact<{
  input: WorkerComposioAccountsInput;
}>;


export type WorkerComposioAccountsQuery = { __typename?: 'Query', workerComposioAccounts: { __typename?: 'WorkerComposioAccountsPayload', configured: boolean, toolKits: Array<{ __typename?: 'ComposioToolKitInfo', slug: string, name: string, logo?: string | null }>, connections: Array<{ __typename?: 'WorkerComposioConnection', id: string, toolkitSlug: string, status: string, accountLabel: string }> } };

export type CreateOrUpdateComposioAuthTokenMutationVariables = Exact<{
  input: CreateOrUpdateComposioAuthTokenInput;
}>;


export type CreateOrUpdateComposioAuthTokenMutation = { __typename?: 'Mutation', createOrUpdateComposioAuthToken: { __typename?: 'CreateOrUpdateComposioAuthTokenPayload', success: boolean } };

export type CreateNewConversationWithConciergeMutationVariables = Exact<{
  input: CreateNewConversationWithConciergeInput;
}>;


export type CreateNewConversationWithConciergeMutation = { __typename?: 'Mutation', createNewConversationWithConcierge: { __typename?: 'CreateNewConversationWithConciergePayload', conversation: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> } } };

export type CreateNewConversationWithLabelingConciergeMutationVariables = Exact<{
  input: CreateNewConversationWithLabelingConciergeInput;
}>;


export type CreateNewConversationWithLabelingConciergeMutation = { __typename?: 'Mutation', createNewConversationWithLabelingConcierge: { __typename?: 'CreateNewConversationWithConciergePayload', conversation: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> } } };

export type DownloadConversationDebugPackageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DownloadConversationDebugPackageQuery = { __typename?: 'Query', downloadConversationDebugPackage: { __typename?: 'DownloadConversationDebugPackagePayload', downloadUrl: string } };

export type GetAgentConversationsQueryVariables = Exact<{
  input?: InputMaybe<ConversationsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetAgentConversationsQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'ConversationEdge', node: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, updatedAt?: any | null, contactIdentifier?: string | null, associatedReferenceNumbers: Array<string>, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata' } | null, associatedCarriers: Array<{ __typename?: 'Carrier', id: string, name: string }>, associatedShipments: Array<{ __typename?: 'Shipment', id: string, referenceNumbers?: Array<string> | null, movements: Array<{ __typename?: 'Movement', id: string, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', city?: string | null, state?: string | null } }> | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AgentConversationPreviewFragment = { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, updatedAt?: any | null, contactIdentifier?: string | null, associatedReferenceNumbers: Array<string>, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata' } | null, associatedCarriers: Array<{ __typename?: 'Carrier', id: string, name: string }>, associatedShipments: Array<{ __typename?: 'Shipment', id: string, referenceNumbers?: Array<string> | null, movements: Array<{ __typename?: 'Movement', id: string, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', city?: string | null, state?: string | null } }> | null }> }> };

export type GetChatSuggestionsQueryVariables = Exact<{
  input: ChatSuggestionsInput;
}>;


export type GetChatSuggestionsQuery = { __typename?: 'Query', chatSuggestions: Array<{ __typename?: 'ChatSuggestion', id: string, label: string, message: string, product: Product }> };

export type GetChatThreadsQueryVariables = Exact<{
  input?: InputMaybe<ConversationsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetChatThreadsQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationConnection', edges: Array<{ __typename?: 'ConversationEdge', node: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, createdAt: any, hasUnreadMessages: boolean, hasActionExecutionInProgress: boolean, handledOpenEscalations: Array<{ __typename?: 'Exception', id: string }>, user?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, latestExternalMessage?: { __typename?: 'ChatThreadMessagePreview', id: string, createdAt: any } | null } }> } };

export type ConversationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConversationQuery = { __typename?: 'Query', conversationById: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> } };

export type GetRelatedActionsQueryVariables = Exact<{
  input: RelatedExternalMessagesInput;
}>;


export type GetRelatedActionsQuery = { __typename?: 'Query', relatedActions: Array<{ __typename?: 'AgentAction', type: AgentActionType, confidence: number, proposedAt: any, entityIds?: { __typename?: 'ActionEntityIds', externalMessageIds?: Array<string> | null, quoteIds?: Array<string> | null, orderIds?: Array<string> | null } | null }> };

export type GetConversationActivityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConversationActivityQuery = { __typename?: 'Query', conversationById: { __typename?: 'Conversation', id: string, hasActionExecutionInProgress: boolean } };

export type GetConversationExperimentAssignmentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConversationExperimentAssignmentsQuery = { __typename?: 'Query', conversationExperimentAssignments: Array<{ __typename?: 'ExperimentParameterAssignment', id: string, parameters: any, experiment: { __typename?: 'Experiment', id: string, name: string, isActive: boolean } }> };

export type GetConversationExternalMessagesQueryVariables = Exact<{
  input?: InputMaybe<ConversationExternalMessagesInput>;
}>;


export type GetConversationExternalMessagesQuery = { __typename?: 'Query', conversationExternalMessages: { __typename?: 'ConversationExternalMessagesConnection', edges: Array<{ __typename?: 'ConversationExternalMessagesEdge', node: { __typename?: 'ExternalMessage', id: string, externalIdentifier: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, emailMetadata?: any | null, userId?: string | null, conversationId?: string | null, canonicalMessageId?: string | null, user?: { __typename?: 'User', id: string, username?: string | null, firstName?: string | null, lastName?: string | null, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile', name?: string | null } | null } | null, documents: Array<{ __typename?: 'ExternalMessageDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null }> } }> } };

export type GetConversationFilterOptionsQueryVariables = Exact<{
  input: ConversationFilterOptionsInput;
}>;


export type GetConversationFilterOptionsQuery = { __typename?: 'Query', conversationFilterOptions: { __typename?: 'ConversationFilterOptionsPayload', options: Array<{ __typename?: 'ConversationFilterOption', label: string, value: string }> } };

export type GetConversationHistoryLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConversationHistoryLogQuery = { __typename?: 'Query', conversationHistoryLog: Array<any> };

export type GetConversationsQueryVariables = Exact<{
  input?: InputMaybe<ConversationsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetConversationsQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'ConversationEdge', node: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetConversationsWithExternalMessagesQueryVariables = Exact<{
  input?: InputMaybe<ConversationsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetConversationsWithExternalMessagesQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'ConversationEdge', node: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, externalMessages: Array<{ __typename?: 'ExternalMessage', id: string, externalIdentifier: string, createdAt: any, userId?: string | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetEmailThreadAgentRunsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailThreadAgentRunsQuery = { __typename?: 'Query', conversationById: { __typename?: 'Conversation', id: string, sideConversationParent?: { __typename?: 'Conversation', id: string } | null, actions: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, organizationId: string, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string }, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType }> }>, runsAboutThread: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, organizationId: string, events: Array<{ __typename?: 'ActionExecutionEvent', id: string, createdAt: any, name: ActionExecutionEventType, agentMessageView?: { __typename?: 'AgentMessageView', content: string, toolCalls: Array<{ __typename?: 'ToolCallView', id?: string | null, name: string, args?: any | null }>, sentMessage?: { __typename?: 'SentMessageView', subject?: string | null, body: string, toRecipients: Array<string>, ccRecipients: Array<string> } | null } | null, data?: { __typename?: 'AeWatcherClosedData' } | { __typename?: 'AgentProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'AgentReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'DecisionEdgeEvaluatedData', eventDataType: ActionExecutionEventType, rationale: string, shouldFollowEdge: boolean, targetNodeActionDefinitionId?: string | null } | { __typename?: 'EscalationData', eventDataType: ActionExecutionEventType, escalationType: EscalationType, message: string, codeExecutionError?: string | null, escalationRationale?: string | null } | { __typename?: 'InstructionMessageData', eventDataType: ActionExecutionEventType, message: string, sourceActionExecutionId?: string | null } | { __typename?: 'MemoryRecalledData', eventDataType: ActionExecutionEventType, memories: Array<{ __typename?: 'MemoryData', id: string, comment: string }> } | { __typename?: 'RawAgentMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'RawSupervisorMessageData', eventDataType: ActionExecutionEventType, data: any } | { __typename?: 'ReminderData', eventDataType: ActionExecutionEventType, message: string } | { __typename?: 'SpamGuardData', eventDataType: ActionExecutionEventType, reason: string, communicationChannel: CommunicationChannel, toIdentifier: string, fromIdentifier: string } | { __typename?: 'StatusChangedData', eventDataType: ActionExecutionEventType, fromStatus: ActionExecutionStatus, toStatus: ActionExecutionStatus } | { __typename?: 'SupervisorProposedOutputData', eventDataType: ActionExecutionEventType, output: any } | { __typename?: 'SupervisorReasoningData', eventDataType: ActionExecutionEventType, reasoning: string } | { __typename?: 'SupervisorToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'ToolUsedData', eventDataType: ActionExecutionEventType, toolName: string, metadata?: any | null, toolInput: any, toolOutput?: any | null, status?: ToolCallStatus | null } | { __typename?: 'UnknownData' } | { __typename?: 'WatcherPokedData' } | null }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string }, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType }> }>, otherLinkedRuns: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, organizationId: string, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string }, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType }> }> } };

export type EmailThreadAgentRunFragment = { __typename?: 'ActionExecution', id: string, createdAt: any, organizationId: string, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string }, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType }> };

export type GetEmailThreadChatQueryVariables = Exact<{
  input: EmailThreadChatInput;
}>;


export type GetEmailThreadChatQuery = { __typename?: 'Query', emailThreadChat?: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null } | null };

export type HasConciergeActionDefinitionQueryVariables = Exact<{
  input: HasConciergeActionDefinitionInput;
}>;


export type HasConciergeActionDefinitionQuery = { __typename?: 'Query', hasConciergeActionDefinition: { __typename?: 'HasConciergeActionDefinitionPayload', hasConcierge: boolean, actionDefinitionId?: string | null, actionDefinitionName?: string | null, escalationHandlerActionDefinitionId?: string | null, escalationHandlerActionDefinitionName?: string | null } };

export type HasLabelingConciergeQueryVariables = Exact<{
  input: HasLabelingConciergeInput;
}>;


export type HasLabelingConciergeQuery = { __typename?: 'Query', hasLabelingConcierge: { __typename?: 'HasLabelingConciergePayload', hasLabelingConcierge: boolean } };

export type GetOrCreateConversationWithConciergeQueryVariables = Exact<{
  input: GetOrCreateConversationWithConciergeInput;
}>;


export type GetOrCreateConversationWithConciergeQuery = { __typename?: 'Query', getOrCreateConversationWithConcierge: { __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> } };

export type GetRejectedCarrierInquiriesForLaneQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
  radiusMiles?: InputMaybe<Scalars['Float']['input']>;
  lookbackDays?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetRejectedCarrierInquiriesForLaneQuery = { __typename?: 'Query', rejectedCarrierInquiriesForLane: Array<{ __typename?: 'Conversation', contactIdentifier?: string | null, id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, associatedCarriers: Array<{ __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean, contacts: Array<{ __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null }> }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> }> };

export type GetRejectedCarrierInquiriesForMovementQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GetRejectedCarrierInquiriesForMovementQuery = { __typename?: 'Query', rejectedCarrierInquiriesForMovement: Array<{ __typename?: 'Conversation', contactIdentifier?: string | null, id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, associatedCarriers: Array<{ __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean, contacts: Array<{ __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null }> }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> }> };

export type CoverageStatePreviewQueryVariables = Exact<{
  input: CoverageStatePreviewInput;
}>;


export type CoverageStatePreviewQuery = { __typename?: 'Query', coverageStatePreview: Array<{ __typename?: 'CoverageStatePreviewResult', shipmentId: string, shipmentReferenceNumber?: string | null, shipmentUpdatedAt?: any | null, movementId?: string | null, defaultCoverageState?: CoverageState | null, coverageState?: CoverageState | null, recordedCoverageState?: CoverageState | null, error?: string | null }> };

export type DatAuthorizedUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type DatAuthorizedUsersQuery = { __typename?: 'Query', datAuthorizedUsers: Array<{ __typename?: 'DatAuthorizedUserPayload', userId: string, name?: string | null, datUsername?: string | null }> };

export type GetErrorGroupsQueryVariables = Exact<{
  input?: InputMaybe<ListErrorGroupsInput>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetErrorGroupsQuery = { __typename?: 'Query', errorGroups: Array<{ __typename?: 'ErrorGroup', id: string, source: ErrorIncidentSource, title: string, status: ErrorGroupStatus, lastOccurrenceCount: number, firstSeenAt: any, lastSeenAt: any, suppressionThreshold?: number | null, linearTicketId?: string | null, githubPrUrl?: string | null, notes?: string | null, createdAt: any, updatedAt?: any | null, topOrganizations: Array<{ __typename?: 'ErrorGroupOrganizationCount', organizationId?: string | null, organizationName?: string | null, count: number }> }> };

export type GetExceptionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExceptionByIdQuery = { __typename?: 'Query', getExceptionById?: { __typename?: 'Exception', id: string, type: ExceptionType, status: ExceptionStatus, createdAt: any, updatedAt?: any | null, context?: any | null, actionExecution?: { __typename?: 'ActionExecution', id: string, conversationId?: string | null } | null, handler?: { __typename?: 'ActionExecution', id: string, conversationId?: string | null } | null } | null };

export type GetConversationExceptionsQueryVariables = Exact<{
  input: ConversationExceptionsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetConversationExceptionsQuery = { __typename?: 'Query', conversationExceptions: { __typename?: 'ExceptionConnection', count: number, totalCount: number, edges: Array<{ __typename?: 'ExceptionEdge', node: { __typename?: 'Exception', id: string, createdAt: any, callTransferStatus: CallTransferStatus, conversation?: { __typename?: 'Conversation', associatedReferenceNumbers: Array<string>, id: string, type: ConversationType, contactIdentifier?: string | null, associatedCarriers: Array<{ __typename?: 'Carrier', name: string }>, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null, actionExecution?: { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null } | null, handler?: { __typename?: 'ActionExecution', id: string, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, contactIdentifier?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string } | { __typename?: 'SMSConversationMetadata' } | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null } } };

export type GetExceptionsQueryVariables = Exact<{
  input: GetExceptionsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExceptionsQuery = { __typename?: 'Query', exceptionsByOrganization: { __typename?: 'ExceptionConnection', totalCount: number, edges: Array<{ __typename?: 'ExceptionEdge', node: { __typename?: 'Exception', id: string, type: ExceptionType, status: ExceptionStatus, createdAt: any, updatedAt?: any | null, context?: any | null, actionExecution?: { __typename?: 'ActionExecution', id: string, conversationId?: string | null } | null, handler?: { __typename?: 'ActionExecution', id: string, conversationId?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetChannelOptionsQueryVariables = Exact<{
  input: GetChannelOptionsInput;
}>;


export type GetChannelOptionsQuery = { __typename?: 'Query', getChannelOptions: { __typename?: 'GetChannelOptionsPayload', options: Array<{ __typename?: 'ChannelOption', id: string, label: string, channelGroup?: string | null }> } };

export type GetExternalChannelsQueryVariables = Exact<{
  input: ExternalChannelsInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetExternalChannelsQuery = { __typename?: 'Query', externalChannels: { __typename?: 'ExternalChannelConnection', totalCount: number, nodes?: Array<{ __typename?: 'ExternalChannel', id: string, createdAt: any, organizationId: string, teamId?: string | null, userId?: string | null, channelType: ExternalChannelType, externalIdentifier: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetExternalIdMappingsQueryVariables = Exact<{
  input: GetExternalIdMappingsInput;
}>;


export type GetExternalIdMappingsQuery = { __typename?: 'Query', getExternalIdMappings: { __typename?: 'GetExternalIdMappingsPayload', externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', externalId: string, integrationType: string }> } };

export type GetExternalMessagesByUserQueryVariables = Exact<{
  input: ExternalMessagesByUserInput;
}>;


export type GetExternalMessagesByUserQuery = { __typename?: 'Query', externalMessagesByUser: { __typename?: 'ExternalMessagesByUserPayload', externalMessageUserSummary: Array<{ __typename?: 'ExternalMessageUserSummary', userId: string, lastClassifiedAt?: any | null, externalMessageDaySummaries: Array<{ __typename?: 'ExternalMessageDaySummary', date: any, failedCount: number, classifiedCount: number }> }> } };

export type GetMessageApplicableGenericTransformationsQueryVariables = Exact<{
  input: ApplicableGenericTransformationsInput;
}>;


export type GetMessageApplicableGenericTransformationsQuery = { __typename?: 'Query', applicableGenericTransformations: { __typename?: 'ApplicableGenericTransformationsPayload', genericTransformationIds: Array<string>, resultingClasses: Array<{ __typename?: 'ExternalMessageClassificationGraphQL', type: string, confidence?: number | null }> } };

export type MessageEntityAssociationsQueryVariables = Exact<{
  input?: InputMaybe<MessageEntityAssociationsInput>;
}>;


export type MessageEntityAssociationsQuery = { __typename?: 'Query', messageEntityAssociations: { __typename?: 'MessageEntityAssociationConnection', edges: Array<{ __typename?: 'MessageEntityAssociationEdge', node: { __typename?: 'MessageEntityAssociation', externalMessageId: string, entityId?: string | null } }> } };

export type MessageQuoteAssociationsQueryVariables = Exact<{
  input?: InputMaybe<MessageQuoteAssociationsInput>;
}>;


export type MessageQuoteAssociationsQuery = { __typename?: 'Query', messageQuoteAssociations: { __typename?: 'MessageQuoteAssociationConnection', nodes?: Array<{ __typename?: 'MessageQuoteAssociation', quote: { __typename?: 'Quote', responseTime?: number | null } }> | null } };

export type QuoteExternalThreadsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteExternalThreadsQuery = { __typename?: 'Query', quoteById: { __typename?: 'Quote', id: string, externalThreads: Array<{ __typename?: 'QuoteExternalThread', externalThreadId: string, threadType: ExternalMessageType, messages: Array<{ __typename?: 'QuoteExternalThreadMessage', id?: string | null, internetMessageId?: string | null, subject?: string | null, recipientAddresses?: Array<string> | null, senderAddress?: string | null, content?: string | null, receivedAt?: string | null, isDraft?: boolean | null }> }> } };

export type RelatedExternalMessagesQueryVariables = Exact<{
  input: RelatedExternalMessagesInput;
}>;


export type RelatedExternalMessagesQuery = { __typename?: 'Query', relatedExternalMessages: Array<{ __typename?: 'ExternalMessage', id: string, type: ExternalMessageType, externalIdentifier: string, status: ClassificationStatus, emailMetadata?: any | null, classifications?: any | null, user?: { __typename?: 'User', id: string } | null }> };

export type FrontSharedInboxesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type FrontSharedInboxesQuery = { __typename?: 'Query', frontSharedInboxes: Array<{ __typename?: 'FrontInbox', id: string, name: string, address?: string | null, type?: string | null, isPrivate?: boolean | null }> };

export type UserFrontMailboxSubscriptionsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type UserFrontMailboxSubscriptionsQuery = { __typename?: 'Query', frontMailboxSubscriptions: Array<{ __typename?: 'FrontMailboxSubscription', id: string, externalId: string, organizationId: string, ownerId: string, createdAt: any, name?: string | null }> };

export type GetGenericTransformationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetGenericTransformationQuery = { __typename?: 'Query', genericTransformationById: { __typename?: 'GenericTransformation', id: string, createdAt: any, seq: number, genericRuleId: string, transformationConfigId: string, templateId?: string | null, templateVersion?: number | null, genericRule: { __typename?: 'GenericRule', id: string, type: string, organization: { __typename?: 'Organization', id: string } }, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } } };

export type GetGenericTransformationsQueryVariables = Exact<{
  input?: InputMaybe<GenericTransformationsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetGenericTransformationsQuery = { __typename?: 'Query', genericTransformations: { __typename?: 'GenericTransformationConnection', count: number, totalCount: number, edges: Array<{ __typename?: 'GenericTransformationEdge', node: { __typename?: 'GenericTransformation', id: string, createdAt: any, seq: number, genericRuleId: string, transformationConfigId: string, templateId?: string | null, templateVersion?: number | null, genericRule: { __typename?: 'GenericRule', id: string, type: string, organization: { __typename?: 'Organization', id: string } }, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } } }>, nodes?: Array<{ __typename?: 'GenericTransformation', id: string, createdAt: any, seq: number, genericRuleId: string, transformationConfigId: string, templateId?: string | null, templateVersion?: number | null, genericRule: { __typename?: 'GenericRule', id: string, type: string, organization: { __typename?: 'Organization', id: string } }, transformationConfig: { __typename?: 'TransformationConfig', id: string, params: any, transformationDefinition: { __typename?: 'TransformationDefinition', id: string, definition: any } } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type TestHighwayCredentialsQueryVariables = Exact<{
  input: HighwayCredentialTestInput;
}>;


export type TestHighwayCredentialsQuery = { __typename?: 'Query', testHighwayCredentials: { __typename?: 'HighwayCredentialTestPayload', organizationId: string, allPassed: boolean, results: Array<{ __typename?: 'HighwayCredentialTestResult', name: string, status: IntegrationCheckStatus, message: string }> } };

export type HostedMcLeodIntegrationHealthQueryVariables = Exact<{
  input: HostedMcLeodIntegrationHealthInput;
}>;


export type HostedMcLeodIntegrationHealthQuery = { __typename?: 'Query', hostedMcLeodIntegrationHealth: { __typename?: 'HostedMcLeodIntegrationHealthPayload', organizationId: string, passCount: number, failCount: number, warnCount: number, skipCount: number, checks: Array<{ __typename?: 'IntegrationCheckDetail', name: string, status: IntegrationCheckStatus, message: string }> } };

export type TestHostedMcLeodCredentialsQueryVariables = Exact<{
  input: HostedMcLeodCredentialTestInput;
}>;


export type TestHostedMcLeodCredentialsQuery = { __typename?: 'Query', testHostedMcLeodCredentials: { __typename?: 'HostedMcLeodCredentialTestPayload', organizationId: string, allPassed: boolean, results: Array<{ __typename?: 'IntegrationCheckDetail', name: string, status: IntegrationCheckStatus, message: string }> } };

export type CheckIntegrationCredentialsQueryVariables = Exact<{
  input: CheckIntegrationCredentialsInput;
}>;


export type CheckIntegrationCredentialsQuery = { __typename?: 'Query', checkIntegrationCredentials: { __typename?: 'CheckIntegrationCredentialsPayload', result: IntegrationCheckResult } };

export type ListIntegrationCredentialsQueryVariables = Exact<{
  input: ListIntegrationCredentialsInput;
}>;


export type ListIntegrationCredentialsQuery = { __typename?: 'Query', integrationCredentials: Array<{ __typename?: 'IntegrationCredentialsSummary', id: string, type: IntegrationCredentialsType, name?: string | null, usageIndicator: UsageIndicator, configPaths: Array<string> }> };

export type GetConfiguredCarrierVerificationCredentialTypesQueryVariables = Exact<{
  input: ConfiguredCarrierVerificationCredentialTypesInput;
}>;


export type GetConfiguredCarrierVerificationCredentialTypesQuery = { __typename?: 'Query', configuredCarrierVerificationCredentialTypes: { __typename?: 'ConfiguredCarrierVerificationCredentialTypesPayload', credentialTypes: Array<IntegrationCredentialsType> } };

export type GetIntegrationVerificationEventsQueryVariables = Exact<{
  input: IntegrationVerificationEventsInput;
}>;


export type GetIntegrationVerificationEventsQuery = { __typename?: 'Query', integrationVerificationEvents: Array<{ __typename?: 'IntegrationVerificationEvent', id: string, createdAt: any, name: IntegrationVerificationEventType, data?: { __typename?: 'IntegrationVerificationEventData', integrationType?: IntegrationType | null, credentialType?: string | null, success: boolean, error?: string | null } | null }> };

export type JobSimulatorPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobSimulatorPreviewQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string } | null, jobById: { __typename?: 'Job', id: string, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, source: JobSource, optimismStatus: OptimismStatus, user?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, orders: Array<{ __typename?: 'Order', id: string, hasSubmittedEvent: boolean, primaryReference?: string | null, extractedData?: string | null, createdAt: any, createdAtDisplay?: any | null, externalDeepLink?: string | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', id: string, name: string } | null, job: { __typename?: 'Job', emailMetadata?: any | null }, orderEvents: Array<{ __typename?: 'OrderEvent', id: string, createdAt: any, type: OrderEventType, orderId: string }> }>, quotes: Array<{ __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null }>, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }> } };

export type QuoteJobSimulationHierarchyLevelFieldsFragment = { __typename?: 'HierarchyLevelSettings', autoReply?: any | null, pricingStrategyResolutionError?: string | null, settingsCount: number, entity?: { __typename?: 'SettingsEntityInfo', id: string, type: SettingsEntityType, name: string } | null, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null };

export type QuoteJobSimulationSettingsQueryVariables = Exact<{
  input: QuoteJobSimulationSettingsInput;
}>;


export type QuoteJobSimulationSettingsQuery = { __typename?: 'Query', quoteJobSimulationSettings: { __typename?: 'QuoteJobSimulationSettingsPayload', resolved: { __typename?: 'QuoteJobSimulationResolvedSettings', quoteAutoReply: any, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null }, levels: { __typename?: 'QuoteSimulationLevels', user?: { __typename?: 'HierarchyLevelSettings', autoReply?: any | null, pricingStrategyResolutionError?: string | null, settingsCount: number, entity?: { __typename?: 'SettingsEntityInfo', id: string, type: SettingsEntityType, name: string } | null, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null } | null, team?: { __typename?: 'HierarchyLevelSettings', autoReply?: any | null, pricingStrategyResolutionError?: string | null, settingsCount: number, entity?: { __typename?: 'SettingsEntityInfo', id: string, type: SettingsEntityType, name: string } | null, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null } | null, originator?: { __typename?: 'HierarchyLevelSettings', autoReply?: any | null, pricingStrategyResolutionError?: string | null, settingsCount: number, entity?: { __typename?: 'SettingsEntityInfo', id: string, type: SettingsEntityType, name: string } | null, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null } | null, organization: { __typename?: 'HierarchyLevelSettings', autoReply?: any | null, pricingStrategyResolutionError?: string | null, settingsCount: number, entity?: { __typename?: 'SettingsEntityInfo', id: string, type: SettingsEntityType, name: string } | null, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null }, global: { __typename?: 'HierarchyLevelSettings', autoReply?: any | null, pricingStrategyResolutionError?: string | null, settingsCount: number, entity?: { __typename?: 'SettingsEntityInfo', id: string, type: SettingsEntityType, name: string } | null, pricingStrategy?: { __typename?: 'PricingStrategy', id: string, type: PricingStrategyType, config: any } | null } } } };

export type KnowledgeBaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type KnowledgeBaseQuery = { __typename?: 'Query', knowledgeBaseById: { __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> } };

export type KnowledgeBasesQueryVariables = Exact<{
  input: KnowledgeBasesInput;
}>;


export type KnowledgeBasesQuery = { __typename?: 'Query', knowledgeBases: { __typename?: 'KnowledgeBaseConnection', edges: Array<{ __typename?: 'KnowledgeBaseEdge', node: { __typename?: 'KnowledgeBase', id: string, name: string, documents: Array<{ __typename?: 'KnowledgeBaseDocumentUpload', id: string, name?: string | null, url: string }> } }> } };

export type GetMemoriesQueryVariables = Exact<{
  input?: InputMaybe<MemoriesInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetMemoriesQuery = { __typename?: 'Query', memories: { __typename?: 'MemoryConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'MemoryEdge', node: { __typename?: 'Memory', id: string, createdAt: any, computationType?: SavedComputationType | null, comment?: string | null, organization: { __typename?: 'Organization', id: string }, labeledComputation?: { __typename?: 'LabeledComputation', id: string, savedComputation: { __typename?: 'SavedComputation', id: string, originatorId?: string | null, jobId?: string | null } } | null, entityLinks?: Array<{ __typename?: 'MemoryEntityLink', id: string, actionDefinitionId?: string | null, organizationId?: string | null, teamId?: string | null, userId?: string | null, originatorId?: string | null, carrierId?: string | null, contactId?: string | null, placeId?: string | null, quoteId?: string | null, orderId?: string | null, shipmentId?: string | null, movementId?: string | null }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type MemoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MemoryQuery = { __typename?: 'Query', memoryById: { __typename?: 'Memory', id: string, createdAt: any, computationType?: SavedComputationType | null, comment?: string | null, organization: { __typename?: 'Organization', id: string }, labeledComputation?: { __typename?: 'LabeledComputation', id: string, savedComputation: { __typename?: 'SavedComputation', id: string, originatorId?: string | null, jobId?: string | null } } | null, entityLinks?: Array<{ __typename?: 'MemoryEntityLink', id: string, actionDefinition?: { __typename?: 'ActionDefinition', id: string, name: string } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null, team?: { __typename?: 'Team', id: string, name: string } | null, user?: { __typename?: 'User', id: string, username?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, carrier?: { __typename?: 'Carrier', id: string, name: string } | null, contact?: { __typename?: 'Contact', id: string, name: string } | null, contactMethod?: { __typename?: 'ContactMethodRecord', id: string, email?: string | null, phoneNumber?: string | null } | null, place?: { __typename?: 'Place', id: string, name?: string | null } | null, quote?: { __typename?: 'Quote', id: string } | null, order?: { __typename?: 'Order', id: string } | null, shipment?: { __typename?: 'Shipment', id: string } | null, movement?: { __typename?: 'Movement', id: string } | null }> | null } };

export type GetMyMessageRatingsQueryVariables = Exact<{
  input: MyMessageRatingsInput;
}>;


export type GetMyMessageRatingsQuery = { __typename?: 'Query', myMessageRatings: Array<{ __typename?: 'MessageRating', id: string, messageId: string, isPositive: boolean, reason?: MessageRatingReason | null, comments?: string | null }> };

export type GetActivePostingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActivePostingsQuery = { __typename?: 'Query', getActivePostings?: { __typename?: 'GetActivePostingsResponse', postings: Array<{ __typename?: 'LoadBoardPosting', externalId: string, integrationType: IntegrationType, postingUrl?: string | null }> } | null };

export type GetExceptionEventsQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GetExceptionEventsQuery = { __typename?: 'Query', exceptionEventsByMovementId: Array<{ __typename?: 'TrackingEventWithActionExecution', event: { __typename?: 'MovementEvent', id: string, createdAt: any, name: MovementEventType, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData' } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }, actionExecutions: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, input: any, output?: any | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string } }> }> };

export type MovementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MovementQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', seq: number, customerRate?: number | null, inquiryCount: number, commodity?: string | null, negotiationStrategyConfigOverride?: any | null, id: string, isTrackingPaused: boolean, attributes?: any | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null }>, shipment: { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> }, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }> } };

export type MovementConversationsQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type MovementConversationsQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', id: string, conversations: Array<{ __typename?: 'Conversation', id: string, organizationId: string, title?: string | null, externalIdentifier: string, createdAt: any, type: ConversationType, status: ConversationStatus, mediaUrl?: string | null, associatedCarriers: Array<{ __typename?: 'Carrier', id: string, name: string }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata', outlookConversationId?: string | null, gmailThreadId?: string | null, frontConversationId?: string | null, alreadyCcdRecipients?: Array<string> | null } | { __typename?: 'MicrosoftTeamsConversationMetadata', teamsConversationType: string, participantUserIds: Array<string> } | { __typename?: 'PhoneConversationMetadata', fromPhoneNumber: string, toPhoneNumber: string, toPhoneNumberExtension?: string | null, initiationDirection: ConversationInitiationDirection } | { __typename?: 'SMSConversationMetadata', ourPhoneNumber: string, theirPhoneNumber: string } | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, transferSummary?: string | null, sentiment?: ConversationSummarySentiment | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string, rationale: string }> | null, eventLabels?: Array<{ __typename?: 'ConversationEventLabel', order: number, event: string, rationale: string }> | null } | null, ratings: Array<{ __typename?: 'ConversationRating', id: string, createdAt: any, userId: string, starRating: number, comments?: string | null }>, analyses: Array<{ __typename?: 'ConversationAnalysis', id: string, type: string, name: string, status: ProcessingStatus, results?: any | null }>, events: Array<{ __typename?: 'ConversationEvent', id: string, createdAt: any, name: ConversationEventType, data?: { __typename?: 'AsyncTransferData', eventDataType: ConversationEventType, ccRecipients: Array<string>, shipmentId?: string | null } | { __typename?: 'CallEndedData', eventDataType: ConversationEventType } | { __typename?: 'CallFailedData', eventDataType: ConversationEventType } | { __typename?: 'CallRecordingReceivedData', eventDataType: ConversationEventType, recordingStartTime: any, recordingEndTime: any } | { __typename?: 'CallRecordingStartedData' } | { __typename?: 'CallTransferAcceptedData', eventDataType: ConversationEventType, conferenceId: string, transferCallSid: string } | { __typename?: 'CallTransferredData', eventDataType: ConversationEventType, phoneNumber: string, extension?: string | null, overrideCallerId?: boolean | null } | { __typename?: 'ChatViewContextUpdatedData', eventDataType: ConversationEventType, context: any } | { __typename?: 'ConferenceJoinedData', eventDataType: ConversationEventType, conferenceId: string } | { __typename?: 'QuietLineIntentData', eventDataType: ConversationEventType } | { __typename?: 'ReturnedToTransferredCallData', eventDataType: ConversationEventType, transferAttemptConversationId?: string | null, conferenceId: string } | { __typename?: 'UnknownConversationEventData' } | { __typename?: 'WatcherClosedData' } | null }> }> } };

export type MovementDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MovementDetailsQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', details?: any | null, attributes?: any | null, coverageStatus?: CoverageStatus | null } };

export type GetMovementDynamoStatusesQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GetMovementDynamoStatusesQuery = { __typename?: 'Query', movementDynamoStatuses: Array<{ __typename?: 'MovementDynamoStatus', timestamp: string, lat: number, lon: number, city?: string | null, state?: string | null, source?: string | null, metadata?: any | null }> };

export type GetMovementLaneHistoryRadiusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovementLaneHistoryRadiusQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', id: string, laneHistoryRadiusMiles: number } };

export type GetMovementTrackingHeaderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovementTrackingHeaderQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', id: string, organizationId: string, linkedDocuments: Array<{ __typename?: 'MovementLinkedDocument', id: string, type: string, url?: string | null, uploadedAt?: any | null }>, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData', eventType: MovementEventType, appointments?: Array<{ __typename?: 'ConfirmedAppointmentSnapshot', confirmationNumber?: string | null }> | null } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData', eventType: MovementEventType, rate?: number | null, facilitatedByVooma?: boolean | null, carrier?: { __typename?: 'CarrierSnapshot', name?: string | null, externalId?: string | null } | null } | { __typename?: 'ExceptionCreatedData' } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData', eventType: MovementEventType } | { __typename?: 'LoadTakenOffHoldData', eventType: MovementEventType } | { __typename?: 'MovementCarrierChangedData', eventType: MovementEventType, from?: { __typename?: 'CarrierSnapshot', name?: string | null, externalId?: string | null, driver?: { __typename?: 'MovementCarrierContact', name?: string | null } | null, dispatch?: { __typename?: 'MovementCarrierContact', name?: string | null } | null } | null, to: { __typename?: 'CarrierSnapshot', name?: string | null, externalId?: string | null, driver?: { __typename?: 'MovementCarrierContact', name?: string | null } | null, dispatch?: { __typename?: 'MovementCarrierContact', name?: string | null } | null } } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData', eventType: MovementEventType } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData', eventType: MovementEventType } | { __typename?: 'ReadyForCoverageData', eventType: MovementEventType } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData', eventType: MovementEventType, eta: string } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData', eventType: MovementEventType, skipReason: TrackingMilestoneSkipReason, milestone: { __typename?: 'TrackingMilestone', type: TrackingMilestoneType } } | { __typename?: 'TrackingPausedData', eventType: MovementEventType, change: TrackingPauseChange, reason?: string | null, source?: TrackingPauseSource | null } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData', eventType: MovementEventType, tmsStatus?: string | null, changedFields?: Array<string> | null } | null }>, latestDynamoStatus?: { __typename?: 'MovementDynamoStatus', city?: string | null, state?: string | null, lat: number, lon: number, source?: string | null, timestamp: string } | null, shipment: { __typename?: 'Shipment', id: string, referenceNumbers?: Array<string> | null, externalDeepLink?: string | null, carrierRates?: Array<{ __typename?: 'ShipmentCarrierMetadata', name: string, buyRate?: number | null }> | null, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null, dispatchName?: string | null, dispatchPhone?: string | null, dispatchEmail?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null } | null } } };

export type MovementWithActionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MovementWithActionsQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', seq: number, customerRate?: number | null, inquiryCount: number, commodity?: string | null, negotiationStrategyConfigOverride?: any | null, id: string, isTrackingPaused: boolean, attributes?: any | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod, createdAt: any, loadData?: any | null, metadata?: any | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, actions: Array<{ __typename?: 'ActionExecution', output?: any | null }>, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null }>, shipment: { __typename?: 'Shipment', externalDeepLink?: string | null, id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> }, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }> } };

export type GetMovementsToCoverQueryVariables = Exact<{
  input: MovementsToCoverInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetMovementsToCoverQuery = { __typename?: 'Query', movementsToCover: { __typename?: 'MovementConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'MovementEdge', node: { __typename?: 'Movement', seq: number, customerRate?: number | null, inquiryCount: number, commodity?: string | null, negotiationStrategyConfigOverride?: any | null, id: string, isTrackingPaused: boolean, attributes?: any | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, loadData?: any | null, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null, quote?: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } | null, carrier?: { __typename?: 'Carrier', id: string, createdAt: any, name: string, mcNumber?: string | null, dotNumber: string, isInNetwork: boolean } | null, contact?: { __typename?: 'Contact', id: string, name: string, email?: string | null, phone?: string | null } | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null } | null }>, shipment: { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> }, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetStatusChangedEventsQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GetStatusChangedEventsQuery = { __typename?: 'Query', statusChangedEventsByMovementId: Array<{ __typename?: 'TrackingEventWithActionExecution', event: { __typename?: 'MovementEvent', id: string, createdAt: any, name: MovementEventType, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData' } | { __typename?: 'ExceptionResolvedData' } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData', eventType: MovementEventType, fromStatus?: MovementStatus | null, toStatus: MovementStatus, coverageStatus?: CoverageStatus | null, tmsStatus?: string | null } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }, actionExecutions: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, input: any, output?: any | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string } }> }> };

export type GetTrackingEventsQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GetTrackingEventsQuery = { __typename?: 'Query', trackingEventsByMovementId: Array<{ __typename?: 'TrackingEventWithActionExecution', event: { __typename?: 'MovementEvent', id: string, createdAt: any, name: MovementEventType, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData' } | { __typename?: 'ExceptionResolvedData' } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData', eventType: MovementEventType, onTime?: boolean | null, trackingDataAvailable?: boolean | null, currentExceptions?: Array<LoadExceptionType> | null, milesToLastDelivery?: number | null, infoToExchange?: string | null, contactMethod?: TrackingOutreachChannel | null, etaToLastDelivery?: any | null, milestone: { __typename?: 'TrackingMilestone', type: TrackingMilestoneType, stopNumber?: string | null }, location?: { __typename?: 'TrackingMilestoneLocation', city?: string | null, state?: string | null } | null } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }, actionExecutions: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, children: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, children: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }> }> };

export type IsMovementPostedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsMovementPostedQuery = { __typename?: 'Query', isMovementPosted?: boolean | null };

export type ComputeSmartPricingPriorsQueryVariables = Exact<{
  input: ComputeSmartPricingPriorsInput;
}>;


export type ComputeSmartPricingPriorsQuery = { __typename?: 'Query', computeSmartPricingPriors: { __typename?: 'SmartPricingPriorsResult', acceptancePriors: Array<{ __typename?: 'AcceptancePriorPoint', price: number, probability: number }>, continuationPriors: Array<{ __typename?: 'ContinuationPriorPoint', step: number, probability: number }> } };

export type GetCarrierInterestContextQueryVariables = Exact<{
  input: GetCarrierInterestContextInput;
}>;


export type GetCarrierInterestContextQuery = { __typename?: 'Query', carrierInterestContext?: { __typename?: 'CarrierInterestContextType', recentCarrierOffers?: Array<{ __typename?: 'RecentCarrierOfferType', price: number, createdAt: string }> | null, recentCarrierInquiries?: Array<{ __typename?: 'RecentCarrierInquiryType', createdAt: string, actionExecutionId: string, conversationId?: string | null }> | null, recentCarriersTransferred?: Array<{ __typename?: 'RecentCarrierTransferType', createdAt: string, actionExecutionId: string, conversationId: string, transferType: string }> | null, rateGuidance?: { __typename?: 'RateGuidanceType', byMethod: Array<{ __typename?: 'RateGuidanceByMethodType', method: RatingMethod, rate: number, createdAt?: string | null, reports?: number | null, highRate?: number | null, lowRate?: number | null, standardDeviation?: number | null, mileage?: number | null, loadToTruckRatio?: number | null, dataPoints?: number | null, totalLoads?: number | null, totalTrucks?: number | null, averageRatio?: number | null, confidenceScore?: number | null }> } | null, negotiationOffers?: Array<{ __typename?: 'NegotiationOfferType', movementId: string, offerAmount: number, offeredBy?: string | null, accepted: boolean, createdAt: string }> | null, historicalNegotiationOffers?: Array<{ __typename?: 'NegotiationOfferType', movementId: string, offerAmount: number, offeredBy?: string | null, accepted: boolean, createdAt: string }> | null } | null };

export type GetNegotiationStrategiesQueryVariables = Exact<{
  input?: InputMaybe<NegotiationStrategiesInput>;
}>;


export type GetNegotiationStrategiesQuery = { __typename?: 'Query', negotiationStrategies: Array<{ __typename?: 'NegotiationStrategy', id: string, name: string, type: NegotiationStrategyType }> };

export type GetNegotiationStrategyMarginQueryVariables = Exact<{
  input: NegotiationStrategyMarginInput;
}>;


export type GetNegotiationStrategyMarginQuery = { __typename?: 'Query', negotiationStrategyMargin: { __typename?: 'NegotiationStrategyMarginResult', conversationCount: number, acceptedMarginPerConversation?: number | null, bookedMarginPerConversation?: number | null, totalAcceptedMargin?: number | null, totalBookedMargin?: number | null } };

export type GetOrganizationProductsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationProductsQuery = { __typename?: 'Query', getOrganizationProducts: Array<Product> };

export type OrganizationSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationSettingsQuery = { __typename?: 'Query', organizationById: { __typename?: 'Organization', id: string, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } } };

export type GetOrgUserEmailSignaturesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrgUserEmailSignaturesQuery = { __typename?: 'Query', organizationById: { __typename?: 'Organization', userEmailSignatures: Array<{ __typename?: 'UserDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null, subjectId: string }> } };

export type GetOrganizationDocumentUploadsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationDocumentUploadsQuery = { __typename?: 'Query', organizationById: { __typename?: 'Organization', emailSignatures: Array<{ __typename?: 'OrganizationDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null }> } };

export type GetOrganizationFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationFeatureFlagsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, organizationsDetails: Array<{ __typename?: 'Organization', id: string, enabledFeatureFlags: Array<{ __typename?: 'OrganizationFeatureFlagPayload', id: string, name: string }> }> } | null };

export type GetOriginatorOrderTemplateQueryVariables = Exact<{
  input: GetOriginatorOrderTemplateInput;
}>;


export type GetOriginatorOrderTemplateQuery = { __typename?: 'Query', getOriginatorOrderTemplate: { __typename?: 'GetOriginatorOrderTemplatePayload', originatorName: string, template?: { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } | null } };

export type OriginatorSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OriginatorSettingsQuery = { __typename?: 'Query', originatorById: { __typename?: 'Originator', id: string, settings?: any | null } };

export type GetOriginatorsQueryVariables = Exact<{
  input: OriginatorsInput;
}>;


export type GetOriginatorsQuery = { __typename?: 'Query', originators: { __typename?: 'OriginatorConnection', edges: Array<{ __typename?: 'OriginatorEdge', node: { __typename?: 'Originator', id: string, transmitIds: Array<string>, name: string, createdAt: any, status: OriginatorStatus, autoSubmitScope: AutoSubmitScope, expectedWeeklyOrderCount?: number | null, configOverrides?: any | null, flagged: boolean, hasExtractedDataConfigured: boolean, attributes?: any | null, organization: { __typename?: 'Organization', id: string, name: string, type?: OrganizationType | null }, knownSenders: Array<{ __typename?: 'Contact', id: string, email?: string | null }>, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } }> } };

export type CreatePlaceMutationVariables = Exact<{
  input: CreatePlaceInput;
}>;


export type CreatePlaceMutation = { __typename?: 'Mutation', createPlace: { __typename?: 'CreatePlacePayload', success: boolean, failureReason?: PlaceCreationFailureReason | null, place: { __typename?: 'Place', id: string, deletedAt?: any | null, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, creationProvenance?: PlaceCreationProvenance | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null } } };

export type PlaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlaceQuery = { __typename?: 'Query', placeById: { __typename?: 'Place', id: string, deletedAt?: any | null, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, creationProvenance?: PlaceCreationProvenance | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null } };

export type PlaceSchedulingQueryVariables = Exact<{
  placeId: Scalars['ID']['input'];
}>;


export type PlaceSchedulingQuery = { __typename?: 'Query', placeScheduling: { __typename?: 'PlaceScheduling', placeId: string, methods: Array<{ __typename?: 'PlaceSchedulingMethod', id: string, method: any }> } };

export type GetPlacesQueryVariables = Exact<{
  input?: InputMaybe<PlacesInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetPlacesQuery = { __typename?: 'Query', places: { __typename?: 'PlaceConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'PlaceEdge', node: { __typename?: 'Place', id: string, deletedAt?: any | null, name?: string | null, data?: any | null, locationCode?: string | null, tags: Array<PlaceTag>, aliases?: Array<string> | null, creationProvenance?: PlaceCreationProvenance | null, address?: { __typename?: 'PlaceAddress', addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, notes?: { __typename?: 'NotesFields', notesFields: Array<{ __typename?: 'NotesField', notesType: NotesType, notes: string }> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type QuoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteQuery = { __typename?: 'Query', quoteById: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } };

export type QuoteEventsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteEventsQuery = { __typename?: 'Query', quoteById: { __typename?: 'Quote', id: string, extractedData?: any | null, originator?: { __typename?: 'Originator', name: string } | null, quoteEvents: Array<{ __typename?: 'QuoteEvent', createdAt: any, metadata?: any | null, type: QuoteEventType, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email?: string | null, id: string } | null }>, quoteNotes: Array<{ __typename?: 'QuoteNote', note?: string | null, createdAt: any, user: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email?: string | null, id: string } }> } };

export type QuoteMileageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteMileageQuery = { __typename?: 'Query', quoteMileage?: { __typename?: 'QuoteMileage', id: string, units: string, value: number } | null };

export type GetQuoteRateFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetQuoteRateFormQuery = { __typename?: 'Query', quoteById: { __typename?: 'Quote', rateForm: { __typename?: 'RateForm', carrierRateId?: string | null, customerRateId?: string | null, lineItems: Array<{ __typename?: 'RateLineItem', index?: number | null, componentId: string, type: RateComponentType, description?: string | null, buyRate: number, sellRate: number }> } } };

export type QuoteValidationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type QuoteValidationQuery = { __typename?: 'Query', quoteById: { __typename?: 'Quote', id: string, validation: { __typename?: 'QuoteValidationPayload', valid: boolean, missingFields?: Array<string> | null, validationMessage?: string | null } } };

export type GetQuotesQueryVariables = Exact<{
  input?: InputMaybe<QuotesInput>;
}>;


export type GetQuotesQuery = { __typename?: 'Query', quotes: { __typename?: 'QuoteConnection', totalCount: number, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, customFreightTags?: Array<string> | null, createdAt: any, notesCount: number, opportunityUserIds?: Array<string> | null, shipmentId?: string | null, mileageBetweenStops?: Array<number> | null, googleMapsEmbedUrl?: string | null, routeGeoCoordinates?: Array<{ __typename?: 'LatLng', latitude: number, longitude: number }> | null, organization: { __typename?: 'Organization', id: string, name: string, integrationConfigs?: any | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', customFreightTags?: Array<string> | null } }, originator?: { __typename?: 'Originator', id: string, name: string, transmitIds: Array<string>, status: OriginatorStatus, configOverrides?: any | null, externalIdMappings: Array<{ __typename?: 'ExternalIdMapping', id: string, externalId: string, integrationType: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null }>, customerRates: Array<{ __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, ratingMethod?: RatingMethod | null, metadata?: any | null }>, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, ratingMethod?: RatingMethod | null, metadata?: any | null, type: CustomerRateType, rate?: any | null } | null, job: { __typename?: 'Job', id: string, source: JobSource, createdAt: any, notes?: string | null, emailMetadata?: any | null, status: ProcessingStatus, redactedAt?: any | null, jobEvents: Array<{ __typename?: 'JobEvent', id: string, createdAt: any, type: JobEventType }>, orders: Array<{ __typename?: 'Order', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, primaryReference?: string | null, processingStatus: ProcessingStatus, hasSubmittedEvent: boolean, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, job: { __typename?: 'Job', redactedAt?: any | null } }>, quotes: Array<{ __typename?: 'Quote', id: string, createdAt: any, createdAtDisplay?: any | null, updatedAt?: any | null, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null }>, organization: { __typename?: 'Organization', id: string, type?: OrganizationType | null }, originator?: { __typename?: 'Originator', id: string, name: string } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null, documents: Array<{ __typename?: 'JobDocument', id: string, upload?: { __typename?: 'JobDocumentUpload', id: string, name?: string | null, url: string } | null }> } } }> } };

export type GetScheduleSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetScheduleSettingsQuery = { __typename?: 'Query', scheduleSettings: Array<{ __typename?: 'ScheduleSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, plannerActionDefinitionId?: string | null, createdAt: any, updatedAt?: any | null, planningSettings: { __typename: 'AgenticPlannerSettings', type: PlanningApproach } | { __typename: 'DeterministicPlanningSettings', type: PlanningApproach, sequencing: PlanningSequence } }> };

export type MovementSchedulePlanQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type MovementSchedulePlanQuery = { __typename?: 'Query', movementSchedulePlan?: { __typename?: 'SchedulePlan', id: string, status: SchedulePlanStatus, plan: any, planningActionExecution?: { __typename?: 'ActionExecution', id: string, status: ActionExecutionStatus } | null } | null };

export type SchedulePlanSchedulingInfoQueryVariables = Exact<{
  shipmentId: Scalars['ID']['input'];
}>;


export type SchedulePlanSchedulingInfoQuery = { __typename?: 'Query', shipmentById: { __typename?: 'Shipment', id: string, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any> } } };

export type SchedulePlansQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  statuses: Array<SchedulePlanStatus> | SchedulePlanStatus;
}>;


export type SchedulePlansQuery = { __typename?: 'Query', schedulePlans: Array<{ __typename?: 'SchedulePlan', id: string, status: SchedulePlanStatus, plan: any, movement: { __typename?: 'Movement', id: string, shipment: { __typename?: 'Shipment', id: string, referenceNumbers?: Array<string> | null } }, planningActionExecution?: { __typename?: 'ActionExecution', id: string, status: ActionExecutionStatus } | null }> };

export type GetNotificationSettingsQueryVariables = Exact<{
  input: NotificationSettingsInput;
}>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', notificationSettings: { __typename?: 'NotificationSettingsPayload', settingsByLevel: { __typename?: 'MultLevelNotificationSettings', ORGANIZATION: any, TEAM?: any | null, USER?: any | null }, resolvedSettingsByLevel: { __typename?: 'MultLevelNotificationSettings', ORGANIZATION: any, TEAM?: any | null, USER?: any | null } } };

export type SharedFileByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SharedFileByIdQuery = { __typename?: 'Query', sharedFileById: { __typename?: 'ReadSharedFilePayload', content?: string | null, file: { __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null }, version?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string, url?: string | null } | null } };

export type SharedFilesQueryVariables = Exact<{
  input?: InputMaybe<SharedFilesInput>;
}>;


export type SharedFilesQuery = { __typename?: 'Query', sharedFiles: { __typename?: 'SharedFileConnection', count: number, totalCount: number, nodes?: Array<{ __typename?: 'SharedFileSummary', id: string, scope: SharedFileScope, canEdit: boolean, currentVersion?: { __typename?: 'SharedFileVersionSummary', id: string, fileName: string, contentType: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type FindShipmentQueryVariables = Exact<{
  input: FindShipmentInput;
}>;


export type FindShipmentQuery = { __typename?: 'Query', findShipment: { __typename?: 'FindShipmentPayload', shipmentId: string } };

export type ShipmentDistanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ShipmentDistanceQuery = { __typename?: 'Query', getShipmentDistance?: { __typename?: 'ShipmentDistanceResult', distance: number, usdPerMile: number } | null };

export type GetLaneShipmentsQueryVariables = Exact<{
  input?: InputMaybe<ShipmentsInput>;
}>;


export type GetLaneShipmentsQuery = { __typename?: 'Query', shipments: { __typename?: 'ShipmentConnection', edges: Array<{ __typename?: 'ShipmentEdge', node: { __typename?: 'Shipment', id: string, externalId?: string | null, externalDeepLink?: string | null, carrierRates?: Array<{ __typename?: 'ShipmentCarrierMetadata', name: string, buyRate?: number | null, sellRate?: number | null, pickupAt?: string | null }> | null } }> } };

export type GetLoadBoardPostingsQueryVariables = Exact<{
  input: GetLoadBoardPostingsInput;
}>;


export type GetLoadBoardPostingsQuery = { __typename?: 'Query', getLoadBoardPostings: { __typename?: 'GetLoadBoardPostingsPayload', postings: Array<{ __typename?: 'LoadBoardPosting', integrationType: IntegrationType, externalId: string, postingUrl?: string | null }> } };

export type ShipmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ShipmentQuery = { __typename?: 'Query', shipmentById: { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, schedulingInfo: { __typename?: 'ShipmentSchedulingInfoPayload', stops: Array<any>, tmsId?: string | null }, trackingInfo: { __typename?: 'ShipmentTrackingInfoPayload', driverName?: string | null, driverPhone?: string | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> } };

export type GetShipmentsQueryVariables = Exact<{
  input?: InputMaybe<ShipmentsInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
  shouldUseDefaultView?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetShipmentsQuery = { __typename?: 'Query', shipments: { __typename?: 'ShipmentConnection', totalCount: number, count: number, savedViewRedirect?: string | null, edges: Array<{ __typename?: 'ShipmentEdge', node: { __typename?: 'Shipment', id: string, createdAt: any, externalId?: string | null, referenceNumbers?: Array<string> | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null } | null, movements: Array<{ __typename?: 'Movement', id: string, isTrackingPaused: boolean, attributes?: any | null, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null, movementEvents: Array<{ __typename?: 'MovementEvent', id: string, name: MovementEventType, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData', eventType: MovementEventType, exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }>, carrierRates: Array<{ __typename?: 'CarrierRate', id: string, computedRate?: any | null, ratingMethod: RatingMethod }>, pricing?: { __typename?: 'MovementPricing', targetPrice?: number | null, maxPrice?: number | null } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetSchedulePortalAvailabilityCheckQueryVariables = Exact<{
  input: GetSchedulePortalAvailabilityCheckInput;
}>;


export type GetSchedulePortalAvailabilityCheckQuery = { __typename?: 'Query', getSchedulePortalAvailabilityCheck: { __typename?: 'GetSchedulePortalAvailabilityCheckPayload', check: { __typename?: 'AvailabilityCheck', times: Array<any>, info: string, fields?: { __typename?: 'OpendockAvailabilityCheckFields', schedulePortalType: SchedulePortalType, day: string, warehouse: { __typename?: 'OpendockWarehouse', id: string, name: string }, warehouses: Array<{ __typename?: 'OpendockWarehouse', id: string, name: string }>, loadTypes: Array<{ __typename?: 'OpendockLoadType', id: string, name: string }>, loadType: { __typename?: 'OpendockLoadType', id: string, name: string }, dock: { __typename?: 'OpendockDock', id: string, name: string }, docks: Array<{ __typename?: 'OpendockDock', id: string, name: string }> } | null } } };

export type OpendockFragment = { __typename?: 'OpendockAvailabilityCheckFields', schedulePortalType: SchedulePortalType, day: string, warehouse: { __typename?: 'OpendockWarehouse', id: string, name: string }, warehouses: Array<{ __typename?: 'OpendockWarehouse', id: string, name: string }>, loadTypes: Array<{ __typename?: 'OpendockLoadType', id: string, name: string }>, loadType: { __typename?: 'OpendockLoadType', id: string, name: string }, dock: { __typename?: 'OpendockDock', id: string, name: string }, docks: Array<{ __typename?: 'OpendockDock', id: string, name: string }> };

export type TriggerSopAppointmentSchedulingMutationVariables = Exact<{
  input: TriggerSopAppointmentSchedulingInput;
}>;


export type TriggerSopAppointmentSchedulingMutation = { __typename?: 'Mutation', triggerSOPAppointmentScheduling: { __typename?: 'TriggerSOPAppointmentSchedulingPayload', success: boolean, error?: string | null } };

export type TriggerPortalAppointmentSchedulingMutationVariables = Exact<{
  input: TriggerPortalAppointmentSchedulingInput;
}>;


export type TriggerPortalAppointmentSchedulingMutation = { __typename?: 'Mutation', triggerPortalAppointmentScheduling: { __typename?: 'TriggerPortalAppointmentSchedulingPayload', success: boolean, error?: string | null } };

export type UpdatePlaceScheduleMethodMutationVariables = Exact<{
  input: UpdatePlaceScheduleMethodInput;
}>;


export type UpdatePlaceScheduleMethodMutation = { __typename?: 'Mutation', updatePlaceScheduleMethod: { __typename?: 'UpdatePlaceScheduleMethodPayload', success: boolean } };

export type SimulationBrokerOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SimulationBrokerOrganizationsQuery = { __typename?: 'Query', simulationBrokerOrganizations: Array<{ __typename?: 'SimulationOrganizationPayload', id: string, name: string }> };

export type SimulationOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SimulationOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationConnection', edges: Array<{ __typename?: 'OrganizationEdge', node: { __typename?: 'Organization', id: string, name: string } }> } };

export type SimulationSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SimulationSettingsQuery = { __typename?: 'Query', simulationSettings: { __typename?: 'SimulationSettingsPayload', organizationId: string, isSimulationBroker: boolean, enabled: boolean, intervalMinutes: number, carrierInquiryActionDefinitionId?: string | null, carrierInquiryActionDefinitionOrganizationId?: string | null } };

export type TemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TemplateQuery = { __typename?: 'Query', templateById: { __typename?: 'Template', id: string, type: TemplateType, orderBuildPrompt?: string | null, multiOrderPrompt?: string | null, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, modelConfig?: { __typename?: 'ModelConfig', documentInterpretationModel?: LlmName | null, computerVisionModel?: ComputerVisionModelName | null, replicationModel?: LlmName | null, multiOrderBuildStrategy?: MultiOrderBuildStrategy | null, groupByFields?: Array<string> | null } | null, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } };

export type GetTemplatesQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type GetTemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'TemplateConnection', edges: Array<{ __typename?: 'TemplateEdge', node: { __typename?: 'Template', id: string, type: TemplateType, currentRevision: { __typename?: 'TemplateRevision', jsonData?: string | null }, originator?: { __typename?: 'Originator', id: string } | null, organization?: { __typename?: 'Organization', id: string } | null } }> } };

export type GetActiveLoadsCountQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetActiveLoadsCountQuery = { __typename?: 'Query', activeLoadsCount: { __typename?: 'ActiveLoadsCount', active: number, inactive: number } };

export type GetExceptionEventsWithMessagesQueryVariables = Exact<{
  movementId: Scalars['ID']['input'];
}>;


export type GetExceptionEventsWithMessagesQuery = { __typename?: 'Query', exceptionEventsByMovementId: Array<{ __typename?: 'TrackingEventWithActionExecution', event: { __typename?: 'MovementEvent', id: string, createdAt: any, data?: { __typename?: 'AllAppointmentsConfirmedData' } | { __typename?: 'CarrierInquiryData' } | { __typename?: 'CoverOfferAcceptedData' } | { __typename?: 'CoverOfferData' } | { __typename?: 'CoveredData' } | { __typename?: 'ExceptionCreatedData', exception: { __typename?: 'LoadException', type: LoadExceptionType, data?: any | null } } | { __typename?: 'ExceptionResolvedData' } | { __typename?: 'ExceptionTriggerSuppressedData' } | { __typename?: 'LoadPutOnHoldData' } | { __typename?: 'LoadTakenOffHoldData' } | { __typename?: 'MovementCarrierChangedData' } | { __typename?: 'MovementStatusChangedData' } | { __typename?: 'NotReadyForCoverageData' } | { __typename?: 'PostedToLoadBoardData' } | { __typename?: 'PrePickupDelayStartedData' } | { __typename?: 'ReadyForCoverageData' } | { __typename?: 'RefreshedPostingOnLoadBoardData' } | { __typename?: 'RequestedPostToLoadBoardData' } | { __typename?: 'RequestedUnpostFromLoadBoardData' } | { __typename?: 'StopArrivedData' } | { __typename?: 'StopClearedData' } | { __typename?: 'StopEtaUpdatedData' } | { __typename?: 'TrackingMilestoneData' } | { __typename?: 'TrackingMilestoneSkippedData' } | { __typename?: 'TrackingPausedData' } | { __typename?: 'UnpostedFromLoadBoardData' } | { __typename?: 'UpdatedPostingOnLoadBoardData' } | { __typename?: 'WebhookReceivedData' } | null }, actionExecutions: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, externalMessages: Array<{ __typename?: 'ExternalMessage', id: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, emailMetadata?: any | null }>, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, children: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, children: Array<{ __typename?: 'ActionExecution', id: string, createdAt: any, status: ActionExecutionStatus, conversationId?: string | null, input: any, output?: any | null, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, conversation?: { __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null } | null, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }>, actionDefinition: { __typename?: 'ActionDefinition', id: string, name: string, sopMetadata?: { __typename?: 'SopMetadata', trackStepKind?: TrackStepKind | null } | null }, linkedConversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, createdAt: any, title?: string | null, summary?: { __typename?: 'ConversationSummary', summary?: string | null, outcomeLabels?: Array<{ __typename?: 'ConversationOutcomeLabel', outcome: string }> | null } | null, metadata?: { __typename?: 'ChatConversationMetadata' } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata', toPhoneNumber: string, fromPhoneNumber: string, initiationDirection: ConversationInitiationDirection, telephonyDurationSeconds?: number | null } | { __typename?: 'SMSConversationMetadata', theirPhoneNumber: string } | null }> }> }> };

export type GetMovementChatConversationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovementChatConversationsQuery = { __typename?: 'Query', movementById: { __typename?: 'Movement', id: string, conversations: Array<{ __typename?: 'Conversation', id: string, type: ConversationType, title?: string | null, createdAt: any, summary?: { __typename?: 'ConversationSummary', summary?: string | null } | null, metadata?: { __typename?: 'ChatConversationMetadata', context?: any | null } | { __typename?: 'EmailConversationMetadata' } | { __typename?: 'MicrosoftTeamsConversationMetadata' } | { __typename?: 'PhoneConversationMetadata' } | { __typename?: 'SMSConversationMetadata' } | null, externalMessages: Array<{ __typename?: 'ExternalMessage', id: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null } | null }> }>, chatConversations: Array<{ __typename?: 'Conversation', id: string, title?: string | null, externalMessages: Array<{ __typename?: 'ExternalMessage', id: string, type: ExternalMessageType, createdAt: any, content?: any | null, htmlBody?: any | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null } | null }> }>, linkedPartyMessages: Array<{ __typename?: 'MovementLinkedMessage', parties: Array<MovementConversationParty>, message: { __typename?: 'ExternalMessage', id: string, type: ExternalMessageType, createdAt: any, conversationId?: string | null, externalThreadId?: string | null, content?: any | null, htmlBody?: any | null, emailMetadata?: any | null, documents: Array<{ __typename?: 'ExternalMessageDocumentUpload', id: string, name?: string | null, url: string }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile', name?: string | null } | null } | null } }> } };

export type GetMovementsWithTrackSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMovementsWithTrackSettingsQuery = { __typename?: 'Query', movementsWithTrackSettings: Array<{ __typename?: 'MovementWithTrackSettings', hasTrackSettings: boolean, isExcludedFromTracking: boolean, corruptedTrackingExceptionId?: string | null, openExceptionTypes: Array<string>, latestTrackStatus?: string | null, customerNames: Array<string>, movement: { __typename?: 'Movement', id: string, trackData?: any | null, details?: any | null, commodity?: string | null, shipperThreadId?: string | null, shipment: { __typename?: 'Shipment', id: string, referenceNumbers?: Array<string> | null, movements: Array<{ __typename?: 'Movement', id: string, stops?: Array<{ __typename?: 'Stop', location: { __typename?: 'Location', name: string, addressOne?: string | null, addressTwo?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, geoCoordinates?: { __typename?: 'GeoCoordinates', latitude: number, longitude: number } | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> }> | null }> } }, primaryResponsibleParty?: { __typename?: 'ResponsibleParty', name?: string | null, email?: string | null } | null }> };

export type GetTrackConversationMessagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTrackConversationMessagesQuery = { __typename?: 'Query', conversationById: { __typename?: 'Conversation', id: string, mediaUrl?: string | null, externalMessages: Array<{ __typename?: 'ExternalMessage', id: string, createdAt: any, content?: any | null }> } };

export type GetTrackDashboardSummaryQueryVariables = Exact<{
  input: TrackDashboardSummaryInput;
}>;


export type GetTrackDashboardSummaryQuery = { __typename?: 'Query', trackDashboardSummary: { __typename?: 'TrackDashboardSummary', timezone: string, automatedRuns: number, priorPeriodAutomatedRuns: number, trendGranularity: TrackDashboardTrendGranularity, currentTrendBucket: string, estimatedHoursSaved: number, automatedRunsTrend: Array<{ __typename?: 'TrackDashboardTrendBucket', bucket: string, count: number }>, automatedRunsByMilestone: Array<{ __typename?: 'TrackDashboardCategoryCount', category: string, count: number }>, totals: { __typename?: 'TrackDashboardTotals', calls: number, emails: number, sms: number, shipperUpdates: number, statusChanges: number, timeUpdates: number, tmsComments: number, sopRuns: number, escalations: number, missingInfo: number, computedAt?: any | null }, disruptions: { __typename?: 'TrackDashboardDisruptions', saved: number, total: number }, disruptionsByWeek: Array<{ __typename?: 'TrackDashboardWeeklyDisruptions', weekStart: string, saved: number, total: number }>, sopCheckScores: Array<{ __typename?: 'TrackDashboardCheckScore', checkName: string, passCount: number, failCount: number }>, exceptionsByType: Array<{ __typename?: 'TrackDashboardCategoryCount', category: string, count: number }> } };

export type GetTrackSettingsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetTrackSettingsQuery = { __typename?: 'Query', trackSettings: Array<{ __typename?: 'TrackSettings', id: string, organizationId: string, name?: string | null, isActive: boolean, isDefault: boolean, createdAt: any, updatedAt?: any | null, stopSettings: { __typename?: 'StopSettings', pickup: { __typename?: 'PickupTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'PickupBeforeSettings', enabled?: boolean | null, trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, suppressIfCarrierChangedWithinMinutes?: number | null, advanced?: { __typename?: 'AdvancedBeforeTriggerSettings', appointment: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor }, windowTiers: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> } | null, triggers?: Array<{ __typename?: 'MilestoneBeforeTriggerSettings', triggerType: MilestoneBeforeTrigger, enabled: boolean, params?: { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, beforeConfigs?: Array<{ __typename?: 'PickupBeforeSettings', enabled?: boolean | null, trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, suppressIfCarrierChangedWithinMinutes?: number | null, advanced?: { __typename?: 'AdvancedBeforeTriggerSettings', appointment: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor }, windowTiers: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> } | null }> | null, after?: { __typename?: 'PickupAfterSettings', enabled?: boolean | null, minutesAfter?: number | null, triggers?: Array<{ __typename?: 'MilestoneAfterTriggerSettings', triggerType: MilestoneAfterTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, at?: { __typename?: 'PickupAtSettings', enabled?: boolean | null, delayMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneAtTriggerSettings', triggerType: MilestoneAtTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, actualArrival?: { __typename?: 'PickupActualArrivalSettings', enabled?: boolean | null } | null, actualDeparture?: { __typename?: 'PickupActualDepartureSettings', enabled?: boolean | null } | null, preDispatch?: { __typename?: 'PreDispatchSettings', enabled?: boolean | null, minutesBefore?: number | null, triggers?: Array<{ __typename?: 'PreDispatchTriggerSettings', triggerType: PreDispatchTrigger, enabled: boolean, params?: { __typename?: 'PreDispatchTriggerParams', minutesBefore?: number | null, cutoffHour?: number | null, hoursBeforeCutoffForEarlyPickups?: number | null, hoursBeforeCutoffForLatePickups?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null }, stops: { __typename?: 'StopTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'MilestoneBeforeSettings', enabled?: boolean | null, minutesBefore?: number | null } | null, after?: { __typename?: 'MilestoneAfterSettings', enabled?: boolean | null, minutesAfter?: number | null } | null, at?: { __typename?: 'MilestoneAtSettings', enabled?: boolean | null, delayMinutes?: number | null } | null }, delivery: { __typename?: 'DeliveryTrackEventSettings', checkTypes?: Array<CheckTypes> | null, timeWindowMinutes?: number | null, before?: { __typename?: 'DeliveryBeforeSettings', enabled?: boolean | null, trigger?: MilestoneBeforeTrigger | null, minutesBefore?: number | null, triggers?: Array<{ __typename?: 'MilestoneBeforeTriggerSettings', triggerType: MilestoneBeforeTrigger, enabled: boolean, params?: { __typename?: 'AdvancedTriggerParams', appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, after?: { __typename?: 'DeliveryAfterSettings', enabled?: boolean | null, minutesAfter?: number | null, triggers?: Array<{ __typename?: 'MilestoneAfterTriggerSettings', triggerType: MilestoneAfterTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAfterTriggerParams', minutesAfter?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null, at?: { __typename?: 'DeliveryAtSettings', enabled?: boolean | null, delayMinutes?: number | null, triggers?: Array<{ __typename?: 'MilestoneAtTriggerSettings', triggerType: MilestoneAtTrigger, enabled: boolean, params?: { __typename?: 'MilestoneAtTriggerParams', delayMinutes?: number | null, appointment?: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } | null, windowTiers?: Array<{ __typename?: 'AdvancedTriggerWindowTier', maxDurationMinutes: number, offset: { __typename?: 'AdvancedTriggerOffset', minutes: number, direction: OffsetDirection, anchor: WindowAnchor } }> | null } | null }> | null } | null } }, enRouteSettings: { __typename?: 'EnRouteSettings', cadenceMode?: EnRouteCadenceMode | null, truckSpeedMph?: number | null, dailyDrivingHours?: number | null, trackingTrigger?: TrackingTrigger | null, enRoute: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null }, enRouteWithTracking?: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null } | null, enRouteWithoutTracking?: { __typename?: 'EnRouteTrackEventSettings', intervalMinutes?: number | null, firstMilestoneDelayMinutes?: number | null, fixedDailyTimes?: Array<string> | null, fixedDailyTimesTimezone?: string | null, filter?: EnRouteFilter | null, stopTrackingWithinMiles?: number | null, skipTrackingWithinMilesOfPickup?: number | null, includeTrackingAlertStatus?: boolean | null, distanceBasedIntervals?: { __typename?: 'DistanceBasedIntervals', defaultIntervalMinutes: number, thresholds: Array<{ __typename?: 'DistanceBasedIntervalThreshold', maxDistanceMiles: number, intervalMinutes: number }> } | null, closeToDeliveryInterval?: { __typename?: 'CloseToDeliveryInterval', intervalMinutes?: number | null, withinMiles?: number | null, withinMinutesOfDeliveryStart?: number | null } | null, smartFilter?: { __typename?: 'SmartFilterSettings', minDistanceMiles?: number | null } | null } | null, exceptionEventsSettings?: { __typename?: 'ExceptionEventsSettings', alertWindowMinutes?: number | null, quietPeriodAfterInTransitMinutes?: number | null, stationaryVehicle?: { __typename?: 'StationaryVehicleExceptionSettings', thresholdMinutes: number, suppressionPeriodMinutes?: number | null } | null, runningLate?: { __typename?: 'RunningLateExceptionSettings', enabled: boolean, suppressionPeriodMinutes?: number | null, toleranceMinutes?: number | null } | null, trackingDataNotAvailable?: { __typename?: 'TrackingDataNotAvailableExceptionSettings', enabled: boolean, suppressionPeriodMinutes?: number | null } | null, trackingDataStale?: { __typename?: 'TrackingDataStaleExceptionSettings', enabled: boolean, thresholdMinutes: number, suppressionPeriodMinutes?: number | null } | null, infoMissing?: { __typename?: 'InfoMissingExceptionSettings', enabled: boolean, checks: Array<InfoMissingCheckType>, suppressionPeriodMinutes?: number | null, evaluateAt?: InfoMissingEvaluateAt | null } | null, notYetDispatched?: { __typename?: 'NotYetDispatchedExceptionSettings', enabled: boolean, minutesBeforePickup?: number | null } | null, runningLateCloseToDelivery?: { __typename?: 'RunningLateCloseToDeliveryExceptionSettings', enabled: boolean, minutesBeforeDelivery?: number | null, toleranceMinutes?: number | null } | null, runningLateCloseToPickup?: { __typename?: 'RunningLateCloseToPickupExceptionSettings', enabled: boolean, minutesBeforePickup?: number | null, toleranceMinutes?: number | null } | null } | null }, nightHoursSettings?: { __typename?: 'NightHoursSettings', startHour?: number | null, endHour?: number | null, windowMinutes?: number | null, skipAllMilestones?: boolean | null } | null }> };

export type GetTrackShipmentInsightCountsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetTrackShipmentInsightCountsQuery = { __typename?: 'Query', trackShipmentInsightCounts: { __typename?: 'TrackShipmentInsightCounts', pastPickupLoads: number, readyForDispatch: number, withCarrierConversation: number, withDriverPhone: number } };

export type GetValhallaComparisonEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetValhallaComparisonEnabledQuery = { __typename?: 'Query', valhallaComparisonEnabled: boolean };

export type SimulateShouldTrackRuleQueryVariables = Exact<{
  input: SimulateShouldTrackRuleInput;
}>;


export type SimulateShouldTrackRuleQuery = { __typename?: 'Query', simulateShouldTrackRule: { __typename?: 'SimulateShouldTrackRulePayload', evaluatedCount: number, passedCount: number, results: Array<{ __typename?: 'ShouldTrackSimulationResult', movementId: string, shipmentId: string, shipmentReferenceNumber?: string | null, passed: boolean, error?: string | null, pickupStop?: { __typename?: 'Stop', location: { __typename?: 'Location', city?: string | null, state?: string | null }, dateTimeRanges: Array<{ __typename?: 'DateTimeRange', type?: DateTimeRangeType | null, start: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy }, end?: { __typename?: 'VDateTime', dateTime: string, timezone?: string | null, interpretationPolicy: DateTimeInterpretationPolicy } | null }> } | null }> } };

export type TrackedMovementsForExternalThreadQueryVariables = Exact<{
  input: RelatedExternalMessagesInput;
}>;


export type TrackedMovementsForExternalThreadQuery = { __typename?: 'Query', trackedMovementsForExternalThread: Array<{ __typename?: 'ThreadTrackedMovement', movementId: string, shipmentId: string, referenceNumber?: string | null, isPaused: boolean }> };

export type GetTruckerToolsScrapingConcurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTruckerToolsScrapingConcurrencyQuery = { __typename?: 'Query', truckerToolsScrapingConcurrency: number };

export type AdminEmailsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AdminEmailsQuery = { __typename?: 'Query', adminEmailsByIds: Array<{ __typename?: 'AdminEmail', id: string, email: string }> };

export type UserEmailSubscriptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserEmailSubscriptionsQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: string, emailSubscriptions: Array<{ __typename?: 'UserEmailSubscription', id: string, type: SubscriptionType, isActive: boolean, description?: string | null }> } };

export type UserSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserSettingsQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: string, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, transfersRateLimit?: any | null, notifications?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, quote?: any | null, pluginLandingPage?: PluginLandingPage | null } | null } };

export type UserSharedInboxesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SharedInboxInput;
}>;


export type UserSharedInboxesQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: string, sharedInboxes: Array<{ __typename?: 'SharedInbox', id: string, name: string, displayName?: string | null }> } };

export type GetUsersQueryVariables = Exact<{
  input?: InputMaybe<UsersInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, count: number, edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, username?: string | null, roles: Array<UserRole>, lastSignedIn?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type MyEmailSignaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEmailSignaturesQuery = { __typename?: 'Query', myEmailSignatures: Array<{ __typename?: 'UserDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null, subjectId: string }> };

export type UserFormDataQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserFormDataQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: string, username?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean } };

export type UserNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserNameQuery = { __typename?: 'Query', userById: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } };

export type GetToolSearchEmbeddingsEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToolSearchEmbeddingsEnabledQuery = { __typename?: 'Query', toolSearchEmbeddingsEnabled: boolean };

export type DeleteWorkerAuthTokenMutationVariables = Exact<{
  input: DeleteWorkerAuthTokenInput;
}>;


export type DeleteWorkerAuthTokenMutation = { __typename?: 'Mutation', deleteWorkerAuthToken: { __typename?: 'DeleteAuthTokenPayload', success: boolean } };

export type WorkerPreviewsQueryVariables = Exact<{
  input: UsersInput;
}>;


export type WorkerPreviewsQuery = { __typename?: 'Query', workers: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, profile?: { __typename?: 'AIProfile', name?: string | null } | { __typename?: 'HumanProfile' } | null } }> } };

export type WorkerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkerQuery = { __typename?: 'Query', workerById?: { __typename?: 'User', id: string, profile?: { __typename?: 'AIProfile', name?: string | null, backStory: string, humanisedDelay?: number | null, voiceId?: string | null, voiceModel?: SupportedVoiceModel | null, voiceSpeed?: number | null, languages?: Array<SupportedLanguage> | null } | { __typename?: 'HumanProfile' } | null, teams: Array<{ __typename?: 'Team', id: string, name: string, description: string, email?: string | null, members: Array<{ __typename?: 'TeamMember', id: string }>, aiPhoneNumbers?: Array<{ __typename?: 'AIPhoneNumber', id: string, phoneNumber: string, extension?: string | null }> | null, inboundPhoneCallTriggers: Array<{ __typename?: 'ActionTrigger', id: string, teamId?: string | null, triggerType: ActionTriggerConfigType, defaultAutonomyState?: AutonomyState | null, config: { __typename?: 'ConversationEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, conversationEventTypes: Array<ConversationEventType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'ExceptionCreatedTriggerConfig', triggerType: ActionTriggerConfigType, types: Array<ExceptionType>, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'GoogleChatMessageTriggerConfig', triggerType: ActionTriggerConfigType, googleChatSources: Array<GoogleChatMessageSource>, googleChatSpaceIds?: Array<string> | null, respondToAnySpaceMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'InboundPhoneCallTriggerConfig', triggerType: ActionTriggerConfigType, phoneNumbers: Array<string>, testPhoneNumber?: string | null, testPhoneNumberExpiresAt?: any | null, override?: { __typename?: 'InboundPhoneCallOverride', active: boolean, forwardToPhoneNumber: string } | null } | { __typename?: 'MicrosoftTeamsMessageTriggerConfig', triggerType: ActionTriggerConfigType, teamsSources: Array<MicrosoftTeamsMessageSource>, teamsChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'MovementEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, eventTypes: Array<MovementEventType>, exceptionTypes?: Array<LoadExceptionType> | null, originatorIds?: Array<string> | null, trackingMilestoneTypes?: Array<TrackingMilestoneType> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'NewClassifiedEmailThreadTriggerConfig', triggerType: ActionTriggerConfigType, classifications: Array<string>, recipientEmails?: Array<string> | null, senderEmails?: Array<string> | null, sideEffectPolicy?: ActionTriggerSideEffectPolicy | null, mailboxes?: EmailTriggerMailboxScope | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'OrderEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, orderEventTypes: Array<OrderEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'PylonWebhookTriggerConfig', triggerType: ActionTriggerConfigType, includePrivateMessages?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'QuoteEventCreatedTriggerConfig', triggerType: ActionTriggerConfigType, quoteEventTypes: Array<QuoteEventType>, originatorIds?: Array<string> | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'RepeatingTriggerConfig', triggerType: ActionTriggerConfigType, cronPattern: string, actionExecutionInput?: any | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null } | { __typename?: 'SlackMessageTriggerConfig', triggerType: ActionTriggerConfigType, sources: Array<SlackMessageSource>, slackChannelIds?: Array<string> | null, respondToAnyChannelMessage?: boolean | null, showToolActivity?: boolean | null, override?: { __typename?: 'BaseTriggerOverride', active: boolean } | null }, organization: { __typename?: 'Organization', id: string }, team?: { __typename?: 'Team', id: string, name: string } | null }> }>, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string }> } | null };

export type GetWorkerAuthorizedServiceQueryVariables = Exact<{
  input: WorkerHasAuthorizedServiceTypeInput;
}>;


export type GetWorkerAuthorizedServiceQuery = { __typename?: 'Query', workerHasAuthorizedServiceType: { __typename?: 'HasAuthorizedServiceTypePayload', success: boolean, email?: string | null } };

export type WorkerEmailSignaturesQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;


export type WorkerEmailSignaturesQuery = { __typename?: 'Query', workerEmailSignatures: Array<{ __typename?: 'UserDocumentUpload', id: string, name?: string | null, url: string, metadata?: any | null, subjectId: string }> };

export type ConversationActionExecutionUpdatedSubscriptionVariables = Exact<{
  conversationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type ConversationActionExecutionUpdatedSubscription = { __typename?: 'Subscription', conversationActionExecutionUpdated: { __typename?: 'ConversationActionExecutionUpdatePayload', actionExecutionId: string, conversationIds: Array<string>, eventId: string, eventType: ActionExecutionEventType, organizationId: string } };

export type ConversationUpdatedSubscriptionVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ConversationUpdatedSubscription = { __typename?: 'Subscription', conversationUpdated: { __typename?: 'ConversationUpdatePayload', conversationId: string, conversationType: ConversationType, messageId?: string | null, organizationId: string, type: ConversationUpdateType } };

export type GetQuoteSummariesQueryVariables = Exact<{
  input?: InputMaybe<QuotesInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetQuoteSummariesQuery = { __typename?: 'Query', quotes: { __typename?: 'QuoteConnection', totalCount: number, count: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'QuoteEdge', node: { __typename?: 'Quote', id: string, status: QuoteBidStatus, extractedData?: any | null, createdAt: any, createdAtDisplay?: any | null, optimismStatus: OptimismStatus, originator?: { __typename?: 'Originator', name: string } | null, job: { __typename?: 'Job', id: string, emailMetadata?: any | null, source: JobSource }, customerRate?: { __typename?: 'CustomerRate', id: string, createdAt: any, type: CustomerRateType, rate?: any | null, metadata?: any | null } | null, carrierRate?: { __typename?: 'CarrierRate', id: string, createdAt: any, ratingMethod: RatingMethod, computedRate?: any | null, metadata?: any | null } | null } }> } };

export type BasicUserFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, username?: string | null, email?: string | null, roles: Array<UserRole>, excludeFromReporting: boolean, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null };

export type OrganizationFragment = { __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } };

export type UserFragment = { __typename?: 'User', id: string, email?: string | null, username?: string | null, features?: any | null, roles: Array<UserRole>, excludeFromReporting: boolean, firstName?: string | null, lastName?: string | null, organizations: Array<{ __typename?: 'OrganizationUserRelation', id: string, organizationId: string, roles: Array<OrganizationUserRole> }>, organizationsDetails: Array<{ __typename?: 'Organization', id: string, name: string, products: Array<Product>, integrationConfigs?: any | null, type?: OrganizationType | null, logoUrl?: string | null, configurableOptions?: { __typename?: 'ConfigurableOptions', commodities?: Array<{ __typename?: 'CommodityOption', id: string, label: string }> | null } | null, settings: { __typename?: 'OrganizationSettings', accessPolicies?: any | null, build?: any | null, buildShipmentFromExternalDataInstructions?: string | null, cover?: any | null, customFreightTags?: Array<string> | null, emailScanning?: any | null, emailTags?: any | null, escalations?: any | null, escalationSuppressionPeriod?: any | null, front?: any | null, glossary?: any | null, locations?: any | null, movementEvents?: any | null, notifications?: any | null, pollStopChanges?: boolean | null, polling?: Array<string> | null, pollingIntervalMinutes?: number | null, otherCompanyIDs?: Array<string> | null, operatingName?: string | null, pronounceableOperatingName?: string | null, defaultTimezone?: string | null, mcNumber?: string | null, pylon?: any | null, quote?: any | null, quoteAutoReply?: any | null, carrierInterestContext?: any | null, retentionPeriodHours?: any | null, schedule?: any | null, simulation?: any | null, track?: any | null, spamGuard?: any | null, teamsWebhookUrl?: string | null, telephony?: any | null, transitModeling?: any | null, transfersRateLimit?: any | null } }>, settings?: { __typename?: 'UserSettings', timeDisplayStyle?: TimeDisplayStyle | null, autoReply?: any | null, emailTags?: any | null, browserExtensionDomainAllowlist?: Array<string> | null, pluginLandingPage?: PluginLandingPage | null } | null, profile?: { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null } | null };

export type PhoneNumberFragment = { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null };

export type HumanProfileFragment = { __typename?: 'HumanProfile', type: UserProfileType, name?: string | null, dtmfPin?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null };

export type AiProfileFragment = { __typename?: 'AIProfile', type: UserProfileType, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', phoneNumber: string, extension?: string | null } | null };

export const PlaceFormFieldsFragmentDoc = gql`
    fragment PlaceFormFields on Place {
  id
  name
  data
  address {
    addressOne
    addressTwo
    city
    state
    zip
    country
  }
  locationCode
  tags
  aliases
  originator {
    id
    name
  }
  notes {
    notesFields {
      notesType
      notes
    }
  }
}
    `;
export const NaturalLanguageProcedurePreviewFragmentDoc = gql`
    fragment NaturalLanguageProcedurePreview on NaturalLanguageProcedure {
  procedureType
}
    `;
export const GraphDefinedProcedurePreviewFragmentDoc = gql`
    fragment GraphDefinedProcedurePreview on GraphDefinedProcedure {
  procedureType
}
    `;
export const ConversationGraphProcedurePreviewFragmentDoc = gql`
    fragment ConversationGraphProcedurePreview on ConversationGraphProcedure {
  procedureType
  modality
}
    `;
export const DeterministicProcedurePreviewFragmentDoc = gql`
    fragment DeterministicProcedurePreview on DeterministicProcedure {
  procedureType
}
    `;
export const ActionDefinitionPreviewFragmentDoc = gql`
    fragment ActionDefinitionPreview on ActionDefinition {
  id
  createdAt
  updatedAt
  deletedAt
  name
  mode
  modelOverride
  reasoningEffort
  hasMemory
  classifyConversationMessages
  respondsToCoworkers
  runDetached
  runsOnExperimentalService
  defaultAutonomyState
  postCompletionMessageBehavior
  referringActionDefinitionsCount
  isEmbeddedInGraph
  triggersCount
  implementsTool
  sopMetadata {
    trackStepKind
    catalogKey
  }
  procedure {
    ...NaturalLanguageProcedurePreview
    ...GraphDefinedProcedurePreview
    ...ConversationGraphProcedurePreview
    ...DeterministicProcedurePreview
  }
  tags
}
    ${NaturalLanguageProcedurePreviewFragmentDoc}
${GraphDefinedProcedurePreviewFragmentDoc}
${ConversationGraphProcedurePreviewFragmentDoc}
${DeterministicProcedurePreviewFragmentDoc}`;
export const ActionTriggerPreviewFragmentDoc = gql`
    fragment ActionTriggerPreview on ActionTrigger {
  id
  teamId
  organization {
    id
  }
  team {
    id
    name
  }
  triggerType
  defaultAutonomyState
}
    `;
export const NewClassifiedEmailThreadTriggerConfigFragmentDoc = gql`
    fragment NewClassifiedEmailThreadTriggerConfig on NewClassifiedEmailThreadTriggerConfig {
  triggerType
  classifications
  recipientEmails
  senderEmails
  sideEffectPolicy
  mailboxes
  override {
    active
  }
}
    `;
export const InboundPhoneCallTriggerConfigFragmentDoc = gql`
    fragment InboundPhoneCallTriggerConfig on InboundPhoneCallTriggerConfig {
  triggerType
  phoneNumbers
  override {
    active
    forwardToPhoneNumber
  }
  testPhoneNumber
  testPhoneNumberExpiresAt
}
    `;
export const MovementEventCreatedTriggerConfigFragmentDoc = gql`
    fragment MovementEventCreatedTriggerConfig on MovementEventCreatedTriggerConfig {
  triggerType
  eventTypes
  exceptionTypes
  originatorIds
  trackingMilestoneTypes
  override {
    active
  }
}
    `;
export const OrderEventCreatedTriggerConfigFragmentDoc = gql`
    fragment OrderEventCreatedTriggerConfig on OrderEventCreatedTriggerConfig {
  triggerType
  orderEventTypes
  originatorIds
  override {
    active
  }
}
    `;
export const QuoteEventCreatedTriggerConfigFragmentDoc = gql`
    fragment QuoteEventCreatedTriggerConfig on QuoteEventCreatedTriggerConfig {
  triggerType
  quoteEventTypes
  originatorIds
  override {
    active
  }
}
    `;
export const ExceptionCreatedTriggerConfigFragmentDoc = gql`
    fragment ExceptionCreatedTriggerConfig on ExceptionCreatedTriggerConfig {
  triggerType
  types
  override {
    active
  }
}
    `;
export const RepeatingTriggerConfigFragmentDoc = gql`
    fragment RepeatingTriggerConfig on RepeatingTriggerConfig {
  triggerType
  cronPattern
  actionExecutionInput
  override {
    active
  }
}
    `;
export const ConversationEventCreatedTriggerConfigFragmentDoc = gql`
    fragment ConversationEventCreatedTriggerConfig on ConversationEventCreatedTriggerConfig {
  triggerType
  conversationEventTypes
  override {
    active
  }
}
    `;
export const MicrosoftTeamsMessageTriggerConfigFragmentDoc = gql`
    fragment MicrosoftTeamsMessageTriggerConfig on MicrosoftTeamsMessageTriggerConfig {
  triggerType
  teamsSources
  teamsChannelIds
  respondToAnyChannelMessage
  showToolActivity
  override {
    active
  }
}
    `;
export const SlackMessageTriggerConfigFragmentDoc = gql`
    fragment SlackMessageTriggerConfig on SlackMessageTriggerConfig {
  triggerType
  sources
  slackChannelIds
  respondToAnyChannelMessage
  showToolActivity
  override {
    active
  }
}
    `;
export const GoogleChatMessageTriggerConfigFragmentDoc = gql`
    fragment GoogleChatMessageTriggerConfig on GoogleChatMessageTriggerConfig {
  triggerType
  googleChatSources
  googleChatSpaceIds
  respondToAnySpaceMessage
  showToolActivity
  override {
    active
  }
}
    `;
export const PylonWebhookTriggerConfigFragmentDoc = gql`
    fragment PylonWebhookTriggerConfig on PylonWebhookTriggerConfig {
  triggerType
  includePrivateMessages
  override {
    active
  }
}
    `;
export const ActionTriggerFragmentDoc = gql`
    fragment ActionTrigger on ActionTrigger {
  ...ActionTriggerPreview
  config {
    ...NewClassifiedEmailThreadTriggerConfig
    ...InboundPhoneCallTriggerConfig
    ...MovementEventCreatedTriggerConfig
    ...OrderEventCreatedTriggerConfig
    ...QuoteEventCreatedTriggerConfig
    ...ExceptionCreatedTriggerConfig
    ...RepeatingTriggerConfig
    ...ConversationEventCreatedTriggerConfig
    ...MicrosoftTeamsMessageTriggerConfig
    ...SlackMessageTriggerConfig
    ...GoogleChatMessageTriggerConfig
    ...PylonWebhookTriggerConfig
  }
}
    ${ActionTriggerPreviewFragmentDoc}
${NewClassifiedEmailThreadTriggerConfigFragmentDoc}
${InboundPhoneCallTriggerConfigFragmentDoc}
${MovementEventCreatedTriggerConfigFragmentDoc}
${OrderEventCreatedTriggerConfigFragmentDoc}
${QuoteEventCreatedTriggerConfigFragmentDoc}
${ExceptionCreatedTriggerConfigFragmentDoc}
${RepeatingTriggerConfigFragmentDoc}
${ConversationEventCreatedTriggerConfigFragmentDoc}
${MicrosoftTeamsMessageTriggerConfigFragmentDoc}
${SlackMessageTriggerConfigFragmentDoc}
${GoogleChatMessageTriggerConfigFragmentDoc}
${PylonWebhookTriggerConfigFragmentDoc}`;
export const ActionDefinitionHierarchyPreviewFragmentDoc = gql`
    fragment ActionDefinitionHierarchyPreview on ActionDefinition {
  ...ActionDefinitionPreview
  childLinks {
    relationshipType
    actionDefinition {
      id
      name
      mode
      tags
      isEmbeddedInGraph
      sopMetadata {
        trackStepKind
      }
      procedure {
        ...NaturalLanguageProcedurePreview
        ...GraphDefinedProcedurePreview
        ...ConversationGraphProcedurePreview
        ...DeterministicProcedurePreview
      }
    }
  }
  triggers {
    ...ActionTrigger
  }
}
    ${ActionDefinitionPreviewFragmentDoc}
${NaturalLanguageProcedurePreviewFragmentDoc}
${GraphDefinedProcedurePreviewFragmentDoc}
${ConversationGraphProcedurePreviewFragmentDoc}
${DeterministicProcedurePreviewFragmentDoc}
${ActionTriggerFragmentDoc}`;
export const ActionDefinitionDocumentUploadsFragmentDoc = gql`
    fragment ActionDefinitionDocumentUploads on ActionDefinition {
  documents {
    id
    name
    url
  }
}
    `;
export const NaturalLanguageProcedureFragmentDoc = gql`
    fragment NaturalLanguageProcedure on NaturalLanguageProcedure {
  procedureType
  instructions
  outcomeLabels {
    name
    description
  }
  eventLabels {
    name
    description
  }
  watchers {
    functionName
    intervalMinutes
    params
  }
}
    `;
export const GraphDefinedProcedureFragmentDoc = gql`
    fragment GraphDefinedProcedure on GraphDefinedProcedure {
  procedureType
  graph {
    nodes {
      id
      position {
        x
        y
      }
      actionDefinitionId
    }
    edges {
      id
      sourceId
      targetId
      type
      prompt
    }
    initialNodeId
  }
}
    `;
export const ConversationGraphProcedureFragmentDoc = gql`
    fragment ConversationGraphProcedure on ConversationGraphProcedure {
  procedureType
  modality
  voiceModelName
  textModelName
  initialInstructions
  outputInstructions
  includeTranscriptInOutput
  semanticWaitPatterns
  outcomeLabels {
    name
    description
  }
  eventLabels {
    name
    description
  }
  watchers {
    functionName
    intervalMinutes
    params
  }
  graph {
    nodes {
      id
      position {
        x
        y
      }
      actionDefinitionId
    }
    edges {
      id
      sourceId
      targetId
      type
      prompt
    }
    initialNodeId
  }
}
    `;
export const DeterministicProcedureFragmentDoc = gql`
    fragment DeterministicProcedure on DeterministicProcedure {
  procedureType
  functionName
}
    `;
export const KnowledgeBaseDocumentFragmentDoc = gql`
    fragment KnowledgeBaseDocument on KnowledgeBaseDocumentUpload {
  id
  name
  url
}
    `;
export const KnowledgeBaseFragmentDoc = gql`
    fragment KnowledgeBase on KnowledgeBase {
  id
  name
  documents {
    ...KnowledgeBaseDocument
  }
}
    ${KnowledgeBaseDocumentFragmentDoc}`;
export const NoWorkersConfigFragmentDoc = gql`
    fragment NoWorkersConfig on NoWorkersConfig {
  type
}
    `;
export const LegacyAgentBackstoryConfigFragmentDoc = gql`
    fragment LegacyAgentBackstoryConfig on LegacyAgentBackstoryConfig {
  type
  agentBackstory
  agentVoiceId
}
    `;
export const SingleWorkerConfigFragmentDoc = gql`
    fragment SingleWorkerConfig on SingleWorkerConfig {
  type
}
    `;
export const MultipleWorkersConfigFragmentDoc = gql`
    fragment MultipleWorkersConfig on MultipleWorkersConfig {
  type
}
    `;
export const TeamFragmentDoc = gql`
    fragment Team on Team {
  id
  name
  description
  email
  members {
    id
  }
  aiPhoneNumbers {
    id
    phoneNumber
    extension
  }
  inboundPhoneCallTriggers {
    ...ActionTrigger
  }
}
    ${ActionTriggerFragmentDoc}`;
export const WorkerProfilePreviewFragmentDoc = gql`
    fragment WorkerProfilePreview on AIProfile {
  name
}
    `;
export const WorkerPreviewFragmentDoc = gql`
    fragment WorkerPreview on User {
  id
  teams {
    ...Team
  }
  profile {
    ...WorkerProfilePreview
  }
}
    ${TeamFragmentDoc}
${WorkerProfilePreviewFragmentDoc}`;
export const SubscribersFragmentDoc = gql`
    fragment Subscribers on User {
  id
}
    `;
export const ActionDefinitionFragmentDoc = gql`
    fragment ActionDefinition on ActionDefinition {
  ...ActionDefinitionPreview
  ...ActionDefinitionDocumentUploads
  organization {
    id
  }
  procedure {
    ...NaturalLanguageProcedure
    ...GraphDefinedProcedure
    ...ConversationGraphProcedure
    ...DeterministicProcedure
  }
  canonicalTools
  deterministicToolInvocations {
    onEnter {
      tool
      input
    }
  }
  triggers {
    ...ActionTriggerPreview
  }
  knowledgeBases {
    ...KnowledgeBase
  }
  workersConfig {
    ...NoWorkersConfig
    ...LegacyAgentBackstoryConfig
    ...SingleWorkerConfig
    ...MultipleWorkersConfig
  }
  workers {
    ...WorkerPreview
    teams {
      ...Team
    }
  }
  subscribers {
    ...Subscribers
  }
  memoryEntityLinks {
    id
  }
  globalPrompt {
    id
    name
    prompt
    parameters
    basePromptId
  }
  globalPromptSkillIds
  globalPromptValues
  globalPromptToolValues
  teamGlobalPromptValues {
    id
    teamId
    team {
      id
      name
    }
    values
    toolValues
  }
  provisioningResourceId
  relatedGlobalPrompts {
    id
    name
  }
}
    ${ActionDefinitionPreviewFragmentDoc}
${ActionDefinitionDocumentUploadsFragmentDoc}
${NaturalLanguageProcedureFragmentDoc}
${GraphDefinedProcedureFragmentDoc}
${ConversationGraphProcedureFragmentDoc}
${DeterministicProcedureFragmentDoc}
${ActionTriggerPreviewFragmentDoc}
${KnowledgeBaseFragmentDoc}
${NoWorkersConfigFragmentDoc}
${LegacyAgentBackstoryConfigFragmentDoc}
${SingleWorkerConfigFragmentDoc}
${MultipleWorkersConfigFragmentDoc}
${WorkerPreviewFragmentDoc}
${TeamFragmentDoc}
${SubscribersFragmentDoc}`;
export const PhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on PhoneNumber {
  phoneNumber
  extension
}
    `;
export const HumanProfileFragmentDoc = gql`
    fragment HumanProfile on HumanProfile {
  type
  name
  phoneNumber {
    ...PhoneNumber
  }
  dtmfPin
}
    ${PhoneNumberFragmentDoc}`;
export const AiProfileFragmentDoc = gql`
    fragment AIProfile on AIProfile {
  type
  name
  phoneNumber {
    phoneNumber
    extension
  }
}
    `;
export const BasicUserFragmentDoc = gql`
    fragment BasicUser on User {
  id
  firstName
  lastName
  username
  email
  roles
  excludeFromReporting
  profile {
    ...HumanProfile
    ...AIProfile
  }
}
    ${HumanProfileFragmentDoc}
${AiProfileFragmentDoc}`;
export const OrganizationSettingsFragmentDoc = gql`
    fragment OrganizationSettings on Organization {
  id
  settings {
    accessPolicies
    build
    buildShipmentFromExternalDataInstructions
    cover
    customFreightTags
    emailScanning
    emailTags
    escalations
    escalationSuppressionPeriod
    front
    glossary
    locations
    movementEvents
    notifications
    pollStopChanges
    polling
    pollingIntervalMinutes
    otherCompanyIDs
    operatingName
    pronounceableOperatingName
    defaultTimezone
    mcNumber
    pylon
    quote
    quoteAutoReply
    carrierInterestContext
    retentionPeriodHours
    schedule
    simulation
    track
    spamGuard
    teamsWebhookUrl
    telephony
    transitModeling
    transfersRateLimit
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on Organization {
  id
  name
  products
  integrationConfigs
  configurableOptions {
    commodities {
      id
      label
    }
  }
  ...OrganizationSettings
  type
  logoUrl
}
    ${OrganizationSettingsFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  ...BasicUser
  email
  username
  features
  roles
  excludeFromReporting
  organizations {
    id
    organizationId
    roles
  }
  organizationsDetails {
    ...Organization
  }
  settings {
    timeDisplayStyle
    autoReply
    emailTags
    browserExtensionDomainAllowlist
    pluginLandingPage
  }
  profile {
    ...HumanProfile
    ...AIProfile
  }
}
    ${BasicUserFragmentDoc}
${OrganizationFragmentDoc}
${HumanProfileFragmentDoc}
${AiProfileFragmentDoc}`;
export const EscalationDataFragmentDoc = gql`
    fragment EscalationData on EscalationData {
  eventDataType
  escalationType
  message
  codeExecutionError
  escalationRationale
}
    `;
export const AgentProposedOutputDataFragmentDoc = gql`
    fragment AgentProposedOutputData on AgentProposedOutputData {
  eventDataType
  output
}
    `;
export const DecisionEdgeEvaluatedDataFragmentDoc = gql`
    fragment DecisionEdgeEvaluatedData on DecisionEdgeEvaluatedData {
  eventDataType
  rationale
  shouldFollowEdge
  targetNodeActionDefinitionId
}
    `;
export const ToolUsedDataFragmentDoc = gql`
    fragment ToolUsedData on ToolUsedData {
  eventDataType
  toolName
  metadata
  toolInput
  toolOutput
  status
}
    `;
export const SupervisorToolUsedDataFragmentDoc = gql`
    fragment SupervisorToolUsedData on SupervisorToolUsedData {
  eventDataType
  toolName
  metadata
  toolInput
  toolOutput
  status
}
    `;
export const RawAgentMessageDataFragmentDoc = gql`
    fragment RawAgentMessageData on RawAgentMessageData {
  eventDataType
  data
}
    `;
export const RawSupervisorMessageDataFragmentDoc = gql`
    fragment RawSupervisorMessageData on RawSupervisorMessageData {
  eventDataType
  data
}
    `;
export const AgentReasoningDataFragmentDoc = gql`
    fragment AgentReasoningData on AgentReasoningData {
  eventDataType
  reasoning
}
    `;
export const SupervisorReasoningDataFragmentDoc = gql`
    fragment SupervisorReasoningData on SupervisorReasoningData {
  eventDataType
  reasoning
}
    `;
export const MemoryRecalledDataFragmentDoc = gql`
    fragment MemoryRecalledData on MemoryRecalledData {
  eventDataType
  memories {
    id
    comment
  }
}
    `;
export const SpamGuardDataFragmentDoc = gql`
    fragment SpamGuardData on SpamGuardData {
  eventDataType
  reason
  communicationChannel
  toIdentifier
  fromIdentifier
}
    `;
export const ReminderDataFragmentDoc = gql`
    fragment ReminderData on ReminderData {
  eventDataType
  message
}
    `;
export const InstructionMessageDataFragmentDoc = gql`
    fragment InstructionMessageData on InstructionMessageData {
  eventDataType
  message
  sourceActionExecutionId
}
    `;
export const StatusChangedDataFragmentDoc = gql`
    fragment StatusChangedData on StatusChangedData {
  eventDataType
  fromStatus
  toStatus
}
    `;
export const SupervisorProposedOutputDataFragmentDoc = gql`
    fragment SupervisorProposedOutputData on SupervisorProposedOutputData {
  eventDataType
  output
}
    `;
export const ActionExecutionEventFragmentDoc = gql`
    fragment ActionExecutionEvent on ActionExecutionEvent {
  id
  createdAt
  name
  agentMessageView {
    content
    toolCalls {
      id
      name
      args
    }
    sentMessage {
      subject
      body
      toRecipients
      ccRecipients
    }
  }
  data {
    ...EscalationData
    ...AgentProposedOutputData
    ...DecisionEdgeEvaluatedData
    ...ToolUsedData
    ...SupervisorToolUsedData
    ...RawAgentMessageData
    ...RawSupervisorMessageData
    ...AgentReasoningData
    ...SupervisorReasoningData
    ...MemoryRecalledData
    ...SpamGuardData
    ...ReminderData
    ...InstructionMessageData
    ...StatusChangedData
    ...SupervisorProposedOutputData
  }
}
    ${EscalationDataFragmentDoc}
${AgentProposedOutputDataFragmentDoc}
${DecisionEdgeEvaluatedDataFragmentDoc}
${ToolUsedDataFragmentDoc}
${SupervisorToolUsedDataFragmentDoc}
${RawAgentMessageDataFragmentDoc}
${RawSupervisorMessageDataFragmentDoc}
${AgentReasoningDataFragmentDoc}
${SupervisorReasoningDataFragmentDoc}
${MemoryRecalledDataFragmentDoc}
${SpamGuardDataFragmentDoc}
${ReminderDataFragmentDoc}
${InstructionMessageDataFragmentDoc}
${StatusChangedDataFragmentDoc}
${SupervisorProposedOutputDataFragmentDoc}`;
export const ActionExecutionNoChildrenFragmentDoc = gql`
    fragment ActionExecutionNoChildren on ActionExecution {
  id
  organizationId
  createdAt
  updatedAt
  deletedAt
  status
  autonomyState
  executeAsUserId
  executeAsUser {
    ...User
  }
  tags
  hasMemory
  respondsToCoworkers
  mode
  input
  output
  actionDefinition {
    ...ActionDefinitionPreview
  }
  reexecutedFromActionExecutionId
  conversation {
    id
    organizationId
    externalIdentifier
    createdAt
    type
    status
  }
  linkedConversations {
    id
    organizationId
    externalIdentifier
    createdAt
    type
    status
  }
  events {
    ...ActionExecutionEvent
  }
  documents {
    id
    createdAt
    name
    url
  }
  parentId
}
    ${UserFragmentDoc}
${ActionDefinitionPreviewFragmentDoc}
${ActionExecutionEventFragmentDoc}`;
export const ActionExecutionFragmentDoc = gql`
    fragment ActionExecution on ActionExecution {
  ...ActionExecutionNoChildren
  children {
    ...ActionExecutionNoChildren
  }
}
    ${ActionExecutionNoChildrenFragmentDoc}`;
export const TaskListItemFragmentDoc = gql`
    fragment TaskListItem on ActionExecution {
  id
  createdAt
  deletedAt
  status
  autonomyState
  tags
  actionDefinition {
    id
    name
    deletedAt
  }
}
    `;
export const AdvancedTriggerParamsFieldsFragmentDoc = gql`
    fragment AdvancedTriggerParamsFields on AdvancedTriggerParams {
  appointment {
    minutes
    direction
    anchor
  }
  windowTiers {
    maxDurationMinutes
    offset {
      minutes
      direction
      anchor
    }
  }
}
    `;
export const JobDocumentsFragmentDoc = gql`
    fragment JobDocuments on Job {
  documents {
    id
    upload {
      id
      name
      url
    }
  }
}
    `;
export const JobEventFragmentDoc = gql`
    fragment JobEvent on JobEvent {
  id
  createdAt
  type
}
    `;
export const OrderPreviewFragmentDoc = gql`
    fragment OrderPreview on Order {
  id
  createdAt
  createdAtDisplay
  updatedAt
  originator {
    id
    name
  }
  user {
    id
    email
  }
  primaryReference
  processingStatus
  hasSubmittedEvent
  job {
    redactedAt
  }
}
    `;
export const QuotePreviewFragmentDoc = gql`
    fragment QuotePreview on Quote {
  id
  createdAt
  createdAtDisplay
  updatedAt
  originator {
    id
    name
  }
  user {
    id
    email
  }
}
    `;
export const JobFragmentDoc = gql`
    fragment Job on Job {
  id
  source
  createdAt
  notes
  emailMetadata
  ...JobDocuments
  jobEvents {
    ...JobEvent
  }
  orders {
    ...OrderPreview
  }
  quotes {
    ...QuotePreview
  }
  organization {
    id
    type
  }
  originator {
    id
    name
  }
  user {
    id
    email
  }
  status
  redactedAt
}
    ${JobDocumentsFragmentDoc}
${JobEventFragmentDoc}
${OrderPreviewFragmentDoc}
${QuotePreviewFragmentDoc}`;
export const QuoteFragmentDoc = gql`
    fragment Quote on Quote {
  id
  status
  extractedData
  customFreightTags
  createdAt
  routeGeoCoordinates {
    latitude
    longitude
  }
  organization {
    id
    name
    integrationConfigs
    configurableOptions {
      commodities {
        id
        label
      }
    }
    settings {
      customFreightTags
    }
  }
  originator {
    id
    name
    transmitIds
    status
    configOverrides
    externalIdMappings {
      id
      externalId
      integrationType
    }
  }
  user {
    id
    email
  }
  carrierRates {
    id
    createdAt
    ratingMethod
    computedRate
    metadata
  }
  customerRates {
    id
    createdAt
    type
    rate
    ratingMethod
    metadata
  }
  carrierRate {
    id
    createdAt
    ratingMethod
    computedRate
    metadata
  }
  customerRate {
    id
    createdAt
    ratingMethod
    metadata
    type
    rate
  }
  job {
    ...Job
  }
  notesCount
  opportunityUserIds
  shipmentId
  mileageBetweenStops
  googleMapsEmbedUrl
}
    ${JobFragmentDoc}`;
export const CarrierFragmentDoc = gql`
    fragment Carrier on Carrier {
  id
  createdAt
  name
  mcNumber
  dotNumber
  isInNetwork
}
    `;
export const CarrierRateFragmentDoc = gql`
    fragment CarrierRate on CarrierRate {
  id
  createdAt
  loadData
  ratingMethod
  computedRate
  metadata
  quote {
    ...Quote
  }
  carrier {
    ...Carrier
  }
  contact {
    id
    name
    email
    phone
  }
  conversation {
    id
    type
    summary {
      summary
    }
  }
}
    ${QuoteFragmentDoc}
${CarrierFragmentDoc}`;
export const CarrierRateWithActionsFragmentDoc = gql`
    fragment CarrierRateWithActions on CarrierRate {
  ...CarrierRate
  conversation {
    actions {
      output
    }
  }
}
    ${CarrierRateFragmentDoc}`;
export const OriginatorFragmentDoc = gql`
    fragment Originator on Originator {
  id
  transmitIds
  name
  createdAt
  status
  autoSubmitScope
  organization {
    id
    name
    type
  }
  knownSenders {
    id
    email
  }
  expectedWeeklyOrderCount
  externalIdMappings {
    id
    externalId
    integrationType
  }
  configOverrides
  flagged
  hasExtractedDataConfigured
  attributes
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on Contact {
  id
  name
  email
  originator {
    ...Originator
  }
}
    ${OriginatorFragmentDoc}`;
export const PhoneConversationMetadataFragmentDoc = gql`
    fragment PhoneConversationMetadata on PhoneConversationMetadata {
  fromPhoneNumber
  toPhoneNumber
  toPhoneNumberExtension
  initiationDirection
}
    `;
export const EmailConversationMetadataFragmentDoc = gql`
    fragment EmailConversationMetadata on EmailConversationMetadata {
  outlookConversationId
  gmailThreadId
  frontConversationId
  alreadyCcdRecipients
}
    `;
export const MicrosoftTeamsConversationMetadataFragmentDoc = gql`
    fragment MicrosoftTeamsConversationMetadata on MicrosoftTeamsConversationMetadata {
  teamsConversationType
  participantUserIds
}
    `;
export const ChatConversationMetadataFragmentDoc = gql`
    fragment ChatConversationMetadata on ChatConversationMetadata {
  context
}
    `;
export const SmsConversationMetadataFragmentDoc = gql`
    fragment SMSConversationMetadata on SMSConversationMetadata {
  ourPhoneNumber
  theirPhoneNumber
}
    `;
export const ConversationRatingFragmentDoc = gql`
    fragment ConversationRating on ConversationRating {
  id
  createdAt
  userId
  starRating
  comments
}
    `;
export const ConversationAnalysisFragmentDoc = gql`
    fragment ConversationAnalysis on ConversationAnalysis {
  id
  type
  name
  status
  results
}
    `;
export const CallFailedDataFragmentDoc = gql`
    fragment CallFailedData on CallFailedData {
  eventDataType
}
    `;
export const CallEndedDataFragmentDoc = gql`
    fragment CallEndedData on CallEndedData {
  eventDataType
}
    `;
export const ChatViewContextUpdatedDataFragmentDoc = gql`
    fragment ChatViewContextUpdatedData on ChatViewContextUpdatedData {
  eventDataType
  context
}
    `;
export const CallTransferredDataFragmentDoc = gql`
    fragment CallTransferredData on CallTransferredData {
  eventDataType
  phoneNumber
  extension
  overrideCallerId
}
    `;
export const CallTransferAcceptedDataFragmentDoc = gql`
    fragment CallTransferAcceptedData on CallTransferAcceptedData {
  eventDataType
  conferenceId
  transferCallSid
}
    `;
export const ConferenceJoinedDataFragmentDoc = gql`
    fragment ConferenceJoinedData on ConferenceJoinedData {
  eventDataType
  conferenceId
}
    `;
export const AsyncTransferDataFragmentDoc = gql`
    fragment AsyncTransferData on AsyncTransferData {
  eventDataType
  ccRecipients
  shipmentId
}
    `;
export const ReturnedToTransferredCallDataFragmentDoc = gql`
    fragment ReturnedToTransferredCallData on ReturnedToTransferredCallData {
  eventDataType
  transferAttemptConversationId
  conferenceId
}
    `;
export const CallRecordingReceivedDataFragmentDoc = gql`
    fragment CallRecordingReceivedData on CallRecordingReceivedData {
  eventDataType
  recordingStartTime
  recordingEndTime
}
    `;
export const QuietLineIntentDataFragmentDoc = gql`
    fragment QuietLineIntentData on QuietLineIntentData {
  eventDataType
}
    `;
export const ConversationEventFragmentDoc = gql`
    fragment ConversationEvent on ConversationEvent {
  id
  createdAt
  name
  data {
    ...CallFailedData
    ...CallEndedData
    ...ChatViewContextUpdatedData
    ...CallTransferredData
    ...CallTransferAcceptedData
    ...ConferenceJoinedData
    ...AsyncTransferData
    ...ReturnedToTransferredCallData
    ...CallRecordingReceivedData
    ...QuietLineIntentData
  }
}
    ${CallFailedDataFragmentDoc}
${CallEndedDataFragmentDoc}
${ChatViewContextUpdatedDataFragmentDoc}
${CallTransferredDataFragmentDoc}
${CallTransferAcceptedDataFragmentDoc}
${ConferenceJoinedDataFragmentDoc}
${AsyncTransferDataFragmentDoc}
${ReturnedToTransferredCallDataFragmentDoc}
${CallRecordingReceivedDataFragmentDoc}
${QuietLineIntentDataFragmentDoc}`;
export const ConversationFragmentDoc = gql`
    fragment Conversation on Conversation {
  id
  organizationId
  title
  externalIdentifier
  createdAt
  type
  status
  user {
    ...BasicUser
  }
  metadata {
    ...PhoneConversationMetadata
    ...EmailConversationMetadata
    ...MicrosoftTeamsConversationMetadata
    ...ChatConversationMetadata
    ...SMSConversationMetadata
  }
  summary {
    summary
    transferSummary
    sentiment
    outcomeLabels {
      outcome
      rationale
    }
    eventLabels {
      order
      event
      rationale
    }
  }
  mediaUrl
  ratings {
    ...ConversationRating
  }
  analyses {
    ...ConversationAnalysis
  }
  events {
    ...ConversationEvent
  }
}
    ${BasicUserFragmentDoc}
${PhoneConversationMetadataFragmentDoc}
${EmailConversationMetadataFragmentDoc}
${MicrosoftTeamsConversationMetadataFragmentDoc}
${ChatConversationMetadataFragmentDoc}
${SmsConversationMetadataFragmentDoc}
${ConversationRatingFragmentDoc}
${ConversationAnalysisFragmentDoc}
${ConversationEventFragmentDoc}`;
export const CustomerRateFragmentDoc = gql`
    fragment CustomerRate on CustomerRate {
  id
  createdAt
  loadData
  type
  rate
  metadata
  quote {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;
export const EnRouteTrackEventSettingsFieldsFragmentDoc = gql`
    fragment EnRouteTrackEventSettingsFields on EnRouteTrackEventSettings {
  intervalMinutes
  firstMilestoneDelayMinutes
  distanceBasedIntervals {
    defaultIntervalMinutes
    thresholds {
      maxDistanceMiles
      intervalMinutes
    }
  }
  fixedDailyTimes
  fixedDailyTimesTimezone
  filter
  stopTrackingWithinMiles
  skipTrackingWithinMilesOfPickup
  closeToDeliveryInterval {
    intervalMinutes
    withinMiles
    withinMinutesOfDeliveryStart
  }
  smartFilter {
    minDistanceMiles
  }
  includeTrackingAlertStatus
}
    `;
export const ErrorGroupFragmentDoc = gql`
    fragment ErrorGroup on ErrorGroup {
  id
  source
  title
  status
  lastOccurrenceCount
  firstSeenAt
  lastSeenAt
  suppressionThreshold
  linearTicketId
  githubPrUrl
  notes
  topOrganizations {
    organizationId
    organizationName
    count
  }
  createdAt
  updatedAt
}
    `;
export const ExceptionFragmentDoc = gql`
    fragment Exception on Exception {
  id
  type
  status
  createdAt
  updatedAt
  context
  actionExecution {
    id
    conversationId
  }
  handler {
    id
    conversationId
  }
}
    `;
export const ExceptionConversationPreviewFragmentDoc = gql`
    fragment ExceptionConversationPreview on Conversation {
  id
  type
  contactIdentifier
  summary {
    summary
    transferSummary
    sentiment
  }
  metadata {
    ... on PhoneConversationMetadata {
      fromPhoneNumber
      toPhoneNumber
    }
  }
}
    `;
export const ExceptionActionExecutionFragmentDoc = gql`
    fragment ExceptionActionExecution on ActionExecution {
  id
  conversation {
    ...ExceptionConversationPreview
  }
}
    ${ExceptionConversationPreviewFragmentDoc}`;
export const HandlingActionExecutionFragmentDoc = gql`
    fragment HandlingActionExecution on ActionExecution {
  id
  conversation {
    ...ExceptionConversationPreview
  }
}
    ${ExceptionConversationPreviewFragmentDoc}`;
export const ConversationExceptionFragmentDoc = gql`
    fragment ConversationException on Exception {
  id
  createdAt
  callTransferStatus
  conversation {
    ...ExceptionConversationPreview
    associatedCarriers {
      name
    }
    associatedReferenceNumbers
  }
  actionExecution {
    ...ExceptionActionExecution
  }
  handler {
    ...HandlingActionExecution
  }
}
    ${ExceptionConversationPreviewFragmentDoc}
${ExceptionActionExecutionFragmentDoc}
${HandlingActionExecutionFragmentDoc}`;
export const ExceptionBasicFragmentDoc = gql`
    fragment ExceptionBasic on Exception {
  id
  type
  status
  createdAt
  updatedAt
  context
  actionExecution {
    id
  }
  handler {
    id
    conversation {
      id
    }
  }
}
    `;
export const ExternalChannelFragmentDoc = gql`
    fragment ExternalChannel on ExternalChannel {
  id
  createdAt
  organizationId
  teamId
  userId
  channelType
  externalIdentifier
}
    `;
export const ExternalMessageFragmentDoc = gql`
    fragment ExternalMessage on ExternalMessage {
  id
  externalIdentifier
  type
  createdAt
  content
  htmlBody
  emailMetadata
  userId
  user {
    id
    username
    firstName
    lastName
    profile {
      ... on HumanProfile {
        name
      }
      ... on AIProfile {
        name
      }
    }
  }
  conversationId
  canonicalMessageId
  documents {
    id
    name
    url
    metadata
  }
}
    `;
export const GenericTransformationFragmentDoc = gql`
    fragment GenericTransformation on GenericTransformation {
  id
  createdAt
  seq
  genericRuleId
  transformationConfigId
  genericRule {
    id
    type
  }
  transformationConfig {
    id
    transformationDefinition {
      id
      definition
    }
  }
}
    `;
export const GenericRuleFragmentDoc = gql`
    fragment GenericRule on GenericRule {
  id
  createdAt
  organization {
    id
  }
  type
  transformations {
    ...GenericTransformation
  }
}
    ${GenericTransformationFragmentDoc}`;
export const GenericTransformationDetailsFragmentDoc = gql`
    fragment GenericTransformationDetails on GenericTransformation {
  id
  createdAt
  seq
  genericRuleId
  transformationConfigId
  templateId
  templateVersion
  genericRule {
    id
    type
    organization {
      id
    }
  }
  transformationConfig {
    id
    params
    transformationDefinition {
      id
      definition
    }
  }
}
    `;
export const OrderEventFragmentDoc = gql`
    fragment OrderEvent on OrderEvent {
  id
  createdAt
  type
  orderId
}
    `;
export const OrderSummaryFragmentDoc = gql`
    fragment OrderSummary on Order {
  id
  hasSubmittedEvent
  primaryReference
  extractedData
  createdAt
  createdAtDisplay
  externalDeepLink
  optimismStatus
  originator {
    id
    name
  }
  job {
    emailMetadata
  }
  orderEvents {
    ...OrderEvent
  }
}
    ${OrderEventFragmentDoc}`;
export const QuoteSummaryFragmentDoc = gql`
    fragment QuoteSummary on Quote {
  id
  status
  extractedData
  createdAt
  createdAtDisplay
  optimismStatus
  originator {
    name
  }
  job {
    id
    emailMetadata
    source
  }
  customerRate {
    id
    createdAt
    type
    rate
    metadata
  }
  carrierRate {
    id
    createdAt
    ratingMethod
    computedRate
    metadata
  }
}
    `;
export const JobSummaryFragmentDoc = gql`
    fragment JobSummary on Job {
  id
  createdAt
  notes
  emailMetadata
  status
  source
  optimismStatus
  user {
    id
    email
    firstName
    lastName
  }
  originator {
    id
    name
  }
  orders {
    ...OrderSummary
  }
  quotes {
    ...QuoteSummary
  }
  jobEvents {
    ...JobEvent
  }
}
    ${OrderSummaryFragmentDoc}
${QuoteSummaryFragmentDoc}
${JobEventFragmentDoc}`;
export const ManagedResourceFragmentDoc = gql`
    fragment ManagedResource on ManagedResource {
  id
  name
  type
  provider
  status
  fallbackResource {
    id
    name
    type
    provider
    status
  }
}
    `;
export const MemoryFragmentDoc = gql`
    fragment Memory on Memory {
  id
  createdAt
  organization {
    id
  }
  labeledComputation {
    id
    savedComputation {
      id
      originatorId
      jobId
    }
  }
  computationType
  comment
  entityLinks {
    id
    actionDefinitionId
    organizationId
    teamId
    userId
    originatorId
    carrierId
    contactId
    placeId
    quoteId
    orderId
    shipmentId
    movementId
  }
}
    `;
export const MemoryEntityLinkEntitiesFragmentDoc = gql`
    fragment MemoryEntityLinkEntities on MemoryEntityLink {
  id
  actionDefinition {
    id
    name
  }
  organization {
    id
    name
  }
  team {
    id
    name
  }
  user {
    id
    username
  }
  originator {
    id
    name
  }
  carrier {
    id
    name
  }
  contact {
    id
    name
  }
  contactMethod {
    id
    email
    phoneNumber
  }
  place {
    id
    name
  }
  quote {
    id
  }
  order {
    id
  }
  shipment {
    id
  }
  movement {
    id
  }
}
    `;
export const MemoryDetailsFragmentDoc = gql`
    fragment MemoryDetails on Memory {
  id
  createdAt
  organization {
    id
  }
  labeledComputation {
    id
    savedComputation {
      id
      originatorId
      jobId
    }
  }
  computationType
  comment
  entityLinks {
    ...MemoryEntityLinkEntities
  }
}
    ${MemoryEntityLinkEntitiesFragmentDoc}`;
export const MessageRatingFragmentDoc = gql`
    fragment MessageRating on MessageRating {
  id
  messageId
  isPositive
  reason
  comments
}
    `;
export const MilestoneAfterTriggerParamsFieldsFragmentDoc = gql`
    fragment MilestoneAfterTriggerParamsFields on MilestoneAfterTriggerParams {
  minutesAfter
  appointment {
    minutes
    direction
    anchor
  }
  windowTiers {
    maxDurationMinutes
    offset {
      minutes
      direction
      anchor
    }
  }
}
    `;
export const MilestoneAtTriggerParamsFieldsFragmentDoc = gql`
    fragment MilestoneAtTriggerParamsFields on MilestoneAtTriggerParams {
  delayMinutes
  appointment {
    minutes
    direction
    anchor
  }
  windowTiers {
    maxDurationMinutes
    offset {
      minutes
      direction
      anchor
    }
  }
}
    `;
export const MovementDetailsFragmentDoc = gql`
    fragment MovementDetails on Movement {
  details
  attributes
  coverageStatus
}
    `;
export const CarrierRatePreviewFragmentDoc = gql`
    fragment CarrierRatePreview on CarrierRate {
  id
  computedRate
  ratingMethod
}
    `;
export const MovementPreviewFragmentDoc = gql`
    fragment MovementPreview on Movement {
  id
  isTrackingPaused
  stops {
    location {
      name
      addressOne
      addressTwo
      city
      state
      zip
      country
    }
    dateTimeRanges {
      start {
        dateTime
        timezone
        interpretationPolicy
      }
      end {
        dateTime
        timezone
        interpretationPolicy
      }
      type
    }
  }
  movementEvents {
    id
    name
    createdAt
    data {
      ... on ExceptionCreatedData {
        eventType
        exception {
          type
          data
        }
      }
      ... on ExceptionResolvedData {
        eventType
        exception {
          type
          data
        }
      }
    }
  }
  carrierRates {
    ...CarrierRatePreview
  }
  pricing {
    targetPrice
    maxPrice
  }
  attributes
}
    ${CarrierRatePreviewFragmentDoc}`;
export const ShipmentPreviewFragmentDoc = gql`
    fragment ShipmentPreview on Shipment {
  id
  createdAt
  externalId
  referenceNumbers
  user {
    ...BasicUser
  }
  movements {
    ...MovementPreview
  }
}
    ${BasicUserFragmentDoc}
${MovementPreviewFragmentDoc}`;
export const ShipmentFragmentDoc = gql`
    fragment Shipment on Shipment {
  ...ShipmentPreview
  schedulingInfo {
    stops
    tmsId
  }
  trackingInfo {
    driverName
    driverPhone
  }
}
    ${ShipmentPreviewFragmentDoc}`;
export const MovementFragmentDoc = gql`
    fragment Movement on Movement {
  seq
  ...MovementPreview
  carrierRates {
    ...CarrierRate
  }
  shipment {
    ...Shipment
  }
  pricing {
    targetPrice
    maxPrice
  }
  customerRate
  inquiryCount
  commodity
  negotiationStrategyConfigOverride
}
    ${MovementPreviewFragmentDoc}
${CarrierRateFragmentDoc}
${ShipmentFragmentDoc}`;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  createdAt
  updatedAt
  job {
    ...Job
  }
  documents {
    id
    upload {
      id
      name
      url
    }
  }
  orderEvents {
    ...OrderEvent
  }
  organization {
    id
    integrationConfigs
  }
  originator {
    id
    name
    transmitIds
    status
    configOverrides
    externalIdMappings {
      id
      externalId
      integrationType
    }
  }
  transmitId
  user {
    id
    email
  }
  primaryReference
  hasSubmittedEvent
  extractedData
  externalDeepLink
  externalId
  shipmentAssociations {
    shipment {
      id
    }
  }
}
    ${JobFragmentDoc}
${OrderEventFragmentDoc}`;
export const OrganizationDocumentUploadPreviewFragmentDoc = gql`
    fragment OrganizationDocumentUploadPreview on OrganizationDocumentUpload {
  id
  name
  url
  metadata
}
    `;
export const PlaceFragmentDoc = gql`
    fragment Place on Place {
  id
  deletedAt
  name
  data
  address {
    addressOne
    addressTwo
    city
    state
    zip
    country
  }
  locationCode
  originator {
    id
    name
  }
  tags
  aliases
  originator {
    id
    name
  }
  creationProvenance
  notes {
    notesFields {
      notesType
      notes
    }
  }
}
    `;
export const PlaceSchedulingFragmentDoc = gql`
    fragment PlaceScheduling on PlaceScheduling {
  placeId
  methods {
    id
    method
  }
}
    `;
export const QuoteEventFragmentDoc = gql`
    fragment QuoteEvent on QuoteEvent {
  id
  createdAt
  type
  quoteId
}
    `;
export const QuoteHistorySummaryFragmentDoc = gql`
    fragment QuoteHistorySummary on Quote {
  id
  status
  extractedData
  createdAt
  originator {
    name
  }
  carrierRate {
    id
    createdAt
    ratingMethod
    computedRate
    metadata
  }
  customerRate {
    id
    createdAt
    type
    rate
    metadata
  }
}
    `;
export const QuoteNoteFragmentDoc = gql`
    fragment QuoteNote on QuoteNote {
  id
  note
}
    `;
export const SharedFileSummaryFragmentDoc = gql`
    fragment SharedFileSummary on SharedFileSummary {
  id
  scope
  canEdit
  currentVersion {
    id
    fileName
    contentType
  }
}
    `;
export const ShipmentHistorySummaryFragmentDoc = gql`
    fragment ShipmentHistorySummary on Shipment {
  id
  carrierRates {
    name
    buyRate
    sellRate
    pickupAt
  }
  externalId
  externalDeepLink
}
    `;
export const TeamDetailsFragmentDoc = gql`
    fragment TeamDetails on Team {
  id
  name
  description
  email
  settings
  phoneNumber {
    phoneNumber
    extension
  }
  actionTriggerCount
  organizationId
  members {
    id
    organizationUserRelation {
      id
      user {
        id
        email
        firstName
        lastName
      }
    }
    role
  }
  aiPhoneNumbers {
    id
    phoneNumber
    extension
  }
}
    `;
export const TeamWithActionTriggerCountFragmentDoc = gql`
    fragment TeamWithActionTriggerCount on Team {
  ...Team
  actionTriggerCount
}
    ${TeamFragmentDoc}`;
export const TemplateFragmentDoc = gql`
    fragment Template on Template {
  id
  type
  currentRevision {
    jsonData
  }
  orderBuildPrompt
  multiOrderPrompt
  modelConfig {
    documentInterpretationModel
    computerVisionModel
    replicationModel
    multiOrderBuildStrategy
    groupByFields
  }
  originator {
    id
  }
  organization {
    id
  }
}
    `;
export const TemplatePreviewFragmentDoc = gql`
    fragment TemplatePreview on Template {
  id
  type
  currentRevision {
    jsonData
  }
  originator {
    id
  }
  organization {
    id
  }
}
    `;
export const TrackWorkspaceActionFieldsFragmentDoc = gql`
    fragment TrackWorkspaceActionFields on ActionExecution {
  id
  createdAt
  status
  conversationId
  actionDefinition {
    id
    name
    sopMetadata {
      trackStepKind
    }
  }
  input
  output
  conversation {
    id
    type
    createdAt
    title
    summary {
      summary
      outcomeLabels {
        outcome
      }
    }
    metadata {
      ... on PhoneConversationMetadata {
        toPhoneNumber
        fromPhoneNumber
        initiationDirection
        telephonyDurationSeconds
      }
      ... on SMSConversationMetadata {
        theirPhoneNumber
      }
    }
  }
  linkedConversations {
    id
    type
    createdAt
    title
    summary {
      summary
      outcomeLabels {
        outcome
      }
    }
    metadata {
      ... on PhoneConversationMetadata {
        toPhoneNumber
        fromPhoneNumber
        initiationDirection
        telephonyDurationSeconds
      }
      ... on SMSConversationMetadata {
        theirPhoneNumber
      }
    }
  }
}
    `;
export const TrackWorkspaceActionFragmentDoc = gql`
    fragment TrackWorkspaceAction on ActionExecution {
  ...TrackWorkspaceActionFields
  children {
    ...TrackWorkspaceActionFields
    children {
      ...TrackWorkspaceActionFields
    }
  }
}
    ${TrackWorkspaceActionFieldsFragmentDoc}`;
export const TrackWorkspaceMovementEventFragmentDoc = gql`
    fragment TrackWorkspaceMovementEvent on MovementEvent {
  id
  name
  createdAt
  data {
    ... on MovementCarrierChangedData {
      eventType
      from {
        name
        externalId
        driver {
          name
        }
        dispatch {
          name
        }
      }
      to {
        name
        externalId
        driver {
          name
        }
        dispatch {
          name
        }
      }
    }
    ... on TrackingPausedData {
      eventType
      change
      reason
      source
    }
    ... on StopEtaUpdatedData {
      eventType
      eta
    }
    ... on ExceptionResolvedData {
      eventType
      exception {
        type
      }
    }
    ... on LoadPutOnHoldData {
      eventType
    }
    ... on LoadTakenOffHoldData {
      eventType
    }
    ... on CoveredData {
      eventType
      rate
      facilitatedByVooma
      carrier {
        name
        externalId
      }
    }
    ... on PrePickupDelayStartedData {
      eventType
    }
    ... on TrackingMilestoneSkippedData {
      eventType
      milestone {
        type
      }
      skipReason: reason
    }
    ... on AllAppointmentsConfirmedData {
      eventType
      appointments {
        confirmationNumber
      }
    }
    ... on ReadyForCoverageData {
      eventType
    }
    ... on NotReadyForCoverageData {
      eventType
    }
    ... on WebhookReceivedData {
      eventType
      tmsStatus
      changedFields
    }
  }
}
    `;
export const TransformationConfigFragmentDoc = gql`
    fragment TransformationConfig on TransformationConfig {
  id
  createdAt
  organization {
    id
  }
  originator {
    id
    name
  }
  id
  params
  transformationDefinition {
    id
    definition
  }
}
    `;
export const TransformationDefinitionFragmentDoc = gql`
    fragment TransformationDefinition on TransformationDefinition {
  id
  createdAt
  organization {
    id
  }
  originator {
    id
    name
  }
  definition
}
    `;
export const UserDocumentUploadPreviewFragmentDoc = gql`
    fragment UserDocumentUploadPreview on UserDocumentUpload {
  id
  name
  url
  metadata
  subjectId
}
    `;
export const UserFormFieldsFragmentDoc = gql`
    fragment UserFormFields on User {
  id
  username
  roles
  excludeFromReporting
}
    `;
export const WebhookSubscriptionDetailFragmentDoc = gql`
    fragment WebhookSubscriptionDetail on WebhookSubscription {
  id
  createdAt
  organizationId
  url
  subscriptionType
  authConfig
}
    `;
export const WorkerProfileFragmentDoc = gql`
    fragment WorkerProfile on AIProfile {
  name
  backStory
  humanisedDelay
  voiceId
  voiceModel
  voiceSpeed
  languages
}
    `;
export const WorkerFragmentDoc = gql`
    fragment Worker on User {
  id
  profile {
    ...WorkerProfile
  }
  teams {
    ...Team
  }
  organizations {
    id
    organizationId
  }
}
    ${WorkerProfileFragmentDoc}
${TeamFragmentDoc}`;
export const WorkflowFragmentDoc = gql`
    fragment Workflow on Workflow {
  id
  createdAt
  organization {
    id
  }
  originator {
    id
    name
  }
  transformations {
    id
    seq
    transformationConfig {
      id
      params
      transformationDefinition {
        id
        definition
      }
    }
  }
  trigger {
    type
    config
  }
}
    `;
export const GenericTransformationTemplateDetailsFragmentDoc = gql`
    fragment GenericTransformationTemplateDetails on GenericTransformationTemplate {
  id
  createdAt
  updatedAt
  name
  description
  genericRuleType
  definition
  version
}
    `;
export const AgentConversationPreviewFragmentDoc = gql`
    fragment AgentConversationPreview on Conversation {
  id
  type
  createdAt
  updatedAt
  contactIdentifier
  summary {
    summary
  }
  metadata {
    ... on PhoneConversationMetadata {
      fromPhoneNumber
      toPhoneNumber
      toPhoneNumberExtension
      initiationDirection
    }
    ...EmailConversationMetadata
  }
  associatedCarriers {
    id
    name
  }
  associatedReferenceNumbers
  associatedShipments {
    id
    referenceNumbers
    movements {
      id
      stops {
        location {
          city
          state
        }
      }
    }
  }
}
    ${EmailConversationMetadataFragmentDoc}`;
export const EmailThreadAgentRunFragmentDoc = gql`
    fragment EmailThreadAgentRun on ActionExecution {
  id
  createdAt
  organizationId
  actionDefinition {
    id
    name
  }
  linkedConversations {
    id
    type
  }
}
    `;
export const QuoteJobSimulationHierarchyLevelFieldsFragmentDoc = gql`
    fragment QuoteJobSimulationHierarchyLevelFields on HierarchyLevelSettings {
  entity {
    id
    type
    name
  }
  autoReply
  pricingStrategy {
    id
    type
    config
  }
  pricingStrategyResolutionError
  settingsCount
}
    `;
export const OpendockFragmentDoc = gql`
    fragment Opendock on OpendockAvailabilityCheckFields {
  schedulePortalType
  day
  warehouse {
    id
    name
  }
  warehouses {
    id
    name
  }
  loadTypes {
    id
    name
  }
  loadType {
    id
    name
  }
  dock {
    id
    name
  }
  docks {
    id
    name
  }
}
    `;
export const CreateOutlookReplyAllDocument = gql`
    mutation CreateOutlookReplyAll($input: CreateOutlookReplyAllInput!) {
  createOutlookReplyAll(input: $input) {
    success
    messageId
  }
}
    `;
export type CreateOutlookReplyAllMutationFn = Apollo.MutationFunction<CreateOutlookReplyAllMutation, CreateOutlookReplyAllMutationVariables>;

/**
 * __useCreateOutlookReplyAllMutation__
 *
 * To run a mutation, you first call `useCreateOutlookReplyAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutlookReplyAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutlookReplyAllMutation, { data, loading, error }] = useCreateOutlookReplyAllMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOutlookReplyAllMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutlookReplyAllMutation, CreateOutlookReplyAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutlookReplyAllMutation, CreateOutlookReplyAllMutationVariables>(CreateOutlookReplyAllDocument, options);
      }
export type CreateOutlookReplyAllMutationHookResult = ReturnType<typeof useCreateOutlookReplyAllMutation>;
export type CreateOutlookReplyAllMutationResult = Apollo.MutationResult<CreateOutlookReplyAllMutation>;
export type CreateOutlookReplyAllMutationOptions = Apollo.BaseMutationOptions<CreateOutlookReplyAllMutation, CreateOutlookReplyAllMutationVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($input: OrdersInput, $first: Int, $last: Int, $before: String, $after: String) {
  orders(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...OrderSummary
      }
    }
  }
}
    ${OrderSummaryFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const SendOutlookMessageDocument = gql`
    mutation SendOutlookMessage($input: SendOutlookMessageInput!) {
  sendOutlookMessage(input: $input) {
    success
  }
}
    `;
export type SendOutlookMessageMutationFn = Apollo.MutationFunction<SendOutlookMessageMutation, SendOutlookMessageMutationVariables>;

/**
 * __useSendOutlookMessageMutation__
 *
 * To run a mutation, you first call `useSendOutlookMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOutlookMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOutlookMessageMutation, { data, loading, error }] = useSendOutlookMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendOutlookMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendOutlookMessageMutation, SendOutlookMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOutlookMessageMutation, SendOutlookMessageMutationVariables>(SendOutlookMessageDocument, options);
      }
export type SendOutlookMessageMutationHookResult = ReturnType<typeof useSendOutlookMessageMutation>;
export type SendOutlookMessageMutationResult = Apollo.MutationResult<SendOutlookMessageMutation>;
export type SendOutlookMessageMutationOptions = Apollo.BaseMutationOptions<SendOutlookMessageMutation, SendOutlookMessageMutationVariables>;
export const GetQuoteResponseMessageDocument = gql`
    query GetQuoteResponseMessage($input: GenerateQuoteResponseMessageInput!) {
  getQuoteResponseMessage(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useGetQuoteResponseMessageQuery__
 *
 * To run a query within a React component, call `useGetQuoteResponseMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteResponseMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteResponseMessageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuoteResponseMessageQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteResponseMessageQuery, GetQuoteResponseMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteResponseMessageQuery, GetQuoteResponseMessageQueryVariables>(GetQuoteResponseMessageDocument, options);
      }
export function useGetQuoteResponseMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteResponseMessageQuery, GetQuoteResponseMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteResponseMessageQuery, GetQuoteResponseMessageQueryVariables>(GetQuoteResponseMessageDocument, options);
        }
export type GetQuoteResponseMessageQueryHookResult = ReturnType<typeof useGetQuoteResponseMessageQuery>;
export type GetQuoteResponseMessageLazyQueryHookResult = ReturnType<typeof useGetQuoteResponseMessageLazyQuery>;
export type GetQuoteResponseMessageQueryResult = Apollo.QueryResult<GetQuoteResponseMessageQuery, GetQuoteResponseMessageQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...User
    teams {
      ...Team
    }
  }
}
    ${UserFragmentDoc}
${TeamFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  userById(id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const GetMessageByInternetMessageIdDocument = gql`
    query GetMessageByInternetMessageId($input: ExternalMessageByInternetMessageIdInput!) {
  externalMessageByInternetMessageId(input: $input) {
    externalMessage {
      classifications
    }
  }
}
    `;

/**
 * __useGetMessageByInternetMessageIdQuery__
 *
 * To run a query within a React component, call `useGetMessageByInternetMessageIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageByInternetMessageIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageByInternetMessageIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMessageByInternetMessageIdQuery(baseOptions: Apollo.QueryHookOptions<GetMessageByInternetMessageIdQuery, GetMessageByInternetMessageIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageByInternetMessageIdQuery, GetMessageByInternetMessageIdQueryVariables>(GetMessageByInternetMessageIdDocument, options);
      }
export function useGetMessageByInternetMessageIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageByInternetMessageIdQuery, GetMessageByInternetMessageIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageByInternetMessageIdQuery, GetMessageByInternetMessageIdQueryVariables>(GetMessageByInternetMessageIdDocument, options);
        }
export type GetMessageByInternetMessageIdQueryHookResult = ReturnType<typeof useGetMessageByInternetMessageIdQuery>;
export type GetMessageByInternetMessageIdLazyQueryHookResult = ReturnType<typeof useGetMessageByInternetMessageIdLazyQuery>;
export type GetMessageByInternetMessageIdQueryResult = Apollo.QueryResult<GetMessageByInternetMessageIdQuery, GetMessageByInternetMessageIdQueryVariables>;
export const PlaceFormDataDocument = gql`
    query PlaceFormData($placeId: ID!) {
  placeById(id: $placeId) {
    ...PlaceFormFields
  }
}
    ${PlaceFormFieldsFragmentDoc}`;

/**
 * __usePlaceFormDataQuery__
 *
 * To run a query within a React component, call `usePlaceFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceFormDataQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function usePlaceFormDataQuery(baseOptions: Apollo.QueryHookOptions<PlaceFormDataQuery, PlaceFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceFormDataQuery, PlaceFormDataQueryVariables>(PlaceFormDataDocument, options);
      }
export function usePlaceFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceFormDataQuery, PlaceFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceFormDataQuery, PlaceFormDataQueryVariables>(PlaceFormDataDocument, options);
        }
export type PlaceFormDataQueryHookResult = ReturnType<typeof usePlaceFormDataQuery>;
export type PlaceFormDataLazyQueryHookResult = ReturnType<typeof usePlaceFormDataLazyQuery>;
export type PlaceFormDataQueryResult = Apollo.QueryResult<PlaceFormDataQuery, PlaceFormDataQueryVariables>;
export const UpdatePlaceDetailsDocument = gql`
    mutation UpdatePlaceDetails($input: UpdatePlaceInput!) {
  updatePlace(input: $input) {
    place {
      ...PlaceFormFields
    }
    success
  }
}
    ${PlaceFormFieldsFragmentDoc}`;
export type UpdatePlaceDetailsMutationFn = Apollo.MutationFunction<UpdatePlaceDetailsMutation, UpdatePlaceDetailsMutationVariables>;

/**
 * __useUpdatePlaceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceDetailsMutation, { data, loading, error }] = useUpdatePlaceDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaceDetailsMutation, UpdatePlaceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaceDetailsMutation, UpdatePlaceDetailsMutationVariables>(UpdatePlaceDetailsDocument, options);
      }
export type UpdatePlaceDetailsMutationHookResult = ReturnType<typeof useUpdatePlaceDetailsMutation>;
export type UpdatePlaceDetailsMutationResult = Apollo.MutationResult<UpdatePlaceDetailsMutation>;
export type UpdatePlaceDetailsMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceDetailsMutation, UpdatePlaceDetailsMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    user {
      ...User
    }
    success
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const GenericTransformationTemplatesDocument = gql`
    query GenericTransformationTemplates($input: GenericTransformationTemplatesInput) {
  genericTransformationTemplates(input: $input) {
    ...GenericTransformationTemplateDetails
  }
}
    ${GenericTransformationTemplateDetailsFragmentDoc}`;

/**
 * __useGenericTransformationTemplatesQuery__
 *
 * To run a query within a React component, call `useGenericTransformationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericTransformationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericTransformationTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenericTransformationTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GenericTransformationTemplatesQuery, GenericTransformationTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericTransformationTemplatesQuery, GenericTransformationTemplatesQueryVariables>(GenericTransformationTemplatesDocument, options);
      }
export function useGenericTransformationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericTransformationTemplatesQuery, GenericTransformationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericTransformationTemplatesQuery, GenericTransformationTemplatesQueryVariables>(GenericTransformationTemplatesDocument, options);
        }
export type GenericTransformationTemplatesQueryHookResult = ReturnType<typeof useGenericTransformationTemplatesQuery>;
export type GenericTransformationTemplatesLazyQueryHookResult = ReturnType<typeof useGenericTransformationTemplatesLazyQuery>;
export type GenericTransformationTemplatesQueryResult = Apollo.QueryResult<GenericTransformationTemplatesQuery, GenericTransformationTemplatesQueryVariables>;
export const GenericTransformationTemplateInheritorsDocument = gql`
    query GenericTransformationTemplateInheritors($templateId: ID!) {
  genericTransformationTemplateInheritors(templateId: $templateId) {
    genericTransformationId
    genericRuleId
    organizationId
    organizationName
    templateVersion
  }
}
    `;

/**
 * __useGenericTransformationTemplateInheritorsQuery__
 *
 * To run a query within a React component, call `useGenericTransformationTemplateInheritorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericTransformationTemplateInheritorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenericTransformationTemplateInheritorsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGenericTransformationTemplateInheritorsQuery(baseOptions: Apollo.QueryHookOptions<GenericTransformationTemplateInheritorsQuery, GenericTransformationTemplateInheritorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenericTransformationTemplateInheritorsQuery, GenericTransformationTemplateInheritorsQueryVariables>(GenericTransformationTemplateInheritorsDocument, options);
      }
export function useGenericTransformationTemplateInheritorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenericTransformationTemplateInheritorsQuery, GenericTransformationTemplateInheritorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenericTransformationTemplateInheritorsQuery, GenericTransformationTemplateInheritorsQueryVariables>(GenericTransformationTemplateInheritorsDocument, options);
        }
export type GenericTransformationTemplateInheritorsQueryHookResult = ReturnType<typeof useGenericTransformationTemplateInheritorsQuery>;
export type GenericTransformationTemplateInheritorsLazyQueryHookResult = ReturnType<typeof useGenericTransformationTemplateInheritorsLazyQuery>;
export type GenericTransformationTemplateInheritorsQueryResult = Apollo.QueryResult<GenericTransformationTemplateInheritorsQuery, GenericTransformationTemplateInheritorsQueryVariables>;
export const CreateGenericTransformationTemplateDocument = gql`
    mutation CreateGenericTransformationTemplate($input: CreateGenericTransformationTemplateInput!) {
  createGenericTransformationTemplate(input: $input) {
    genericTransformationTemplate {
      ...GenericTransformationTemplateDetails
    }
  }
}
    ${GenericTransformationTemplateDetailsFragmentDoc}`;
export type CreateGenericTransformationTemplateMutationFn = Apollo.MutationFunction<CreateGenericTransformationTemplateMutation, CreateGenericTransformationTemplateMutationVariables>;

/**
 * __useCreateGenericTransformationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateGenericTransformationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericTransformationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericTransformationTemplateMutation, { data, loading, error }] = useCreateGenericTransformationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGenericTransformationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericTransformationTemplateMutation, CreateGenericTransformationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericTransformationTemplateMutation, CreateGenericTransformationTemplateMutationVariables>(CreateGenericTransformationTemplateDocument, options);
      }
export type CreateGenericTransformationTemplateMutationHookResult = ReturnType<typeof useCreateGenericTransformationTemplateMutation>;
export type CreateGenericTransformationTemplateMutationResult = Apollo.MutationResult<CreateGenericTransformationTemplateMutation>;
export type CreateGenericTransformationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateGenericTransformationTemplateMutation, CreateGenericTransformationTemplateMutationVariables>;
export const UpdateGenericTransformationTemplateDocument = gql`
    mutation UpdateGenericTransformationTemplate($input: UpdateGenericTransformationTemplateInput!) {
  updateGenericTransformationTemplate(input: $input) {
    genericTransformationTemplate {
      ...GenericTransformationTemplateDetails
    }
  }
}
    ${GenericTransformationTemplateDetailsFragmentDoc}`;
export type UpdateGenericTransformationTemplateMutationFn = Apollo.MutationFunction<UpdateGenericTransformationTemplateMutation, UpdateGenericTransformationTemplateMutationVariables>;

/**
 * __useUpdateGenericTransformationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateGenericTransformationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericTransformationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericTransformationTemplateMutation, { data, loading, error }] = useUpdateGenericTransformationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGenericTransformationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericTransformationTemplateMutation, UpdateGenericTransformationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericTransformationTemplateMutation, UpdateGenericTransformationTemplateMutationVariables>(UpdateGenericTransformationTemplateDocument, options);
      }
export type UpdateGenericTransformationTemplateMutationHookResult = ReturnType<typeof useUpdateGenericTransformationTemplateMutation>;
export type UpdateGenericTransformationTemplateMutationResult = Apollo.MutationResult<UpdateGenericTransformationTemplateMutation>;
export type UpdateGenericTransformationTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateGenericTransformationTemplateMutation, UpdateGenericTransformationTemplateMutationVariables>;
export const DeleteGenericTransformationTemplateDocument = gql`
    mutation DeleteGenericTransformationTemplate($id: ID!) {
  deleteGenericTransformationTemplate(id: $id) {
    success
  }
}
    `;
export type DeleteGenericTransformationTemplateMutationFn = Apollo.MutationFunction<DeleteGenericTransformationTemplateMutation, DeleteGenericTransformationTemplateMutationVariables>;

/**
 * __useDeleteGenericTransformationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteGenericTransformationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericTransformationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericTransformationTemplateMutation, { data, loading, error }] = useDeleteGenericTransformationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGenericTransformationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericTransformationTemplateMutation, DeleteGenericTransformationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericTransformationTemplateMutation, DeleteGenericTransformationTemplateMutationVariables>(DeleteGenericTransformationTemplateDocument, options);
      }
export type DeleteGenericTransformationTemplateMutationHookResult = ReturnType<typeof useDeleteGenericTransformationTemplateMutation>;
export type DeleteGenericTransformationTemplateMutationResult = Apollo.MutationResult<DeleteGenericTransformationTemplateMutation>;
export type DeleteGenericTransformationTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteGenericTransformationTemplateMutation, DeleteGenericTransformationTemplateMutationVariables>;
export const MergeGenericTransformationTemplateDocument = gql`
    mutation MergeGenericTransformationTemplate($id: ID!) {
  mergeGenericTransformationTemplate(id: $id) {
    mergedCount
  }
}
    `;
export type MergeGenericTransformationTemplateMutationFn = Apollo.MutationFunction<MergeGenericTransformationTemplateMutation, MergeGenericTransformationTemplateMutationVariables>;

/**
 * __useMergeGenericTransformationTemplateMutation__
 *
 * To run a mutation, you first call `useMergeGenericTransformationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeGenericTransformationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeGenericTransformationTemplateMutation, { data, loading, error }] = useMergeGenericTransformationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMergeGenericTransformationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<MergeGenericTransformationTemplateMutation, MergeGenericTransformationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeGenericTransformationTemplateMutation, MergeGenericTransformationTemplateMutationVariables>(MergeGenericTransformationTemplateDocument, options);
      }
export type MergeGenericTransformationTemplateMutationHookResult = ReturnType<typeof useMergeGenericTransformationTemplateMutation>;
export type MergeGenericTransformationTemplateMutationResult = Apollo.MutationResult<MergeGenericTransformationTemplateMutation>;
export type MergeGenericTransformationTemplateMutationOptions = Apollo.BaseMutationOptions<MergeGenericTransformationTemplateMutation, MergeGenericTransformationTemplateMutationVariables>;
export const ApplyGenericTransformationTemplateDocument = gql`
    mutation ApplyGenericTransformationTemplate($input: ApplyGenericTransformationTemplateInput!) {
  applyGenericTransformationTemplate(input: $input) {
    genericTransformationId
    genericRuleId
  }
}
    `;
export type ApplyGenericTransformationTemplateMutationFn = Apollo.MutationFunction<ApplyGenericTransformationTemplateMutation, ApplyGenericTransformationTemplateMutationVariables>;

/**
 * __useApplyGenericTransformationTemplateMutation__
 *
 * To run a mutation, you first call `useApplyGenericTransformationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyGenericTransformationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyGenericTransformationTemplateMutation, { data, loading, error }] = useApplyGenericTransformationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyGenericTransformationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ApplyGenericTransformationTemplateMutation, ApplyGenericTransformationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyGenericTransformationTemplateMutation, ApplyGenericTransformationTemplateMutationVariables>(ApplyGenericTransformationTemplateDocument, options);
      }
export type ApplyGenericTransformationTemplateMutationHookResult = ReturnType<typeof useApplyGenericTransformationTemplateMutation>;
export type ApplyGenericTransformationTemplateMutationResult = Apollo.MutationResult<ApplyGenericTransformationTemplateMutation>;
export type ApplyGenericTransformationTemplateMutationOptions = Apollo.BaseMutationOptions<ApplyGenericTransformationTemplateMutation, ApplyGenericTransformationTemplateMutationVariables>;
export const GlobalPromptsDocument = gql`
    query GlobalPrompts {
  globalPrompts {
    id
    createdAt
    updatedAt
    currentVersionId
    name
    prompt
    parameters
    runsOnExperimentalService
  }
}
    `;

/**
 * __useGlobalPromptsQuery__
 *
 * To run a query within a React component, call `useGlobalPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalPromptsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalPromptsQuery, GlobalPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalPromptsQuery, GlobalPromptsQueryVariables>(GlobalPromptsDocument, options);
      }
export function useGlobalPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalPromptsQuery, GlobalPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalPromptsQuery, GlobalPromptsQueryVariables>(GlobalPromptsDocument, options);
        }
export type GlobalPromptsQueryHookResult = ReturnType<typeof useGlobalPromptsQuery>;
export type GlobalPromptsLazyQueryHookResult = ReturnType<typeof useGlobalPromptsLazyQuery>;
export type GlobalPromptsQueryResult = Apollo.QueryResult<GlobalPromptsQuery, GlobalPromptsQueryVariables>;
export const GlobalPromptByIdDocument = gql`
    query GlobalPromptById($input: GlobalPromptByIdInput!) {
  globalPromptById(input: $input) {
    globalPrompt {
      id
      createdAt
      updatedAt
      currentVersionId
      name
      prompt
      parameters
      runsOnExperimentalService
      canRollOutFromCode
      basePromptId
    }
    versions {
      id
      version
      prompt
      parameters
      provisioningResourceId
      createdAt
    }
  }
}
    `;

/**
 * __useGlobalPromptByIdQuery__
 *
 * To run a query within a React component, call `useGlobalPromptByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPromptByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPromptByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGlobalPromptByIdQuery(baseOptions: Apollo.QueryHookOptions<GlobalPromptByIdQuery, GlobalPromptByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalPromptByIdQuery, GlobalPromptByIdQueryVariables>(GlobalPromptByIdDocument, options);
      }
export function useGlobalPromptByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalPromptByIdQuery, GlobalPromptByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalPromptByIdQuery, GlobalPromptByIdQueryVariables>(GlobalPromptByIdDocument, options);
        }
export type GlobalPromptByIdQueryHookResult = ReturnType<typeof useGlobalPromptByIdQuery>;
export type GlobalPromptByIdLazyQueryHookResult = ReturnType<typeof useGlobalPromptByIdLazyQuery>;
export type GlobalPromptByIdQueryResult = Apollo.QueryResult<GlobalPromptByIdQuery, GlobalPromptByIdQueryVariables>;
export const CreateGlobalPromptDocument = gql`
    mutation CreateGlobalPrompt($input: CreateGlobalPromptInput!) {
  createGlobalPrompt(input: $input) {
    globalPrompt {
      id
      name
      prompt
      parameters
    }
  }
}
    `;
export type CreateGlobalPromptMutationFn = Apollo.MutationFunction<CreateGlobalPromptMutation, CreateGlobalPromptMutationVariables>;

/**
 * __useCreateGlobalPromptMutation__
 *
 * To run a mutation, you first call `useCreateGlobalPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalPromptMutation, { data, loading, error }] = useCreateGlobalPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGlobalPromptMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalPromptMutation, CreateGlobalPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlobalPromptMutation, CreateGlobalPromptMutationVariables>(CreateGlobalPromptDocument, options);
      }
export type CreateGlobalPromptMutationHookResult = ReturnType<typeof useCreateGlobalPromptMutation>;
export type CreateGlobalPromptMutationResult = Apollo.MutationResult<CreateGlobalPromptMutation>;
export type CreateGlobalPromptMutationOptions = Apollo.BaseMutationOptions<CreateGlobalPromptMutation, CreateGlobalPromptMutationVariables>;
export const UpdateGlobalPromptDocument = gql`
    mutation UpdateGlobalPrompt($input: UpdateGlobalPromptInput!) {
  updateGlobalPrompt(input: $input) {
    globalPrompt {
      id
      prompt
      parameters
    }
  }
}
    `;
export type UpdateGlobalPromptMutationFn = Apollo.MutationFunction<UpdateGlobalPromptMutation, UpdateGlobalPromptMutationVariables>;

/**
 * __useUpdateGlobalPromptMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalPromptMutation, { data, loading, error }] = useUpdateGlobalPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGlobalPromptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalPromptMutation, UpdateGlobalPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalPromptMutation, UpdateGlobalPromptMutationVariables>(UpdateGlobalPromptDocument, options);
      }
export type UpdateGlobalPromptMutationHookResult = ReturnType<typeof useUpdateGlobalPromptMutation>;
export type UpdateGlobalPromptMutationResult = Apollo.MutationResult<UpdateGlobalPromptMutation>;
export type UpdateGlobalPromptMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalPromptMutation, UpdateGlobalPromptMutationVariables>;
export const SetGlobalPromptRunsOnExperimentalServiceDocument = gql`
    mutation SetGlobalPromptRunsOnExperimentalService($globalPromptId: String!, $runsOnExperimentalService: Boolean!) {
  setGlobalPromptRunsOnExperimentalService(
    globalPromptId: $globalPromptId
    runsOnExperimentalService: $runsOnExperimentalService
  ) {
    globalPrompt {
      id
      runsOnExperimentalService
    }
  }
}
    `;
export type SetGlobalPromptRunsOnExperimentalServiceMutationFn = Apollo.MutationFunction<SetGlobalPromptRunsOnExperimentalServiceMutation, SetGlobalPromptRunsOnExperimentalServiceMutationVariables>;

/**
 * __useSetGlobalPromptRunsOnExperimentalServiceMutation__
 *
 * To run a mutation, you first call `useSetGlobalPromptRunsOnExperimentalServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalPromptRunsOnExperimentalServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalPromptRunsOnExperimentalServiceMutation, { data, loading, error }] = useSetGlobalPromptRunsOnExperimentalServiceMutation({
 *   variables: {
 *      globalPromptId: // value for 'globalPromptId'
 *      runsOnExperimentalService: // value for 'runsOnExperimentalService'
 *   },
 * });
 */
export function useSetGlobalPromptRunsOnExperimentalServiceMutation(baseOptions?: Apollo.MutationHookOptions<SetGlobalPromptRunsOnExperimentalServiceMutation, SetGlobalPromptRunsOnExperimentalServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGlobalPromptRunsOnExperimentalServiceMutation, SetGlobalPromptRunsOnExperimentalServiceMutationVariables>(SetGlobalPromptRunsOnExperimentalServiceDocument, options);
      }
export type SetGlobalPromptRunsOnExperimentalServiceMutationHookResult = ReturnType<typeof useSetGlobalPromptRunsOnExperimentalServiceMutation>;
export type SetGlobalPromptRunsOnExperimentalServiceMutationResult = Apollo.MutationResult<SetGlobalPromptRunsOnExperimentalServiceMutation>;
export type SetGlobalPromptRunsOnExperimentalServiceMutationOptions = Apollo.BaseMutationOptions<SetGlobalPromptRunsOnExperimentalServiceMutation, SetGlobalPromptRunsOnExperimentalServiceMutationVariables>;
export const SetGlobalPromptBasePromptDocument = gql`
    mutation SetGlobalPromptBasePrompt($globalPromptId: String!, $basePromptId: ID) {
  setGlobalPromptBasePrompt(
    globalPromptId: $globalPromptId
    basePromptId: $basePromptId
  ) {
    globalPrompt {
      id
      basePromptId
    }
  }
}
    `;
export type SetGlobalPromptBasePromptMutationFn = Apollo.MutationFunction<SetGlobalPromptBasePromptMutation, SetGlobalPromptBasePromptMutationVariables>;

/**
 * __useSetGlobalPromptBasePromptMutation__
 *
 * To run a mutation, you first call `useSetGlobalPromptBasePromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalPromptBasePromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalPromptBasePromptMutation, { data, loading, error }] = useSetGlobalPromptBasePromptMutation({
 *   variables: {
 *      globalPromptId: // value for 'globalPromptId'
 *      basePromptId: // value for 'basePromptId'
 *   },
 * });
 */
export function useSetGlobalPromptBasePromptMutation(baseOptions?: Apollo.MutationHookOptions<SetGlobalPromptBasePromptMutation, SetGlobalPromptBasePromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGlobalPromptBasePromptMutation, SetGlobalPromptBasePromptMutationVariables>(SetGlobalPromptBasePromptDocument, options);
      }
export type SetGlobalPromptBasePromptMutationHookResult = ReturnType<typeof useSetGlobalPromptBasePromptMutation>;
export type SetGlobalPromptBasePromptMutationResult = Apollo.MutationResult<SetGlobalPromptBasePromptMutation>;
export type SetGlobalPromptBasePromptMutationOptions = Apollo.BaseMutationOptions<SetGlobalPromptBasePromptMutation, SetGlobalPromptBasePromptMutationVariables>;
export const BasePromptsDocument = gql`
    query BasePrompts {
  basePrompts {
    id
    key
    name
  }
}
    `;

/**
 * __useBasePromptsQuery__
 *
 * To run a query within a React component, call `useBasePromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasePromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasePromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBasePromptsQuery(baseOptions?: Apollo.QueryHookOptions<BasePromptsQuery, BasePromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasePromptsQuery, BasePromptsQueryVariables>(BasePromptsDocument, options);
      }
export function useBasePromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasePromptsQuery, BasePromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasePromptsQuery, BasePromptsQueryVariables>(BasePromptsDocument, options);
        }
export type BasePromptsQueryHookResult = ReturnType<typeof useBasePromptsQuery>;
export type BasePromptsLazyQueryHookResult = ReturnType<typeof useBasePromptsLazyQuery>;
export type BasePromptsQueryResult = Apollo.QueryResult<BasePromptsQuery, BasePromptsQueryVariables>;
export const SetGlobalPromptVersionDocument = gql`
    mutation SetGlobalPromptVersion($input: SetGlobalPromptVersionInput!) {
  setGlobalPromptVersion(input: $input) {
    globalPrompt {
      id
      prompt
      parameters
    }
  }
}
    `;
export type SetGlobalPromptVersionMutationFn = Apollo.MutationFunction<SetGlobalPromptVersionMutation, SetGlobalPromptVersionMutationVariables>;

/**
 * __useSetGlobalPromptVersionMutation__
 *
 * To run a mutation, you first call `useSetGlobalPromptVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGlobalPromptVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGlobalPromptVersionMutation, { data, loading, error }] = useSetGlobalPromptVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGlobalPromptVersionMutation(baseOptions?: Apollo.MutationHookOptions<SetGlobalPromptVersionMutation, SetGlobalPromptVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGlobalPromptVersionMutation, SetGlobalPromptVersionMutationVariables>(SetGlobalPromptVersionDocument, options);
      }
export type SetGlobalPromptVersionMutationHookResult = ReturnType<typeof useSetGlobalPromptVersionMutation>;
export type SetGlobalPromptVersionMutationResult = Apollo.MutationResult<SetGlobalPromptVersionMutation>;
export type SetGlobalPromptVersionMutationOptions = Apollo.BaseMutationOptions<SetGlobalPromptVersionMutation, SetGlobalPromptVersionMutationVariables>;
export const DeleteGlobalPromptDocument = gql`
    mutation DeleteGlobalPrompt($id: String!) {
  deleteGlobalPrompt(id: $id)
}
    `;
export type DeleteGlobalPromptMutationFn = Apollo.MutationFunction<DeleteGlobalPromptMutation, DeleteGlobalPromptMutationVariables>;

/**
 * __useDeleteGlobalPromptMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalPromptMutation, { data, loading, error }] = useDeleteGlobalPromptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGlobalPromptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGlobalPromptMutation, DeleteGlobalPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGlobalPromptMutation, DeleteGlobalPromptMutationVariables>(DeleteGlobalPromptDocument, options);
      }
export type DeleteGlobalPromptMutationHookResult = ReturnType<typeof useDeleteGlobalPromptMutation>;
export type DeleteGlobalPromptMutationResult = Apollo.MutationResult<DeleteGlobalPromptMutation>;
export type DeleteGlobalPromptMutationOptions = Apollo.BaseMutationOptions<DeleteGlobalPromptMutation, DeleteGlobalPromptMutationVariables>;
export const RollOutGlobalPromptFromCodeDocument = gql`
    mutation RollOutGlobalPromptFromCode($globalPromptId: String!) {
  rollOutGlobalPromptFromCode(globalPromptId: $globalPromptId) {
    organizationCount
    succeededCount
    failedCount
  }
}
    `;
export type RollOutGlobalPromptFromCodeMutationFn = Apollo.MutationFunction<RollOutGlobalPromptFromCodeMutation, RollOutGlobalPromptFromCodeMutationVariables>;

/**
 * __useRollOutGlobalPromptFromCodeMutation__
 *
 * To run a mutation, you first call `useRollOutGlobalPromptFromCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollOutGlobalPromptFromCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollOutGlobalPromptFromCodeMutation, { data, loading, error }] = useRollOutGlobalPromptFromCodeMutation({
 *   variables: {
 *      globalPromptId: // value for 'globalPromptId'
 *   },
 * });
 */
export function useRollOutGlobalPromptFromCodeMutation(baseOptions?: Apollo.MutationHookOptions<RollOutGlobalPromptFromCodeMutation, RollOutGlobalPromptFromCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollOutGlobalPromptFromCodeMutation, RollOutGlobalPromptFromCodeMutationVariables>(RollOutGlobalPromptFromCodeDocument, options);
      }
export type RollOutGlobalPromptFromCodeMutationHookResult = ReturnType<typeof useRollOutGlobalPromptFromCodeMutation>;
export type RollOutGlobalPromptFromCodeMutationResult = Apollo.MutationResult<RollOutGlobalPromptFromCodeMutation>;
export type RollOutGlobalPromptFromCodeMutationOptions = Apollo.BaseMutationOptions<RollOutGlobalPromptFromCodeMutation, RollOutGlobalPromptFromCodeMutationVariables>;
export const OrganizationsInheritingGlobalPromptDocument = gql`
    query OrganizationsInheritingGlobalPrompt($globalPromptId: String!) {
  organizationsInheritingGlobalPrompt(globalPromptId: $globalPromptId) {
    id
    name
  }
}
    `;

/**
 * __useOrganizationsInheritingGlobalPromptQuery__
 *
 * To run a query within a React component, call `useOrganizationsInheritingGlobalPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsInheritingGlobalPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsInheritingGlobalPromptQuery({
 *   variables: {
 *      globalPromptId: // value for 'globalPromptId'
 *   },
 * });
 */
export function useOrganizationsInheritingGlobalPromptQuery(baseOptions: Apollo.QueryHookOptions<OrganizationsInheritingGlobalPromptQuery, OrganizationsInheritingGlobalPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsInheritingGlobalPromptQuery, OrganizationsInheritingGlobalPromptQueryVariables>(OrganizationsInheritingGlobalPromptDocument, options);
      }
export function useOrganizationsInheritingGlobalPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsInheritingGlobalPromptQuery, OrganizationsInheritingGlobalPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsInheritingGlobalPromptQuery, OrganizationsInheritingGlobalPromptQueryVariables>(OrganizationsInheritingGlobalPromptDocument, options);
        }
export type OrganizationsInheritingGlobalPromptQueryHookResult = ReturnType<typeof useOrganizationsInheritingGlobalPromptQuery>;
export type OrganizationsInheritingGlobalPromptLazyQueryHookResult = ReturnType<typeof useOrganizationsInheritingGlobalPromptLazyQuery>;
export type OrganizationsInheritingGlobalPromptQueryResult = Apollo.QueryResult<OrganizationsInheritingGlobalPromptQuery, OrganizationsInheritingGlobalPromptQueryVariables>;
export const AddChatMessageToConversationDocument = gql`
    mutation AddChatMessageToConversation($input: AddChatMessageToConversationInput!) {
  addChatMessageToConversation(input: $input) {
    externalMessage {
      ...ExternalMessage
    }
    success
  }
}
    ${ExternalMessageFragmentDoc}`;
export type AddChatMessageToConversationMutationFn = Apollo.MutationFunction<AddChatMessageToConversationMutation, AddChatMessageToConversationMutationVariables>;

/**
 * __useAddChatMessageToConversationMutation__
 *
 * To run a mutation, you first call `useAddChatMessageToConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChatMessageToConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChatMessageToConversationMutation, { data, loading, error }] = useAddChatMessageToConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddChatMessageToConversationMutation(baseOptions?: Apollo.MutationHookOptions<AddChatMessageToConversationMutation, AddChatMessageToConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddChatMessageToConversationMutation, AddChatMessageToConversationMutationVariables>(AddChatMessageToConversationDocument, options);
      }
export type AddChatMessageToConversationMutationHookResult = ReturnType<typeof useAddChatMessageToConversationMutation>;
export type AddChatMessageToConversationMutationResult = Apollo.MutationResult<AddChatMessageToConversationMutation>;
export type AddChatMessageToConversationMutationOptions = Apollo.BaseMutationOptions<AddChatMessageToConversationMutation, AddChatMessageToConversationMutationVariables>;
export const BulkDeleteQuotesDocument = gql`
    mutation BulkDeleteQuotes($input: BulkDeleteQuotesInput!) {
  bulkDeleteQuotes(input: $input) {
    success
  }
}
    `;
export type BulkDeleteQuotesMutationFn = Apollo.MutationFunction<BulkDeleteQuotesMutation, BulkDeleteQuotesMutationVariables>;

/**
 * __useBulkDeleteQuotesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteQuotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteQuotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteQuotesMutation, { data, loading, error }] = useBulkDeleteQuotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkDeleteQuotesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteQuotesMutation, BulkDeleteQuotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteQuotesMutation, BulkDeleteQuotesMutationVariables>(BulkDeleteQuotesDocument, options);
      }
export type BulkDeleteQuotesMutationHookResult = ReturnType<typeof useBulkDeleteQuotesMutation>;
export type BulkDeleteQuotesMutationResult = Apollo.MutationResult<BulkDeleteQuotesMutation>;
export type BulkDeleteQuotesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteQuotesMutation, BulkDeleteQuotesMutationVariables>;
export const ComputeRatesDocument = gql`
    mutation ComputeRates($input: ComputeRatesInput!) {
  computeRates(input: $input) {
    success
    customerRates {
      ...CustomerRate
    }
    carrierRates {
      ...CarrierRate
    }
    ratingErrors {
      ratingMethod
      errorMessage
    }
  }
}
    ${CustomerRateFragmentDoc}
${CarrierRateFragmentDoc}`;
export type ComputeRatesMutationFn = Apollo.MutationFunction<ComputeRatesMutation, ComputeRatesMutationVariables>;

/**
 * __useComputeRatesMutation__
 *
 * To run a mutation, you first call `useComputeRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeRatesMutation, { data, loading, error }] = useComputeRatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeRatesMutation(baseOptions?: Apollo.MutationHookOptions<ComputeRatesMutation, ComputeRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ComputeRatesMutation, ComputeRatesMutationVariables>(ComputeRatesDocument, options);
      }
export type ComputeRatesMutationHookResult = ReturnType<typeof useComputeRatesMutation>;
export type ComputeRatesMutationResult = Apollo.MutationResult<ComputeRatesMutation>;
export type ComputeRatesMutationOptions = Apollo.BaseMutationOptions<ComputeRatesMutation, ComputeRatesMutationVariables>;
export const CreateApiClientDocument = gql`
    mutation CreateApiClient($input: CreateApiClientInput!) {
  createApiClient(input: $input) {
    success
    apiKey
  }
}
    `;
export type CreateApiClientMutationFn = Apollo.MutationFunction<CreateApiClientMutation, CreateApiClientMutationVariables>;

/**
 * __useCreateApiClientMutation__
 *
 * To run a mutation, you first call `useCreateApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiClientMutation, { data, loading, error }] = useCreateApiClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiClientMutation, CreateApiClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiClientMutation, CreateApiClientMutationVariables>(CreateApiClientDocument, options);
      }
export type CreateApiClientMutationHookResult = ReturnType<typeof useCreateApiClientMutation>;
export type CreateApiClientMutationResult = Apollo.MutationResult<CreateApiClientMutation>;
export type CreateApiClientMutationOptions = Apollo.BaseMutationOptions<CreateApiClientMutation, CreateApiClientMutationVariables>;
export const CreateAuthTokenDocument = gql`
    mutation CreateAuthToken($input: CreateAuthTokenInput!) {
  createAuthToken(input: $input) {
    success
    email
  }
}
    `;
export type CreateAuthTokenMutationFn = Apollo.MutationFunction<CreateAuthTokenMutation, CreateAuthTokenMutationVariables>;

/**
 * __useCreateAuthTokenMutation__
 *
 * To run a mutation, you first call `useCreateAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthTokenMutation, { data, loading, error }] = useCreateAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuthTokenMutation, CreateAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuthTokenMutation, CreateAuthTokenMutationVariables>(CreateAuthTokenDocument, options);
      }
export type CreateAuthTokenMutationHookResult = ReturnType<typeof useCreateAuthTokenMutation>;
export type CreateAuthTokenMutationResult = Apollo.MutationResult<CreateAuthTokenMutation>;
export type CreateAuthTokenMutationOptions = Apollo.BaseMutationOptions<CreateAuthTokenMutation, CreateAuthTokenMutationVariables>;
export const CreateAwkwardMomentLabelDocument = gql`
    mutation CreateAwkwardMomentLabel($input: CreateAwkwardMomentLabelInput!) {
  createAwkwardMomentLabel(input: $input) {
    success
    error
  }
}
    `;
export type CreateAwkwardMomentLabelMutationFn = Apollo.MutationFunction<CreateAwkwardMomentLabelMutation, CreateAwkwardMomentLabelMutationVariables>;

/**
 * __useCreateAwkwardMomentLabelMutation__
 *
 * To run a mutation, you first call `useCreateAwkwardMomentLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAwkwardMomentLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAwkwardMomentLabelMutation, { data, loading, error }] = useCreateAwkwardMomentLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAwkwardMomentLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateAwkwardMomentLabelMutation, CreateAwkwardMomentLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAwkwardMomentLabelMutation, CreateAwkwardMomentLabelMutationVariables>(CreateAwkwardMomentLabelDocument, options);
      }
export type CreateAwkwardMomentLabelMutationHookResult = ReturnType<typeof useCreateAwkwardMomentLabelMutation>;
export type CreateAwkwardMomentLabelMutationResult = Apollo.MutationResult<CreateAwkwardMomentLabelMutation>;
export type CreateAwkwardMomentLabelMutationOptions = Apollo.BaseMutationOptions<CreateAwkwardMomentLabelMutation, CreateAwkwardMomentLabelMutationVariables>;
export const CreateCarrierRateDocument = gql`
    mutation CreateCarrierRate($input: CreateCarrierRateInput!) {
  createCarrierRate(input: $input) {
    success
    carrierRate {
      ...CarrierRate
    }
  }
}
    ${CarrierRateFragmentDoc}`;
export type CreateCarrierRateMutationFn = Apollo.MutationFunction<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>;

/**
 * __useCreateCarrierRateMutation__
 *
 * To run a mutation, you first call `useCreateCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierRateMutation, { data, loading, error }] = useCreateCarrierRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>(CreateCarrierRateDocument, options);
      }
export type CreateCarrierRateMutationHookResult = ReturnType<typeof useCreateCarrierRateMutation>;
export type CreateCarrierRateMutationResult = Apollo.MutationResult<CreateCarrierRateMutation>;
export type CreateCarrierRateMutationOptions = Apollo.BaseMutationOptions<CreateCarrierRateMutation, CreateCarrierRateMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    success
  }
}
    `;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateCustomerRateDocument = gql`
    mutation CreateCustomerRate($input: CreateCustomerRateInput!) {
  createCustomerRate(input: $input) {
    success
    customerRate {
      ...CustomerRate
    }
  }
}
    ${CustomerRateFragmentDoc}`;
export type CreateCustomerRateMutationFn = Apollo.MutationFunction<CreateCustomerRateMutation, CreateCustomerRateMutationVariables>;

/**
 * __useCreateCustomerRateMutation__
 *
 * To run a mutation, you first call `useCreateCustomerRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerRateMutation, { data, loading, error }] = useCreateCustomerRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerRateMutation, CreateCustomerRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerRateMutation, CreateCustomerRateMutationVariables>(CreateCustomerRateDocument, options);
      }
export type CreateCustomerRateMutationHookResult = ReturnType<typeof useCreateCustomerRateMutation>;
export type CreateCustomerRateMutationResult = Apollo.MutationResult<CreateCustomerRateMutation>;
export type CreateCustomerRateMutationOptions = Apollo.BaseMutationOptions<CreateCustomerRateMutation, CreateCustomerRateMutationVariables>;
export const CreateExternalChannelDocument = gql`
    mutation CreateExternalChannel($input: CreateExternalChannelInput!) {
  createExternalChannel(input: $input) {
    success
    externalChannel {
      ...ExternalChannel
    }
  }
}
    ${ExternalChannelFragmentDoc}`;
export type CreateExternalChannelMutationFn = Apollo.MutationFunction<CreateExternalChannelMutation, CreateExternalChannelMutationVariables>;

/**
 * __useCreateExternalChannelMutation__
 *
 * To run a mutation, you first call `useCreateExternalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalChannelMutation, { data, loading, error }] = useCreateExternalChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalChannelMutation, CreateExternalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalChannelMutation, CreateExternalChannelMutationVariables>(CreateExternalChannelDocument, options);
      }
export type CreateExternalChannelMutationHookResult = ReturnType<typeof useCreateExternalChannelMutation>;
export type CreateExternalChannelMutationResult = Apollo.MutationResult<CreateExternalChannelMutation>;
export type CreateExternalChannelMutationOptions = Apollo.BaseMutationOptions<CreateExternalChannelMutation, CreateExternalChannelMutationVariables>;
export const CreateFreightDataMappingDocument = gql`
    mutation CreateFreightDataMapping($input: CreateFreightDataMappingInput!) {
  createFreightDataMapping(input: $input) {
    freightDataMapping {
      id
      key
      type
      values
      organizationId
      createdAt
      updatedAt
    }
    success
  }
}
    `;
export type CreateFreightDataMappingMutationFn = Apollo.MutationFunction<CreateFreightDataMappingMutation, CreateFreightDataMappingMutationVariables>;

/**
 * __useCreateFreightDataMappingMutation__
 *
 * To run a mutation, you first call `useCreateFreightDataMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFreightDataMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFreightDataMappingMutation, { data, loading, error }] = useCreateFreightDataMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFreightDataMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateFreightDataMappingMutation, CreateFreightDataMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFreightDataMappingMutation, CreateFreightDataMappingMutationVariables>(CreateFreightDataMappingDocument, options);
      }
export type CreateFreightDataMappingMutationHookResult = ReturnType<typeof useCreateFreightDataMappingMutation>;
export type CreateFreightDataMappingMutationResult = Apollo.MutationResult<CreateFreightDataMappingMutation>;
export type CreateFreightDataMappingMutationOptions = Apollo.BaseMutationOptions<CreateFreightDataMappingMutation, CreateFreightDataMappingMutationVariables>;
export const CreateFrontMailboxSubscriptionsDocument = gql`
    mutation CreateFrontMailboxSubscriptions($input: CreateFrontMailboxSubscriptionsInput!) {
  createFrontMailboxSubscriptions(input: $input) {
    success
    mailboxes {
      id
      externalId
      organizationId
      ownerId
      createdAt
    }
    error
  }
}
    `;
export type CreateFrontMailboxSubscriptionsMutationFn = Apollo.MutationFunction<CreateFrontMailboxSubscriptionsMutation, CreateFrontMailboxSubscriptionsMutationVariables>;

/**
 * __useCreateFrontMailboxSubscriptionsMutation__
 *
 * To run a mutation, you first call `useCreateFrontMailboxSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFrontMailboxSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFrontMailboxSubscriptionsMutation, { data, loading, error }] = useCreateFrontMailboxSubscriptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFrontMailboxSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateFrontMailboxSubscriptionsMutation, CreateFrontMailboxSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFrontMailboxSubscriptionsMutation, CreateFrontMailboxSubscriptionsMutationVariables>(CreateFrontMailboxSubscriptionsDocument, options);
      }
export type CreateFrontMailboxSubscriptionsMutationHookResult = ReturnType<typeof useCreateFrontMailboxSubscriptionsMutation>;
export type CreateFrontMailboxSubscriptionsMutationResult = Apollo.MutationResult<CreateFrontMailboxSubscriptionsMutation>;
export type CreateFrontMailboxSubscriptionsMutationOptions = Apollo.BaseMutationOptions<CreateFrontMailboxSubscriptionsMutation, CreateFrontMailboxSubscriptionsMutationVariables>;
export const CreateGenericTransformationDocument = gql`
    mutation CreateGenericTransformation($input: CreateGenericTransformationInput!) {
  createGenericTransformation(input: $input) {
    success
  }
}
    `;
export type CreateGenericTransformationMutationFn = Apollo.MutationFunction<CreateGenericTransformationMutation, CreateGenericTransformationMutationVariables>;

/**
 * __useCreateGenericTransformationMutation__
 *
 * To run a mutation, you first call `useCreateGenericTransformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericTransformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericTransformationMutation, { data, loading, error }] = useCreateGenericTransformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGenericTransformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericTransformationMutation, CreateGenericTransformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericTransformationMutation, CreateGenericTransformationMutationVariables>(CreateGenericTransformationDocument, options);
      }
export type CreateGenericTransformationMutationHookResult = ReturnType<typeof useCreateGenericTransformationMutation>;
export type CreateGenericTransformationMutationResult = Apollo.MutationResult<CreateGenericTransformationMutation>;
export type CreateGenericTransformationMutationOptions = Apollo.BaseMutationOptions<CreateGenericTransformationMutation, CreateGenericTransformationMutationVariables>;
export const CreateInstantQuoteDocument = gql`
    mutation CreateInstantQuote {
  createInstantQuote {
    success
    quote {
      id
    }
  }
}
    `;
export type CreateInstantQuoteMutationFn = Apollo.MutationFunction<CreateInstantQuoteMutation, CreateInstantQuoteMutationVariables>;

/**
 * __useCreateInstantQuoteMutation__
 *
 * To run a mutation, you first call `useCreateInstantQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstantQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstantQuoteMutation, { data, loading, error }] = useCreateInstantQuoteMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateInstantQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstantQuoteMutation, CreateInstantQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstantQuoteMutation, CreateInstantQuoteMutationVariables>(CreateInstantQuoteDocument, options);
      }
export type CreateInstantQuoteMutationHookResult = ReturnType<typeof useCreateInstantQuoteMutation>;
export type CreateInstantQuoteMutationResult = Apollo.MutationResult<CreateInstantQuoteMutation>;
export type CreateInstantQuoteMutationOptions = Apollo.BaseMutationOptions<CreateInstantQuoteMutation, CreateInstantQuoteMutationVariables>;
export const CreateMemoryEntityLinkDocument = gql`
    mutation CreateMemoryEntityLink($input: CreateMemoryEntityLinkInput!) {
  createMemoryEntityLink(input: $input) {
    success
    memoryEntityLink {
      ...MemoryEntityLinkEntities
    }
  }
}
    ${MemoryEntityLinkEntitiesFragmentDoc}`;
export type CreateMemoryEntityLinkMutationFn = Apollo.MutationFunction<CreateMemoryEntityLinkMutation, CreateMemoryEntityLinkMutationVariables>;

/**
 * __useCreateMemoryEntityLinkMutation__
 *
 * To run a mutation, you first call `useCreateMemoryEntityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemoryEntityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemoryEntityLinkMutation, { data, loading, error }] = useCreateMemoryEntityLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMemoryEntityLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateMemoryEntityLinkMutation, CreateMemoryEntityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMemoryEntityLinkMutation, CreateMemoryEntityLinkMutationVariables>(CreateMemoryEntityLinkDocument, options);
      }
export type CreateMemoryEntityLinkMutationHookResult = ReturnType<typeof useCreateMemoryEntityLinkMutation>;
export type CreateMemoryEntityLinkMutationResult = Apollo.MutationResult<CreateMemoryEntityLinkMutation>;
export type CreateMemoryEntityLinkMutationOptions = Apollo.BaseMutationOptions<CreateMemoryEntityLinkMutation, CreateMemoryEntityLinkMutationVariables>;
export const CreateOriginatorDocument = gql`
    mutation CreateOriginator($input: CreateOriginatorInput!) {
  createOriginator(input: $input) {
    success
    originator {
      ...Originator
    }
  }
}
    ${OriginatorFragmentDoc}`;
export type CreateOriginatorMutationFn = Apollo.MutationFunction<CreateOriginatorMutation, CreateOriginatorMutationVariables>;

/**
 * __useCreateOriginatorMutation__
 *
 * To run a mutation, you first call `useCreateOriginatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOriginatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOriginatorMutation, { data, loading, error }] = useCreateOriginatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOriginatorMutation(baseOptions?: Apollo.MutationHookOptions<CreateOriginatorMutation, CreateOriginatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOriginatorMutation, CreateOriginatorMutationVariables>(CreateOriginatorDocument, options);
      }
export type CreateOriginatorMutationHookResult = ReturnType<typeof useCreateOriginatorMutation>;
export type CreateOriginatorMutationResult = Apollo.MutationResult<CreateOriginatorMutation>;
export type CreateOriginatorMutationOptions = Apollo.BaseMutationOptions<CreateOriginatorMutation, CreateOriginatorMutationVariables>;
export const CreateOriginatorEventDocument = gql`
    mutation CreateOriginatorEvent($input: CreateOriginatorEventInput!) {
  createOriginatorEvent(input: $input) {
    success
  }
}
    `;
export type CreateOriginatorEventMutationFn = Apollo.MutationFunction<CreateOriginatorEventMutation, CreateOriginatorEventMutationVariables>;

/**
 * __useCreateOriginatorEventMutation__
 *
 * To run a mutation, you first call `useCreateOriginatorEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOriginatorEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOriginatorEventMutation, { data, loading, error }] = useCreateOriginatorEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOriginatorEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateOriginatorEventMutation, CreateOriginatorEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOriginatorEventMutation, CreateOriginatorEventMutationVariables>(CreateOriginatorEventDocument, options);
      }
export type CreateOriginatorEventMutationHookResult = ReturnType<typeof useCreateOriginatorEventMutation>;
export type CreateOriginatorEventMutationResult = Apollo.MutationResult<CreateOriginatorEventMutation>;
export type CreateOriginatorEventMutationOptions = Apollo.BaseMutationOptions<CreateOriginatorEventMutation, CreateOriginatorEventMutationVariables>;
export const CreatePlaceSchedulingMethodDocument = gql`
    mutation CreatePlaceSchedulingMethod($input: CreatePlaceSchedulingMethodInput!) {
  createPlaceSchedulingMethod(input: $input) {
    scheduling {
      ...PlaceScheduling
    }
  }
}
    ${PlaceSchedulingFragmentDoc}`;
export type CreatePlaceSchedulingMethodMutationFn = Apollo.MutationFunction<CreatePlaceSchedulingMethodMutation, CreatePlaceSchedulingMethodMutationVariables>;

/**
 * __useCreatePlaceSchedulingMethodMutation__
 *
 * To run a mutation, you first call `useCreatePlaceSchedulingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaceSchedulingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaceSchedulingMethodMutation, { data, loading, error }] = useCreatePlaceSchedulingMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaceSchedulingMethodMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaceSchedulingMethodMutation, CreatePlaceSchedulingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaceSchedulingMethodMutation, CreatePlaceSchedulingMethodMutationVariables>(CreatePlaceSchedulingMethodDocument, options);
      }
export type CreatePlaceSchedulingMethodMutationHookResult = ReturnType<typeof useCreatePlaceSchedulingMethodMutation>;
export type CreatePlaceSchedulingMethodMutationResult = Apollo.MutationResult<CreatePlaceSchedulingMethodMutation>;
export type CreatePlaceSchedulingMethodMutationOptions = Apollo.BaseMutationOptions<CreatePlaceSchedulingMethodMutation, CreatePlaceSchedulingMethodMutationVariables>;
export const CreatePricingStrategyDocument = gql`
    mutation CreatePricingStrategy($input: CreatePricingStrategyInput!) {
  createPricingStrategy(input: $input) {
    pricingStrategy {
      id
      type
      config
    }
    success
  }
}
    `;
export type CreatePricingStrategyMutationFn = Apollo.MutationFunction<CreatePricingStrategyMutation, CreatePricingStrategyMutationVariables>;

/**
 * __useCreatePricingStrategyMutation__
 *
 * To run a mutation, you first call `useCreatePricingStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingStrategyMutation, { data, loading, error }] = useCreatePricingStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePricingStrategyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePricingStrategyMutation, CreatePricingStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePricingStrategyMutation, CreatePricingStrategyMutationVariables>(CreatePricingStrategyDocument, options);
      }
export type CreatePricingStrategyMutationHookResult = ReturnType<typeof useCreatePricingStrategyMutation>;
export type CreatePricingStrategyMutationResult = Apollo.MutationResult<CreatePricingStrategyMutation>;
export type CreatePricingStrategyMutationOptions = Apollo.BaseMutationOptions<CreatePricingStrategyMutation, CreatePricingStrategyMutationVariables>;
export const CreateQuoteEventDocument = gql`
    mutation CreateQuoteEvent($input: CreateQuoteEventInput!) {
  createQuoteEvent(input: $input) {
    success
    quoteEvent {
      ...QuoteEvent
    }
  }
}
    ${QuoteEventFragmentDoc}`;
export type CreateQuoteEventMutationFn = Apollo.MutationFunction<CreateQuoteEventMutation, CreateQuoteEventMutationVariables>;

/**
 * __useCreateQuoteEventMutation__
 *
 * To run a mutation, you first call `useCreateQuoteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteEventMutation, { data, loading, error }] = useCreateQuoteEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteEventMutation, CreateQuoteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteEventMutation, CreateQuoteEventMutationVariables>(CreateQuoteEventDocument, options);
      }
export type CreateQuoteEventMutationHookResult = ReturnType<typeof useCreateQuoteEventMutation>;
export type CreateQuoteEventMutationResult = Apollo.MutationResult<CreateQuoteEventMutation>;
export type CreateQuoteEventMutationOptions = Apollo.BaseMutationOptions<CreateQuoteEventMutation, CreateQuoteEventMutationVariables>;
export const CreateQuoteNoteDocument = gql`
    mutation CreateQuoteNote($input: CreateQuoteNoteInput!) {
  createQuoteNote(input: $input) {
    success
    quoteNote {
      ...QuoteNote
    }
  }
}
    ${QuoteNoteFragmentDoc}`;
export type CreateQuoteNoteMutationFn = Apollo.MutationFunction<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>;

/**
 * __useCreateQuoteNoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteNoteMutation, { data, loading, error }] = useCreateQuoteNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuoteNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>(CreateQuoteNoteDocument, options);
      }
export type CreateQuoteNoteMutationHookResult = ReturnType<typeof useCreateQuoteNoteMutation>;
export type CreateQuoteNoteMutationResult = Apollo.MutationResult<CreateQuoteNoteMutation>;
export type CreateQuoteNoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    team {
      id
      name
      description
    }
    success
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const CreateTeamMemberDocument = gql`
    mutation CreateTeamMember($input: CreateTeamMemberInput!) {
  createTeamMember(input: $input) {
    success
  }
}
    `;
export type CreateTeamMemberMutationFn = Apollo.MutationFunction<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;

/**
 * __useCreateTeamMemberMutation__
 *
 * To run a mutation, you first call `useCreateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMemberMutation, { data, loading, error }] = useCreateTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>(CreateTeamMemberDocument, options);
      }
export type CreateTeamMemberMutationHookResult = ReturnType<typeof useCreateTeamMemberMutation>;
export type CreateTeamMemberMutationResult = Apollo.MutationResult<CreateTeamMemberMutation>;
export type CreateTeamMemberMutationOptions = Apollo.BaseMutationOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($input: CreateTemplateInput!) {
  createTemplate(input: $input) {
    success
    template {
      ...Template
    }
  }
}
    ${TemplateFragmentDoc}`;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutation, { data, loading, error }] = useCreateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutationHookResult = ReturnType<typeof useCreateTemplateMutation>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const CreateTranscriptionLabelDocument = gql`
    mutation CreateTranscriptionLabel($input: CreateTranscriptionLabelInput!) {
  createTranscriptionLabel(input: $input) {
    success
    alreadyFlagged
    error
  }
}
    `;
export type CreateTranscriptionLabelMutationFn = Apollo.MutationFunction<CreateTranscriptionLabelMutation, CreateTranscriptionLabelMutationVariables>;

/**
 * __useCreateTranscriptionLabelMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptionLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptionLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranscriptionLabelMutation, { data, loading, error }] = useCreateTranscriptionLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranscriptionLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranscriptionLabelMutation, CreateTranscriptionLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranscriptionLabelMutation, CreateTranscriptionLabelMutationVariables>(CreateTranscriptionLabelDocument, options);
      }
export type CreateTranscriptionLabelMutationHookResult = ReturnType<typeof useCreateTranscriptionLabelMutation>;
export type CreateTranscriptionLabelMutationResult = Apollo.MutationResult<CreateTranscriptionLabelMutation>;
export type CreateTranscriptionLabelMutationOptions = Apollo.BaseMutationOptions<CreateTranscriptionLabelMutation, CreateTranscriptionLabelMutationVariables>;
export const CreateTransformationConfigDocument = gql`
    mutation CreateTransformationConfig($input: CreateTransformationConfigInput!) {
  createTransformationConfig(input: $input) {
    success
    transformationConfig {
      ...TransformationConfig
    }
  }
}
    ${TransformationConfigFragmentDoc}`;
export type CreateTransformationConfigMutationFn = Apollo.MutationFunction<CreateTransformationConfigMutation, CreateTransformationConfigMutationVariables>;

/**
 * __useCreateTransformationConfigMutation__
 *
 * To run a mutation, you first call `useCreateTransformationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransformationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransformationConfigMutation, { data, loading, error }] = useCreateTransformationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransformationConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransformationConfigMutation, CreateTransformationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransformationConfigMutation, CreateTransformationConfigMutationVariables>(CreateTransformationConfigDocument, options);
      }
export type CreateTransformationConfigMutationHookResult = ReturnType<typeof useCreateTransformationConfigMutation>;
export type CreateTransformationConfigMutationResult = Apollo.MutationResult<CreateTransformationConfigMutation>;
export type CreateTransformationConfigMutationOptions = Apollo.BaseMutationOptions<CreateTransformationConfigMutation, CreateTransformationConfigMutationVariables>;
export const CreateTransformationDefinitionDocument = gql`
    mutation CreateTransformationDefinition($input: CreateTransformationDefinitionInput!) {
  createTransformationDefinition(input: $input) {
    success
    transformationDefinition {
      ...TransformationDefinition
    }
  }
}
    ${TransformationDefinitionFragmentDoc}`;
export type CreateTransformationDefinitionMutationFn = Apollo.MutationFunction<CreateTransformationDefinitionMutation, CreateTransformationDefinitionMutationVariables>;

/**
 * __useCreateTransformationDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateTransformationDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransformationDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransformationDefinitionMutation, { data, loading, error }] = useCreateTransformationDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransformationDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransformationDefinitionMutation, CreateTransformationDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransformationDefinitionMutation, CreateTransformationDefinitionMutationVariables>(CreateTransformationDefinitionDocument, options);
      }
export type CreateTransformationDefinitionMutationHookResult = ReturnType<typeof useCreateTransformationDefinitionMutation>;
export type CreateTransformationDefinitionMutationResult = Apollo.MutationResult<CreateTransformationDefinitionMutation>;
export type CreateTransformationDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateTransformationDefinitionMutation, CreateTransformationDefinitionMutationVariables>;
export const CreateTurnTakingLabelDocument = gql`
    mutation CreateTurnTakingLabel($input: CreateTurnTakingLabelInput!) {
  createTurnTakingLabel(input: $input) {
    success
    alreadyFlagged
    error
  }
}
    `;
export type CreateTurnTakingLabelMutationFn = Apollo.MutationFunction<CreateTurnTakingLabelMutation, CreateTurnTakingLabelMutationVariables>;

/**
 * __useCreateTurnTakingLabelMutation__
 *
 * To run a mutation, you first call `useCreateTurnTakingLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTurnTakingLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTurnTakingLabelMutation, { data, loading, error }] = useCreateTurnTakingLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTurnTakingLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateTurnTakingLabelMutation, CreateTurnTakingLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTurnTakingLabelMutation, CreateTurnTakingLabelMutationVariables>(CreateTurnTakingLabelDocument, options);
      }
export type CreateTurnTakingLabelMutationHookResult = ReturnType<typeof useCreateTurnTakingLabelMutation>;
export type CreateTurnTakingLabelMutationResult = Apollo.MutationResult<CreateTurnTakingLabelMutation>;
export type CreateTurnTakingLabelMutationOptions = Apollo.BaseMutationOptions<CreateTurnTakingLabelMutation, CreateTurnTakingLabelMutationVariables>;
export const CreateWebhookSubscriptionDocument = gql`
    mutation CreateWebhookSubscription($input: CreateWebhookSubscriptionInput!) {
  createWebhookSubscription(input: $input) {
    success
    item {
      id
    }
  }
}
    `;
export type CreateWebhookSubscriptionMutationFn = Apollo.MutationFunction<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>;

/**
 * __useCreateWebhookSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateWebhookSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookSubscriptionMutation, { data, loading, error }] = useCreateWebhookSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>(CreateWebhookSubscriptionDocument, options);
      }
export type CreateWebhookSubscriptionMutationHookResult = ReturnType<typeof useCreateWebhookSubscriptionMutation>;
export type CreateWebhookSubscriptionMutationResult = Apollo.MutationResult<CreateWebhookSubscriptionMutation>;
export type CreateWebhookSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateWebhookSubscriptionMutation, CreateWebhookSubscriptionMutationVariables>;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow($input: CreateWorkflowInput!) {
  createWorkflow(input: $input) {
    success
    workflow {
      ...Workflow
    }
  }
}
    ${WorkflowFragmentDoc}`;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<CreateWorkflowMutation, CreateWorkflowMutationVariables>;

/**
 * __useCreateWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutation, { data, loading, error }] = useCreateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
      }
export type CreateWorkflowMutationHookResult = ReturnType<typeof useCreateWorkflowMutation>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const DeleteApiClientDocument = gql`
    mutation DeleteApiClient($input: DeleteApiClientInput!) {
  deleteApiClient(input: $input) {
    success
  }
}
    `;
export type DeleteApiClientMutationFn = Apollo.MutationFunction<DeleteApiClientMutation, DeleteApiClientMutationVariables>;

/**
 * __useDeleteApiClientMutation__
 *
 * To run a mutation, you first call `useDeleteApiClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiClientMutation, { data, loading, error }] = useDeleteApiClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteApiClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiClientMutation, DeleteApiClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiClientMutation, DeleteApiClientMutationVariables>(DeleteApiClientDocument, options);
      }
export type DeleteApiClientMutationHookResult = ReturnType<typeof useDeleteApiClientMutation>;
export type DeleteApiClientMutationResult = Apollo.MutationResult<DeleteApiClientMutation>;
export type DeleteApiClientMutationOptions = Apollo.BaseMutationOptions<DeleteApiClientMutation, DeleteApiClientMutationVariables>;
export const DeleteAuthTokenDocument = gql`
    mutation DeleteAuthToken($input: DeleteAuthTokenInput!) {
  deleteAuthToken(input: $input) {
    success
  }
}
    `;
export type DeleteAuthTokenMutationFn = Apollo.MutationFunction<DeleteAuthTokenMutation, DeleteAuthTokenMutationVariables>;

/**
 * __useDeleteAuthTokenMutation__
 *
 * To run a mutation, you first call `useDeleteAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthTokenMutation, { data, loading, error }] = useDeleteAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthTokenMutation, DeleteAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAuthTokenMutation, DeleteAuthTokenMutationVariables>(DeleteAuthTokenDocument, options);
      }
export type DeleteAuthTokenMutationHookResult = ReturnType<typeof useDeleteAuthTokenMutation>;
export type DeleteAuthTokenMutationResult = Apollo.MutationResult<DeleteAuthTokenMutation>;
export type DeleteAuthTokenMutationOptions = Apollo.BaseMutationOptions<DeleteAuthTokenMutation, DeleteAuthTokenMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($input: DeleteContactInput!) {
  deleteContact(input: $input) {
    success
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const DeleteFreightDataMappingDocument = gql`
    mutation DeleteFreightDataMapping($input: DeleteFreightDataMappingInput!) {
  deleteFreightDataMapping(input: $input) {
    success
  }
}
    `;
export type DeleteFreightDataMappingMutationFn = Apollo.MutationFunction<DeleteFreightDataMappingMutation, DeleteFreightDataMappingMutationVariables>;

/**
 * __useDeleteFreightDataMappingMutation__
 *
 * To run a mutation, you first call `useDeleteFreightDataMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFreightDataMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFreightDataMappingMutation, { data, loading, error }] = useDeleteFreightDataMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFreightDataMappingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFreightDataMappingMutation, DeleteFreightDataMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFreightDataMappingMutation, DeleteFreightDataMappingMutationVariables>(DeleteFreightDataMappingDocument, options);
      }
export type DeleteFreightDataMappingMutationHookResult = ReturnType<typeof useDeleteFreightDataMappingMutation>;
export type DeleteFreightDataMappingMutationResult = Apollo.MutationResult<DeleteFreightDataMappingMutation>;
export type DeleteFreightDataMappingMutationOptions = Apollo.BaseMutationOptions<DeleteFreightDataMappingMutation, DeleteFreightDataMappingMutationVariables>;
export const DeleteFrontMailboxSubscriptionsDocument = gql`
    mutation DeleteFrontMailboxSubscriptions($input: DeleteFrontMailboxSubscriptionsInput!) {
  deleteFrontMailboxSubscriptions(input: $input) {
    success
    error
  }
}
    `;
export type DeleteFrontMailboxSubscriptionsMutationFn = Apollo.MutationFunction<DeleteFrontMailboxSubscriptionsMutation, DeleteFrontMailboxSubscriptionsMutationVariables>;

/**
 * __useDeleteFrontMailboxSubscriptionsMutation__
 *
 * To run a mutation, you first call `useDeleteFrontMailboxSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFrontMailboxSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFrontMailboxSubscriptionsMutation, { data, loading, error }] = useDeleteFrontMailboxSubscriptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFrontMailboxSubscriptionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFrontMailboxSubscriptionsMutation, DeleteFrontMailboxSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFrontMailboxSubscriptionsMutation, DeleteFrontMailboxSubscriptionsMutationVariables>(DeleteFrontMailboxSubscriptionsDocument, options);
      }
export type DeleteFrontMailboxSubscriptionsMutationHookResult = ReturnType<typeof useDeleteFrontMailboxSubscriptionsMutation>;
export type DeleteFrontMailboxSubscriptionsMutationResult = Apollo.MutationResult<DeleteFrontMailboxSubscriptionsMutation>;
export type DeleteFrontMailboxSubscriptionsMutationOptions = Apollo.BaseMutationOptions<DeleteFrontMailboxSubscriptionsMutation, DeleteFrontMailboxSubscriptionsMutationVariables>;
export const DeleteGenericTransformationDocument = gql`
    mutation DeleteGenericTransformation($input: DeleteGenericTransformationInput!) {
  deleteGenericTransformation(input: $input) {
    success
  }
}
    `;
export type DeleteGenericTransformationMutationFn = Apollo.MutationFunction<DeleteGenericTransformationMutation, DeleteGenericTransformationMutationVariables>;

/**
 * __useDeleteGenericTransformationMutation__
 *
 * To run a mutation, you first call `useDeleteGenericTransformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericTransformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericTransformationMutation, { data, loading, error }] = useDeleteGenericTransformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGenericTransformationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericTransformationMutation, DeleteGenericTransformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericTransformationMutation, DeleteGenericTransformationMutationVariables>(DeleteGenericTransformationDocument, options);
      }
export type DeleteGenericTransformationMutationHookResult = ReturnType<typeof useDeleteGenericTransformationMutation>;
export type DeleteGenericTransformationMutationResult = Apollo.MutationResult<DeleteGenericTransformationMutation>;
export type DeleteGenericTransformationMutationOptions = Apollo.BaseMutationOptions<DeleteGenericTransformationMutation, DeleteGenericTransformationMutationVariables>;
export const DeleteMemoryDocument = gql`
    mutation DeleteMemory($input: DeleteMemoryInput!) {
  deleteMemory(input: $input) {
    success
  }
}
    `;
export type DeleteMemoryMutationFn = Apollo.MutationFunction<DeleteMemoryMutation, DeleteMemoryMutationVariables>;

/**
 * __useDeleteMemoryMutation__
 *
 * To run a mutation, you first call `useDeleteMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemoryMutation, { data, loading, error }] = useDeleteMemoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMemoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemoryMutation, DeleteMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemoryMutation, DeleteMemoryMutationVariables>(DeleteMemoryDocument, options);
      }
export type DeleteMemoryMutationHookResult = ReturnType<typeof useDeleteMemoryMutation>;
export type DeleteMemoryMutationResult = Apollo.MutationResult<DeleteMemoryMutation>;
export type DeleteMemoryMutationOptions = Apollo.BaseMutationOptions<DeleteMemoryMutation, DeleteMemoryMutationVariables>;
export const DeleteMemoryEntityLinkDocument = gql`
    mutation DeleteMemoryEntityLink($input: DeleteMemoryEntityLinkInput!) {
  deleteMemoryEntityLink(input: $input) {
    success
  }
}
    `;
export type DeleteMemoryEntityLinkMutationFn = Apollo.MutationFunction<DeleteMemoryEntityLinkMutation, DeleteMemoryEntityLinkMutationVariables>;

/**
 * __useDeleteMemoryEntityLinkMutation__
 *
 * To run a mutation, you first call `useDeleteMemoryEntityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemoryEntityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemoryEntityLinkMutation, { data, loading, error }] = useDeleteMemoryEntityLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMemoryEntityLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemoryEntityLinkMutation, DeleteMemoryEntityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemoryEntityLinkMutation, DeleteMemoryEntityLinkMutationVariables>(DeleteMemoryEntityLinkDocument, options);
      }
export type DeleteMemoryEntityLinkMutationHookResult = ReturnType<typeof useDeleteMemoryEntityLinkMutation>;
export type DeleteMemoryEntityLinkMutationResult = Apollo.MutationResult<DeleteMemoryEntityLinkMutation>;
export type DeleteMemoryEntityLinkMutationOptions = Apollo.BaseMutationOptions<DeleteMemoryEntityLinkMutation, DeleteMemoryEntityLinkMutationVariables>;
export const DeletePlaceSchedulingMethodDocument = gql`
    mutation DeletePlaceSchedulingMethod($input: DeletePlaceSchedulingMethodInput!) {
  deletePlaceSchedulingMethod(input: $input) {
    scheduling {
      ...PlaceScheduling
    }
  }
}
    ${PlaceSchedulingFragmentDoc}`;
export type DeletePlaceSchedulingMethodMutationFn = Apollo.MutationFunction<DeletePlaceSchedulingMethodMutation, DeletePlaceSchedulingMethodMutationVariables>;

/**
 * __useDeletePlaceSchedulingMethodMutation__
 *
 * To run a mutation, you first call `useDeletePlaceSchedulingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaceSchedulingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaceSchedulingMethodMutation, { data, loading, error }] = useDeletePlaceSchedulingMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlaceSchedulingMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaceSchedulingMethodMutation, DeletePlaceSchedulingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaceSchedulingMethodMutation, DeletePlaceSchedulingMethodMutationVariables>(DeletePlaceSchedulingMethodDocument, options);
      }
export type DeletePlaceSchedulingMethodMutationHookResult = ReturnType<typeof useDeletePlaceSchedulingMethodMutation>;
export type DeletePlaceSchedulingMethodMutationResult = Apollo.MutationResult<DeletePlaceSchedulingMethodMutation>;
export type DeletePlaceSchedulingMethodMutationOptions = Apollo.BaseMutationOptions<DeletePlaceSchedulingMethodMutation, DeletePlaceSchedulingMethodMutationVariables>;
export const DeletePricingStrategyDocument = gql`
    mutation DeletePricingStrategy($input: DeletePricingStrategyInput!) {
  deletePricingStrategy(input: $input) {
    success
  }
}
    `;
export type DeletePricingStrategyMutationFn = Apollo.MutationFunction<DeletePricingStrategyMutation, DeletePricingStrategyMutationVariables>;

/**
 * __useDeletePricingStrategyMutation__
 *
 * To run a mutation, you first call `useDeletePricingStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePricingStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePricingStrategyMutation, { data, loading, error }] = useDeletePricingStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePricingStrategyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePricingStrategyMutation, DeletePricingStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePricingStrategyMutation, DeletePricingStrategyMutationVariables>(DeletePricingStrategyDocument, options);
      }
export type DeletePricingStrategyMutationHookResult = ReturnType<typeof useDeletePricingStrategyMutation>;
export type DeletePricingStrategyMutationResult = Apollo.MutationResult<DeletePricingStrategyMutation>;
export type DeletePricingStrategyMutationOptions = Apollo.BaseMutationOptions<DeletePricingStrategyMutation, DeletePricingStrategyMutationVariables>;
export const DeleteQuoteDocument = gql`
    mutation DeleteQuote($input: DeleteQuoteInput!) {
  deleteQuote(input: $input) {
    success
  }
}
    `;
export type DeleteQuoteMutationFn = Apollo.MutationFunction<DeleteQuoteMutation, DeleteQuoteMutationVariables>;

/**
 * __useDeleteQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMutation, { data, loading, error }] = useDeleteQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument, options);
      }
export type DeleteQuoteMutationHookResult = ReturnType<typeof useDeleteQuoteMutation>;
export type DeleteQuoteMutationResult = Apollo.MutationResult<DeleteQuoteMutation>;
export type DeleteQuoteMutationOptions = Apollo.BaseMutationOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($input: DeleteTeamInput!) {
  deleteTeam(input: $input) {
    success
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const DeleteTeamMemberDocument = gql`
    mutation DeleteTeamMember($input: DeleteTeamMemberInput!) {
  deleteTeamMember(input: $input) {
    success
  }
}
    `;
export type DeleteTeamMemberMutationFn = Apollo.MutationFunction<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;

/**
 * __useDeleteTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberMutation, { data, loading, error }] = useDeleteTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>(DeleteTeamMemberDocument, options);
      }
export type DeleteTeamMemberMutationHookResult = ReturnType<typeof useDeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationResult = Apollo.MutationResult<DeleteTeamMemberMutation>;
export type DeleteTeamMemberMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;
export const DeleteWebhookSubscriptionDocument = gql`
    mutation DeleteWebhookSubscription($input: DeleteWebhookSubscriptionInput!) {
  deleteWebhookSubscription(input: $input) {
    success
  }
}
    `;
export type DeleteWebhookSubscriptionMutationFn = Apollo.MutationFunction<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>;

/**
 * __useDeleteWebhookSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookSubscriptionMutation, { data, loading, error }] = useDeleteWebhookSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWebhookSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>(DeleteWebhookSubscriptionDocument, options);
      }
export type DeleteWebhookSubscriptionMutationHookResult = ReturnType<typeof useDeleteWebhookSubscriptionMutation>;
export type DeleteWebhookSubscriptionMutationResult = Apollo.MutationResult<DeleteWebhookSubscriptionMutation>;
export type DeleteWebhookSubscriptionMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>;
export const DeleteWorkflowDocument = gql`
    mutation DeleteWorkflow($input: DeleteWorkflowInput!) {
  deleteWorkflow(input: $input) {
    success
  }
}
    `;
export type DeleteWorkflowMutationFn = Apollo.MutationFunction<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;

/**
 * __useDeleteWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowMutation, { data, loading, error }] = useDeleteWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>(DeleteWorkflowDocument, options);
      }
export type DeleteWorkflowMutationHookResult = ReturnType<typeof useDeleteWorkflowMutation>;
export type DeleteWorkflowMutationResult = Apollo.MutationResult<DeleteWorkflowMutation>;
export type DeleteWorkflowMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowMutation, DeleteWorkflowMutationVariables>;
export const FindOrCreateDatHistoryRatesDocument = gql`
    mutation FindOrCreateDATHistoryRates($input: DATHistoryRatesInput!) {
  findOrCreateDATHistoryRates(input: $input) {
    metadata
    rate
    label
    key
    errorMessage
  }
}
    `;
export type FindOrCreateDatHistoryRatesMutationFn = Apollo.MutationFunction<FindOrCreateDatHistoryRatesMutation, FindOrCreateDatHistoryRatesMutationVariables>;

/**
 * __useFindOrCreateDatHistoryRatesMutation__
 *
 * To run a mutation, you first call `useFindOrCreateDatHistoryRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateDatHistoryRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateDatHistoryRatesMutation, { data, loading, error }] = useFindOrCreateDatHistoryRatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrCreateDatHistoryRatesMutation(baseOptions?: Apollo.MutationHookOptions<FindOrCreateDatHistoryRatesMutation, FindOrCreateDatHistoryRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindOrCreateDatHistoryRatesMutation, FindOrCreateDatHistoryRatesMutationVariables>(FindOrCreateDatHistoryRatesDocument, options);
      }
export type FindOrCreateDatHistoryRatesMutationHookResult = ReturnType<typeof useFindOrCreateDatHistoryRatesMutation>;
export type FindOrCreateDatHistoryRatesMutationResult = Apollo.MutationResult<FindOrCreateDatHistoryRatesMutation>;
export type FindOrCreateDatHistoryRatesMutationOptions = Apollo.BaseMutationOptions<FindOrCreateDatHistoryRatesMutation, FindOrCreateDatHistoryRatesMutationVariables>;
export const FindOrCreateMarketConditionsDocument = gql`
    mutation FindOrCreateMarketConditions($input: MarketConditionsInput!) {
  findOrCreateMarketConditions(input: $input) {
    stop
    equipmentType
    integrationType
    marketConditions {
      apiResponse
      requestType
    }
    errorMessage
  }
}
    `;
export type FindOrCreateMarketConditionsMutationFn = Apollo.MutationFunction<FindOrCreateMarketConditionsMutation, FindOrCreateMarketConditionsMutationVariables>;

/**
 * __useFindOrCreateMarketConditionsMutation__
 *
 * To run a mutation, you first call `useFindOrCreateMarketConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateMarketConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateMarketConditionsMutation, { data, loading, error }] = useFindOrCreateMarketConditionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindOrCreateMarketConditionsMutation(baseOptions?: Apollo.MutationHookOptions<FindOrCreateMarketConditionsMutation, FindOrCreateMarketConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindOrCreateMarketConditionsMutation, FindOrCreateMarketConditionsMutationVariables>(FindOrCreateMarketConditionsDocument, options);
      }
export type FindOrCreateMarketConditionsMutationHookResult = ReturnType<typeof useFindOrCreateMarketConditionsMutation>;
export type FindOrCreateMarketConditionsMutationResult = Apollo.MutationResult<FindOrCreateMarketConditionsMutation>;
export type FindOrCreateMarketConditionsMutationOptions = Apollo.BaseMutationOptions<FindOrCreateMarketConditionsMutation, FindOrCreateMarketConditionsMutationVariables>;
export const LeaveTeamDocument = gql`
    mutation LeaveTeam($input: LeaveTeamInput!) {
  leaveTeam(input: $input) {
    success
  }
}
    `;
export type LeaveTeamMutationFn = Apollo.MutationFunction<LeaveTeamMutation, LeaveTeamMutationVariables>;

/**
 * __useLeaveTeamMutation__
 *
 * To run a mutation, you first call `useLeaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveTeamMutation, { data, loading, error }] = useLeaveTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveTeamMutation(baseOptions?: Apollo.MutationHookOptions<LeaveTeamMutation, LeaveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveTeamMutation, LeaveTeamMutationVariables>(LeaveTeamDocument, options);
      }
export type LeaveTeamMutationHookResult = ReturnType<typeof useLeaveTeamMutation>;
export type LeaveTeamMutationResult = Apollo.MutationResult<LeaveTeamMutation>;
export type LeaveTeamMutationOptions = Apollo.BaseMutationOptions<LeaveTeamMutation, LeaveTeamMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const OnboardNewOriginatorDocument = gql`
    mutation OnboardNewOriginator($input: OnboardNewOriginatorInput!) {
  onboardNewOriginator(input: $input) {
    success
    customerFacingOriginator {
      ...Originator
    }
  }
}
    ${OriginatorFragmentDoc}`;
export type OnboardNewOriginatorMutationFn = Apollo.MutationFunction<OnboardNewOriginatorMutation, OnboardNewOriginatorMutationVariables>;

/**
 * __useOnboardNewOriginatorMutation__
 *
 * To run a mutation, you first call `useOnboardNewOriginatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardNewOriginatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardNewOriginatorMutation, { data, loading, error }] = useOnboardNewOriginatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardNewOriginatorMutation(baseOptions?: Apollo.MutationHookOptions<OnboardNewOriginatorMutation, OnboardNewOriginatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardNewOriginatorMutation, OnboardNewOriginatorMutationVariables>(OnboardNewOriginatorDocument, options);
      }
export type OnboardNewOriginatorMutationHookResult = ReturnType<typeof useOnboardNewOriginatorMutation>;
export type OnboardNewOriginatorMutationResult = Apollo.MutationResult<OnboardNewOriginatorMutation>;
export type OnboardNewOriginatorMutationOptions = Apollo.BaseMutationOptions<OnboardNewOriginatorMutation, OnboardNewOriginatorMutationVariables>;
export const PageDocument = gql`
    mutation Page($input: PageInput!) {
  page(input: $input)
}
    `;
export type PageMutationFn = Apollo.MutationFunction<PageMutation, PageMutationVariables>;

/**
 * __usePageMutation__
 *
 * To run a mutation, you first call `usePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pageMutation, { data, loading, error }] = usePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePageMutation(baseOptions?: Apollo.MutationHookOptions<PageMutation, PageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PageMutation, PageMutationVariables>(PageDocument, options);
      }
export type PageMutationHookResult = ReturnType<typeof usePageMutation>;
export type PageMutationResult = Apollo.MutationResult<PageMutation>;
export type PageMutationOptions = Apollo.BaseMutationOptions<PageMutation, PageMutationVariables>;
export const ProposeFreightDataMappingValuesDocument = gql`
    mutation ProposeFreightDataMappingValues($input: ProposeFreightDataMappingValuesInput!) {
  proposeFreightDataMappingValues(input: $input) {
    proposedValues
    success
  }
}
    `;
export type ProposeFreightDataMappingValuesMutationFn = Apollo.MutationFunction<ProposeFreightDataMappingValuesMutation, ProposeFreightDataMappingValuesMutationVariables>;

/**
 * __useProposeFreightDataMappingValuesMutation__
 *
 * To run a mutation, you first call `useProposeFreightDataMappingValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposeFreightDataMappingValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposeFreightDataMappingValuesMutation, { data, loading, error }] = useProposeFreightDataMappingValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProposeFreightDataMappingValuesMutation(baseOptions?: Apollo.MutationHookOptions<ProposeFreightDataMappingValuesMutation, ProposeFreightDataMappingValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposeFreightDataMappingValuesMutation, ProposeFreightDataMappingValuesMutationVariables>(ProposeFreightDataMappingValuesDocument, options);
      }
export type ProposeFreightDataMappingValuesMutationHookResult = ReturnType<typeof useProposeFreightDataMappingValuesMutation>;
export type ProposeFreightDataMappingValuesMutationResult = Apollo.MutationResult<ProposeFreightDataMappingValuesMutation>;
export type ProposeFreightDataMappingValuesMutationOptions = Apollo.BaseMutationOptions<ProposeFreightDataMappingValuesMutation, ProposeFreightDataMappingValuesMutationVariables>;
export const RecoverMemoryDocument = gql`
    mutation RecoverMemory($input: RecoverMemoryInput!) {
  recoverMemory(input: $input) {
    success
  }
}
    `;
export type RecoverMemoryMutationFn = Apollo.MutationFunction<RecoverMemoryMutation, RecoverMemoryMutationVariables>;

/**
 * __useRecoverMemoryMutation__
 *
 * To run a mutation, you first call `useRecoverMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverMemoryMutation, { data, loading, error }] = useRecoverMemoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecoverMemoryMutation(baseOptions?: Apollo.MutationHookOptions<RecoverMemoryMutation, RecoverMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverMemoryMutation, RecoverMemoryMutationVariables>(RecoverMemoryDocument, options);
      }
export type RecoverMemoryMutationHookResult = ReturnType<typeof useRecoverMemoryMutation>;
export type RecoverMemoryMutationResult = Apollo.MutationResult<RecoverMemoryMutation>;
export type RecoverMemoryMutationOptions = Apollo.BaseMutationOptions<RecoverMemoryMutation, RecoverMemoryMutationVariables>;
export const RefreshQuoteMileageDocument = gql`
    mutation RefreshQuoteMileage($input: RefreshQuoteMileageInput!) {
  refreshQuoteMileage(input: $input) {
    success
  }
}
    `;
export type RefreshQuoteMileageMutationFn = Apollo.MutationFunction<RefreshQuoteMileageMutation, RefreshQuoteMileageMutationVariables>;

/**
 * __useRefreshQuoteMileageMutation__
 *
 * To run a mutation, you first call `useRefreshQuoteMileageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshQuoteMileageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshQuoteMileageMutation, { data, loading, error }] = useRefreshQuoteMileageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshQuoteMileageMutation(baseOptions?: Apollo.MutationHookOptions<RefreshQuoteMileageMutation, RefreshQuoteMileageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshQuoteMileageMutation, RefreshQuoteMileageMutationVariables>(RefreshQuoteMileageDocument, options);
      }
export type RefreshQuoteMileageMutationHookResult = ReturnType<typeof useRefreshQuoteMileageMutation>;
export type RefreshQuoteMileageMutationResult = Apollo.MutationResult<RefreshQuoteMileageMutation>;
export type RefreshQuoteMileageMutationOptions = Apollo.BaseMutationOptions<RefreshQuoteMileageMutation, RefreshQuoteMileageMutationVariables>;
export const ReprocessOrderDocument = gql`
    mutation ReprocessOrder($input: ReprocessOrderInput!) {
  reprocessOrder(input: $input) {
    success
  }
}
    `;
export type ReprocessOrderMutationFn = Apollo.MutationFunction<ReprocessOrderMutation, ReprocessOrderMutationVariables>;

/**
 * __useReprocessOrderMutation__
 *
 * To run a mutation, you first call `useReprocessOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessOrderMutation, { data, loading, error }] = useReprocessOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReprocessOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessOrderMutation, ReprocessOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessOrderMutation, ReprocessOrderMutationVariables>(ReprocessOrderDocument, options);
      }
export type ReprocessOrderMutationHookResult = ReturnType<typeof useReprocessOrderMutation>;
export type ReprocessOrderMutationResult = Apollo.MutationResult<ReprocessOrderMutation>;
export type ReprocessOrderMutationOptions = Apollo.BaseMutationOptions<ReprocessOrderMutation, ReprocessOrderMutationVariables>;
export const ResolveCorruptedTrackingExceptionDocument = gql`
    mutation ResolveCorruptedTrackingException($exceptionId: ID!) {
  resolveCorruptedTrackingException(exceptionId: $exceptionId)
}
    `;
export type ResolveCorruptedTrackingExceptionMutationFn = Apollo.MutationFunction<ResolveCorruptedTrackingExceptionMutation, ResolveCorruptedTrackingExceptionMutationVariables>;

/**
 * __useResolveCorruptedTrackingExceptionMutation__
 *
 * To run a mutation, you first call `useResolveCorruptedTrackingExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveCorruptedTrackingExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveCorruptedTrackingExceptionMutation, { data, loading, error }] = useResolveCorruptedTrackingExceptionMutation({
 *   variables: {
 *      exceptionId: // value for 'exceptionId'
 *   },
 * });
 */
export function useResolveCorruptedTrackingExceptionMutation(baseOptions?: Apollo.MutationHookOptions<ResolveCorruptedTrackingExceptionMutation, ResolveCorruptedTrackingExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveCorruptedTrackingExceptionMutation, ResolveCorruptedTrackingExceptionMutationVariables>(ResolveCorruptedTrackingExceptionDocument, options);
      }
export type ResolveCorruptedTrackingExceptionMutationHookResult = ReturnType<typeof useResolveCorruptedTrackingExceptionMutation>;
export type ResolveCorruptedTrackingExceptionMutationResult = Apollo.MutationResult<ResolveCorruptedTrackingExceptionMutation>;
export type ResolveCorruptedTrackingExceptionMutationOptions = Apollo.BaseMutationOptions<ResolveCorruptedTrackingExceptionMutation, ResolveCorruptedTrackingExceptionMutationVariables>;
export const SelectQuickReplyDocument = gql`
    mutation SelectQuickReply($input: SelectQuickReplyInput!) {
  selectQuickReply(input: $input)
}
    `;
export type SelectQuickReplyMutationFn = Apollo.MutationFunction<SelectQuickReplyMutation, SelectQuickReplyMutationVariables>;

/**
 * __useSelectQuickReplyMutation__
 *
 * To run a mutation, you first call `useSelectQuickReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectQuickReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectQuickReplyMutation, { data, loading, error }] = useSelectQuickReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectQuickReplyMutation(baseOptions?: Apollo.MutationHookOptions<SelectQuickReplyMutation, SelectQuickReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectQuickReplyMutation, SelectQuickReplyMutationVariables>(SelectQuickReplyDocument, options);
      }
export type SelectQuickReplyMutationHookResult = ReturnType<typeof useSelectQuickReplyMutation>;
export type SelectQuickReplyMutationResult = Apollo.MutationResult<SelectQuickReplyMutation>;
export type SelectQuickReplyMutationOptions = Apollo.BaseMutationOptions<SelectQuickReplyMutation, SelectQuickReplyMutationVariables>;
export const TakeConversationSnapshotDocument = gql`
    mutation TakeConversationSnapshot($input: TakeConversationSnapshotInput!) {
  takeConversationSnapshot(input: $input) {
    success
  }
}
    `;
export type TakeConversationSnapshotMutationFn = Apollo.MutationFunction<TakeConversationSnapshotMutation, TakeConversationSnapshotMutationVariables>;

/**
 * __useTakeConversationSnapshotMutation__
 *
 * To run a mutation, you first call `useTakeConversationSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeConversationSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeConversationSnapshotMutation, { data, loading, error }] = useTakeConversationSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTakeConversationSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<TakeConversationSnapshotMutation, TakeConversationSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TakeConversationSnapshotMutation, TakeConversationSnapshotMutationVariables>(TakeConversationSnapshotDocument, options);
      }
export type TakeConversationSnapshotMutationHookResult = ReturnType<typeof useTakeConversationSnapshotMutation>;
export type TakeConversationSnapshotMutationResult = Apollo.MutationResult<TakeConversationSnapshotMutation>;
export type TakeConversationSnapshotMutationOptions = Apollo.BaseMutationOptions<TakeConversationSnapshotMutation, TakeConversationSnapshotMutationVariables>;
export const TrackDocument = gql`
    mutation Track($input: TrackInput!) {
  track(input: $input)
}
    `;
export type TrackMutationFn = Apollo.MutationFunction<TrackMutation, TrackMutationVariables>;

/**
 * __useTrackMutation__
 *
 * To run a mutation, you first call `useTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackMutation, { data, loading, error }] = useTrackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackMutation(baseOptions?: Apollo.MutationHookOptions<TrackMutation, TrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackMutation, TrackMutationVariables>(TrackDocument, options);
      }
export type TrackMutationHookResult = ReturnType<typeof useTrackMutation>;
export type TrackMutationResult = Apollo.MutationResult<TrackMutation>;
export type TrackMutationOptions = Apollo.BaseMutationOptions<TrackMutation, TrackMutationVariables>;
export const UpdateCarrierRateDocument = gql`
    mutation updateCarrierRate($input: UpdateCarrierRateInput!) {
  updateCarrierRate(input: $input) {
    success
    carrierRate {
      ...CarrierRate
    }
  }
}
    ${CarrierRateFragmentDoc}`;
export type UpdateCarrierRateMutationFn = Apollo.MutationFunction<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>;

/**
 * __useUpdateCarrierRateMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierRateMutation, { data, loading, error }] = useUpdateCarrierRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarrierRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>(UpdateCarrierRateDocument, options);
      }
export type UpdateCarrierRateMutationHookResult = ReturnType<typeof useUpdateCarrierRateMutation>;
export type UpdateCarrierRateMutationResult = Apollo.MutationResult<UpdateCarrierRateMutation>;
export type UpdateCarrierRateMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierRateMutation, UpdateCarrierRateMutationVariables>;
export const UpdateConversationLabelsDocument = gql`
    mutation UpdateConversationLabels($input: UpdateConversationLabelsInput!) {
  updateConversationLabels(input: $input) {
    success
  }
}
    `;
export type UpdateConversationLabelsMutationFn = Apollo.MutationFunction<UpdateConversationLabelsMutation, UpdateConversationLabelsMutationVariables>;

/**
 * __useUpdateConversationLabelsMutation__
 *
 * To run a mutation, you first call `useUpdateConversationLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationLabelsMutation, { data, loading, error }] = useUpdateConversationLabelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationLabelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationLabelsMutation, UpdateConversationLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationLabelsMutation, UpdateConversationLabelsMutationVariables>(UpdateConversationLabelsDocument, options);
      }
export type UpdateConversationLabelsMutationHookResult = ReturnType<typeof useUpdateConversationLabelsMutation>;
export type UpdateConversationLabelsMutationResult = Apollo.MutationResult<UpdateConversationLabelsMutation>;
export type UpdateConversationLabelsMutationOptions = Apollo.BaseMutationOptions<UpdateConversationLabelsMutation, UpdateConversationLabelsMutationVariables>;
export const UpdateCustomerRateDocument = gql`
    mutation UpdateCustomerRate($input: UpdateCustomerRateInput!) {
  updateCustomerRate(input: $input) {
    success
    customerRate {
      ...CustomerRate
    }
  }
}
    ${CustomerRateFragmentDoc}`;
export type UpdateCustomerRateMutationFn = Apollo.MutationFunction<UpdateCustomerRateMutation, UpdateCustomerRateMutationVariables>;

/**
 * __useUpdateCustomerRateMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerRateMutation, { data, loading, error }] = useUpdateCustomerRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerRateMutation, UpdateCustomerRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerRateMutation, UpdateCustomerRateMutationVariables>(UpdateCustomerRateDocument, options);
      }
export type UpdateCustomerRateMutationHookResult = ReturnType<typeof useUpdateCustomerRateMutation>;
export type UpdateCustomerRateMutationResult = Apollo.MutationResult<UpdateCustomerRateMutation>;
export type UpdateCustomerRateMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerRateMutation, UpdateCustomerRateMutationVariables>;
export const UpdateFreightDataMappingDocument = gql`
    mutation UpdateFreightDataMapping($input: UpdateFreightDataMappingInput!) {
  updateFreightDataMapping(input: $input) {
    freightDataMapping {
      id
      key
      type
      values
      organizationId
      createdAt
      updatedAt
    }
    success
  }
}
    `;
export type UpdateFreightDataMappingMutationFn = Apollo.MutationFunction<UpdateFreightDataMappingMutation, UpdateFreightDataMappingMutationVariables>;

/**
 * __useUpdateFreightDataMappingMutation__
 *
 * To run a mutation, you first call `useUpdateFreightDataMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFreightDataMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFreightDataMappingMutation, { data, loading, error }] = useUpdateFreightDataMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFreightDataMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFreightDataMappingMutation, UpdateFreightDataMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFreightDataMappingMutation, UpdateFreightDataMappingMutationVariables>(UpdateFreightDataMappingDocument, options);
      }
export type UpdateFreightDataMappingMutationHookResult = ReturnType<typeof useUpdateFreightDataMappingMutation>;
export type UpdateFreightDataMappingMutationResult = Apollo.MutationResult<UpdateFreightDataMappingMutation>;
export type UpdateFreightDataMappingMutationOptions = Apollo.BaseMutationOptions<UpdateFreightDataMappingMutation, UpdateFreightDataMappingMutationVariables>;
export const UpdateGenericTransformationDocument = gql`
    mutation UpdateGenericTransformation($input: UpdateGenericTransformationInput!) {
  updateGenericTransformation(input: $input) {
    success
  }
}
    `;
export type UpdateGenericTransformationMutationFn = Apollo.MutationFunction<UpdateGenericTransformationMutation, UpdateGenericTransformationMutationVariables>;

/**
 * __useUpdateGenericTransformationMutation__
 *
 * To run a mutation, you first call `useUpdateGenericTransformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericTransformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericTransformationMutation, { data, loading, error }] = useUpdateGenericTransformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGenericTransformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericTransformationMutation, UpdateGenericTransformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericTransformationMutation, UpdateGenericTransformationMutationVariables>(UpdateGenericTransformationDocument, options);
      }
export type UpdateGenericTransformationMutationHookResult = ReturnType<typeof useUpdateGenericTransformationMutation>;
export type UpdateGenericTransformationMutationResult = Apollo.MutationResult<UpdateGenericTransformationMutation>;
export type UpdateGenericTransformationMutationOptions = Apollo.BaseMutationOptions<UpdateGenericTransformationMutation, UpdateGenericTransformationMutationVariables>;
export const UpdateMemoryDocument = gql`
    mutation UpdateMemory($input: UpdateMemoryInput!) {
  updateMemory(input: $input) {
    success
    memory {
      id
      comment
    }
  }
}
    `;
export type UpdateMemoryMutationFn = Apollo.MutationFunction<UpdateMemoryMutation, UpdateMemoryMutationVariables>;

/**
 * __useUpdateMemoryMutation__
 *
 * To run a mutation, you first call `useUpdateMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemoryMutation, { data, loading, error }] = useUpdateMemoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemoryMutation, UpdateMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemoryMutation, UpdateMemoryMutationVariables>(UpdateMemoryDocument, options);
      }
export type UpdateMemoryMutationHookResult = ReturnType<typeof useUpdateMemoryMutation>;
export type UpdateMemoryMutationResult = Apollo.MutationResult<UpdateMemoryMutation>;
export type UpdateMemoryMutationOptions = Apollo.BaseMutationOptions<UpdateMemoryMutation, UpdateMemoryMutationVariables>;
export const UpdateMemoryEntityLinkDocument = gql`
    mutation UpdateMemoryEntityLink($input: UpdateMemoryEntityLinkInput!) {
  updateMemoryEntityLink(input: $input) {
    success
  }
}
    `;
export type UpdateMemoryEntityLinkMutationFn = Apollo.MutationFunction<UpdateMemoryEntityLinkMutation, UpdateMemoryEntityLinkMutationVariables>;

/**
 * __useUpdateMemoryEntityLinkMutation__
 *
 * To run a mutation, you first call `useUpdateMemoryEntityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemoryEntityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemoryEntityLinkMutation, { data, loading, error }] = useUpdateMemoryEntityLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemoryEntityLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemoryEntityLinkMutation, UpdateMemoryEntityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemoryEntityLinkMutation, UpdateMemoryEntityLinkMutationVariables>(UpdateMemoryEntityLinkDocument, options);
      }
export type UpdateMemoryEntityLinkMutationHookResult = ReturnType<typeof useUpdateMemoryEntityLinkMutation>;
export type UpdateMemoryEntityLinkMutationResult = Apollo.MutationResult<UpdateMemoryEntityLinkMutation>;
export type UpdateMemoryEntityLinkMutationOptions = Apollo.BaseMutationOptions<UpdateMemoryEntityLinkMutation, UpdateMemoryEntityLinkMutationVariables>;
export const UpdateOriginatorDocument = gql`
    mutation UpdateOriginator($input: UpdateOriginatorInput!) {
  updateOriginator(input: $input) {
    success
  }
}
    `;
export type UpdateOriginatorMutationFn = Apollo.MutationFunction<UpdateOriginatorMutation, UpdateOriginatorMutationVariables>;

/**
 * __useUpdateOriginatorMutation__
 *
 * To run a mutation, you first call `useUpdateOriginatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOriginatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOriginatorMutation, { data, loading, error }] = useUpdateOriginatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOriginatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOriginatorMutation, UpdateOriginatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOriginatorMutation, UpdateOriginatorMutationVariables>(UpdateOriginatorDocument, options);
      }
export type UpdateOriginatorMutationHookResult = ReturnType<typeof useUpdateOriginatorMutation>;
export type UpdateOriginatorMutationResult = Apollo.MutationResult<UpdateOriginatorMutation>;
export type UpdateOriginatorMutationOptions = Apollo.BaseMutationOptions<UpdateOriginatorMutation, UpdateOriginatorMutationVariables>;
export const UpdatePlaceSchedulingMethodDocument = gql`
    mutation UpdatePlaceSchedulingMethod($input: UpdatePlaceSchedulingMethodInput!) {
  updatePlaceSchedulingMethod(input: $input) {
    scheduling {
      ...PlaceScheduling
    }
  }
}
    ${PlaceSchedulingFragmentDoc}`;
export type UpdatePlaceSchedulingMethodMutationFn = Apollo.MutationFunction<UpdatePlaceSchedulingMethodMutation, UpdatePlaceSchedulingMethodMutationVariables>;

/**
 * __useUpdatePlaceSchedulingMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceSchedulingMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceSchedulingMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceSchedulingMethodMutation, { data, loading, error }] = useUpdatePlaceSchedulingMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaceSchedulingMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaceSchedulingMethodMutation, UpdatePlaceSchedulingMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaceSchedulingMethodMutation, UpdatePlaceSchedulingMethodMutationVariables>(UpdatePlaceSchedulingMethodDocument, options);
      }
export type UpdatePlaceSchedulingMethodMutationHookResult = ReturnType<typeof useUpdatePlaceSchedulingMethodMutation>;
export type UpdatePlaceSchedulingMethodMutationResult = Apollo.MutationResult<UpdatePlaceSchedulingMethodMutation>;
export type UpdatePlaceSchedulingMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceSchedulingMethodMutation, UpdatePlaceSchedulingMethodMutationVariables>;
export const UpdatePricingStrategyDocument = gql`
    mutation UpdatePricingStrategy($input: UpdatePricingStrategyInput!) {
  updatePricingStrategy(input: $input) {
    pricingStrategy {
      id
      type
      config
    }
    success
  }
}
    `;
export type UpdatePricingStrategyMutationFn = Apollo.MutationFunction<UpdatePricingStrategyMutation, UpdatePricingStrategyMutationVariables>;

/**
 * __useUpdatePricingStrategyMutation__
 *
 * To run a mutation, you first call `useUpdatePricingStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePricingStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePricingStrategyMutation, { data, loading, error }] = useUpdatePricingStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePricingStrategyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePricingStrategyMutation, UpdatePricingStrategyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePricingStrategyMutation, UpdatePricingStrategyMutationVariables>(UpdatePricingStrategyDocument, options);
      }
export type UpdatePricingStrategyMutationHookResult = ReturnType<typeof useUpdatePricingStrategyMutation>;
export type UpdatePricingStrategyMutationResult = Apollo.MutationResult<UpdatePricingStrategyMutation>;
export type UpdatePricingStrategyMutationOptions = Apollo.BaseMutationOptions<UpdatePricingStrategyMutation, UpdatePricingStrategyMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation UpdateQuote($input: UpdateQuoteInput!) {
  updateQuote(input: $input) {
    quote {
      ...Quote
    }
    success
  }
}
    ${QuoteFragmentDoc}`;
export type UpdateQuoteMutationFn = Apollo.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, options);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = Apollo.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    team {
      id
      name
      description
      settings
      email
      phoneNumber {
        phoneNumber
        extension
      }
    }
    success
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const UpdateTeamMemberDocument = gql`
    mutation UpdateTeamMember($input: UpdateTeamMemberInput!) {
  updateTeamMember(input: $input) {
    success
  }
}
    `;
export type UpdateTeamMemberMutationFn = Apollo.MutationFunction<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;

/**
 * __useUpdateTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMemberMutation, { data, loading, error }] = useUpdateTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>(UpdateTeamMemberDocument, options);
      }
export type UpdateTeamMemberMutationHookResult = ReturnType<typeof useUpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationResult = Apollo.MutationResult<UpdateTeamMemberMutation>;
export type UpdateTeamMemberMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMemberMutation, UpdateTeamMemberMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($input: UpdateTemplateInput!) {
  updateTemplate(input: $input) {
    template {
      ...Template
    }
    success
  }
}
    ${TemplateFragmentDoc}`;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const UpdateTransformationConfigDocument = gql`
    mutation UpdateTransformationConfig($input: UpdateTransformationConfigInput!) {
  updateTransformationConfig(input: $input) {
    transformationConfig {
      ...TransformationConfig
    }
  }
}
    ${TransformationConfigFragmentDoc}`;
export type UpdateTransformationConfigMutationFn = Apollo.MutationFunction<UpdateTransformationConfigMutation, UpdateTransformationConfigMutationVariables>;

/**
 * __useUpdateTransformationConfigMutation__
 *
 * To run a mutation, you first call `useUpdateTransformationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransformationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransformationConfigMutation, { data, loading, error }] = useUpdateTransformationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransformationConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransformationConfigMutation, UpdateTransformationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransformationConfigMutation, UpdateTransformationConfigMutationVariables>(UpdateTransformationConfigDocument, options);
      }
export type UpdateTransformationConfigMutationHookResult = ReturnType<typeof useUpdateTransformationConfigMutation>;
export type UpdateTransformationConfigMutationResult = Apollo.MutationResult<UpdateTransformationConfigMutation>;
export type UpdateTransformationConfigMutationOptions = Apollo.BaseMutationOptions<UpdateTransformationConfigMutation, UpdateTransformationConfigMutationVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation UpdateUserDetails($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      ...UserFormFields
      features
    }
    success
  }
}
    ${UserFormFieldsFragmentDoc}`;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const UpdateUserFeaturesDocument = gql`
    mutation UpdateUserFeatures($input: UpdateUserFeaturesInput!) {
  updateUserFeatures(input: $input) {
    user {
      ...UserFormFields
      features
    }
    success
  }
}
    ${UserFormFieldsFragmentDoc}`;
export type UpdateUserFeaturesMutationFn = Apollo.MutationFunction<UpdateUserFeaturesMutation, UpdateUserFeaturesMutationVariables>;

/**
 * __useUpdateUserFeaturesMutation__
 *
 * To run a mutation, you first call `useUpdateUserFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFeaturesMutation, { data, loading, error }] = useUpdateUserFeaturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserFeaturesMutation, UpdateUserFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserFeaturesMutation, UpdateUserFeaturesMutationVariables>(UpdateUserFeaturesDocument, options);
      }
export type UpdateUserFeaturesMutationHookResult = ReturnType<typeof useUpdateUserFeaturesMutation>;
export type UpdateUserFeaturesMutationResult = Apollo.MutationResult<UpdateUserFeaturesMutation>;
export type UpdateUserFeaturesMutationOptions = Apollo.BaseMutationOptions<UpdateUserFeaturesMutation, UpdateUserFeaturesMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    user {
      settings {
        timeDisplayStyle
        autoReply
        browserExtensionDomainAllowlist
        pluginLandingPage
      }
    }
    success
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UpdateWebhookSubscriptionDocument = gql`
    mutation UpdateWebhookSubscription($input: UpdateWebhookSubscriptionInput!) {
  updateWebhookSubscription(input: $input) {
    item {
      ...WebhookSubscriptionDetail
    }
  }
}
    ${WebhookSubscriptionDetailFragmentDoc}`;
export type UpdateWebhookSubscriptionMutationFn = Apollo.MutationFunction<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>;

/**
 * __useUpdateWebhookSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookSubscriptionMutation, { data, loading, error }] = useUpdateWebhookSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>(UpdateWebhookSubscriptionDocument, options);
      }
export type UpdateWebhookSubscriptionMutationHookResult = ReturnType<typeof useUpdateWebhookSubscriptionMutation>;
export type UpdateWebhookSubscriptionMutationResult = Apollo.MutationResult<UpdateWebhookSubscriptionMutation>;
export type UpdateWebhookSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>;
export const UpdateWorkflowDocument = gql`
    mutation UpdateWorkflow($input: UpdateWorkflowInput!) {
  updateWorkflow(input: $input) {
    success
    workflow {
      ...Workflow
    }
  }
}
    ${WorkflowFragmentDoc}`;
export type UpdateWorkflowMutationFn = Apollo.MutationFunction<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;

/**
 * __useUpdateWorkflowMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowMutation, { data, loading, error }] = useUpdateWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
      }
export type UpdateWorkflowMutationHookResult = ReturnType<typeof useUpdateWorkflowMutation>;
export type UpdateWorkflowMutationResult = Apollo.MutationResult<UpdateWorkflowMutation>;
export type UpdateWorkflowMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($input: UploadFileInput!, $file: Upload!) {
  uploadFile(file: $file, input: $input) {
    upload {
      id
      url
    }
    success
    url
  }
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const ValidatePricingStrategyInstructionsDocument = gql`
    mutation ValidatePricingStrategyInstructions($input: ValidatePricingStrategyInstructionsInput!) {
  validatePricingStrategyInstructions(input: $input) {
    isValid
    issues {
      rule
      explanation
    }
  }
}
    `;
export type ValidatePricingStrategyInstructionsMutationFn = Apollo.MutationFunction<ValidatePricingStrategyInstructionsMutation, ValidatePricingStrategyInstructionsMutationVariables>;

/**
 * __useValidatePricingStrategyInstructionsMutation__
 *
 * To run a mutation, you first call `useValidatePricingStrategyInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePricingStrategyInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePricingStrategyInstructionsMutation, { data, loading, error }] = useValidatePricingStrategyInstructionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePricingStrategyInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePricingStrategyInstructionsMutation, ValidatePricingStrategyInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePricingStrategyInstructionsMutation, ValidatePricingStrategyInstructionsMutationVariables>(ValidatePricingStrategyInstructionsDocument, options);
      }
export type ValidatePricingStrategyInstructionsMutationHookResult = ReturnType<typeof useValidatePricingStrategyInstructionsMutation>;
export type ValidatePricingStrategyInstructionsMutationResult = Apollo.MutationResult<ValidatePricingStrategyInstructionsMutation>;
export type ValidatePricingStrategyInstructionsMutationOptions = Apollo.BaseMutationOptions<ValidatePricingStrategyInstructionsMutation, ValidatePricingStrategyInstructionsMutationVariables>;
export const AddWorkerToActionDefinitionDocument = gql`
    mutation AddWorkerToActionDefinition($input: AddWorkerToActionDefinitionInput!) {
  addWorkerToActionDefinition(input: $input) {
    actionDefinition {
      ...ActionDefinition
    }
  }
}
    ${ActionDefinitionFragmentDoc}`;
export type AddWorkerToActionDefinitionMutationFn = Apollo.MutationFunction<AddWorkerToActionDefinitionMutation, AddWorkerToActionDefinitionMutationVariables>;

/**
 * __useAddWorkerToActionDefinitionMutation__
 *
 * To run a mutation, you first call `useAddWorkerToActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkerToActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkerToActionDefinitionMutation, { data, loading, error }] = useAddWorkerToActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkerToActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkerToActionDefinitionMutation, AddWorkerToActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkerToActionDefinitionMutation, AddWorkerToActionDefinitionMutationVariables>(AddWorkerToActionDefinitionDocument, options);
      }
export type AddWorkerToActionDefinitionMutationHookResult = ReturnType<typeof useAddWorkerToActionDefinitionMutation>;
export type AddWorkerToActionDefinitionMutationResult = Apollo.MutationResult<AddWorkerToActionDefinitionMutation>;
export type AddWorkerToActionDefinitionMutationOptions = Apollo.BaseMutationOptions<AddWorkerToActionDefinitionMutation, AddWorkerToActionDefinitionMutationVariables>;
export const CloneActionDefinitionDocument = gql`
    mutation CloneActionDefinition($input: CloneActionDefinitionInput!) {
  cloneActionDefinition(input: $input) {
    actionDefinition {
      id
    }
  }
}
    `;
export type CloneActionDefinitionMutationFn = Apollo.MutationFunction<CloneActionDefinitionMutation, CloneActionDefinitionMutationVariables>;

/**
 * __useCloneActionDefinitionMutation__
 *
 * To run a mutation, you first call `useCloneActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneActionDefinitionMutation, { data, loading, error }] = useCloneActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CloneActionDefinitionMutation, CloneActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneActionDefinitionMutation, CloneActionDefinitionMutationVariables>(CloneActionDefinitionDocument, options);
      }
export type CloneActionDefinitionMutationHookResult = ReturnType<typeof useCloneActionDefinitionMutation>;
export type CloneActionDefinitionMutationResult = Apollo.MutationResult<CloneActionDefinitionMutation>;
export type CloneActionDefinitionMutationOptions = Apollo.BaseMutationOptions<CloneActionDefinitionMutation, CloneActionDefinitionMutationVariables>;
export const CreateActionDefinitionDocument = gql`
    mutation CreateActionDefinition($input: CreateActionDefinitionInput!) {
  createActionDefinition(input: $input) {
    actionDefinition {
      ...ActionDefinition
    }
  }
}
    ${ActionDefinitionFragmentDoc}`;
export type CreateActionDefinitionMutationFn = Apollo.MutationFunction<CreateActionDefinitionMutation, CreateActionDefinitionMutationVariables>;

/**
 * __useCreateActionDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionDefinitionMutation, { data, loading, error }] = useCreateActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionDefinitionMutation, CreateActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionDefinitionMutation, CreateActionDefinitionMutationVariables>(CreateActionDefinitionDocument, options);
      }
export type CreateActionDefinitionMutationHookResult = ReturnType<typeof useCreateActionDefinitionMutation>;
export type CreateActionDefinitionMutationResult = Apollo.MutationResult<CreateActionDefinitionMutation>;
export type CreateActionDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateActionDefinitionMutation, CreateActionDefinitionMutationVariables>;
export const DeleteActionDefinitionDocument = gql`
    mutation DeleteActionDefinition($input: DeleteActionDefinitionInput!) {
  deleteActionDefinition(input: $input) {
    success
  }
}
    `;
export type DeleteActionDefinitionMutationFn = Apollo.MutationFunction<DeleteActionDefinitionMutation, DeleteActionDefinitionMutationVariables>;

/**
 * __useDeleteActionDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionDefinitionMutation, { data, loading, error }] = useDeleteActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionDefinitionMutation, DeleteActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionDefinitionMutation, DeleteActionDefinitionMutationVariables>(DeleteActionDefinitionDocument, options);
      }
export type DeleteActionDefinitionMutationHookResult = ReturnType<typeof useDeleteActionDefinitionMutation>;
export type DeleteActionDefinitionMutationResult = Apollo.MutationResult<DeleteActionDefinitionMutation>;
export type DeleteActionDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteActionDefinitionMutation, DeleteActionDefinitionMutationVariables>;
export const DeleteActionDefinitionDocumentDocument = gql`
    mutation DeleteActionDefinitionDocument($input: DeleteActionDefinitionDocumentInput!) {
  deleteActionDefinitionDocument(input: $input) {
    success
  }
}
    `;
export type DeleteActionDefinitionDocumentMutationFn = Apollo.MutationFunction<DeleteActionDefinitionDocumentMutation, DeleteActionDefinitionDocumentMutationVariables>;

/**
 * __useDeleteActionDefinitionDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteActionDefinitionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionDefinitionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionDefinitionDocumentMutation, { data, loading, error }] = useDeleteActionDefinitionDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteActionDefinitionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionDefinitionDocumentMutation, DeleteActionDefinitionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionDefinitionDocumentMutation, DeleteActionDefinitionDocumentMutationVariables>(DeleteActionDefinitionDocumentDocument, options);
      }
export type DeleteActionDefinitionDocumentMutationHookResult = ReturnType<typeof useDeleteActionDefinitionDocumentMutation>;
export type DeleteActionDefinitionDocumentMutationResult = Apollo.MutationResult<DeleteActionDefinitionDocumentMutation>;
export type DeleteActionDefinitionDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteActionDefinitionDocumentMutation, DeleteActionDefinitionDocumentMutationVariables>;
export const DeleteActionDefinitionTeamGlobalPromptValuesDocument = gql`
    mutation DeleteActionDefinitionTeamGlobalPromptValues($input: DeleteActionDefinitionTeamGlobalPromptValuesInput!) {
  deleteActionDefinitionTeamGlobalPromptValues(input: $input) {
    success
  }
}
    `;
export type DeleteActionDefinitionTeamGlobalPromptValuesMutationFn = Apollo.MutationFunction<DeleteActionDefinitionTeamGlobalPromptValuesMutation, DeleteActionDefinitionTeamGlobalPromptValuesMutationVariables>;

/**
 * __useDeleteActionDefinitionTeamGlobalPromptValuesMutation__
 *
 * To run a mutation, you first call `useDeleteActionDefinitionTeamGlobalPromptValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionDefinitionTeamGlobalPromptValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionDefinitionTeamGlobalPromptValuesMutation, { data, loading, error }] = useDeleteActionDefinitionTeamGlobalPromptValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteActionDefinitionTeamGlobalPromptValuesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionDefinitionTeamGlobalPromptValuesMutation, DeleteActionDefinitionTeamGlobalPromptValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionDefinitionTeamGlobalPromptValuesMutation, DeleteActionDefinitionTeamGlobalPromptValuesMutationVariables>(DeleteActionDefinitionTeamGlobalPromptValuesDocument, options);
      }
export type DeleteActionDefinitionTeamGlobalPromptValuesMutationHookResult = ReturnType<typeof useDeleteActionDefinitionTeamGlobalPromptValuesMutation>;
export type DeleteActionDefinitionTeamGlobalPromptValuesMutationResult = Apollo.MutationResult<DeleteActionDefinitionTeamGlobalPromptValuesMutation>;
export type DeleteActionDefinitionTeamGlobalPromptValuesMutationOptions = Apollo.BaseMutationOptions<DeleteActionDefinitionTeamGlobalPromptValuesMutation, DeleteActionDefinitionTeamGlobalPromptValuesMutationVariables>;
export const DiffActionDefinitionNaturalLanguageProcedureDocument = gql`
    mutation DiffActionDefinitionNaturalLanguageProcedure($input: DiffActionDefinitionNaturalLanguageProcedureInput!) {
  diffActionDefinitionNaturalLanguageProcedure(input: $input) {
    diff
  }
}
    `;
export type DiffActionDefinitionNaturalLanguageProcedureMutationFn = Apollo.MutationFunction<DiffActionDefinitionNaturalLanguageProcedureMutation, DiffActionDefinitionNaturalLanguageProcedureMutationVariables>;

/**
 * __useDiffActionDefinitionNaturalLanguageProcedureMutation__
 *
 * To run a mutation, you first call `useDiffActionDefinitionNaturalLanguageProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiffActionDefinitionNaturalLanguageProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [diffActionDefinitionNaturalLanguageProcedureMutation, { data, loading, error }] = useDiffActionDefinitionNaturalLanguageProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiffActionDefinitionNaturalLanguageProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DiffActionDefinitionNaturalLanguageProcedureMutation, DiffActionDefinitionNaturalLanguageProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiffActionDefinitionNaturalLanguageProcedureMutation, DiffActionDefinitionNaturalLanguageProcedureMutationVariables>(DiffActionDefinitionNaturalLanguageProcedureDocument, options);
      }
export type DiffActionDefinitionNaturalLanguageProcedureMutationHookResult = ReturnType<typeof useDiffActionDefinitionNaturalLanguageProcedureMutation>;
export type DiffActionDefinitionNaturalLanguageProcedureMutationResult = Apollo.MutationResult<DiffActionDefinitionNaturalLanguageProcedureMutation>;
export type DiffActionDefinitionNaturalLanguageProcedureMutationOptions = Apollo.BaseMutationOptions<DiffActionDefinitionNaturalLanguageProcedureMutation, DiffActionDefinitionNaturalLanguageProcedureMutationVariables>;
export const ProposeGlobalPromptSopAlignmentDocument = gql`
    mutation ProposeGlobalPromptSopAlignment($input: ProposeGlobalPromptSopAlignmentInput!) {
  proposeGlobalPromptSopAlignment(input: $input) {
    proposals {
      id
      title
      rationale
      anchor
      replacement
      lineHint
    }
  }
}
    `;
export type ProposeGlobalPromptSopAlignmentMutationFn = Apollo.MutationFunction<ProposeGlobalPromptSopAlignmentMutation, ProposeGlobalPromptSopAlignmentMutationVariables>;

/**
 * __useProposeGlobalPromptSopAlignmentMutation__
 *
 * To run a mutation, you first call `useProposeGlobalPromptSopAlignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProposeGlobalPromptSopAlignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proposeGlobalPromptSopAlignmentMutation, { data, loading, error }] = useProposeGlobalPromptSopAlignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProposeGlobalPromptSopAlignmentMutation(baseOptions?: Apollo.MutationHookOptions<ProposeGlobalPromptSopAlignmentMutation, ProposeGlobalPromptSopAlignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProposeGlobalPromptSopAlignmentMutation, ProposeGlobalPromptSopAlignmentMutationVariables>(ProposeGlobalPromptSopAlignmentDocument, options);
      }
export type ProposeGlobalPromptSopAlignmentMutationHookResult = ReturnType<typeof useProposeGlobalPromptSopAlignmentMutation>;
export type ProposeGlobalPromptSopAlignmentMutationResult = Apollo.MutationResult<ProposeGlobalPromptSopAlignmentMutation>;
export type ProposeGlobalPromptSopAlignmentMutationOptions = Apollo.BaseMutationOptions<ProposeGlobalPromptSopAlignmentMutation, ProposeGlobalPromptSopAlignmentMutationVariables>;
export const RemoveWorkerFromActionDefinitionDocument = gql`
    mutation RemoveWorkerFromActionDefinition($input: RemoveWorkerFromActionDefinitionInput!) {
  removeWorkerFromActionDefinition(input: $input) {
    actionDefinition {
      ...ActionDefinition
    }
  }
}
    ${ActionDefinitionFragmentDoc}`;
export type RemoveWorkerFromActionDefinitionMutationFn = Apollo.MutationFunction<RemoveWorkerFromActionDefinitionMutation, RemoveWorkerFromActionDefinitionMutationVariables>;

/**
 * __useRemoveWorkerFromActionDefinitionMutation__
 *
 * To run a mutation, you first call `useRemoveWorkerFromActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkerFromActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkerFromActionDefinitionMutation, { data, loading, error }] = useRemoveWorkerFromActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkerFromActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkerFromActionDefinitionMutation, RemoveWorkerFromActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkerFromActionDefinitionMutation, RemoveWorkerFromActionDefinitionMutationVariables>(RemoveWorkerFromActionDefinitionDocument, options);
      }
export type RemoveWorkerFromActionDefinitionMutationHookResult = ReturnType<typeof useRemoveWorkerFromActionDefinitionMutation>;
export type RemoveWorkerFromActionDefinitionMutationResult = Apollo.MutationResult<RemoveWorkerFromActionDefinitionMutation>;
export type RemoveWorkerFromActionDefinitionMutationOptions = Apollo.BaseMutationOptions<RemoveWorkerFromActionDefinitionMutation, RemoveWorkerFromActionDefinitionMutationVariables>;
export const SetTrackSopDocument = gql`
    mutation SetTrackSop($input: SetTrackSopInput!) {
  setTrackSop(input: $input) {
    actionDefinition {
      id
    }
  }
}
    `;
export type SetTrackSopMutationFn = Apollo.MutationFunction<SetTrackSopMutation, SetTrackSopMutationVariables>;

/**
 * __useSetTrackSopMutation__
 *
 * To run a mutation, you first call `useSetTrackSopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTrackSopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTrackSopMutation, { data, loading, error }] = useSetTrackSopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTrackSopMutation(baseOptions?: Apollo.MutationHookOptions<SetTrackSopMutation, SetTrackSopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTrackSopMutation, SetTrackSopMutationVariables>(SetTrackSopDocument, options);
      }
export type SetTrackSopMutationHookResult = ReturnType<typeof useSetTrackSopMutation>;
export type SetTrackSopMutationResult = Apollo.MutationResult<SetTrackSopMutation>;
export type SetTrackSopMutationOptions = Apollo.BaseMutationOptions<SetTrackSopMutation, SetTrackSopMutationVariables>;
export const SimulateSemanticWaitPatternsDocument = gql`
    mutation SimulateSemanticWaitPatterns($input: SimulateSemanticWaitPatternsInput!) {
  simulateSemanticWaitPatterns(input: $input) {
    results {
      patternName
      status
    }
  }
}
    `;
export type SimulateSemanticWaitPatternsMutationFn = Apollo.MutationFunction<SimulateSemanticWaitPatternsMutation, SimulateSemanticWaitPatternsMutationVariables>;

/**
 * __useSimulateSemanticWaitPatternsMutation__
 *
 * To run a mutation, you first call `useSimulateSemanticWaitPatternsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateSemanticWaitPatternsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateSemanticWaitPatternsMutation, { data, loading, error }] = useSimulateSemanticWaitPatternsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateSemanticWaitPatternsMutation(baseOptions?: Apollo.MutationHookOptions<SimulateSemanticWaitPatternsMutation, SimulateSemanticWaitPatternsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimulateSemanticWaitPatternsMutation, SimulateSemanticWaitPatternsMutationVariables>(SimulateSemanticWaitPatternsDocument, options);
      }
export type SimulateSemanticWaitPatternsMutationHookResult = ReturnType<typeof useSimulateSemanticWaitPatternsMutation>;
export type SimulateSemanticWaitPatternsMutationResult = Apollo.MutationResult<SimulateSemanticWaitPatternsMutation>;
export type SimulateSemanticWaitPatternsMutationOptions = Apollo.BaseMutationOptions<SimulateSemanticWaitPatternsMutation, SimulateSemanticWaitPatternsMutationVariables>;
export const SubscribeToActionDefinitionDocument = gql`
    mutation SubscribeToActionDefinition($input: SubscribeToActionDefinitionInput!) {
  subscribeToActionDefinition(input: $input) {
    actionDefinition {
      ...ActionDefinition
    }
  }
}
    ${ActionDefinitionFragmentDoc}`;
export type SubscribeToActionDefinitionMutationFn = Apollo.MutationFunction<SubscribeToActionDefinitionMutation, SubscribeToActionDefinitionMutationVariables>;

/**
 * __useSubscribeToActionDefinitionMutation__
 *
 * To run a mutation, you first call `useSubscribeToActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToActionDefinitionMutation, { data, loading, error }] = useSubscribeToActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeToActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToActionDefinitionMutation, SubscribeToActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToActionDefinitionMutation, SubscribeToActionDefinitionMutationVariables>(SubscribeToActionDefinitionDocument, options);
      }
export type SubscribeToActionDefinitionMutationHookResult = ReturnType<typeof useSubscribeToActionDefinitionMutation>;
export type SubscribeToActionDefinitionMutationResult = Apollo.MutationResult<SubscribeToActionDefinitionMutation>;
export type SubscribeToActionDefinitionMutationOptions = Apollo.BaseMutationOptions<SubscribeToActionDefinitionMutation, SubscribeToActionDefinitionMutationVariables>;
export const SyncActionDefinitionToShadowOrgDocument = gql`
    mutation SyncActionDefinitionToShadowOrg($input: SyncActionDefinitionToShadowOrgInput!) {
  syncActionDefinitionToShadowOrganization(input: $input) {
    success
    syncedActionDefinitionIds
  }
}
    `;
export type SyncActionDefinitionToShadowOrgMutationFn = Apollo.MutationFunction<SyncActionDefinitionToShadowOrgMutation, SyncActionDefinitionToShadowOrgMutationVariables>;

/**
 * __useSyncActionDefinitionToShadowOrgMutation__
 *
 * To run a mutation, you first call `useSyncActionDefinitionToShadowOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncActionDefinitionToShadowOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncActionDefinitionToShadowOrgMutation, { data, loading, error }] = useSyncActionDefinitionToShadowOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncActionDefinitionToShadowOrgMutation(baseOptions?: Apollo.MutationHookOptions<SyncActionDefinitionToShadowOrgMutation, SyncActionDefinitionToShadowOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncActionDefinitionToShadowOrgMutation, SyncActionDefinitionToShadowOrgMutationVariables>(SyncActionDefinitionToShadowOrgDocument, options);
      }
export type SyncActionDefinitionToShadowOrgMutationHookResult = ReturnType<typeof useSyncActionDefinitionToShadowOrgMutation>;
export type SyncActionDefinitionToShadowOrgMutationResult = Apollo.MutationResult<SyncActionDefinitionToShadowOrgMutation>;
export type SyncActionDefinitionToShadowOrgMutationOptions = Apollo.BaseMutationOptions<SyncActionDefinitionToShadowOrgMutation, SyncActionDefinitionToShadowOrgMutationVariables>;
export const UnsubscribeToActionDefinitionDocument = gql`
    mutation UnsubscribeToActionDefinition($input: SubscribeToActionDefinitionInput!) {
  unsubscribeToActionDefinition(input: $input) {
    actionDefinition {
      ...ActionDefinition
    }
  }
}
    ${ActionDefinitionFragmentDoc}`;
export type UnsubscribeToActionDefinitionMutationFn = Apollo.MutationFunction<UnsubscribeToActionDefinitionMutation, UnsubscribeToActionDefinitionMutationVariables>;

/**
 * __useUnsubscribeToActionDefinitionMutation__
 *
 * To run a mutation, you first call `useUnsubscribeToActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeToActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeToActionDefinitionMutation, { data, loading, error }] = useUnsubscribeToActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeToActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeToActionDefinitionMutation, UnsubscribeToActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeToActionDefinitionMutation, UnsubscribeToActionDefinitionMutationVariables>(UnsubscribeToActionDefinitionDocument, options);
      }
export type UnsubscribeToActionDefinitionMutationHookResult = ReturnType<typeof useUnsubscribeToActionDefinitionMutation>;
export type UnsubscribeToActionDefinitionMutationResult = Apollo.MutationResult<UnsubscribeToActionDefinitionMutation>;
export type UnsubscribeToActionDefinitionMutationOptions = Apollo.BaseMutationOptions<UnsubscribeToActionDefinitionMutation, UnsubscribeToActionDefinitionMutationVariables>;
export const UpdateActionDefinitionDocument = gql`
    mutation UpdateActionDefinition($input: UpdateActionDefinitionInput!) {
  updateActionDefinition(input: $input) {
    actionDefinition {
      ...ActionDefinition
    }
  }
}
    ${ActionDefinitionFragmentDoc}`;
export type UpdateActionDefinitionMutationFn = Apollo.MutationFunction<UpdateActionDefinitionMutation, UpdateActionDefinitionMutationVariables>;

/**
 * __useUpdateActionDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateActionDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionDefinitionMutation, { data, loading, error }] = useUpdateActionDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionDefinitionMutation, UpdateActionDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionDefinitionMutation, UpdateActionDefinitionMutationVariables>(UpdateActionDefinitionDocument, options);
      }
export type UpdateActionDefinitionMutationHookResult = ReturnType<typeof useUpdateActionDefinitionMutation>;
export type UpdateActionDefinitionMutationResult = Apollo.MutationResult<UpdateActionDefinitionMutation>;
export type UpdateActionDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateActionDefinitionMutation, UpdateActionDefinitionMutationVariables>;
export const UpsertActionDefinitionTeamGlobalPromptValuesDocument = gql`
    mutation UpsertActionDefinitionTeamGlobalPromptValues($input: UpsertActionDefinitionTeamGlobalPromptValuesInput!) {
  upsertActionDefinitionTeamGlobalPromptValues(input: $input) {
    teamGlobalPromptValues {
      id
      teamId
      values
      toolValues
    }
  }
}
    `;
export type UpsertActionDefinitionTeamGlobalPromptValuesMutationFn = Apollo.MutationFunction<UpsertActionDefinitionTeamGlobalPromptValuesMutation, UpsertActionDefinitionTeamGlobalPromptValuesMutationVariables>;

/**
 * __useUpsertActionDefinitionTeamGlobalPromptValuesMutation__
 *
 * To run a mutation, you first call `useUpsertActionDefinitionTeamGlobalPromptValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertActionDefinitionTeamGlobalPromptValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertActionDefinitionTeamGlobalPromptValuesMutation, { data, loading, error }] = useUpsertActionDefinitionTeamGlobalPromptValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertActionDefinitionTeamGlobalPromptValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertActionDefinitionTeamGlobalPromptValuesMutation, UpsertActionDefinitionTeamGlobalPromptValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertActionDefinitionTeamGlobalPromptValuesMutation, UpsertActionDefinitionTeamGlobalPromptValuesMutationVariables>(UpsertActionDefinitionTeamGlobalPromptValuesDocument, options);
      }
export type UpsertActionDefinitionTeamGlobalPromptValuesMutationHookResult = ReturnType<typeof useUpsertActionDefinitionTeamGlobalPromptValuesMutation>;
export type UpsertActionDefinitionTeamGlobalPromptValuesMutationResult = Apollo.MutationResult<UpsertActionDefinitionTeamGlobalPromptValuesMutation>;
export type UpsertActionDefinitionTeamGlobalPromptValuesMutationOptions = Apollo.BaseMutationOptions<UpsertActionDefinitionTeamGlobalPromptValuesMutation, UpsertActionDefinitionTeamGlobalPromptValuesMutationVariables>;
export const ValidateTextInstructionsDocument = gql`
    mutation ValidateTextInstructions($input: ValidateTextInstructionsInput!) {
  validateTextInstructions(input: $input) {
    promptEvaluationOverview
    individualHighlights {
      textToHighlight
      severity
      rationale
    }
  }
}
    `;
export type ValidateTextInstructionsMutationFn = Apollo.MutationFunction<ValidateTextInstructionsMutation, ValidateTextInstructionsMutationVariables>;

/**
 * __useValidateTextInstructionsMutation__
 *
 * To run a mutation, you first call `useValidateTextInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateTextInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateTextInstructionsMutation, { data, loading, error }] = useValidateTextInstructionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateTextInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<ValidateTextInstructionsMutation, ValidateTextInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateTextInstructionsMutation, ValidateTextInstructionsMutationVariables>(ValidateTextInstructionsDocument, options);
      }
export type ValidateTextInstructionsMutationHookResult = ReturnType<typeof useValidateTextInstructionsMutation>;
export type ValidateTextInstructionsMutationResult = Apollo.MutationResult<ValidateTextInstructionsMutation>;
export type ValidateTextInstructionsMutationOptions = Apollo.BaseMutationOptions<ValidateTextInstructionsMutation, ValidateTextInstructionsMutationVariables>;
export const ChangeActionExecutionAutonomyStateDocument = gql`
    mutation ChangeActionExecutionAutonomyState($input: ChangeActionExecutionAutonomyStateInput!) {
  changeActionExecutionAutonomyState(input: $input) {
    success
  }
}
    `;
export type ChangeActionExecutionAutonomyStateMutationFn = Apollo.MutationFunction<ChangeActionExecutionAutonomyStateMutation, ChangeActionExecutionAutonomyStateMutationVariables>;

/**
 * __useChangeActionExecutionAutonomyStateMutation__
 *
 * To run a mutation, you first call `useChangeActionExecutionAutonomyStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeActionExecutionAutonomyStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeActionExecutionAutonomyStateMutation, { data, loading, error }] = useChangeActionExecutionAutonomyStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeActionExecutionAutonomyStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeActionExecutionAutonomyStateMutation, ChangeActionExecutionAutonomyStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeActionExecutionAutonomyStateMutation, ChangeActionExecutionAutonomyStateMutationVariables>(ChangeActionExecutionAutonomyStateDocument, options);
      }
export type ChangeActionExecutionAutonomyStateMutationHookResult = ReturnType<typeof useChangeActionExecutionAutonomyStateMutation>;
export type ChangeActionExecutionAutonomyStateMutationResult = Apollo.MutationResult<ChangeActionExecutionAutonomyStateMutation>;
export type ChangeActionExecutionAutonomyStateMutationOptions = Apollo.BaseMutationOptions<ChangeActionExecutionAutonomyStateMutation, ChangeActionExecutionAutonomyStateMutationVariables>;
export const TriggerActionExecutionDocument = gql`
    mutation TriggerActionExecution($input: TriggerActionExecutionInput!) {
  triggerActionExecution(input: $input) {
    actionExecutionId
    success
  }
}
    `;
export type TriggerActionExecutionMutationFn = Apollo.MutationFunction<TriggerActionExecutionMutation, TriggerActionExecutionMutationVariables>;

/**
 * __useTriggerActionExecutionMutation__
 *
 * To run a mutation, you first call `useTriggerActionExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerActionExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerActionExecutionMutation, { data, loading, error }] = useTriggerActionExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerActionExecutionMutation(baseOptions?: Apollo.MutationHookOptions<TriggerActionExecutionMutation, TriggerActionExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerActionExecutionMutation, TriggerActionExecutionMutationVariables>(TriggerActionExecutionDocument, options);
      }
export type TriggerActionExecutionMutationHookResult = ReturnType<typeof useTriggerActionExecutionMutation>;
export type TriggerActionExecutionMutationResult = Apollo.MutationResult<TriggerActionExecutionMutation>;
export type TriggerActionExecutionMutationOptions = Apollo.BaseMutationOptions<TriggerActionExecutionMutation, TriggerActionExecutionMutationVariables>;
export const CreateActionTriggerDocument = gql`
    mutation CreateActionTrigger($input: CreateActionTriggerInput!) {
  createActionTrigger(input: $input) {
    actionTrigger {
      ...ActionTrigger
    }
  }
}
    ${ActionTriggerFragmentDoc}`;
export type CreateActionTriggerMutationFn = Apollo.MutationFunction<CreateActionTriggerMutation, CreateActionTriggerMutationVariables>;

/**
 * __useCreateActionTriggerMutation__
 *
 * To run a mutation, you first call `useCreateActionTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionTriggerMutation, { data, loading, error }] = useCreateActionTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActionTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionTriggerMutation, CreateActionTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionTriggerMutation, CreateActionTriggerMutationVariables>(CreateActionTriggerDocument, options);
      }
export type CreateActionTriggerMutationHookResult = ReturnType<typeof useCreateActionTriggerMutation>;
export type CreateActionTriggerMutationResult = Apollo.MutationResult<CreateActionTriggerMutation>;
export type CreateActionTriggerMutationOptions = Apollo.BaseMutationOptions<CreateActionTriggerMutation, CreateActionTriggerMutationVariables>;
export const DeleteActionTriggerDocument = gql`
    mutation DeleteActionTrigger($input: DeleteActionTriggerInput!) {
  deleteActionTrigger(input: $input) {
    success
  }
}
    `;
export type DeleteActionTriggerMutationFn = Apollo.MutationFunction<DeleteActionTriggerMutation, DeleteActionTriggerMutationVariables>;

/**
 * __useDeleteActionTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteActionTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionTriggerMutation, { data, loading, error }] = useDeleteActionTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteActionTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionTriggerMutation, DeleteActionTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionTriggerMutation, DeleteActionTriggerMutationVariables>(DeleteActionTriggerDocument, options);
      }
export type DeleteActionTriggerMutationHookResult = ReturnType<typeof useDeleteActionTriggerMutation>;
export type DeleteActionTriggerMutationResult = Apollo.MutationResult<DeleteActionTriggerMutation>;
export type DeleteActionTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteActionTriggerMutation, DeleteActionTriggerMutationVariables>;
export const UpdateActionTriggerDocument = gql`
    mutation UpdateActionTrigger($input: UpdateActionTriggerInput!) {
  updateActionTrigger(input: $input) {
    actionTrigger {
      ...ActionTrigger
    }
  }
}
    ${ActionTriggerFragmentDoc}`;
export type UpdateActionTriggerMutationFn = Apollo.MutationFunction<UpdateActionTriggerMutation, UpdateActionTriggerMutationVariables>;

/**
 * __useUpdateActionTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateActionTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionTriggerMutation, { data, loading, error }] = useUpdateActionTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionTriggerMutation, UpdateActionTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionTriggerMutation, UpdateActionTriggerMutationVariables>(UpdateActionTriggerDocument, options);
      }
export type UpdateActionTriggerMutationHookResult = ReturnType<typeof useUpdateActionTriggerMutation>;
export type UpdateActionTriggerMutationResult = Apollo.MutationResult<UpdateActionTriggerMutation>;
export type UpdateActionTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateActionTriggerMutation, UpdateActionTriggerMutationVariables>;
export const DeleteAiPhoneNumberDocument = gql`
    mutation DeleteAIPhoneNumber($input: DeleteAIPhoneNumberInput!) {
  deleteAIPhoneNumber(input: $input) {
    success
  }
}
    `;
export type DeleteAiPhoneNumberMutationFn = Apollo.MutationFunction<DeleteAiPhoneNumberMutation, DeleteAiPhoneNumberMutationVariables>;

/**
 * __useDeleteAiPhoneNumberMutation__
 *
 * To run a mutation, you first call `useDeleteAiPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiPhoneNumberMutation, { data, loading, error }] = useDeleteAiPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAiPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAiPhoneNumberMutation, DeleteAiPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAiPhoneNumberMutation, DeleteAiPhoneNumberMutationVariables>(DeleteAiPhoneNumberDocument, options);
      }
export type DeleteAiPhoneNumberMutationHookResult = ReturnType<typeof useDeleteAiPhoneNumberMutation>;
export type DeleteAiPhoneNumberMutationResult = Apollo.MutationResult<DeleteAiPhoneNumberMutation>;
export type DeleteAiPhoneNumberMutationOptions = Apollo.BaseMutationOptions<DeleteAiPhoneNumberMutation, DeleteAiPhoneNumberMutationVariables>;
export const ProvisionAiPhoneNumberDocument = gql`
    mutation ProvisionAIPhoneNumber($input: ProvisionAIPhoneNumberInput!) {
  provisionAIPhoneNumber(input: $input) {
    success
    aiPhoneNumber {
      id
      phoneNumber
      extension
    }
  }
}
    `;
export type ProvisionAiPhoneNumberMutationFn = Apollo.MutationFunction<ProvisionAiPhoneNumberMutation, ProvisionAiPhoneNumberMutationVariables>;

/**
 * __useProvisionAiPhoneNumberMutation__
 *
 * To run a mutation, you first call `useProvisionAiPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionAiPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionAiPhoneNumberMutation, { data, loading, error }] = useProvisionAiPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionAiPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionAiPhoneNumberMutation, ProvisionAiPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionAiPhoneNumberMutation, ProvisionAiPhoneNumberMutationVariables>(ProvisionAiPhoneNumberDocument, options);
      }
export type ProvisionAiPhoneNumberMutationHookResult = ReturnType<typeof useProvisionAiPhoneNumberMutation>;
export type ProvisionAiPhoneNumberMutationResult = Apollo.MutationResult<ProvisionAiPhoneNumberMutation>;
export type ProvisionAiPhoneNumberMutationOptions = Apollo.BaseMutationOptions<ProvisionAiPhoneNumberMutation, ProvisionAiPhoneNumberMutationVariables>;
export const ReserveTestPhoneNumberDocument = gql`
    mutation ReserveTestPhoneNumber($input: ReserveTestPhoneNumberInput!) {
  reserveTestPhoneNumber(input: $input) {
    aiPhoneNumber {
      id
      phoneNumber
      teamId
      organizationId
    }
    phoneNumber
    expiresAt
    success
    wasExistingNumberAvailable
  }
}
    `;
export type ReserveTestPhoneNumberMutationFn = Apollo.MutationFunction<ReserveTestPhoneNumberMutation, ReserveTestPhoneNumberMutationVariables>;

/**
 * __useReserveTestPhoneNumberMutation__
 *
 * To run a mutation, you first call `useReserveTestPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveTestPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveTestPhoneNumberMutation, { data, loading, error }] = useReserveTestPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReserveTestPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ReserveTestPhoneNumberMutation, ReserveTestPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReserveTestPhoneNumberMutation, ReserveTestPhoneNumberMutationVariables>(ReserveTestPhoneNumberDocument, options);
      }
export type ReserveTestPhoneNumberMutationHookResult = ReturnType<typeof useReserveTestPhoneNumberMutation>;
export type ReserveTestPhoneNumberMutationResult = Apollo.MutationResult<ReserveTestPhoneNumberMutation>;
export type ReserveTestPhoneNumberMutationOptions = Apollo.BaseMutationOptions<ReserveTestPhoneNumberMutation, ReserveTestPhoneNumberMutationVariables>;
export const CreateBraintrustDatasetDocument = gql`
    mutation CreateBraintrustDataset($input: CreateBraintrustDatasetInput!) {
  createBraintrustDataset(input: $input) {
    success
    datasetId
    error
  }
}
    `;
export type CreateBraintrustDatasetMutationFn = Apollo.MutationFunction<CreateBraintrustDatasetMutation, CreateBraintrustDatasetMutationVariables>;

/**
 * __useCreateBraintrustDatasetMutation__
 *
 * To run a mutation, you first call `useCreateBraintrustDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBraintrustDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBraintrustDatasetMutation, { data, loading, error }] = useCreateBraintrustDatasetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBraintrustDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateBraintrustDatasetMutation, CreateBraintrustDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBraintrustDatasetMutation, CreateBraintrustDatasetMutationVariables>(CreateBraintrustDatasetDocument, options);
      }
export type CreateBraintrustDatasetMutationHookResult = ReturnType<typeof useCreateBraintrustDatasetMutation>;
export type CreateBraintrustDatasetMutationResult = Apollo.MutationResult<CreateBraintrustDatasetMutation>;
export type CreateBraintrustDatasetMutationOptions = Apollo.BaseMutationOptions<CreateBraintrustDatasetMutation, CreateBraintrustDatasetMutationVariables>;
export const SaveConversationSnapshotToDatasetDocument = gql`
    mutation SaveConversationSnapshotToDataset($input: SaveConversationSnapshotToDatasetInput!) {
  saveConversationSnapshotToDataset(input: $input) {
    success
    error
  }
}
    `;
export type SaveConversationSnapshotToDatasetMutationFn = Apollo.MutationFunction<SaveConversationSnapshotToDatasetMutation, SaveConversationSnapshotToDatasetMutationVariables>;

/**
 * __useSaveConversationSnapshotToDatasetMutation__
 *
 * To run a mutation, you first call `useSaveConversationSnapshotToDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConversationSnapshotToDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConversationSnapshotToDatasetMutation, { data, loading, error }] = useSaveConversationSnapshotToDatasetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveConversationSnapshotToDatasetMutation(baseOptions?: Apollo.MutationHookOptions<SaveConversationSnapshotToDatasetMutation, SaveConversationSnapshotToDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConversationSnapshotToDatasetMutation, SaveConversationSnapshotToDatasetMutationVariables>(SaveConversationSnapshotToDatasetDocument, options);
      }
export type SaveConversationSnapshotToDatasetMutationHookResult = ReturnType<typeof useSaveConversationSnapshotToDatasetMutation>;
export type SaveConversationSnapshotToDatasetMutationResult = Apollo.MutationResult<SaveConversationSnapshotToDatasetMutation>;
export type SaveConversationSnapshotToDatasetMutationOptions = Apollo.BaseMutationOptions<SaveConversationSnapshotToDatasetMutation, SaveConversationSnapshotToDatasetMutationVariables>;
export const ContactCarrierToCollectLoadBidDocument = gql`
    mutation ContactCarrierToCollectLoadBid($input: ContactCarrierToCollectLoadBidInput!) {
  contactCarrierToCollectLoadBid(input: $input) {
    actionExecutionId
  }
}
    `;
export type ContactCarrierToCollectLoadBidMutationFn = Apollo.MutationFunction<ContactCarrierToCollectLoadBidMutation, ContactCarrierToCollectLoadBidMutationVariables>;

/**
 * __useContactCarrierToCollectLoadBidMutation__
 *
 * To run a mutation, you first call `useContactCarrierToCollectLoadBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactCarrierToCollectLoadBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactCarrierToCollectLoadBidMutation, { data, loading, error }] = useContactCarrierToCollectLoadBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactCarrierToCollectLoadBidMutation(baseOptions?: Apollo.MutationHookOptions<ContactCarrierToCollectLoadBidMutation, ContactCarrierToCollectLoadBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactCarrierToCollectLoadBidMutation, ContactCarrierToCollectLoadBidMutationVariables>(ContactCarrierToCollectLoadBidDocument, options);
      }
export type ContactCarrierToCollectLoadBidMutationHookResult = ReturnType<typeof useContactCarrierToCollectLoadBidMutation>;
export type ContactCarrierToCollectLoadBidMutationResult = Apollo.MutationResult<ContactCarrierToCollectLoadBidMutation>;
export type ContactCarrierToCollectLoadBidMutationOptions = Apollo.BaseMutationOptions<ContactCarrierToCollectLoadBidMutation, ContactCarrierToCollectLoadBidMutationVariables>;
export const CreateCarrierByIdentifierDocument = gql`
    mutation CreateCarrierByIdentifier($input: CreateCarrierByIdentifierInput!) {
  createCarrierByIdentifier(input: $input) {
    carrier {
      id
      name
      mcNumber
      dotNumber
    }
  }
}
    `;
export type CreateCarrierByIdentifierMutationFn = Apollo.MutationFunction<CreateCarrierByIdentifierMutation, CreateCarrierByIdentifierMutationVariables>;

/**
 * __useCreateCarrierByIdentifierMutation__
 *
 * To run a mutation, you first call `useCreateCarrierByIdentifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierByIdentifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierByIdentifierMutation, { data, loading, error }] = useCreateCarrierByIdentifierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarrierByIdentifierMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierByIdentifierMutation, CreateCarrierByIdentifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierByIdentifierMutation, CreateCarrierByIdentifierMutationVariables>(CreateCarrierByIdentifierDocument, options);
      }
export type CreateCarrierByIdentifierMutationHookResult = ReturnType<typeof useCreateCarrierByIdentifierMutation>;
export type CreateCarrierByIdentifierMutationResult = Apollo.MutationResult<CreateCarrierByIdentifierMutation>;
export type CreateCarrierByIdentifierMutationOptions = Apollo.BaseMutationOptions<CreateCarrierByIdentifierMutation, CreateCarrierByIdentifierMutationVariables>;
export const SimulateCarrierVerificationDocument = gql`
    mutation SimulateCarrierVerification($input: SimulateCarrierVerificationInput!) {
  simulateCarrierVerification(input: $input) {
    success
    error
    results {
      mcNumber
      dotNumber
      aggregatedResult
      carrierName
      aggregationMode
      availableIntegrations
      individualResults {
        integrationType
        result
        carrierName
        matchedFailConditions
        matchedRiskConditions
        error
        parsedData
        rawData
      }
      summary
      matchesExpected
      expectedResult
    }
    totalCount
    passCount
    matchCount
  }
}
    `;
export type SimulateCarrierVerificationMutationFn = Apollo.MutationFunction<SimulateCarrierVerificationMutation, SimulateCarrierVerificationMutationVariables>;

/**
 * __useSimulateCarrierVerificationMutation__
 *
 * To run a mutation, you first call `useSimulateCarrierVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateCarrierVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateCarrierVerificationMutation, { data, loading, error }] = useSimulateCarrierVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateCarrierVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SimulateCarrierVerificationMutation, SimulateCarrierVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimulateCarrierVerificationMutation, SimulateCarrierVerificationMutationVariables>(SimulateCarrierVerificationDocument, options);
      }
export type SimulateCarrierVerificationMutationHookResult = ReturnType<typeof useSimulateCarrierVerificationMutation>;
export type SimulateCarrierVerificationMutationResult = Apollo.MutationResult<SimulateCarrierVerificationMutation>;
export type SimulateCarrierVerificationMutationOptions = Apollo.BaseMutationOptions<SimulateCarrierVerificationMutation, SimulateCarrierVerificationMutationVariables>;
export const SetClassificationLockDurationSecondsDocument = gql`
    mutation SetClassificationLockDurationSeconds($seconds: Int) {
  setClassificationLockDurationSeconds(seconds: $seconds)
}
    `;
export type SetClassificationLockDurationSecondsMutationFn = Apollo.MutationFunction<SetClassificationLockDurationSecondsMutation, SetClassificationLockDurationSecondsMutationVariables>;

/**
 * __useSetClassificationLockDurationSecondsMutation__
 *
 * To run a mutation, you first call `useSetClassificationLockDurationSecondsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetClassificationLockDurationSecondsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setClassificationLockDurationSecondsMutation, { data, loading, error }] = useSetClassificationLockDurationSecondsMutation({
 *   variables: {
 *      seconds: // value for 'seconds'
 *   },
 * });
 */
export function useSetClassificationLockDurationSecondsMutation(baseOptions?: Apollo.MutationHookOptions<SetClassificationLockDurationSecondsMutation, SetClassificationLockDurationSecondsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetClassificationLockDurationSecondsMutation, SetClassificationLockDurationSecondsMutationVariables>(SetClassificationLockDurationSecondsDocument, options);
      }
export type SetClassificationLockDurationSecondsMutationHookResult = ReturnType<typeof useSetClassificationLockDurationSecondsMutation>;
export type SetClassificationLockDurationSecondsMutationResult = Apollo.MutationResult<SetClassificationLockDurationSecondsMutation>;
export type SetClassificationLockDurationSecondsMutationOptions = Apollo.BaseMutationOptions<SetClassificationLockDurationSecondsMutation, SetClassificationLockDurationSecondsMutationVariables>;
export const ConnectWorkerComposioAccountDocument = gql`
    mutation ConnectWorkerComposioAccount($input: ConnectWorkerComposioAccountInput!) {
  connectWorkerComposioAccount(input: $input)
}
    `;
export type ConnectWorkerComposioAccountMutationFn = Apollo.MutationFunction<ConnectWorkerComposioAccountMutation, ConnectWorkerComposioAccountMutationVariables>;

/**
 * __useConnectWorkerComposioAccountMutation__
 *
 * To run a mutation, you first call `useConnectWorkerComposioAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectWorkerComposioAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectWorkerComposioAccountMutation, { data, loading, error }] = useConnectWorkerComposioAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectWorkerComposioAccountMutation(baseOptions?: Apollo.MutationHookOptions<ConnectWorkerComposioAccountMutation, ConnectWorkerComposioAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectWorkerComposioAccountMutation, ConnectWorkerComposioAccountMutationVariables>(ConnectWorkerComposioAccountDocument, options);
      }
export type ConnectWorkerComposioAccountMutationHookResult = ReturnType<typeof useConnectWorkerComposioAccountMutation>;
export type ConnectWorkerComposioAccountMutationResult = Apollo.MutationResult<ConnectWorkerComposioAccountMutation>;
export type ConnectWorkerComposioAccountMutationOptions = Apollo.BaseMutationOptions<ConnectWorkerComposioAccountMutation, ConnectWorkerComposioAccountMutationVariables>;
export const DisconnectWorkerComposioDocument = gql`
    mutation DisconnectWorkerComposio($input: WorkerComposioConnectionInput!) {
  disconnectWorkerComposio(input: $input)
}
    `;
export type DisconnectWorkerComposioMutationFn = Apollo.MutationFunction<DisconnectWorkerComposioMutation, DisconnectWorkerComposioMutationVariables>;

/**
 * __useDisconnectWorkerComposioMutation__
 *
 * To run a mutation, you first call `useDisconnectWorkerComposioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectWorkerComposioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectWorkerComposioMutation, { data, loading, error }] = useDisconnectWorkerComposioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectWorkerComposioMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectWorkerComposioMutation, DisconnectWorkerComposioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectWorkerComposioMutation, DisconnectWorkerComposioMutationVariables>(DisconnectWorkerComposioDocument, options);
      }
export type DisconnectWorkerComposioMutationHookResult = ReturnType<typeof useDisconnectWorkerComposioMutation>;
export type DisconnectWorkerComposioMutationResult = Apollo.MutationResult<DisconnectWorkerComposioMutation>;
export type DisconnectWorkerComposioMutationOptions = Apollo.BaseMutationOptions<DisconnectWorkerComposioMutation, DisconnectWorkerComposioMutationVariables>;
export const RefreshWorkerComposioAccountDocument = gql`
    mutation RefreshWorkerComposioAccount($input: WorkerComposioConnectionInput!) {
  refreshWorkerComposioAccount(input: $input)
}
    `;
export type RefreshWorkerComposioAccountMutationFn = Apollo.MutationFunction<RefreshWorkerComposioAccountMutation, RefreshWorkerComposioAccountMutationVariables>;

/**
 * __useRefreshWorkerComposioAccountMutation__
 *
 * To run a mutation, you first call `useRefreshWorkerComposioAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshWorkerComposioAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshWorkerComposioAccountMutation, { data, loading, error }] = useRefreshWorkerComposioAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshWorkerComposioAccountMutation(baseOptions?: Apollo.MutationHookOptions<RefreshWorkerComposioAccountMutation, RefreshWorkerComposioAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshWorkerComposioAccountMutation, RefreshWorkerComposioAccountMutationVariables>(RefreshWorkerComposioAccountDocument, options);
      }
export type RefreshWorkerComposioAccountMutationHookResult = ReturnType<typeof useRefreshWorkerComposioAccountMutation>;
export type RefreshWorkerComposioAccountMutationResult = Apollo.MutationResult<RefreshWorkerComposioAccountMutation>;
export type RefreshWorkerComposioAccountMutationOptions = Apollo.BaseMutationOptions<RefreshWorkerComposioAccountMutation, RefreshWorkerComposioAccountMutationVariables>;
export const CreateRatingDocument = gql`
    mutation CreateRating($input: CreateRatingInput!) {
  createRating(input: $input) {
    success
  }
}
    `;
export type CreateRatingMutationFn = Apollo.MutationFunction<CreateRatingMutation, CreateRatingMutationVariables>;

/**
 * __useCreateRatingMutation__
 *
 * To run a mutation, you first call `useCreateRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRatingMutation, { data, loading, error }] = useCreateRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRatingMutation(baseOptions?: Apollo.MutationHookOptions<CreateRatingMutation, CreateRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRatingMutation, CreateRatingMutationVariables>(CreateRatingDocument, options);
      }
export type CreateRatingMutationHookResult = ReturnType<typeof useCreateRatingMutation>;
export type CreateRatingMutationResult = Apollo.MutationResult<CreateRatingMutation>;
export type CreateRatingMutationOptions = Apollo.BaseMutationOptions<CreateRatingMutation, CreateRatingMutationVariables>;
export const MarkConversationReadDocument = gql`
    mutation MarkConversationRead($input: MarkConversationReadInput!) {
  markConversationRead(input: $input) {
    success
  }
}
    `;
export type MarkConversationReadMutationFn = Apollo.MutationFunction<MarkConversationReadMutation, MarkConversationReadMutationVariables>;

/**
 * __useMarkConversationReadMutation__
 *
 * To run a mutation, you first call `useMarkConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationReadMutation, { data, loading, error }] = useMarkConversationReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationReadMutation, MarkConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationReadMutation, MarkConversationReadMutationVariables>(MarkConversationReadDocument, options);
      }
export type MarkConversationReadMutationHookResult = ReturnType<typeof useMarkConversationReadMutation>;
export type MarkConversationReadMutationResult = Apollo.MutationResult<MarkConversationReadMutation>;
export type MarkConversationReadMutationOptions = Apollo.BaseMutationOptions<MarkConversationReadMutation, MarkConversationReadMutationVariables>;
export const RequestConversationCcDocument = gql`
    mutation RequestConversationCc($input: RequestConversationCcInput!) {
  requestConversationCc(input: $input) {
    success
    alreadyRequested
    conversation {
      id
      metadata {
        ...EmailConversationMetadata
      }
    }
  }
}
    ${EmailConversationMetadataFragmentDoc}`;
export type RequestConversationCcMutationFn = Apollo.MutationFunction<RequestConversationCcMutation, RequestConversationCcMutationVariables>;

/**
 * __useRequestConversationCcMutation__
 *
 * To run a mutation, you first call `useRequestConversationCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestConversationCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestConversationCcMutation, { data, loading, error }] = useRequestConversationCcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestConversationCcMutation(baseOptions?: Apollo.MutationHookOptions<RequestConversationCcMutation, RequestConversationCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestConversationCcMutation, RequestConversationCcMutationVariables>(RequestConversationCcDocument, options);
      }
export type RequestConversationCcMutationHookResult = ReturnType<typeof useRequestConversationCcMutation>;
export type RequestConversationCcMutationResult = Apollo.MutationResult<RequestConversationCcMutation>;
export type RequestConversationCcMutationOptions = Apollo.BaseMutationOptions<RequestConversationCcMutation, RequestConversationCcMutationVariables>;
export const TerminateConversationCallDocument = gql`
    mutation TerminateConversationCall($input: TerminateConversationCallInput!) {
  terminateConversationCall(input: $input) {
    success
  }
}
    `;
export type TerminateConversationCallMutationFn = Apollo.MutationFunction<TerminateConversationCallMutation, TerminateConversationCallMutationVariables>;

/**
 * __useTerminateConversationCallMutation__
 *
 * To run a mutation, you first call `useTerminateConversationCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateConversationCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateConversationCallMutation, { data, loading, error }] = useTerminateConversationCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTerminateConversationCallMutation(baseOptions?: Apollo.MutationHookOptions<TerminateConversationCallMutation, TerminateConversationCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateConversationCallMutation, TerminateConversationCallMutationVariables>(TerminateConversationCallDocument, options);
      }
export type TerminateConversationCallMutationHookResult = ReturnType<typeof useTerminateConversationCallMutation>;
export type TerminateConversationCallMutationResult = Apollo.MutationResult<TerminateConversationCallMutation>;
export type TerminateConversationCallMutationOptions = Apollo.BaseMutationOptions<TerminateConversationCallMutation, TerminateConversationCallMutationVariables>;
export const CreateCoveragePlanFromCarrierContactListDocument = gql`
    mutation CreateCoveragePlanFromCarrierContactList($input: CreateCoveragePlanFromCarrierContactListInput!) {
  createCoveragePlanFromCarrierContactList(input: $input) {
    coveragePlan {
      id
    }
    success
  }
}
    `;
export type CreateCoveragePlanFromCarrierContactListMutationFn = Apollo.MutationFunction<CreateCoveragePlanFromCarrierContactListMutation, CreateCoveragePlanFromCarrierContactListMutationVariables>;

/**
 * __useCreateCoveragePlanFromCarrierContactListMutation__
 *
 * To run a mutation, you first call `useCreateCoveragePlanFromCarrierContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoveragePlanFromCarrierContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoveragePlanFromCarrierContactListMutation, { data, loading, error }] = useCreateCoveragePlanFromCarrierContactListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoveragePlanFromCarrierContactListMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoveragePlanFromCarrierContactListMutation, CreateCoveragePlanFromCarrierContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoveragePlanFromCarrierContactListMutation, CreateCoveragePlanFromCarrierContactListMutationVariables>(CreateCoveragePlanFromCarrierContactListDocument, options);
      }
export type CreateCoveragePlanFromCarrierContactListMutationHookResult = ReturnType<typeof useCreateCoveragePlanFromCarrierContactListMutation>;
export type CreateCoveragePlanFromCarrierContactListMutationResult = Apollo.MutationResult<CreateCoveragePlanFromCarrierContactListMutation>;
export type CreateCoveragePlanFromCarrierContactListMutationOptions = Apollo.BaseMutationOptions<CreateCoveragePlanFromCarrierContactListMutation, CreateCoveragePlanFromCarrierContactListMutationVariables>;
export const AuditDatAutopostsDocument = gql`
    mutation AuditDATAutoposts($input: AuditDATAutopostsInput!) {
  auditDATAutoposts(input: $input) {
    success
    configured
    mcLeodCandidatesChecked
    ingestedCount
    postedCount
    unpostedCount
    postFailures
    unpostFailures
    activeMappingsChecked
    skippedCount
    error
  }
}
    `;
export type AuditDatAutopostsMutationFn = Apollo.MutationFunction<AuditDatAutopostsMutation, AuditDatAutopostsMutationVariables>;

/**
 * __useAuditDatAutopostsMutation__
 *
 * To run a mutation, you first call `useAuditDatAutopostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditDatAutopostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditDatAutopostsMutation, { data, loading, error }] = useAuditDatAutopostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditDatAutopostsMutation(baseOptions?: Apollo.MutationHookOptions<AuditDatAutopostsMutation, AuditDatAutopostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuditDatAutopostsMutation, AuditDatAutopostsMutationVariables>(AuditDatAutopostsDocument, options);
      }
export type AuditDatAutopostsMutationHookResult = ReturnType<typeof useAuditDatAutopostsMutation>;
export type AuditDatAutopostsMutationResult = Apollo.MutationResult<AuditDatAutopostsMutation>;
export type AuditDatAutopostsMutationOptions = Apollo.BaseMutationOptions<AuditDatAutopostsMutation, AuditDatAutopostsMutationVariables>;
export const AuditDatShipmentPostingsDocument = gql`
    mutation AuditDATShipmentPostings($input: AuditDATShipmentPostingsInput!) {
  auditDATShipmentPostings(input: $input) {
    success
    totalChecked
    correctedCount
    stillPostedCount
    inconclusiveCount
    skippedCount
    error
  }
}
    `;
export type AuditDatShipmentPostingsMutationFn = Apollo.MutationFunction<AuditDatShipmentPostingsMutation, AuditDatShipmentPostingsMutationVariables>;

/**
 * __useAuditDatShipmentPostingsMutation__
 *
 * To run a mutation, you first call `useAuditDatShipmentPostingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuditDatShipmentPostingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [auditDatShipmentPostingsMutation, { data, loading, error }] = useAuditDatShipmentPostingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuditDatShipmentPostingsMutation(baseOptions?: Apollo.MutationHookOptions<AuditDatShipmentPostingsMutation, AuditDatShipmentPostingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuditDatShipmentPostingsMutation, AuditDatShipmentPostingsMutationVariables>(AuditDatShipmentPostingsDocument, options);
      }
export type AuditDatShipmentPostingsMutationHookResult = ReturnType<typeof useAuditDatShipmentPostingsMutation>;
export type AuditDatShipmentPostingsMutationResult = Apollo.MutationResult<AuditDatShipmentPostingsMutation>;
export type AuditDatShipmentPostingsMutationOptions = Apollo.BaseMutationOptions<AuditDatShipmentPostingsMutation, AuditDatShipmentPostingsMutationVariables>;
export const CreateBlankRichTextDocumentUploadDocument = gql`
    mutation CreateBlankRichTextDocumentUpload($input: CreateBlankRichTextDocumentUploadInput!) {
  createBlankRichTextDocumentUpload(input: $input) {
    success
  }
}
    `;
export type CreateBlankRichTextDocumentUploadMutationFn = Apollo.MutationFunction<CreateBlankRichTextDocumentUploadMutation, CreateBlankRichTextDocumentUploadMutationVariables>;

/**
 * __useCreateBlankRichTextDocumentUploadMutation__
 *
 * To run a mutation, you first call `useCreateBlankRichTextDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankRichTextDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankRichTextDocumentUploadMutation, { data, loading, error }] = useCreateBlankRichTextDocumentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlankRichTextDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlankRichTextDocumentUploadMutation, CreateBlankRichTextDocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlankRichTextDocumentUploadMutation, CreateBlankRichTextDocumentUploadMutationVariables>(CreateBlankRichTextDocumentUploadDocument, options);
      }
export type CreateBlankRichTextDocumentUploadMutationHookResult = ReturnType<typeof useCreateBlankRichTextDocumentUploadMutation>;
export type CreateBlankRichTextDocumentUploadMutationResult = Apollo.MutationResult<CreateBlankRichTextDocumentUploadMutation>;
export type CreateBlankRichTextDocumentUploadMutationOptions = Apollo.BaseMutationOptions<CreateBlankRichTextDocumentUploadMutation, CreateBlankRichTextDocumentUploadMutationVariables>;
export const UpdateBlankRichTextDocumentUploadMetadataDocument = gql`
    mutation UpdateBlankRichTextDocumentUploadMetadata($input: UpdateBlankRichTextDocumentUploadMetadataInput!) {
  updateRichTextDocumentUploadMetadata(input: $input) {
    success
  }
}
    `;
export type UpdateBlankRichTextDocumentUploadMetadataMutationFn = Apollo.MutationFunction<UpdateBlankRichTextDocumentUploadMetadataMutation, UpdateBlankRichTextDocumentUploadMetadataMutationVariables>;

/**
 * __useUpdateBlankRichTextDocumentUploadMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateBlankRichTextDocumentUploadMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlankRichTextDocumentUploadMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlankRichTextDocumentUploadMetadataMutation, { data, loading, error }] = useUpdateBlankRichTextDocumentUploadMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlankRichTextDocumentUploadMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlankRichTextDocumentUploadMetadataMutation, UpdateBlankRichTextDocumentUploadMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlankRichTextDocumentUploadMetadataMutation, UpdateBlankRichTextDocumentUploadMetadataMutationVariables>(UpdateBlankRichTextDocumentUploadMetadataDocument, options);
      }
export type UpdateBlankRichTextDocumentUploadMetadataMutationHookResult = ReturnType<typeof useUpdateBlankRichTextDocumentUploadMetadataMutation>;
export type UpdateBlankRichTextDocumentUploadMetadataMutationResult = Apollo.MutationResult<UpdateBlankRichTextDocumentUploadMetadataMutation>;
export type UpdateBlankRichTextDocumentUploadMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateBlankRichTextDocumentUploadMetadataMutation, UpdateBlankRichTextDocumentUploadMetadataMutationVariables>;
export const UpdateErrorGroupDocument = gql`
    mutation UpdateErrorGroup($input: UpdateErrorGroupInput!) {
  updateErrorGroup(input: $input) {
    ...ErrorGroup
  }
}
    ${ErrorGroupFragmentDoc}`;
export type UpdateErrorGroupMutationFn = Apollo.MutationFunction<UpdateErrorGroupMutation, UpdateErrorGroupMutationVariables>;

/**
 * __useUpdateErrorGroupMutation__
 *
 * To run a mutation, you first call `useUpdateErrorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorGroupMutation, { data, loading, error }] = useUpdateErrorGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateErrorGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrorGroupMutation, UpdateErrorGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrorGroupMutation, UpdateErrorGroupMutationVariables>(UpdateErrorGroupDocument, options);
      }
export type UpdateErrorGroupMutationHookResult = ReturnType<typeof useUpdateErrorGroupMutation>;
export type UpdateErrorGroupMutationResult = Apollo.MutationResult<UpdateErrorGroupMutation>;
export type UpdateErrorGroupMutationOptions = Apollo.BaseMutationOptions<UpdateErrorGroupMutation, UpdateErrorGroupMutationVariables>;
export const DismissConversationExceptionsDocument = gql`
    mutation DismissConversationExceptions($input: DismissConversationExceptionsInput!) {
  dismissConversationExceptions(input: $input)
}
    `;
export type DismissConversationExceptionsMutationFn = Apollo.MutationFunction<DismissConversationExceptionsMutation, DismissConversationExceptionsMutationVariables>;

/**
 * __useDismissConversationExceptionsMutation__
 *
 * To run a mutation, you first call `useDismissConversationExceptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissConversationExceptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissConversationExceptionsMutation, { data, loading, error }] = useDismissConversationExceptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissConversationExceptionsMutation(baseOptions?: Apollo.MutationHookOptions<DismissConversationExceptionsMutation, DismissConversationExceptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissConversationExceptionsMutation, DismissConversationExceptionsMutationVariables>(DismissConversationExceptionsDocument, options);
      }
export type DismissConversationExceptionsMutationHookResult = ReturnType<typeof useDismissConversationExceptionsMutation>;
export type DismissConversationExceptionsMutationResult = Apollo.MutationResult<DismissConversationExceptionsMutation>;
export type DismissConversationExceptionsMutationOptions = Apollo.BaseMutationOptions<DismissConversationExceptionsMutation, DismissConversationExceptionsMutationVariables>;
export const ResolveSkillChangeRequestDocument = gql`
    mutation ResolveSkillChangeRequest($exceptionId: ID!, $outcome: SkillChangeApprovalOutcome!, $rationale: String) {
  resolveSkillChangeRequest(
    exceptionId: $exceptionId
    outcome: $outcome
    rationale: $rationale
  )
}
    `;
export type ResolveSkillChangeRequestMutationFn = Apollo.MutationFunction<ResolveSkillChangeRequestMutation, ResolveSkillChangeRequestMutationVariables>;

/**
 * __useResolveSkillChangeRequestMutation__
 *
 * To run a mutation, you first call `useResolveSkillChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveSkillChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveSkillChangeRequestMutation, { data, loading, error }] = useResolveSkillChangeRequestMutation({
 *   variables: {
 *      exceptionId: // value for 'exceptionId'
 *      outcome: // value for 'outcome'
 *      rationale: // value for 'rationale'
 *   },
 * });
 */
export function useResolveSkillChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveSkillChangeRequestMutation, ResolveSkillChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveSkillChangeRequestMutation, ResolveSkillChangeRequestMutationVariables>(ResolveSkillChangeRequestDocument, options);
      }
export type ResolveSkillChangeRequestMutationHookResult = ReturnType<typeof useResolveSkillChangeRequestMutation>;
export type ResolveSkillChangeRequestMutationResult = Apollo.MutationResult<ResolveSkillChangeRequestMutation>;
export type ResolveSkillChangeRequestMutationOptions = Apollo.BaseMutationOptions<ResolveSkillChangeRequestMutation, ResolveSkillChangeRequestMutationVariables>;
export const ResolveTrackSettingsChangeRequestDocument = gql`
    mutation ResolveTrackSettingsChangeRequest($exceptionId: ID!, $outcome: SkillChangeApprovalOutcome!) {
  resolveTrackSettingsChangeRequest(exceptionId: $exceptionId, outcome: $outcome)
}
    `;
export type ResolveTrackSettingsChangeRequestMutationFn = Apollo.MutationFunction<ResolveTrackSettingsChangeRequestMutation, ResolveTrackSettingsChangeRequestMutationVariables>;

/**
 * __useResolveTrackSettingsChangeRequestMutation__
 *
 * To run a mutation, you first call `useResolveTrackSettingsChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveTrackSettingsChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveTrackSettingsChangeRequestMutation, { data, loading, error }] = useResolveTrackSettingsChangeRequestMutation({
 *   variables: {
 *      exceptionId: // value for 'exceptionId'
 *      outcome: // value for 'outcome'
 *   },
 * });
 */
export function useResolveTrackSettingsChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveTrackSettingsChangeRequestMutation, ResolveTrackSettingsChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveTrackSettingsChangeRequestMutation, ResolveTrackSettingsChangeRequestMutationVariables>(ResolveTrackSettingsChangeRequestDocument, options);
      }
export type ResolveTrackSettingsChangeRequestMutationHookResult = ReturnType<typeof useResolveTrackSettingsChangeRequestMutation>;
export type ResolveTrackSettingsChangeRequestMutationResult = Apollo.MutationResult<ResolveTrackSettingsChangeRequestMutation>;
export type ResolveTrackSettingsChangeRequestMutationOptions = Apollo.BaseMutationOptions<ResolveTrackSettingsChangeRequestMutation, ResolveTrackSettingsChangeRequestMutationVariables>;
export const RunSkillChangeTestsDocument = gql`
    mutation RunSkillChangeTests($exceptionId: ID!) {
  runSkillChangeTests(exceptionId: $exceptionId)
}
    `;
export type RunSkillChangeTestsMutationFn = Apollo.MutationFunction<RunSkillChangeTestsMutation, RunSkillChangeTestsMutationVariables>;

/**
 * __useRunSkillChangeTestsMutation__
 *
 * To run a mutation, you first call `useRunSkillChangeTestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunSkillChangeTestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runSkillChangeTestsMutation, { data, loading, error }] = useRunSkillChangeTestsMutation({
 *   variables: {
 *      exceptionId: // value for 'exceptionId'
 *   },
 * });
 */
export function useRunSkillChangeTestsMutation(baseOptions?: Apollo.MutationHookOptions<RunSkillChangeTestsMutation, RunSkillChangeTestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunSkillChangeTestsMutation, RunSkillChangeTestsMutationVariables>(RunSkillChangeTestsDocument, options);
      }
export type RunSkillChangeTestsMutationHookResult = ReturnType<typeof useRunSkillChangeTestsMutation>;
export type RunSkillChangeTestsMutationResult = Apollo.MutationResult<RunSkillChangeTestsMutation>;
export type RunSkillChangeTestsMutationOptions = Apollo.BaseMutationOptions<RunSkillChangeTestsMutation, RunSkillChangeTestsMutationVariables>;
export const CreateExceptionDocument = gql`
    mutation createException($input: CreateExceptionInput!) {
  createException(input: $input) {
    type
    status
  }
}
    `;
export type CreateExceptionMutationFn = Apollo.MutationFunction<CreateExceptionMutation, CreateExceptionMutationVariables>;

/**
 * __useCreateExceptionMutation__
 *
 * To run a mutation, you first call `useCreateExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionMutation, { data, loading, error }] = useCreateExceptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExceptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateExceptionMutation, CreateExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExceptionMutation, CreateExceptionMutationVariables>(CreateExceptionDocument, options);
      }
export type CreateExceptionMutationHookResult = ReturnType<typeof useCreateExceptionMutation>;
export type CreateExceptionMutationResult = Apollo.MutationResult<CreateExceptionMutation>;
export type CreateExceptionMutationOptions = Apollo.BaseMutationOptions<CreateExceptionMutation, CreateExceptionMutationVariables>;
export const RunCoverEvalsDocument = gql`
    mutation RunCoverEvals {
  runCoverEvals {
    success
    datasetsRun
    message
    error
    results {
      datasetName
      score
      experimentUrl
      scorerRegressions
      errorRegressions
      error
    }
  }
}
    `;
export type RunCoverEvalsMutationFn = Apollo.MutationFunction<RunCoverEvalsMutation, RunCoverEvalsMutationVariables>;

/**
 * __useRunCoverEvalsMutation__
 *
 * To run a mutation, you first call `useRunCoverEvalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCoverEvalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCoverEvalsMutation, { data, loading, error }] = useRunCoverEvalsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunCoverEvalsMutation(baseOptions?: Apollo.MutationHookOptions<RunCoverEvalsMutation, RunCoverEvalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunCoverEvalsMutation, RunCoverEvalsMutationVariables>(RunCoverEvalsDocument, options);
      }
export type RunCoverEvalsMutationHookResult = ReturnType<typeof useRunCoverEvalsMutation>;
export type RunCoverEvalsMutationResult = Apollo.MutationResult<RunCoverEvalsMutation>;
export type RunCoverEvalsMutationOptions = Apollo.BaseMutationOptions<RunCoverEvalsMutation, RunCoverEvalsMutationVariables>;
export const CreateMemoryDocument = gql`
    mutation CreateMemory($input: CreateMemoryInput!) {
  createMemory(input: $input) {
    success
    errors
    memory {
      ...Memory
    }
  }
}
    ${MemoryFragmentDoc}`;
export type CreateMemoryMutationFn = Apollo.MutationFunction<CreateMemoryMutation, CreateMemoryMutationVariables>;

/**
 * __useCreateMemoryMutation__
 *
 * To run a mutation, you first call `useCreateMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMemoryMutation, { data, loading, error }] = useCreateMemoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMemoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateMemoryMutation, CreateMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMemoryMutation, CreateMemoryMutationVariables>(CreateMemoryDocument, options);
      }
export type CreateMemoryMutationHookResult = ReturnType<typeof useCreateMemoryMutation>;
export type CreateMemoryMutationResult = Apollo.MutationResult<CreateMemoryMutation>;
export type CreateMemoryMutationOptions = Apollo.BaseMutationOptions<CreateMemoryMutation, CreateMemoryMutationVariables>;
export const DeleteExternalChannelDocument = gql`
    mutation DeleteExternalChannel($input: DeleteExternalChannelInput!) {
  deleteExternalChannel(input: $input) {
    success
  }
}
    `;
export type DeleteExternalChannelMutationFn = Apollo.MutationFunction<DeleteExternalChannelMutation, DeleteExternalChannelMutationVariables>;

/**
 * __useDeleteExternalChannelMutation__
 *
 * To run a mutation, you first call `useDeleteExternalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalChannelMutation, { data, loading, error }] = useDeleteExternalChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExternalChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalChannelMutation, DeleteExternalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalChannelMutation, DeleteExternalChannelMutationVariables>(DeleteExternalChannelDocument, options);
      }
export type DeleteExternalChannelMutationHookResult = ReturnType<typeof useDeleteExternalChannelMutation>;
export type DeleteExternalChannelMutationResult = Apollo.MutationResult<DeleteExternalChannelMutation>;
export type DeleteExternalChannelMutationOptions = Apollo.BaseMutationOptions<DeleteExternalChannelMutation, DeleteExternalChannelMutationVariables>;
export const UpdateExternalChannelDocument = gql`
    mutation UpdateExternalChannel($input: UpdateExternalChannelInput!) {
  updateExternalChannel(input: $input) {
    success
    externalChannel {
      ...ExternalChannel
    }
  }
}
    ${ExternalChannelFragmentDoc}`;
export type UpdateExternalChannelMutationFn = Apollo.MutationFunction<UpdateExternalChannelMutation, UpdateExternalChannelMutationVariables>;

/**
 * __useUpdateExternalChannelMutation__
 *
 * To run a mutation, you first call `useUpdateExternalChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalChannelMutation, { data, loading, error }] = useUpdateExternalChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalChannelMutation, UpdateExternalChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalChannelMutation, UpdateExternalChannelMutationVariables>(UpdateExternalChannelDocument, options);
      }
export type UpdateExternalChannelMutationHookResult = ReturnType<typeof useUpdateExternalChannelMutation>;
export type UpdateExternalChannelMutationResult = Apollo.MutationResult<UpdateExternalChannelMutation>;
export type UpdateExternalChannelMutationOptions = Apollo.BaseMutationOptions<UpdateExternalChannelMutation, UpdateExternalChannelMutationVariables>;
export const CreateOrUpdateExternalIdMappingDocument = gql`
    mutation CreateOrUpdateExternalIdMapping($input: CreateOrUpdateExternalIdMappingInput!) {
  createOrUpdateExternalIdMapping(input: $input) {
    success
  }
}
    `;
export type CreateOrUpdateExternalIdMappingMutationFn = Apollo.MutationFunction<CreateOrUpdateExternalIdMappingMutation, CreateOrUpdateExternalIdMappingMutationVariables>;

/**
 * __useCreateOrUpdateExternalIdMappingMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateExternalIdMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateExternalIdMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateExternalIdMappingMutation, { data, loading, error }] = useCreateOrUpdateExternalIdMappingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateExternalIdMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateExternalIdMappingMutation, CreateOrUpdateExternalIdMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateExternalIdMappingMutation, CreateOrUpdateExternalIdMappingMutationVariables>(CreateOrUpdateExternalIdMappingDocument, options);
      }
export type CreateOrUpdateExternalIdMappingMutationHookResult = ReturnType<typeof useCreateOrUpdateExternalIdMappingMutation>;
export type CreateOrUpdateExternalIdMappingMutationResult = Apollo.MutationResult<CreateOrUpdateExternalIdMappingMutation>;
export type CreateOrUpdateExternalIdMappingMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateExternalIdMappingMutation, CreateOrUpdateExternalIdMappingMutationVariables>;
export const EnsureOutlookExternalMessageDocument = gql`
    mutation EnsureOutlookExternalMessage($input: EnsureOutlookExternalMessageInput!) {
  ensureOutlookExternalMessage(input: $input)
}
    `;
export type EnsureOutlookExternalMessageMutationFn = Apollo.MutationFunction<EnsureOutlookExternalMessageMutation, EnsureOutlookExternalMessageMutationVariables>;

/**
 * __useEnsureOutlookExternalMessageMutation__
 *
 * To run a mutation, you first call `useEnsureOutlookExternalMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureOutlookExternalMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureOutlookExternalMessageMutation, { data, loading, error }] = useEnsureOutlookExternalMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnsureOutlookExternalMessageMutation(baseOptions?: Apollo.MutationHookOptions<EnsureOutlookExternalMessageMutation, EnsureOutlookExternalMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureOutlookExternalMessageMutation, EnsureOutlookExternalMessageMutationVariables>(EnsureOutlookExternalMessageDocument, options);
      }
export type EnsureOutlookExternalMessageMutationHookResult = ReturnType<typeof useEnsureOutlookExternalMessageMutation>;
export type EnsureOutlookExternalMessageMutationResult = Apollo.MutationResult<EnsureOutlookExternalMessageMutation>;
export type EnsureOutlookExternalMessageMutationOptions = Apollo.BaseMutationOptions<EnsureOutlookExternalMessageMutation, EnsureOutlookExternalMessageMutationVariables>;
export const DisableTmsIntegrationVerificationDocument = gql`
    mutation DisableTMSIntegrationVerification($input: DisableTMSIntegrationVerificationInput!) {
  disableTMSIntegrationVerification(input: $input)
}
    `;
export type DisableTmsIntegrationVerificationMutationFn = Apollo.MutationFunction<DisableTmsIntegrationVerificationMutation, DisableTmsIntegrationVerificationMutationVariables>;

/**
 * __useDisableTmsIntegrationVerificationMutation__
 *
 * To run a mutation, you first call `useDisableTmsIntegrationVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTmsIntegrationVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTmsIntegrationVerificationMutation, { data, loading, error }] = useDisableTmsIntegrationVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableTmsIntegrationVerificationMutation(baseOptions?: Apollo.MutationHookOptions<DisableTmsIntegrationVerificationMutation, DisableTmsIntegrationVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTmsIntegrationVerificationMutation, DisableTmsIntegrationVerificationMutationVariables>(DisableTmsIntegrationVerificationDocument, options);
      }
export type DisableTmsIntegrationVerificationMutationHookResult = ReturnType<typeof useDisableTmsIntegrationVerificationMutation>;
export type DisableTmsIntegrationVerificationMutationResult = Apollo.MutationResult<DisableTmsIntegrationVerificationMutation>;
export type DisableTmsIntegrationVerificationMutationOptions = Apollo.BaseMutationOptions<DisableTmsIntegrationVerificationMutation, DisableTmsIntegrationVerificationMutationVariables>;
export const EnableTmsIntegrationVerificationDocument = gql`
    mutation EnableTMSIntegrationVerification($input: EnableTMSIntegrationVerificationInput!) {
  enableTMSIntegrationVerification(input: $input) {
    success
    schedule
  }
}
    `;
export type EnableTmsIntegrationVerificationMutationFn = Apollo.MutationFunction<EnableTmsIntegrationVerificationMutation, EnableTmsIntegrationVerificationMutationVariables>;

/**
 * __useEnableTmsIntegrationVerificationMutation__
 *
 * To run a mutation, you first call `useEnableTmsIntegrationVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTmsIntegrationVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTmsIntegrationVerificationMutation, { data, loading, error }] = useEnableTmsIntegrationVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableTmsIntegrationVerificationMutation(baseOptions?: Apollo.MutationHookOptions<EnableTmsIntegrationVerificationMutation, EnableTmsIntegrationVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableTmsIntegrationVerificationMutation, EnableTmsIntegrationVerificationMutationVariables>(EnableTmsIntegrationVerificationDocument, options);
      }
export type EnableTmsIntegrationVerificationMutationHookResult = ReturnType<typeof useEnableTmsIntegrationVerificationMutation>;
export type EnableTmsIntegrationVerificationMutationResult = Apollo.MutationResult<EnableTmsIntegrationVerificationMutation>;
export type EnableTmsIntegrationVerificationMutationOptions = Apollo.BaseMutationOptions<EnableTmsIntegrationVerificationMutation, EnableTmsIntegrationVerificationMutationVariables>;
export const VerifyCarrierIntegrationDocument = gql`
    mutation VerifyCarrierIntegration($input: VerifyCarrierIntegrationInput!) {
  verifyCarrierIntegration(input: $input) {
    success
    error
  }
}
    `;
export type VerifyCarrierIntegrationMutationFn = Apollo.MutationFunction<VerifyCarrierIntegrationMutation, VerifyCarrierIntegrationMutationVariables>;

/**
 * __useVerifyCarrierIntegrationMutation__
 *
 * To run a mutation, you first call `useVerifyCarrierIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCarrierIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCarrierIntegrationMutation, { data, loading, error }] = useVerifyCarrierIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyCarrierIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCarrierIntegrationMutation, VerifyCarrierIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCarrierIntegrationMutation, VerifyCarrierIntegrationMutationVariables>(VerifyCarrierIntegrationDocument, options);
      }
export type VerifyCarrierIntegrationMutationHookResult = ReturnType<typeof useVerifyCarrierIntegrationMutation>;
export type VerifyCarrierIntegrationMutationResult = Apollo.MutationResult<VerifyCarrierIntegrationMutation>;
export type VerifyCarrierIntegrationMutationOptions = Apollo.BaseMutationOptions<VerifyCarrierIntegrationMutation, VerifyCarrierIntegrationMutationVariables>;
export const VerifyTmsIntegrationDocument = gql`
    mutation VerifyTMSIntegration($input: VerifyTMSIntegrationInput!) {
  verifyTMSIntegration(input: $input) {
    success
    error
  }
}
    `;
export type VerifyTmsIntegrationMutationFn = Apollo.MutationFunction<VerifyTmsIntegrationMutation, VerifyTmsIntegrationMutationVariables>;

/**
 * __useVerifyTmsIntegrationMutation__
 *
 * To run a mutation, you first call `useVerifyTmsIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTmsIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTmsIntegrationMutation, { data, loading, error }] = useVerifyTmsIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyTmsIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTmsIntegrationMutation, VerifyTmsIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTmsIntegrationMutation, VerifyTmsIntegrationMutationVariables>(VerifyTmsIntegrationDocument, options);
      }
export type VerifyTmsIntegrationMutationHookResult = ReturnType<typeof useVerifyTmsIntegrationMutation>;
export type VerifyTmsIntegrationMutationResult = Apollo.MutationResult<VerifyTmsIntegrationMutation>;
export type VerifyTmsIntegrationMutationOptions = Apollo.BaseMutationOptions<VerifyTmsIntegrationMutation, VerifyTmsIntegrationMutationVariables>;
export const CreateJobFromOutlookDocument = gql`
    mutation CreateJobFromOutlook($input: CreateOutlookJobInput!) {
  createOutlookJob(input: $input) {
    success
    job {
      ...JobSummary
    }
  }
}
    ${JobSummaryFragmentDoc}`;
export type CreateJobFromOutlookMutationFn = Apollo.MutationFunction<CreateJobFromOutlookMutation, CreateJobFromOutlookMutationVariables>;

/**
 * __useCreateJobFromOutlookMutation__
 *
 * To run a mutation, you first call `useCreateJobFromOutlookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobFromOutlookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobFromOutlookMutation, { data, loading, error }] = useCreateJobFromOutlookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobFromOutlookMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobFromOutlookMutation, CreateJobFromOutlookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobFromOutlookMutation, CreateJobFromOutlookMutationVariables>(CreateJobFromOutlookDocument, options);
      }
export type CreateJobFromOutlookMutationHookResult = ReturnType<typeof useCreateJobFromOutlookMutation>;
export type CreateJobFromOutlookMutationResult = Apollo.MutationResult<CreateJobFromOutlookMutation>;
export type CreateJobFromOutlookMutationOptions = Apollo.BaseMutationOptions<CreateJobFromOutlookMutation, CreateJobFromOutlookMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($input: DeleteJobInput!) {
  deleteJob(input: $input) {
    success
  }
}
    `;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const ReprocessJobDocument = gql`
    mutation ReprocessJob($input: ReprocessJobInput!) {
  reprocessJob(input: $input) {
    success
  }
}
    `;
export type ReprocessJobMutationFn = Apollo.MutationFunction<ReprocessJobMutation, ReprocessJobMutationVariables>;

/**
 * __useReprocessJobMutation__
 *
 * To run a mutation, you first call `useReprocessJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessJobMutation, { data, loading, error }] = useReprocessJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReprocessJobMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessJobMutation, ReprocessJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessJobMutation, ReprocessJobMutationVariables>(ReprocessJobDocument, options);
      }
export type ReprocessJobMutationHookResult = ReturnType<typeof useReprocessJobMutation>;
export type ReprocessJobMutationResult = Apollo.MutationResult<ReprocessJobMutation>;
export type ReprocessJobMutationOptions = Apollo.BaseMutationOptions<ReprocessJobMutation, ReprocessJobMutationVariables>;
export const SimulateQuoteJobReplyDocument = gql`
    mutation SimulateQuoteJobReply($input: SimulateQuoteJobReplyInput!) {
  simulateQuoteJobReply(input: $input) {
    success
    steps {
      id
      kind
      title
      detail
      status
      occurredAt
      metadata
    }
  }
}
    `;
export type SimulateQuoteJobReplyMutationFn = Apollo.MutationFunction<SimulateQuoteJobReplyMutation, SimulateQuoteJobReplyMutationVariables>;

/**
 * __useSimulateQuoteJobReplyMutation__
 *
 * To run a mutation, you first call `useSimulateQuoteJobReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateQuoteJobReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateQuoteJobReplyMutation, { data, loading, error }] = useSimulateQuoteJobReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateQuoteJobReplyMutation(baseOptions?: Apollo.MutationHookOptions<SimulateQuoteJobReplyMutation, SimulateQuoteJobReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimulateQuoteJobReplyMutation, SimulateQuoteJobReplyMutationVariables>(SimulateQuoteJobReplyDocument, options);
      }
export type SimulateQuoteJobReplyMutationHookResult = ReturnType<typeof useSimulateQuoteJobReplyMutation>;
export type SimulateQuoteJobReplyMutationResult = Apollo.MutationResult<SimulateQuoteJobReplyMutation>;
export type SimulateQuoteJobReplyMutationOptions = Apollo.BaseMutationOptions<SimulateQuoteJobReplyMutation, SimulateQuoteJobReplyMutationVariables>;
export const TriggerQuoteAgentForJobDocument = gql`
    mutation TriggerQuoteAgentForJob($input: TriggerQuoteAgentForJobInput!) {
  triggerQuoteAgentForJob(input: $input) {
    success
    actionExecutionId
  }
}
    `;
export type TriggerQuoteAgentForJobMutationFn = Apollo.MutationFunction<TriggerQuoteAgentForJobMutation, TriggerQuoteAgentForJobMutationVariables>;

/**
 * __useTriggerQuoteAgentForJobMutation__
 *
 * To run a mutation, you first call `useTriggerQuoteAgentForJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerQuoteAgentForJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerQuoteAgentForJobMutation, { data, loading, error }] = useTriggerQuoteAgentForJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerQuoteAgentForJobMutation(baseOptions?: Apollo.MutationHookOptions<TriggerQuoteAgentForJobMutation, TriggerQuoteAgentForJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerQuoteAgentForJobMutation, TriggerQuoteAgentForJobMutationVariables>(TriggerQuoteAgentForJobDocument, options);
      }
export type TriggerQuoteAgentForJobMutationHookResult = ReturnType<typeof useTriggerQuoteAgentForJobMutation>;
export type TriggerQuoteAgentForJobMutationResult = Apollo.MutationResult<TriggerQuoteAgentForJobMutation>;
export type TriggerQuoteAgentForJobMutationOptions = Apollo.BaseMutationOptions<TriggerQuoteAgentForJobMutation, TriggerQuoteAgentForJobMutationVariables>;
export const CreateBlankDocumentInKnowledgeBaseDocument = gql`
    mutation CreateBlankDocumentInKnowledgeBase($input: CreateBlankDocumentInKnowledgeBaseInput!) {
  createBlankDocumentInKnowledgeBase(input: $input) {
    knowledgeBaseDocumentUpload {
      ...KnowledgeBaseDocument
    }
  }
}
    ${KnowledgeBaseDocumentFragmentDoc}`;
export type CreateBlankDocumentInKnowledgeBaseMutationFn = Apollo.MutationFunction<CreateBlankDocumentInKnowledgeBaseMutation, CreateBlankDocumentInKnowledgeBaseMutationVariables>;

/**
 * __useCreateBlankDocumentInKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useCreateBlankDocumentInKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankDocumentInKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankDocumentInKnowledgeBaseMutation, { data, loading, error }] = useCreateBlankDocumentInKnowledgeBaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlankDocumentInKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlankDocumentInKnowledgeBaseMutation, CreateBlankDocumentInKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlankDocumentInKnowledgeBaseMutation, CreateBlankDocumentInKnowledgeBaseMutationVariables>(CreateBlankDocumentInKnowledgeBaseDocument, options);
      }
export type CreateBlankDocumentInKnowledgeBaseMutationHookResult = ReturnType<typeof useCreateBlankDocumentInKnowledgeBaseMutation>;
export type CreateBlankDocumentInKnowledgeBaseMutationResult = Apollo.MutationResult<CreateBlankDocumentInKnowledgeBaseMutation>;
export type CreateBlankDocumentInKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<CreateBlankDocumentInKnowledgeBaseMutation, CreateBlankDocumentInKnowledgeBaseMutationVariables>;
export const CreateCustomerDocumentsInKnowledgeBaseDocument = gql`
    mutation CreateCustomerDocumentsInKnowledgeBase($input: CreateCustomerDocumentsInKnowledgeBaseInput!) {
  createCustomerDocumentsInKnowledgeBase(input: $input) {
    knowledgeBaseDocumentUploads {
      ...KnowledgeBaseDocument
    }
    success
  }
}
    ${KnowledgeBaseDocumentFragmentDoc}`;
export type CreateCustomerDocumentsInKnowledgeBaseMutationFn = Apollo.MutationFunction<CreateCustomerDocumentsInKnowledgeBaseMutation, CreateCustomerDocumentsInKnowledgeBaseMutationVariables>;

/**
 * __useCreateCustomerDocumentsInKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useCreateCustomerDocumentsInKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerDocumentsInKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerDocumentsInKnowledgeBaseMutation, { data, loading, error }] = useCreateCustomerDocumentsInKnowledgeBaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerDocumentsInKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerDocumentsInKnowledgeBaseMutation, CreateCustomerDocumentsInKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerDocumentsInKnowledgeBaseMutation, CreateCustomerDocumentsInKnowledgeBaseMutationVariables>(CreateCustomerDocumentsInKnowledgeBaseDocument, options);
      }
export type CreateCustomerDocumentsInKnowledgeBaseMutationHookResult = ReturnType<typeof useCreateCustomerDocumentsInKnowledgeBaseMutation>;
export type CreateCustomerDocumentsInKnowledgeBaseMutationResult = Apollo.MutationResult<CreateCustomerDocumentsInKnowledgeBaseMutation>;
export type CreateCustomerDocumentsInKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<CreateCustomerDocumentsInKnowledgeBaseMutation, CreateCustomerDocumentsInKnowledgeBaseMutationVariables>;
export const CreateKnowledgeBaseDocument = gql`
    mutation CreateKnowledgeBase($input: CreateKnowledgeBaseInput!) {
  createKnowledgeBase(input: $input) {
    knowledgeBase {
      ...KnowledgeBase
    }
  }
}
    ${KnowledgeBaseFragmentDoc}`;
export type CreateKnowledgeBaseMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>;

/**
 * __useCreateKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseMutation, { data, loading, error }] = useCreateKnowledgeBaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>(CreateKnowledgeBaseDocument, options);
      }
export type CreateKnowledgeBaseMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseMutation>;
export type CreateKnowledgeBaseMutationResult = Apollo.MutationResult<CreateKnowledgeBaseMutation>;
export type CreateKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseMutation, CreateKnowledgeBaseMutationVariables>;
export const DeleteKnowledgeBaseDocument = gql`
    mutation DeleteKnowledgeBase($id: ID!) {
  deleteKnowledgeBaseById(id: $id) {
    success
  }
}
    `;
export type DeleteKnowledgeBaseMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>;

/**
 * __useDeleteKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseMutation, { data, loading, error }] = useDeleteKnowledgeBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>(DeleteKnowledgeBaseDocument, options);
      }
export type DeleteKnowledgeBaseMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseMutation>;
export type DeleteKnowledgeBaseMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseMutation>;
export type DeleteKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseMutation, DeleteKnowledgeBaseMutationVariables>;
export const DeleteKnowledgeBaseDocumentDocument = gql`
    mutation DeleteKnowledgeBaseDocument($input: DeleteDocumentInKnowledgeBaseInput!) {
  deleteDocumentInKnowledgeBase(input: $input) {
    success
  }
}
    `;
export type DeleteKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>;

/**
 * __useDeleteKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseDocumentMutation, { data, loading, error }] = useDeleteKnowledgeBaseDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>(DeleteKnowledgeBaseDocumentDocument, options);
      }
export type DeleteKnowledgeBaseDocumentMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseDocumentMutation>;
export type DeleteKnowledgeBaseDocumentMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseDocumentMutation>;
export type DeleteKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>;
export const RenameKnowledgeBaseDocument = gql`
    mutation RenameKnowledgeBase($input: RenameKnowledgeBaseInput!) {
  renameKnowledgeBase(input: $input) {
    success
  }
}
    `;
export type RenameKnowledgeBaseMutationFn = Apollo.MutationFunction<RenameKnowledgeBaseMutation, RenameKnowledgeBaseMutationVariables>;

/**
 * __useRenameKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useRenameKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameKnowledgeBaseMutation, { data, loading, error }] = useRenameKnowledgeBaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<RenameKnowledgeBaseMutation, RenameKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameKnowledgeBaseMutation, RenameKnowledgeBaseMutationVariables>(RenameKnowledgeBaseDocument, options);
      }
export type RenameKnowledgeBaseMutationHookResult = ReturnType<typeof useRenameKnowledgeBaseMutation>;
export type RenameKnowledgeBaseMutationResult = Apollo.MutationResult<RenameKnowledgeBaseMutation>;
export type RenameKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<RenameKnowledgeBaseMutation, RenameKnowledgeBaseMutationVariables>;
export const RenameKnowledgeBaseDocumentDocument = gql`
    mutation RenameKnowledgeBaseDocument($input: RenameDocumentInKnowledgeBaseInput!) {
  renameDocumentInKnowledgeBase(input: $input) {
    success
  }
}
    `;
export type RenameKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<RenameKnowledgeBaseDocumentMutation, RenameKnowledgeBaseDocumentMutationVariables>;

/**
 * __useRenameKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useRenameKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameKnowledgeBaseDocumentMutation, { data, loading, error }] = useRenameKnowledgeBaseDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameKnowledgeBaseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RenameKnowledgeBaseDocumentMutation, RenameKnowledgeBaseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameKnowledgeBaseDocumentMutation, RenameKnowledgeBaseDocumentMutationVariables>(RenameKnowledgeBaseDocumentDocument, options);
      }
export type RenameKnowledgeBaseDocumentMutationHookResult = ReturnType<typeof useRenameKnowledgeBaseDocumentMutation>;
export type RenameKnowledgeBaseDocumentMutationResult = Apollo.MutationResult<RenameKnowledgeBaseDocumentMutation>;
export type RenameKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<RenameKnowledgeBaseDocumentMutation, RenameKnowledgeBaseDocumentMutationVariables>;
export const UpdateFileContentDocument = gql`
    mutation UpdateFileContent($input: UpdateFileContentInput!, $file: Upload!) {
  updateFileContent(input: $input, file: $file) {
    success
  }
}
    `;
export type UpdateFileContentMutationFn = Apollo.MutationFunction<UpdateFileContentMutation, UpdateFileContentMutationVariables>;

/**
 * __useUpdateFileContentMutation__
 *
 * To run a mutation, you first call `useUpdateFileContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileContentMutation, { data, loading, error }] = useUpdateFileContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateFileContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileContentMutation, UpdateFileContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileContentMutation, UpdateFileContentMutationVariables>(UpdateFileContentDocument, options);
      }
export type UpdateFileContentMutationHookResult = ReturnType<typeof useUpdateFileContentMutation>;
export type UpdateFileContentMutationResult = Apollo.MutationResult<UpdateFileContentMutation>;
export type UpdateFileContentMutationOptions = Apollo.BaseMutationOptions<UpdateFileContentMutation, UpdateFileContentMutationVariables>;
export const CreateManagedResourceDocument = gql`
    mutation CreateManagedResource($input: CreateManagedResourceInput!) {
  createManagedResource(input: $input) {
    managedResource {
      ...ManagedResource
    }
  }
}
    ${ManagedResourceFragmentDoc}`;
export type CreateManagedResourceMutationFn = Apollo.MutationFunction<CreateManagedResourceMutation, CreateManagedResourceMutationVariables>;

/**
 * __useCreateManagedResourceMutation__
 *
 * To run a mutation, you first call `useCreateManagedResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedResourceMutation, { data, loading, error }] = useCreateManagedResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManagedResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagedResourceMutation, CreateManagedResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagedResourceMutation, CreateManagedResourceMutationVariables>(CreateManagedResourceDocument, options);
      }
export type CreateManagedResourceMutationHookResult = ReturnType<typeof useCreateManagedResourceMutation>;
export type CreateManagedResourceMutationResult = Apollo.MutationResult<CreateManagedResourceMutation>;
export type CreateManagedResourceMutationOptions = Apollo.BaseMutationOptions<CreateManagedResourceMutation, CreateManagedResourceMutationVariables>;
export const DeleteManagedResourceDocument = gql`
    mutation DeleteManagedResource($id: ID!) {
  deleteManagedResource(id: $id) {
    success
  }
}
    `;
export type DeleteManagedResourceMutationFn = Apollo.MutationFunction<DeleteManagedResourceMutation, DeleteManagedResourceMutationVariables>;

/**
 * __useDeleteManagedResourceMutation__
 *
 * To run a mutation, you first call `useDeleteManagedResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagedResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagedResourceMutation, { data, loading, error }] = useDeleteManagedResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteManagedResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagedResourceMutation, DeleteManagedResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagedResourceMutation, DeleteManagedResourceMutationVariables>(DeleteManagedResourceDocument, options);
      }
export type DeleteManagedResourceMutationHookResult = ReturnType<typeof useDeleteManagedResourceMutation>;
export type DeleteManagedResourceMutationResult = Apollo.MutationResult<DeleteManagedResourceMutation>;
export type DeleteManagedResourceMutationOptions = Apollo.BaseMutationOptions<DeleteManagedResourceMutation, DeleteManagedResourceMutationVariables>;
export const RunManagedResourceCanaryDocument = gql`
    mutation RunManagedResourceCanary($id: ID!) {
  runManagedResourceCanary(id: $id) {
    overallStatus
    durationMs
    failureReason
  }
}
    `;
export type RunManagedResourceCanaryMutationFn = Apollo.MutationFunction<RunManagedResourceCanaryMutation, RunManagedResourceCanaryMutationVariables>;

/**
 * __useRunManagedResourceCanaryMutation__
 *
 * To run a mutation, you first call `useRunManagedResourceCanaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunManagedResourceCanaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runManagedResourceCanaryMutation, { data, loading, error }] = useRunManagedResourceCanaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRunManagedResourceCanaryMutation(baseOptions?: Apollo.MutationHookOptions<RunManagedResourceCanaryMutation, RunManagedResourceCanaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunManagedResourceCanaryMutation, RunManagedResourceCanaryMutationVariables>(RunManagedResourceCanaryDocument, options);
      }
export type RunManagedResourceCanaryMutationHookResult = ReturnType<typeof useRunManagedResourceCanaryMutation>;
export type RunManagedResourceCanaryMutationResult = Apollo.MutationResult<RunManagedResourceCanaryMutation>;
export type RunManagedResourceCanaryMutationOptions = Apollo.BaseMutationOptions<RunManagedResourceCanaryMutation, RunManagedResourceCanaryMutationVariables>;
export const UpdateManagedResourceDocument = gql`
    mutation UpdateManagedResource($input: UpdateManagedResourceInput!) {
  updateManagedResource(input: $input) {
    managedResource {
      ...ManagedResource
    }
  }
}
    ${ManagedResourceFragmentDoc}`;
export type UpdateManagedResourceMutationFn = Apollo.MutationFunction<UpdateManagedResourceMutation, UpdateManagedResourceMutationVariables>;

/**
 * __useUpdateManagedResourceMutation__
 *
 * To run a mutation, you first call `useUpdateManagedResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagedResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagedResourceMutation, { data, loading, error }] = useUpdateManagedResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManagedResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagedResourceMutation, UpdateManagedResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManagedResourceMutation, UpdateManagedResourceMutationVariables>(UpdateManagedResourceDocument, options);
      }
export type UpdateManagedResourceMutationHookResult = ReturnType<typeof useUpdateManagedResourceMutation>;
export type UpdateManagedResourceMutationResult = Apollo.MutationResult<UpdateManagedResourceMutation>;
export type UpdateManagedResourceMutationOptions = Apollo.BaseMutationOptions<UpdateManagedResourceMutation, UpdateManagedResourceMutationVariables>;
export const RateMessageDocument = gql`
    mutation RateMessage($input: RateMessageInput!) {
  rateMessage(input: $input) {
    rating {
      ...MessageRating
    }
  }
}
    ${MessageRatingFragmentDoc}`;
export type RateMessageMutationFn = Apollo.MutationFunction<RateMessageMutation, RateMessageMutationVariables>;

/**
 * __useRateMessageMutation__
 *
 * To run a mutation, you first call `useRateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateMessageMutation, { data, loading, error }] = useRateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateMessageMutation(baseOptions?: Apollo.MutationHookOptions<RateMessageMutation, RateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateMessageMutation, RateMessageMutationVariables>(RateMessageDocument, options);
      }
export type RateMessageMutationHookResult = ReturnType<typeof useRateMessageMutation>;
export type RateMessageMutationResult = Apollo.MutationResult<RateMessageMutation>;
export type RateMessageMutationOptions = Apollo.BaseMutationOptions<RateMessageMutation, RateMessageMutationVariables>;
export const RemoveMessageRatingDocument = gql`
    mutation RemoveMessageRating($input: RemoveMessageRatingInput!) {
  removeMessageRating(input: $input) {
    success
  }
}
    `;
export type RemoveMessageRatingMutationFn = Apollo.MutationFunction<RemoveMessageRatingMutation, RemoveMessageRatingMutationVariables>;

/**
 * __useRemoveMessageRatingMutation__
 *
 * To run a mutation, you first call `useRemoveMessageRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMessageRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMessageRatingMutation, { data, loading, error }] = useRemoveMessageRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMessageRatingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMessageRatingMutation, RemoveMessageRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMessageRatingMutation, RemoveMessageRatingMutationVariables>(RemoveMessageRatingDocument, options);
      }
export type RemoveMessageRatingMutationHookResult = ReturnType<typeof useRemoveMessageRatingMutation>;
export type RemoveMessageRatingMutationResult = Apollo.MutationResult<RemoveMessageRatingMutation>;
export type RemoveMessageRatingMutationOptions = Apollo.BaseMutationOptions<RemoveMessageRatingMutation, RemoveMessageRatingMutationVariables>;
export const SaveMessageRatingDetailsDocument = gql`
    mutation SaveMessageRatingDetails($input: SaveMessageRatingDetailsInput!) {
  saveMessageRatingDetails(input: $input) {
    rating {
      ...MessageRating
    }
  }
}
    ${MessageRatingFragmentDoc}`;
export type SaveMessageRatingDetailsMutationFn = Apollo.MutationFunction<SaveMessageRatingDetailsMutation, SaveMessageRatingDetailsMutationVariables>;

/**
 * __useSaveMessageRatingDetailsMutation__
 *
 * To run a mutation, you first call `useSaveMessageRatingDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMessageRatingDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMessageRatingDetailsMutation, { data, loading, error }] = useSaveMessageRatingDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMessageRatingDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SaveMessageRatingDetailsMutation, SaveMessageRatingDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMessageRatingDetailsMutation, SaveMessageRatingDetailsMutationVariables>(SaveMessageRatingDetailsDocument, options);
      }
export type SaveMessageRatingDetailsMutationHookResult = ReturnType<typeof useSaveMessageRatingDetailsMutation>;
export type SaveMessageRatingDetailsMutationResult = Apollo.MutationResult<SaveMessageRatingDetailsMutation>;
export type SaveMessageRatingDetailsMutationOptions = Apollo.BaseMutationOptions<SaveMessageRatingDetailsMutation, SaveMessageRatingDetailsMutationVariables>;
export const CompleteMicrosoftGraphConnectDocument = gql`
    mutation CompleteMicrosoftGraphConnect($state: String!, $code: String, $error: String) {
  completeMicrosoftGraphConnect(state: $state, code: $code, error: $error) {
    success
    error
  }
}
    `;
export type CompleteMicrosoftGraphConnectMutationFn = Apollo.MutationFunction<CompleteMicrosoftGraphConnectMutation, CompleteMicrosoftGraphConnectMutationVariables>;

/**
 * __useCompleteMicrosoftGraphConnectMutation__
 *
 * To run a mutation, you first call `useCompleteMicrosoftGraphConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMicrosoftGraphConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMicrosoftGraphConnectMutation, { data, loading, error }] = useCompleteMicrosoftGraphConnectMutation({
 *   variables: {
 *      state: // value for 'state'
 *      code: // value for 'code'
 *      error: // value for 'error'
 *   },
 * });
 */
export function useCompleteMicrosoftGraphConnectMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMicrosoftGraphConnectMutation, CompleteMicrosoftGraphConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMicrosoftGraphConnectMutation, CompleteMicrosoftGraphConnectMutationVariables>(CompleteMicrosoftGraphConnectDocument, options);
      }
export type CompleteMicrosoftGraphConnectMutationHookResult = ReturnType<typeof useCompleteMicrosoftGraphConnectMutation>;
export type CompleteMicrosoftGraphConnectMutationResult = Apollo.MutationResult<CompleteMicrosoftGraphConnectMutation>;
export type CompleteMicrosoftGraphConnectMutationOptions = Apollo.BaseMutationOptions<CompleteMicrosoftGraphConnectMutation, CompleteMicrosoftGraphConnectMutationVariables>;
export const StartMicrosoftGraphConnectDocument = gql`
    mutation StartMicrosoftGraphConnect($userId: String!) {
  startMicrosoftGraphConnect(userId: $userId) {
    authorizeUrl
  }
}
    `;
export type StartMicrosoftGraphConnectMutationFn = Apollo.MutationFunction<StartMicrosoftGraphConnectMutation, StartMicrosoftGraphConnectMutationVariables>;

/**
 * __useStartMicrosoftGraphConnectMutation__
 *
 * To run a mutation, you first call `useStartMicrosoftGraphConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMicrosoftGraphConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMicrosoftGraphConnectMutation, { data, loading, error }] = useStartMicrosoftGraphConnectMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useStartMicrosoftGraphConnectMutation(baseOptions?: Apollo.MutationHookOptions<StartMicrosoftGraphConnectMutation, StartMicrosoftGraphConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMicrosoftGraphConnectMutation, StartMicrosoftGraphConnectMutationVariables>(StartMicrosoftGraphConnectDocument, options);
      }
export type StartMicrosoftGraphConnectMutationHookResult = ReturnType<typeof useStartMicrosoftGraphConnectMutation>;
export type StartMicrosoftGraphConnectMutationResult = Apollo.MutationResult<StartMicrosoftGraphConnectMutation>;
export type StartMicrosoftGraphConnectMutationOptions = Apollo.BaseMutationOptions<StartMicrosoftGraphConnectMutation, StartMicrosoftGraphConnectMutationVariables>;
export const ComputeLaneRatesDocument = gql`
    mutation ComputeLaneRates($input: ComputeLaneRatesInput!) {
  computeLaneRates(input: $input) {
    success
    rates {
      provider
      minRate
      maxRate
      midpointRate
      confidence
      reportCount
      error
    }
  }
}
    `;
export type ComputeLaneRatesMutationFn = Apollo.MutationFunction<ComputeLaneRatesMutation, ComputeLaneRatesMutationVariables>;

/**
 * __useComputeLaneRatesMutation__
 *
 * To run a mutation, you first call `useComputeLaneRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComputeLaneRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [computeLaneRatesMutation, { data, loading, error }] = useComputeLaneRatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeLaneRatesMutation(baseOptions?: Apollo.MutationHookOptions<ComputeLaneRatesMutation, ComputeLaneRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ComputeLaneRatesMutation, ComputeLaneRatesMutationVariables>(ComputeLaneRatesDocument, options);
      }
export type ComputeLaneRatesMutationHookResult = ReturnType<typeof useComputeLaneRatesMutation>;
export type ComputeLaneRatesMutationResult = Apollo.MutationResult<ComputeLaneRatesMutation>;
export type ComputeLaneRatesMutationOptions = Apollo.BaseMutationOptions<ComputeLaneRatesMutation, ComputeLaneRatesMutationVariables>;
export const CreateFakeTrackingMilestonesDocument = gql`
    mutation CreateFakeTrackingMilestones($input: CreateFakeTrackingMilestonesInput!) {
  createFakeTrackingMilestones(input: $input) {
    success
    count
  }
}
    `;
export type CreateFakeTrackingMilestonesMutationFn = Apollo.MutationFunction<CreateFakeTrackingMilestonesMutation, CreateFakeTrackingMilestonesMutationVariables>;

/**
 * __useCreateFakeTrackingMilestonesMutation__
 *
 * To run a mutation, you first call `useCreateFakeTrackingMilestonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFakeTrackingMilestonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFakeTrackingMilestonesMutation, { data, loading, error }] = useCreateFakeTrackingMilestonesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFakeTrackingMilestonesMutation(baseOptions?: Apollo.MutationHookOptions<CreateFakeTrackingMilestonesMutation, CreateFakeTrackingMilestonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFakeTrackingMilestonesMutation, CreateFakeTrackingMilestonesMutationVariables>(CreateFakeTrackingMilestonesDocument, options);
      }
export type CreateFakeTrackingMilestonesMutationHookResult = ReturnType<typeof useCreateFakeTrackingMilestonesMutation>;
export type CreateFakeTrackingMilestonesMutationResult = Apollo.MutationResult<CreateFakeTrackingMilestonesMutation>;
export type CreateFakeTrackingMilestonesMutationOptions = Apollo.BaseMutationOptions<CreateFakeTrackingMilestonesMutation, CreateFakeTrackingMilestonesMutationVariables>;
export const CreateTrackingExceptionEventDocument = gql`
    mutation CreateTrackingExceptionEvent($input: CreateTrackingExceptionEventInput!) {
  createTrackingExceptionEvent(input: $input) {
    success
  }
}
    `;
export type CreateTrackingExceptionEventMutationFn = Apollo.MutationFunction<CreateTrackingExceptionEventMutation, CreateTrackingExceptionEventMutationVariables>;

/**
 * __useCreateTrackingExceptionEventMutation__
 *
 * To run a mutation, you first call `useCreateTrackingExceptionEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackingExceptionEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackingExceptionEventMutation, { data, loading, error }] = useCreateTrackingExceptionEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrackingExceptionEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackingExceptionEventMutation, CreateTrackingExceptionEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackingExceptionEventMutation, CreateTrackingExceptionEventMutationVariables>(CreateTrackingExceptionEventDocument, options);
      }
export type CreateTrackingExceptionEventMutationHookResult = ReturnType<typeof useCreateTrackingExceptionEventMutation>;
export type CreateTrackingExceptionEventMutationResult = Apollo.MutationResult<CreateTrackingExceptionEventMutation>;
export type CreateTrackingExceptionEventMutationOptions = Apollo.BaseMutationOptions<CreateTrackingExceptionEventMutation, CreateTrackingExceptionEventMutationVariables>;
export const CreateTrackingMilestoneEventDocument = gql`
    mutation CreateTrackingMilestoneEvent($input: CreateTrackingMilestoneEventInput!) {
  createTrackingMilestoneEvent(input: $input) {
    success
    event {
      id
      createdAt
    }
  }
}
    `;
export type CreateTrackingMilestoneEventMutationFn = Apollo.MutationFunction<CreateTrackingMilestoneEventMutation, CreateTrackingMilestoneEventMutationVariables>;

/**
 * __useCreateTrackingMilestoneEventMutation__
 *
 * To run a mutation, you first call `useCreateTrackingMilestoneEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackingMilestoneEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackingMilestoneEventMutation, { data, loading, error }] = useCreateTrackingMilestoneEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrackingMilestoneEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackingMilestoneEventMutation, CreateTrackingMilestoneEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackingMilestoneEventMutation, CreateTrackingMilestoneEventMutationVariables>(CreateTrackingMilestoneEventDocument, options);
      }
export type CreateTrackingMilestoneEventMutationHookResult = ReturnType<typeof useCreateTrackingMilestoneEventMutation>;
export type CreateTrackingMilestoneEventMutationResult = Apollo.MutationResult<CreateTrackingMilestoneEventMutation>;
export type CreateTrackingMilestoneEventMutationOptions = Apollo.BaseMutationOptions<CreateTrackingMilestoneEventMutation, CreateTrackingMilestoneEventMutationVariables>;
export const SetMovementTrackingPausedDocument = gql`
    mutation SetMovementTrackingPaused($input: SetMovementTrackingPausedInput!) {
  setMovementTrackingPaused(input: $input) {
    success
    movement {
      id
      trackData
    }
  }
}
    `;
export type SetMovementTrackingPausedMutationFn = Apollo.MutationFunction<SetMovementTrackingPausedMutation, SetMovementTrackingPausedMutationVariables>;

/**
 * __useSetMovementTrackingPausedMutation__
 *
 * To run a mutation, you first call `useSetMovementTrackingPausedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMovementTrackingPausedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMovementTrackingPausedMutation, { data, loading, error }] = useSetMovementTrackingPausedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMovementTrackingPausedMutation(baseOptions?: Apollo.MutationHookOptions<SetMovementTrackingPausedMutation, SetMovementTrackingPausedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMovementTrackingPausedMutation, SetMovementTrackingPausedMutationVariables>(SetMovementTrackingPausedDocument, options);
      }
export type SetMovementTrackingPausedMutationHookResult = ReturnType<typeof useSetMovementTrackingPausedMutation>;
export type SetMovementTrackingPausedMutationResult = Apollo.MutationResult<SetMovementTrackingPausedMutation>;
export type SetMovementTrackingPausedMutationOptions = Apollo.BaseMutationOptions<SetMovementTrackingPausedMutation, SetMovementTrackingPausedMutationVariables>;
export const StartTrackSopTestDocument = gql`
    mutation StartTrackSopTest($input: StartTrackSopTestInput!) {
  startTrackSopTest(input: $input) {
    movementId
    shipmentId
    referenceNumber
    actionExecutionId
  }
}
    `;
export type StartTrackSopTestMutationFn = Apollo.MutationFunction<StartTrackSopTestMutation, StartTrackSopTestMutationVariables>;

/**
 * __useStartTrackSopTestMutation__
 *
 * To run a mutation, you first call `useStartTrackSopTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTrackSopTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTrackSopTestMutation, { data, loading, error }] = useStartTrackSopTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartTrackSopTestMutation(baseOptions?: Apollo.MutationHookOptions<StartTrackSopTestMutation, StartTrackSopTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTrackSopTestMutation, StartTrackSopTestMutationVariables>(StartTrackSopTestDocument, options);
      }
export type StartTrackSopTestMutationHookResult = ReturnType<typeof useStartTrackSopTestMutation>;
export type StartTrackSopTestMutationResult = Apollo.MutationResult<StartTrackSopTestMutation>;
export type StartTrackSopTestMutationOptions = Apollo.BaseMutationOptions<StartTrackSopTestMutation, StartTrackSopTestMutationVariables>;
export const UpdateMovementDocument = gql`
    mutation UpdateMovement($input: UpdateMovementInput!) {
  updateMovement(input: $input) {
    success
    movement {
      id
      negotiationStrategyConfigOverride
    }
  }
}
    `;
export type UpdateMovementMutationFn = Apollo.MutationFunction<UpdateMovementMutation, UpdateMovementMutationVariables>;

/**
 * __useUpdateMovementMutation__
 *
 * To run a mutation, you first call `useUpdateMovementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovementMutation, { data, loading, error }] = useUpdateMovementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMovementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMovementMutation, UpdateMovementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMovementMutation, UpdateMovementMutationVariables>(UpdateMovementDocument, options);
      }
export type UpdateMovementMutationHookResult = ReturnType<typeof useUpdateMovementMutation>;
export type UpdateMovementMutationResult = Apollo.MutationResult<UpdateMovementMutation>;
export type UpdateMovementMutationOptions = Apollo.BaseMutationOptions<UpdateMovementMutation, UpdateMovementMutationVariables>;
export const SimulateNegotiationDocument = gql`
    mutation SimulateNegotiation($input: SimulateNegotiationInput!) {
  simulateNegotiation(input: $input) {
    success
    error
    recommendedAction
    strategyUsed {
      id
      name
      type
    }
    variantStrategyId
    variantStrategyName
    needsClarification {
      field
      message
      acceptableValues
    }
    triggerException {
      voomaBestOffer
      carrierBestOffer
      timeoutSeconds
    }
    handlerActionExecutionId
  }
}
    `;
export type SimulateNegotiationMutationFn = Apollo.MutationFunction<SimulateNegotiationMutation, SimulateNegotiationMutationVariables>;

/**
 * __useSimulateNegotiationMutation__
 *
 * To run a mutation, you first call `useSimulateNegotiationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateNegotiationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateNegotiationMutation, { data, loading, error }] = useSimulateNegotiationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateNegotiationMutation(baseOptions?: Apollo.MutationHookOptions<SimulateNegotiationMutation, SimulateNegotiationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimulateNegotiationMutation, SimulateNegotiationMutationVariables>(SimulateNegotiationDocument, options);
      }
export type SimulateNegotiationMutationHookResult = ReturnType<typeof useSimulateNegotiationMutation>;
export type SimulateNegotiationMutationResult = Apollo.MutationResult<SimulateNegotiationMutation>;
export type SimulateNegotiationMutationOptions = Apollo.BaseMutationOptions<SimulateNegotiationMutation, SimulateNegotiationMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($input: DeleteOrderInput!) {
  deleteOrder(input: $input) {
    success
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const RepeatOrderDocument = gql`
    mutation RepeatOrder($input: RepeatOrderInput!) {
  repeatOrder(input: $input) {
    success
  }
}
    `;
export type RepeatOrderMutationFn = Apollo.MutationFunction<RepeatOrderMutation, RepeatOrderMutationVariables>;

/**
 * __useRepeatOrderMutation__
 *
 * To run a mutation, you first call `useRepeatOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepeatOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repeatOrderMutation, { data, loading, error }] = useRepeatOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRepeatOrderMutation(baseOptions?: Apollo.MutationHookOptions<RepeatOrderMutation, RepeatOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepeatOrderMutation, RepeatOrderMutationVariables>(RepeatOrderDocument, options);
      }
export type RepeatOrderMutationHookResult = ReturnType<typeof useRepeatOrderMutation>;
export type RepeatOrderMutationResult = Apollo.MutationResult<RepeatOrderMutation>;
export type RepeatOrderMutationOptions = Apollo.BaseMutationOptions<RepeatOrderMutation, RepeatOrderMutationVariables>;
export const ReplicateOrderDocument = gql`
    mutation ReplicateOrder($input: ReplicateOrderInput!) {
  replicateOrder(input: $input) {
    success
  }
}
    `;
export type ReplicateOrderMutationFn = Apollo.MutationFunction<ReplicateOrderMutation, ReplicateOrderMutationVariables>;

/**
 * __useReplicateOrderMutation__
 *
 * To run a mutation, you first call `useReplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replicateOrderMutation, { data, loading, error }] = useReplicateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplicateOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReplicateOrderMutation, ReplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplicateOrderMutation, ReplicateOrderMutationVariables>(ReplicateOrderDocument, options);
      }
export type ReplicateOrderMutationHookResult = ReturnType<typeof useReplicateOrderMutation>;
export type ReplicateOrderMutationResult = Apollo.MutationResult<ReplicateOrderMutation>;
export type ReplicateOrderMutationOptions = Apollo.BaseMutationOptions<ReplicateOrderMutation, ReplicateOrderMutationVariables>;
export const SubmitOrderDocument = gql`
    mutation SubmitOrder($input: SubmitOrderInput!) {
  submitOrder(input: $input) {
    success
    errors
    order {
      externalDeepLink
    }
  }
}
    `;
export type SubmitOrderMutationFn = Apollo.MutationFunction<SubmitOrderMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderMutation__
 *
 * To run a mutation, you first call `useSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderMutation, { data, loading, error }] = useSubmitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOrderMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(SubmitOrderDocument, options);
      }
export type SubmitOrderMutationHookResult = ReturnType<typeof useSubmitOrderMutation>;
export type SubmitOrderMutationResult = Apollo.MutationResult<SubmitOrderMutation>;
export type SubmitOrderMutationOptions = Apollo.BaseMutationOptions<SubmitOrderMutation, SubmitOrderMutationVariables>;
export const SubmitSubjectOrderDocument = gql`
    mutation SubmitSubjectOrder($input: SubmitSubjectOrderInput!) {
  submitSubjectOrder(input: $input) {
    success
    externalOrderId
    error
  }
}
    `;
export type SubmitSubjectOrderMutationFn = Apollo.MutationFunction<SubmitSubjectOrderMutation, SubmitSubjectOrderMutationVariables>;

/**
 * __useSubmitSubjectOrderMutation__
 *
 * To run a mutation, you first call `useSubmitSubjectOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSubjectOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSubjectOrderMutation, { data, loading, error }] = useSubmitSubjectOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitSubjectOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitSubjectOrderMutation, SubmitSubjectOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitSubjectOrderMutation, SubmitSubjectOrderMutationVariables>(SubmitSubjectOrderDocument, options);
      }
export type SubmitSubjectOrderMutationHookResult = ReturnType<typeof useSubmitSubjectOrderMutation>;
export type SubmitSubjectOrderMutationResult = Apollo.MutationResult<SubmitSubjectOrderMutation>;
export type SubmitSubjectOrderMutationOptions = Apollo.BaseMutationOptions<SubmitSubjectOrderMutation, SubmitSubjectOrderMutationVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($input: UpdateOrderInput!) {
  updateOrder(input: $input) {
    order {
      ...Order
    }
    success
    errors
  }
}
    ${OrderFragmentDoc}`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const ConfigureOrderTemplateDocument = gql`
    mutation ConfigureOrderTemplate($input: ConfigureOrderTemplateInput!) {
  configureOrderTemplate(input: $input) {
    template {
      ...Template
    }
  }
}
    ${TemplateFragmentDoc}`;
export type ConfigureOrderTemplateMutationFn = Apollo.MutationFunction<ConfigureOrderTemplateMutation, ConfigureOrderTemplateMutationVariables>;

/**
 * __useConfigureOrderTemplateMutation__
 *
 * To run a mutation, you first call `useConfigureOrderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureOrderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureOrderTemplateMutation, { data, loading, error }] = useConfigureOrderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureOrderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureOrderTemplateMutation, ConfigureOrderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureOrderTemplateMutation, ConfigureOrderTemplateMutationVariables>(ConfigureOrderTemplateDocument, options);
      }
export type ConfigureOrderTemplateMutationHookResult = ReturnType<typeof useConfigureOrderTemplateMutation>;
export type ConfigureOrderTemplateMutationResult = Apollo.MutationResult<ConfigureOrderTemplateMutation>;
export type ConfigureOrderTemplateMutationOptions = Apollo.BaseMutationOptions<ConfigureOrderTemplateMutation, ConfigureOrderTemplateMutationVariables>;
export const InitializeOrderTemplateDocument = gql`
    mutation InitializeOrderTemplate($input: InitializeOrderTemplateForOriginatorInput!) {
  initializeOrderTemplateForOriginator(input: $input) {
    template {
      ...Template
    }
  }
}
    ${TemplateFragmentDoc}`;
export type InitializeOrderTemplateMutationFn = Apollo.MutationFunction<InitializeOrderTemplateMutation, InitializeOrderTemplateMutationVariables>;

/**
 * __useInitializeOrderTemplateMutation__
 *
 * To run a mutation, you first call `useInitializeOrderTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeOrderTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeOrderTemplateMutation, { data, loading, error }] = useInitializeOrderTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitializeOrderTemplateMutation(baseOptions?: Apollo.MutationHookOptions<InitializeOrderTemplateMutation, InitializeOrderTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeOrderTemplateMutation, InitializeOrderTemplateMutationVariables>(InitializeOrderTemplateDocument, options);
      }
export type InitializeOrderTemplateMutationHookResult = ReturnType<typeof useInitializeOrderTemplateMutation>;
export type InitializeOrderTemplateMutationResult = Apollo.MutationResult<InitializeOrderTemplateMutation>;
export type InitializeOrderTemplateMutationOptions = Apollo.BaseMutationOptions<InitializeOrderTemplateMutation, InitializeOrderTemplateMutationVariables>;
export const PokeActionExecutionDocument = gql`
    mutation pokeActionExecution($input: PokeActionExecutionInput!) {
  pokeActionExecution(input: $input) {
    success
  }
}
    `;
export type PokeActionExecutionMutationFn = Apollo.MutationFunction<PokeActionExecutionMutation, PokeActionExecutionMutationVariables>;

/**
 * __usePokeActionExecutionMutation__
 *
 * To run a mutation, you first call `usePokeActionExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePokeActionExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pokeActionExecutionMutation, { data, loading, error }] = usePokeActionExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePokeActionExecutionMutation(baseOptions?: Apollo.MutationHookOptions<PokeActionExecutionMutation, PokeActionExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PokeActionExecutionMutation, PokeActionExecutionMutationVariables>(PokeActionExecutionDocument, options);
      }
export type PokeActionExecutionMutationHookResult = ReturnType<typeof usePokeActionExecutionMutation>;
export type PokeActionExecutionMutationResult = Apollo.MutationResult<PokeActionExecutionMutation>;
export type PokeActionExecutionMutationOptions = Apollo.BaseMutationOptions<PokeActionExecutionMutation, PokeActionExecutionMutationVariables>;
export const ProvisionFakeTrackMovementDocument = gql`
    mutation ProvisionFakeTrackMovement($input: CreateFakeTrackMovementInput!) {
  provisionFakeTrackMovement(input: $input) {
    success
    shipmentId
  }
}
    `;
export type ProvisionFakeTrackMovementMutationFn = Apollo.MutationFunction<ProvisionFakeTrackMovementMutation, ProvisionFakeTrackMovementMutationVariables>;

/**
 * __useProvisionFakeTrackMovementMutation__
 *
 * To run a mutation, you first call `useProvisionFakeTrackMovementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionFakeTrackMovementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionFakeTrackMovementMutation, { data, loading, error }] = useProvisionFakeTrackMovementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionFakeTrackMovementMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionFakeTrackMovementMutation, ProvisionFakeTrackMovementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionFakeTrackMovementMutation, ProvisionFakeTrackMovementMutationVariables>(ProvisionFakeTrackMovementDocument, options);
      }
export type ProvisionFakeTrackMovementMutationHookResult = ReturnType<typeof useProvisionFakeTrackMovementMutation>;
export type ProvisionFakeTrackMovementMutationResult = Apollo.MutationResult<ProvisionFakeTrackMovementMutation>;
export type ProvisionFakeTrackMovementMutationOptions = Apollo.BaseMutationOptions<ProvisionFakeTrackMovementMutation, ProvisionFakeTrackMovementMutationVariables>;
export const ProvisionBrowserUseDemoDocument = gql`
    mutation ProvisionBrowserUseDemo($input: ProvisionBrowserUseDemoInput!) {
  provisionBrowserUseDemo(input: $input) {
    organizationId
    actionDefinitionId
  }
}
    `;
export type ProvisionBrowserUseDemoMutationFn = Apollo.MutationFunction<ProvisionBrowserUseDemoMutation, ProvisionBrowserUseDemoMutationVariables>;

/**
 * __useProvisionBrowserUseDemoMutation__
 *
 * To run a mutation, you first call `useProvisionBrowserUseDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionBrowserUseDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionBrowserUseDemoMutation, { data, loading, error }] = useProvisionBrowserUseDemoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionBrowserUseDemoMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionBrowserUseDemoMutation, ProvisionBrowserUseDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionBrowserUseDemoMutation, ProvisionBrowserUseDemoMutationVariables>(ProvisionBrowserUseDemoDocument, options);
      }
export type ProvisionBrowserUseDemoMutationHookResult = ReturnType<typeof useProvisionBrowserUseDemoMutation>;
export type ProvisionBrowserUseDemoMutationResult = Apollo.MutationResult<ProvisionBrowserUseDemoMutation>;
export type ProvisionBrowserUseDemoMutationOptions = Apollo.BaseMutationOptions<ProvisionBrowserUseDemoMutation, ProvisionBrowserUseDemoMutationVariables>;
export const ProvisionConciergeSopDocument = gql`
    mutation ProvisionConciergeSOP($input: ProvisionConciergeSOPInput!) {
  provisionConciergeSOP(input: $input) {
    organizationId
    success
  }
}
    `;
export type ProvisionConciergeSopMutationFn = Apollo.MutationFunction<ProvisionConciergeSopMutation, ProvisionConciergeSopMutationVariables>;

/**
 * __useProvisionConciergeSopMutation__
 *
 * To run a mutation, you first call `useProvisionConciergeSopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionConciergeSopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionConciergeSopMutation, { data, loading, error }] = useProvisionConciergeSopMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionConciergeSopMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionConciergeSopMutation, ProvisionConciergeSopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionConciergeSopMutation, ProvisionConciergeSopMutationVariables>(ProvisionConciergeSopDocument, options);
      }
export type ProvisionConciergeSopMutationHookResult = ReturnType<typeof useProvisionConciergeSopMutation>;
export type ProvisionConciergeSopMutationResult = Apollo.MutationResult<ProvisionConciergeSopMutation>;
export type ProvisionConciergeSopMutationOptions = Apollo.BaseMutationOptions<ProvisionConciergeSopMutation, ProvisionConciergeSopMutationVariables>;
export const ProvisionCoverForTeamDocument = gql`
    mutation ProvisionCoverForTeam($input: ProvisionCoverForTeamInput!) {
  provisionCoverForTeam(input: $input) {
    teamId
    phoneNumber
  }
}
    `;
export type ProvisionCoverForTeamMutationFn = Apollo.MutationFunction<ProvisionCoverForTeamMutation, ProvisionCoverForTeamMutationVariables>;

/**
 * __useProvisionCoverForTeamMutation__
 *
 * To run a mutation, you first call `useProvisionCoverForTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionCoverForTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionCoverForTeamMutation, { data, loading, error }] = useProvisionCoverForTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionCoverForTeamMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionCoverForTeamMutation, ProvisionCoverForTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionCoverForTeamMutation, ProvisionCoverForTeamMutationVariables>(ProvisionCoverForTeamDocument, options);
      }
export type ProvisionCoverForTeamMutationHookResult = ReturnType<typeof useProvisionCoverForTeamMutation>;
export type ProvisionCoverForTeamMutationResult = Apollo.MutationResult<ProvisionCoverForTeamMutation>;
export type ProvisionCoverForTeamMutationOptions = Apollo.BaseMutationOptions<ProvisionCoverForTeamMutation, ProvisionCoverForTeamMutationVariables>;
export const ProvisionCoverSimulationsDocument = gql`
    mutation ProvisionCoverSimulations($input: ProvisionCoverSimulationsInput!) {
  provisionCoverSimulations(input: $input) {
    success
  }
}
    `;
export type ProvisionCoverSimulationsMutationFn = Apollo.MutationFunction<ProvisionCoverSimulationsMutation, ProvisionCoverSimulationsMutationVariables>;

/**
 * __useProvisionCoverSimulationsMutation__
 *
 * To run a mutation, you first call `useProvisionCoverSimulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionCoverSimulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionCoverSimulationsMutation, { data, loading, error }] = useProvisionCoverSimulationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionCoverSimulationsMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionCoverSimulationsMutation, ProvisionCoverSimulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionCoverSimulationsMutation, ProvisionCoverSimulationsMutationVariables>(ProvisionCoverSimulationsDocument, options);
      }
export type ProvisionCoverSimulationsMutationHookResult = ReturnType<typeof useProvisionCoverSimulationsMutation>;
export type ProvisionCoverSimulationsMutationResult = Apollo.MutationResult<ProvisionCoverSimulationsMutation>;
export type ProvisionCoverSimulationsMutationOptions = Apollo.BaseMutationOptions<ProvisionCoverSimulationsMutation, ProvisionCoverSimulationsMutationVariables>;
export const ProvisionInterviewDocument = gql`
    mutation ProvisionInterview($input: ProvisionInterviewInput!) {
  provisionInterview(input: $input) {
    organizationId
    actionDefinitionId
  }
}
    `;
export type ProvisionInterviewMutationFn = Apollo.MutationFunction<ProvisionInterviewMutation, ProvisionInterviewMutationVariables>;

/**
 * __useProvisionInterviewMutation__
 *
 * To run a mutation, you first call `useProvisionInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionInterviewMutation, { data, loading, error }] = useProvisionInterviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionInterviewMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionInterviewMutation, ProvisionInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionInterviewMutation, ProvisionInterviewMutationVariables>(ProvisionInterviewDocument, options);
      }
export type ProvisionInterviewMutationHookResult = ReturnType<typeof useProvisionInterviewMutation>;
export type ProvisionInterviewMutationResult = Apollo.MutationResult<ProvisionInterviewMutation>;
export type ProvisionInterviewMutationOptions = Apollo.BaseMutationOptions<ProvisionInterviewMutation, ProvisionInterviewMutationVariables>;
export const ProvisionLabelingConciergeDocument = gql`
    mutation ProvisionLabelingConcierge($input: ProvisionLabelingConciergeInput!) {
  provisionLabelingConcierge(input: $input) {
    organizationId
    success
  }
}
    `;
export type ProvisionLabelingConciergeMutationFn = Apollo.MutationFunction<ProvisionLabelingConciergeMutation, ProvisionLabelingConciergeMutationVariables>;

/**
 * __useProvisionLabelingConciergeMutation__
 *
 * To run a mutation, you first call `useProvisionLabelingConciergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionLabelingConciergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionLabelingConciergeMutation, { data, loading, error }] = useProvisionLabelingConciergeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionLabelingConciergeMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionLabelingConciergeMutation, ProvisionLabelingConciergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionLabelingConciergeMutation, ProvisionLabelingConciergeMutationVariables>(ProvisionLabelingConciergeDocument, options);
      }
export type ProvisionLabelingConciergeMutationHookResult = ReturnType<typeof useProvisionLabelingConciergeMutation>;
export type ProvisionLabelingConciergeMutationResult = Apollo.MutationResult<ProvisionLabelingConciergeMutation>;
export type ProvisionLabelingConciergeMutationOptions = Apollo.BaseMutationOptions<ProvisionLabelingConciergeMutation, ProvisionLabelingConciergeMutationVariables>;
export const ProvisionQuoteForOrgDocument = gql`
    mutation ProvisionQuoteForOrg($input: ProvisionQuoteForOrgInput!) {
  provisionQuoteForOrg(input: $input) {
    organizationId
  }
}
    `;
export type ProvisionQuoteForOrgMutationFn = Apollo.MutationFunction<ProvisionQuoteForOrgMutation, ProvisionQuoteForOrgMutationVariables>;

/**
 * __useProvisionQuoteForOrgMutation__
 *
 * To run a mutation, you first call `useProvisionQuoteForOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionQuoteForOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionQuoteForOrgMutation, { data, loading, error }] = useProvisionQuoteForOrgMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionQuoteForOrgMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionQuoteForOrgMutation, ProvisionQuoteForOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionQuoteForOrgMutation, ProvisionQuoteForOrgMutationVariables>(ProvisionQuoteForOrgDocument, options);
      }
export type ProvisionQuoteForOrgMutationHookResult = ReturnType<typeof useProvisionQuoteForOrgMutation>;
export type ProvisionQuoteForOrgMutationResult = Apollo.MutationResult<ProvisionQuoteForOrgMutation>;
export type ProvisionQuoteForOrgMutationOptions = Apollo.BaseMutationOptions<ProvisionQuoteForOrgMutation, ProvisionQuoteForOrgMutationVariables>;
export const ProvisionQuoteForTeamDocument = gql`
    mutation ProvisionQuoteForTeam($input: ProvisionQuoteForTeamInput!) {
  provisionQuoteForTeam(input: $input) {
    teamId
    actionDefinitionId
  }
}
    `;
export type ProvisionQuoteForTeamMutationFn = Apollo.MutationFunction<ProvisionQuoteForTeamMutation, ProvisionQuoteForTeamMutationVariables>;

/**
 * __useProvisionQuoteForTeamMutation__
 *
 * To run a mutation, you first call `useProvisionQuoteForTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionQuoteForTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionQuoteForTeamMutation, { data, loading, error }] = useProvisionQuoteForTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionQuoteForTeamMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionQuoteForTeamMutation, ProvisionQuoteForTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionQuoteForTeamMutation, ProvisionQuoteForTeamMutationVariables>(ProvisionQuoteForTeamDocument, options);
      }
export type ProvisionQuoteForTeamMutationHookResult = ReturnType<typeof useProvisionQuoteForTeamMutation>;
export type ProvisionQuoteForTeamMutationResult = Apollo.MutationResult<ProvisionQuoteForTeamMutation>;
export type ProvisionQuoteForTeamMutationOptions = Apollo.BaseMutationOptions<ProvisionQuoteForTeamMutation, ProvisionQuoteForTeamMutationVariables>;
export const ProvisionQuoteOriginatorsDocument = gql`
    mutation ProvisionQuoteOriginators($input: ProvisionQuoteOriginatorsInput!) {
  provisionQuoteOriginators(input: $input) {
    success
  }
}
    `;
export type ProvisionQuoteOriginatorsMutationFn = Apollo.MutationFunction<ProvisionQuoteOriginatorsMutation, ProvisionQuoteOriginatorsMutationVariables>;

/**
 * __useProvisionQuoteOriginatorsMutation__
 *
 * To run a mutation, you first call `useProvisionQuoteOriginatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionQuoteOriginatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionQuoteOriginatorsMutation, { data, loading, error }] = useProvisionQuoteOriginatorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionQuoteOriginatorsMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionQuoteOriginatorsMutation, ProvisionQuoteOriginatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionQuoteOriginatorsMutation, ProvisionQuoteOriginatorsMutationVariables>(ProvisionQuoteOriginatorsDocument, options);
      }
export type ProvisionQuoteOriginatorsMutationHookResult = ReturnType<typeof useProvisionQuoteOriginatorsMutation>;
export type ProvisionQuoteOriginatorsMutationResult = Apollo.MutationResult<ProvisionQuoteOriginatorsMutation>;
export type ProvisionQuoteOriginatorsMutationOptions = Apollo.BaseMutationOptions<ProvisionQuoteOriginatorsMutation, ProvisionQuoteOriginatorsMutationVariables>;
export const ProvisionQuoteSimulationsDocument = gql`
    mutation ProvisionQuoteSimulations($input: ProvisionQuoteSimulationsInput!) {
  provisionQuoteSimulations(input: $input) {
    success
  }
}
    `;
export type ProvisionQuoteSimulationsMutationFn = Apollo.MutationFunction<ProvisionQuoteSimulationsMutation, ProvisionQuoteSimulationsMutationVariables>;

/**
 * __useProvisionQuoteSimulationsMutation__
 *
 * To run a mutation, you first call `useProvisionQuoteSimulationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionQuoteSimulationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionQuoteSimulationsMutation, { data, loading, error }] = useProvisionQuoteSimulationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionQuoteSimulationsMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionQuoteSimulationsMutation, ProvisionQuoteSimulationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionQuoteSimulationsMutation, ProvisionQuoteSimulationsMutationVariables>(ProvisionQuoteSimulationsDocument, options);
      }
export type ProvisionQuoteSimulationsMutationHookResult = ReturnType<typeof useProvisionQuoteSimulationsMutation>;
export type ProvisionQuoteSimulationsMutationResult = Apollo.MutationResult<ProvisionQuoteSimulationsMutation>;
export type ProvisionQuoteSimulationsMutationOptions = Apollo.BaseMutationOptions<ProvisionQuoteSimulationsMutation, ProvisionQuoteSimulationsMutationVariables>;
export const ProvisionRunnersDocument = gql`
    mutation ProvisionRunners($input: ProvisionRunnersInput!) {
  provisionRunners(input: $input) {
    created {
      id
      name
      isDeleted
    }
    existing {
      id
      name
      isDeleted
    }
  }
}
    `;
export type ProvisionRunnersMutationFn = Apollo.MutationFunction<ProvisionRunnersMutation, ProvisionRunnersMutationVariables>;

/**
 * __useProvisionRunnersMutation__
 *
 * To run a mutation, you first call `useProvisionRunnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionRunnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionRunnersMutation, { data, loading, error }] = useProvisionRunnersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionRunnersMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionRunnersMutation, ProvisionRunnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionRunnersMutation, ProvisionRunnersMutationVariables>(ProvisionRunnersDocument, options);
      }
export type ProvisionRunnersMutationHookResult = ReturnType<typeof useProvisionRunnersMutation>;
export type ProvisionRunnersMutationResult = Apollo.MutationResult<ProvisionRunnersMutation>;
export type ProvisionRunnersMutationOptions = Apollo.BaseMutationOptions<ProvisionRunnersMutation, ProvisionRunnersMutationVariables>;
export const ProvisionScheduleDocument = gql`
    mutation ProvisionSchedule($input: ProvisionScheduleInput!) {
  provisionSchedule(input: $input) {
    success
  }
}
    `;
export type ProvisionScheduleMutationFn = Apollo.MutationFunction<ProvisionScheduleMutation, ProvisionScheduleMutationVariables>;

/**
 * __useProvisionScheduleMutation__
 *
 * To run a mutation, you first call `useProvisionScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionScheduleMutation, { data, loading, error }] = useProvisionScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionScheduleMutation, ProvisionScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionScheduleMutation, ProvisionScheduleMutationVariables>(ProvisionScheduleDocument, options);
      }
export type ProvisionScheduleMutationHookResult = ReturnType<typeof useProvisionScheduleMutation>;
export type ProvisionScheduleMutationResult = Apollo.MutationResult<ProvisionScheduleMutation>;
export type ProvisionScheduleMutationOptions = Apollo.BaseMutationOptions<ProvisionScheduleMutation, ProvisionScheduleMutationVariables>;
export const ProvisionTrackDocument = gql`
    mutation ProvisionTrack($input: ProvisionTrackInput!) {
  provisionTrack(input: $input) {
    success
    phoneNumber
  }
}
    `;
export type ProvisionTrackMutationFn = Apollo.MutationFunction<ProvisionTrackMutation, ProvisionTrackMutationVariables>;

/**
 * __useProvisionTrackMutation__
 *
 * To run a mutation, you first call `useProvisionTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionTrackMutation, { data, loading, error }] = useProvisionTrackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionTrackMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionTrackMutation, ProvisionTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionTrackMutation, ProvisionTrackMutationVariables>(ProvisionTrackDocument, options);
      }
export type ProvisionTrackMutationHookResult = ReturnType<typeof useProvisionTrackMutation>;
export type ProvisionTrackMutationResult = Apollo.MutationResult<ProvisionTrackMutation>;
export type ProvisionTrackMutationOptions = Apollo.BaseMutationOptions<ProvisionTrackMutation, ProvisionTrackMutationVariables>;
export const ProvisionVeeDocument = gql`
    mutation ProvisionVee($input: ProvisionVeeInput!) {
  provisionVee(input: $input) {
    organizationId
    actionDefinitionId
  }
}
    `;
export type ProvisionVeeMutationFn = Apollo.MutationFunction<ProvisionVeeMutation, ProvisionVeeMutationVariables>;

/**
 * __useProvisionVeeMutation__
 *
 * To run a mutation, you first call `useProvisionVeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionVeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionVeeMutation, { data, loading, error }] = useProvisionVeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionVeeMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionVeeMutation, ProvisionVeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionVeeMutation, ProvisionVeeMutationVariables>(ProvisionVeeDocument, options);
      }
export type ProvisionVeeMutationHookResult = ReturnType<typeof useProvisionVeeMutation>;
export type ProvisionVeeMutationResult = Apollo.MutationResult<ProvisionVeeMutation>;
export type ProvisionVeeMutationOptions = Apollo.BaseMutationOptions<ProvisionVeeMutation, ProvisionVeeMutationVariables>;
export const ProvisionVoomaBuildAgentDocument = gql`
    mutation ProvisionVoomaBuildAgent($input: ProvisionVoomaBuildAgentInput!) {
  provisionVoomaBuildAgent(input: $input) {
    success
  }
}
    `;
export type ProvisionVoomaBuildAgentMutationFn = Apollo.MutationFunction<ProvisionVoomaBuildAgentMutation, ProvisionVoomaBuildAgentMutationVariables>;

/**
 * __useProvisionVoomaBuildAgentMutation__
 *
 * To run a mutation, you first call `useProvisionVoomaBuildAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionVoomaBuildAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionVoomaBuildAgentMutation, { data, loading, error }] = useProvisionVoomaBuildAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProvisionVoomaBuildAgentMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionVoomaBuildAgentMutation, ProvisionVoomaBuildAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionVoomaBuildAgentMutation, ProvisionVoomaBuildAgentMutationVariables>(ProvisionVoomaBuildAgentDocument, options);
      }
export type ProvisionVoomaBuildAgentMutationHookResult = ReturnType<typeof useProvisionVoomaBuildAgentMutation>;
export type ProvisionVoomaBuildAgentMutationResult = Apollo.MutationResult<ProvisionVoomaBuildAgentMutation>;
export type ProvisionVoomaBuildAgentMutationOptions = Apollo.BaseMutationOptions<ProvisionVoomaBuildAgentMutation, ProvisionVoomaBuildAgentMutationVariables>;
export const SeedCoverDemoDataDocument = gql`
    mutation SeedCoverDemoData($input: SeedCoverDemoDataInput!) {
  seedCoverDemoData(input: $input) {
    success
    shipmentsCreated
    shipmentsUpdated
    carrierOffersSeeded
    coveragePlansSeeded
    actionExecutionsSeeded
  }
}
    `;
export type SeedCoverDemoDataMutationFn = Apollo.MutationFunction<SeedCoverDemoDataMutation, SeedCoverDemoDataMutationVariables>;

/**
 * __useSeedCoverDemoDataMutation__
 *
 * To run a mutation, you first call `useSeedCoverDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedCoverDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedCoverDemoDataMutation, { data, loading, error }] = useSeedCoverDemoDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSeedCoverDemoDataMutation(baseOptions?: Apollo.MutationHookOptions<SeedCoverDemoDataMutation, SeedCoverDemoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedCoverDemoDataMutation, SeedCoverDemoDataMutationVariables>(SeedCoverDemoDataDocument, options);
      }
export type SeedCoverDemoDataMutationHookResult = ReturnType<typeof useSeedCoverDemoDataMutation>;
export type SeedCoverDemoDataMutationResult = Apollo.MutationResult<SeedCoverDemoDataMutation>;
export type SeedCoverDemoDataMutationOptions = Apollo.BaseMutationOptions<SeedCoverDemoDataMutation, SeedCoverDemoDataMutationVariables>;
export const SeedVeeDemoDataDocument = gql`
    mutation SeedVeeDemoData($input: SeedVeeDemoDataInput!) {
  seedVeeDemoData(input: $input) {
    success
  }
}
    `;
export type SeedVeeDemoDataMutationFn = Apollo.MutationFunction<SeedVeeDemoDataMutation, SeedVeeDemoDataMutationVariables>;

/**
 * __useSeedVeeDemoDataMutation__
 *
 * To run a mutation, you first call `useSeedVeeDemoDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedVeeDemoDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedVeeDemoDataMutation, { data, loading, error }] = useSeedVeeDemoDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSeedVeeDemoDataMutation(baseOptions?: Apollo.MutationHookOptions<SeedVeeDemoDataMutation, SeedVeeDemoDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SeedVeeDemoDataMutation, SeedVeeDemoDataMutationVariables>(SeedVeeDemoDataDocument, options);
      }
export type SeedVeeDemoDataMutationHookResult = ReturnType<typeof useSeedVeeDemoDataMutation>;
export type SeedVeeDemoDataMutationResult = Apollo.MutationResult<SeedVeeDemoDataMutation>;
export type SeedVeeDemoDataMutationOptions = Apollo.BaseMutationOptions<SeedVeeDemoDataMutation, SeedVeeDemoDataMutationVariables>;
export const FindDuplicateDocument = gql`
    mutation FindDuplicate($input: FindDuplicateInput!) {
  findDuplicate(input: $input) {
    success
    canonicalId
  }
}
    `;
export type FindDuplicateMutationFn = Apollo.MutationFunction<FindDuplicateMutation, FindDuplicateMutationVariables>;

/**
 * __useFindDuplicateMutation__
 *
 * To run a mutation, you first call `useFindDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findDuplicateMutation, { data, loading, error }] = useFindDuplicateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<FindDuplicateMutation, FindDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindDuplicateMutation, FindDuplicateMutationVariables>(FindDuplicateDocument, options);
      }
export type FindDuplicateMutationHookResult = ReturnType<typeof useFindDuplicateMutation>;
export type FindDuplicateMutationResult = Apollo.MutationResult<FindDuplicateMutation>;
export type FindDuplicateMutationOptions = Apollo.BaseMutationOptions<FindDuplicateMutation, FindDuplicateMutationVariables>;
export const CreateScheduleSettingsDocument = gql`
    mutation CreateScheduleSettings($input: CreateScheduleSettingsInput!) {
  createScheduleSettings(input: $input) {
    id
    organizationId
    name
    isActive
    plannerActionDefinitionId
    planningSettings {
      __typename
      ... on AgenticPlannerSettings {
        type
      }
      ... on DeterministicPlanningSettings {
        type
        sequencing
      }
    }
    createdAt
    updatedAt
  }
}
    `;
export type CreateScheduleSettingsMutationFn = Apollo.MutationFunction<CreateScheduleSettingsMutation, CreateScheduleSettingsMutationVariables>;

/**
 * __useCreateScheduleSettingsMutation__
 *
 * To run a mutation, you first call `useCreateScheduleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleSettingsMutation, { data, loading, error }] = useCreateScheduleSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleSettingsMutation, CreateScheduleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleSettingsMutation, CreateScheduleSettingsMutationVariables>(CreateScheduleSettingsDocument, options);
      }
export type CreateScheduleSettingsMutationHookResult = ReturnType<typeof useCreateScheduleSettingsMutation>;
export type CreateScheduleSettingsMutationResult = Apollo.MutationResult<CreateScheduleSettingsMutation>;
export type CreateScheduleSettingsMutationOptions = Apollo.BaseMutationOptions<CreateScheduleSettingsMutation, CreateScheduleSettingsMutationVariables>;
export const DeleteScheduleSettingsDocument = gql`
    mutation DeleteScheduleSettings($id: ID!) {
  deleteScheduleSettings(id: $id)
}
    `;
export type DeleteScheduleSettingsMutationFn = Apollo.MutationFunction<DeleteScheduleSettingsMutation, DeleteScheduleSettingsMutationVariables>;

/**
 * __useDeleteScheduleSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleSettingsMutation, { data, loading, error }] = useDeleteScheduleSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleSettingsMutation, DeleteScheduleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleSettingsMutation, DeleteScheduleSettingsMutationVariables>(DeleteScheduleSettingsDocument, options);
      }
export type DeleteScheduleSettingsMutationHookResult = ReturnType<typeof useDeleteScheduleSettingsMutation>;
export type DeleteScheduleSettingsMutationResult = Apollo.MutationResult<DeleteScheduleSettingsMutation>;
export type DeleteScheduleSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleSettingsMutation, DeleteScheduleSettingsMutationVariables>;
export const UpdateScheduleSettingsDocument = gql`
    mutation UpdateScheduleSettings($input: UpdateScheduleSettingsInput!) {
  updateScheduleSettings(input: $input) {
    id
    organizationId
    name
    isActive
    plannerActionDefinitionId
    planningSettings {
      __typename
      ... on AgenticPlannerSettings {
        type
      }
      ... on DeterministicPlanningSettings {
        type
        sequencing
      }
    }
    createdAt
    updatedAt
  }
}
    `;
export type UpdateScheduleSettingsMutationFn = Apollo.MutationFunction<UpdateScheduleSettingsMutation, UpdateScheduleSettingsMutationVariables>;

/**
 * __useUpdateScheduleSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleSettingsMutation, { data, loading, error }] = useUpdateScheduleSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleSettingsMutation, UpdateScheduleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleSettingsMutation, UpdateScheduleSettingsMutationVariables>(UpdateScheduleSettingsDocument, options);
      }
export type UpdateScheduleSettingsMutationHookResult = ReturnType<typeof useUpdateScheduleSettingsMutation>;
export type UpdateScheduleSettingsMutationResult = Apollo.MutationResult<UpdateScheduleSettingsMutation>;
export type UpdateScheduleSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleSettingsMutation, UpdateScheduleSettingsMutationVariables>;
export const ApproveSchedulePlanDocument = gql`
    mutation ApproveSchedulePlan($schedulePlanId: ID!) {
  approveSchedulePlan(schedulePlanId: $schedulePlanId) {
    id
    status
  }
}
    `;
export type ApproveSchedulePlanMutationFn = Apollo.MutationFunction<ApproveSchedulePlanMutation, ApproveSchedulePlanMutationVariables>;

/**
 * __useApproveSchedulePlanMutation__
 *
 * To run a mutation, you first call `useApproveSchedulePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSchedulePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSchedulePlanMutation, { data, loading, error }] = useApproveSchedulePlanMutation({
 *   variables: {
 *      schedulePlanId: // value for 'schedulePlanId'
 *   },
 * });
 */
export function useApproveSchedulePlanMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSchedulePlanMutation, ApproveSchedulePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSchedulePlanMutation, ApproveSchedulePlanMutationVariables>(ApproveSchedulePlanDocument, options);
      }
export type ApproveSchedulePlanMutationHookResult = ReturnType<typeof useApproveSchedulePlanMutation>;
export type ApproveSchedulePlanMutationResult = Apollo.MutationResult<ApproveSchedulePlanMutation>;
export type ApproveSchedulePlanMutationOptions = Apollo.BaseMutationOptions<ApproveSchedulePlanMutation, ApproveSchedulePlanMutationVariables>;
export const CancelSchedulePlanDocument = gql`
    mutation CancelSchedulePlan($schedulePlanId: ID!) {
  cancelSchedulePlan(schedulePlanId: $schedulePlanId) {
    id
    status
  }
}
    `;
export type CancelSchedulePlanMutationFn = Apollo.MutationFunction<CancelSchedulePlanMutation, CancelSchedulePlanMutationVariables>;

/**
 * __useCancelSchedulePlanMutation__
 *
 * To run a mutation, you first call `useCancelSchedulePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSchedulePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSchedulePlanMutation, { data, loading, error }] = useCancelSchedulePlanMutation({
 *   variables: {
 *      schedulePlanId: // value for 'schedulePlanId'
 *   },
 * });
 */
export function useCancelSchedulePlanMutation(baseOptions?: Apollo.MutationHookOptions<CancelSchedulePlanMutation, CancelSchedulePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSchedulePlanMutation, CancelSchedulePlanMutationVariables>(CancelSchedulePlanDocument, options);
      }
export type CancelSchedulePlanMutationHookResult = ReturnType<typeof useCancelSchedulePlanMutation>;
export type CancelSchedulePlanMutationResult = Apollo.MutationResult<CancelSchedulePlanMutation>;
export type CancelSchedulePlanMutationOptions = Apollo.BaseMutationOptions<CancelSchedulePlanMutation, CancelSchedulePlanMutationVariables>;
export const GenerateSchedulePlanDocument = gql`
    mutation GenerateSchedulePlan($movementId: ID!) {
  generateSchedulePlan(movementId: $movementId) {
    id
    status
    plan
    planningActionExecution {
      id
      status
    }
  }
}
    `;
export type GenerateSchedulePlanMutationFn = Apollo.MutationFunction<GenerateSchedulePlanMutation, GenerateSchedulePlanMutationVariables>;

/**
 * __useGenerateSchedulePlanMutation__
 *
 * To run a mutation, you first call `useGenerateSchedulePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSchedulePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSchedulePlanMutation, { data, loading, error }] = useGenerateSchedulePlanMutation({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGenerateSchedulePlanMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSchedulePlanMutation, GenerateSchedulePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSchedulePlanMutation, GenerateSchedulePlanMutationVariables>(GenerateSchedulePlanDocument, options);
      }
export type GenerateSchedulePlanMutationHookResult = ReturnType<typeof useGenerateSchedulePlanMutation>;
export type GenerateSchedulePlanMutationResult = Apollo.MutationResult<GenerateSchedulePlanMutation>;
export type GenerateSchedulePlanMutationOptions = Apollo.BaseMutationOptions<GenerateSchedulePlanMutation, GenerateSchedulePlanMutationVariables>;
export const SendTestNotificationDocument = gql`
    mutation sendTestNotification($input: SendTestNotificationInput!) {
  sendTestNotification(input: $input)
}
    `;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = Apollo.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const UpdateNotificationSettingsDocument = gql`
    mutation UpdateNotificationSettings($input: UpdateNotificationSettingsInput!) {
  updateNotificationSettings(input: $input) {
    success
  }
}
    `;
export type UpdateNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;

/**
 * __useUpdateNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsMutation, { data, loading, error }] = useUpdateNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>(UpdateNotificationSettingsDocument, options);
      }
export type UpdateNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationResult = Apollo.MutationResult<UpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const CreateSharedFileDocument = gql`
    mutation CreateSharedFile($input: CreateSharedFileInput!) {
  createSharedFile(input: $input) {
    success
    message
    sharedFile {
      ...SharedFileSummary
    }
  }
}
    ${SharedFileSummaryFragmentDoc}`;
export type CreateSharedFileMutationFn = Apollo.MutationFunction<CreateSharedFileMutation, CreateSharedFileMutationVariables>;

/**
 * __useCreateSharedFileMutation__
 *
 * To run a mutation, you first call `useCreateSharedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedFileMutation, { data, loading, error }] = useCreateSharedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSharedFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateSharedFileMutation, CreateSharedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSharedFileMutation, CreateSharedFileMutationVariables>(CreateSharedFileDocument, options);
      }
export type CreateSharedFileMutationHookResult = ReturnType<typeof useCreateSharedFileMutation>;
export type CreateSharedFileMutationResult = Apollo.MutationResult<CreateSharedFileMutation>;
export type CreateSharedFileMutationOptions = Apollo.BaseMutationOptions<CreateSharedFileMutation, CreateSharedFileMutationVariables>;
export const DeleteSharedFileDocument = gql`
    mutation DeleteSharedFile($input: DeleteSharedFileInput!) {
  deleteSharedFile(input: $input) {
    success
    message
    sharedFile {
      ...SharedFileSummary
    }
  }
}
    ${SharedFileSummaryFragmentDoc}`;
export type DeleteSharedFileMutationFn = Apollo.MutationFunction<DeleteSharedFileMutation, DeleteSharedFileMutationVariables>;

/**
 * __useDeleteSharedFileMutation__
 *
 * To run a mutation, you first call `useDeleteSharedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharedFileMutation, { data, loading, error }] = useDeleteSharedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSharedFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSharedFileMutation, DeleteSharedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSharedFileMutation, DeleteSharedFileMutationVariables>(DeleteSharedFileDocument, options);
      }
export type DeleteSharedFileMutationHookResult = ReturnType<typeof useDeleteSharedFileMutation>;
export type DeleteSharedFileMutationResult = Apollo.MutationResult<DeleteSharedFileMutation>;
export type DeleteSharedFileMutationOptions = Apollo.BaseMutationOptions<DeleteSharedFileMutation, DeleteSharedFileMutationVariables>;
export const RenameSharedFileDocument = gql`
    mutation RenameSharedFile($input: RenameSharedFileInput!) {
  renameSharedFile(input: $input) {
    success
    message
    sharedFile {
      ...SharedFileSummary
    }
  }
}
    ${SharedFileSummaryFragmentDoc}`;
export type RenameSharedFileMutationFn = Apollo.MutationFunction<RenameSharedFileMutation, RenameSharedFileMutationVariables>;

/**
 * __useRenameSharedFileMutation__
 *
 * To run a mutation, you first call `useRenameSharedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameSharedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameSharedFileMutation, { data, loading, error }] = useRenameSharedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameSharedFileMutation(baseOptions?: Apollo.MutationHookOptions<RenameSharedFileMutation, RenameSharedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameSharedFileMutation, RenameSharedFileMutationVariables>(RenameSharedFileDocument, options);
      }
export type RenameSharedFileMutationHookResult = ReturnType<typeof useRenameSharedFileMutation>;
export type RenameSharedFileMutationResult = Apollo.MutationResult<RenameSharedFileMutation>;
export type RenameSharedFileMutationOptions = Apollo.BaseMutationOptions<RenameSharedFileMutation, RenameSharedFileMutationVariables>;
export const UpdateSharedFileDocument = gql`
    mutation UpdateSharedFile($input: UpdateSharedFileInput!) {
  updateSharedFile(input: $input) {
    success
    message
    sharedFile {
      ...SharedFileSummary
    }
  }
}
    ${SharedFileSummaryFragmentDoc}`;
export type UpdateSharedFileMutationFn = Apollo.MutationFunction<UpdateSharedFileMutation, UpdateSharedFileMutationVariables>;

/**
 * __useUpdateSharedFileMutation__
 *
 * To run a mutation, you first call `useUpdateSharedFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedFileMutation, { data, loading, error }] = useUpdateSharedFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSharedFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSharedFileMutation, UpdateSharedFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSharedFileMutation, UpdateSharedFileMutationVariables>(UpdateSharedFileDocument, options);
      }
export type UpdateSharedFileMutationHookResult = ReturnType<typeof useUpdateSharedFileMutation>;
export type UpdateSharedFileMutationResult = Apollo.MutationResult<UpdateSharedFileMutation>;
export type UpdateSharedFileMutationOptions = Apollo.BaseMutationOptions<UpdateSharedFileMutation, UpdateSharedFileMutationVariables>;
export const GenerateShipmentLifecycleSimShipmentDocument = gql`
    mutation GenerateShipmentLifecycleSimShipment($input: GenerateShipmentLifecycleSimShipmentInput!) {
  generateShipmentLifecycleSimShipment(input: $input) {
    requestQuoteActionExecutionId
    shipment
    success
  }
}
    `;
export type GenerateShipmentLifecycleSimShipmentMutationFn = Apollo.MutationFunction<GenerateShipmentLifecycleSimShipmentMutation, GenerateShipmentLifecycleSimShipmentMutationVariables>;

/**
 * __useGenerateShipmentLifecycleSimShipmentMutation__
 *
 * To run a mutation, you first call `useGenerateShipmentLifecycleSimShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateShipmentLifecycleSimShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateShipmentLifecycleSimShipmentMutation, { data, loading, error }] = useGenerateShipmentLifecycleSimShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateShipmentLifecycleSimShipmentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateShipmentLifecycleSimShipmentMutation, GenerateShipmentLifecycleSimShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateShipmentLifecycleSimShipmentMutation, GenerateShipmentLifecycleSimShipmentMutationVariables>(GenerateShipmentLifecycleSimShipmentDocument, options);
      }
export type GenerateShipmentLifecycleSimShipmentMutationHookResult = ReturnType<typeof useGenerateShipmentLifecycleSimShipmentMutation>;
export type GenerateShipmentLifecycleSimShipmentMutationResult = Apollo.MutationResult<GenerateShipmentLifecycleSimShipmentMutation>;
export type GenerateShipmentLifecycleSimShipmentMutationOptions = Apollo.BaseMutationOptions<GenerateShipmentLifecycleSimShipmentMutation, GenerateShipmentLifecycleSimShipmentMutationVariables>;
export const BuildShipmentDocument = gql`
    mutation BuildShipment($input: BuildShipmentInput!) {
  buildShipment(input: $input) {
    shipmentId
  }
}
    `;
export type BuildShipmentMutationFn = Apollo.MutationFunction<BuildShipmentMutation, BuildShipmentMutationVariables>;

/**
 * __useBuildShipmentMutation__
 *
 * To run a mutation, you first call `useBuildShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildShipmentMutation, { data, loading, error }] = useBuildShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildShipmentMutation(baseOptions?: Apollo.MutationHookOptions<BuildShipmentMutation, BuildShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildShipmentMutation, BuildShipmentMutationVariables>(BuildShipmentDocument, options);
      }
export type BuildShipmentMutationHookResult = ReturnType<typeof useBuildShipmentMutation>;
export type BuildShipmentMutationResult = Apollo.MutationResult<BuildShipmentMutation>;
export type BuildShipmentMutationOptions = Apollo.BaseMutationOptions<BuildShipmentMutation, BuildShipmentMutationVariables>;
export const EnsureShipmentExistsForQuoteDocument = gql`
    mutation EnsureShipmentExistsForQuote($input: EnsureShipmentExistsForQuoteInput!) {
  ensureShipmentExistsForQuote(input: $input) {
    shipment {
      ...Shipment
    }
  }
}
    ${ShipmentFragmentDoc}`;
export type EnsureShipmentExistsForQuoteMutationFn = Apollo.MutationFunction<EnsureShipmentExistsForQuoteMutation, EnsureShipmentExistsForQuoteMutationVariables>;

/**
 * __useEnsureShipmentExistsForQuoteMutation__
 *
 * To run a mutation, you first call `useEnsureShipmentExistsForQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureShipmentExistsForQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureShipmentExistsForQuoteMutation, { data, loading, error }] = useEnsureShipmentExistsForQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnsureShipmentExistsForQuoteMutation(baseOptions?: Apollo.MutationHookOptions<EnsureShipmentExistsForQuoteMutation, EnsureShipmentExistsForQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureShipmentExistsForQuoteMutation, EnsureShipmentExistsForQuoteMutationVariables>(EnsureShipmentExistsForQuoteDocument, options);
      }
export type EnsureShipmentExistsForQuoteMutationHookResult = ReturnType<typeof useEnsureShipmentExistsForQuoteMutation>;
export type EnsureShipmentExistsForQuoteMutationResult = Apollo.MutationResult<EnsureShipmentExistsForQuoteMutation>;
export type EnsureShipmentExistsForQuoteMutationOptions = Apollo.BaseMutationOptions<EnsureShipmentExistsForQuoteMutation, EnsureShipmentExistsForQuoteMutationVariables>;
export const MassDeleteShipmentsAndMovementsDocument = gql`
    mutation MassDeleteShipmentsAndMovements($input: MassDeleteShipmentsAndMovementsInput!) {
  massDeleteShipmentsAndMovements(input: $input) {
    success
  }
}
    `;
export type MassDeleteShipmentsAndMovementsMutationFn = Apollo.MutationFunction<MassDeleteShipmentsAndMovementsMutation, MassDeleteShipmentsAndMovementsMutationVariables>;

/**
 * __useMassDeleteShipmentsAndMovementsMutation__
 *
 * To run a mutation, you first call `useMassDeleteShipmentsAndMovementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassDeleteShipmentsAndMovementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massDeleteShipmentsAndMovementsMutation, { data, loading, error }] = useMassDeleteShipmentsAndMovementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassDeleteShipmentsAndMovementsMutation(baseOptions?: Apollo.MutationHookOptions<MassDeleteShipmentsAndMovementsMutation, MassDeleteShipmentsAndMovementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassDeleteShipmentsAndMovementsMutation, MassDeleteShipmentsAndMovementsMutationVariables>(MassDeleteShipmentsAndMovementsDocument, options);
      }
export type MassDeleteShipmentsAndMovementsMutationHookResult = ReturnType<typeof useMassDeleteShipmentsAndMovementsMutation>;
export type MassDeleteShipmentsAndMovementsMutationResult = Apollo.MutationResult<MassDeleteShipmentsAndMovementsMutation>;
export type MassDeleteShipmentsAndMovementsMutationOptions = Apollo.BaseMutationOptions<MassDeleteShipmentsAndMovementsMutation, MassDeleteShipmentsAndMovementsMutationVariables>;
export const MassPostToLoadBoardDocument = gql`
    mutation MassPostToLoadBoard($input: MassPostToLoadBoardInput!) {
  massPostToLoadBoard(input: $input) {
    results {
      success
      error
      externalIdMapping {
        id
        integrationType
        externalId
      }
    }
  }
}
    `;
export type MassPostToLoadBoardMutationFn = Apollo.MutationFunction<MassPostToLoadBoardMutation, MassPostToLoadBoardMutationVariables>;

/**
 * __useMassPostToLoadBoardMutation__
 *
 * To run a mutation, you first call `useMassPostToLoadBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassPostToLoadBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massPostToLoadBoardMutation, { data, loading, error }] = useMassPostToLoadBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassPostToLoadBoardMutation(baseOptions?: Apollo.MutationHookOptions<MassPostToLoadBoardMutation, MassPostToLoadBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassPostToLoadBoardMutation, MassPostToLoadBoardMutationVariables>(MassPostToLoadBoardDocument, options);
      }
export type MassPostToLoadBoardMutationHookResult = ReturnType<typeof useMassPostToLoadBoardMutation>;
export type MassPostToLoadBoardMutationResult = Apollo.MutationResult<MassPostToLoadBoardMutation>;
export type MassPostToLoadBoardMutationOptions = Apollo.BaseMutationOptions<MassPostToLoadBoardMutation, MassPostToLoadBoardMutationVariables>;
export const MassUnpostFromLoadBoardDocument = gql`
    mutation MassUnpostFromLoadBoard($input: MassUnpostFromLoadBoardInput!) {
  massUnpostFromLoadBoard(input: $input) {
    results {
      success
    }
  }
}
    `;
export type MassUnpostFromLoadBoardMutationFn = Apollo.MutationFunction<MassUnpostFromLoadBoardMutation, MassUnpostFromLoadBoardMutationVariables>;

/**
 * __useMassUnpostFromLoadBoardMutation__
 *
 * To run a mutation, you first call `useMassUnpostFromLoadBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassUnpostFromLoadBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massUnpostFromLoadBoardMutation, { data, loading, error }] = useMassUnpostFromLoadBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassUnpostFromLoadBoardMutation(baseOptions?: Apollo.MutationHookOptions<MassUnpostFromLoadBoardMutation, MassUnpostFromLoadBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassUnpostFromLoadBoardMutation, MassUnpostFromLoadBoardMutationVariables>(MassUnpostFromLoadBoardDocument, options);
      }
export type MassUnpostFromLoadBoardMutationHookResult = ReturnType<typeof useMassUnpostFromLoadBoardMutation>;
export type MassUnpostFromLoadBoardMutationResult = Apollo.MutationResult<MassUnpostFromLoadBoardMutation>;
export type MassUnpostFromLoadBoardMutationOptions = Apollo.BaseMutationOptions<MassUnpostFromLoadBoardMutation, MassUnpostFromLoadBoardMutationVariables>;
export const PostToLoadBoardDocument = gql`
    mutation PostToLoadBoard($input: PostToLoadBoardInput!) {
  postToLoadBoard(input: $input) {
    externalIdMapping {
      id
      integrationType
      externalId
    }
  }
}
    `;
export type PostToLoadBoardMutationFn = Apollo.MutationFunction<PostToLoadBoardMutation, PostToLoadBoardMutationVariables>;

/**
 * __usePostToLoadBoardMutation__
 *
 * To run a mutation, you first call `usePostToLoadBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostToLoadBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postToLoadBoardMutation, { data, loading, error }] = usePostToLoadBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostToLoadBoardMutation(baseOptions?: Apollo.MutationHookOptions<PostToLoadBoardMutation, PostToLoadBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostToLoadBoardMutation, PostToLoadBoardMutationVariables>(PostToLoadBoardDocument, options);
      }
export type PostToLoadBoardMutationHookResult = ReturnType<typeof usePostToLoadBoardMutation>;
export type PostToLoadBoardMutationResult = Apollo.MutationResult<PostToLoadBoardMutation>;
export type PostToLoadBoardMutationOptions = Apollo.BaseMutationOptions<PostToLoadBoardMutation, PostToLoadBoardMutationVariables>;
export const RefreshPostingOnLoadBoardDocument = gql`
    mutation RefreshPostingOnLoadBoard($input: RefreshPostingOnLoadBoardInput!) {
  refreshPostingOnLoadBoard(input: $input) {
    success
  }
}
    `;
export type RefreshPostingOnLoadBoardMutationFn = Apollo.MutationFunction<RefreshPostingOnLoadBoardMutation, RefreshPostingOnLoadBoardMutationVariables>;

/**
 * __useRefreshPostingOnLoadBoardMutation__
 *
 * To run a mutation, you first call `useRefreshPostingOnLoadBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshPostingOnLoadBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshPostingOnLoadBoardMutation, { data, loading, error }] = useRefreshPostingOnLoadBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshPostingOnLoadBoardMutation(baseOptions?: Apollo.MutationHookOptions<RefreshPostingOnLoadBoardMutation, RefreshPostingOnLoadBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshPostingOnLoadBoardMutation, RefreshPostingOnLoadBoardMutationVariables>(RefreshPostingOnLoadBoardDocument, options);
      }
export type RefreshPostingOnLoadBoardMutationHookResult = ReturnType<typeof useRefreshPostingOnLoadBoardMutation>;
export type RefreshPostingOnLoadBoardMutationResult = Apollo.MutationResult<RefreshPostingOnLoadBoardMutation>;
export type RefreshPostingOnLoadBoardMutationOptions = Apollo.BaseMutationOptions<RefreshPostingOnLoadBoardMutation, RefreshPostingOnLoadBoardMutationVariables>;
export const SimulateShipmentLookupDocument = gql`
    mutation SimulateShipmentLookup($input: SimulateShipmentLookupInput!) {
  simulateShipmentLookup(input: $input) {
    success
    error
    results {
      referenceNumber
      found
      shipmentId
      movementId
      description
      stops {
        stopType
        location {
          city
          state
          zip
          country
        }
        startDateTime
        endDateTime
      }
      pricingData {
        targetPrice
        maxPrice
      }
      equipment {
        equipmentType
        length
      }
      hasCarrier
      error
      matchCount
    }
    totalCount
    foundCount
  }
}
    `;
export type SimulateShipmentLookupMutationFn = Apollo.MutationFunction<SimulateShipmentLookupMutation, SimulateShipmentLookupMutationVariables>;

/**
 * __useSimulateShipmentLookupMutation__
 *
 * To run a mutation, you first call `useSimulateShipmentLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateShipmentLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateShipmentLookupMutation, { data, loading, error }] = useSimulateShipmentLookupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateShipmentLookupMutation(baseOptions?: Apollo.MutationHookOptions<SimulateShipmentLookupMutation, SimulateShipmentLookupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SimulateShipmentLookupMutation, SimulateShipmentLookupMutationVariables>(SimulateShipmentLookupDocument, options);
      }
export type SimulateShipmentLookupMutationHookResult = ReturnType<typeof useSimulateShipmentLookupMutation>;
export type SimulateShipmentLookupMutationResult = Apollo.MutationResult<SimulateShipmentLookupMutation>;
export type SimulateShipmentLookupMutationOptions = Apollo.BaseMutationOptions<SimulateShipmentLookupMutation, SimulateShipmentLookupMutationVariables>;
export const TriggerShipmentIngestionDocument = gql`
    mutation TriggerShipmentIngestion($input: TriggerShipmentIngestionInput!) {
  triggerShipmentIngestion(input: $input) {
    success
    error
  }
}
    `;
export type TriggerShipmentIngestionMutationFn = Apollo.MutationFunction<TriggerShipmentIngestionMutation, TriggerShipmentIngestionMutationVariables>;

/**
 * __useTriggerShipmentIngestionMutation__
 *
 * To run a mutation, you first call `useTriggerShipmentIngestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerShipmentIngestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerShipmentIngestionMutation, { data, loading, error }] = useTriggerShipmentIngestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerShipmentIngestionMutation(baseOptions?: Apollo.MutationHookOptions<TriggerShipmentIngestionMutation, TriggerShipmentIngestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerShipmentIngestionMutation, TriggerShipmentIngestionMutationVariables>(TriggerShipmentIngestionDocument, options);
      }
export type TriggerShipmentIngestionMutationHookResult = ReturnType<typeof useTriggerShipmentIngestionMutation>;
export type TriggerShipmentIngestionMutationResult = Apollo.MutationResult<TriggerShipmentIngestionMutation>;
export type TriggerShipmentIngestionMutationOptions = Apollo.BaseMutationOptions<TriggerShipmentIngestionMutation, TriggerShipmentIngestionMutationVariables>;
export const TriggerTrackingProcedureDocument = gql`
    mutation TriggerTrackingProcedure($input: TriggerTrackingProcedureInput!) {
  triggerTrackingProcedure(input: $input) {
    success
  }
}
    `;
export type TriggerTrackingProcedureMutationFn = Apollo.MutationFunction<TriggerTrackingProcedureMutation, TriggerTrackingProcedureMutationVariables>;

/**
 * __useTriggerTrackingProcedureMutation__
 *
 * To run a mutation, you first call `useTriggerTrackingProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerTrackingProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerTrackingProcedureMutation, { data, loading, error }] = useTriggerTrackingProcedureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerTrackingProcedureMutation(baseOptions?: Apollo.MutationHookOptions<TriggerTrackingProcedureMutation, TriggerTrackingProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerTrackingProcedureMutation, TriggerTrackingProcedureMutationVariables>(TriggerTrackingProcedureDocument, options);
      }
export type TriggerTrackingProcedureMutationHookResult = ReturnType<typeof useTriggerTrackingProcedureMutation>;
export type TriggerTrackingProcedureMutationResult = Apollo.MutationResult<TriggerTrackingProcedureMutation>;
export type TriggerTrackingProcedureMutationOptions = Apollo.BaseMutationOptions<TriggerTrackingProcedureMutation, TriggerTrackingProcedureMutationVariables>;
export const UnpostFromLoadBoardDocument = gql`
    mutation UnpostFromLoadBoard($input: UnpostFromLoadBoardInput!) {
  unpostFromLoadBoard(input: $input) {
    success
  }
}
    `;
export type UnpostFromLoadBoardMutationFn = Apollo.MutationFunction<UnpostFromLoadBoardMutation, UnpostFromLoadBoardMutationVariables>;

/**
 * __useUnpostFromLoadBoardMutation__
 *
 * To run a mutation, you first call `useUnpostFromLoadBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpostFromLoadBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpostFromLoadBoardMutation, { data, loading, error }] = useUnpostFromLoadBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpostFromLoadBoardMutation(baseOptions?: Apollo.MutationHookOptions<UnpostFromLoadBoardMutation, UnpostFromLoadBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpostFromLoadBoardMutation, UnpostFromLoadBoardMutationVariables>(UnpostFromLoadBoardDocument, options);
      }
export type UnpostFromLoadBoardMutationHookResult = ReturnType<typeof useUnpostFromLoadBoardMutation>;
export type UnpostFromLoadBoardMutationResult = Apollo.MutationResult<UnpostFromLoadBoardMutation>;
export type UnpostFromLoadBoardMutationOptions = Apollo.BaseMutationOptions<UnpostFromLoadBoardMutation, UnpostFromLoadBoardMutationVariables>;
export const UpdateShipmentDocument = gql`
    mutation UpdateShipment($input: BuildShipmentInput!) {
  updateShipment(input: $input) {
    shipmentId
  }
}
    `;
export type UpdateShipmentMutationFn = Apollo.MutationFunction<UpdateShipmentMutation, UpdateShipmentMutationVariables>;

/**
 * __useUpdateShipmentMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentMutation, { data, loading, error }] = useUpdateShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShipmentMutation, UpdateShipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShipmentMutation, UpdateShipmentMutationVariables>(UpdateShipmentDocument, options);
      }
export type UpdateShipmentMutationHookResult = ReturnType<typeof useUpdateShipmentMutation>;
export type UpdateShipmentMutationResult = Apollo.MutationResult<UpdateShipmentMutation>;
export type UpdateShipmentMutationOptions = Apollo.BaseMutationOptions<UpdateShipmentMutation, UpdateShipmentMutationVariables>;
export const UpdateSimulationBrokerOrganizationDocument = gql`
    mutation UpdateSimulationBrokerOrganization($input: UpdateSimulationBrokerOrganizationInput!) {
  updateSimulationBrokerOrganization(input: $input) {
    organizationId
    isSimulationBroker
    enabled
    intervalMinutes
    carrierInquiryActionDefinitionId
    carrierInquiryActionDefinitionOrganizationId
  }
}
    `;
export type UpdateSimulationBrokerOrganizationMutationFn = Apollo.MutationFunction<UpdateSimulationBrokerOrganizationMutation, UpdateSimulationBrokerOrganizationMutationVariables>;

/**
 * __useUpdateSimulationBrokerOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateSimulationBrokerOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSimulationBrokerOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSimulationBrokerOrganizationMutation, { data, loading, error }] = useUpdateSimulationBrokerOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSimulationBrokerOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSimulationBrokerOrganizationMutation, UpdateSimulationBrokerOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSimulationBrokerOrganizationMutation, UpdateSimulationBrokerOrganizationMutationVariables>(UpdateSimulationBrokerOrganizationDocument, options);
      }
export type UpdateSimulationBrokerOrganizationMutationHookResult = ReturnType<typeof useUpdateSimulationBrokerOrganizationMutation>;
export type UpdateSimulationBrokerOrganizationMutationResult = Apollo.MutationResult<UpdateSimulationBrokerOrganizationMutation>;
export type UpdateSimulationBrokerOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateSimulationBrokerOrganizationMutation, UpdateSimulationBrokerOrganizationMutationVariables>;
export const UpdateSimulationSettingsDocument = gql`
    mutation UpdateSimulationSettings($input: UpdateSimulationSettingsInput!) {
  updateSimulationSettings(input: $input) {
    organizationId
    isSimulationBroker
    enabled
    intervalMinutes
    carrierInquiryActionDefinitionId
    carrierInquiryActionDefinitionOrganizationId
  }
}
    `;
export type UpdateSimulationSettingsMutationFn = Apollo.MutationFunction<UpdateSimulationSettingsMutation, UpdateSimulationSettingsMutationVariables>;

/**
 * __useUpdateSimulationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSimulationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSimulationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSimulationSettingsMutation, { data, loading, error }] = useUpdateSimulationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSimulationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSimulationSettingsMutation, UpdateSimulationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSimulationSettingsMutation, UpdateSimulationSettingsMutationVariables>(UpdateSimulationSettingsDocument, options);
      }
export type UpdateSimulationSettingsMutationHookResult = ReturnType<typeof useUpdateSimulationSettingsMutation>;
export type UpdateSimulationSettingsMutationResult = Apollo.MutationResult<UpdateSimulationSettingsMutation>;
export type UpdateSimulationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSimulationSettingsMutation, UpdateSimulationSettingsMutationVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation UpdateOrganizationSettings($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    success
    organization {
      id
      settings {
        quoteAutoReply
      }
    }
  }
}
    `;
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, options);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const UpdateOriginatorSettingsDocument = gql`
    mutation UpdateOriginatorSettings($input: UpdateOriginatorInput!) {
  updateOriginator(input: $input) {
    success
    originator {
      id
    }
  }
}
    `;
export type UpdateOriginatorSettingsMutationFn = Apollo.MutationFunction<UpdateOriginatorSettingsMutation, UpdateOriginatorSettingsMutationVariables>;

/**
 * __useUpdateOriginatorSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOriginatorSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOriginatorSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOriginatorSettingsMutation, { data, loading, error }] = useUpdateOriginatorSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOriginatorSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOriginatorSettingsMutation, UpdateOriginatorSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOriginatorSettingsMutation, UpdateOriginatorSettingsMutationVariables>(UpdateOriginatorSettingsDocument, options);
      }
export type UpdateOriginatorSettingsMutationHookResult = ReturnType<typeof useUpdateOriginatorSettingsMutation>;
export type UpdateOriginatorSettingsMutationResult = Apollo.MutationResult<UpdateOriginatorSettingsMutation>;
export type UpdateOriginatorSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOriginatorSettingsMutation, UpdateOriginatorSettingsMutationVariables>;
export const ContinueTeamsConnectionDocument = gql`
    mutation ContinueTeamsConnection($state: String!, $tenant: String, $code: String, $error: String) {
  continueTeamsConnection(
    state: $state
    tenant: $tenant
    code: $code
    error: $error
  ) {
    success
    nextUrl
    error
  }
}
    `;
export type ContinueTeamsConnectionMutationFn = Apollo.MutationFunction<ContinueTeamsConnectionMutation, ContinueTeamsConnectionMutationVariables>;

/**
 * __useContinueTeamsConnectionMutation__
 *
 * To run a mutation, you first call `useContinueTeamsConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueTeamsConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueTeamsConnectionMutation, { data, loading, error }] = useContinueTeamsConnectionMutation({
 *   variables: {
 *      state: // value for 'state'
 *      tenant: // value for 'tenant'
 *      code: // value for 'code'
 *      error: // value for 'error'
 *   },
 * });
 */
export function useContinueTeamsConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ContinueTeamsConnectionMutation, ContinueTeamsConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueTeamsConnectionMutation, ContinueTeamsConnectionMutationVariables>(ContinueTeamsConnectionDocument, options);
      }
export type ContinueTeamsConnectionMutationHookResult = ReturnType<typeof useContinueTeamsConnectionMutation>;
export type ContinueTeamsConnectionMutationResult = Apollo.MutationResult<ContinueTeamsConnectionMutation>;
export type ContinueTeamsConnectionMutationOptions = Apollo.BaseMutationOptions<ContinueTeamsConnectionMutation, ContinueTeamsConnectionMutationVariables>;
export const SetTeamsTenantIdDocument = gql`
    mutation SetTeamsTenantId($organizationId: String!, $tenantId: String) {
  setTeamsTenantId(organizationId: $organizationId, tenantId: $tenantId) {
    success
    error
  }
}
    `;
export type SetTeamsTenantIdMutationFn = Apollo.MutationFunction<SetTeamsTenantIdMutation, SetTeamsTenantIdMutationVariables>;

/**
 * __useSetTeamsTenantIdMutation__
 *
 * To run a mutation, you first call `useSetTeamsTenantIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTeamsTenantIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTeamsTenantIdMutation, { data, loading, error }] = useSetTeamsTenantIdMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useSetTeamsTenantIdMutation(baseOptions?: Apollo.MutationHookOptions<SetTeamsTenantIdMutation, SetTeamsTenantIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTeamsTenantIdMutation, SetTeamsTenantIdMutationVariables>(SetTeamsTenantIdDocument, options);
      }
export type SetTeamsTenantIdMutationHookResult = ReturnType<typeof useSetTeamsTenantIdMutation>;
export type SetTeamsTenantIdMutationResult = Apollo.MutationResult<SetTeamsTenantIdMutation>;
export type SetTeamsTenantIdMutationOptions = Apollo.BaseMutationOptions<SetTeamsTenantIdMutation, SetTeamsTenantIdMutationVariables>;
export const StartTeamsAdminConsentDocument = gql`
    mutation StartTeamsAdminConsent($organizationId: String!) {
  startTeamsAdminConsent(organizationId: $organizationId) {
    authorizeUrl
  }
}
    `;
export type StartTeamsAdminConsentMutationFn = Apollo.MutationFunction<StartTeamsAdminConsentMutation, StartTeamsAdminConsentMutationVariables>;

/**
 * __useStartTeamsAdminConsentMutation__
 *
 * To run a mutation, you first call `useStartTeamsAdminConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTeamsAdminConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTeamsAdminConsentMutation, { data, loading, error }] = useStartTeamsAdminConsentMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStartTeamsAdminConsentMutation(baseOptions?: Apollo.MutationHookOptions<StartTeamsAdminConsentMutation, StartTeamsAdminConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTeamsAdminConsentMutation, StartTeamsAdminConsentMutationVariables>(StartTeamsAdminConsentDocument, options);
      }
export type StartTeamsAdminConsentMutationHookResult = ReturnType<typeof useStartTeamsAdminConsentMutation>;
export type StartTeamsAdminConsentMutationResult = Apollo.MutationResult<StartTeamsAdminConsentMutation>;
export type StartTeamsAdminConsentMutationOptions = Apollo.BaseMutationOptions<StartTeamsAdminConsentMutation, StartTeamsAdminConsentMutationVariables>;
export const ExecuteToolDocument = gql`
    mutation ExecuteTool($input: ExecuteToolInput!) {
  executeTool(input: $input) {
    success
    error
    toolOutput
  }
}
    `;
export type ExecuteToolMutationFn = Apollo.MutationFunction<ExecuteToolMutation, ExecuteToolMutationVariables>;

/**
 * __useExecuteToolMutation__
 *
 * To run a mutation, you first call `useExecuteToolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteToolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeToolMutation, { data, loading, error }] = useExecuteToolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExecuteToolMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteToolMutation, ExecuteToolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteToolMutation, ExecuteToolMutationVariables>(ExecuteToolDocument, options);
      }
export type ExecuteToolMutationHookResult = ReturnType<typeof useExecuteToolMutation>;
export type ExecuteToolMutationResult = Apollo.MutationResult<ExecuteToolMutation>;
export type ExecuteToolMutationOptions = Apollo.BaseMutationOptions<ExecuteToolMutation, ExecuteToolMutationVariables>;
export const CreateTrackSettingsDocument = gql`
    mutation CreateTrackSettings($input: CreateTrackSettingsInput!) {
  createTrackSettings(input: $input) {
    id
    organizationId
    name
    isActive
    createdAt
    updatedAt
    stopSettings {
      pickup {
        checkTypes
        timeWindowMinutes
        before {
          trigger
          minutesBefore
          suppressIfCarrierChangedWithinMinutes
          triggers {
            triggerType
            enabled
            params {
              appointment {
                minutes
                direction
                anchor
              }
              windowTiers {
                maxDurationMinutes
                offset {
                  minutes
                  direction
                  anchor
                }
              }
            }
          }
        }
        beforeConfigs {
          enabled
          trigger
          minutesBefore
          suppressIfCarrierChangedWithinMinutes
          advanced {
            appointment {
              minutes
              direction
              anchor
            }
            windowTiers {
              maxDurationMinutes
              offset {
                minutes
                direction
                anchor
              }
            }
          }
        }
        after {
          minutesAfter
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAfterTriggerParamsFields
            }
          }
        }
        at {
          delayMinutes
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAtTriggerParamsFields
            }
          }
        }
        actualArrival {
          enabled
        }
        actualDeparture {
          enabled
        }
        preDispatch {
          enabled
          minutesBefore
          triggers {
            triggerType
            enabled
            params {
              minutesBefore
              cutoffHour
              hoursBeforeCutoffForEarlyPickups
              hoursBeforeCutoffForLatePickups
              appointment {
                minutes
                direction
                anchor
              }
              windowTiers {
                maxDurationMinutes
                offset {
                  minutes
                  direction
                  anchor
                }
              }
            }
          }
        }
      }
      stops {
        checkTypes
        timeWindowMinutes
      }
      delivery {
        checkTypes
        timeWindowMinutes
        before {
          trigger
          triggers {
            triggerType
            enabled
            params {
              ...AdvancedTriggerParamsFields
            }
          }
        }
        after {
          minutesAfter
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAfterTriggerParamsFields
            }
          }
        }
        at {
          delayMinutes
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAtTriggerParamsFields
            }
          }
        }
      }
    }
    enRouteSettings {
      cadenceMode
      enRoute {
        ...EnRouteTrackEventSettingsFields
      }
      enRouteWithTracking {
        ...EnRouteTrackEventSettingsFields
      }
      enRouteWithoutTracking {
        ...EnRouteTrackEventSettingsFields
      }
      exceptionEventsSettings {
        alertWindowMinutes
        quietPeriodAfterInTransitMinutes
        stationaryVehicle {
          thresholdMinutes
          suppressionPeriodMinutes
        }
        runningLate {
          enabled
          suppressionPeriodMinutes
          toleranceMinutes
        }
        trackingDataNotAvailable {
          enabled
          suppressionPeriodMinutes
        }
        trackingDataStale {
          enabled
          thresholdMinutes
          suppressionPeriodMinutes
        }
        infoMissing {
          enabled
          checks
          suppressionPeriodMinutes
          evaluateAt
        }
        notYetDispatched {
          enabled
          minutesBeforePickup
        }
        runningLateCloseToDelivery {
          enabled
          minutesBeforeDelivery
          toleranceMinutes
        }
        runningLateCloseToPickup {
          enabled
          minutesBeforePickup
          toleranceMinutes
        }
      }
      truckSpeedMph
      dailyDrivingHours
      trackingTrigger
    }
    nightHoursSettings {
      startHour
      endHour
      windowMinutes
      skipAllMilestones
    }
  }
}
    ${MilestoneAfterTriggerParamsFieldsFragmentDoc}
${MilestoneAtTriggerParamsFieldsFragmentDoc}
${AdvancedTriggerParamsFieldsFragmentDoc}
${EnRouteTrackEventSettingsFieldsFragmentDoc}`;
export type CreateTrackSettingsMutationFn = Apollo.MutationFunction<CreateTrackSettingsMutation, CreateTrackSettingsMutationVariables>;

/**
 * __useCreateTrackSettingsMutation__
 *
 * To run a mutation, you first call `useCreateTrackSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackSettingsMutation, { data, loading, error }] = useCreateTrackSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrackSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackSettingsMutation, CreateTrackSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackSettingsMutation, CreateTrackSettingsMutationVariables>(CreateTrackSettingsDocument, options);
      }
export type CreateTrackSettingsMutationHookResult = ReturnType<typeof useCreateTrackSettingsMutation>;
export type CreateTrackSettingsMutationResult = Apollo.MutationResult<CreateTrackSettingsMutation>;
export type CreateTrackSettingsMutationOptions = Apollo.BaseMutationOptions<CreateTrackSettingsMutation, CreateTrackSettingsMutationVariables>;
export const DeleteTrackSettingsDocument = gql`
    mutation DeleteTrackSettings($id: ID!) {
  deleteTrackSettings(id: $id)
}
    `;
export type DeleteTrackSettingsMutationFn = Apollo.MutationFunction<DeleteTrackSettingsMutation, DeleteTrackSettingsMutationVariables>;

/**
 * __useDeleteTrackSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteTrackSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackSettingsMutation, { data, loading, error }] = useDeleteTrackSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrackSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrackSettingsMutation, DeleteTrackSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrackSettingsMutation, DeleteTrackSettingsMutationVariables>(DeleteTrackSettingsDocument, options);
      }
export type DeleteTrackSettingsMutationHookResult = ReturnType<typeof useDeleteTrackSettingsMutation>;
export type DeleteTrackSettingsMutationResult = Apollo.MutationResult<DeleteTrackSettingsMutation>;
export type DeleteTrackSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteTrackSettingsMutation, DeleteTrackSettingsMutationVariables>;
export const SetDefaultTrackSettingsDocument = gql`
    mutation SetDefaultTrackSettings($id: ID!, $isDefault: Boolean!) {
  setDefaultTrackSettings(id: $id, isDefault: $isDefault) {
    id
    organizationId
    name
    isActive
    isDefault
  }
}
    `;
export type SetDefaultTrackSettingsMutationFn = Apollo.MutationFunction<SetDefaultTrackSettingsMutation, SetDefaultTrackSettingsMutationVariables>;

/**
 * __useSetDefaultTrackSettingsMutation__
 *
 * To run a mutation, you first call `useSetDefaultTrackSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultTrackSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultTrackSettingsMutation, { data, loading, error }] = useSetDefaultTrackSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useSetDefaultTrackSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultTrackSettingsMutation, SetDefaultTrackSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultTrackSettingsMutation, SetDefaultTrackSettingsMutationVariables>(SetDefaultTrackSettingsDocument, options);
      }
export type SetDefaultTrackSettingsMutationHookResult = ReturnType<typeof useSetDefaultTrackSettingsMutation>;
export type SetDefaultTrackSettingsMutationResult = Apollo.MutationResult<SetDefaultTrackSettingsMutation>;
export type SetDefaultTrackSettingsMutationOptions = Apollo.BaseMutationOptions<SetDefaultTrackSettingsMutation, SetDefaultTrackSettingsMutationVariables>;
export const SetValhallaComparisonEnabledDocument = gql`
    mutation SetValhallaComparisonEnabled($enabled: Boolean!) {
  setValhallaComparisonEnabled(enabled: $enabled)
}
    `;
export type SetValhallaComparisonEnabledMutationFn = Apollo.MutationFunction<SetValhallaComparisonEnabledMutation, SetValhallaComparisonEnabledMutationVariables>;

/**
 * __useSetValhallaComparisonEnabledMutation__
 *
 * To run a mutation, you first call `useSetValhallaComparisonEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetValhallaComparisonEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setValhallaComparisonEnabledMutation, { data, loading, error }] = useSetValhallaComparisonEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetValhallaComparisonEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetValhallaComparisonEnabledMutation, SetValhallaComparisonEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetValhallaComparisonEnabledMutation, SetValhallaComparisonEnabledMutationVariables>(SetValhallaComparisonEnabledDocument, options);
      }
export type SetValhallaComparisonEnabledMutationHookResult = ReturnType<typeof useSetValhallaComparisonEnabledMutation>;
export type SetValhallaComparisonEnabledMutationResult = Apollo.MutationResult<SetValhallaComparisonEnabledMutation>;
export type SetValhallaComparisonEnabledMutationOptions = Apollo.BaseMutationOptions<SetValhallaComparisonEnabledMutation, SetValhallaComparisonEnabledMutationVariables>;
export const UpdateTrackDashboardPreferencesDocument = gql`
    mutation UpdateTrackDashboardPreferences($input: UpdateTrackDashboardPreferencesInput!) {
  updateTrackDashboardPreferences(input: $input) {
    hiddenCards
    hiddenSopChecks
    hiddenTotals
  }
}
    `;
export type UpdateTrackDashboardPreferencesMutationFn = Apollo.MutationFunction<UpdateTrackDashboardPreferencesMutation, UpdateTrackDashboardPreferencesMutationVariables>;

/**
 * __useUpdateTrackDashboardPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateTrackDashboardPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackDashboardPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackDashboardPreferencesMutation, { data, loading, error }] = useUpdateTrackDashboardPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrackDashboardPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackDashboardPreferencesMutation, UpdateTrackDashboardPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackDashboardPreferencesMutation, UpdateTrackDashboardPreferencesMutationVariables>(UpdateTrackDashboardPreferencesDocument, options);
      }
export type UpdateTrackDashboardPreferencesMutationHookResult = ReturnType<typeof useUpdateTrackDashboardPreferencesMutation>;
export type UpdateTrackDashboardPreferencesMutationResult = Apollo.MutationResult<UpdateTrackDashboardPreferencesMutation>;
export type UpdateTrackDashboardPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateTrackDashboardPreferencesMutation, UpdateTrackDashboardPreferencesMutationVariables>;
export const UpdateTrackSettingsDocument = gql`
    mutation UpdateTrackSettings($input: UpdateTrackSettingsInput!) {
  updateTrackSettings(input: $input) {
    id
    organizationId
    name
    isActive
    createdAt
    updatedAt
    stopSettings {
      pickup {
        checkTypes
        timeWindowMinutes
        before {
          trigger
          minutesBefore
          suppressIfCarrierChangedWithinMinutes
          triggers {
            triggerType
            enabled
            params {
              appointment {
                minutes
                direction
                anchor
              }
              windowTiers {
                maxDurationMinutes
                offset {
                  minutes
                  direction
                  anchor
                }
              }
            }
          }
        }
        beforeConfigs {
          enabled
          trigger
          minutesBefore
          suppressIfCarrierChangedWithinMinutes
          advanced {
            appointment {
              minutes
              direction
              anchor
            }
            windowTiers {
              maxDurationMinutes
              offset {
                minutes
                direction
                anchor
              }
            }
          }
        }
        after {
          minutesAfter
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAfterTriggerParamsFields
            }
          }
        }
        at {
          delayMinutes
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAtTriggerParamsFields
            }
          }
        }
        actualArrival {
          enabled
        }
        actualDeparture {
          enabled
        }
        preDispatch {
          enabled
          minutesBefore
          triggers {
            triggerType
            enabled
            params {
              minutesBefore
              cutoffHour
              hoursBeforeCutoffForEarlyPickups
              hoursBeforeCutoffForLatePickups
              appointment {
                minutes
                direction
                anchor
              }
              windowTiers {
                maxDurationMinutes
                offset {
                  minutes
                  direction
                  anchor
                }
              }
            }
          }
        }
      }
      stops {
        checkTypes
        timeWindowMinutes
      }
      delivery {
        checkTypes
        timeWindowMinutes
        before {
          trigger
          triggers {
            triggerType
            enabled
            params {
              ...AdvancedTriggerParamsFields
            }
          }
        }
        after {
          minutesAfter
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAfterTriggerParamsFields
            }
          }
        }
        at {
          delayMinutes
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAtTriggerParamsFields
            }
          }
        }
      }
    }
    enRouteSettings {
      cadenceMode
      enRoute {
        ...EnRouteTrackEventSettingsFields
      }
      enRouteWithTracking {
        ...EnRouteTrackEventSettingsFields
      }
      enRouteWithoutTracking {
        ...EnRouteTrackEventSettingsFields
      }
      exceptionEventsSettings {
        alertWindowMinutes
        quietPeriodAfterInTransitMinutes
        stationaryVehicle {
          thresholdMinutes
          suppressionPeriodMinutes
        }
        runningLate {
          enabled
          suppressionPeriodMinutes
          toleranceMinutes
        }
        trackingDataNotAvailable {
          enabled
          suppressionPeriodMinutes
        }
        trackingDataStale {
          enabled
          thresholdMinutes
          suppressionPeriodMinutes
        }
        infoMissing {
          enabled
          checks
          suppressionPeriodMinutes
          evaluateAt
        }
        notYetDispatched {
          enabled
          minutesBeforePickup
        }
        runningLateCloseToDelivery {
          enabled
          minutesBeforeDelivery
          toleranceMinutes
        }
        runningLateCloseToPickup {
          enabled
          minutesBeforePickup
          toleranceMinutes
        }
      }
      truckSpeedMph
      dailyDrivingHours
      trackingTrigger
    }
    nightHoursSettings {
      startHour
      endHour
      windowMinutes
      skipAllMilestones
    }
  }
}
    ${MilestoneAfterTriggerParamsFieldsFragmentDoc}
${MilestoneAtTriggerParamsFieldsFragmentDoc}
${AdvancedTriggerParamsFieldsFragmentDoc}
${EnRouteTrackEventSettingsFieldsFragmentDoc}`;
export type UpdateTrackSettingsMutationFn = Apollo.MutationFunction<UpdateTrackSettingsMutation, UpdateTrackSettingsMutationVariables>;

/**
 * __useUpdateTrackSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackSettingsMutation, { data, loading, error }] = useUpdateTrackSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrackSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackSettingsMutation, UpdateTrackSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackSettingsMutation, UpdateTrackSettingsMutationVariables>(UpdateTrackSettingsDocument, options);
      }
export type UpdateTrackSettingsMutationHookResult = ReturnType<typeof useUpdateTrackSettingsMutation>;
export type UpdateTrackSettingsMutationResult = Apollo.MutationResult<UpdateTrackSettingsMutation>;
export type UpdateTrackSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTrackSettingsMutation, UpdateTrackSettingsMutationVariables>;
export const SetTruckerToolsScrapingConcurrencyDocument = gql`
    mutation SetTruckerToolsScrapingConcurrency($limit: Int) {
  setTruckerToolsScrapingConcurrency(limit: $limit)
}
    `;
export type SetTruckerToolsScrapingConcurrencyMutationFn = Apollo.MutationFunction<SetTruckerToolsScrapingConcurrencyMutation, SetTruckerToolsScrapingConcurrencyMutationVariables>;

/**
 * __useSetTruckerToolsScrapingConcurrencyMutation__
 *
 * To run a mutation, you first call `useSetTruckerToolsScrapingConcurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTruckerToolsScrapingConcurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTruckerToolsScrapingConcurrencyMutation, { data, loading, error }] = useSetTruckerToolsScrapingConcurrencyMutation({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSetTruckerToolsScrapingConcurrencyMutation(baseOptions?: Apollo.MutationHookOptions<SetTruckerToolsScrapingConcurrencyMutation, SetTruckerToolsScrapingConcurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTruckerToolsScrapingConcurrencyMutation, SetTruckerToolsScrapingConcurrencyMutationVariables>(SetTruckerToolsScrapingConcurrencyDocument, options);
      }
export type SetTruckerToolsScrapingConcurrencyMutationHookResult = ReturnType<typeof useSetTruckerToolsScrapingConcurrencyMutation>;
export type SetTruckerToolsScrapingConcurrencyMutationResult = Apollo.MutationResult<SetTruckerToolsScrapingConcurrencyMutation>;
export type SetTruckerToolsScrapingConcurrencyMutationOptions = Apollo.BaseMutationOptions<SetTruckerToolsScrapingConcurrencyMutation, SetTruckerToolsScrapingConcurrencyMutationVariables>;
export const SetToolSearchEmbeddingsEnabledDocument = gql`
    mutation SetToolSearchEmbeddingsEnabled($enabled: Boolean) {
  setToolSearchEmbeddingsEnabled(enabled: $enabled)
}
    `;
export type SetToolSearchEmbeddingsEnabledMutationFn = Apollo.MutationFunction<SetToolSearchEmbeddingsEnabledMutation, SetToolSearchEmbeddingsEnabledMutationVariables>;

/**
 * __useSetToolSearchEmbeddingsEnabledMutation__
 *
 * To run a mutation, you first call `useSetToolSearchEmbeddingsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetToolSearchEmbeddingsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setToolSearchEmbeddingsEnabledMutation, { data, loading, error }] = useSetToolSearchEmbeddingsEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetToolSearchEmbeddingsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetToolSearchEmbeddingsEnabledMutation, SetToolSearchEmbeddingsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetToolSearchEmbeddingsEnabledMutation, SetToolSearchEmbeddingsEnabledMutationVariables>(SetToolSearchEmbeddingsEnabledDocument, options);
      }
export type SetToolSearchEmbeddingsEnabledMutationHookResult = ReturnType<typeof useSetToolSearchEmbeddingsEnabledMutation>;
export type SetToolSearchEmbeddingsEnabledMutationResult = Apollo.MutationResult<SetToolSearchEmbeddingsEnabledMutation>;
export type SetToolSearchEmbeddingsEnabledMutationOptions = Apollo.BaseMutationOptions<SetToolSearchEmbeddingsEnabledMutation, SetToolSearchEmbeddingsEnabledMutationVariables>;
export const CreateAgentMailInboxDocument = gql`
    mutation CreateAgentMailInbox($input: CreateAgentMailInboxInput!) {
  createAgentMailInbox(input: $input) {
    success
    email
    inboxId
    errorMessage
  }
}
    `;
export type CreateAgentMailInboxMutationFn = Apollo.MutationFunction<CreateAgentMailInboxMutation, CreateAgentMailInboxMutationVariables>;

/**
 * __useCreateAgentMailInboxMutation__
 *
 * To run a mutation, you first call `useCreateAgentMailInboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentMailInboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentMailInboxMutation, { data, loading, error }] = useCreateAgentMailInboxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentMailInboxMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentMailInboxMutation, CreateAgentMailInboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentMailInboxMutation, CreateAgentMailInboxMutationVariables>(CreateAgentMailInboxDocument, options);
      }
export type CreateAgentMailInboxMutationHookResult = ReturnType<typeof useCreateAgentMailInboxMutation>;
export type CreateAgentMailInboxMutationResult = Apollo.MutationResult<CreateAgentMailInboxMutation>;
export type CreateAgentMailInboxMutationOptions = Apollo.BaseMutationOptions<CreateAgentMailInboxMutation, CreateAgentMailInboxMutationVariables>;
export const CreateWorkerDocument = gql`
    mutation CreateWorker($input: CreateWorkerInput!) {
  createWorker(input: $input) {
    worker {
      ...WorkerPreview
    }
  }
}
    ${WorkerPreviewFragmentDoc}`;
export type CreateWorkerMutationFn = Apollo.MutationFunction<CreateWorkerMutation, CreateWorkerMutationVariables>;

/**
 * __useCreateWorkerMutation__
 *
 * To run a mutation, you first call `useCreateWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkerMutation, { data, loading, error }] = useCreateWorkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkerMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkerMutation, CreateWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkerMutation, CreateWorkerMutationVariables>(CreateWorkerDocument, options);
      }
export type CreateWorkerMutationHookResult = ReturnType<typeof useCreateWorkerMutation>;
export type CreateWorkerMutationResult = Apollo.MutationResult<CreateWorkerMutation>;
export type CreateWorkerMutationOptions = Apollo.BaseMutationOptions<CreateWorkerMutation, CreateWorkerMutationVariables>;
export const DeleteWorkerDocument = gql`
    mutation DeleteWorker($input: DeleteWorkerInput!) {
  deleteWorker(input: $input) {
    success
  }
}
    `;
export type DeleteWorkerMutationFn = Apollo.MutationFunction<DeleteWorkerMutation, DeleteWorkerMutationVariables>;

/**
 * __useDeleteWorkerMutation__
 *
 * To run a mutation, you first call `useDeleteWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkerMutation, { data, loading, error }] = useDeleteWorkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkerMutation, DeleteWorkerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkerMutation, DeleteWorkerMutationVariables>(DeleteWorkerDocument, options);
      }
export type DeleteWorkerMutationHookResult = ReturnType<typeof useDeleteWorkerMutation>;
export type DeleteWorkerMutationResult = Apollo.MutationResult<DeleteWorkerMutation>;
export type DeleteWorkerMutationOptions = Apollo.BaseMutationOptions<DeleteWorkerMutation, DeleteWorkerMutationVariables>;
export const UpdateWorkerProfileDocument = gql`
    mutation UpdateWorkerProfile($input: UpdateWorkerProfileInput!) {
  updateWorkerProfile(input: $input) {
    worker {
      ...Worker
    }
  }
}
    ${WorkerFragmentDoc}`;
export type UpdateWorkerProfileMutationFn = Apollo.MutationFunction<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>;

/**
 * __useUpdateWorkerProfileMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerProfileMutation, { data, loading, error }] = useUpdateWorkerProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkerProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>(UpdateWorkerProfileDocument, options);
      }
export type UpdateWorkerProfileMutationHookResult = ReturnType<typeof useUpdateWorkerProfileMutation>;
export type UpdateWorkerProfileMutationResult = Apollo.MutationResult<UpdateWorkerProfileMutation>;
export type UpdateWorkerProfileMutationOptions = Apollo.BaseMutationOptions<UpdateWorkerProfileMutation, UpdateWorkerProfileMutationVariables>;
export const FrontendMaintenanceModeDocument = gql`
    query FrontendMaintenanceMode {
  frontendMaintenanceMode {
    enabled
  }
}
    `;

/**
 * __useFrontendMaintenanceModeQuery__
 *
 * To run a query within a React component, call `useFrontendMaintenanceModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontendMaintenanceModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontendMaintenanceModeQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrontendMaintenanceModeQuery(baseOptions?: Apollo.QueryHookOptions<FrontendMaintenanceModeQuery, FrontendMaintenanceModeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrontendMaintenanceModeQuery, FrontendMaintenanceModeQueryVariables>(FrontendMaintenanceModeDocument, options);
      }
export function useFrontendMaintenanceModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrontendMaintenanceModeQuery, FrontendMaintenanceModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrontendMaintenanceModeQuery, FrontendMaintenanceModeQueryVariables>(FrontendMaintenanceModeDocument, options);
        }
export type FrontendMaintenanceModeQueryHookResult = ReturnType<typeof useFrontendMaintenanceModeQuery>;
export type FrontendMaintenanceModeLazyQueryHookResult = ReturnType<typeof useFrontendMaintenanceModeLazyQuery>;
export type FrontendMaintenanceModeQueryResult = Apollo.QueryResult<FrontendMaintenanceModeQuery, FrontendMaintenanceModeQueryVariables>;
export const GetApiKeysDocument = gql`
    query GetApiKeys($input: ApiClientsInput!) {
  apiClients(input: $input) {
    edges {
      node {
        id
        userEmail
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const GetEvaluationTracesDocument = gql`
    query GetEvaluationTraces($input: GetEvaluationTraceInput!) {
  getEvaluationTraces(input: $input) {
    externalUrl
    name
  }
}
    `;

/**
 * __useGetEvaluationTracesQuery__
 *
 * To run a query within a React component, call `useGetEvaluationTracesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEvaluationTracesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEvaluationTracesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEvaluationTracesQuery(baseOptions: Apollo.QueryHookOptions<GetEvaluationTracesQuery, GetEvaluationTracesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEvaluationTracesQuery, GetEvaluationTracesQueryVariables>(GetEvaluationTracesDocument, options);
      }
export function useGetEvaluationTracesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEvaluationTracesQuery, GetEvaluationTracesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEvaluationTracesQuery, GetEvaluationTracesQueryVariables>(GetEvaluationTracesDocument, options);
        }
export type GetEvaluationTracesQueryHookResult = ReturnType<typeof useGetEvaluationTracesQuery>;
export type GetEvaluationTracesLazyQueryHookResult = ReturnType<typeof useGetEvaluationTracesLazyQuery>;
export type GetEvaluationTracesQueryResult = Apollo.QueryResult<GetEvaluationTracesQuery, GetEvaluationTracesQueryVariables>;
export const GetFeatureFlagEnabledDocument = gql`
    query GetFeatureFlagEnabled($input: GetFeatureFlagEnabledInput!) {
  isFeatureFlagEnabled(input: $input)
}
    `;

/**
 * __useGetFeatureFlagEnabledQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagEnabledQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeatureFlagEnabledQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFlagEnabledQuery, GetFeatureFlagEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagEnabledQuery, GetFeatureFlagEnabledQueryVariables>(GetFeatureFlagEnabledDocument, options);
      }
export function useGetFeatureFlagEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagEnabledQuery, GetFeatureFlagEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagEnabledQuery, GetFeatureFlagEnabledQueryVariables>(GetFeatureFlagEnabledDocument, options);
        }
export type GetFeatureFlagEnabledQueryHookResult = ReturnType<typeof useGetFeatureFlagEnabledQuery>;
export type GetFeatureFlagEnabledLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagEnabledLazyQuery>;
export type GetFeatureFlagEnabledQueryResult = Apollo.QueryResult<GetFeatureFlagEnabledQuery, GetFeatureFlagEnabledQueryVariables>;
export const GetFeedQuoteEventsDocument = gql`
    query GetFeedQuoteEvents($input: JobsInput) {
  jobs(input: $input) {
    edges {
      node {
        id
        quotes {
          id
          quoteEvents {
            id
            quoteId
            createdAt
            type
            metadata
            user {
              firstName
              lastName
              email
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedQuoteEventsQuery__
 *
 * To run a query within a React component, call `useGetFeedQuoteEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedQuoteEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedQuoteEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedQuoteEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedQuoteEventsQuery, GetFeedQuoteEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedQuoteEventsQuery, GetFeedQuoteEventsQueryVariables>(GetFeedQuoteEventsDocument, options);
      }
export function useGetFeedQuoteEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedQuoteEventsQuery, GetFeedQuoteEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedQuoteEventsQuery, GetFeedQuoteEventsQueryVariables>(GetFeedQuoteEventsDocument, options);
        }
export type GetFeedQuoteEventsQueryHookResult = ReturnType<typeof useGetFeedQuoteEventsQuery>;
export type GetFeedQuoteEventsLazyQueryHookResult = ReturnType<typeof useGetFeedQuoteEventsLazyQuery>;
export type GetFeedQuoteEventsQueryResult = Apollo.QueryResult<GetFeedQuoteEventsQuery, GetFeedQuoteEventsQueryVariables>;
export const GetFreightDataMappingsDocument = gql`
    query GetFreightDataMappings($organizationId: ID!, $type: FreightDataMappingType!) {
  freightDataMappings(organizationId: $organizationId, type: $type) {
    id
    key
    type
    values
    organizationId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFreightDataMappingsQuery__
 *
 * To run a query within a React component, call `useGetFreightDataMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreightDataMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreightDataMappingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetFreightDataMappingsQuery(baseOptions: Apollo.QueryHookOptions<GetFreightDataMappingsQuery, GetFreightDataMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreightDataMappingsQuery, GetFreightDataMappingsQueryVariables>(GetFreightDataMappingsDocument, options);
      }
export function useGetFreightDataMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreightDataMappingsQuery, GetFreightDataMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreightDataMappingsQuery, GetFreightDataMappingsQueryVariables>(GetFreightDataMappingsDocument, options);
        }
export type GetFreightDataMappingsQueryHookResult = ReturnType<typeof useGetFreightDataMappingsQuery>;
export type GetFreightDataMappingsLazyQueryHookResult = ReturnType<typeof useGetFreightDataMappingsLazyQuery>;
export type GetFreightDataMappingsQueryResult = Apollo.QueryResult<GetFreightDataMappingsQuery, GetFreightDataMappingsQueryVariables>;
export const GetAuthorizedServiceDocument = gql`
    query GetAuthorizedService($type: AuthTokenType!, $externalUserId: String) {
  hasAuthorizedServiceType(type: $type, externalUserId: $externalUserId) {
    success
    email
    scopes
  }
}
    `;

/**
 * __useGetAuthorizedServiceQuery__
 *
 * To run a query within a React component, call `useGetAuthorizedServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizedServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizedServiceQuery({
 *   variables: {
 *      type: // value for 'type'
 *      externalUserId: // value for 'externalUserId'
 *   },
 * });
 */
export function useGetAuthorizedServiceQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorizedServiceQuery, GetAuthorizedServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizedServiceQuery, GetAuthorizedServiceQueryVariables>(GetAuthorizedServiceDocument, options);
      }
export function useGetAuthorizedServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizedServiceQuery, GetAuthorizedServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizedServiceQuery, GetAuthorizedServiceQueryVariables>(GetAuthorizedServiceDocument, options);
        }
export type GetAuthorizedServiceQueryHookResult = ReturnType<typeof useGetAuthorizedServiceQuery>;
export type GetAuthorizedServiceLazyQueryHookResult = ReturnType<typeof useGetAuthorizedServiceLazyQuery>;
export type GetAuthorizedServiceQueryResult = Apollo.QueryResult<GetAuthorizedServiceQuery, GetAuthorizedServiceQueryVariables>;
export const GetJobsDocument = gql`
    query GetJobs($input: JobsInput) {
  jobs(input: $input) {
    edges {
      node {
        ...JobSummary
        relatedCanonicalQuotes {
          ...QuoteSummary
        }
      }
    }
  }
}
    ${JobSummaryFragmentDoc}
${QuoteSummaryFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetKnockTokenDocument = gql`
    query GetKnockToken($id: ID!) {
  knockToken(id: $id)
}
    `;

/**
 * __useGetKnockTokenQuery__
 *
 * To run a query within a React component, call `useGetKnockTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnockTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnockTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnockTokenQuery(baseOptions: Apollo.QueryHookOptions<GetKnockTokenQuery, GetKnockTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnockTokenQuery, GetKnockTokenQueryVariables>(GetKnockTokenDocument, options);
      }
export function useGetKnockTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnockTokenQuery, GetKnockTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnockTokenQuery, GetKnockTokenQueryVariables>(GetKnockTokenDocument, options);
        }
export type GetKnockTokenQueryHookResult = ReturnType<typeof useGetKnockTokenQuery>;
export type GetKnockTokenLazyQueryHookResult = ReturnType<typeof useGetKnockTokenLazyQuery>;
export type GetKnockTokenQueryResult = Apollo.QueryResult<GetKnockTokenQuery, GetKnockTokenQueryVariables>;
export const GetManagedResourcesDocument = gql`
    query GetManagedResources {
  managedResources {
    ...ManagedResource
  }
}
    ${ManagedResourceFragmentDoc}`;

/**
 * __useGetManagedResourcesQuery__
 *
 * To run a query within a React component, call `useGetManagedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagedResourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetManagedResourcesQuery, GetManagedResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedResourcesQuery, GetManagedResourcesQueryVariables>(GetManagedResourcesDocument, options);
      }
export function useGetManagedResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedResourcesQuery, GetManagedResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedResourcesQuery, GetManagedResourcesQueryVariables>(GetManagedResourcesDocument, options);
        }
export type GetManagedResourcesQueryHookResult = ReturnType<typeof useGetManagedResourcesQuery>;
export type GetManagedResourcesLazyQueryHookResult = ReturnType<typeof useGetManagedResourcesLazyQuery>;
export type GetManagedResourcesQueryResult = Apollo.QueryResult<GetManagedResourcesQuery, GetManagedResourcesQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID!) {
  orderById(id: $id) {
    ...Order
  }
}
    ${OrderFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const PricingStrategiesDocument = gql`
    query PricingStrategies($input: PricingStrategiesInput!) {
  pricingStrategies(input: $input) {
    id
    type
    config
  }
}
    `;

/**
 * __usePricingStrategiesQuery__
 *
 * To run a query within a React component, call `usePricingStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingStrategiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePricingStrategiesQuery(baseOptions: Apollo.QueryHookOptions<PricingStrategiesQuery, PricingStrategiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingStrategiesQuery, PricingStrategiesQueryVariables>(PricingStrategiesDocument, options);
      }
export function usePricingStrategiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingStrategiesQuery, PricingStrategiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingStrategiesQuery, PricingStrategiesQueryVariables>(PricingStrategiesDocument, options);
        }
export type PricingStrategiesQueryHookResult = ReturnType<typeof usePricingStrategiesQuery>;
export type PricingStrategiesLazyQueryHookResult = ReturnType<typeof usePricingStrategiesLazyQuery>;
export type PricingStrategiesQueryResult = Apollo.QueryResult<PricingStrategiesQuery, PricingStrategiesQueryVariables>;
export const GetResourceResolutionDocument = gql`
    query GetResourceResolution {
  getResourceResolution {
    resolutions {
      name
      resolvesToName
    }
  }
}
    `;

/**
 * __useGetResourceResolutionQuery__
 *
 * To run a query within a React component, call `useGetResourceResolutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceResolutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceResolutionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResourceResolutionQuery(baseOptions?: Apollo.QueryHookOptions<GetResourceResolutionQuery, GetResourceResolutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceResolutionQuery, GetResourceResolutionQueryVariables>(GetResourceResolutionDocument, options);
      }
export function useGetResourceResolutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceResolutionQuery, GetResourceResolutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceResolutionQuery, GetResourceResolutionQueryVariables>(GetResourceResolutionDocument, options);
        }
export type GetResourceResolutionQueryHookResult = ReturnType<typeof useGetResourceResolutionQuery>;
export type GetResourceResolutionLazyQueryHookResult = ReturnType<typeof useGetResourceResolutionLazyQuery>;
export type GetResourceResolutionQueryResult = Apollo.QueryResult<GetResourceResolutionQuery, GetResourceResolutionQueryVariables>;
export const GetTeamDocument = gql`
    query GetTeam($id: ID!) {
  teamById(id: $id) {
    ...TeamDetails
  }
}
    ${TeamDetailsFragmentDoc}`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export const GetTeamsDocument = gql`
    query GetTeams($input: TeamsInput!) {
  teams(input: $input) {
    ...Team
  }
}
    ${TeamFragmentDoc}`;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
      }
export function useGetTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>;
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export const GetTeamsWithActionTriggerCountDocument = gql`
    query GetTeamsWithActionTriggerCount($input: TeamsInput!) {
  teams(input: $input) {
    ...TeamWithActionTriggerCount
  }
}
    ${TeamWithActionTriggerCountFragmentDoc}`;

/**
 * __useGetTeamsWithActionTriggerCountQuery__
 *
 * To run a query within a React component, call `useGetTeamsWithActionTriggerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsWithActionTriggerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsWithActionTriggerCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTeamsWithActionTriggerCountQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsWithActionTriggerCountQuery, GetTeamsWithActionTriggerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsWithActionTriggerCountQuery, GetTeamsWithActionTriggerCountQueryVariables>(GetTeamsWithActionTriggerCountDocument, options);
      }
export function useGetTeamsWithActionTriggerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsWithActionTriggerCountQuery, GetTeamsWithActionTriggerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsWithActionTriggerCountQuery, GetTeamsWithActionTriggerCountQueryVariables>(GetTeamsWithActionTriggerCountDocument, options);
        }
export type GetTeamsWithActionTriggerCountQueryHookResult = ReturnType<typeof useGetTeamsWithActionTriggerCountQuery>;
export type GetTeamsWithActionTriggerCountLazyQueryHookResult = ReturnType<typeof useGetTeamsWithActionTriggerCountLazyQuery>;
export type GetTeamsWithActionTriggerCountQueryResult = Apollo.QueryResult<GetTeamsWithActionTriggerCountQuery, GetTeamsWithActionTriggerCountQueryVariables>;
export const GetTransformationDefinitionsDocument = gql`
    query GetTransformationDefinitions($input: TransformationDefinitionsInput) {
  transformationDefinitions(input: $input) {
    edges {
      node {
        ...TransformationDefinition
      }
    }
  }
}
    ${TransformationDefinitionFragmentDoc}`;

/**
 * __useGetTransformationDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetTransformationDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransformationDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransformationDefinitionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTransformationDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransformationDefinitionsQuery, GetTransformationDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransformationDefinitionsQuery, GetTransformationDefinitionsQueryVariables>(GetTransformationDefinitionsDocument, options);
      }
export function useGetTransformationDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransformationDefinitionsQuery, GetTransformationDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransformationDefinitionsQuery, GetTransformationDefinitionsQueryVariables>(GetTransformationDefinitionsDocument, options);
        }
export type GetTransformationDefinitionsQueryHookResult = ReturnType<typeof useGetTransformationDefinitionsQuery>;
export type GetTransformationDefinitionsLazyQueryHookResult = ReturnType<typeof useGetTransformationDefinitionsLazyQuery>;
export type GetTransformationDefinitionsQueryResult = Apollo.QueryResult<GetTransformationDefinitionsQuery, GetTransformationDefinitionsQueryVariables>;
export const GetWebhookSubscriptionsDocument = gql`
    query GetWebhookSubscriptions($input: WebhookSubscriptionsInput!) {
  webhookSubscriptions(input: $input) {
    items {
      ...WebhookSubscriptionDetail
    }
  }
}
    ${WebhookSubscriptionDetailFragmentDoc}`;

/**
 * __useGetWebhookSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetWebhookSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhookSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhookSubscriptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWebhookSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>(GetWebhookSubscriptionsDocument, options);
      }
export function useGetWebhookSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>(GetWebhookSubscriptionsDocument, options);
        }
export type GetWebhookSubscriptionsQueryHookResult = ReturnType<typeof useGetWebhookSubscriptionsQuery>;
export type GetWebhookSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetWebhookSubscriptionsLazyQuery>;
export type GetWebhookSubscriptionsQueryResult = Apollo.QueryResult<GetWebhookSubscriptionsQuery, GetWebhookSubscriptionsQueryVariables>;
export const GetWorkflowsDocument = gql`
    query GetWorkflows($input: WorkflowsInput) {
  workflows(input: $input) {
    edges {
      node {
        ...Workflow
      }
    }
  }
}
    ${WorkflowFragmentDoc}`;

/**
 * __useGetWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
      }
export function useGetWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
        }
export type GetWorkflowsQueryHookResult = ReturnType<typeof useGetWorkflowsQuery>;
export type GetWorkflowsLazyQueryHookResult = ReturnType<typeof useGetWorkflowsLazyQuery>;
export type GetWorkflowsQueryResult = Apollo.QueryResult<GetWorkflowsQuery, GetWorkflowsQueryVariables>;
export const HasIntegrationCredentialsDocument = gql`
    query HasIntegrationCredentials($input: HasIntegrationCredentialsInput!) {
  hasIntegrationCredentials(input: $input) {
    hasIntegrationCredentials
  }
}
    `;

/**
 * __useHasIntegrationCredentialsQuery__
 *
 * To run a query within a React component, call `useHasIntegrationCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasIntegrationCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasIntegrationCredentialsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasIntegrationCredentialsQuery(baseOptions: Apollo.QueryHookOptions<HasIntegrationCredentialsQuery, HasIntegrationCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasIntegrationCredentialsQuery, HasIntegrationCredentialsQueryVariables>(HasIntegrationCredentialsDocument, options);
      }
export function useHasIntegrationCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasIntegrationCredentialsQuery, HasIntegrationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasIntegrationCredentialsQuery, HasIntegrationCredentialsQueryVariables>(HasIntegrationCredentialsDocument, options);
        }
export type HasIntegrationCredentialsQueryHookResult = ReturnType<typeof useHasIntegrationCredentialsQuery>;
export type HasIntegrationCredentialsLazyQueryHookResult = ReturnType<typeof useHasIntegrationCredentialsLazyQuery>;
export type HasIntegrationCredentialsQueryResult = Apollo.QueryResult<HasIntegrationCredentialsQuery, HasIntegrationCredentialsQueryVariables>;
export const GetLaneHistoryDocument = gql`
    query GetLaneHistory($input: QuotesInput, $first: Int, $last: Int, $before: String, $after: String) {
  quotes(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...QuoteHistorySummary
      }
    }
  }
}
    ${QuoteHistorySummaryFragmentDoc}`;

/**
 * __useGetLaneHistoryQuery__
 *
 * To run a query within a React component, call `useGetLaneHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaneHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaneHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetLaneHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetLaneHistoryQuery, GetLaneHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaneHistoryQuery, GetLaneHistoryQueryVariables>(GetLaneHistoryDocument, options);
      }
export function useGetLaneHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaneHistoryQuery, GetLaneHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaneHistoryQuery, GetLaneHistoryQueryVariables>(GetLaneHistoryDocument, options);
        }
export type GetLaneHistoryQueryHookResult = ReturnType<typeof useGetLaneHistoryQuery>;
export type GetLaneHistoryLazyQueryHookResult = ReturnType<typeof useGetLaneHistoryLazyQuery>;
export type GetLaneHistoryQueryResult = Apollo.QueryResult<GetLaneHistoryQuery, GetLaneHistoryQueryVariables>;
export const DownloadActionDefinitionDocument = gql`
    query DownloadActionDefinition($input: DownloadActionDefinitionInput!) {
  downloadActionDefinition(input: $input) {
    downloadUrl
    actionDefinitionIds
  }
}
    `;

/**
 * __useDownloadActionDefinitionQuery__
 *
 * To run a query within a React component, call `useDownloadActionDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadActionDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadActionDefinitionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadActionDefinitionQuery(baseOptions: Apollo.QueryHookOptions<DownloadActionDefinitionQuery, DownloadActionDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadActionDefinitionQuery, DownloadActionDefinitionQueryVariables>(DownloadActionDefinitionDocument, options);
      }
export function useDownloadActionDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadActionDefinitionQuery, DownloadActionDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadActionDefinitionQuery, DownloadActionDefinitionQueryVariables>(DownloadActionDefinitionDocument, options);
        }
export type DownloadActionDefinitionQueryHookResult = ReturnType<typeof useDownloadActionDefinitionQuery>;
export type DownloadActionDefinitionLazyQueryHookResult = ReturnType<typeof useDownloadActionDefinitionLazyQuery>;
export type DownloadActionDefinitionQueryResult = Apollo.QueryResult<DownloadActionDefinitionQuery, DownloadActionDefinitionQueryVariables>;
export const ActionDefinitionDocument = gql`
    query ActionDefinition($id: ID!) {
  actionDefinitionById(id: $id) {
    ...ActionDefinition
  }
}
    ${ActionDefinitionFragmentDoc}`;

/**
 * __useActionDefinitionQuery__
 *
 * To run a query within a React component, call `useActionDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionDefinitionQuery(baseOptions: Apollo.QueryHookOptions<ActionDefinitionQuery, ActionDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionDefinitionQuery, ActionDefinitionQueryVariables>(ActionDefinitionDocument, options);
      }
export function useActionDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionDefinitionQuery, ActionDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionDefinitionQuery, ActionDefinitionQueryVariables>(ActionDefinitionDocument, options);
        }
export type ActionDefinitionQueryHookResult = ReturnType<typeof useActionDefinitionQuery>;
export type ActionDefinitionLazyQueryHookResult = ReturnType<typeof useActionDefinitionLazyQuery>;
export type ActionDefinitionQueryResult = Apollo.QueryResult<ActionDefinitionQuery, ActionDefinitionQueryVariables>;
export const ActionDefinitionHierarchyPreviewsDocument = gql`
    query ActionDefinitionHierarchyPreviews($input: ActionDefinitionsInput!) {
  actionDefinitions(input: $input) {
    edges {
      node {
        ...ActionDefinitionHierarchyPreview
      }
    }
  }
}
    ${ActionDefinitionHierarchyPreviewFragmentDoc}`;

/**
 * __useActionDefinitionHierarchyPreviewsQuery__
 *
 * To run a query within a React component, call `useActionDefinitionHierarchyPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionDefinitionHierarchyPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionDefinitionHierarchyPreviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionDefinitionHierarchyPreviewsQuery(baseOptions: Apollo.QueryHookOptions<ActionDefinitionHierarchyPreviewsQuery, ActionDefinitionHierarchyPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionDefinitionHierarchyPreviewsQuery, ActionDefinitionHierarchyPreviewsQueryVariables>(ActionDefinitionHierarchyPreviewsDocument, options);
      }
export function useActionDefinitionHierarchyPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionDefinitionHierarchyPreviewsQuery, ActionDefinitionHierarchyPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionDefinitionHierarchyPreviewsQuery, ActionDefinitionHierarchyPreviewsQueryVariables>(ActionDefinitionHierarchyPreviewsDocument, options);
        }
export type ActionDefinitionHierarchyPreviewsQueryHookResult = ReturnType<typeof useActionDefinitionHierarchyPreviewsQuery>;
export type ActionDefinitionHierarchyPreviewsLazyQueryHookResult = ReturnType<typeof useActionDefinitionHierarchyPreviewsLazyQuery>;
export type ActionDefinitionHierarchyPreviewsQueryResult = Apollo.QueryResult<ActionDefinitionHierarchyPreviewsQuery, ActionDefinitionHierarchyPreviewsQueryVariables>;
export const ActionDefinitionPreviewDocument = gql`
    query ActionDefinitionPreview($id: ID!) {
  actionDefinitionById(id: $id) {
    ...ActionDefinitionPreview
  }
}
    ${ActionDefinitionPreviewFragmentDoc}`;

/**
 * __useActionDefinitionPreviewQuery__
 *
 * To run a query within a React component, call `useActionDefinitionPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionDefinitionPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionDefinitionPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionDefinitionPreviewQuery(baseOptions: Apollo.QueryHookOptions<ActionDefinitionPreviewQuery, ActionDefinitionPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionDefinitionPreviewQuery, ActionDefinitionPreviewQueryVariables>(ActionDefinitionPreviewDocument, options);
      }
export function useActionDefinitionPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionDefinitionPreviewQuery, ActionDefinitionPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionDefinitionPreviewQuery, ActionDefinitionPreviewQueryVariables>(ActionDefinitionPreviewDocument, options);
        }
export type ActionDefinitionPreviewQueryHookResult = ReturnType<typeof useActionDefinitionPreviewQuery>;
export type ActionDefinitionPreviewLazyQueryHookResult = ReturnType<typeof useActionDefinitionPreviewLazyQuery>;
export type ActionDefinitionPreviewQueryResult = Apollo.QueryResult<ActionDefinitionPreviewQuery, ActionDefinitionPreviewQueryVariables>;
export const ActionDefinitionPreviewsDocument = gql`
    query ActionDefinitionPreviews($input: ActionDefinitionsInput!) {
  actionDefinitions(input: $input) {
    edges {
      node {
        ...ActionDefinitionPreview
      }
    }
  }
}
    ${ActionDefinitionPreviewFragmentDoc}`;

/**
 * __useActionDefinitionPreviewsQuery__
 *
 * To run a query within a React component, call `useActionDefinitionPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionDefinitionPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionDefinitionPreviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionDefinitionPreviewsQuery(baseOptions: Apollo.QueryHookOptions<ActionDefinitionPreviewsQuery, ActionDefinitionPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionDefinitionPreviewsQuery, ActionDefinitionPreviewsQueryVariables>(ActionDefinitionPreviewsDocument, options);
      }
export function useActionDefinitionPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionDefinitionPreviewsQuery, ActionDefinitionPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionDefinitionPreviewsQuery, ActionDefinitionPreviewsQueryVariables>(ActionDefinitionPreviewsDocument, options);
        }
export type ActionDefinitionPreviewsQueryHookResult = ReturnType<typeof useActionDefinitionPreviewsQuery>;
export type ActionDefinitionPreviewsLazyQueryHookResult = ReturnType<typeof useActionDefinitionPreviewsLazyQuery>;
export type ActionDefinitionPreviewsQueryResult = Apollo.QueryResult<ActionDefinitionPreviewsQuery, ActionDefinitionPreviewsQueryVariables>;
export const ActionDefinitionTagsDocument = gql`
    query ActionDefinitionTags($input: ActionDefinitionTagsInput!) {
  actionDefinitionTags(input: $input) {
    tags
  }
}
    `;

/**
 * __useActionDefinitionTagsQuery__
 *
 * To run a query within a React component, call `useActionDefinitionTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionDefinitionTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionDefinitionTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionDefinitionTagsQuery(baseOptions: Apollo.QueryHookOptions<ActionDefinitionTagsQuery, ActionDefinitionTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionDefinitionTagsQuery, ActionDefinitionTagsQueryVariables>(ActionDefinitionTagsDocument, options);
      }
export function useActionDefinitionTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionDefinitionTagsQuery, ActionDefinitionTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionDefinitionTagsQuery, ActionDefinitionTagsQueryVariables>(ActionDefinitionTagsDocument, options);
        }
export type ActionDefinitionTagsQueryHookResult = ReturnType<typeof useActionDefinitionTagsQuery>;
export type ActionDefinitionTagsLazyQueryHookResult = ReturnType<typeof useActionDefinitionTagsLazyQuery>;
export type ActionDefinitionTagsQueryResult = Apollo.QueryResult<ActionDefinitionTagsQuery, ActionDefinitionTagsQueryVariables>;
export const GetActionDefinitionsUsedAsParentsDocument = gql`
    query GetActionDefinitionsUsedAsParents($input: GetActionDefinitionsUsedAsParentsInput!) {
  getActionDefinitionsUsedAsParents(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useGetActionDefinitionsUsedAsParentsQuery__
 *
 * To run a query within a React component, call `useGetActionDefinitionsUsedAsParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionDefinitionsUsedAsParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionDefinitionsUsedAsParentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActionDefinitionsUsedAsParentsQuery(baseOptions: Apollo.QueryHookOptions<GetActionDefinitionsUsedAsParentsQuery, GetActionDefinitionsUsedAsParentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionDefinitionsUsedAsParentsQuery, GetActionDefinitionsUsedAsParentsQueryVariables>(GetActionDefinitionsUsedAsParentsDocument, options);
      }
export function useGetActionDefinitionsUsedAsParentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionDefinitionsUsedAsParentsQuery, GetActionDefinitionsUsedAsParentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionDefinitionsUsedAsParentsQuery, GetActionDefinitionsUsedAsParentsQueryVariables>(GetActionDefinitionsUsedAsParentsDocument, options);
        }
export type GetActionDefinitionsUsedAsParentsQueryHookResult = ReturnType<typeof useGetActionDefinitionsUsedAsParentsQuery>;
export type GetActionDefinitionsUsedAsParentsLazyQueryHookResult = ReturnType<typeof useGetActionDefinitionsUsedAsParentsLazyQuery>;
export type GetActionDefinitionsUsedAsParentsQueryResult = Apollo.QueryResult<GetActionDefinitionsUsedAsParentsQuery, GetActionDefinitionsUsedAsParentsQueryVariables>;
export const GetGraphqlToolCatalogDocument = gql`
    query GetGraphqlToolCatalog {
  graphqlToolCatalog {
    name
    description
  }
}
    `;

/**
 * __useGetGraphqlToolCatalogQuery__
 *
 * To run a query within a React component, call `useGetGraphqlToolCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphqlToolCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphqlToolCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGraphqlToolCatalogQuery(baseOptions?: Apollo.QueryHookOptions<GetGraphqlToolCatalogQuery, GetGraphqlToolCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphqlToolCatalogQuery, GetGraphqlToolCatalogQueryVariables>(GetGraphqlToolCatalogDocument, options);
      }
export function useGetGraphqlToolCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphqlToolCatalogQuery, GetGraphqlToolCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphqlToolCatalogQuery, GetGraphqlToolCatalogQueryVariables>(GetGraphqlToolCatalogDocument, options);
        }
export type GetGraphqlToolCatalogQueryHookResult = ReturnType<typeof useGetGraphqlToolCatalogQuery>;
export type GetGraphqlToolCatalogLazyQueryHookResult = ReturnType<typeof useGetGraphqlToolCatalogLazyQuery>;
export type GetGraphqlToolCatalogQueryResult = Apollo.QueryResult<GetGraphqlToolCatalogQuery, GetGraphqlToolCatalogQueryVariables>;
export const QuoteSimulationActionDefinitionDocument = gql`
    query QuoteSimulationActionDefinition($input: GetQuoteSimulationsInput!) {
  getQuoteSimulationsActionDefinition(input: $input) {
    quoteSimulationId
  }
}
    `;

/**
 * __useQuoteSimulationActionDefinitionQuery__
 *
 * To run a query within a React component, call `useQuoteSimulationActionDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteSimulationActionDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteSimulationActionDefinitionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuoteSimulationActionDefinitionQuery(baseOptions: Apollo.QueryHookOptions<QuoteSimulationActionDefinitionQuery, QuoteSimulationActionDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteSimulationActionDefinitionQuery, QuoteSimulationActionDefinitionQueryVariables>(QuoteSimulationActionDefinitionDocument, options);
      }
export function useQuoteSimulationActionDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteSimulationActionDefinitionQuery, QuoteSimulationActionDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteSimulationActionDefinitionQuery, QuoteSimulationActionDefinitionQueryVariables>(QuoteSimulationActionDefinitionDocument, options);
        }
export type QuoteSimulationActionDefinitionQueryHookResult = ReturnType<typeof useQuoteSimulationActionDefinitionQuery>;
export type QuoteSimulationActionDefinitionLazyQueryHookResult = ReturnType<typeof useQuoteSimulationActionDefinitionLazyQuery>;
export type QuoteSimulationActionDefinitionQueryResult = Apollo.QueryResult<QuoteSimulationActionDefinitionQuery, QuoteSimulationActionDefinitionQueryVariables>;
export const RootSopsForProvisioningDocument = gql`
    query RootSopsForProvisioning($input: RootSOPsForProvisioningInput!) {
  rootSOPsForProvisioning(input: $input) {
    rootSOPsForProvisioning {
      provisioningResourceId
      provisioningResourceName
      actionDefinitions {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useRootSopsForProvisioningQuery__
 *
 * To run a query within a React component, call `useRootSopsForProvisioningQuery` and pass it any options that fit your needs.
 * When your component renders, `useRootSopsForProvisioningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRootSopsForProvisioningQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRootSopsForProvisioningQuery(baseOptions: Apollo.QueryHookOptions<RootSopsForProvisioningQuery, RootSopsForProvisioningQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RootSopsForProvisioningQuery, RootSopsForProvisioningQueryVariables>(RootSopsForProvisioningDocument, options);
      }
export function useRootSopsForProvisioningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RootSopsForProvisioningQuery, RootSopsForProvisioningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RootSopsForProvisioningQuery, RootSopsForProvisioningQueryVariables>(RootSopsForProvisioningDocument, options);
        }
export type RootSopsForProvisioningQueryHookResult = ReturnType<typeof useRootSopsForProvisioningQuery>;
export type RootSopsForProvisioningLazyQueryHookResult = ReturnType<typeof useRootSopsForProvisioningLazyQuery>;
export type RootSopsForProvisioningQueryResult = Apollo.QueryResult<RootSopsForProvisioningQuery, RootSopsForProvisioningQueryVariables>;
export const ToolValidationSchemaInputDocument = gql`
    query ToolValidationSchemaInput($input: ToolValidationSchemaInput!) {
  toolInputValidationSchema(input: $input) {
    jsonSchema
  }
}
    `;

/**
 * __useToolValidationSchemaInputQuery__
 *
 * To run a query within a React component, call `useToolValidationSchemaInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useToolValidationSchemaInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToolValidationSchemaInputQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToolValidationSchemaInputQuery(baseOptions: Apollo.QueryHookOptions<ToolValidationSchemaInputQuery, ToolValidationSchemaInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToolValidationSchemaInputQuery, ToolValidationSchemaInputQueryVariables>(ToolValidationSchemaInputDocument, options);
      }
export function useToolValidationSchemaInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToolValidationSchemaInputQuery, ToolValidationSchemaInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToolValidationSchemaInputQuery, ToolValidationSchemaInputQueryVariables>(ToolValidationSchemaInputDocument, options);
        }
export type ToolValidationSchemaInputQueryHookResult = ReturnType<typeof useToolValidationSchemaInputQuery>;
export type ToolValidationSchemaInputLazyQueryHookResult = ReturnType<typeof useToolValidationSchemaInputLazyQuery>;
export type ToolValidationSchemaInputQueryResult = Apollo.QueryResult<ToolValidationSchemaInputQuery, ToolValidationSchemaInputQueryVariables>;
export const ActionExecutionBreadcrumbDocument = gql`
    query ActionExecutionBreadcrumb($id: ID!) {
  actionExecutionById(id: $id) {
    id
    parentId
    actionDefinition {
      id
      name
      procedure {
        ...NaturalLanguageProcedurePreview
        ...GraphDefinedProcedurePreview
        ...ConversationGraphProcedurePreview
        ...DeterministicProcedurePreview
      }
    }
    linkedConversations {
      id
      externalIdentifier
      type
      createdAt
      metadata {
        ... on PhoneConversationMetadata {
          fromPhoneNumber
          toPhoneNumber
        }
      }
    }
  }
}
    ${NaturalLanguageProcedurePreviewFragmentDoc}
${GraphDefinedProcedurePreviewFragmentDoc}
${ConversationGraphProcedurePreviewFragmentDoc}
${DeterministicProcedurePreviewFragmentDoc}`;

/**
 * __useActionExecutionBreadcrumbQuery__
 *
 * To run a query within a React component, call `useActionExecutionBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionExecutionBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionExecutionBreadcrumbQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionExecutionBreadcrumbQuery(baseOptions: Apollo.QueryHookOptions<ActionExecutionBreadcrumbQuery, ActionExecutionBreadcrumbQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionExecutionBreadcrumbQuery, ActionExecutionBreadcrumbQueryVariables>(ActionExecutionBreadcrumbDocument, options);
      }
export function useActionExecutionBreadcrumbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionExecutionBreadcrumbQuery, ActionExecutionBreadcrumbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionExecutionBreadcrumbQuery, ActionExecutionBreadcrumbQueryVariables>(ActionExecutionBreadcrumbDocument, options);
        }
export type ActionExecutionBreadcrumbQueryHookResult = ReturnType<typeof useActionExecutionBreadcrumbQuery>;
export type ActionExecutionBreadcrumbLazyQueryHookResult = ReturnType<typeof useActionExecutionBreadcrumbLazyQuery>;
export type ActionExecutionBreadcrumbQueryResult = Apollo.QueryResult<ActionExecutionBreadcrumbQuery, ActionExecutionBreadcrumbQueryVariables>;
export const ActionExecutionSummariesDocument = gql`
    query ActionExecutionSummaries($input: ActionExecutionSummariesInput!) {
  actionExecutionSummaries(input: $input) {
    all
    inProgress
    failedOrPaused
  }
}
    `;

/**
 * __useActionExecutionSummariesQuery__
 *
 * To run a query within a React component, call `useActionExecutionSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionExecutionSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionExecutionSummariesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionExecutionSummariesQuery(baseOptions: Apollo.QueryHookOptions<ActionExecutionSummariesQuery, ActionExecutionSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionExecutionSummariesQuery, ActionExecutionSummariesQueryVariables>(ActionExecutionSummariesDocument, options);
      }
export function useActionExecutionSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionExecutionSummariesQuery, ActionExecutionSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionExecutionSummariesQuery, ActionExecutionSummariesQueryVariables>(ActionExecutionSummariesDocument, options);
        }
export type ActionExecutionSummariesQueryHookResult = ReturnType<typeof useActionExecutionSummariesQuery>;
export type ActionExecutionSummariesLazyQueryHookResult = ReturnType<typeof useActionExecutionSummariesLazyQuery>;
export type ActionExecutionSummariesQueryResult = Apollo.QueryResult<ActionExecutionSummariesQuery, ActionExecutionSummariesQueryVariables>;
export const ActionExecutionDocument = gql`
    query ActionExecution($id: ID!) {
  actionExecutionById(id: $id) {
    ...ActionExecution
  }
}
    ${ActionExecutionFragmentDoc}`;

/**
 * __useActionExecutionQuery__
 *
 * To run a query within a React component, call `useActionExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionExecutionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionExecutionQuery(baseOptions: Apollo.QueryHookOptions<ActionExecutionQuery, ActionExecutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionExecutionQuery, ActionExecutionQueryVariables>(ActionExecutionDocument, options);
      }
export function useActionExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionExecutionQuery, ActionExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionExecutionQuery, ActionExecutionQueryVariables>(ActionExecutionDocument, options);
        }
export type ActionExecutionQueryHookResult = ReturnType<typeof useActionExecutionQuery>;
export type ActionExecutionLazyQueryHookResult = ReturnType<typeof useActionExecutionLazyQuery>;
export type ActionExecutionQueryResult = Apollo.QueryResult<ActionExecutionQuery, ActionExecutionQueryVariables>;
export const ActionExecutionCreditsDocument = gql`
    query ActionExecutionCredits($id: ID!) {
  actionExecutionCredits(id: $id) {
    actionExecutionId
    ownCredits
    downstreamCredits
    totalCredits
    downstream {
      actionExecutionId
      causedByActionExecutionId
      actionDefinitionId
      actionDefinitionName
      depth
      credits
    }
  }
}
    `;

/**
 * __useActionExecutionCreditsQuery__
 *
 * To run a query within a React component, call `useActionExecutionCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionExecutionCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionExecutionCreditsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionExecutionCreditsQuery(baseOptions: Apollo.QueryHookOptions<ActionExecutionCreditsQuery, ActionExecutionCreditsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionExecutionCreditsQuery, ActionExecutionCreditsQueryVariables>(ActionExecutionCreditsDocument, options);
      }
export function useActionExecutionCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionExecutionCreditsQuery, ActionExecutionCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionExecutionCreditsQuery, ActionExecutionCreditsQueryVariables>(ActionExecutionCreditsDocument, options);
        }
export type ActionExecutionCreditsQueryHookResult = ReturnType<typeof useActionExecutionCreditsQuery>;
export type ActionExecutionCreditsLazyQueryHookResult = ReturnType<typeof useActionExecutionCreditsLazyQuery>;
export type ActionExecutionCreditsQueryResult = Apollo.QueryResult<ActionExecutionCreditsQuery, ActionExecutionCreditsQueryVariables>;
export const ActionExecutionWithDescendantsDocument = gql`
    query ActionExecutionWithDescendants($id: ID!) {
  actionExecutionWithDescendants(id: $id) {
    actionExecutions {
      ...ActionExecution
    }
    conversationEvents {
      ...ConversationEvent
      conversationId
    }
    externalMessages {
      ...ExternalMessage
    }
  }
}
    ${ActionExecutionFragmentDoc}
${ConversationEventFragmentDoc}
${ExternalMessageFragmentDoc}`;

/**
 * __useActionExecutionWithDescendantsQuery__
 *
 * To run a query within a React component, call `useActionExecutionWithDescendantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionExecutionWithDescendantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionExecutionWithDescendantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionExecutionWithDescendantsQuery(baseOptions: Apollo.QueryHookOptions<ActionExecutionWithDescendantsQuery, ActionExecutionWithDescendantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionExecutionWithDescendantsQuery, ActionExecutionWithDescendantsQueryVariables>(ActionExecutionWithDescendantsDocument, options);
      }
export function useActionExecutionWithDescendantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionExecutionWithDescendantsQuery, ActionExecutionWithDescendantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionExecutionWithDescendantsQuery, ActionExecutionWithDescendantsQueryVariables>(ActionExecutionWithDescendantsDocument, options);
        }
export type ActionExecutionWithDescendantsQueryHookResult = ReturnType<typeof useActionExecutionWithDescendantsQuery>;
export type ActionExecutionWithDescendantsLazyQueryHookResult = ReturnType<typeof useActionExecutionWithDescendantsLazyQuery>;
export type ActionExecutionWithDescendantsQueryResult = Apollo.QueryResult<ActionExecutionWithDescendantsQuery, ActionExecutionWithDescendantsQueryVariables>;
export const ActionExecutionsDocument = gql`
    query ActionExecutions($input: ActionExecutionInput!, $after: String) {
  actionExecutions(input: $input, after: $after) {
    edges {
      node {
        ...ActionExecution
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      hasNextPage
      endCursor
    }
  }
}
    ${ActionExecutionFragmentDoc}`;

/**
 * __useActionExecutionsQuery__
 *
 * To run a query within a React component, call `useActionExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionExecutionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useActionExecutionsQuery(baseOptions: Apollo.QueryHookOptions<ActionExecutionsQuery, ActionExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionExecutionsQuery, ActionExecutionsQueryVariables>(ActionExecutionsDocument, options);
      }
export function useActionExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionExecutionsQuery, ActionExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionExecutionsQuery, ActionExecutionsQueryVariables>(ActionExecutionsDocument, options);
        }
export type ActionExecutionsQueryHookResult = ReturnType<typeof useActionExecutionsQuery>;
export type ActionExecutionsLazyQueryHookResult = ReturnType<typeof useActionExecutionsLazyQuery>;
export type ActionExecutionsQueryResult = Apollo.QueryResult<ActionExecutionsQuery, ActionExecutionsQueryVariables>;
export const InProgressActionExecutionsDocument = gql`
    query InProgressActionExecutions($input: ActionExecutionInput!, $after: String) {
  inProgressActionExecutions(input: $input, after: $after) {
    edges {
      node {
        ...TaskListItem
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      hasNextPage
      endCursor
    }
  }
}
    ${TaskListItemFragmentDoc}`;

/**
 * __useInProgressActionExecutionsQuery__
 *
 * To run a query within a React component, call `useInProgressActionExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProgressActionExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProgressActionExecutionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInProgressActionExecutionsQuery(baseOptions: Apollo.QueryHookOptions<InProgressActionExecutionsQuery, InProgressActionExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InProgressActionExecutionsQuery, InProgressActionExecutionsQueryVariables>(InProgressActionExecutionsDocument, options);
      }
export function useInProgressActionExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InProgressActionExecutionsQuery, InProgressActionExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InProgressActionExecutionsQuery, InProgressActionExecutionsQueryVariables>(InProgressActionExecutionsDocument, options);
        }
export type InProgressActionExecutionsQueryHookResult = ReturnType<typeof useInProgressActionExecutionsQuery>;
export type InProgressActionExecutionsLazyQueryHookResult = ReturnType<typeof useInProgressActionExecutionsLazyQuery>;
export type InProgressActionExecutionsQueryResult = Apollo.QueryResult<InProgressActionExecutionsQuery, InProgressActionExecutionsQueryVariables>;
export const NeedAttentionActionExecutionsDocument = gql`
    query NeedAttentionActionExecutions($input: ActionExecutionInput!, $after: String) {
  needAttentionActionExecutions(input: $input, after: $after) {
    edges {
      node {
        ...TaskListItem
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      hasNextPage
      endCursor
    }
  }
}
    ${TaskListItemFragmentDoc}`;

/**
 * __useNeedAttentionActionExecutionsQuery__
 *
 * To run a query within a React component, call `useNeedAttentionActionExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedAttentionActionExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedAttentionActionExecutionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNeedAttentionActionExecutionsQuery(baseOptions: Apollo.QueryHookOptions<NeedAttentionActionExecutionsQuery, NeedAttentionActionExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NeedAttentionActionExecutionsQuery, NeedAttentionActionExecutionsQueryVariables>(NeedAttentionActionExecutionsDocument, options);
      }
export function useNeedAttentionActionExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NeedAttentionActionExecutionsQuery, NeedAttentionActionExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NeedAttentionActionExecutionsQuery, NeedAttentionActionExecutionsQueryVariables>(NeedAttentionActionExecutionsDocument, options);
        }
export type NeedAttentionActionExecutionsQueryHookResult = ReturnType<typeof useNeedAttentionActionExecutionsQuery>;
export type NeedAttentionActionExecutionsLazyQueryHookResult = ReturnType<typeof useNeedAttentionActionExecutionsLazyQuery>;
export type NeedAttentionActionExecutionsQueryResult = Apollo.QueryResult<NeedAttentionActionExecutionsQuery, NeedAttentionActionExecutionsQueryVariables>;
export const TaskListActionExecutionsDocument = gql`
    query TaskListActionExecutions($input: ActionExecutionInput!, $after: String) {
  actionExecutions(input: $input, after: $after) {
    edges {
      node {
        ...TaskListItem
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
    ${TaskListItemFragmentDoc}`;

/**
 * __useTaskListActionExecutionsQuery__
 *
 * To run a query within a React component, call `useTaskListActionExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskListActionExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskListActionExecutionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTaskListActionExecutionsQuery(baseOptions: Apollo.QueryHookOptions<TaskListActionExecutionsQuery, TaskListActionExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskListActionExecutionsQuery, TaskListActionExecutionsQueryVariables>(TaskListActionExecutionsDocument, options);
      }
export function useTaskListActionExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskListActionExecutionsQuery, TaskListActionExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskListActionExecutionsQuery, TaskListActionExecutionsQueryVariables>(TaskListActionExecutionsDocument, options);
        }
export type TaskListActionExecutionsQueryHookResult = ReturnType<typeof useTaskListActionExecutionsQuery>;
export type TaskListActionExecutionsLazyQueryHookResult = ReturnType<typeof useTaskListActionExecutionsLazyQuery>;
export type TaskListActionExecutionsQueryResult = Apollo.QueryResult<TaskListActionExecutionsQuery, TaskListActionExecutionsQueryVariables>;
export const ActionTriggerValidationDocument = gql`
    query ActionTriggerValidation($input: ActionTriggerValidationInput!) {
  actionTriggerValidation(input: $input) {
    validations {
      validationType
      status
      reasons
      actionDefinitionIds
    }
  }
}
    `;

/**
 * __useActionTriggerValidationQuery__
 *
 * To run a query within a React component, call `useActionTriggerValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionTriggerValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionTriggerValidationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionTriggerValidationQuery(baseOptions: Apollo.QueryHookOptions<ActionTriggerValidationQuery, ActionTriggerValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionTriggerValidationQuery, ActionTriggerValidationQueryVariables>(ActionTriggerValidationDocument, options);
      }
export function useActionTriggerValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionTriggerValidationQuery, ActionTriggerValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionTriggerValidationQuery, ActionTriggerValidationQueryVariables>(ActionTriggerValidationDocument, options);
        }
export type ActionTriggerValidationQueryHookResult = ReturnType<typeof useActionTriggerValidationQuery>;
export type ActionTriggerValidationLazyQueryHookResult = ReturnType<typeof useActionTriggerValidationLazyQuery>;
export type ActionTriggerValidationQueryResult = Apollo.QueryResult<ActionTriggerValidationQuery, ActionTriggerValidationQueryVariables>;
export const ActionTriggerDocument = gql`
    query ActionTrigger($id: ID!) {
  actionTriggerById(id: $id) {
    ...ActionTrigger
  }
}
    ${ActionTriggerFragmentDoc}`;

/**
 * __useActionTriggerQuery__
 *
 * To run a query within a React component, call `useActionTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionTriggerQuery(baseOptions: Apollo.QueryHookOptions<ActionTriggerQuery, ActionTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionTriggerQuery, ActionTriggerQueryVariables>(ActionTriggerDocument, options);
      }
export function useActionTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionTriggerQuery, ActionTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionTriggerQuery, ActionTriggerQueryVariables>(ActionTriggerDocument, options);
        }
export type ActionTriggerQueryHookResult = ReturnType<typeof useActionTriggerQuery>;
export type ActionTriggerLazyQueryHookResult = ReturnType<typeof useActionTriggerLazyQuery>;
export type ActionTriggerQueryResult = Apollo.QueryResult<ActionTriggerQuery, ActionTriggerQueryVariables>;
export const CheckAgentMailAvailabilityDocument = gql`
    query CheckAgentMailAvailability($input: CheckAgentMailAvailabilityInput!) {
  checkAgentMailAvailability(input: $input) {
    available
  }
}
    `;

/**
 * __useCheckAgentMailAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckAgentMailAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAgentMailAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAgentMailAvailabilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckAgentMailAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CheckAgentMailAvailabilityQuery, CheckAgentMailAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAgentMailAvailabilityQuery, CheckAgentMailAvailabilityQueryVariables>(CheckAgentMailAvailabilityDocument, options);
      }
export function useCheckAgentMailAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAgentMailAvailabilityQuery, CheckAgentMailAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAgentMailAvailabilityQuery, CheckAgentMailAvailabilityQueryVariables>(CheckAgentMailAvailabilityDocument, options);
        }
export type CheckAgentMailAvailabilityQueryHookResult = ReturnType<typeof useCheckAgentMailAvailabilityQuery>;
export type CheckAgentMailAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckAgentMailAvailabilityLazyQuery>;
export type CheckAgentMailAvailabilityQueryResult = Apollo.QueryResult<CheckAgentMailAvailabilityQuery, CheckAgentMailAvailabilityQueryVariables>;
export const ListAgentMailDomainsDocument = gql`
    query ListAgentMailDomains {
  listAgentMailDomains {
    domains {
      domainId
      domain
      verified
    }
  }
}
    `;

/**
 * __useListAgentMailDomainsQuery__
 *
 * To run a query within a React component, call `useListAgentMailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAgentMailDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAgentMailDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListAgentMailDomainsQuery(baseOptions?: Apollo.QueryHookOptions<ListAgentMailDomainsQuery, ListAgentMailDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAgentMailDomainsQuery, ListAgentMailDomainsQueryVariables>(ListAgentMailDomainsDocument, options);
      }
export function useListAgentMailDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAgentMailDomainsQuery, ListAgentMailDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAgentMailDomainsQuery, ListAgentMailDomainsQueryVariables>(ListAgentMailDomainsDocument, options);
        }
export type ListAgentMailDomainsQueryHookResult = ReturnType<typeof useListAgentMailDomainsQuery>;
export type ListAgentMailDomainsLazyQueryHookResult = ReturnType<typeof useListAgentMailDomainsLazyQuery>;
export type ListAgentMailDomainsQueryResult = Apollo.QueryResult<ListAgentMailDomainsQuery, ListAgentMailDomainsQueryVariables>;
export const GetBraintrustDatasetsDocument = gql`
    query GetBraintrustDatasets($input: GetBraintrustDatasetsInput) {
  getBraintrustDatasets(input: $input) {
    id
    name
    description
    created
  }
}
    `;

/**
 * __useGetBraintrustDatasetsQuery__
 *
 * To run a query within a React component, call `useGetBraintrustDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBraintrustDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBraintrustDatasetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBraintrustDatasetsQuery(baseOptions?: Apollo.QueryHookOptions<GetBraintrustDatasetsQuery, GetBraintrustDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBraintrustDatasetsQuery, GetBraintrustDatasetsQueryVariables>(GetBraintrustDatasetsDocument, options);
      }
export function useGetBraintrustDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBraintrustDatasetsQuery, GetBraintrustDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBraintrustDatasetsQuery, GetBraintrustDatasetsQueryVariables>(GetBraintrustDatasetsDocument, options);
        }
export type GetBraintrustDatasetsQueryHookResult = ReturnType<typeof useGetBraintrustDatasetsQuery>;
export type GetBraintrustDatasetsLazyQueryHookResult = ReturnType<typeof useGetBraintrustDatasetsLazyQuery>;
export type GetBraintrustDatasetsQueryResult = Apollo.QueryResult<GetBraintrustDatasetsQuery, GetBraintrustDatasetsQueryVariables>;
export const GetCarrierLaneRunsForLaneDocument = gql`
    query GetCarrierLaneRunsForLane($movementId: ID!, $radiusMiles: Float, $lookbackDays: Float) {
  carrierLaneRunsForLane(
    input: {movementId: $movementId, radiusMiles: $radiusMiles, lookbackDays: $lookbackDays}
  ) {
    carrier {
      ...Carrier
    }
    runCount
    lastRunDate
    lastRunRate
  }
}
    ${CarrierFragmentDoc}`;

/**
 * __useGetCarrierLaneRunsForLaneQuery__
 *
 * To run a query within a React component, call `useGetCarrierLaneRunsForLaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierLaneRunsForLaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierLaneRunsForLaneQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *      radiusMiles: // value for 'radiusMiles'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useGetCarrierLaneRunsForLaneQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierLaneRunsForLaneQuery, GetCarrierLaneRunsForLaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierLaneRunsForLaneQuery, GetCarrierLaneRunsForLaneQueryVariables>(GetCarrierLaneRunsForLaneDocument, options);
      }
export function useGetCarrierLaneRunsForLaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierLaneRunsForLaneQuery, GetCarrierLaneRunsForLaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierLaneRunsForLaneQuery, GetCarrierLaneRunsForLaneQueryVariables>(GetCarrierLaneRunsForLaneDocument, options);
        }
export type GetCarrierLaneRunsForLaneQueryHookResult = ReturnType<typeof useGetCarrierLaneRunsForLaneQuery>;
export type GetCarrierLaneRunsForLaneLazyQueryHookResult = ReturnType<typeof useGetCarrierLaneRunsForLaneLazyQuery>;
export type GetCarrierLaneRunsForLaneQueryResult = Apollo.QueryResult<GetCarrierLaneRunsForLaneQuery, GetCarrierLaneRunsForLaneQueryVariables>;
export const GetCarrierRatesForLaneDocument = gql`
    query GetCarrierRatesForLane($movementId: ID!, $radiusMiles: Float, $lookbackDays: Float) {
  carrierRatesForLane(
    input: {movementId: $movementId, radiusMiles: $radiusMiles, lookbackDays: $lookbackDays}
  ) {
    ...CarrierRate
  }
}
    ${CarrierRateFragmentDoc}`;

/**
 * __useGetCarrierRatesForLaneQuery__
 *
 * To run a query within a React component, call `useGetCarrierRatesForLaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierRatesForLaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierRatesForLaneQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *      radiusMiles: // value for 'radiusMiles'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useGetCarrierRatesForLaneQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierRatesForLaneQuery, GetCarrierRatesForLaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierRatesForLaneQuery, GetCarrierRatesForLaneQueryVariables>(GetCarrierRatesForLaneDocument, options);
      }
export function useGetCarrierRatesForLaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierRatesForLaneQuery, GetCarrierRatesForLaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierRatesForLaneQuery, GetCarrierRatesForLaneQueryVariables>(GetCarrierRatesForLaneDocument, options);
        }
export type GetCarrierRatesForLaneQueryHookResult = ReturnType<typeof useGetCarrierRatesForLaneQuery>;
export type GetCarrierRatesForLaneLazyQueryHookResult = ReturnType<typeof useGetCarrierRatesForLaneLazyQuery>;
export type GetCarrierRatesForLaneQueryResult = Apollo.QueryResult<GetCarrierRatesForLaneQuery, GetCarrierRatesForLaneQueryVariables>;
export const GetExistingCarriersDocument = gql`
    query GetExistingCarriers($input: GetExistingCarriersInput!, $first: Int, $last: Int, $before: String, $after: String, $limit: Int) {
  getExistingCarriers(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    limit: $limit
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        name
        dotNumber
        mcNumber
        organization {
          id
        }
        contacts {
          id
          name
          email
          phone
          isVerified
        }
      }
    }
    nodes {
      id
      name
      dotNumber
      mcNumber
      contacts {
        id
        name
        email
        phone
        isVerified
      }
    }
    count
    totalCount
  }
}
    `;

/**
 * __useGetExistingCarriersQuery__
 *
 * To run a query within a React component, call `useGetExistingCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingCarriersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetExistingCarriersQuery(baseOptions: Apollo.QueryHookOptions<GetExistingCarriersQuery, GetExistingCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingCarriersQuery, GetExistingCarriersQueryVariables>(GetExistingCarriersDocument, options);
      }
export function useGetExistingCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingCarriersQuery, GetExistingCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingCarriersQuery, GetExistingCarriersQueryVariables>(GetExistingCarriersDocument, options);
        }
export type GetExistingCarriersQueryHookResult = ReturnType<typeof useGetExistingCarriersQuery>;
export type GetExistingCarriersLazyQueryHookResult = ReturnType<typeof useGetExistingCarriersLazyQuery>;
export type GetExistingCarriersQueryResult = Apollo.QueryResult<GetExistingCarriersQuery, GetExistingCarriersQueryVariables>;
export const GetIntegratedCarrierVerificationIntegrationsDocument = gql`
    query GetIntegratedCarrierVerificationIntegrations($organizationId: String!) {
  integratedCarrierVerificationIntegrations(organizationId: $organizationId)
}
    `;

/**
 * __useGetIntegratedCarrierVerificationIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegratedCarrierVerificationIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegratedCarrierVerificationIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegratedCarrierVerificationIntegrationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetIntegratedCarrierVerificationIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegratedCarrierVerificationIntegrationsQuery, GetIntegratedCarrierVerificationIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegratedCarrierVerificationIntegrationsQuery, GetIntegratedCarrierVerificationIntegrationsQueryVariables>(GetIntegratedCarrierVerificationIntegrationsDocument, options);
      }
export function useGetIntegratedCarrierVerificationIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegratedCarrierVerificationIntegrationsQuery, GetIntegratedCarrierVerificationIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegratedCarrierVerificationIntegrationsQuery, GetIntegratedCarrierVerificationIntegrationsQueryVariables>(GetIntegratedCarrierVerificationIntegrationsDocument, options);
        }
export type GetIntegratedCarrierVerificationIntegrationsQueryHookResult = ReturnType<typeof useGetIntegratedCarrierVerificationIntegrationsQuery>;
export type GetIntegratedCarrierVerificationIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegratedCarrierVerificationIntegrationsLazyQuery>;
export type GetIntegratedCarrierVerificationIntegrationsQueryResult = Apollo.QueryResult<GetIntegratedCarrierVerificationIntegrationsQuery, GetIntegratedCarrierVerificationIntegrationsQueryVariables>;
export const GetSuggestedCarriersDocument = gql`
    query GetSuggestedCarriers($input: GetSuggestedCarriersInput!) {
  getSuggestedCarriers(input: $input) {
    suggestedCarriers {
      mcNumber
      carrierName
      phoneNumber
      email
    }
  }
}
    `;

/**
 * __useGetSuggestedCarriersQuery__
 *
 * To run a query within a React component, call `useGetSuggestedCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedCarriersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSuggestedCarriersQuery(baseOptions: Apollo.QueryHookOptions<GetSuggestedCarriersQuery, GetSuggestedCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuggestedCarriersQuery, GetSuggestedCarriersQueryVariables>(GetSuggestedCarriersDocument, options);
      }
export function useGetSuggestedCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuggestedCarriersQuery, GetSuggestedCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuggestedCarriersQuery, GetSuggestedCarriersQueryVariables>(GetSuggestedCarriersDocument, options);
        }
export type GetSuggestedCarriersQueryHookResult = ReturnType<typeof useGetSuggestedCarriersQuery>;
export type GetSuggestedCarriersLazyQueryHookResult = ReturnType<typeof useGetSuggestedCarriersLazyQuery>;
export type GetSuggestedCarriersQueryResult = Apollo.QueryResult<GetSuggestedCarriersQuery, GetSuggestedCarriersQueryVariables>;
export const LookupFmcsaCarrierContactDocument = gql`
    query LookupFmcsaCarrierContact($input: LookupFmcsaCarrierContactInput!) {
  lookupFmcsaCarrierContact(input: $input) {
    legalName
    dbaName
    phone
    dotNumber
    mcNumber
    message
  }
}
    `;

/**
 * __useLookupFmcsaCarrierContactQuery__
 *
 * To run a query within a React component, call `useLookupFmcsaCarrierContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupFmcsaCarrierContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupFmcsaCarrierContactQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLookupFmcsaCarrierContactQuery(baseOptions: Apollo.QueryHookOptions<LookupFmcsaCarrierContactQuery, LookupFmcsaCarrierContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupFmcsaCarrierContactQuery, LookupFmcsaCarrierContactQueryVariables>(LookupFmcsaCarrierContactDocument, options);
      }
export function useLookupFmcsaCarrierContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupFmcsaCarrierContactQuery, LookupFmcsaCarrierContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupFmcsaCarrierContactQuery, LookupFmcsaCarrierContactQueryVariables>(LookupFmcsaCarrierContactDocument, options);
        }
export type LookupFmcsaCarrierContactQueryHookResult = ReturnType<typeof useLookupFmcsaCarrierContactQuery>;
export type LookupFmcsaCarrierContactLazyQueryHookResult = ReturnType<typeof useLookupFmcsaCarrierContactLazyQuery>;
export type LookupFmcsaCarrierContactQueryResult = Apollo.QueryResult<LookupFmcsaCarrierContactQuery, LookupFmcsaCarrierContactQueryVariables>;
export const GetClassificationLockDurationSecondsDocument = gql`
    query GetClassificationLockDurationSeconds {
  classificationLockDurationSeconds
}
    `;

/**
 * __useGetClassificationLockDurationSecondsQuery__
 *
 * To run a query within a React component, call `useGetClassificationLockDurationSecondsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassificationLockDurationSecondsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassificationLockDurationSecondsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClassificationLockDurationSecondsQuery(baseOptions?: Apollo.QueryHookOptions<GetClassificationLockDurationSecondsQuery, GetClassificationLockDurationSecondsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassificationLockDurationSecondsQuery, GetClassificationLockDurationSecondsQueryVariables>(GetClassificationLockDurationSecondsDocument, options);
      }
export function useGetClassificationLockDurationSecondsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassificationLockDurationSecondsQuery, GetClassificationLockDurationSecondsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassificationLockDurationSecondsQuery, GetClassificationLockDurationSecondsQueryVariables>(GetClassificationLockDurationSecondsDocument, options);
        }
export type GetClassificationLockDurationSecondsQueryHookResult = ReturnType<typeof useGetClassificationLockDurationSecondsQuery>;
export type GetClassificationLockDurationSecondsLazyQueryHookResult = ReturnType<typeof useGetClassificationLockDurationSecondsLazyQuery>;
export type GetClassificationLockDurationSecondsQueryResult = Apollo.QueryResult<GetClassificationLockDurationSecondsQuery, GetClassificationLockDurationSecondsQueryVariables>;
export const GetComposioToolKitDetailsDocument = gql`
    query GetComposioToolKitDetails($input: GetComposioToolKitDetailsInput!) {
  getComposioToolKitDetails(input: $input) {
    success
    toolKit {
      toolKitName
      logo
    }
  }
}
    `;

/**
 * __useGetComposioToolKitDetailsQuery__
 *
 * To run a query within a React component, call `useGetComposioToolKitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComposioToolKitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComposioToolKitDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetComposioToolKitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetComposioToolKitDetailsQuery, GetComposioToolKitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComposioToolKitDetailsQuery, GetComposioToolKitDetailsQueryVariables>(GetComposioToolKitDetailsDocument, options);
      }
export function useGetComposioToolKitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComposioToolKitDetailsQuery, GetComposioToolKitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComposioToolKitDetailsQuery, GetComposioToolKitDetailsQueryVariables>(GetComposioToolKitDetailsDocument, options);
        }
export type GetComposioToolKitDetailsQueryHookResult = ReturnType<typeof useGetComposioToolKitDetailsQuery>;
export type GetComposioToolKitDetailsLazyQueryHookResult = ReturnType<typeof useGetComposioToolKitDetailsLazyQuery>;
export type GetComposioToolKitDetailsQueryResult = Apollo.QueryResult<GetComposioToolKitDetailsQuery, GetComposioToolKitDetailsQueryVariables>;
export const ListComposioAuthTokensDocument = gql`
    query ListComposioAuthTokens($input: ListComposioAuthTokensInput!) {
  listComposioAuthTokens(input: $input) {
    success
    authTokens {
      id
      config
    }
  }
}
    `;

/**
 * __useListComposioAuthTokensQuery__
 *
 * To run a query within a React component, call `useListComposioAuthTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useListComposioAuthTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListComposioAuthTokensQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListComposioAuthTokensQuery(baseOptions: Apollo.QueryHookOptions<ListComposioAuthTokensQuery, ListComposioAuthTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListComposioAuthTokensQuery, ListComposioAuthTokensQueryVariables>(ListComposioAuthTokensDocument, options);
      }
export function useListComposioAuthTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListComposioAuthTokensQuery, ListComposioAuthTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListComposioAuthTokensQuery, ListComposioAuthTokensQueryVariables>(ListComposioAuthTokensDocument, options);
        }
export type ListComposioAuthTokensQueryHookResult = ReturnType<typeof useListComposioAuthTokensQuery>;
export type ListComposioAuthTokensLazyQueryHookResult = ReturnType<typeof useListComposioAuthTokensLazyQuery>;
export type ListComposioAuthTokensQueryResult = Apollo.QueryResult<ListComposioAuthTokensQuery, ListComposioAuthTokensQueryVariables>;
export const ListComposioToolKitsDocument = gql`
    query ListComposioToolKits($input: ListComposioToolKitsInput!) {
  listComposioToolKits(input: $input) {
    success
    toolKits {
      name
      slug
      description
    }
  }
}
    `;

/**
 * __useListComposioToolKitsQuery__
 *
 * To run a query within a React component, call `useListComposioToolKitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListComposioToolKitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListComposioToolKitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListComposioToolKitsQuery(baseOptions: Apollo.QueryHookOptions<ListComposioToolKitsQuery, ListComposioToolKitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListComposioToolKitsQuery, ListComposioToolKitsQueryVariables>(ListComposioToolKitsDocument, options);
      }
export function useListComposioToolKitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListComposioToolKitsQuery, ListComposioToolKitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListComposioToolKitsQuery, ListComposioToolKitsQueryVariables>(ListComposioToolKitsDocument, options);
        }
export type ListComposioToolKitsQueryHookResult = ReturnType<typeof useListComposioToolKitsQuery>;
export type ListComposioToolKitsLazyQueryHookResult = ReturnType<typeof useListComposioToolKitsLazyQuery>;
export type ListComposioToolKitsQueryResult = Apollo.QueryResult<ListComposioToolKitsQuery, ListComposioToolKitsQueryVariables>;
export const ListComposioToolsDocument = gql`
    query ListComposioTools($input: ListComposioToolsInput!) {
  listComposioTools(input: $input) {
    success
    tools {
      name
      slug
      description
    }
  }
}
    `;

/**
 * __useListComposioToolsQuery__
 *
 * To run a query within a React component, call `useListComposioToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListComposioToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListComposioToolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListComposioToolsQuery(baseOptions: Apollo.QueryHookOptions<ListComposioToolsQuery, ListComposioToolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListComposioToolsQuery, ListComposioToolsQueryVariables>(ListComposioToolsDocument, options);
      }
export function useListComposioToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListComposioToolsQuery, ListComposioToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListComposioToolsQuery, ListComposioToolsQueryVariables>(ListComposioToolsDocument, options);
        }
export type ListComposioToolsQueryHookResult = ReturnType<typeof useListComposioToolsQuery>;
export type ListComposioToolsLazyQueryHookResult = ReturnType<typeof useListComposioToolsLazyQuery>;
export type ListComposioToolsQueryResult = Apollo.QueryResult<ListComposioToolsQuery, ListComposioToolsQueryVariables>;
export const WorkerComposioAccountsDocument = gql`
    query WorkerComposioAccounts($input: WorkerComposioAccountsInput!) {
  workerComposioAccounts(input: $input) {
    configured
    toolKits {
      slug
      name
      logo
    }
    connections {
      id
      toolkitSlug
      status
      accountLabel
    }
  }
}
    `;

/**
 * __useWorkerComposioAccountsQuery__
 *
 * To run a query within a React component, call `useWorkerComposioAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerComposioAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerComposioAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkerComposioAccountsQuery(baseOptions: Apollo.QueryHookOptions<WorkerComposioAccountsQuery, WorkerComposioAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerComposioAccountsQuery, WorkerComposioAccountsQueryVariables>(WorkerComposioAccountsDocument, options);
      }
export function useWorkerComposioAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerComposioAccountsQuery, WorkerComposioAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerComposioAccountsQuery, WorkerComposioAccountsQueryVariables>(WorkerComposioAccountsDocument, options);
        }
export type WorkerComposioAccountsQueryHookResult = ReturnType<typeof useWorkerComposioAccountsQuery>;
export type WorkerComposioAccountsLazyQueryHookResult = ReturnType<typeof useWorkerComposioAccountsLazyQuery>;
export type WorkerComposioAccountsQueryResult = Apollo.QueryResult<WorkerComposioAccountsQuery, WorkerComposioAccountsQueryVariables>;
export const CreateOrUpdateComposioAuthTokenDocument = gql`
    mutation CreateOrUpdateComposioAuthToken($input: CreateOrUpdateComposioAuthTokenInput!) {
  createOrUpdateComposioAuthToken(input: $input) {
    success
  }
}
    `;
export type CreateOrUpdateComposioAuthTokenMutationFn = Apollo.MutationFunction<CreateOrUpdateComposioAuthTokenMutation, CreateOrUpdateComposioAuthTokenMutationVariables>;

/**
 * __useCreateOrUpdateComposioAuthTokenMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateComposioAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateComposioAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateComposioAuthTokenMutation, { data, loading, error }] = useCreateOrUpdateComposioAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateComposioAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateComposioAuthTokenMutation, CreateOrUpdateComposioAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateComposioAuthTokenMutation, CreateOrUpdateComposioAuthTokenMutationVariables>(CreateOrUpdateComposioAuthTokenDocument, options);
      }
export type CreateOrUpdateComposioAuthTokenMutationHookResult = ReturnType<typeof useCreateOrUpdateComposioAuthTokenMutation>;
export type CreateOrUpdateComposioAuthTokenMutationResult = Apollo.MutationResult<CreateOrUpdateComposioAuthTokenMutation>;
export type CreateOrUpdateComposioAuthTokenMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateComposioAuthTokenMutation, CreateOrUpdateComposioAuthTokenMutationVariables>;
export const CreateNewConversationWithConciergeDocument = gql`
    mutation CreateNewConversationWithConcierge($input: CreateNewConversationWithConciergeInput!) {
  createNewConversationWithConcierge(input: $input) {
    conversation {
      ...Conversation
    }
  }
}
    ${ConversationFragmentDoc}`;
export type CreateNewConversationWithConciergeMutationFn = Apollo.MutationFunction<CreateNewConversationWithConciergeMutation, CreateNewConversationWithConciergeMutationVariables>;

/**
 * __useCreateNewConversationWithConciergeMutation__
 *
 * To run a mutation, you first call `useCreateNewConversationWithConciergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewConversationWithConciergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewConversationWithConciergeMutation, { data, loading, error }] = useCreateNewConversationWithConciergeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewConversationWithConciergeMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewConversationWithConciergeMutation, CreateNewConversationWithConciergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewConversationWithConciergeMutation, CreateNewConversationWithConciergeMutationVariables>(CreateNewConversationWithConciergeDocument, options);
      }
export type CreateNewConversationWithConciergeMutationHookResult = ReturnType<typeof useCreateNewConversationWithConciergeMutation>;
export type CreateNewConversationWithConciergeMutationResult = Apollo.MutationResult<CreateNewConversationWithConciergeMutation>;
export type CreateNewConversationWithConciergeMutationOptions = Apollo.BaseMutationOptions<CreateNewConversationWithConciergeMutation, CreateNewConversationWithConciergeMutationVariables>;
export const CreateNewConversationWithLabelingConciergeDocument = gql`
    mutation CreateNewConversationWithLabelingConcierge($input: CreateNewConversationWithLabelingConciergeInput!) {
  createNewConversationWithLabelingConcierge(input: $input) {
    conversation {
      ...Conversation
    }
  }
}
    ${ConversationFragmentDoc}`;
export type CreateNewConversationWithLabelingConciergeMutationFn = Apollo.MutationFunction<CreateNewConversationWithLabelingConciergeMutation, CreateNewConversationWithLabelingConciergeMutationVariables>;

/**
 * __useCreateNewConversationWithLabelingConciergeMutation__
 *
 * To run a mutation, you first call `useCreateNewConversationWithLabelingConciergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewConversationWithLabelingConciergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewConversationWithLabelingConciergeMutation, { data, loading, error }] = useCreateNewConversationWithLabelingConciergeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewConversationWithLabelingConciergeMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewConversationWithLabelingConciergeMutation, CreateNewConversationWithLabelingConciergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewConversationWithLabelingConciergeMutation, CreateNewConversationWithLabelingConciergeMutationVariables>(CreateNewConversationWithLabelingConciergeDocument, options);
      }
export type CreateNewConversationWithLabelingConciergeMutationHookResult = ReturnType<typeof useCreateNewConversationWithLabelingConciergeMutation>;
export type CreateNewConversationWithLabelingConciergeMutationResult = Apollo.MutationResult<CreateNewConversationWithLabelingConciergeMutation>;
export type CreateNewConversationWithLabelingConciergeMutationOptions = Apollo.BaseMutationOptions<CreateNewConversationWithLabelingConciergeMutation, CreateNewConversationWithLabelingConciergeMutationVariables>;
export const DownloadConversationDebugPackageDocument = gql`
    query DownloadConversationDebugPackage($id: ID!) {
  downloadConversationDebugPackage(id: $id) {
    downloadUrl
  }
}
    `;

/**
 * __useDownloadConversationDebugPackageQuery__
 *
 * To run a query within a React component, call `useDownloadConversationDebugPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadConversationDebugPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadConversationDebugPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadConversationDebugPackageQuery(baseOptions: Apollo.QueryHookOptions<DownloadConversationDebugPackageQuery, DownloadConversationDebugPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadConversationDebugPackageQuery, DownloadConversationDebugPackageQueryVariables>(DownloadConversationDebugPackageDocument, options);
      }
export function useDownloadConversationDebugPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadConversationDebugPackageQuery, DownloadConversationDebugPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadConversationDebugPackageQuery, DownloadConversationDebugPackageQueryVariables>(DownloadConversationDebugPackageDocument, options);
        }
export type DownloadConversationDebugPackageQueryHookResult = ReturnType<typeof useDownloadConversationDebugPackageQuery>;
export type DownloadConversationDebugPackageLazyQueryHookResult = ReturnType<typeof useDownloadConversationDebugPackageLazyQuery>;
export type DownloadConversationDebugPackageQueryResult = Apollo.QueryResult<DownloadConversationDebugPackageQuery, DownloadConversationDebugPackageQueryVariables>;
export const GetAgentConversationsDocument = gql`
    query GetAgentConversations($input: ConversationsInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput) {
  conversations(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        ...AgentConversationPreview
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${AgentConversationPreviewFragmentDoc}`;

/**
 * __useGetAgentConversationsQuery__
 *
 * To run a query within a React component, call `useGetAgentConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAgentConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentConversationsQuery, GetAgentConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentConversationsQuery, GetAgentConversationsQueryVariables>(GetAgentConversationsDocument, options);
      }
export function useGetAgentConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentConversationsQuery, GetAgentConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentConversationsQuery, GetAgentConversationsQueryVariables>(GetAgentConversationsDocument, options);
        }
export type GetAgentConversationsQueryHookResult = ReturnType<typeof useGetAgentConversationsQuery>;
export type GetAgentConversationsLazyQueryHookResult = ReturnType<typeof useGetAgentConversationsLazyQuery>;
export type GetAgentConversationsQueryResult = Apollo.QueryResult<GetAgentConversationsQuery, GetAgentConversationsQueryVariables>;
export const GetChatSuggestionsDocument = gql`
    query GetChatSuggestions($input: ChatSuggestionsInput!) {
  chatSuggestions(input: $input) {
    id
    label
    message
    product
  }
}
    `;

/**
 * __useGetChatSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetChatSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChatSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetChatSuggestionsQuery, GetChatSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatSuggestionsQuery, GetChatSuggestionsQueryVariables>(GetChatSuggestionsDocument, options);
      }
export function useGetChatSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatSuggestionsQuery, GetChatSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatSuggestionsQuery, GetChatSuggestionsQueryVariables>(GetChatSuggestionsDocument, options);
        }
export type GetChatSuggestionsQueryHookResult = ReturnType<typeof useGetChatSuggestionsQuery>;
export type GetChatSuggestionsLazyQueryHookResult = ReturnType<typeof useGetChatSuggestionsLazyQuery>;
export type GetChatSuggestionsQueryResult = Apollo.QueryResult<GetChatSuggestionsQuery, GetChatSuggestionsQueryVariables>;
export const GetChatThreadsDocument = gql`
    query GetChatThreads($input: ConversationsInput, $limit: Int) {
  conversations(input: $input, limit: $limit) {
    edges {
      node {
        id
        organizationId
        title
        createdAt
        hasUnreadMessages
        hasActionExecutionInProgress
        handledOpenEscalations {
          id
        }
        user {
          id
          email
          firstName
          lastName
        }
        latestExternalMessage {
          id
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetChatThreadsQuery__
 *
 * To run a query within a React component, call `useGetChatThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatThreadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetChatThreadsQuery(baseOptions?: Apollo.QueryHookOptions<GetChatThreadsQuery, GetChatThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatThreadsQuery, GetChatThreadsQueryVariables>(GetChatThreadsDocument, options);
      }
export function useGetChatThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatThreadsQuery, GetChatThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatThreadsQuery, GetChatThreadsQueryVariables>(GetChatThreadsDocument, options);
        }
export type GetChatThreadsQueryHookResult = ReturnType<typeof useGetChatThreadsQuery>;
export type GetChatThreadsLazyQueryHookResult = ReturnType<typeof useGetChatThreadsLazyQuery>;
export type GetChatThreadsQueryResult = Apollo.QueryResult<GetChatThreadsQuery, GetChatThreadsQueryVariables>;
export const ConversationDocument = gql`
    query Conversation($id: ID!) {
  conversationById(id: $id) {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useConversationQuery__
 *
 * To run a query within a React component, call `useConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationQuery(baseOptions: Apollo.QueryHookOptions<ConversationQuery, ConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationQuery, ConversationQueryVariables>(ConversationDocument, options);
      }
export function useConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationQuery, ConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationQuery, ConversationQueryVariables>(ConversationDocument, options);
        }
export type ConversationQueryHookResult = ReturnType<typeof useConversationQuery>;
export type ConversationLazyQueryHookResult = ReturnType<typeof useConversationLazyQuery>;
export type ConversationQueryResult = Apollo.QueryResult<ConversationQuery, ConversationQueryVariables>;
export const GetRelatedActionsDocument = gql`
    query GetRelatedActions($input: RelatedExternalMessagesInput!) {
  relatedActions(input: $input) {
    type
    entityIds {
      externalMessageIds
      quoteIds
      orderIds
    }
    confidence
    proposedAt
  }
}
    `;

/**
 * __useGetRelatedActionsQuery__
 *
 * To run a query within a React component, call `useGetRelatedActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedActionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRelatedActionsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedActionsQuery, GetRelatedActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedActionsQuery, GetRelatedActionsQueryVariables>(GetRelatedActionsDocument, options);
      }
export function useGetRelatedActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedActionsQuery, GetRelatedActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedActionsQuery, GetRelatedActionsQueryVariables>(GetRelatedActionsDocument, options);
        }
export type GetRelatedActionsQueryHookResult = ReturnType<typeof useGetRelatedActionsQuery>;
export type GetRelatedActionsLazyQueryHookResult = ReturnType<typeof useGetRelatedActionsLazyQuery>;
export type GetRelatedActionsQueryResult = Apollo.QueryResult<GetRelatedActionsQuery, GetRelatedActionsQueryVariables>;
export const GetConversationActivityDocument = gql`
    query GetConversationActivity($id: ID!) {
  conversationById(id: $id) {
    id
    hasActionExecutionInProgress
  }
}
    `;

/**
 * __useGetConversationActivityQuery__
 *
 * To run a query within a React component, call `useGetConversationActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationActivityQuery(baseOptions: Apollo.QueryHookOptions<GetConversationActivityQuery, GetConversationActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationActivityQuery, GetConversationActivityQueryVariables>(GetConversationActivityDocument, options);
      }
export function useGetConversationActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationActivityQuery, GetConversationActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationActivityQuery, GetConversationActivityQueryVariables>(GetConversationActivityDocument, options);
        }
export type GetConversationActivityQueryHookResult = ReturnType<typeof useGetConversationActivityQuery>;
export type GetConversationActivityLazyQueryHookResult = ReturnType<typeof useGetConversationActivityLazyQuery>;
export type GetConversationActivityQueryResult = Apollo.QueryResult<GetConversationActivityQuery, GetConversationActivityQueryVariables>;
export const GetConversationExperimentAssignmentsDocument = gql`
    query GetConversationExperimentAssignments($id: ID!) {
  conversationExperimentAssignments(id: $id) {
    id
    parameters
    experiment {
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useGetConversationExperimentAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetConversationExperimentAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationExperimentAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationExperimentAssignmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationExperimentAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationExperimentAssignmentsQuery, GetConversationExperimentAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationExperimentAssignmentsQuery, GetConversationExperimentAssignmentsQueryVariables>(GetConversationExperimentAssignmentsDocument, options);
      }
export function useGetConversationExperimentAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationExperimentAssignmentsQuery, GetConversationExperimentAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationExperimentAssignmentsQuery, GetConversationExperimentAssignmentsQueryVariables>(GetConversationExperimentAssignmentsDocument, options);
        }
export type GetConversationExperimentAssignmentsQueryHookResult = ReturnType<typeof useGetConversationExperimentAssignmentsQuery>;
export type GetConversationExperimentAssignmentsLazyQueryHookResult = ReturnType<typeof useGetConversationExperimentAssignmentsLazyQuery>;
export type GetConversationExperimentAssignmentsQueryResult = Apollo.QueryResult<GetConversationExperimentAssignmentsQuery, GetConversationExperimentAssignmentsQueryVariables>;
export const GetConversationExternalMessagesDocument = gql`
    query GetConversationExternalMessages($input: ConversationExternalMessagesInput) {
  conversationExternalMessages(input: $input) {
    edges {
      node {
        ...ExternalMessage
      }
    }
  }
}
    ${ExternalMessageFragmentDoc}`;

/**
 * __useGetConversationExternalMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationExternalMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationExternalMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationExternalMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConversationExternalMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationExternalMessagesQuery, GetConversationExternalMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationExternalMessagesQuery, GetConversationExternalMessagesQueryVariables>(GetConversationExternalMessagesDocument, options);
      }
export function useGetConversationExternalMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationExternalMessagesQuery, GetConversationExternalMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationExternalMessagesQuery, GetConversationExternalMessagesQueryVariables>(GetConversationExternalMessagesDocument, options);
        }
export type GetConversationExternalMessagesQueryHookResult = ReturnType<typeof useGetConversationExternalMessagesQuery>;
export type GetConversationExternalMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationExternalMessagesLazyQuery>;
export type GetConversationExternalMessagesQueryResult = Apollo.QueryResult<GetConversationExternalMessagesQuery, GetConversationExternalMessagesQueryVariables>;
export const GetConversationFilterOptionsDocument = gql`
    query GetConversationFilterOptions($input: ConversationFilterOptionsInput!) {
  conversationFilterOptions(input: $input) {
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useGetConversationFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetConversationFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationFilterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConversationFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationFilterOptionsQuery, GetConversationFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationFilterOptionsQuery, GetConversationFilterOptionsQueryVariables>(GetConversationFilterOptionsDocument, options);
      }
export function useGetConversationFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationFilterOptionsQuery, GetConversationFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationFilterOptionsQuery, GetConversationFilterOptionsQueryVariables>(GetConversationFilterOptionsDocument, options);
        }
export type GetConversationFilterOptionsQueryHookResult = ReturnType<typeof useGetConversationFilterOptionsQuery>;
export type GetConversationFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetConversationFilterOptionsLazyQuery>;
export type GetConversationFilterOptionsQueryResult = Apollo.QueryResult<GetConversationFilterOptionsQuery, GetConversationFilterOptionsQueryVariables>;
export const GetConversationHistoryLogDocument = gql`
    query GetConversationHistoryLog($id: ID!) {
  conversationHistoryLog(id: $id)
}
    `;

/**
 * __useGetConversationHistoryLogQuery__
 *
 * To run a query within a React component, call `useGetConversationHistoryLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationHistoryLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationHistoryLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConversationHistoryLogQuery(baseOptions: Apollo.QueryHookOptions<GetConversationHistoryLogQuery, GetConversationHistoryLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationHistoryLogQuery, GetConversationHistoryLogQueryVariables>(GetConversationHistoryLogDocument, options);
      }
export function useGetConversationHistoryLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationHistoryLogQuery, GetConversationHistoryLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationHistoryLogQuery, GetConversationHistoryLogQueryVariables>(GetConversationHistoryLogDocument, options);
        }
export type GetConversationHistoryLogQueryHookResult = ReturnType<typeof useGetConversationHistoryLogQuery>;
export type GetConversationHistoryLogLazyQueryHookResult = ReturnType<typeof useGetConversationHistoryLogLazyQuery>;
export type GetConversationHistoryLogQueryResult = Apollo.QueryResult<GetConversationHistoryLogQuery, GetConversationHistoryLogQueryVariables>;
export const GetConversationsDocument = gql`
    query GetConversations($input: ConversationsInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput) {
  conversations(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        ...Conversation
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
      }
export function useGetConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsQueryResult = Apollo.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const GetConversationsWithExternalMessagesDocument = gql`
    query GetConversationsWithExternalMessages($input: ConversationsInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput, $limit: Int) {
  conversations(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
    limit: $limit
  ) {
    edges {
      node {
        ...Conversation
        externalMessages {
          id
          externalIdentifier
          createdAt
          userId
        }
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useGetConversationsWithExternalMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationsWithExternalMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsWithExternalMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsWithExternalMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetConversationsWithExternalMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationsWithExternalMessagesQuery, GetConversationsWithExternalMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsWithExternalMessagesQuery, GetConversationsWithExternalMessagesQueryVariables>(GetConversationsWithExternalMessagesDocument, options);
      }
export function useGetConversationsWithExternalMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsWithExternalMessagesQuery, GetConversationsWithExternalMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsWithExternalMessagesQuery, GetConversationsWithExternalMessagesQueryVariables>(GetConversationsWithExternalMessagesDocument, options);
        }
export type GetConversationsWithExternalMessagesQueryHookResult = ReturnType<typeof useGetConversationsWithExternalMessagesQuery>;
export type GetConversationsWithExternalMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationsWithExternalMessagesLazyQuery>;
export type GetConversationsWithExternalMessagesQueryResult = Apollo.QueryResult<GetConversationsWithExternalMessagesQuery, GetConversationsWithExternalMessagesQueryVariables>;
export const GetEmailThreadAgentRunsDocument = gql`
    query GetEmailThreadAgentRuns($id: ID!) {
  conversationById(id: $id) {
    id
    sideConversationParent {
      id
    }
    actions {
      ...EmailThreadAgentRun
      events {
        ...ActionExecutionEvent
      }
    }
    runsAboutThread: associatedActionExecutions(aboutThisThread: true) {
      ...EmailThreadAgentRun
      events {
        ...ActionExecutionEvent
      }
    }
    otherLinkedRuns: associatedActionExecutions(aboutThisThread: false) {
      ...EmailThreadAgentRun
    }
  }
}
    ${EmailThreadAgentRunFragmentDoc}
${ActionExecutionEventFragmentDoc}`;

/**
 * __useGetEmailThreadAgentRunsQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadAgentRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadAgentRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadAgentRunsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailThreadAgentRunsQuery(baseOptions: Apollo.QueryHookOptions<GetEmailThreadAgentRunsQuery, GetEmailThreadAgentRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailThreadAgentRunsQuery, GetEmailThreadAgentRunsQueryVariables>(GetEmailThreadAgentRunsDocument, options);
      }
export function useGetEmailThreadAgentRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadAgentRunsQuery, GetEmailThreadAgentRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailThreadAgentRunsQuery, GetEmailThreadAgentRunsQueryVariables>(GetEmailThreadAgentRunsDocument, options);
        }
export type GetEmailThreadAgentRunsQueryHookResult = ReturnType<typeof useGetEmailThreadAgentRunsQuery>;
export type GetEmailThreadAgentRunsLazyQueryHookResult = ReturnType<typeof useGetEmailThreadAgentRunsLazyQuery>;
export type GetEmailThreadAgentRunsQueryResult = Apollo.QueryResult<GetEmailThreadAgentRunsQuery, GetEmailThreadAgentRunsQueryVariables>;
export const GetEmailThreadChatDocument = gql`
    query GetEmailThreadChat($input: EmailThreadChatInput!) {
  emailThreadChat(input: $input) {
    id
    organizationId
    title
  }
}
    `;

/**
 * __useGetEmailThreadChatQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadChatQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailThreadChatQuery(baseOptions: Apollo.QueryHookOptions<GetEmailThreadChatQuery, GetEmailThreadChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailThreadChatQuery, GetEmailThreadChatQueryVariables>(GetEmailThreadChatDocument, options);
      }
export function useGetEmailThreadChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadChatQuery, GetEmailThreadChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailThreadChatQuery, GetEmailThreadChatQueryVariables>(GetEmailThreadChatDocument, options);
        }
export type GetEmailThreadChatQueryHookResult = ReturnType<typeof useGetEmailThreadChatQuery>;
export type GetEmailThreadChatLazyQueryHookResult = ReturnType<typeof useGetEmailThreadChatLazyQuery>;
export type GetEmailThreadChatQueryResult = Apollo.QueryResult<GetEmailThreadChatQuery, GetEmailThreadChatQueryVariables>;
export const HasConciergeActionDefinitionDocument = gql`
    query HasConciergeActionDefinition($input: HasConciergeActionDefinitionInput!) {
  hasConciergeActionDefinition(input: $input) {
    hasConcierge
    actionDefinitionId
    actionDefinitionName
    escalationHandlerActionDefinitionId
    escalationHandlerActionDefinitionName
  }
}
    `;

/**
 * __useHasConciergeActionDefinitionQuery__
 *
 * To run a query within a React component, call `useHasConciergeActionDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasConciergeActionDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasConciergeActionDefinitionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasConciergeActionDefinitionQuery(baseOptions: Apollo.QueryHookOptions<HasConciergeActionDefinitionQuery, HasConciergeActionDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasConciergeActionDefinitionQuery, HasConciergeActionDefinitionQueryVariables>(HasConciergeActionDefinitionDocument, options);
      }
export function useHasConciergeActionDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasConciergeActionDefinitionQuery, HasConciergeActionDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasConciergeActionDefinitionQuery, HasConciergeActionDefinitionQueryVariables>(HasConciergeActionDefinitionDocument, options);
        }
export type HasConciergeActionDefinitionQueryHookResult = ReturnType<typeof useHasConciergeActionDefinitionQuery>;
export type HasConciergeActionDefinitionLazyQueryHookResult = ReturnType<typeof useHasConciergeActionDefinitionLazyQuery>;
export type HasConciergeActionDefinitionQueryResult = Apollo.QueryResult<HasConciergeActionDefinitionQuery, HasConciergeActionDefinitionQueryVariables>;
export const HasLabelingConciergeDocument = gql`
    query HasLabelingConcierge($input: HasLabelingConciergeInput!) {
  hasLabelingConcierge(input: $input) {
    hasLabelingConcierge
  }
}
    `;

/**
 * __useHasLabelingConciergeQuery__
 *
 * To run a query within a React component, call `useHasLabelingConciergeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasLabelingConciergeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasLabelingConciergeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasLabelingConciergeQuery(baseOptions: Apollo.QueryHookOptions<HasLabelingConciergeQuery, HasLabelingConciergeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasLabelingConciergeQuery, HasLabelingConciergeQueryVariables>(HasLabelingConciergeDocument, options);
      }
export function useHasLabelingConciergeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasLabelingConciergeQuery, HasLabelingConciergeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasLabelingConciergeQuery, HasLabelingConciergeQueryVariables>(HasLabelingConciergeDocument, options);
        }
export type HasLabelingConciergeQueryHookResult = ReturnType<typeof useHasLabelingConciergeQuery>;
export type HasLabelingConciergeLazyQueryHookResult = ReturnType<typeof useHasLabelingConciergeLazyQuery>;
export type HasLabelingConciergeQueryResult = Apollo.QueryResult<HasLabelingConciergeQuery, HasLabelingConciergeQueryVariables>;
export const GetOrCreateConversationWithConciergeDocument = gql`
    query GetOrCreateConversationWithConcierge($input: GetOrCreateConversationWithConciergeInput!) {
  getOrCreateConversationWithConcierge(input: $input) {
    ...Conversation
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useGetOrCreateConversationWithConciergeQuery__
 *
 * To run a query within a React component, call `useGetOrCreateConversationWithConciergeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateConversationWithConciergeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrCreateConversationWithConciergeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrCreateConversationWithConciergeQuery(baseOptions: Apollo.QueryHookOptions<GetOrCreateConversationWithConciergeQuery, GetOrCreateConversationWithConciergeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrCreateConversationWithConciergeQuery, GetOrCreateConversationWithConciergeQueryVariables>(GetOrCreateConversationWithConciergeDocument, options);
      }
export function useGetOrCreateConversationWithConciergeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrCreateConversationWithConciergeQuery, GetOrCreateConversationWithConciergeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrCreateConversationWithConciergeQuery, GetOrCreateConversationWithConciergeQueryVariables>(GetOrCreateConversationWithConciergeDocument, options);
        }
export type GetOrCreateConversationWithConciergeQueryHookResult = ReturnType<typeof useGetOrCreateConversationWithConciergeQuery>;
export type GetOrCreateConversationWithConciergeLazyQueryHookResult = ReturnType<typeof useGetOrCreateConversationWithConciergeLazyQuery>;
export type GetOrCreateConversationWithConciergeQueryResult = Apollo.QueryResult<GetOrCreateConversationWithConciergeQuery, GetOrCreateConversationWithConciergeQueryVariables>;
export const GetRejectedCarrierInquiriesForLaneDocument = gql`
    query GetRejectedCarrierInquiriesForLane($movementId: ID!, $radiusMiles: Float, $lookbackDays: Float) {
  rejectedCarrierInquiriesForLane(
    input: {movementId: $movementId, radiusMiles: $radiusMiles, lookbackDays: $lookbackDays}
  ) {
    ...Conversation
    contactIdentifier
    associatedCarriers {
      ...Carrier
      contacts {
        id
        name
        email
        phone
      }
    }
  }
}
    ${ConversationFragmentDoc}
${CarrierFragmentDoc}`;

/**
 * __useGetRejectedCarrierInquiriesForLaneQuery__
 *
 * To run a query within a React component, call `useGetRejectedCarrierInquiriesForLaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectedCarrierInquiriesForLaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectedCarrierInquiriesForLaneQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *      radiusMiles: // value for 'radiusMiles'
 *      lookbackDays: // value for 'lookbackDays'
 *   },
 * });
 */
export function useGetRejectedCarrierInquiriesForLaneQuery(baseOptions: Apollo.QueryHookOptions<GetRejectedCarrierInquiriesForLaneQuery, GetRejectedCarrierInquiriesForLaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRejectedCarrierInquiriesForLaneQuery, GetRejectedCarrierInquiriesForLaneQueryVariables>(GetRejectedCarrierInquiriesForLaneDocument, options);
      }
export function useGetRejectedCarrierInquiriesForLaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectedCarrierInquiriesForLaneQuery, GetRejectedCarrierInquiriesForLaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRejectedCarrierInquiriesForLaneQuery, GetRejectedCarrierInquiriesForLaneQueryVariables>(GetRejectedCarrierInquiriesForLaneDocument, options);
        }
export type GetRejectedCarrierInquiriesForLaneQueryHookResult = ReturnType<typeof useGetRejectedCarrierInquiriesForLaneQuery>;
export type GetRejectedCarrierInquiriesForLaneLazyQueryHookResult = ReturnType<typeof useGetRejectedCarrierInquiriesForLaneLazyQuery>;
export type GetRejectedCarrierInquiriesForLaneQueryResult = Apollo.QueryResult<GetRejectedCarrierInquiriesForLaneQuery, GetRejectedCarrierInquiriesForLaneQueryVariables>;
export const GetRejectedCarrierInquiriesForMovementDocument = gql`
    query GetRejectedCarrierInquiriesForMovement($movementId: ID!) {
  rejectedCarrierInquiriesForMovement(input: {movementId: $movementId}) {
    ...Conversation
    contactIdentifier
    associatedCarriers {
      ...Carrier
      contacts {
        id
        name
        email
        phone
      }
    }
  }
}
    ${ConversationFragmentDoc}
${CarrierFragmentDoc}`;

/**
 * __useGetRejectedCarrierInquiriesForMovementQuery__
 *
 * To run a query within a React component, call `useGetRejectedCarrierInquiriesForMovementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectedCarrierInquiriesForMovementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectedCarrierInquiriesForMovementQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetRejectedCarrierInquiriesForMovementQuery(baseOptions: Apollo.QueryHookOptions<GetRejectedCarrierInquiriesForMovementQuery, GetRejectedCarrierInquiriesForMovementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRejectedCarrierInquiriesForMovementQuery, GetRejectedCarrierInquiriesForMovementQueryVariables>(GetRejectedCarrierInquiriesForMovementDocument, options);
      }
export function useGetRejectedCarrierInquiriesForMovementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRejectedCarrierInquiriesForMovementQuery, GetRejectedCarrierInquiriesForMovementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRejectedCarrierInquiriesForMovementQuery, GetRejectedCarrierInquiriesForMovementQueryVariables>(GetRejectedCarrierInquiriesForMovementDocument, options);
        }
export type GetRejectedCarrierInquiriesForMovementQueryHookResult = ReturnType<typeof useGetRejectedCarrierInquiriesForMovementQuery>;
export type GetRejectedCarrierInquiriesForMovementLazyQueryHookResult = ReturnType<typeof useGetRejectedCarrierInquiriesForMovementLazyQuery>;
export type GetRejectedCarrierInquiriesForMovementQueryResult = Apollo.QueryResult<GetRejectedCarrierInquiriesForMovementQuery, GetRejectedCarrierInquiriesForMovementQueryVariables>;
export const CoverageStatePreviewDocument = gql`
    query CoverageStatePreview($input: CoverageStatePreviewInput!) {
  coverageStatePreview(input: $input) {
    shipmentId
    shipmentReferenceNumber
    shipmentUpdatedAt
    movementId
    defaultCoverageState
    coverageState
    recordedCoverageState
    error
  }
}
    `;

/**
 * __useCoverageStatePreviewQuery__
 *
 * To run a query within a React component, call `useCoverageStatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverageStatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverageStatePreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoverageStatePreviewQuery(baseOptions: Apollo.QueryHookOptions<CoverageStatePreviewQuery, CoverageStatePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoverageStatePreviewQuery, CoverageStatePreviewQueryVariables>(CoverageStatePreviewDocument, options);
      }
export function useCoverageStatePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoverageStatePreviewQuery, CoverageStatePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoverageStatePreviewQuery, CoverageStatePreviewQueryVariables>(CoverageStatePreviewDocument, options);
        }
export type CoverageStatePreviewQueryHookResult = ReturnType<typeof useCoverageStatePreviewQuery>;
export type CoverageStatePreviewLazyQueryHookResult = ReturnType<typeof useCoverageStatePreviewLazyQuery>;
export type CoverageStatePreviewQueryResult = Apollo.QueryResult<CoverageStatePreviewQuery, CoverageStatePreviewQueryVariables>;
export const DatAuthorizedUsersDocument = gql`
    query DatAuthorizedUsers {
  datAuthorizedUsers {
    userId
    name
    datUsername
  }
}
    `;

/**
 * __useDatAuthorizedUsersQuery__
 *
 * To run a query within a React component, call `useDatAuthorizedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatAuthorizedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatAuthorizedUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDatAuthorizedUsersQuery(baseOptions?: Apollo.QueryHookOptions<DatAuthorizedUsersQuery, DatAuthorizedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatAuthorizedUsersQuery, DatAuthorizedUsersQueryVariables>(DatAuthorizedUsersDocument, options);
      }
export function useDatAuthorizedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatAuthorizedUsersQuery, DatAuthorizedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatAuthorizedUsersQuery, DatAuthorizedUsersQueryVariables>(DatAuthorizedUsersDocument, options);
        }
export type DatAuthorizedUsersQueryHookResult = ReturnType<typeof useDatAuthorizedUsersQuery>;
export type DatAuthorizedUsersLazyQueryHookResult = ReturnType<typeof useDatAuthorizedUsersLazyQuery>;
export type DatAuthorizedUsersQueryResult = Apollo.QueryResult<DatAuthorizedUsersQuery, DatAuthorizedUsersQueryVariables>;
export const GetErrorGroupsDocument = gql`
    query GetErrorGroups($input: ListErrorGroupsInput, $sort: SortInput) {
  errorGroups(input: $input, sort: $sort) {
    ...ErrorGroup
  }
}
    ${ErrorGroupFragmentDoc}`;

/**
 * __useGetErrorGroupsQuery__
 *
 * To run a query within a React component, call `useGetErrorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetErrorGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetErrorGroupsQuery, GetErrorGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorGroupsQuery, GetErrorGroupsQueryVariables>(GetErrorGroupsDocument, options);
      }
export function useGetErrorGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorGroupsQuery, GetErrorGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorGroupsQuery, GetErrorGroupsQueryVariables>(GetErrorGroupsDocument, options);
        }
export type GetErrorGroupsQueryHookResult = ReturnType<typeof useGetErrorGroupsQuery>;
export type GetErrorGroupsLazyQueryHookResult = ReturnType<typeof useGetErrorGroupsLazyQuery>;
export type GetErrorGroupsQueryResult = Apollo.QueryResult<GetErrorGroupsQuery, GetErrorGroupsQueryVariables>;
export const GetExceptionByIdDocument = gql`
    query getExceptionById($id: ID!) {
  getExceptionById(id: $id) {
    ...Exception
  }
}
    ${ExceptionFragmentDoc}`;

/**
 * __useGetExceptionByIdQuery__
 *
 * To run a query within a React component, call `useGetExceptionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExceptionByIdQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionByIdQuery, GetExceptionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionByIdQuery, GetExceptionByIdQueryVariables>(GetExceptionByIdDocument, options);
      }
export function useGetExceptionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionByIdQuery, GetExceptionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionByIdQuery, GetExceptionByIdQueryVariables>(GetExceptionByIdDocument, options);
        }
export type GetExceptionByIdQueryHookResult = ReturnType<typeof useGetExceptionByIdQuery>;
export type GetExceptionByIdLazyQueryHookResult = ReturnType<typeof useGetExceptionByIdLazyQuery>;
export type GetExceptionByIdQueryResult = Apollo.QueryResult<GetExceptionByIdQuery, GetExceptionByIdQueryVariables>;
export const GetConversationExceptionsDocument = gql`
    query GetConversationExceptions($input: ConversationExceptionsInput!, $first: Int, $after: String) {
  conversationExceptions(input: $input, first: $first, after: $after) {
    edges {
      node {
        ...ConversationException
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      endCursor
    }
    count
    totalCount
  }
}
    ${ConversationExceptionFragmentDoc}`;

/**
 * __useGetConversationExceptionsQuery__
 *
 * To run a query within a React component, call `useGetConversationExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationExceptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetConversationExceptionsQuery(baseOptions: Apollo.QueryHookOptions<GetConversationExceptionsQuery, GetConversationExceptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationExceptionsQuery, GetConversationExceptionsQueryVariables>(GetConversationExceptionsDocument, options);
      }
export function useGetConversationExceptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationExceptionsQuery, GetConversationExceptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationExceptionsQuery, GetConversationExceptionsQueryVariables>(GetConversationExceptionsDocument, options);
        }
export type GetConversationExceptionsQueryHookResult = ReturnType<typeof useGetConversationExceptionsQuery>;
export type GetConversationExceptionsLazyQueryHookResult = ReturnType<typeof useGetConversationExceptionsLazyQuery>;
export type GetConversationExceptionsQueryResult = Apollo.QueryResult<GetConversationExceptionsQuery, GetConversationExceptionsQueryVariables>;
export const GetExceptionsDocument = gql`
    query GetExceptions($input: GetExceptionsInput!, $first: Int, $after: String) {
  exceptionsByOrganization(input: $input, first: $first, after: $after) {
    edges {
      node {
        ...Exception
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${ExceptionFragmentDoc}`;

/**
 * __useGetExceptionsQuery__
 *
 * To run a query within a React component, call `useGetExceptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetExceptionsQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionsQuery, GetExceptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionsQuery, GetExceptionsQueryVariables>(GetExceptionsDocument, options);
      }
export function useGetExceptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionsQuery, GetExceptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionsQuery, GetExceptionsQueryVariables>(GetExceptionsDocument, options);
        }
export type GetExceptionsQueryHookResult = ReturnType<typeof useGetExceptionsQuery>;
export type GetExceptionsLazyQueryHookResult = ReturnType<typeof useGetExceptionsLazyQuery>;
export type GetExceptionsQueryResult = Apollo.QueryResult<GetExceptionsQuery, GetExceptionsQueryVariables>;
export const GetChannelOptionsDocument = gql`
    query GetChannelOptions($input: GetChannelOptionsInput!) {
  getChannelOptions(input: $input) {
    options {
      id
      label
      channelGroup
    }
  }
}
    `;

/**
 * __useGetChannelOptionsQuery__
 *
 * To run a query within a React component, call `useGetChannelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChannelOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetChannelOptionsQuery, GetChannelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelOptionsQuery, GetChannelOptionsQueryVariables>(GetChannelOptionsDocument, options);
      }
export function useGetChannelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelOptionsQuery, GetChannelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelOptionsQuery, GetChannelOptionsQueryVariables>(GetChannelOptionsDocument, options);
        }
export type GetChannelOptionsQueryHookResult = ReturnType<typeof useGetChannelOptionsQuery>;
export type GetChannelOptionsLazyQueryHookResult = ReturnType<typeof useGetChannelOptionsLazyQuery>;
export type GetChannelOptionsQueryResult = Apollo.QueryResult<GetChannelOptionsQuery, GetChannelOptionsQueryVariables>;
export const GetExternalChannelsDocument = gql`
    query GetExternalChannels($input: ExternalChannelsInput!, $first: Int, $last: Int, $before: String, $after: String, $limit: Int, $sort: SortInput) {
  externalChannels(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    limit: $limit
    sort: $sort
  ) {
    nodes {
      ...ExternalChannel
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    ${ExternalChannelFragmentDoc}`;

/**
 * __useGetExternalChannelsQuery__
 *
 * To run a query within a React component, call `useGetExternalChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalChannelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetExternalChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalChannelsQuery, GetExternalChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalChannelsQuery, GetExternalChannelsQueryVariables>(GetExternalChannelsDocument, options);
      }
export function useGetExternalChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalChannelsQuery, GetExternalChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalChannelsQuery, GetExternalChannelsQueryVariables>(GetExternalChannelsDocument, options);
        }
export type GetExternalChannelsQueryHookResult = ReturnType<typeof useGetExternalChannelsQuery>;
export type GetExternalChannelsLazyQueryHookResult = ReturnType<typeof useGetExternalChannelsLazyQuery>;
export type GetExternalChannelsQueryResult = Apollo.QueryResult<GetExternalChannelsQuery, GetExternalChannelsQueryVariables>;
export const GetExternalIdMappingsDocument = gql`
    query GetExternalIdMappings($input: GetExternalIdMappingsInput!) {
  getExternalIdMappings(input: $input) {
    externalIdMappings {
      externalId
      integrationType
    }
  }
}
    `;

/**
 * __useGetExternalIdMappingsQuery__
 *
 * To run a query within a React component, call `useGetExternalIdMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalIdMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalIdMappingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExternalIdMappingsQuery(baseOptions: Apollo.QueryHookOptions<GetExternalIdMappingsQuery, GetExternalIdMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalIdMappingsQuery, GetExternalIdMappingsQueryVariables>(GetExternalIdMappingsDocument, options);
      }
export function useGetExternalIdMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalIdMappingsQuery, GetExternalIdMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalIdMappingsQuery, GetExternalIdMappingsQueryVariables>(GetExternalIdMappingsDocument, options);
        }
export type GetExternalIdMappingsQueryHookResult = ReturnType<typeof useGetExternalIdMappingsQuery>;
export type GetExternalIdMappingsLazyQueryHookResult = ReturnType<typeof useGetExternalIdMappingsLazyQuery>;
export type GetExternalIdMappingsQueryResult = Apollo.QueryResult<GetExternalIdMappingsQuery, GetExternalIdMappingsQueryVariables>;
export const GetExternalMessagesByUserDocument = gql`
    query GetExternalMessagesByUser($input: ExternalMessagesByUserInput!) {
  externalMessagesByUser(input: $input) {
    externalMessageUserSummary {
      userId
      lastClassifiedAt
      externalMessageDaySummaries {
        date
        failedCount
        classifiedCount
      }
    }
  }
}
    `;

/**
 * __useGetExternalMessagesByUserQuery__
 *
 * To run a query within a React component, call `useGetExternalMessagesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalMessagesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalMessagesByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetExternalMessagesByUserQuery(baseOptions: Apollo.QueryHookOptions<GetExternalMessagesByUserQuery, GetExternalMessagesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalMessagesByUserQuery, GetExternalMessagesByUserQueryVariables>(GetExternalMessagesByUserDocument, options);
      }
export function useGetExternalMessagesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalMessagesByUserQuery, GetExternalMessagesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalMessagesByUserQuery, GetExternalMessagesByUserQueryVariables>(GetExternalMessagesByUserDocument, options);
        }
export type GetExternalMessagesByUserQueryHookResult = ReturnType<typeof useGetExternalMessagesByUserQuery>;
export type GetExternalMessagesByUserLazyQueryHookResult = ReturnType<typeof useGetExternalMessagesByUserLazyQuery>;
export type GetExternalMessagesByUserQueryResult = Apollo.QueryResult<GetExternalMessagesByUserQuery, GetExternalMessagesByUserQueryVariables>;
export const GetMessageApplicableGenericTransformationsDocument = gql`
    query GetMessageApplicableGenericTransformations($input: ApplicableGenericTransformationsInput!) {
  applicableGenericTransformations(input: $input) {
    genericTransformationIds
    resultingClasses {
      type
      confidence
    }
  }
}
    `;

/**
 * __useGetMessageApplicableGenericTransformationsQuery__
 *
 * To run a query within a React component, call `useGetMessageApplicableGenericTransformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageApplicableGenericTransformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageApplicableGenericTransformationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMessageApplicableGenericTransformationsQuery(baseOptions: Apollo.QueryHookOptions<GetMessageApplicableGenericTransformationsQuery, GetMessageApplicableGenericTransformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageApplicableGenericTransformationsQuery, GetMessageApplicableGenericTransformationsQueryVariables>(GetMessageApplicableGenericTransformationsDocument, options);
      }
export function useGetMessageApplicableGenericTransformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageApplicableGenericTransformationsQuery, GetMessageApplicableGenericTransformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageApplicableGenericTransformationsQuery, GetMessageApplicableGenericTransformationsQueryVariables>(GetMessageApplicableGenericTransformationsDocument, options);
        }
export type GetMessageApplicableGenericTransformationsQueryHookResult = ReturnType<typeof useGetMessageApplicableGenericTransformationsQuery>;
export type GetMessageApplicableGenericTransformationsLazyQueryHookResult = ReturnType<typeof useGetMessageApplicableGenericTransformationsLazyQuery>;
export type GetMessageApplicableGenericTransformationsQueryResult = Apollo.QueryResult<GetMessageApplicableGenericTransformationsQuery, GetMessageApplicableGenericTransformationsQueryVariables>;
export const MessageEntityAssociationsDocument = gql`
    query MessageEntityAssociations($input: MessageEntityAssociationsInput) {
  messageEntityAssociations(input: $input) {
    edges {
      node {
        externalMessageId
        entityId
      }
    }
  }
}
    `;

/**
 * __useMessageEntityAssociationsQuery__
 *
 * To run a query within a React component, call `useMessageEntityAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageEntityAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageEntityAssociationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageEntityAssociationsQuery(baseOptions?: Apollo.QueryHookOptions<MessageEntityAssociationsQuery, MessageEntityAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageEntityAssociationsQuery, MessageEntityAssociationsQueryVariables>(MessageEntityAssociationsDocument, options);
      }
export function useMessageEntityAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageEntityAssociationsQuery, MessageEntityAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageEntityAssociationsQuery, MessageEntityAssociationsQueryVariables>(MessageEntityAssociationsDocument, options);
        }
export type MessageEntityAssociationsQueryHookResult = ReturnType<typeof useMessageEntityAssociationsQuery>;
export type MessageEntityAssociationsLazyQueryHookResult = ReturnType<typeof useMessageEntityAssociationsLazyQuery>;
export type MessageEntityAssociationsQueryResult = Apollo.QueryResult<MessageEntityAssociationsQuery, MessageEntityAssociationsQueryVariables>;
export const MessageQuoteAssociationsDocument = gql`
    query MessageQuoteAssociations($input: MessageQuoteAssociationsInput) {
  messageQuoteAssociations(input: $input) {
    nodes {
      quote {
        responseTime
      }
    }
  }
}
    `;

/**
 * __useMessageQuoteAssociationsQuery__
 *
 * To run a query within a React component, call `useMessageQuoteAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageQuoteAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageQuoteAssociationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageQuoteAssociationsQuery(baseOptions?: Apollo.QueryHookOptions<MessageQuoteAssociationsQuery, MessageQuoteAssociationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageQuoteAssociationsQuery, MessageQuoteAssociationsQueryVariables>(MessageQuoteAssociationsDocument, options);
      }
export function useMessageQuoteAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageQuoteAssociationsQuery, MessageQuoteAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageQuoteAssociationsQuery, MessageQuoteAssociationsQueryVariables>(MessageQuoteAssociationsDocument, options);
        }
export type MessageQuoteAssociationsQueryHookResult = ReturnType<typeof useMessageQuoteAssociationsQuery>;
export type MessageQuoteAssociationsLazyQueryHookResult = ReturnType<typeof useMessageQuoteAssociationsLazyQuery>;
export type MessageQuoteAssociationsQueryResult = Apollo.QueryResult<MessageQuoteAssociationsQuery, MessageQuoteAssociationsQueryVariables>;
export const QuoteExternalThreadsDocument = gql`
    query QuoteExternalThreads($id: ID!) {
  quoteById(id: $id) {
    id
    externalThreads {
      externalThreadId
      messages {
        id
        internetMessageId
        subject
        recipientAddresses
        senderAddress
        content
        receivedAt
        isDraft
      }
      threadType
    }
  }
}
    `;

/**
 * __useQuoteExternalThreadsQuery__
 *
 * To run a query within a React component, call `useQuoteExternalThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteExternalThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteExternalThreadsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteExternalThreadsQuery(baseOptions: Apollo.QueryHookOptions<QuoteExternalThreadsQuery, QuoteExternalThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteExternalThreadsQuery, QuoteExternalThreadsQueryVariables>(QuoteExternalThreadsDocument, options);
      }
export function useQuoteExternalThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteExternalThreadsQuery, QuoteExternalThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteExternalThreadsQuery, QuoteExternalThreadsQueryVariables>(QuoteExternalThreadsDocument, options);
        }
export type QuoteExternalThreadsQueryHookResult = ReturnType<typeof useQuoteExternalThreadsQuery>;
export type QuoteExternalThreadsLazyQueryHookResult = ReturnType<typeof useQuoteExternalThreadsLazyQuery>;
export type QuoteExternalThreadsQueryResult = Apollo.QueryResult<QuoteExternalThreadsQuery, QuoteExternalThreadsQueryVariables>;
export const RelatedExternalMessagesDocument = gql`
    query RelatedExternalMessages($input: RelatedExternalMessagesInput!) {
  relatedExternalMessages(input: $input) {
    id
    user {
      id
    }
    type
    externalIdentifier
    status
    emailMetadata
    classifications
  }
}
    `;

/**
 * __useRelatedExternalMessagesQuery__
 *
 * To run a query within a React component, call `useRelatedExternalMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedExternalMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedExternalMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRelatedExternalMessagesQuery(baseOptions: Apollo.QueryHookOptions<RelatedExternalMessagesQuery, RelatedExternalMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedExternalMessagesQuery, RelatedExternalMessagesQueryVariables>(RelatedExternalMessagesDocument, options);
      }
export function useRelatedExternalMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedExternalMessagesQuery, RelatedExternalMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedExternalMessagesQuery, RelatedExternalMessagesQueryVariables>(RelatedExternalMessagesDocument, options);
        }
export type RelatedExternalMessagesQueryHookResult = ReturnType<typeof useRelatedExternalMessagesQuery>;
export type RelatedExternalMessagesLazyQueryHookResult = ReturnType<typeof useRelatedExternalMessagesLazyQuery>;
export type RelatedExternalMessagesQueryResult = Apollo.QueryResult<RelatedExternalMessagesQuery, RelatedExternalMessagesQueryVariables>;
export const FrontSharedInboxesDocument = gql`
    query FrontSharedInboxes($organizationId: ID!) {
  frontSharedInboxes(organizationId: $organizationId) {
    id
    name
    address
    type
    isPrivate
  }
}
    `;

/**
 * __useFrontSharedInboxesQuery__
 *
 * To run a query within a React component, call `useFrontSharedInboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontSharedInboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontSharedInboxesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useFrontSharedInboxesQuery(baseOptions: Apollo.QueryHookOptions<FrontSharedInboxesQuery, FrontSharedInboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrontSharedInboxesQuery, FrontSharedInboxesQueryVariables>(FrontSharedInboxesDocument, options);
      }
export function useFrontSharedInboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrontSharedInboxesQuery, FrontSharedInboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrontSharedInboxesQuery, FrontSharedInboxesQueryVariables>(FrontSharedInboxesDocument, options);
        }
export type FrontSharedInboxesQueryHookResult = ReturnType<typeof useFrontSharedInboxesQuery>;
export type FrontSharedInboxesLazyQueryHookResult = ReturnType<typeof useFrontSharedInboxesLazyQuery>;
export type FrontSharedInboxesQueryResult = Apollo.QueryResult<FrontSharedInboxesQuery, FrontSharedInboxesQueryVariables>;
export const UserFrontMailboxSubscriptionsDocument = gql`
    query UserFrontMailboxSubscriptions($userId: ID!, $organizationId: ID!) {
  frontMailboxSubscriptions(userId: $userId, organizationId: $organizationId) {
    id
    externalId
    organizationId
    ownerId
    createdAt
    name
  }
}
    `;

/**
 * __useUserFrontMailboxSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserFrontMailboxSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFrontMailboxSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFrontMailboxSubscriptionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUserFrontMailboxSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<UserFrontMailboxSubscriptionsQuery, UserFrontMailboxSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFrontMailboxSubscriptionsQuery, UserFrontMailboxSubscriptionsQueryVariables>(UserFrontMailboxSubscriptionsDocument, options);
      }
export function useUserFrontMailboxSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFrontMailboxSubscriptionsQuery, UserFrontMailboxSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFrontMailboxSubscriptionsQuery, UserFrontMailboxSubscriptionsQueryVariables>(UserFrontMailboxSubscriptionsDocument, options);
        }
export type UserFrontMailboxSubscriptionsQueryHookResult = ReturnType<typeof useUserFrontMailboxSubscriptionsQuery>;
export type UserFrontMailboxSubscriptionsLazyQueryHookResult = ReturnType<typeof useUserFrontMailboxSubscriptionsLazyQuery>;
export type UserFrontMailboxSubscriptionsQueryResult = Apollo.QueryResult<UserFrontMailboxSubscriptionsQuery, UserFrontMailboxSubscriptionsQueryVariables>;
export const GetGenericTransformationDocument = gql`
    query GetGenericTransformation($id: ID!) {
  genericTransformationById(id: $id) {
    ...GenericTransformationDetails
  }
}
    ${GenericTransformationDetailsFragmentDoc}`;

/**
 * __useGetGenericTransformationQuery__
 *
 * To run a query within a React component, call `useGetGenericTransformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericTransformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericTransformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGenericTransformationQuery(baseOptions: Apollo.QueryHookOptions<GetGenericTransformationQuery, GetGenericTransformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericTransformationQuery, GetGenericTransformationQueryVariables>(GetGenericTransformationDocument, options);
      }
export function useGetGenericTransformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericTransformationQuery, GetGenericTransformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericTransformationQuery, GetGenericTransformationQueryVariables>(GetGenericTransformationDocument, options);
        }
export type GetGenericTransformationQueryHookResult = ReturnType<typeof useGetGenericTransformationQuery>;
export type GetGenericTransformationLazyQueryHookResult = ReturnType<typeof useGetGenericTransformationLazyQuery>;
export type GetGenericTransformationQueryResult = Apollo.QueryResult<GetGenericTransformationQuery, GetGenericTransformationQueryVariables>;
export const GetGenericTransformationsDocument = gql`
    query GetGenericTransformations($input: GenericTransformationsInput, $first: Int, $last: Int, $before: String, $after: String, $limit: Int, $sort: SortInput) {
  genericTransformations(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    limit: $limit
    sort: $sort
  ) {
    edges {
      node {
        ...GenericTransformationDetails
      }
    }
    nodes {
      ...GenericTransformationDetails
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    count
    totalCount
  }
}
    ${GenericTransformationDetailsFragmentDoc}`;

/**
 * __useGetGenericTransformationsQuery__
 *
 * To run a query within a React component, call `useGetGenericTransformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericTransformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericTransformationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetGenericTransformationsQuery(baseOptions?: Apollo.QueryHookOptions<GetGenericTransformationsQuery, GetGenericTransformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericTransformationsQuery, GetGenericTransformationsQueryVariables>(GetGenericTransformationsDocument, options);
      }
export function useGetGenericTransformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericTransformationsQuery, GetGenericTransformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericTransformationsQuery, GetGenericTransformationsQueryVariables>(GetGenericTransformationsDocument, options);
        }
export type GetGenericTransformationsQueryHookResult = ReturnType<typeof useGetGenericTransformationsQuery>;
export type GetGenericTransformationsLazyQueryHookResult = ReturnType<typeof useGetGenericTransformationsLazyQuery>;
export type GetGenericTransformationsQueryResult = Apollo.QueryResult<GetGenericTransformationsQuery, GetGenericTransformationsQueryVariables>;
export const TestHighwayCredentialsDocument = gql`
    query TestHighwayCredentials($input: HighwayCredentialTestInput!) {
  testHighwayCredentials(input: $input) {
    organizationId
    results {
      name
      status
      message
    }
    allPassed
  }
}
    `;

/**
 * __useTestHighwayCredentialsQuery__
 *
 * To run a query within a React component, call `useTestHighwayCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestHighwayCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestHighwayCredentialsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestHighwayCredentialsQuery(baseOptions: Apollo.QueryHookOptions<TestHighwayCredentialsQuery, TestHighwayCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestHighwayCredentialsQuery, TestHighwayCredentialsQueryVariables>(TestHighwayCredentialsDocument, options);
      }
export function useTestHighwayCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestHighwayCredentialsQuery, TestHighwayCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestHighwayCredentialsQuery, TestHighwayCredentialsQueryVariables>(TestHighwayCredentialsDocument, options);
        }
export type TestHighwayCredentialsQueryHookResult = ReturnType<typeof useTestHighwayCredentialsQuery>;
export type TestHighwayCredentialsLazyQueryHookResult = ReturnType<typeof useTestHighwayCredentialsLazyQuery>;
export type TestHighwayCredentialsQueryResult = Apollo.QueryResult<TestHighwayCredentialsQuery, TestHighwayCredentialsQueryVariables>;
export const HostedMcLeodIntegrationHealthDocument = gql`
    query HostedMcLeodIntegrationHealth($input: HostedMcLeodIntegrationHealthInput!) {
  hostedMcLeodIntegrationHealth(input: $input) {
    organizationId
    checks {
      name
      status
      message
    }
    passCount
    failCount
    warnCount
    skipCount
  }
}
    `;

/**
 * __useHostedMcLeodIntegrationHealthQuery__
 *
 * To run a query within a React component, call `useHostedMcLeodIntegrationHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostedMcLeodIntegrationHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostedMcLeodIntegrationHealthQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHostedMcLeodIntegrationHealthQuery(baseOptions: Apollo.QueryHookOptions<HostedMcLeodIntegrationHealthQuery, HostedMcLeodIntegrationHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostedMcLeodIntegrationHealthQuery, HostedMcLeodIntegrationHealthQueryVariables>(HostedMcLeodIntegrationHealthDocument, options);
      }
export function useHostedMcLeodIntegrationHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostedMcLeodIntegrationHealthQuery, HostedMcLeodIntegrationHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostedMcLeodIntegrationHealthQuery, HostedMcLeodIntegrationHealthQueryVariables>(HostedMcLeodIntegrationHealthDocument, options);
        }
export type HostedMcLeodIntegrationHealthQueryHookResult = ReturnType<typeof useHostedMcLeodIntegrationHealthQuery>;
export type HostedMcLeodIntegrationHealthLazyQueryHookResult = ReturnType<typeof useHostedMcLeodIntegrationHealthLazyQuery>;
export type HostedMcLeodIntegrationHealthQueryResult = Apollo.QueryResult<HostedMcLeodIntegrationHealthQuery, HostedMcLeodIntegrationHealthQueryVariables>;
export const TestHostedMcLeodCredentialsDocument = gql`
    query TestHostedMcLeodCredentials($input: HostedMcLeodCredentialTestInput!) {
  testHostedMcLeodCredentials(input: $input) {
    organizationId
    results {
      name
      status
      message
    }
    allPassed
  }
}
    `;

/**
 * __useTestHostedMcLeodCredentialsQuery__
 *
 * To run a query within a React component, call `useTestHostedMcLeodCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestHostedMcLeodCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestHostedMcLeodCredentialsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestHostedMcLeodCredentialsQuery(baseOptions: Apollo.QueryHookOptions<TestHostedMcLeodCredentialsQuery, TestHostedMcLeodCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestHostedMcLeodCredentialsQuery, TestHostedMcLeodCredentialsQueryVariables>(TestHostedMcLeodCredentialsDocument, options);
      }
export function useTestHostedMcLeodCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestHostedMcLeodCredentialsQuery, TestHostedMcLeodCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestHostedMcLeodCredentialsQuery, TestHostedMcLeodCredentialsQueryVariables>(TestHostedMcLeodCredentialsDocument, options);
        }
export type TestHostedMcLeodCredentialsQueryHookResult = ReturnType<typeof useTestHostedMcLeodCredentialsQuery>;
export type TestHostedMcLeodCredentialsLazyQueryHookResult = ReturnType<typeof useTestHostedMcLeodCredentialsLazyQuery>;
export type TestHostedMcLeodCredentialsQueryResult = Apollo.QueryResult<TestHostedMcLeodCredentialsQuery, TestHostedMcLeodCredentialsQueryVariables>;
export const CheckIntegrationCredentialsDocument = gql`
    query CheckIntegrationCredentials($input: CheckIntegrationCredentialsInput!) {
  checkIntegrationCredentials(input: $input) {
    result
  }
}
    `;

/**
 * __useCheckIntegrationCredentialsQuery__
 *
 * To run a query within a React component, call `useCheckIntegrationCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIntegrationCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIntegrationCredentialsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckIntegrationCredentialsQuery(baseOptions: Apollo.QueryHookOptions<CheckIntegrationCredentialsQuery, CheckIntegrationCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIntegrationCredentialsQuery, CheckIntegrationCredentialsQueryVariables>(CheckIntegrationCredentialsDocument, options);
      }
export function useCheckIntegrationCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIntegrationCredentialsQuery, CheckIntegrationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIntegrationCredentialsQuery, CheckIntegrationCredentialsQueryVariables>(CheckIntegrationCredentialsDocument, options);
        }
export type CheckIntegrationCredentialsQueryHookResult = ReturnType<typeof useCheckIntegrationCredentialsQuery>;
export type CheckIntegrationCredentialsLazyQueryHookResult = ReturnType<typeof useCheckIntegrationCredentialsLazyQuery>;
export type CheckIntegrationCredentialsQueryResult = Apollo.QueryResult<CheckIntegrationCredentialsQuery, CheckIntegrationCredentialsQueryVariables>;
export const ListIntegrationCredentialsDocument = gql`
    query ListIntegrationCredentials($input: ListIntegrationCredentialsInput!) {
  integrationCredentials(input: $input) {
    id
    type
    name
    usageIndicator
    configPaths
  }
}
    `;

/**
 * __useListIntegrationCredentialsQuery__
 *
 * To run a query within a React component, call `useListIntegrationCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIntegrationCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIntegrationCredentialsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListIntegrationCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ListIntegrationCredentialsQuery, ListIntegrationCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListIntegrationCredentialsQuery, ListIntegrationCredentialsQueryVariables>(ListIntegrationCredentialsDocument, options);
      }
export function useListIntegrationCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListIntegrationCredentialsQuery, ListIntegrationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListIntegrationCredentialsQuery, ListIntegrationCredentialsQueryVariables>(ListIntegrationCredentialsDocument, options);
        }
export type ListIntegrationCredentialsQueryHookResult = ReturnType<typeof useListIntegrationCredentialsQuery>;
export type ListIntegrationCredentialsLazyQueryHookResult = ReturnType<typeof useListIntegrationCredentialsLazyQuery>;
export type ListIntegrationCredentialsQueryResult = Apollo.QueryResult<ListIntegrationCredentialsQuery, ListIntegrationCredentialsQueryVariables>;
export const GetConfiguredCarrierVerificationCredentialTypesDocument = gql`
    query GetConfiguredCarrierVerificationCredentialTypes($input: ConfiguredCarrierVerificationCredentialTypesInput!) {
  configuredCarrierVerificationCredentialTypes(input: $input) {
    credentialTypes
  }
}
    `;

/**
 * __useGetConfiguredCarrierVerificationCredentialTypesQuery__
 *
 * To run a query within a React component, call `useGetConfiguredCarrierVerificationCredentialTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfiguredCarrierVerificationCredentialTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfiguredCarrierVerificationCredentialTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConfiguredCarrierVerificationCredentialTypesQuery(baseOptions: Apollo.QueryHookOptions<GetConfiguredCarrierVerificationCredentialTypesQuery, GetConfiguredCarrierVerificationCredentialTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfiguredCarrierVerificationCredentialTypesQuery, GetConfiguredCarrierVerificationCredentialTypesQueryVariables>(GetConfiguredCarrierVerificationCredentialTypesDocument, options);
      }
export function useGetConfiguredCarrierVerificationCredentialTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfiguredCarrierVerificationCredentialTypesQuery, GetConfiguredCarrierVerificationCredentialTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfiguredCarrierVerificationCredentialTypesQuery, GetConfiguredCarrierVerificationCredentialTypesQueryVariables>(GetConfiguredCarrierVerificationCredentialTypesDocument, options);
        }
export type GetConfiguredCarrierVerificationCredentialTypesQueryHookResult = ReturnType<typeof useGetConfiguredCarrierVerificationCredentialTypesQuery>;
export type GetConfiguredCarrierVerificationCredentialTypesLazyQueryHookResult = ReturnType<typeof useGetConfiguredCarrierVerificationCredentialTypesLazyQuery>;
export type GetConfiguredCarrierVerificationCredentialTypesQueryResult = Apollo.QueryResult<GetConfiguredCarrierVerificationCredentialTypesQuery, GetConfiguredCarrierVerificationCredentialTypesQueryVariables>;
export const GetIntegrationVerificationEventsDocument = gql`
    query GetIntegrationVerificationEvents($input: IntegrationVerificationEventsInput!) {
  integrationVerificationEvents(input: $input) {
    id
    createdAt
    name
    data {
      integrationType
      credentialType
      success
      error
    }
  }
}
    `;

/**
 * __useGetIntegrationVerificationEventsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationVerificationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationVerificationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationVerificationEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntegrationVerificationEventsQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationVerificationEventsQuery, GetIntegrationVerificationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationVerificationEventsQuery, GetIntegrationVerificationEventsQueryVariables>(GetIntegrationVerificationEventsDocument, options);
      }
export function useGetIntegrationVerificationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationVerificationEventsQuery, GetIntegrationVerificationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationVerificationEventsQuery, GetIntegrationVerificationEventsQueryVariables>(GetIntegrationVerificationEventsDocument, options);
        }
export type GetIntegrationVerificationEventsQueryHookResult = ReturnType<typeof useGetIntegrationVerificationEventsQuery>;
export type GetIntegrationVerificationEventsLazyQueryHookResult = ReturnType<typeof useGetIntegrationVerificationEventsLazyQuery>;
export type GetIntegrationVerificationEventsQueryResult = Apollo.QueryResult<GetIntegrationVerificationEventsQuery, GetIntegrationVerificationEventsQueryVariables>;
export const JobSimulatorPreviewDocument = gql`
    query JobSimulatorPreview($id: ID!) {
  me {
    id
  }
  jobById(id: $id) {
    ...JobSummary
  }
}
    ${JobSummaryFragmentDoc}`;

/**
 * __useJobSimulatorPreviewQuery__
 *
 * To run a query within a React component, call `useJobSimulatorPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSimulatorPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSimulatorPreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobSimulatorPreviewQuery(baseOptions: Apollo.QueryHookOptions<JobSimulatorPreviewQuery, JobSimulatorPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSimulatorPreviewQuery, JobSimulatorPreviewQueryVariables>(JobSimulatorPreviewDocument, options);
      }
export function useJobSimulatorPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSimulatorPreviewQuery, JobSimulatorPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSimulatorPreviewQuery, JobSimulatorPreviewQueryVariables>(JobSimulatorPreviewDocument, options);
        }
export type JobSimulatorPreviewQueryHookResult = ReturnType<typeof useJobSimulatorPreviewQuery>;
export type JobSimulatorPreviewLazyQueryHookResult = ReturnType<typeof useJobSimulatorPreviewLazyQuery>;
export type JobSimulatorPreviewQueryResult = Apollo.QueryResult<JobSimulatorPreviewQuery, JobSimulatorPreviewQueryVariables>;
export const QuoteJobSimulationSettingsDocument = gql`
    query QuoteJobSimulationSettings($input: QuoteJobSimulationSettingsInput!) {
  quoteJobSimulationSettings(input: $input) {
    resolved {
      quoteAutoReply
      pricingStrategy {
        id
        type
        config
      }
    }
    levels {
      user {
        ...QuoteJobSimulationHierarchyLevelFields
      }
      team {
        ...QuoteJobSimulationHierarchyLevelFields
      }
      originator {
        ...QuoteJobSimulationHierarchyLevelFields
      }
      organization {
        ...QuoteJobSimulationHierarchyLevelFields
      }
      global {
        ...QuoteJobSimulationHierarchyLevelFields
      }
    }
  }
}
    ${QuoteJobSimulationHierarchyLevelFieldsFragmentDoc}`;

/**
 * __useQuoteJobSimulationSettingsQuery__
 *
 * To run a query within a React component, call `useQuoteJobSimulationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteJobSimulationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteJobSimulationSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuoteJobSimulationSettingsQuery(baseOptions: Apollo.QueryHookOptions<QuoteJobSimulationSettingsQuery, QuoteJobSimulationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteJobSimulationSettingsQuery, QuoteJobSimulationSettingsQueryVariables>(QuoteJobSimulationSettingsDocument, options);
      }
export function useQuoteJobSimulationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteJobSimulationSettingsQuery, QuoteJobSimulationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteJobSimulationSettingsQuery, QuoteJobSimulationSettingsQueryVariables>(QuoteJobSimulationSettingsDocument, options);
        }
export type QuoteJobSimulationSettingsQueryHookResult = ReturnType<typeof useQuoteJobSimulationSettingsQuery>;
export type QuoteJobSimulationSettingsLazyQueryHookResult = ReturnType<typeof useQuoteJobSimulationSettingsLazyQuery>;
export type QuoteJobSimulationSettingsQueryResult = Apollo.QueryResult<QuoteJobSimulationSettingsQuery, QuoteJobSimulationSettingsQueryVariables>;
export const KnowledgeBaseDocument = gql`
    query KnowledgeBase($id: ID!) {
  knowledgeBaseById(id: $id) {
    ...KnowledgeBase
  }
}
    ${KnowledgeBaseFragmentDoc}`;

/**
 * __useKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useKnowledgeBaseQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
      }
export function useKnowledgeBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
        }
export type KnowledgeBaseQueryHookResult = ReturnType<typeof useKnowledgeBaseQuery>;
export type KnowledgeBaseLazyQueryHookResult = ReturnType<typeof useKnowledgeBaseLazyQuery>;
export type KnowledgeBaseQueryResult = Apollo.QueryResult<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>;
export const KnowledgeBasesDocument = gql`
    query KnowledgeBases($input: KnowledgeBasesInput!) {
  knowledgeBases(input: $input) {
    edges {
      node {
        ...KnowledgeBase
      }
    }
  }
}
    ${KnowledgeBaseFragmentDoc}`;

/**
 * __useKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBasesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKnowledgeBasesQuery(baseOptions: Apollo.QueryHookOptions<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>(KnowledgeBasesDocument, options);
      }
export function useKnowledgeBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>(KnowledgeBasesDocument, options);
        }
export type KnowledgeBasesQueryHookResult = ReturnType<typeof useKnowledgeBasesQuery>;
export type KnowledgeBasesLazyQueryHookResult = ReturnType<typeof useKnowledgeBasesLazyQuery>;
export type KnowledgeBasesQueryResult = Apollo.QueryResult<KnowledgeBasesQuery, KnowledgeBasesQueryVariables>;
export const GetMemoriesDocument = gql`
    query GetMemories($input: MemoriesInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput) {
  memories(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        ...Memory
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${MemoryFragmentDoc}`;

/**
 * __useGetMemoriesQuery__
 *
 * To run a query within a React component, call `useGetMemoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMemoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetMemoriesQuery, GetMemoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemoriesQuery, GetMemoriesQueryVariables>(GetMemoriesDocument, options);
      }
export function useGetMemoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemoriesQuery, GetMemoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemoriesQuery, GetMemoriesQueryVariables>(GetMemoriesDocument, options);
        }
export type GetMemoriesQueryHookResult = ReturnType<typeof useGetMemoriesQuery>;
export type GetMemoriesLazyQueryHookResult = ReturnType<typeof useGetMemoriesLazyQuery>;
export type GetMemoriesQueryResult = Apollo.QueryResult<GetMemoriesQuery, GetMemoriesQueryVariables>;
export const MemoryDocument = gql`
    query Memory($id: ID!) {
  memoryById(id: $id) {
    ...MemoryDetails
  }
}
    ${MemoryDetailsFragmentDoc}`;

/**
 * __useMemoryQuery__
 *
 * To run a query within a React component, call `useMemoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMemoryQuery(baseOptions: Apollo.QueryHookOptions<MemoryQuery, MemoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemoryQuery, MemoryQueryVariables>(MemoryDocument, options);
      }
export function useMemoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemoryQuery, MemoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemoryQuery, MemoryQueryVariables>(MemoryDocument, options);
        }
export type MemoryQueryHookResult = ReturnType<typeof useMemoryQuery>;
export type MemoryLazyQueryHookResult = ReturnType<typeof useMemoryLazyQuery>;
export type MemoryQueryResult = Apollo.QueryResult<MemoryQuery, MemoryQueryVariables>;
export const GetMyMessageRatingsDocument = gql`
    query GetMyMessageRatings($input: MyMessageRatingsInput!) {
  myMessageRatings(input: $input) {
    ...MessageRating
  }
}
    ${MessageRatingFragmentDoc}`;

/**
 * __useGetMyMessageRatingsQuery__
 *
 * To run a query within a React component, call `useGetMyMessageRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMessageRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMessageRatingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyMessageRatingsQuery(baseOptions: Apollo.QueryHookOptions<GetMyMessageRatingsQuery, GetMyMessageRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMessageRatingsQuery, GetMyMessageRatingsQueryVariables>(GetMyMessageRatingsDocument, options);
      }
export function useGetMyMessageRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMessageRatingsQuery, GetMyMessageRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMessageRatingsQuery, GetMyMessageRatingsQueryVariables>(GetMyMessageRatingsDocument, options);
        }
export type GetMyMessageRatingsQueryHookResult = ReturnType<typeof useGetMyMessageRatingsQuery>;
export type GetMyMessageRatingsLazyQueryHookResult = ReturnType<typeof useGetMyMessageRatingsLazyQuery>;
export type GetMyMessageRatingsQueryResult = Apollo.QueryResult<GetMyMessageRatingsQuery, GetMyMessageRatingsQueryVariables>;
export const GetActivePostingsDocument = gql`
    query GetActivePostings($id: ID!) {
  getActivePostings(id: $id) {
    postings {
      externalId
      integrationType
      postingUrl
    }
  }
}
    `;

/**
 * __useGetActivePostingsQuery__
 *
 * To run a query within a React component, call `useGetActivePostingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePostingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePostingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActivePostingsQuery(baseOptions: Apollo.QueryHookOptions<GetActivePostingsQuery, GetActivePostingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePostingsQuery, GetActivePostingsQueryVariables>(GetActivePostingsDocument, options);
      }
export function useGetActivePostingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePostingsQuery, GetActivePostingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePostingsQuery, GetActivePostingsQueryVariables>(GetActivePostingsDocument, options);
        }
export type GetActivePostingsQueryHookResult = ReturnType<typeof useGetActivePostingsQuery>;
export type GetActivePostingsLazyQueryHookResult = ReturnType<typeof useGetActivePostingsLazyQuery>;
export type GetActivePostingsQueryResult = Apollo.QueryResult<GetActivePostingsQuery, GetActivePostingsQueryVariables>;
export const GetExceptionEventsDocument = gql`
    query GetExceptionEvents($movementId: ID!) {
  exceptionEventsByMovementId(movementId: $movementId) {
    event {
      id
      createdAt
      name
      data {
        ... on ExceptionCreatedData {
          eventType
          exception {
            type
            data
          }
        }
      }
    }
    actionExecutions {
      id
      createdAt
      status
      actionDefinition {
        id
        name
      }
      input
      output
    }
  }
}
    `;

/**
 * __useGetExceptionEventsQuery__
 *
 * To run a query within a React component, call `useGetExceptionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionEventsQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetExceptionEventsQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionEventsQuery, GetExceptionEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionEventsQuery, GetExceptionEventsQueryVariables>(GetExceptionEventsDocument, options);
      }
export function useGetExceptionEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionEventsQuery, GetExceptionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionEventsQuery, GetExceptionEventsQueryVariables>(GetExceptionEventsDocument, options);
        }
export type GetExceptionEventsQueryHookResult = ReturnType<typeof useGetExceptionEventsQuery>;
export type GetExceptionEventsLazyQueryHookResult = ReturnType<typeof useGetExceptionEventsLazyQuery>;
export type GetExceptionEventsQueryResult = Apollo.QueryResult<GetExceptionEventsQuery, GetExceptionEventsQueryVariables>;
export const MovementDocument = gql`
    query Movement($id: ID!) {
  movementById(id: $id) {
    ...Movement
  }
}
    ${MovementFragmentDoc}`;

/**
 * __useMovementQuery__
 *
 * To run a query within a React component, call `useMovementQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMovementQuery(baseOptions: Apollo.QueryHookOptions<MovementQuery, MovementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovementQuery, MovementQueryVariables>(MovementDocument, options);
      }
export function useMovementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovementQuery, MovementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovementQuery, MovementQueryVariables>(MovementDocument, options);
        }
export type MovementQueryHookResult = ReturnType<typeof useMovementQuery>;
export type MovementLazyQueryHookResult = ReturnType<typeof useMovementLazyQuery>;
export type MovementQueryResult = Apollo.QueryResult<MovementQuery, MovementQueryVariables>;
export const MovementConversationsDocument = gql`
    query MovementConversations($movementId: ID!) {
  movementById(id: $movementId) {
    id
    conversations {
      ...Conversation
      associatedCarriers {
        id
        name
      }
    }
  }
}
    ${ConversationFragmentDoc}`;

/**
 * __useMovementConversationsQuery__
 *
 * To run a query within a React component, call `useMovementConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovementConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovementConversationsQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useMovementConversationsQuery(baseOptions: Apollo.QueryHookOptions<MovementConversationsQuery, MovementConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovementConversationsQuery, MovementConversationsQueryVariables>(MovementConversationsDocument, options);
      }
export function useMovementConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovementConversationsQuery, MovementConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovementConversationsQuery, MovementConversationsQueryVariables>(MovementConversationsDocument, options);
        }
export type MovementConversationsQueryHookResult = ReturnType<typeof useMovementConversationsQuery>;
export type MovementConversationsLazyQueryHookResult = ReturnType<typeof useMovementConversationsLazyQuery>;
export type MovementConversationsQueryResult = Apollo.QueryResult<MovementConversationsQuery, MovementConversationsQueryVariables>;
export const MovementDetailsDocument = gql`
    query MovementDetails($id: ID!) {
  movementById(id: $id) {
    ...MovementDetails
  }
}
    ${MovementDetailsFragmentDoc}`;

/**
 * __useMovementDetailsQuery__
 *
 * To run a query within a React component, call `useMovementDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovementDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovementDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMovementDetailsQuery(baseOptions: Apollo.QueryHookOptions<MovementDetailsQuery, MovementDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovementDetailsQuery, MovementDetailsQueryVariables>(MovementDetailsDocument, options);
      }
export function useMovementDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovementDetailsQuery, MovementDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovementDetailsQuery, MovementDetailsQueryVariables>(MovementDetailsDocument, options);
        }
export type MovementDetailsQueryHookResult = ReturnType<typeof useMovementDetailsQuery>;
export type MovementDetailsLazyQueryHookResult = ReturnType<typeof useMovementDetailsLazyQuery>;
export type MovementDetailsQueryResult = Apollo.QueryResult<MovementDetailsQuery, MovementDetailsQueryVariables>;
export const GetMovementDynamoStatusesDocument = gql`
    query GetMovementDynamoStatuses($movementId: ID!) {
  movementDynamoStatuses(movementId: $movementId) {
    timestamp
    lat
    lon
    city
    state
    source
    metadata
  }
}
    `;

/**
 * __useGetMovementDynamoStatusesQuery__
 *
 * To run a query within a React component, call `useGetMovementDynamoStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementDynamoStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementDynamoStatusesQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetMovementDynamoStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetMovementDynamoStatusesQuery, GetMovementDynamoStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovementDynamoStatusesQuery, GetMovementDynamoStatusesQueryVariables>(GetMovementDynamoStatusesDocument, options);
      }
export function useGetMovementDynamoStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovementDynamoStatusesQuery, GetMovementDynamoStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovementDynamoStatusesQuery, GetMovementDynamoStatusesQueryVariables>(GetMovementDynamoStatusesDocument, options);
        }
export type GetMovementDynamoStatusesQueryHookResult = ReturnType<typeof useGetMovementDynamoStatusesQuery>;
export type GetMovementDynamoStatusesLazyQueryHookResult = ReturnType<typeof useGetMovementDynamoStatusesLazyQuery>;
export type GetMovementDynamoStatusesQueryResult = Apollo.QueryResult<GetMovementDynamoStatusesQuery, GetMovementDynamoStatusesQueryVariables>;
export const GetMovementLaneHistoryRadiusDocument = gql`
    query GetMovementLaneHistoryRadius($id: ID!) {
  movementById(id: $id) {
    id
    laneHistoryRadiusMiles
  }
}
    `;

/**
 * __useGetMovementLaneHistoryRadiusQuery__
 *
 * To run a query within a React component, call `useGetMovementLaneHistoryRadiusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementLaneHistoryRadiusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementLaneHistoryRadiusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovementLaneHistoryRadiusQuery(baseOptions: Apollo.QueryHookOptions<GetMovementLaneHistoryRadiusQuery, GetMovementLaneHistoryRadiusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovementLaneHistoryRadiusQuery, GetMovementLaneHistoryRadiusQueryVariables>(GetMovementLaneHistoryRadiusDocument, options);
      }
export function useGetMovementLaneHistoryRadiusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovementLaneHistoryRadiusQuery, GetMovementLaneHistoryRadiusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovementLaneHistoryRadiusQuery, GetMovementLaneHistoryRadiusQueryVariables>(GetMovementLaneHistoryRadiusDocument, options);
        }
export type GetMovementLaneHistoryRadiusQueryHookResult = ReturnType<typeof useGetMovementLaneHistoryRadiusQuery>;
export type GetMovementLaneHistoryRadiusLazyQueryHookResult = ReturnType<typeof useGetMovementLaneHistoryRadiusLazyQuery>;
export type GetMovementLaneHistoryRadiusQueryResult = Apollo.QueryResult<GetMovementLaneHistoryRadiusQuery, GetMovementLaneHistoryRadiusQueryVariables>;
export const GetMovementTrackingHeaderDocument = gql`
    query GetMovementTrackingHeader($id: ID!) {
  movementById(id: $id) {
    id
    organizationId
    linkedDocuments {
      id
      type
      url
      uploadedAt
    }
    movementEvents {
      ...TrackWorkspaceMovementEvent
    }
    latestDynamoStatus {
      city
      state
      lat
      lon
      source
      timestamp
    }
    shipment {
      id
      referenceNumbers
      externalDeepLink
      carrierRates {
        name
        buyRate
      }
      trackingInfo {
        driverName
        driverPhone
        dispatchName
        dispatchPhone
        dispatchEmail
      }
      user {
        id
        firstName
        lastName
        username
        email
      }
    }
  }
}
    ${TrackWorkspaceMovementEventFragmentDoc}`;

/**
 * __useGetMovementTrackingHeaderQuery__
 *
 * To run a query within a React component, call `useGetMovementTrackingHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementTrackingHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementTrackingHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovementTrackingHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetMovementTrackingHeaderQuery, GetMovementTrackingHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovementTrackingHeaderQuery, GetMovementTrackingHeaderQueryVariables>(GetMovementTrackingHeaderDocument, options);
      }
export function useGetMovementTrackingHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovementTrackingHeaderQuery, GetMovementTrackingHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovementTrackingHeaderQuery, GetMovementTrackingHeaderQueryVariables>(GetMovementTrackingHeaderDocument, options);
        }
export type GetMovementTrackingHeaderQueryHookResult = ReturnType<typeof useGetMovementTrackingHeaderQuery>;
export type GetMovementTrackingHeaderLazyQueryHookResult = ReturnType<typeof useGetMovementTrackingHeaderLazyQuery>;
export type GetMovementTrackingHeaderQueryResult = Apollo.QueryResult<GetMovementTrackingHeaderQuery, GetMovementTrackingHeaderQueryVariables>;
export const MovementWithActionsDocument = gql`
    query MovementWithActions($id: ID!) {
  movementById(id: $id) {
    seq
    ...MovementPreview
    carrierRates {
      ...CarrierRateWithActions
    }
    shipment {
      ...Shipment
      externalDeepLink
    }
    pricing {
      targetPrice
      maxPrice
    }
    customerRate
    inquiryCount
    commodity
    negotiationStrategyConfigOverride
  }
}
    ${MovementPreviewFragmentDoc}
${CarrierRateWithActionsFragmentDoc}
${ShipmentFragmentDoc}`;

/**
 * __useMovementWithActionsQuery__
 *
 * To run a query within a React component, call `useMovementWithActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovementWithActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovementWithActionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMovementWithActionsQuery(baseOptions: Apollo.QueryHookOptions<MovementWithActionsQuery, MovementWithActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovementWithActionsQuery, MovementWithActionsQueryVariables>(MovementWithActionsDocument, options);
      }
export function useMovementWithActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovementWithActionsQuery, MovementWithActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovementWithActionsQuery, MovementWithActionsQueryVariables>(MovementWithActionsDocument, options);
        }
export type MovementWithActionsQueryHookResult = ReturnType<typeof useMovementWithActionsQuery>;
export type MovementWithActionsLazyQueryHookResult = ReturnType<typeof useMovementWithActionsLazyQuery>;
export type MovementWithActionsQueryResult = Apollo.QueryResult<MovementWithActionsQuery, MovementWithActionsQueryVariables>;
export const GetMovementsToCoverDocument = gql`
    query GetMovementsToCover($input: MovementsToCoverInput!, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput) {
  movementsToCover(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        ...Movement
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${MovementFragmentDoc}`;

/**
 * __useGetMovementsToCoverQuery__
 *
 * To run a query within a React component, call `useGetMovementsToCoverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsToCoverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsToCoverQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetMovementsToCoverQuery(baseOptions: Apollo.QueryHookOptions<GetMovementsToCoverQuery, GetMovementsToCoverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovementsToCoverQuery, GetMovementsToCoverQueryVariables>(GetMovementsToCoverDocument, options);
      }
export function useGetMovementsToCoverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovementsToCoverQuery, GetMovementsToCoverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovementsToCoverQuery, GetMovementsToCoverQueryVariables>(GetMovementsToCoverDocument, options);
        }
export type GetMovementsToCoverQueryHookResult = ReturnType<typeof useGetMovementsToCoverQuery>;
export type GetMovementsToCoverLazyQueryHookResult = ReturnType<typeof useGetMovementsToCoverLazyQuery>;
export type GetMovementsToCoverQueryResult = Apollo.QueryResult<GetMovementsToCoverQuery, GetMovementsToCoverQueryVariables>;
export const GetStatusChangedEventsDocument = gql`
    query GetStatusChangedEvents($movementId: ID!) {
  statusChangedEventsByMovementId(movementId: $movementId) {
    event {
      id
      createdAt
      name
      data {
        ... on MovementStatusChangedData {
          eventType
          fromStatus
          toStatus
          coverageStatus
          tmsStatus
        }
      }
    }
    actionExecutions {
      id
      createdAt
      status
      actionDefinition {
        id
        name
      }
      input
      output
    }
  }
}
    `;

/**
 * __useGetStatusChangedEventsQuery__
 *
 * To run a query within a React component, call `useGetStatusChangedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusChangedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusChangedEventsQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetStatusChangedEventsQuery(baseOptions: Apollo.QueryHookOptions<GetStatusChangedEventsQuery, GetStatusChangedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusChangedEventsQuery, GetStatusChangedEventsQueryVariables>(GetStatusChangedEventsDocument, options);
      }
export function useGetStatusChangedEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusChangedEventsQuery, GetStatusChangedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusChangedEventsQuery, GetStatusChangedEventsQueryVariables>(GetStatusChangedEventsDocument, options);
        }
export type GetStatusChangedEventsQueryHookResult = ReturnType<typeof useGetStatusChangedEventsQuery>;
export type GetStatusChangedEventsLazyQueryHookResult = ReturnType<typeof useGetStatusChangedEventsLazyQuery>;
export type GetStatusChangedEventsQueryResult = Apollo.QueryResult<GetStatusChangedEventsQuery, GetStatusChangedEventsQueryVariables>;
export const GetTrackingEventsDocument = gql`
    query GetTrackingEvents($movementId: ID!) {
  trackingEventsByMovementId(movementId: $movementId) {
    event {
      id
      createdAt
      name
      data {
        ... on TrackingMilestoneData {
          eventType
          milestone {
            type
            stopNumber
          }
          onTime
          location {
            city
            state
          }
          trackingDataAvailable
          currentExceptions
          milesToLastDelivery
          infoToExchange
          contactMethod
          etaToLastDelivery
        }
      }
    }
    actionExecutions {
      ...TrackWorkspaceAction
    }
  }
}
    ${TrackWorkspaceActionFragmentDoc}`;

/**
 * __useGetTrackingEventsQuery__
 *
 * To run a query within a React component, call `useGetTrackingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackingEventsQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetTrackingEventsQuery(baseOptions: Apollo.QueryHookOptions<GetTrackingEventsQuery, GetTrackingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackingEventsQuery, GetTrackingEventsQueryVariables>(GetTrackingEventsDocument, options);
      }
export function useGetTrackingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackingEventsQuery, GetTrackingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackingEventsQuery, GetTrackingEventsQueryVariables>(GetTrackingEventsDocument, options);
        }
export type GetTrackingEventsQueryHookResult = ReturnType<typeof useGetTrackingEventsQuery>;
export type GetTrackingEventsLazyQueryHookResult = ReturnType<typeof useGetTrackingEventsLazyQuery>;
export type GetTrackingEventsQueryResult = Apollo.QueryResult<GetTrackingEventsQuery, GetTrackingEventsQueryVariables>;
export const IsMovementPostedDocument = gql`
    query IsMovementPosted($id: ID!) {
  isMovementPosted(id: $id)
}
    `;

/**
 * __useIsMovementPostedQuery__
 *
 * To run a query within a React component, call `useIsMovementPostedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsMovementPostedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsMovementPostedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsMovementPostedQuery(baseOptions: Apollo.QueryHookOptions<IsMovementPostedQuery, IsMovementPostedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsMovementPostedQuery, IsMovementPostedQueryVariables>(IsMovementPostedDocument, options);
      }
export function useIsMovementPostedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsMovementPostedQuery, IsMovementPostedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsMovementPostedQuery, IsMovementPostedQueryVariables>(IsMovementPostedDocument, options);
        }
export type IsMovementPostedQueryHookResult = ReturnType<typeof useIsMovementPostedQuery>;
export type IsMovementPostedLazyQueryHookResult = ReturnType<typeof useIsMovementPostedLazyQuery>;
export type IsMovementPostedQueryResult = Apollo.QueryResult<IsMovementPostedQuery, IsMovementPostedQueryVariables>;
export const ComputeSmartPricingPriorsDocument = gql`
    query ComputeSmartPricingPriors($input: ComputeSmartPricingPriorsInput!) {
  computeSmartPricingPriors(input: $input) {
    acceptancePriors {
      price
      probability
    }
    continuationPriors {
      step
      probability
    }
  }
}
    `;

/**
 * __useComputeSmartPricingPriorsQuery__
 *
 * To run a query within a React component, call `useComputeSmartPricingPriorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComputeSmartPricingPriorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComputeSmartPricingPriorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useComputeSmartPricingPriorsQuery(baseOptions: Apollo.QueryHookOptions<ComputeSmartPricingPriorsQuery, ComputeSmartPricingPriorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComputeSmartPricingPriorsQuery, ComputeSmartPricingPriorsQueryVariables>(ComputeSmartPricingPriorsDocument, options);
      }
export function useComputeSmartPricingPriorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComputeSmartPricingPriorsQuery, ComputeSmartPricingPriorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComputeSmartPricingPriorsQuery, ComputeSmartPricingPriorsQueryVariables>(ComputeSmartPricingPriorsDocument, options);
        }
export type ComputeSmartPricingPriorsQueryHookResult = ReturnType<typeof useComputeSmartPricingPriorsQuery>;
export type ComputeSmartPricingPriorsLazyQueryHookResult = ReturnType<typeof useComputeSmartPricingPriorsLazyQuery>;
export type ComputeSmartPricingPriorsQueryResult = Apollo.QueryResult<ComputeSmartPricingPriorsQuery, ComputeSmartPricingPriorsQueryVariables>;
export const GetCarrierInterestContextDocument = gql`
    query GetCarrierInterestContext($input: GetCarrierInterestContextInput!) {
  carrierInterestContext(input: $input) {
    recentCarrierOffers {
      price
      createdAt
    }
    recentCarrierInquiries {
      createdAt
      actionExecutionId
      conversationId
    }
    recentCarriersTransferred {
      createdAt
      actionExecutionId
      conversationId
      transferType
    }
    rateGuidance {
      byMethod {
        method
        rate
        createdAt
        reports
        highRate
        lowRate
        standardDeviation
        mileage
        loadToTruckRatio
        dataPoints
        totalLoads
        totalTrucks
        averageRatio
        confidenceScore
      }
    }
    negotiationOffers {
      movementId
      offerAmount
      offeredBy
      accepted
      createdAt
    }
    historicalNegotiationOffers {
      movementId
      offerAmount
      offeredBy
      accepted
      createdAt
    }
  }
}
    `;

/**
 * __useGetCarrierInterestContextQuery__
 *
 * To run a query within a React component, call `useGetCarrierInterestContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarrierInterestContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarrierInterestContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCarrierInterestContextQuery(baseOptions: Apollo.QueryHookOptions<GetCarrierInterestContextQuery, GetCarrierInterestContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarrierInterestContextQuery, GetCarrierInterestContextQueryVariables>(GetCarrierInterestContextDocument, options);
      }
export function useGetCarrierInterestContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarrierInterestContextQuery, GetCarrierInterestContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarrierInterestContextQuery, GetCarrierInterestContextQueryVariables>(GetCarrierInterestContextDocument, options);
        }
export type GetCarrierInterestContextQueryHookResult = ReturnType<typeof useGetCarrierInterestContextQuery>;
export type GetCarrierInterestContextLazyQueryHookResult = ReturnType<typeof useGetCarrierInterestContextLazyQuery>;
export type GetCarrierInterestContextQueryResult = Apollo.QueryResult<GetCarrierInterestContextQuery, GetCarrierInterestContextQueryVariables>;
export const GetNegotiationStrategiesDocument = gql`
    query GetNegotiationStrategies($input: NegotiationStrategiesInput) {
  negotiationStrategies(input: $input) {
    id
    name
    type
  }
}
    `;

/**
 * __useGetNegotiationStrategiesQuery__
 *
 * To run a query within a React component, call `useGetNegotiationStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNegotiationStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNegotiationStrategiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNegotiationStrategiesQuery(baseOptions?: Apollo.QueryHookOptions<GetNegotiationStrategiesQuery, GetNegotiationStrategiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNegotiationStrategiesQuery, GetNegotiationStrategiesQueryVariables>(GetNegotiationStrategiesDocument, options);
      }
export function useGetNegotiationStrategiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNegotiationStrategiesQuery, GetNegotiationStrategiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNegotiationStrategiesQuery, GetNegotiationStrategiesQueryVariables>(GetNegotiationStrategiesDocument, options);
        }
export type GetNegotiationStrategiesQueryHookResult = ReturnType<typeof useGetNegotiationStrategiesQuery>;
export type GetNegotiationStrategiesLazyQueryHookResult = ReturnType<typeof useGetNegotiationStrategiesLazyQuery>;
export type GetNegotiationStrategiesQueryResult = Apollo.QueryResult<GetNegotiationStrategiesQuery, GetNegotiationStrategiesQueryVariables>;
export const GetNegotiationStrategyMarginDocument = gql`
    query GetNegotiationStrategyMargin($input: NegotiationStrategyMarginInput!) {
  negotiationStrategyMargin(input: $input) {
    conversationCount
    acceptedMarginPerConversation
    bookedMarginPerConversation
    totalAcceptedMargin
    totalBookedMargin
  }
}
    `;

/**
 * __useGetNegotiationStrategyMarginQuery__
 *
 * To run a query within a React component, call `useGetNegotiationStrategyMarginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNegotiationStrategyMarginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNegotiationStrategyMarginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNegotiationStrategyMarginQuery(baseOptions: Apollo.QueryHookOptions<GetNegotiationStrategyMarginQuery, GetNegotiationStrategyMarginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNegotiationStrategyMarginQuery, GetNegotiationStrategyMarginQueryVariables>(GetNegotiationStrategyMarginDocument, options);
      }
export function useGetNegotiationStrategyMarginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNegotiationStrategyMarginQuery, GetNegotiationStrategyMarginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNegotiationStrategyMarginQuery, GetNegotiationStrategyMarginQueryVariables>(GetNegotiationStrategyMarginDocument, options);
        }
export type GetNegotiationStrategyMarginQueryHookResult = ReturnType<typeof useGetNegotiationStrategyMarginQuery>;
export type GetNegotiationStrategyMarginLazyQueryHookResult = ReturnType<typeof useGetNegotiationStrategyMarginLazyQuery>;
export type GetNegotiationStrategyMarginQueryResult = Apollo.QueryResult<GetNegotiationStrategyMarginQuery, GetNegotiationStrategyMarginQueryVariables>;
export const GetOrganizationProductsDocument = gql`
    query GetOrganizationProducts($id: ID!) {
  getOrganizationProducts(id: $id)
}
    `;

/**
 * __useGetOrganizationProductsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProductsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationProductsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationProductsQuery, GetOrganizationProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProductsQuery, GetOrganizationProductsQueryVariables>(GetOrganizationProductsDocument, options);
      }
export function useGetOrganizationProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProductsQuery, GetOrganizationProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProductsQuery, GetOrganizationProductsQueryVariables>(GetOrganizationProductsDocument, options);
        }
export type GetOrganizationProductsQueryHookResult = ReturnType<typeof useGetOrganizationProductsQuery>;
export type GetOrganizationProductsLazyQueryHookResult = ReturnType<typeof useGetOrganizationProductsLazyQuery>;
export type GetOrganizationProductsQueryResult = Apollo.QueryResult<GetOrganizationProductsQuery, GetOrganizationProductsQueryVariables>;
export const OrganizationSettingsDocument = gql`
    query OrganizationSettings($id: ID!) {
  organizationById(id: $id) {
    ...OrganizationSettings
  }
}
    ${OrganizationSettingsFragmentDoc}`;

/**
 * __useOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>(OrganizationSettingsDocument, options);
      }
export function useOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>(OrganizationSettingsDocument, options);
        }
export type OrganizationSettingsQueryHookResult = ReturnType<typeof useOrganizationSettingsQuery>;
export type OrganizationSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationSettingsLazyQuery>;
export type OrganizationSettingsQueryResult = Apollo.QueryResult<OrganizationSettingsQuery, OrganizationSettingsQueryVariables>;
export const GetOrgUserEmailSignaturesDocument = gql`
    query GetOrgUserEmailSignatures($id: ID!) {
  organizationById(id: $id) {
    userEmailSignatures {
      ...UserDocumentUploadPreview
    }
  }
}
    ${UserDocumentUploadPreviewFragmentDoc}`;

/**
 * __useGetOrgUserEmailSignaturesQuery__
 *
 * To run a query within a React component, call `useGetOrgUserEmailSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgUserEmailSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgUserEmailSignaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrgUserEmailSignaturesQuery(baseOptions: Apollo.QueryHookOptions<GetOrgUserEmailSignaturesQuery, GetOrgUserEmailSignaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgUserEmailSignaturesQuery, GetOrgUserEmailSignaturesQueryVariables>(GetOrgUserEmailSignaturesDocument, options);
      }
export function useGetOrgUserEmailSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgUserEmailSignaturesQuery, GetOrgUserEmailSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgUserEmailSignaturesQuery, GetOrgUserEmailSignaturesQueryVariables>(GetOrgUserEmailSignaturesDocument, options);
        }
export type GetOrgUserEmailSignaturesQueryHookResult = ReturnType<typeof useGetOrgUserEmailSignaturesQuery>;
export type GetOrgUserEmailSignaturesLazyQueryHookResult = ReturnType<typeof useGetOrgUserEmailSignaturesLazyQuery>;
export type GetOrgUserEmailSignaturesQueryResult = Apollo.QueryResult<GetOrgUserEmailSignaturesQuery, GetOrgUserEmailSignaturesQueryVariables>;
export const GetOrganizationDocumentUploadsDocument = gql`
    query GetOrganizationDocumentUploads($id: ID!) {
  organizationById(id: $id) {
    emailSignatures {
      ...OrganizationDocumentUploadPreview
    }
  }
}
    ${OrganizationDocumentUploadPreviewFragmentDoc}`;

/**
 * __useGetOrganizationDocumentUploadsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDocumentUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDocumentUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDocumentUploadsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationDocumentUploadsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationDocumentUploadsQuery, GetOrganizationDocumentUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationDocumentUploadsQuery, GetOrganizationDocumentUploadsQueryVariables>(GetOrganizationDocumentUploadsDocument, options);
      }
export function useGetOrganizationDocumentUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDocumentUploadsQuery, GetOrganizationDocumentUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationDocumentUploadsQuery, GetOrganizationDocumentUploadsQueryVariables>(GetOrganizationDocumentUploadsDocument, options);
        }
export type GetOrganizationDocumentUploadsQueryHookResult = ReturnType<typeof useGetOrganizationDocumentUploadsQuery>;
export type GetOrganizationDocumentUploadsLazyQueryHookResult = ReturnType<typeof useGetOrganizationDocumentUploadsLazyQuery>;
export type GetOrganizationDocumentUploadsQueryResult = Apollo.QueryResult<GetOrganizationDocumentUploadsQuery, GetOrganizationDocumentUploadsQueryVariables>;
export const GetOrganizationFeatureFlagsDocument = gql`
    query GetOrganizationFeatureFlags {
  me {
    id
    organizationsDetails {
      id
      enabledFeatureFlags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationFeatureFlagsQuery, GetOrganizationFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationFeatureFlagsQuery, GetOrganizationFeatureFlagsQueryVariables>(GetOrganizationFeatureFlagsDocument, options);
      }
export function useGetOrganizationFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationFeatureFlagsQuery, GetOrganizationFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationFeatureFlagsQuery, GetOrganizationFeatureFlagsQueryVariables>(GetOrganizationFeatureFlagsDocument, options);
        }
export type GetOrganizationFeatureFlagsQueryHookResult = ReturnType<typeof useGetOrganizationFeatureFlagsQuery>;
export type GetOrganizationFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetOrganizationFeatureFlagsLazyQuery>;
export type GetOrganizationFeatureFlagsQueryResult = Apollo.QueryResult<GetOrganizationFeatureFlagsQuery, GetOrganizationFeatureFlagsQueryVariables>;
export const GetOriginatorOrderTemplateDocument = gql`
    query GetOriginatorOrderTemplate($input: GetOriginatorOrderTemplateInput!) {
  getOriginatorOrderTemplate(input: $input) {
    originatorName
    template {
      ...Template
    }
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __useGetOriginatorOrderTemplateQuery__
 *
 * To run a query within a React component, call `useGetOriginatorOrderTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOriginatorOrderTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOriginatorOrderTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOriginatorOrderTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetOriginatorOrderTemplateQuery, GetOriginatorOrderTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOriginatorOrderTemplateQuery, GetOriginatorOrderTemplateQueryVariables>(GetOriginatorOrderTemplateDocument, options);
      }
export function useGetOriginatorOrderTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOriginatorOrderTemplateQuery, GetOriginatorOrderTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOriginatorOrderTemplateQuery, GetOriginatorOrderTemplateQueryVariables>(GetOriginatorOrderTemplateDocument, options);
        }
export type GetOriginatorOrderTemplateQueryHookResult = ReturnType<typeof useGetOriginatorOrderTemplateQuery>;
export type GetOriginatorOrderTemplateLazyQueryHookResult = ReturnType<typeof useGetOriginatorOrderTemplateLazyQuery>;
export type GetOriginatorOrderTemplateQueryResult = Apollo.QueryResult<GetOriginatorOrderTemplateQuery, GetOriginatorOrderTemplateQueryVariables>;
export const OriginatorSettingsDocument = gql`
    query OriginatorSettings($id: ID!) {
  originatorById(id: $id) {
    id
    settings
  }
}
    `;

/**
 * __useOriginatorSettingsQuery__
 *
 * To run a query within a React component, call `useOriginatorSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginatorSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginatorSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOriginatorSettingsQuery(baseOptions: Apollo.QueryHookOptions<OriginatorSettingsQuery, OriginatorSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginatorSettingsQuery, OriginatorSettingsQueryVariables>(OriginatorSettingsDocument, options);
      }
export function useOriginatorSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginatorSettingsQuery, OriginatorSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginatorSettingsQuery, OriginatorSettingsQueryVariables>(OriginatorSettingsDocument, options);
        }
export type OriginatorSettingsQueryHookResult = ReturnType<typeof useOriginatorSettingsQuery>;
export type OriginatorSettingsLazyQueryHookResult = ReturnType<typeof useOriginatorSettingsLazyQuery>;
export type OriginatorSettingsQueryResult = Apollo.QueryResult<OriginatorSettingsQuery, OriginatorSettingsQueryVariables>;
export const GetOriginatorsDocument = gql`
    query GetOriginators($input: OriginatorsInput!) {
  originators(input: $input) {
    edges {
      node {
        ...Originator
      }
    }
  }
}
    ${OriginatorFragmentDoc}`;

/**
 * __useGetOriginatorsQuery__
 *
 * To run a query within a React component, call `useGetOriginatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOriginatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOriginatorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOriginatorsQuery(baseOptions: Apollo.QueryHookOptions<GetOriginatorsQuery, GetOriginatorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOriginatorsQuery, GetOriginatorsQueryVariables>(GetOriginatorsDocument, options);
      }
export function useGetOriginatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOriginatorsQuery, GetOriginatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOriginatorsQuery, GetOriginatorsQueryVariables>(GetOriginatorsDocument, options);
        }
export type GetOriginatorsQueryHookResult = ReturnType<typeof useGetOriginatorsQuery>;
export type GetOriginatorsLazyQueryHookResult = ReturnType<typeof useGetOriginatorsLazyQuery>;
export type GetOriginatorsQueryResult = Apollo.QueryResult<GetOriginatorsQuery, GetOriginatorsQueryVariables>;
export const CreatePlaceDocument = gql`
    mutation CreatePlace($input: CreatePlaceInput!) {
  createPlace(input: $input) {
    success
    failureReason
    place {
      ...Place
    }
  }
}
    ${PlaceFragmentDoc}`;
export type CreatePlaceMutationFn = Apollo.MutationFunction<CreatePlaceMutation, CreatePlaceMutationVariables>;

/**
 * __useCreatePlaceMutation__
 *
 * To run a mutation, you first call `useCreatePlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaceMutation, { data, loading, error }] = useCreatePlaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaceMutation, CreatePlaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaceMutation, CreatePlaceMutationVariables>(CreatePlaceDocument, options);
      }
export type CreatePlaceMutationHookResult = ReturnType<typeof useCreatePlaceMutation>;
export type CreatePlaceMutationResult = Apollo.MutationResult<CreatePlaceMutation>;
export type CreatePlaceMutationOptions = Apollo.BaseMutationOptions<CreatePlaceMutation, CreatePlaceMutationVariables>;
export const PlaceDocument = gql`
    query Place($id: ID!, $includeDeleted: Boolean) {
  placeById(id: $id, includeDeleted: $includeDeleted) {
    ...Place
  }
}
    ${PlaceFragmentDoc}`;

/**
 * __usePlaceQuery__
 *
 * To run a query within a React component, call `usePlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function usePlaceQuery(baseOptions: Apollo.QueryHookOptions<PlaceQuery, PlaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceQuery, PlaceQueryVariables>(PlaceDocument, options);
      }
export function usePlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceQuery, PlaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceQuery, PlaceQueryVariables>(PlaceDocument, options);
        }
export type PlaceQueryHookResult = ReturnType<typeof usePlaceQuery>;
export type PlaceLazyQueryHookResult = ReturnType<typeof usePlaceLazyQuery>;
export type PlaceQueryResult = Apollo.QueryResult<PlaceQuery, PlaceQueryVariables>;
export const PlaceSchedulingDocument = gql`
    query PlaceScheduling($placeId: ID!) {
  placeScheduling(placeId: $placeId) {
    ...PlaceScheduling
  }
}
    ${PlaceSchedulingFragmentDoc}`;

/**
 * __usePlaceSchedulingQuery__
 *
 * To run a query within a React component, call `usePlaceSchedulingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceSchedulingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceSchedulingQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function usePlaceSchedulingQuery(baseOptions: Apollo.QueryHookOptions<PlaceSchedulingQuery, PlaceSchedulingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceSchedulingQuery, PlaceSchedulingQueryVariables>(PlaceSchedulingDocument, options);
      }
export function usePlaceSchedulingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceSchedulingQuery, PlaceSchedulingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceSchedulingQuery, PlaceSchedulingQueryVariables>(PlaceSchedulingDocument, options);
        }
export type PlaceSchedulingQueryHookResult = ReturnType<typeof usePlaceSchedulingQuery>;
export type PlaceSchedulingLazyQueryHookResult = ReturnType<typeof usePlaceSchedulingLazyQuery>;
export type PlaceSchedulingQueryResult = Apollo.QueryResult<PlaceSchedulingQuery, PlaceSchedulingQueryVariables>;
export const GetPlacesDocument = gql`
    query GetPlaces($input: PlacesInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput) {
  places(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        ...Place
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${PlaceFragmentDoc}`;

/**
 * __useGetPlacesQuery__
 *
 * To run a query within a React component, call `useGetPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetPlacesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
      }
export function useGetPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlacesQuery, GetPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlacesQuery, GetPlacesQueryVariables>(GetPlacesDocument, options);
        }
export type GetPlacesQueryHookResult = ReturnType<typeof useGetPlacesQuery>;
export type GetPlacesLazyQueryHookResult = ReturnType<typeof useGetPlacesLazyQuery>;
export type GetPlacesQueryResult = Apollo.QueryResult<GetPlacesQuery, GetPlacesQueryVariables>;
export const QuoteDocument = gql`
    query Quote($id: ID!) {
  quoteById(id: $id) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}`;

/**
 * __useQuoteQuery__
 *
 * To run a query within a React component, call `useQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteQuery(baseOptions: Apollo.QueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
      }
export function useQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
        }
export type QuoteQueryHookResult = ReturnType<typeof useQuoteQuery>;
export type QuoteLazyQueryHookResult = ReturnType<typeof useQuoteLazyQuery>;
export type QuoteQueryResult = Apollo.QueryResult<QuoteQuery, QuoteQueryVariables>;
export const QuoteEventsDocument = gql`
    query QuoteEvents($id: ID!) {
  quoteById(id: $id) {
    id
    extractedData
    originator {
      name
    }
    quoteEvents {
      user {
        firstName
        lastName
        email
        id
      }
      createdAt
      metadata
      type
    }
    quoteNotes {
      user {
        firstName
        lastName
        email
        id
      }
      note
      createdAt
    }
  }
}
    `;

/**
 * __useQuoteEventsQuery__
 *
 * To run a query within a React component, call `useQuoteEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteEventsQuery(baseOptions: Apollo.QueryHookOptions<QuoteEventsQuery, QuoteEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteEventsQuery, QuoteEventsQueryVariables>(QuoteEventsDocument, options);
      }
export function useQuoteEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteEventsQuery, QuoteEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteEventsQuery, QuoteEventsQueryVariables>(QuoteEventsDocument, options);
        }
export type QuoteEventsQueryHookResult = ReturnType<typeof useQuoteEventsQuery>;
export type QuoteEventsLazyQueryHookResult = ReturnType<typeof useQuoteEventsLazyQuery>;
export type QuoteEventsQueryResult = Apollo.QueryResult<QuoteEventsQuery, QuoteEventsQueryVariables>;
export const QuoteMileageDocument = gql`
    query QuoteMileage($id: ID!) {
  quoteMileage(id: $id) {
    id
    units
    value
  }
}
    `;

/**
 * __useQuoteMileageQuery__
 *
 * To run a query within a React component, call `useQuoteMileageQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteMileageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteMileageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteMileageQuery(baseOptions: Apollo.QueryHookOptions<QuoteMileageQuery, QuoteMileageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteMileageQuery, QuoteMileageQueryVariables>(QuoteMileageDocument, options);
      }
export function useQuoteMileageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteMileageQuery, QuoteMileageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteMileageQuery, QuoteMileageQueryVariables>(QuoteMileageDocument, options);
        }
export type QuoteMileageQueryHookResult = ReturnType<typeof useQuoteMileageQuery>;
export type QuoteMileageLazyQueryHookResult = ReturnType<typeof useQuoteMileageLazyQuery>;
export type QuoteMileageQueryResult = Apollo.QueryResult<QuoteMileageQuery, QuoteMileageQueryVariables>;
export const GetQuoteRateFormDocument = gql`
    query GetQuoteRateForm($id: ID!) {
  quoteById(id: $id) {
    rateForm {
      carrierRateId
      customerRateId
      lineItems {
        index
        componentId
        type
        description
        buyRate
        sellRate
      }
    }
  }
}
    `;

/**
 * __useGetQuoteRateFormQuery__
 *
 * To run a query within a React component, call `useGetQuoteRateFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteRateFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteRateFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQuoteRateFormQuery(baseOptions: Apollo.QueryHookOptions<GetQuoteRateFormQuery, GetQuoteRateFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteRateFormQuery, GetQuoteRateFormQueryVariables>(GetQuoteRateFormDocument, options);
      }
export function useGetQuoteRateFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteRateFormQuery, GetQuoteRateFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteRateFormQuery, GetQuoteRateFormQueryVariables>(GetQuoteRateFormDocument, options);
        }
export type GetQuoteRateFormQueryHookResult = ReturnType<typeof useGetQuoteRateFormQuery>;
export type GetQuoteRateFormLazyQueryHookResult = ReturnType<typeof useGetQuoteRateFormLazyQuery>;
export type GetQuoteRateFormQueryResult = Apollo.QueryResult<GetQuoteRateFormQuery, GetQuoteRateFormQueryVariables>;
export const QuoteValidationDocument = gql`
    query QuoteValidation($id: ID!) {
  quoteById(id: $id) {
    id
    validation {
      valid
      missingFields
      validationMessage
    }
  }
}
    `;

/**
 * __useQuoteValidationQuery__
 *
 * To run a query within a React component, call `useQuoteValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteValidationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteValidationQuery(baseOptions: Apollo.QueryHookOptions<QuoteValidationQuery, QuoteValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteValidationQuery, QuoteValidationQueryVariables>(QuoteValidationDocument, options);
      }
export function useQuoteValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteValidationQuery, QuoteValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteValidationQuery, QuoteValidationQueryVariables>(QuoteValidationDocument, options);
        }
export type QuoteValidationQueryHookResult = ReturnType<typeof useQuoteValidationQuery>;
export type QuoteValidationLazyQueryHookResult = ReturnType<typeof useQuoteValidationLazyQuery>;
export type QuoteValidationQueryResult = Apollo.QueryResult<QuoteValidationQuery, QuoteValidationQueryVariables>;
export const GetQuotesDocument = gql`
    query GetQuotes($input: QuotesInput) {
  quotes(input: $input) {
    edges {
      node {
        ...Quote
      }
    }
    totalCount
  }
}
    ${QuoteFragmentDoc}`;

/**
 * __useGetQuotesQuery__
 *
 * To run a query within a React component, call `useGetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
      }
export function useGetQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
export type GetQuotesQueryHookResult = ReturnType<typeof useGetQuotesQuery>;
export type GetQuotesLazyQueryHookResult = ReturnType<typeof useGetQuotesLazyQuery>;
export type GetQuotesQueryResult = Apollo.QueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export const GetScheduleSettingsDocument = gql`
    query GetScheduleSettings($organizationId: ID!) {
  scheduleSettings(organizationId: $organizationId) {
    id
    organizationId
    name
    isActive
    plannerActionDefinitionId
    planningSettings {
      __typename
      ... on AgenticPlannerSettings {
        type
      }
      ... on DeterministicPlanningSettings {
        type
        sequencing
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetScheduleSettingsQuery__
 *
 * To run a query within a React component, call `useGetScheduleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetScheduleSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleSettingsQuery, GetScheduleSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleSettingsQuery, GetScheduleSettingsQueryVariables>(GetScheduleSettingsDocument, options);
      }
export function useGetScheduleSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleSettingsQuery, GetScheduleSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleSettingsQuery, GetScheduleSettingsQueryVariables>(GetScheduleSettingsDocument, options);
        }
export type GetScheduleSettingsQueryHookResult = ReturnType<typeof useGetScheduleSettingsQuery>;
export type GetScheduleSettingsLazyQueryHookResult = ReturnType<typeof useGetScheduleSettingsLazyQuery>;
export type GetScheduleSettingsQueryResult = Apollo.QueryResult<GetScheduleSettingsQuery, GetScheduleSettingsQueryVariables>;
export const MovementSchedulePlanDocument = gql`
    query MovementSchedulePlan($movementId: ID!) {
  movementSchedulePlan(movementId: $movementId) {
    id
    status
    plan
    planningActionExecution {
      id
      status
    }
  }
}
    `;

/**
 * __useMovementSchedulePlanQuery__
 *
 * To run a query within a React component, call `useMovementSchedulePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovementSchedulePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovementSchedulePlanQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useMovementSchedulePlanQuery(baseOptions: Apollo.QueryHookOptions<MovementSchedulePlanQuery, MovementSchedulePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovementSchedulePlanQuery, MovementSchedulePlanQueryVariables>(MovementSchedulePlanDocument, options);
      }
export function useMovementSchedulePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovementSchedulePlanQuery, MovementSchedulePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovementSchedulePlanQuery, MovementSchedulePlanQueryVariables>(MovementSchedulePlanDocument, options);
        }
export type MovementSchedulePlanQueryHookResult = ReturnType<typeof useMovementSchedulePlanQuery>;
export type MovementSchedulePlanLazyQueryHookResult = ReturnType<typeof useMovementSchedulePlanLazyQuery>;
export type MovementSchedulePlanQueryResult = Apollo.QueryResult<MovementSchedulePlanQuery, MovementSchedulePlanQueryVariables>;
export const SchedulePlanSchedulingInfoDocument = gql`
    query SchedulePlanSchedulingInfo($shipmentId: ID!) {
  shipmentById(id: $shipmentId) {
    id
    schedulingInfo {
      stops
    }
  }
}
    `;

/**
 * __useSchedulePlanSchedulingInfoQuery__
 *
 * To run a query within a React component, call `useSchedulePlanSchedulingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulePlanSchedulingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulePlanSchedulingInfoQuery({
 *   variables: {
 *      shipmentId: // value for 'shipmentId'
 *   },
 * });
 */
export function useSchedulePlanSchedulingInfoQuery(baseOptions: Apollo.QueryHookOptions<SchedulePlanSchedulingInfoQuery, SchedulePlanSchedulingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulePlanSchedulingInfoQuery, SchedulePlanSchedulingInfoQueryVariables>(SchedulePlanSchedulingInfoDocument, options);
      }
export function useSchedulePlanSchedulingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulePlanSchedulingInfoQuery, SchedulePlanSchedulingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulePlanSchedulingInfoQuery, SchedulePlanSchedulingInfoQueryVariables>(SchedulePlanSchedulingInfoDocument, options);
        }
export type SchedulePlanSchedulingInfoQueryHookResult = ReturnType<typeof useSchedulePlanSchedulingInfoQuery>;
export type SchedulePlanSchedulingInfoLazyQueryHookResult = ReturnType<typeof useSchedulePlanSchedulingInfoLazyQuery>;
export type SchedulePlanSchedulingInfoQueryResult = Apollo.QueryResult<SchedulePlanSchedulingInfoQuery, SchedulePlanSchedulingInfoQueryVariables>;
export const SchedulePlansDocument = gql`
    query SchedulePlans($limit: Int, $organizationId: ID!, $statuses: [SchedulePlanStatus!]!) {
  schedulePlans(
    limit: $limit
    organizationId: $organizationId
    statuses: $statuses
  ) {
    id
    status
    plan
    movement {
      id
      shipment {
        id
        referenceNumbers
      }
    }
    planningActionExecution {
      id
      status
    }
  }
}
    `;

/**
 * __useSchedulePlansQuery__
 *
 * To run a query within a React component, call `useSchedulePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulePlansQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      organizationId: // value for 'organizationId'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useSchedulePlansQuery(baseOptions: Apollo.QueryHookOptions<SchedulePlansQuery, SchedulePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulePlansQuery, SchedulePlansQueryVariables>(SchedulePlansDocument, options);
      }
export function useSchedulePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulePlansQuery, SchedulePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulePlansQuery, SchedulePlansQueryVariables>(SchedulePlansDocument, options);
        }
export type SchedulePlansQueryHookResult = ReturnType<typeof useSchedulePlansQuery>;
export type SchedulePlansLazyQueryHookResult = ReturnType<typeof useSchedulePlansLazyQuery>;
export type SchedulePlansQueryResult = Apollo.QueryResult<SchedulePlansQuery, SchedulePlansQueryVariables>;
export const GetNotificationSettingsDocument = gql`
    query GetNotificationSettings($input: NotificationSettingsInput!) {
  notificationSettings(input: $input) {
    settingsByLevel {
      ORGANIZATION
      TEAM
      USER
    }
    resolvedSettingsByLevel {
      ORGANIZATION
      TEAM
      USER
    }
  }
}
    `;

/**
 * __useGetNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSettingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNotificationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
      }
export function useGetNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
        }
export type GetNotificationSettingsQueryHookResult = ReturnType<typeof useGetNotificationSettingsQuery>;
export type GetNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetNotificationSettingsLazyQuery>;
export type GetNotificationSettingsQueryResult = Apollo.QueryResult<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const SharedFileByIdDocument = gql`
    query SharedFileById($id: ID!, $includeContent: Boolean) {
  sharedFileById(id: $id, includeContent: $includeContent) {
    file {
      ...SharedFileSummary
    }
    version {
      id
      fileName
      contentType
      url
    }
    content
  }
}
    ${SharedFileSummaryFragmentDoc}`;

/**
 * __useSharedFileByIdQuery__
 *
 * To run a query within a React component, call `useSharedFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeContent: // value for 'includeContent'
 *   },
 * });
 */
export function useSharedFileByIdQuery(baseOptions: Apollo.QueryHookOptions<SharedFileByIdQuery, SharedFileByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedFileByIdQuery, SharedFileByIdQueryVariables>(SharedFileByIdDocument, options);
      }
export function useSharedFileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedFileByIdQuery, SharedFileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedFileByIdQuery, SharedFileByIdQueryVariables>(SharedFileByIdDocument, options);
        }
export type SharedFileByIdQueryHookResult = ReturnType<typeof useSharedFileByIdQuery>;
export type SharedFileByIdLazyQueryHookResult = ReturnType<typeof useSharedFileByIdLazyQuery>;
export type SharedFileByIdQueryResult = Apollo.QueryResult<SharedFileByIdQuery, SharedFileByIdQueryVariables>;
export const SharedFilesDocument = gql`
    query SharedFiles($input: SharedFilesInput) {
  sharedFiles(input: $input) {
    nodes {
      ...SharedFileSummary
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    count
    totalCount
  }
}
    ${SharedFileSummaryFragmentDoc}`;

/**
 * __useSharedFilesQuery__
 *
 * To run a query within a React component, call `useSharedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharedFilesQuery(baseOptions?: Apollo.QueryHookOptions<SharedFilesQuery, SharedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedFilesQuery, SharedFilesQueryVariables>(SharedFilesDocument, options);
      }
export function useSharedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedFilesQuery, SharedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedFilesQuery, SharedFilesQueryVariables>(SharedFilesDocument, options);
        }
export type SharedFilesQueryHookResult = ReturnType<typeof useSharedFilesQuery>;
export type SharedFilesLazyQueryHookResult = ReturnType<typeof useSharedFilesLazyQuery>;
export type SharedFilesQueryResult = Apollo.QueryResult<SharedFilesQuery, SharedFilesQueryVariables>;
export const FindShipmentDocument = gql`
    query FindShipment($input: FindShipmentInput!) {
  findShipment(input: $input) {
    shipmentId
  }
}
    `;

/**
 * __useFindShipmentQuery__
 *
 * To run a query within a React component, call `useFindShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindShipmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindShipmentQuery(baseOptions: Apollo.QueryHookOptions<FindShipmentQuery, FindShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindShipmentQuery, FindShipmentQueryVariables>(FindShipmentDocument, options);
      }
export function useFindShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindShipmentQuery, FindShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindShipmentQuery, FindShipmentQueryVariables>(FindShipmentDocument, options);
        }
export type FindShipmentQueryHookResult = ReturnType<typeof useFindShipmentQuery>;
export type FindShipmentLazyQueryHookResult = ReturnType<typeof useFindShipmentLazyQuery>;
export type FindShipmentQueryResult = Apollo.QueryResult<FindShipmentQuery, FindShipmentQueryVariables>;
export const ShipmentDistanceDocument = gql`
    query ShipmentDistance($id: ID!) {
  getShipmentDistance(id: $id) {
    distance
    usdPerMile
  }
}
    `;

/**
 * __useShipmentDistanceQuery__
 *
 * To run a query within a React component, call `useShipmentDistanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentDistanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentDistanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShipmentDistanceQuery(baseOptions: Apollo.QueryHookOptions<ShipmentDistanceQuery, ShipmentDistanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentDistanceQuery, ShipmentDistanceQueryVariables>(ShipmentDistanceDocument, options);
      }
export function useShipmentDistanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentDistanceQuery, ShipmentDistanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentDistanceQuery, ShipmentDistanceQueryVariables>(ShipmentDistanceDocument, options);
        }
export type ShipmentDistanceQueryHookResult = ReturnType<typeof useShipmentDistanceQuery>;
export type ShipmentDistanceLazyQueryHookResult = ReturnType<typeof useShipmentDistanceLazyQuery>;
export type ShipmentDistanceQueryResult = Apollo.QueryResult<ShipmentDistanceQuery, ShipmentDistanceQueryVariables>;
export const GetLaneShipmentsDocument = gql`
    query GetLaneShipments($input: ShipmentsInput) {
  shipments(input: $input) {
    edges {
      node {
        ...ShipmentHistorySummary
      }
    }
  }
}
    ${ShipmentHistorySummaryFragmentDoc}`;

/**
 * __useGetLaneShipmentsQuery__
 *
 * To run a query within a React component, call `useGetLaneShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaneShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaneShipmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLaneShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetLaneShipmentsQuery, GetLaneShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaneShipmentsQuery, GetLaneShipmentsQueryVariables>(GetLaneShipmentsDocument, options);
      }
export function useGetLaneShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaneShipmentsQuery, GetLaneShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaneShipmentsQuery, GetLaneShipmentsQueryVariables>(GetLaneShipmentsDocument, options);
        }
export type GetLaneShipmentsQueryHookResult = ReturnType<typeof useGetLaneShipmentsQuery>;
export type GetLaneShipmentsLazyQueryHookResult = ReturnType<typeof useGetLaneShipmentsLazyQuery>;
export type GetLaneShipmentsQueryResult = Apollo.QueryResult<GetLaneShipmentsQuery, GetLaneShipmentsQueryVariables>;
export const GetLoadBoardPostingsDocument = gql`
    query GetLoadBoardPostings($input: GetLoadBoardPostingsInput!) {
  getLoadBoardPostings(input: $input) {
    postings {
      integrationType
      externalId
      postingUrl
    }
  }
}
    `;

/**
 * __useGetLoadBoardPostingsQuery__
 *
 * To run a query within a React component, call `useGetLoadBoardPostingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoadBoardPostingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoadBoardPostingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLoadBoardPostingsQuery(baseOptions: Apollo.QueryHookOptions<GetLoadBoardPostingsQuery, GetLoadBoardPostingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoadBoardPostingsQuery, GetLoadBoardPostingsQueryVariables>(GetLoadBoardPostingsDocument, options);
      }
export function useGetLoadBoardPostingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoadBoardPostingsQuery, GetLoadBoardPostingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoadBoardPostingsQuery, GetLoadBoardPostingsQueryVariables>(GetLoadBoardPostingsDocument, options);
        }
export type GetLoadBoardPostingsQueryHookResult = ReturnType<typeof useGetLoadBoardPostingsQuery>;
export type GetLoadBoardPostingsLazyQueryHookResult = ReturnType<typeof useGetLoadBoardPostingsLazyQuery>;
export type GetLoadBoardPostingsQueryResult = Apollo.QueryResult<GetLoadBoardPostingsQuery, GetLoadBoardPostingsQueryVariables>;
export const ShipmentDocument = gql`
    query Shipment($id: ID!) {
  shipmentById(id: $id) {
    ...Shipment
  }
}
    ${ShipmentFragmentDoc}`;

/**
 * __useShipmentQuery__
 *
 * To run a query within a React component, call `useShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShipmentQuery(baseOptions: Apollo.QueryHookOptions<ShipmentQuery, ShipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipmentQuery, ShipmentQueryVariables>(ShipmentDocument, options);
      }
export function useShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipmentQuery, ShipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipmentQuery, ShipmentQueryVariables>(ShipmentDocument, options);
        }
export type ShipmentQueryHookResult = ReturnType<typeof useShipmentQuery>;
export type ShipmentLazyQueryHookResult = ReturnType<typeof useShipmentLazyQuery>;
export type ShipmentQueryResult = Apollo.QueryResult<ShipmentQuery, ShipmentQueryVariables>;
export const GetShipmentsDocument = gql`
    query GetShipments($input: ShipmentsInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput, $shouldUseDefaultView: Boolean) {
  shipments(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
    shouldUseDefaultView: $shouldUseDefaultView
  ) {
    edges {
      node {
        ...ShipmentPreview
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    savedViewRedirect
  }
}
    ${ShipmentPreviewFragmentDoc}`;

/**
 * __useGetShipmentsQuery__
 *
 * To run a query within a React component, call `useGetShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *      shouldUseDefaultView: // value for 'shouldUseDefaultView'
 *   },
 * });
 */
export function useGetShipmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
      }
export function useGetShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipmentsQuery, GetShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipmentsQuery, GetShipmentsQueryVariables>(GetShipmentsDocument, options);
        }
export type GetShipmentsQueryHookResult = ReturnType<typeof useGetShipmentsQuery>;
export type GetShipmentsLazyQueryHookResult = ReturnType<typeof useGetShipmentsLazyQuery>;
export type GetShipmentsQueryResult = Apollo.QueryResult<GetShipmentsQuery, GetShipmentsQueryVariables>;
export const GetSchedulePortalAvailabilityCheckDocument = gql`
    query GetSchedulePortalAvailabilityCheck($input: GetSchedulePortalAvailabilityCheckInput!) {
  getSchedulePortalAvailabilityCheck(input: $input) {
    check {
      times
      info
      fields {
        ...Opendock
      }
    }
  }
}
    ${OpendockFragmentDoc}`;

/**
 * __useGetSchedulePortalAvailabilityCheckQuery__
 *
 * To run a query within a React component, call `useGetSchedulePortalAvailabilityCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulePortalAvailabilityCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulePortalAvailabilityCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSchedulePortalAvailabilityCheckQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulePortalAvailabilityCheckQuery, GetSchedulePortalAvailabilityCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulePortalAvailabilityCheckQuery, GetSchedulePortalAvailabilityCheckQueryVariables>(GetSchedulePortalAvailabilityCheckDocument, options);
      }
export function useGetSchedulePortalAvailabilityCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulePortalAvailabilityCheckQuery, GetSchedulePortalAvailabilityCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulePortalAvailabilityCheckQuery, GetSchedulePortalAvailabilityCheckQueryVariables>(GetSchedulePortalAvailabilityCheckDocument, options);
        }
export type GetSchedulePortalAvailabilityCheckQueryHookResult = ReturnType<typeof useGetSchedulePortalAvailabilityCheckQuery>;
export type GetSchedulePortalAvailabilityCheckLazyQueryHookResult = ReturnType<typeof useGetSchedulePortalAvailabilityCheckLazyQuery>;
export type GetSchedulePortalAvailabilityCheckQueryResult = Apollo.QueryResult<GetSchedulePortalAvailabilityCheckQuery, GetSchedulePortalAvailabilityCheckQueryVariables>;
export const TriggerSopAppointmentSchedulingDocument = gql`
    mutation TriggerSOPAppointmentScheduling($input: TriggerSOPAppointmentSchedulingInput!) {
  triggerSOPAppointmentScheduling(input: $input) {
    success
    error
  }
}
    `;
export type TriggerSopAppointmentSchedulingMutationFn = Apollo.MutationFunction<TriggerSopAppointmentSchedulingMutation, TriggerSopAppointmentSchedulingMutationVariables>;

/**
 * __useTriggerSopAppointmentSchedulingMutation__
 *
 * To run a mutation, you first call `useTriggerSopAppointmentSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerSopAppointmentSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerSopAppointmentSchedulingMutation, { data, loading, error }] = useTriggerSopAppointmentSchedulingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerSopAppointmentSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<TriggerSopAppointmentSchedulingMutation, TriggerSopAppointmentSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerSopAppointmentSchedulingMutation, TriggerSopAppointmentSchedulingMutationVariables>(TriggerSopAppointmentSchedulingDocument, options);
      }
export type TriggerSopAppointmentSchedulingMutationHookResult = ReturnType<typeof useTriggerSopAppointmentSchedulingMutation>;
export type TriggerSopAppointmentSchedulingMutationResult = Apollo.MutationResult<TriggerSopAppointmentSchedulingMutation>;
export type TriggerSopAppointmentSchedulingMutationOptions = Apollo.BaseMutationOptions<TriggerSopAppointmentSchedulingMutation, TriggerSopAppointmentSchedulingMutationVariables>;
export const TriggerPortalAppointmentSchedulingDocument = gql`
    mutation TriggerPortalAppointmentScheduling($input: TriggerPortalAppointmentSchedulingInput!) {
  triggerPortalAppointmentScheduling(input: $input) {
    success
    error
  }
}
    `;
export type TriggerPortalAppointmentSchedulingMutationFn = Apollo.MutationFunction<TriggerPortalAppointmentSchedulingMutation, TriggerPortalAppointmentSchedulingMutationVariables>;

/**
 * __useTriggerPortalAppointmentSchedulingMutation__
 *
 * To run a mutation, you first call `useTriggerPortalAppointmentSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPortalAppointmentSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPortalAppointmentSchedulingMutation, { data, loading, error }] = useTriggerPortalAppointmentSchedulingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerPortalAppointmentSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<TriggerPortalAppointmentSchedulingMutation, TriggerPortalAppointmentSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerPortalAppointmentSchedulingMutation, TriggerPortalAppointmentSchedulingMutationVariables>(TriggerPortalAppointmentSchedulingDocument, options);
      }
export type TriggerPortalAppointmentSchedulingMutationHookResult = ReturnType<typeof useTriggerPortalAppointmentSchedulingMutation>;
export type TriggerPortalAppointmentSchedulingMutationResult = Apollo.MutationResult<TriggerPortalAppointmentSchedulingMutation>;
export type TriggerPortalAppointmentSchedulingMutationOptions = Apollo.BaseMutationOptions<TriggerPortalAppointmentSchedulingMutation, TriggerPortalAppointmentSchedulingMutationVariables>;
export const UpdatePlaceScheduleMethodDocument = gql`
    mutation UpdatePlaceScheduleMethod($input: UpdatePlaceScheduleMethodInput!) {
  updatePlaceScheduleMethod(input: $input) {
    success
  }
}
    `;
export type UpdatePlaceScheduleMethodMutationFn = Apollo.MutationFunction<UpdatePlaceScheduleMethodMutation, UpdatePlaceScheduleMethodMutationVariables>;

/**
 * __useUpdatePlaceScheduleMethodMutation__
 *
 * To run a mutation, you first call `useUpdatePlaceScheduleMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaceScheduleMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaceScheduleMethodMutation, { data, loading, error }] = useUpdatePlaceScheduleMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaceScheduleMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaceScheduleMethodMutation, UpdatePlaceScheduleMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaceScheduleMethodMutation, UpdatePlaceScheduleMethodMutationVariables>(UpdatePlaceScheduleMethodDocument, options);
      }
export type UpdatePlaceScheduleMethodMutationHookResult = ReturnType<typeof useUpdatePlaceScheduleMethodMutation>;
export type UpdatePlaceScheduleMethodMutationResult = Apollo.MutationResult<UpdatePlaceScheduleMethodMutation>;
export type UpdatePlaceScheduleMethodMutationOptions = Apollo.BaseMutationOptions<UpdatePlaceScheduleMethodMutation, UpdatePlaceScheduleMethodMutationVariables>;
export const SimulationBrokerOrganizationsDocument = gql`
    query SimulationBrokerOrganizations {
  simulationBrokerOrganizations {
    id
    name
  }
}
    `;

/**
 * __useSimulationBrokerOrganizationsQuery__
 *
 * To run a query within a React component, call `useSimulationBrokerOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulationBrokerOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulationBrokerOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimulationBrokerOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<SimulationBrokerOrganizationsQuery, SimulationBrokerOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimulationBrokerOrganizationsQuery, SimulationBrokerOrganizationsQueryVariables>(SimulationBrokerOrganizationsDocument, options);
      }
export function useSimulationBrokerOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimulationBrokerOrganizationsQuery, SimulationBrokerOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimulationBrokerOrganizationsQuery, SimulationBrokerOrganizationsQueryVariables>(SimulationBrokerOrganizationsDocument, options);
        }
export type SimulationBrokerOrganizationsQueryHookResult = ReturnType<typeof useSimulationBrokerOrganizationsQuery>;
export type SimulationBrokerOrganizationsLazyQueryHookResult = ReturnType<typeof useSimulationBrokerOrganizationsLazyQuery>;
export type SimulationBrokerOrganizationsQueryResult = Apollo.QueryResult<SimulationBrokerOrganizationsQuery, SimulationBrokerOrganizationsQueryVariables>;
export const SimulationOrganizationsDocument = gql`
    query SimulationOrganizations {
  organizations(first: 1000) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSimulationOrganizationsQuery__
 *
 * To run a query within a React component, call `useSimulationOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulationOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulationOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimulationOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<SimulationOrganizationsQuery, SimulationOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimulationOrganizationsQuery, SimulationOrganizationsQueryVariables>(SimulationOrganizationsDocument, options);
      }
export function useSimulationOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimulationOrganizationsQuery, SimulationOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimulationOrganizationsQuery, SimulationOrganizationsQueryVariables>(SimulationOrganizationsDocument, options);
        }
export type SimulationOrganizationsQueryHookResult = ReturnType<typeof useSimulationOrganizationsQuery>;
export type SimulationOrganizationsLazyQueryHookResult = ReturnType<typeof useSimulationOrganizationsLazyQuery>;
export type SimulationOrganizationsQueryResult = Apollo.QueryResult<SimulationOrganizationsQuery, SimulationOrganizationsQueryVariables>;
export const SimulationSettingsDocument = gql`
    query SimulationSettings($organizationId: ID!) {
  simulationSettings(organizationId: $organizationId) {
    organizationId
    isSimulationBroker
    enabled
    intervalMinutes
    carrierInquiryActionDefinitionId
    carrierInquiryActionDefinitionOrganizationId
  }
}
    `;

/**
 * __useSimulationSettingsQuery__
 *
 * To run a query within a React component, call `useSimulationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSimulationSettingsQuery(baseOptions: Apollo.QueryHookOptions<SimulationSettingsQuery, SimulationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimulationSettingsQuery, SimulationSettingsQueryVariables>(SimulationSettingsDocument, options);
      }
export function useSimulationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimulationSettingsQuery, SimulationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimulationSettingsQuery, SimulationSettingsQueryVariables>(SimulationSettingsDocument, options);
        }
export type SimulationSettingsQueryHookResult = ReturnType<typeof useSimulationSettingsQuery>;
export type SimulationSettingsLazyQueryHookResult = ReturnType<typeof useSimulationSettingsLazyQuery>;
export type SimulationSettingsQueryResult = Apollo.QueryResult<SimulationSettingsQuery, SimulationSettingsQueryVariables>;
export const TemplateDocument = gql`
    query Template($id: ID!) {
  templateById(id: $id) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __useTemplateQuery__
 *
 * To run a query within a React component, call `useTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateQuery(baseOptions: Apollo.QueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
      }
export function useTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateQuery, TemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateQuery, TemplateQueryVariables>(TemplateDocument, options);
        }
export type TemplateQueryHookResult = ReturnType<typeof useTemplateQuery>;
export type TemplateLazyQueryHookResult = ReturnType<typeof useTemplateLazyQuery>;
export type TemplateQueryResult = Apollo.QueryResult<TemplateQuery, TemplateQueryVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates($input: TemplatesInput!) {
  templates(input: $input) {
    edges {
      node {
        ...TemplatePreview
      }
    }
  }
}
    ${TemplatePreviewFragmentDoc}`;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetActiveLoadsCountDocument = gql`
    query GetActiveLoadsCount($organizationId: ID!) {
  activeLoadsCount(organizationId: $organizationId) {
    active
    inactive
  }
}
    `;

/**
 * __useGetActiveLoadsCountQuery__
 *
 * To run a query within a React component, call `useGetActiveLoadsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveLoadsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveLoadsCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetActiveLoadsCountQuery(baseOptions: Apollo.QueryHookOptions<GetActiveLoadsCountQuery, GetActiveLoadsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveLoadsCountQuery, GetActiveLoadsCountQueryVariables>(GetActiveLoadsCountDocument, options);
      }
export function useGetActiveLoadsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveLoadsCountQuery, GetActiveLoadsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveLoadsCountQuery, GetActiveLoadsCountQueryVariables>(GetActiveLoadsCountDocument, options);
        }
export type GetActiveLoadsCountQueryHookResult = ReturnType<typeof useGetActiveLoadsCountQuery>;
export type GetActiveLoadsCountLazyQueryHookResult = ReturnType<typeof useGetActiveLoadsCountLazyQuery>;
export type GetActiveLoadsCountQueryResult = Apollo.QueryResult<GetActiveLoadsCountQuery, GetActiveLoadsCountQueryVariables>;
export const GetExceptionEventsWithMessagesDocument = gql`
    query GetExceptionEventsWithMessages($movementId: ID!) {
  exceptionEventsByMovementId(movementId: $movementId) {
    event {
      id
      createdAt
      data {
        ... on ExceptionCreatedData {
          exception {
            type
            data
          }
        }
      }
    }
    actionExecutions {
      ...TrackWorkspaceAction
      conversation {
        id
        externalMessages {
          id
          type
          createdAt
          content
          htmlBody
          emailMetadata
        }
      }
    }
  }
}
    ${TrackWorkspaceActionFragmentDoc}`;

/**
 * __useGetExceptionEventsWithMessagesQuery__
 *
 * To run a query within a React component, call `useGetExceptionEventsWithMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExceptionEventsWithMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExceptionEventsWithMessagesQuery({
 *   variables: {
 *      movementId: // value for 'movementId'
 *   },
 * });
 */
export function useGetExceptionEventsWithMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetExceptionEventsWithMessagesQuery, GetExceptionEventsWithMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExceptionEventsWithMessagesQuery, GetExceptionEventsWithMessagesQueryVariables>(GetExceptionEventsWithMessagesDocument, options);
      }
export function useGetExceptionEventsWithMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExceptionEventsWithMessagesQuery, GetExceptionEventsWithMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExceptionEventsWithMessagesQuery, GetExceptionEventsWithMessagesQueryVariables>(GetExceptionEventsWithMessagesDocument, options);
        }
export type GetExceptionEventsWithMessagesQueryHookResult = ReturnType<typeof useGetExceptionEventsWithMessagesQuery>;
export type GetExceptionEventsWithMessagesLazyQueryHookResult = ReturnType<typeof useGetExceptionEventsWithMessagesLazyQuery>;
export type GetExceptionEventsWithMessagesQueryResult = Apollo.QueryResult<GetExceptionEventsWithMessagesQuery, GetExceptionEventsWithMessagesQueryVariables>;
export const GetMovementChatConversationsDocument = gql`
    query GetMovementChatConversations($id: ID!) {
  movementById(id: $id) {
    id
    conversations {
      id
      type
      title
      createdAt
      summary {
        summary
      }
      metadata {
        ... on ChatConversationMetadata {
          context
        }
      }
      externalMessages {
        id
        type
        createdAt
        content
        htmlBody
        user {
          id
          firstName
          lastName
          username
        }
      }
    }
    chatConversations {
      id
      title
      externalMessages {
        id
        type
        createdAt
        content
        htmlBody
        user {
          id
          firstName
          lastName
          username
        }
      }
    }
    linkedPartyMessages {
      parties
      message {
        id
        type
        createdAt
        conversationId
        externalThreadId
        content
        htmlBody
        emailMetadata
        documents {
          id
          name
          url
        }
        user {
          id
          firstName
          lastName
          username
          profile {
            ... on HumanProfile {
              name
            }
            ... on AIProfile {
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMovementChatConversationsQuery__
 *
 * To run a query within a React component, call `useGetMovementChatConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementChatConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementChatConversationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMovementChatConversationsQuery(baseOptions: Apollo.QueryHookOptions<GetMovementChatConversationsQuery, GetMovementChatConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovementChatConversationsQuery, GetMovementChatConversationsQueryVariables>(GetMovementChatConversationsDocument, options);
      }
export function useGetMovementChatConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovementChatConversationsQuery, GetMovementChatConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovementChatConversationsQuery, GetMovementChatConversationsQueryVariables>(GetMovementChatConversationsDocument, options);
        }
export type GetMovementChatConversationsQueryHookResult = ReturnType<typeof useGetMovementChatConversationsQuery>;
export type GetMovementChatConversationsLazyQueryHookResult = ReturnType<typeof useGetMovementChatConversationsLazyQuery>;
export type GetMovementChatConversationsQueryResult = Apollo.QueryResult<GetMovementChatConversationsQuery, GetMovementChatConversationsQueryVariables>;
export const GetMovementsWithTrackSettingsDocument = gql`
    query GetMovementsWithTrackSettings($organizationId: ID!, $searchTerm: String) {
  movementsWithTrackSettings(
    organizationId: $organizationId
    searchTerm: $searchTerm
  ) {
    movement {
      id
      trackData
      details
      commodity
      shipperThreadId
      shipment {
        id
        referenceNumbers
        movements {
          id
          stops {
            location {
              name
              addressOne
              addressTwo
              city
              state
              zip
              country
              geoCoordinates {
                latitude
                longitude
              }
            }
            dateTimeRanges {
              start {
                dateTime
                timezone
                interpretationPolicy
              }
              end {
                dateTime
                timezone
                interpretationPolicy
              }
              type
            }
          }
        }
      }
    }
    hasTrackSettings
    isExcludedFromTracking
    corruptedTrackingExceptionId
    openExceptionTypes
    latestTrackStatus
    customerNames
    primaryResponsibleParty {
      name
      email
    }
  }
}
    `;

/**
 * __useGetMovementsWithTrackSettingsQuery__
 *
 * To run a query within a React component, call `useGetMovementsWithTrackSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovementsWithTrackSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovementsWithTrackSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetMovementsWithTrackSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetMovementsWithTrackSettingsQuery, GetMovementsWithTrackSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovementsWithTrackSettingsQuery, GetMovementsWithTrackSettingsQueryVariables>(GetMovementsWithTrackSettingsDocument, options);
      }
export function useGetMovementsWithTrackSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovementsWithTrackSettingsQuery, GetMovementsWithTrackSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovementsWithTrackSettingsQuery, GetMovementsWithTrackSettingsQueryVariables>(GetMovementsWithTrackSettingsDocument, options);
        }
export type GetMovementsWithTrackSettingsQueryHookResult = ReturnType<typeof useGetMovementsWithTrackSettingsQuery>;
export type GetMovementsWithTrackSettingsLazyQueryHookResult = ReturnType<typeof useGetMovementsWithTrackSettingsLazyQuery>;
export type GetMovementsWithTrackSettingsQueryResult = Apollo.QueryResult<GetMovementsWithTrackSettingsQuery, GetMovementsWithTrackSettingsQueryVariables>;
export const GetTrackConversationMessagesDocument = gql`
    query GetTrackConversationMessages($id: ID!) {
  conversationById(id: $id) {
    id
    mediaUrl
    externalMessages {
      id
      createdAt
      content
    }
  }
}
    `;

/**
 * __useGetTrackConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetTrackConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackConversationMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTrackConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetTrackConversationMessagesQuery, GetTrackConversationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackConversationMessagesQuery, GetTrackConversationMessagesQueryVariables>(GetTrackConversationMessagesDocument, options);
      }
export function useGetTrackConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackConversationMessagesQuery, GetTrackConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackConversationMessagesQuery, GetTrackConversationMessagesQueryVariables>(GetTrackConversationMessagesDocument, options);
        }
export type GetTrackConversationMessagesQueryHookResult = ReturnType<typeof useGetTrackConversationMessagesQuery>;
export type GetTrackConversationMessagesLazyQueryHookResult = ReturnType<typeof useGetTrackConversationMessagesLazyQuery>;
export type GetTrackConversationMessagesQueryResult = Apollo.QueryResult<GetTrackConversationMessagesQuery, GetTrackConversationMessagesQueryVariables>;
export const GetTrackDashboardSummaryDocument = gql`
    query GetTrackDashboardSummary($input: TrackDashboardSummaryInput!) {
  trackDashboardSummary(input: $input) {
    timezone
    automatedRuns
    priorPeriodAutomatedRuns
    trendGranularity
    currentTrendBucket
    automatedRunsTrend {
      bucket
      count
    }
    automatedRunsByMilestone {
      category
      count
    }
    totals {
      calls
      emails
      sms
      shipperUpdates
      statusChanges
      timeUpdates
      tmsComments
      sopRuns
      escalations
      missingInfo
      computedAt
    }
    disruptions {
      saved
      total
    }
    disruptionsByWeek {
      weekStart
      saved
      total
    }
    sopCheckScores {
      checkName
      passCount
      failCount
    }
    exceptionsByType {
      category
      count
    }
    estimatedHoursSaved
  }
}
    `;

/**
 * __useGetTrackDashboardSummaryQuery__
 *
 * To run a query within a React component, call `useGetTrackDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackDashboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackDashboardSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTrackDashboardSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetTrackDashboardSummaryQuery, GetTrackDashboardSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackDashboardSummaryQuery, GetTrackDashboardSummaryQueryVariables>(GetTrackDashboardSummaryDocument, options);
      }
export function useGetTrackDashboardSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackDashboardSummaryQuery, GetTrackDashboardSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackDashboardSummaryQuery, GetTrackDashboardSummaryQueryVariables>(GetTrackDashboardSummaryDocument, options);
        }
export type GetTrackDashboardSummaryQueryHookResult = ReturnType<typeof useGetTrackDashboardSummaryQuery>;
export type GetTrackDashboardSummaryLazyQueryHookResult = ReturnType<typeof useGetTrackDashboardSummaryLazyQuery>;
export type GetTrackDashboardSummaryQueryResult = Apollo.QueryResult<GetTrackDashboardSummaryQuery, GetTrackDashboardSummaryQueryVariables>;
export const GetTrackSettingsDocument = gql`
    query GetTrackSettings($organizationId: ID!) {
  trackSettings(organizationId: $organizationId) {
    id
    organizationId
    name
    isActive
    isDefault
    createdAt
    updatedAt
    stopSettings {
      pickup {
        checkTypes
        timeWindowMinutes
        before {
          enabled
          trigger
          minutesBefore
          suppressIfCarrierChangedWithinMinutes
          advanced {
            appointment {
              minutes
              direction
              anchor
            }
            windowTiers {
              maxDurationMinutes
              offset {
                minutes
                direction
                anchor
              }
            }
          }
          triggers {
            triggerType
            enabled
            params {
              appointment {
                minutes
                direction
                anchor
              }
              windowTiers {
                maxDurationMinutes
                offset {
                  minutes
                  direction
                  anchor
                }
              }
            }
          }
        }
        beforeConfigs {
          enabled
          trigger
          minutesBefore
          suppressIfCarrierChangedWithinMinutes
          advanced {
            appointment {
              minutes
              direction
              anchor
            }
            windowTiers {
              maxDurationMinutes
              offset {
                minutes
                direction
                anchor
              }
            }
          }
        }
        after {
          enabled
          minutesAfter
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAfterTriggerParamsFields
            }
          }
        }
        at {
          enabled
          delayMinutes
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAtTriggerParamsFields
            }
          }
        }
        actualArrival {
          enabled
        }
        actualDeparture {
          enabled
        }
        preDispatch {
          enabled
          minutesBefore
          triggers {
            triggerType
            enabled
            params {
              minutesBefore
              cutoffHour
              hoursBeforeCutoffForEarlyPickups
              hoursBeforeCutoffForLatePickups
              appointment {
                minutes
                direction
                anchor
              }
              windowTiers {
                maxDurationMinutes
                offset {
                  minutes
                  direction
                  anchor
                }
              }
            }
          }
        }
      }
      stops {
        checkTypes
        timeWindowMinutes
        before {
          enabled
          minutesBefore
        }
        after {
          enabled
          minutesAfter
        }
        at {
          enabled
          delayMinutes
        }
      }
      delivery {
        checkTypes
        timeWindowMinutes
        before {
          enabled
          trigger
          minutesBefore
          triggers {
            triggerType
            enabled
            params {
              ...AdvancedTriggerParamsFields
            }
          }
        }
        after {
          enabled
          minutesAfter
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAfterTriggerParamsFields
            }
          }
        }
        at {
          enabled
          delayMinutes
          triggers {
            triggerType
            enabled
            params {
              ...MilestoneAtTriggerParamsFields
            }
          }
        }
      }
    }
    enRouteSettings {
      cadenceMode
      enRoute {
        ...EnRouteTrackEventSettingsFields
      }
      enRouteWithTracking {
        ...EnRouteTrackEventSettingsFields
      }
      enRouteWithoutTracking {
        ...EnRouteTrackEventSettingsFields
      }
      exceptionEventsSettings {
        alertWindowMinutes
        quietPeriodAfterInTransitMinutes
        stationaryVehicle {
          thresholdMinutes
          suppressionPeriodMinutes
        }
        runningLate {
          enabled
          suppressionPeriodMinutes
          toleranceMinutes
        }
        trackingDataNotAvailable {
          enabled
          suppressionPeriodMinutes
        }
        trackingDataStale {
          enabled
          thresholdMinutes
          suppressionPeriodMinutes
        }
        infoMissing {
          enabled
          checks
          suppressionPeriodMinutes
          evaluateAt
        }
        notYetDispatched {
          enabled
          minutesBeforePickup
        }
        runningLateCloseToDelivery {
          enabled
          minutesBeforeDelivery
          toleranceMinutes
        }
        runningLateCloseToPickup {
          enabled
          minutesBeforePickup
          toleranceMinutes
        }
      }
      truckSpeedMph
      dailyDrivingHours
      trackingTrigger
    }
    nightHoursSettings {
      startHour
      endHour
      windowMinutes
      skipAllMilestones
    }
  }
}
    ${MilestoneAfterTriggerParamsFieldsFragmentDoc}
${MilestoneAtTriggerParamsFieldsFragmentDoc}
${AdvancedTriggerParamsFieldsFragmentDoc}
${EnRouteTrackEventSettingsFieldsFragmentDoc}`;

/**
 * __useGetTrackSettingsQuery__
 *
 * To run a query within a React component, call `useGetTrackSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetTrackSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetTrackSettingsQuery, GetTrackSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackSettingsQuery, GetTrackSettingsQueryVariables>(GetTrackSettingsDocument, options);
      }
export function useGetTrackSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackSettingsQuery, GetTrackSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackSettingsQuery, GetTrackSettingsQueryVariables>(GetTrackSettingsDocument, options);
        }
export type GetTrackSettingsQueryHookResult = ReturnType<typeof useGetTrackSettingsQuery>;
export type GetTrackSettingsLazyQueryHookResult = ReturnType<typeof useGetTrackSettingsLazyQuery>;
export type GetTrackSettingsQueryResult = Apollo.QueryResult<GetTrackSettingsQuery, GetTrackSettingsQueryVariables>;
export const GetTrackShipmentInsightCountsDocument = gql`
    query GetTrackShipmentInsightCounts($organizationId: ID!) {
  trackShipmentInsightCounts(organizationId: $organizationId) {
    pastPickupLoads
    readyForDispatch
    withCarrierConversation
    withDriverPhone
  }
}
    `;

/**
 * __useGetTrackShipmentInsightCountsQuery__
 *
 * To run a query within a React component, call `useGetTrackShipmentInsightCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackShipmentInsightCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackShipmentInsightCountsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetTrackShipmentInsightCountsQuery(baseOptions: Apollo.QueryHookOptions<GetTrackShipmentInsightCountsQuery, GetTrackShipmentInsightCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackShipmentInsightCountsQuery, GetTrackShipmentInsightCountsQueryVariables>(GetTrackShipmentInsightCountsDocument, options);
      }
export function useGetTrackShipmentInsightCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackShipmentInsightCountsQuery, GetTrackShipmentInsightCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackShipmentInsightCountsQuery, GetTrackShipmentInsightCountsQueryVariables>(GetTrackShipmentInsightCountsDocument, options);
        }
export type GetTrackShipmentInsightCountsQueryHookResult = ReturnType<typeof useGetTrackShipmentInsightCountsQuery>;
export type GetTrackShipmentInsightCountsLazyQueryHookResult = ReturnType<typeof useGetTrackShipmentInsightCountsLazyQuery>;
export type GetTrackShipmentInsightCountsQueryResult = Apollo.QueryResult<GetTrackShipmentInsightCountsQuery, GetTrackShipmentInsightCountsQueryVariables>;
export const GetValhallaComparisonEnabledDocument = gql`
    query GetValhallaComparisonEnabled {
  valhallaComparisonEnabled
}
    `;

/**
 * __useGetValhallaComparisonEnabledQuery__
 *
 * To run a query within a React component, call `useGetValhallaComparisonEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValhallaComparisonEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValhallaComparisonEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetValhallaComparisonEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GetValhallaComparisonEnabledQuery, GetValhallaComparisonEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValhallaComparisonEnabledQuery, GetValhallaComparisonEnabledQueryVariables>(GetValhallaComparisonEnabledDocument, options);
      }
export function useGetValhallaComparisonEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValhallaComparisonEnabledQuery, GetValhallaComparisonEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValhallaComparisonEnabledQuery, GetValhallaComparisonEnabledQueryVariables>(GetValhallaComparisonEnabledDocument, options);
        }
export type GetValhallaComparisonEnabledQueryHookResult = ReturnType<typeof useGetValhallaComparisonEnabledQuery>;
export type GetValhallaComparisonEnabledLazyQueryHookResult = ReturnType<typeof useGetValhallaComparisonEnabledLazyQuery>;
export type GetValhallaComparisonEnabledQueryResult = Apollo.QueryResult<GetValhallaComparisonEnabledQuery, GetValhallaComparisonEnabledQueryVariables>;
export const SimulateShouldTrackRuleDocument = gql`
    query SimulateShouldTrackRule($input: SimulateShouldTrackRuleInput!) {
  simulateShouldTrackRule(input: $input) {
    evaluatedCount
    passedCount
    results {
      movementId
      shipmentId
      shipmentReferenceNumber
      pickupStop {
        location {
          city
          state
        }
        dateTimeRanges {
          start {
            dateTime
            timezone
            interpretationPolicy
          }
          end {
            dateTime
            timezone
            interpretationPolicy
          }
          type
        }
      }
      passed
      error
    }
  }
}
    `;

/**
 * __useSimulateShouldTrackRuleQuery__
 *
 * To run a query within a React component, call `useSimulateShouldTrackRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulateShouldTrackRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulateShouldTrackRuleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateShouldTrackRuleQuery(baseOptions: Apollo.QueryHookOptions<SimulateShouldTrackRuleQuery, SimulateShouldTrackRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimulateShouldTrackRuleQuery, SimulateShouldTrackRuleQueryVariables>(SimulateShouldTrackRuleDocument, options);
      }
export function useSimulateShouldTrackRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimulateShouldTrackRuleQuery, SimulateShouldTrackRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimulateShouldTrackRuleQuery, SimulateShouldTrackRuleQueryVariables>(SimulateShouldTrackRuleDocument, options);
        }
export type SimulateShouldTrackRuleQueryHookResult = ReturnType<typeof useSimulateShouldTrackRuleQuery>;
export type SimulateShouldTrackRuleLazyQueryHookResult = ReturnType<typeof useSimulateShouldTrackRuleLazyQuery>;
export type SimulateShouldTrackRuleQueryResult = Apollo.QueryResult<SimulateShouldTrackRuleQuery, SimulateShouldTrackRuleQueryVariables>;
export const TrackedMovementsForExternalThreadDocument = gql`
    query TrackedMovementsForExternalThread($input: RelatedExternalMessagesInput!) {
  trackedMovementsForExternalThread(input: $input) {
    movementId
    shipmentId
    referenceNumber
    isPaused
  }
}
    `;

/**
 * __useTrackedMovementsForExternalThreadQuery__
 *
 * To run a query within a React component, call `useTrackedMovementsForExternalThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackedMovementsForExternalThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackedMovementsForExternalThreadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackedMovementsForExternalThreadQuery(baseOptions: Apollo.QueryHookOptions<TrackedMovementsForExternalThreadQuery, TrackedMovementsForExternalThreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackedMovementsForExternalThreadQuery, TrackedMovementsForExternalThreadQueryVariables>(TrackedMovementsForExternalThreadDocument, options);
      }
export function useTrackedMovementsForExternalThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackedMovementsForExternalThreadQuery, TrackedMovementsForExternalThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackedMovementsForExternalThreadQuery, TrackedMovementsForExternalThreadQueryVariables>(TrackedMovementsForExternalThreadDocument, options);
        }
export type TrackedMovementsForExternalThreadQueryHookResult = ReturnType<typeof useTrackedMovementsForExternalThreadQuery>;
export type TrackedMovementsForExternalThreadLazyQueryHookResult = ReturnType<typeof useTrackedMovementsForExternalThreadLazyQuery>;
export type TrackedMovementsForExternalThreadQueryResult = Apollo.QueryResult<TrackedMovementsForExternalThreadQuery, TrackedMovementsForExternalThreadQueryVariables>;
export const GetTruckerToolsScrapingConcurrencyDocument = gql`
    query GetTruckerToolsScrapingConcurrency {
  truckerToolsScrapingConcurrency
}
    `;

/**
 * __useGetTruckerToolsScrapingConcurrencyQuery__
 *
 * To run a query within a React component, call `useGetTruckerToolsScrapingConcurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTruckerToolsScrapingConcurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTruckerToolsScrapingConcurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTruckerToolsScrapingConcurrencyQuery(baseOptions?: Apollo.QueryHookOptions<GetTruckerToolsScrapingConcurrencyQuery, GetTruckerToolsScrapingConcurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTruckerToolsScrapingConcurrencyQuery, GetTruckerToolsScrapingConcurrencyQueryVariables>(GetTruckerToolsScrapingConcurrencyDocument, options);
      }
export function useGetTruckerToolsScrapingConcurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTruckerToolsScrapingConcurrencyQuery, GetTruckerToolsScrapingConcurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTruckerToolsScrapingConcurrencyQuery, GetTruckerToolsScrapingConcurrencyQueryVariables>(GetTruckerToolsScrapingConcurrencyDocument, options);
        }
export type GetTruckerToolsScrapingConcurrencyQueryHookResult = ReturnType<typeof useGetTruckerToolsScrapingConcurrencyQuery>;
export type GetTruckerToolsScrapingConcurrencyLazyQueryHookResult = ReturnType<typeof useGetTruckerToolsScrapingConcurrencyLazyQuery>;
export type GetTruckerToolsScrapingConcurrencyQueryResult = Apollo.QueryResult<GetTruckerToolsScrapingConcurrencyQuery, GetTruckerToolsScrapingConcurrencyQueryVariables>;
export const AdminEmailsDocument = gql`
    query AdminEmails($ids: [ID!]!) {
  adminEmailsByIds(ids: $ids) {
    id
    email
  }
}
    `;

/**
 * __useAdminEmailsQuery__
 *
 * To run a query within a React component, call `useAdminEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEmailsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAdminEmailsQuery(baseOptions: Apollo.QueryHookOptions<AdminEmailsQuery, AdminEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEmailsQuery, AdminEmailsQueryVariables>(AdminEmailsDocument, options);
      }
export function useAdminEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEmailsQuery, AdminEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEmailsQuery, AdminEmailsQueryVariables>(AdminEmailsDocument, options);
        }
export type AdminEmailsQueryHookResult = ReturnType<typeof useAdminEmailsQuery>;
export type AdminEmailsLazyQueryHookResult = ReturnType<typeof useAdminEmailsLazyQuery>;
export type AdminEmailsQueryResult = Apollo.QueryResult<AdminEmailsQuery, AdminEmailsQueryVariables>;
export const UserEmailSubscriptionsDocument = gql`
    query UserEmailSubscriptions($id: ID!) {
  userById(id: $id) {
    id
    emailSubscriptions {
      id
      type
      isActive
      description
    }
  }
}
    `;

/**
 * __useUserEmailSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserEmailSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmailSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmailSubscriptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserEmailSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<UserEmailSubscriptionsQuery, UserEmailSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEmailSubscriptionsQuery, UserEmailSubscriptionsQueryVariables>(UserEmailSubscriptionsDocument, options);
      }
export function useUserEmailSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEmailSubscriptionsQuery, UserEmailSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEmailSubscriptionsQuery, UserEmailSubscriptionsQueryVariables>(UserEmailSubscriptionsDocument, options);
        }
export type UserEmailSubscriptionsQueryHookResult = ReturnType<typeof useUserEmailSubscriptionsQuery>;
export type UserEmailSubscriptionsLazyQueryHookResult = ReturnType<typeof useUserEmailSubscriptionsLazyQuery>;
export type UserEmailSubscriptionsQueryResult = Apollo.QueryResult<UserEmailSubscriptionsQuery, UserEmailSubscriptionsQueryVariables>;
export const UserSettingsDocument = gql`
    query UserSettings($id: ID!) {
  userById(id: $id) {
    id
    settings {
      timeDisplayStyle
      autoReply
      emailTags
      transfersRateLimit
      notifications
      browserExtensionDomainAllowlist
      quote
      pluginLandingPage
    }
  }
}
    `;

/**
 * __useUserSettingsQuery__
 *
 * To run a query within a React component, call `useUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserSettingsQuery(baseOptions: Apollo.QueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
      }
export function useUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
        }
export type UserSettingsQueryHookResult = ReturnType<typeof useUserSettingsQuery>;
export type UserSettingsLazyQueryHookResult = ReturnType<typeof useUserSettingsLazyQuery>;
export type UserSettingsQueryResult = Apollo.QueryResult<UserSettingsQuery, UserSettingsQueryVariables>;
export const UserSharedInboxesDocument = gql`
    query UserSharedInboxes($id: ID!, $input: SharedInboxInput!) {
  userById(id: $id) {
    id
    sharedInboxes(input: $input) {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useUserSharedInboxesQuery__
 *
 * To run a query within a React component, call `useUserSharedInboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSharedInboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSharedInboxesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserSharedInboxesQuery(baseOptions: Apollo.QueryHookOptions<UserSharedInboxesQuery, UserSharedInboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSharedInboxesQuery, UserSharedInboxesQueryVariables>(UserSharedInboxesDocument, options);
      }
export function useUserSharedInboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSharedInboxesQuery, UserSharedInboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSharedInboxesQuery, UserSharedInboxesQueryVariables>(UserSharedInboxesDocument, options);
        }
export type UserSharedInboxesQueryHookResult = ReturnType<typeof useUserSharedInboxesQuery>;
export type UserSharedInboxesLazyQueryHookResult = ReturnType<typeof useUserSharedInboxesLazyQuery>;
export type UserSharedInboxesQueryResult = Apollo.QueryResult<UserSharedInboxesQuery, UserSharedInboxesQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($input: UsersInput, $first: Int, $last: Int, $before: String, $after: String, $sort: SortInput) {
  users(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
    sort: $sort
  ) {
    edges {
      node {
        id
        firstName
        lastName
        email
        username
        roles
        lastSignedIn
      }
    }
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const MyEmailSignaturesDocument = gql`
    query MyEmailSignatures {
  myEmailSignatures {
    ...UserDocumentUploadPreview
  }
}
    ${UserDocumentUploadPreviewFragmentDoc}`;

/**
 * __useMyEmailSignaturesQuery__
 *
 * To run a query within a React component, call `useMyEmailSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEmailSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEmailSignaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEmailSignaturesQuery(baseOptions?: Apollo.QueryHookOptions<MyEmailSignaturesQuery, MyEmailSignaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEmailSignaturesQuery, MyEmailSignaturesQueryVariables>(MyEmailSignaturesDocument, options);
      }
export function useMyEmailSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEmailSignaturesQuery, MyEmailSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEmailSignaturesQuery, MyEmailSignaturesQueryVariables>(MyEmailSignaturesDocument, options);
        }
export type MyEmailSignaturesQueryHookResult = ReturnType<typeof useMyEmailSignaturesQuery>;
export type MyEmailSignaturesLazyQueryHookResult = ReturnType<typeof useMyEmailSignaturesLazyQuery>;
export type MyEmailSignaturesQueryResult = Apollo.QueryResult<MyEmailSignaturesQuery, MyEmailSignaturesQueryVariables>;
export const UserFormDataDocument = gql`
    query UserFormData($userId: ID!) {
  userById(id: $userId) {
    ...UserFormFields
  }
}
    ${UserFormFieldsFragmentDoc}`;

/**
 * __useUserFormDataQuery__
 *
 * To run a query within a React component, call `useUserFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFormDataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserFormDataQuery(baseOptions: Apollo.QueryHookOptions<UserFormDataQuery, UserFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFormDataQuery, UserFormDataQueryVariables>(UserFormDataDocument, options);
      }
export function useUserFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFormDataQuery, UserFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFormDataQuery, UserFormDataQueryVariables>(UserFormDataDocument, options);
        }
export type UserFormDataQueryHookResult = ReturnType<typeof useUserFormDataQuery>;
export type UserFormDataLazyQueryHookResult = ReturnType<typeof useUserFormDataLazyQuery>;
export type UserFormDataQueryResult = Apollo.QueryResult<UserFormDataQuery, UserFormDataQueryVariables>;
export const UserNameDocument = gql`
    query UserName($id: ID!) {
  userById(id: $id) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useUserNameQuery__
 *
 * To run a query within a React component, call `useUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNameQuery(baseOptions: Apollo.QueryHookOptions<UserNameQuery, UserNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
      }
export function useUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNameQuery, UserNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
        }
export type UserNameQueryHookResult = ReturnType<typeof useUserNameQuery>;
export type UserNameLazyQueryHookResult = ReturnType<typeof useUserNameLazyQuery>;
export type UserNameQueryResult = Apollo.QueryResult<UserNameQuery, UserNameQueryVariables>;
export const GetToolSearchEmbeddingsEnabledDocument = gql`
    query GetToolSearchEmbeddingsEnabled {
  toolSearchEmbeddingsEnabled
}
    `;

/**
 * __useGetToolSearchEmbeddingsEnabledQuery__
 *
 * To run a query within a React component, call `useGetToolSearchEmbeddingsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolSearchEmbeddingsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolSearchEmbeddingsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetToolSearchEmbeddingsEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GetToolSearchEmbeddingsEnabledQuery, GetToolSearchEmbeddingsEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetToolSearchEmbeddingsEnabledQuery, GetToolSearchEmbeddingsEnabledQueryVariables>(GetToolSearchEmbeddingsEnabledDocument, options);
      }
export function useGetToolSearchEmbeddingsEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetToolSearchEmbeddingsEnabledQuery, GetToolSearchEmbeddingsEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetToolSearchEmbeddingsEnabledQuery, GetToolSearchEmbeddingsEnabledQueryVariables>(GetToolSearchEmbeddingsEnabledDocument, options);
        }
export type GetToolSearchEmbeddingsEnabledQueryHookResult = ReturnType<typeof useGetToolSearchEmbeddingsEnabledQuery>;
export type GetToolSearchEmbeddingsEnabledLazyQueryHookResult = ReturnType<typeof useGetToolSearchEmbeddingsEnabledLazyQuery>;
export type GetToolSearchEmbeddingsEnabledQueryResult = Apollo.QueryResult<GetToolSearchEmbeddingsEnabledQuery, GetToolSearchEmbeddingsEnabledQueryVariables>;
export const DeleteWorkerAuthTokenDocument = gql`
    mutation DeleteWorkerAuthToken($input: DeleteWorkerAuthTokenInput!) {
  deleteWorkerAuthToken(input: $input) {
    success
  }
}
    `;
export type DeleteWorkerAuthTokenMutationFn = Apollo.MutationFunction<DeleteWorkerAuthTokenMutation, DeleteWorkerAuthTokenMutationVariables>;

/**
 * __useDeleteWorkerAuthTokenMutation__
 *
 * To run a mutation, you first call `useDeleteWorkerAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkerAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkerAuthTokenMutation, { data, loading, error }] = useDeleteWorkerAuthTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkerAuthTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkerAuthTokenMutation, DeleteWorkerAuthTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkerAuthTokenMutation, DeleteWorkerAuthTokenMutationVariables>(DeleteWorkerAuthTokenDocument, options);
      }
export type DeleteWorkerAuthTokenMutationHookResult = ReturnType<typeof useDeleteWorkerAuthTokenMutation>;
export type DeleteWorkerAuthTokenMutationResult = Apollo.MutationResult<DeleteWorkerAuthTokenMutation>;
export type DeleteWorkerAuthTokenMutationOptions = Apollo.BaseMutationOptions<DeleteWorkerAuthTokenMutation, DeleteWorkerAuthTokenMutationVariables>;
export const WorkerPreviewsDocument = gql`
    query WorkerPreviews($input: UsersInput!) {
  workers(input: $input) {
    edges {
      node {
        ...WorkerPreview
      }
    }
  }
}
    ${WorkerPreviewFragmentDoc}`;

/**
 * __useWorkerPreviewsQuery__
 *
 * To run a query within a React component, call `useWorkerPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerPreviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkerPreviewsQuery(baseOptions: Apollo.QueryHookOptions<WorkerPreviewsQuery, WorkerPreviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerPreviewsQuery, WorkerPreviewsQueryVariables>(WorkerPreviewsDocument, options);
      }
export function useWorkerPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerPreviewsQuery, WorkerPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerPreviewsQuery, WorkerPreviewsQueryVariables>(WorkerPreviewsDocument, options);
        }
export type WorkerPreviewsQueryHookResult = ReturnType<typeof useWorkerPreviewsQuery>;
export type WorkerPreviewsLazyQueryHookResult = ReturnType<typeof useWorkerPreviewsLazyQuery>;
export type WorkerPreviewsQueryResult = Apollo.QueryResult<WorkerPreviewsQuery, WorkerPreviewsQueryVariables>;
export const WorkerDocument = gql`
    query Worker($id: ID!) {
  workerById(id: $id) {
    ...Worker
  }
}
    ${WorkerFragmentDoc}`;

/**
 * __useWorkerQuery__
 *
 * To run a query within a React component, call `useWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkerQuery(baseOptions: Apollo.QueryHookOptions<WorkerQuery, WorkerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerQuery, WorkerQueryVariables>(WorkerDocument, options);
      }
export function useWorkerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerQuery, WorkerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerQuery, WorkerQueryVariables>(WorkerDocument, options);
        }
export type WorkerQueryHookResult = ReturnType<typeof useWorkerQuery>;
export type WorkerLazyQueryHookResult = ReturnType<typeof useWorkerLazyQuery>;
export type WorkerQueryResult = Apollo.QueryResult<WorkerQuery, WorkerQueryVariables>;
export const GetWorkerAuthorizedServiceDocument = gql`
    query GetWorkerAuthorizedService($input: WorkerHasAuthorizedServiceTypeInput!) {
  workerHasAuthorizedServiceType(input: $input) {
    success
    email
  }
}
    `;

/**
 * __useGetWorkerAuthorizedServiceQuery__
 *
 * To run a query within a React component, call `useGetWorkerAuthorizedServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerAuthorizedServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerAuthorizedServiceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkerAuthorizedServiceQuery(baseOptions: Apollo.QueryHookOptions<GetWorkerAuthorizedServiceQuery, GetWorkerAuthorizedServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkerAuthorizedServiceQuery, GetWorkerAuthorizedServiceQueryVariables>(GetWorkerAuthorizedServiceDocument, options);
      }
export function useGetWorkerAuthorizedServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkerAuthorizedServiceQuery, GetWorkerAuthorizedServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkerAuthorizedServiceQuery, GetWorkerAuthorizedServiceQueryVariables>(GetWorkerAuthorizedServiceDocument, options);
        }
export type GetWorkerAuthorizedServiceQueryHookResult = ReturnType<typeof useGetWorkerAuthorizedServiceQuery>;
export type GetWorkerAuthorizedServiceLazyQueryHookResult = ReturnType<typeof useGetWorkerAuthorizedServiceLazyQuery>;
export type GetWorkerAuthorizedServiceQueryResult = Apollo.QueryResult<GetWorkerAuthorizedServiceQuery, GetWorkerAuthorizedServiceQueryVariables>;
export const WorkerEmailSignaturesDocument = gql`
    query WorkerEmailSignatures($workerId: ID!) {
  workerEmailSignatures(workerId: $workerId) {
    ...UserDocumentUploadPreview
  }
}
    ${UserDocumentUploadPreviewFragmentDoc}`;

/**
 * __useWorkerEmailSignaturesQuery__
 *
 * To run a query within a React component, call `useWorkerEmailSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkerEmailSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkerEmailSignaturesQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useWorkerEmailSignaturesQuery(baseOptions: Apollo.QueryHookOptions<WorkerEmailSignaturesQuery, WorkerEmailSignaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkerEmailSignaturesQuery, WorkerEmailSignaturesQueryVariables>(WorkerEmailSignaturesDocument, options);
      }
export function useWorkerEmailSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkerEmailSignaturesQuery, WorkerEmailSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkerEmailSignaturesQuery, WorkerEmailSignaturesQueryVariables>(WorkerEmailSignaturesDocument, options);
        }
export type WorkerEmailSignaturesQueryHookResult = ReturnType<typeof useWorkerEmailSignaturesQuery>;
export type WorkerEmailSignaturesLazyQueryHookResult = ReturnType<typeof useWorkerEmailSignaturesLazyQuery>;
export type WorkerEmailSignaturesQueryResult = Apollo.QueryResult<WorkerEmailSignaturesQuery, WorkerEmailSignaturesQueryVariables>;
export const ConversationActionExecutionUpdatedDocument = gql`
    subscription ConversationActionExecutionUpdated($conversationIds: [String!]!, $organizationId: String!) {
  conversationActionExecutionUpdated(
    conversationIds: $conversationIds
    organizationId: $organizationId
  ) {
    actionExecutionId
    conversationIds
    eventId
    eventType
    organizationId
  }
}
    `;

/**
 * __useConversationActionExecutionUpdatedSubscription__
 *
 * To run a query within a React component, call `useConversationActionExecutionUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConversationActionExecutionUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationActionExecutionUpdatedSubscription({
 *   variables: {
 *      conversationIds: // value for 'conversationIds'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useConversationActionExecutionUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConversationActionExecutionUpdatedSubscription, ConversationActionExecutionUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConversationActionExecutionUpdatedSubscription, ConversationActionExecutionUpdatedSubscriptionVariables>(ConversationActionExecutionUpdatedDocument, options);
      }
export type ConversationActionExecutionUpdatedSubscriptionHookResult = ReturnType<typeof useConversationActionExecutionUpdatedSubscription>;
export type ConversationActionExecutionUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConversationActionExecutionUpdatedSubscription>;
export const ConversationUpdatedDocument = gql`
    subscription ConversationUpdated($organizationId: String!) {
  conversationUpdated(organizationId: $organizationId) {
    conversationId
    conversationType
    messageId
    organizationId
    type
  }
}
    `;

/**
 * __useConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationUpdatedSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useConversationUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConversationUpdatedSubscription, ConversationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConversationUpdatedSubscription, ConversationUpdatedSubscriptionVariables>(ConversationUpdatedDocument, options);
      }
export type ConversationUpdatedSubscriptionHookResult = ReturnType<typeof useConversationUpdatedSubscription>;
export type ConversationUpdatedSubscriptionResult = Apollo.SubscriptionResult<ConversationUpdatedSubscription>;
export const GetQuoteSummariesDocument = gql`
    query GetQuoteSummaries($input: QuotesInput, $first: Int, $last: Int, $before: String, $after: String) {
  quotes(
    input: $input
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    totalCount
    count
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        ...QuoteSummary
      }
    }
  }
}
    ${QuoteSummaryFragmentDoc}`;

/**
 * __useGetQuoteSummariesQuery__
 *
 * To run a query within a React component, call `useGetQuoteSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteSummariesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetQuoteSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuoteSummariesQuery, GetQuoteSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuoteSummariesQuery, GetQuoteSummariesQueryVariables>(GetQuoteSummariesDocument, options);
      }
export function useGetQuoteSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuoteSummariesQuery, GetQuoteSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuoteSummariesQuery, GetQuoteSummariesQueryVariables>(GetQuoteSummariesDocument, options);
        }
export type GetQuoteSummariesQueryHookResult = ReturnType<typeof useGetQuoteSummariesQuery>;
export type GetQuoteSummariesLazyQueryHookResult = ReturnType<typeof useGetQuoteSummariesLazyQuery>;
export type GetQuoteSummariesQueryResult = Apollo.QueryResult<GetQuoteSummariesQuery, GetQuoteSummariesQueryVariables>;